(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root['minigdx-game-template'] = factory(typeof this['minigdx-game-template'] === 'undefined' ? {} : this['minigdx-game-template']);
}(this, function (_) {
  'use strict';
  State.prototype = Object.create(Enum.prototype);
  State.prototype.constructor = State;
  AbstractList.prototype = Object.create(AbstractCollection.prototype);
  AbstractList.prototype.constructor = AbstractList;
  ListIteratorImpl.prototype = Object.create(IteratorImpl.prototype);
  ListIteratorImpl.prototype.constructor = ListIteratorImpl;
  AbstractSet.prototype = Object.create(AbstractCollection.prototype);
  AbstractSet.prototype.constructor = AbstractSet;
  _no_name_provided__6.prototype = Object.create(AbstractSet.prototype);
  _no_name_provided__6.prototype.constructor = _no_name_provided__6;
  _no_name_provided__8.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__8.prototype.constructor = _no_name_provided__8;
  SequenceBuilderIterator.prototype = Object.create(SequenceScope.prototype);
  SequenceBuilderIterator.prototype.constructor = SequenceBuilderIterator;
  RingBuffer.prototype = Object.create(AbstractList.prototype);
  RingBuffer.prototype.constructor = RingBuffer;
  _no_name_provided__14.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__14.prototype.constructor = _no_name_provided__14;
  _no_name_provided__15.prototype = Object.create(AbstractIterator.prototype);
  _no_name_provided__15.prototype.constructor = _no_name_provided__15;
  CoroutineSingletons.prototype = Object.create(Enum.prototype);
  CoroutineSingletons.prototype.constructor = CoroutineSingletons;
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  KVariance.prototype = Object.create(Enum.prototype);
  KVariance.prototype.constructor = KVariance;
  LazyThreadSafetyMode.prototype = Object.create(Enum.prototype);
  LazyThreadSafetyMode.prototype.constructor = LazyThreadSafetyMode;
  Error_0.prototype = Object.create(Error.prototype);
  Error_0.prototype.constructor = Error_0;
  NotImplementedError.prototype = Object.create(Error_0.prototype);
  NotImplementedError.prototype.constructor = NotImplementedError;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  LongProgressionIterator.prototype = Object.create(LongIterator.prototype);
  LongProgressionIterator.prototype.constructor = LongProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  LongRange.prototype = Object.create(LongProgression.prototype);
  LongRange.prototype.constructor = LongRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  ListIteratorImpl_0.prototype = Object.create(IteratorImpl_0.prototype);
  ListIteratorImpl_0.prototype.constructor = ListIteratorImpl_0;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  _no_name_provided__25.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__25.prototype.constructor = _no_name_provided__25;
  _no_name_provided__26.prototype = Object.create(AbstractMutableCollection.prototype);
  _no_name_provided__26.prototype.constructor = _no_name_provided__26;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  EntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractMutableSet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  CharacterCodingException.prototype = Object.create(Exception.prototype);
  CharacterCodingException.prototype.constructor = CharacterCodingException;
  _no_name_provided__55.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__55.prototype.constructor = _no_name_provided__55;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  _no_name_provided__1_1.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_1.prototype.constructor = _no_name_provided__1_1;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  NumberFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  NumberFormatException.prototype.constructor = NumberFormatException;
  ArithmeticException.prototype = Object.create(RuntimeException.prototype);
  ArithmeticException.prototype.constructor = ArithmeticException;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  NoWhenBranchMatchedException.prototype = Object.create(RuntimeException.prototype);
  NoWhenBranchMatchedException.prototype.constructor = NoWhenBranchMatchedException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  PolymorphicSerializer.prototype = Object.create(AbstractPolymorphicSerializer.prototype);
  PolymorphicSerializer.prototype.constructor = PolymorphicSerializer;
  SerializationException.prototype = Object.create(IllegalArgumentException.prototype);
  SerializationException.prototype.constructor = SerializationException;
  UnknownFieldException.prototype = Object.create(SerializationException.prototype);
  UnknownFieldException.prototype.constructor = UnknownFieldException;
  MissingFieldException.prototype = Object.create(SerializationException.prototype);
  MissingFieldException.prototype.constructor = MissingFieldException;
  PrimitiveKind.prototype = Object.create(SerialKind.prototype);
  PrimitiveKind.prototype.constructor = PrimitiveKind;
  StructureKind.prototype = Object.create(SerialKind.prototype);
  StructureKind.prototype.constructor = StructureKind;
  PolymorphicKind.prototype = Object.create(SerialKind.prototype);
  PolymorphicKind.prototype.constructor = PolymorphicKind;
  ENUM.prototype = Object.create(SerialKind.prototype);
  ENUM.prototype.constructor = ENUM;
  CONTEXTUAL.prototype = Object.create(SerialKind.prototype);
  CONTEXTUAL.prototype.constructor = CONTEXTUAL;
  BOOLEAN.prototype = Object.create(PrimitiveKind.prototype);
  BOOLEAN.prototype.constructor = BOOLEAN;
  BYTE.prototype = Object.create(PrimitiveKind.prototype);
  BYTE.prototype.constructor = BYTE;
  CHAR.prototype = Object.create(PrimitiveKind.prototype);
  CHAR.prototype.constructor = CHAR;
  SHORT.prototype = Object.create(PrimitiveKind.prototype);
  SHORT.prototype.constructor = SHORT;
  INT.prototype = Object.create(PrimitiveKind.prototype);
  INT.prototype.constructor = INT;
  LONG.prototype = Object.create(PrimitiveKind.prototype);
  LONG.prototype.constructor = LONG;
  FLOAT.prototype = Object.create(PrimitiveKind.prototype);
  FLOAT.prototype.constructor = FLOAT;
  DOUBLE.prototype = Object.create(PrimitiveKind.prototype);
  DOUBLE.prototype.constructor = DOUBLE;
  STRING.prototype = Object.create(PrimitiveKind.prototype);
  STRING.prototype.constructor = STRING;
  CLASS.prototype = Object.create(StructureKind.prototype);
  CLASS.prototype.constructor = CLASS;
  LIST.prototype = Object.create(StructureKind.prototype);
  LIST.prototype.constructor = LIST;
  MAP.prototype = Object.create(StructureKind.prototype);
  MAP.prototype.constructor = MAP;
  OBJECT.prototype = Object.create(StructureKind.prototype);
  OBJECT.prototype.constructor = OBJECT;
  SEALED.prototype = Object.create(PolymorphicKind.prototype);
  SEALED.prototype.constructor = SEALED;
  OPEN.prototype = Object.create(PolymorphicKind.prototype);
  OPEN.prototype.constructor = OPEN;
  PrimitiveArrayDescriptor.prototype = Object.create(ListLikeDescriptor.prototype);
  PrimitiveArrayDescriptor.prototype.constructor = PrimitiveArrayDescriptor;
  ArrayListClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  ArrayListClassDesc.prototype.constructor = ArrayListClassDesc;
  LinkedHashMapClassDesc.prototype = Object.create(MapLikeDescriptor.prototype);
  LinkedHashMapClassDesc.prototype.constructor = LinkedHashMapClassDesc;
  ArrayClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  ArrayClassDesc.prototype.constructor = ArrayClassDesc;
  LinkedHashSetClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  LinkedHashSetClassDesc.prototype.constructor = LinkedHashSetClassDesc;
  HashSetClassDesc.prototype = Object.create(ListLikeDescriptor.prototype);
  HashSetClassDesc.prototype.constructor = HashSetClassDesc;
  HashMapClassDesc.prototype = Object.create(MapLikeDescriptor.prototype);
  HashMapClassDesc.prototype.constructor = HashMapClassDesc;
  ListLikeSerializer.prototype = Object.create(AbstractCollectionSerializer.prototype);
  ListLikeSerializer.prototype.constructor = ListLikeSerializer;
  PrimitiveArraySerializer.prototype = Object.create(ListLikeSerializer.prototype);
  PrimitiveArraySerializer.prototype.constructor = PrimitiveArraySerializer;
  ArrayListSerializer.prototype = Object.create(ListLikeSerializer.prototype);
  ArrayListSerializer.prototype.constructor = ArrayListSerializer;
  MapLikeSerializer.prototype = Object.create(AbstractCollectionSerializer.prototype);
  MapLikeSerializer.prototype.constructor = MapLikeSerializer;
  LinkedHashMapSerializer.prototype = Object.create(MapLikeSerializer.prototype);
  LinkedHashMapSerializer.prototype.constructor = LinkedHashMapSerializer;
  ReferenceArraySerializer.prototype = Object.create(ListLikeSerializer.prototype);
  ReferenceArraySerializer.prototype.constructor = ReferenceArraySerializer;
  LinkedHashSetSerializer.prototype = Object.create(ListLikeSerializer.prototype);
  LinkedHashSetSerializer.prototype.constructor = LinkedHashSetSerializer;
  HashSetSerializer.prototype = Object.create(ListLikeSerializer.prototype);
  HashSetSerializer.prototype.constructor = HashSetSerializer;
  HashMapSerializer.prototype = Object.create(MapLikeSerializer.prototype);
  HashMapSerializer.prototype.constructor = HashMapSerializer;
  CharArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  CharArraySerializer_0.prototype.constructor = CharArraySerializer_0;
  DoubleArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  DoubleArraySerializer_0.prototype.constructor = DoubleArraySerializer_0;
  FloatArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  FloatArraySerializer_0.prototype.constructor = FloatArraySerializer_0;
  LongArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  LongArraySerializer_0.prototype.constructor = LongArraySerializer_0;
  IntArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  IntArraySerializer_0.prototype.constructor = IntArraySerializer_0;
  ShortArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  ShortArraySerializer_0.prototype.constructor = ShortArraySerializer_0;
  ByteArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  ByteArraySerializer_0.prototype.constructor = ByteArraySerializer_0;
  BooleanArraySerializer_0.prototype = Object.create(PrimitiveArraySerializer.prototype);
  BooleanArraySerializer_0.prototype.constructor = BooleanArraySerializer_0;
  CharArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  CharArrayBuilder.prototype.constructor = CharArrayBuilder;
  DoubleArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  DoubleArrayBuilder.prototype.constructor = DoubleArrayBuilder;
  FloatArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  FloatArrayBuilder.prototype.constructor = FloatArrayBuilder;
  LongArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  LongArrayBuilder.prototype.constructor = LongArrayBuilder;
  IntArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  IntArrayBuilder.prototype.constructor = IntArrayBuilder;
  ShortArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  ShortArrayBuilder.prototype.constructor = ShortArrayBuilder;
  ByteArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  ByteArrayBuilder.prototype.constructor = ByteArrayBuilder;
  BooleanArrayBuilder.prototype = Object.create(PrimitiveArrayBuilder.prototype);
  BooleanArrayBuilder.prototype.constructor = BooleanArrayBuilder;
  NamedValueDecoder.prototype = Object.create(TaggedDecoder.prototype);
  NamedValueDecoder.prototype.constructor = NamedValueDecoder;
  MapEntrySerializer_0.prototype = Object.create(KeyValueSerializer.prototype);
  MapEntrySerializer_0.prototype.constructor = MapEntrySerializer_0;
  PairSerializer_0.prototype = Object.create(KeyValueSerializer.prototype);
  PairSerializer_0.prototype.constructor = PairSerializer_0;
  SerialModuleImpl.prototype = Object.create(SerializersModule.prototype);
  SerialModuleImpl.prototype.constructor = SerialModuleImpl;
  SerializerAlreadyRegisteredException.prototype = Object.create(IllegalArgumentException.prototype);
  SerializerAlreadyRegisteredException.prototype.constructor = SerializerAlreadyRegisteredException;
  ProtoBufImpl.prototype = Object.create(ProtoBuf.prototype);
  ProtoBufImpl.prototype.constructor = ProtoBufImpl;
  Default_0.prototype = Object.create(ProtoBuf.prototype);
  Default_0.prototype.constructor = Default_0;
  ProtoIntegerType.prototype = Object.create(Enum.prototype);
  ProtoIntegerType.prototype.constructor = ProtoIntegerType;
  ProtobufDecodingException.prototype = Object.create(SerializationException.prototype);
  ProtobufDecodingException.prototype.constructor = ProtobufDecodingException;
  ProtobufTaggedDecoder.prototype = Object.create(ProtobufTaggedBase.prototype);
  ProtobufTaggedDecoder.prototype.constructor = ProtobufTaggedDecoder;
  ProtobufDecoder.prototype = Object.create(ProtobufTaggedDecoder.prototype);
  ProtobufDecoder.prototype.constructor = ProtobufDecoder;
  RepeatedDecoder.prototype = Object.create(ProtobufDecoder.prototype);
  RepeatedDecoder.prototype.constructor = RepeatedDecoder;
  MapEntryReader.prototype = Object.create(ProtobufDecoder.prototype);
  MapEntryReader.prototype.constructor = MapEntryReader;
  JsonImpl.prototype = Object.create(Json.prototype);
  JsonImpl.prototype.constructor = JsonImpl;
  Default_1.prototype = Object.create(Json.prototype);
  Default_1.prototype.constructor = Default_1;
  JsonObject.prototype = Object.create(JsonElement.prototype);
  JsonObject.prototype.constructor = JsonObject;
  JsonPrimitive.prototype = Object.create(JsonElement.prototype);
  JsonPrimitive.prototype.constructor = JsonPrimitive;
  JsonNull.prototype = Object.create(JsonPrimitive.prototype);
  JsonNull.prototype.constructor = JsonNull;
  JsonArray.prototype = Object.create(JsonElement.prototype);
  JsonArray.prototype.constructor = JsonArray;
  JsonLiteral.prototype = Object.create(JsonPrimitive.prototype);
  JsonLiteral.prototype.constructor = JsonLiteral;
  JsonException.prototype = Object.create(SerializationException.prototype);
  JsonException.prototype.constructor = JsonException;
  JsonEncodingException.prototype = Object.create(JsonException.prototype);
  JsonEncodingException.prototype.constructor = JsonEncodingException;
  JsonDecodingException.prototype = Object.create(JsonException.prototype);
  JsonDecodingException.prototype.constructor = JsonDecodingException;
  StreamingJsonDecoder.prototype = Object.create(AbstractDecoder.prototype);
  StreamingJsonDecoder.prototype.constructor = StreamingJsonDecoder;
  AbstractJsonTreeDecoder.prototype = Object.create(NamedValueDecoder.prototype);
  AbstractJsonTreeDecoder.prototype.constructor = AbstractJsonTreeDecoder;
  JsonTreeDecoder.prototype = Object.create(AbstractJsonTreeDecoder.prototype);
  JsonTreeDecoder.prototype.constructor = JsonTreeDecoder;
  JsonTreeListDecoder.prototype = Object.create(AbstractJsonTreeDecoder.prototype);
  JsonTreeListDecoder.prototype.constructor = JsonTreeListDecoder;
  JsonTreeMapDecoder.prototype = Object.create(JsonTreeDecoder.prototype);
  JsonTreeMapDecoder.prototype.constructor = JsonTreeMapDecoder;
  WriteMode.prototype = Object.create(Enum.prototype);
  WriteMode.prototype.constructor = WriteMode;
  ObjectType.prototype = Object.create(Enum.prototype);
  ObjectType.prototype.constructor = ObjectType;
  AbstractCoroutine.prototype = Object.create(JobSupport.prototype);
  AbstractCoroutine.prototype.constructor = AbstractCoroutine;
  StandaloneCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  StandaloneCoroutine.prototype.constructor = StandaloneCoroutine;
  LazyStandaloneCoroutine.prototype = Object.create(StandaloneCoroutine.prototype);
  LazyStandaloneCoroutine.prototype.constructor = LazyStandaloneCoroutine;
  CancelHandler.prototype = Object.create(CancelHandlerBase.prototype);
  CancelHandler.prototype.constructor = CancelHandler;
  BeforeResumeCancelHandler.prototype = Object.create(CancelHandler.prototype);
  BeforeResumeCancelHandler.prototype.constructor = BeforeResumeCancelHandler;
  RemoveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveOnCancel.prototype.constructor = RemoveOnCancel;
  DispatchedTask.prototype = Object.create(SchedulerTask.prototype);
  DispatchedTask.prototype.constructor = DispatchedTask;
  CancellableContinuationImpl.prototype = Object.create(DispatchedTask.prototype);
  CancellableContinuationImpl.prototype.constructor = CancellableContinuationImpl;
  InvokeOnCancel.prototype = Object.create(CancelHandler.prototype);
  InvokeOnCancel.prototype.constructor = InvokeOnCancel;
  CancelledContinuation.prototype = Object.create(CompletedExceptionally.prototype);
  CancelledContinuation.prototype.constructor = CancelledContinuation;
  CoroutineDispatcher.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineDispatcher.prototype.constructor = CoroutineDispatcher;
  CoroutineStart.prototype = Object.create(Enum.prototype);
  CoroutineStart.prototype.constructor = CoroutineStart;
  EventLoop.prototype = Object.create(CoroutineDispatcher.prototype);
  EventLoop.prototype.constructor = EventLoop;
  CompletionHandlerException.prototype = Object.create(RuntimeException.prototype);
  CompletionHandlerException.prototype.constructor = CompletionHandlerException;
  CoroutinesInternalError.prototype = Object.create(Error_0.prototype);
  CoroutinesInternalError.prototype.constructor = CoroutinesInternalError;
  LinkedListHead.prototype = Object.create(LinkedListNode.prototype);
  LinkedListHead.prototype.constructor = LinkedListHead;
  NodeList_0.prototype = Object.create(LinkedListHead.prototype);
  NodeList_0.prototype.constructor = NodeList_0;
  CompletionHandlerBase.prototype = Object.create(LinkedListNode.prototype);
  CompletionHandlerBase.prototype.constructor = CompletionHandlerBase;
  JobNode.prototype = Object.create(CompletionHandlerBase.prototype);
  JobNode.prototype.constructor = JobNode;
  JobCancellingNode.prototype = Object.create(JobNode.prototype);
  JobCancellingNode.prototype.constructor = JobCancellingNode;
  ChildHandleNode.prototype = Object.create(JobCancellingNode.prototype);
  ChildHandleNode.prototype.constructor = ChildHandleNode;
  InvokeOnCancelling.prototype = Object.create(JobCancellingNode.prototype);
  InvokeOnCancelling.prototype.constructor = InvokeOnCancelling;
  InvokeOnCompletion.prototype = Object.create(JobNode.prototype);
  InvokeOnCompletion.prototype.constructor = InvokeOnCompletion;
  ChildContinuation.prototype = Object.create(JobCancellingNode.prototype);
  ChildContinuation.prototype.constructor = ChildContinuation;
  ChildCompletion.prototype = Object.create(JobNode.prototype);
  ChildCompletion.prototype.constructor = ChildCompletion;
  MainCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  MainCoroutineDispatcher.prototype.constructor = MainCoroutineDispatcher;
  CancellationException.prototype = Object.create(IllegalStateException.prototype);
  CancellationException.prototype.constructor = CancellationException;
  TimeoutCancellationException.prototype = Object.create(CancellationException.prototype);
  TimeoutCancellationException.prototype.constructor = TimeoutCancellationException;
  Unconfined.prototype = Object.create(CoroutineDispatcher.prototype);
  Unconfined.prototype.constructor = Unconfined;
  AtomicOp.prototype = Object.create(OpDescriptor.prototype);
  AtomicOp.prototype.constructor = AtomicOp;
  DispatchedContinuation.prototype = Object.create(DispatchedTask.prototype);
  DispatchedContinuation.prototype.constructor = DispatchedContinuation;
  LockedQueue.prototype = Object.create(LinkedListHead.prototype);
  LockedQueue.prototype.constructor = LockedQueue;
  LockWaiter.prototype = Object.create(LinkedListNode.prototype);
  LockWaiter.prototype.constructor = LockWaiter;
  LockCont.prototype = Object.create(LockWaiter.prototype);
  LockCont.prototype.constructor = LockCont;
  UnlockOp.prototype = Object.create(AtomicOp.prototype);
  UnlockOp.prototype.constructor = UnlockOp;
  JsMainDispatcher.prototype = Object.create(MainCoroutineDispatcher.prototype);
  JsMainDispatcher.prototype.constructor = JsMainDispatcher;
  UnconfinedEventLoop.prototype = Object.create(EventLoop.prototype);
  UnconfinedEventLoop.prototype.constructor = UnconfinedEventLoop;
  JobCancellationException.prototype = Object.create(CancellationException.prototype);
  JobCancellationException.prototype.constructor = JobCancellationException;
  SetTimeoutBasedDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  SetTimeoutBasedDispatcher.prototype.constructor = SetTimeoutBasedDispatcher;
  NodeDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  NodeDispatcher.prototype.constructor = NodeDispatcher;
  SetTimeoutDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  SetTimeoutDispatcher.prototype.constructor = SetTimeoutDispatcher;
  MessageQueue.prototype = Object.create(ArrayQueue.prototype);
  MessageQueue.prototype.constructor = MessageQueue;
  WindowDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  WindowDispatcher.prototype.constructor = WindowDispatcher;
  WindowMessageQueue.prototype = Object.create(MessageQueue.prototype);
  WindowMessageQueue.prototype.constructor = WindowMessageQueue;
  ScheduledMessageQueue.prototype = Object.create(MessageQueue.prototype);
  ScheduledMessageQueue.prototype.constructor = ScheduledMessageQueue;
  WithRatio.prototype = Object.create(GameScreenConfiguration.prototype);
  WithRatio.prototype.constructor = WithRatio;
  Type.prototype = Object.create(Enum.prototype);
  Type.prototype.constructor = Type;
  Local.prototype = Object.create(CoordinateConverter.prototype);
  Local.prototype.constructor = Local;
  Left.prototype = Object.create(HorizontalAlignment.prototype);
  Left.prototype.constructor = Left;
  Top.prototype = Object.create(VerticalAlignment.prototype);
  Top.prototype.constructor = Top;
  EventQueue.prototype = Object.create(System.prototype);
  EventQueue.prototype.constructor = EventQueue;
  EventWithQueryObjectPool.prototype = Object.create(ObjectPool.prototype);
  EventWithQueryObjectPool.prototype.constructor = EventWithQueryObjectPool;
  ArmatureUpdateSystem.prototype = Object.create(System.prototype);
  ArmatureUpdateSystem.prototype.constructor = ArmatureUpdateSystem;
  CameraTrackSystem.prototype = Object.create(System.prototype);
  CameraTrackSystem.prototype.constructor = CameraTrackSystem;
  ParticlesEmitterSystem.prototype = Object.create(System.prototype);
  ParticlesEmitterSystem.prototype.constructor = ParticlesEmitterSystem;
  ParticlesUpdateSystem.prototype = Object.create(System.prototype);
  ParticlesUpdateSystem.prototype.constructor = ParticlesUpdateSystem;
  ScriptExecutorSystem.prototype = Object.create(System.prototype);
  ScriptExecutorSystem.prototype.constructor = ScriptExecutorSystem;
  _no_name_provided__107.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__107.prototype.constructor = _no_name_provided__107;
  SpriteAnimatedSystem.prototype = Object.create(System.prototype);
  SpriteAnimatedSystem.prototype.constructor = SpriteAnimatedSystem;
  TemporalSystem.prototype = Object.create(System.prototype);
  TemporalSystem.prototype.constructor = TemporalSystem;
  TextEffectSystem.prototype = Object.create(System.prototype);
  TextEffectSystem.prototype.constructor = TextEffectSystem;
  AssetsManagerSystem.prototype = Object.create(System.prototype);
  AssetsManagerSystem.prototype.constructor = AssetsManagerSystem;
  EarlyAccessException.prototype = Object.create(RuntimeException.prototype);
  EarlyAccessException.prototype.constructor = EarlyAccessException;
  UnsupportedTypeException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedTypeException.prototype.constructor = UnsupportedTypeException;
  StayHere.prototype = Object.create(StoryboardAction.prototype);
  StayHere.prototype.constructor = StayHere;
  Back.prototype = Object.create(StoryboardAction.prototype);
  Back.prototype.constructor = Back;
  SwitchTo.prototype = Object.create(StoryboardAction.prototype);
  SwitchTo.prototype.constructor = SwitchTo;
  ReplaceWith.prototype = Object.create(StoryboardAction.prototype);
  ReplaceWith.prototype.constructor = ReplaceWith;
  DrawingType.prototype = Object.create(Enum.prototype);
  DrawingType.prototype.constructor = DrawingType;
  FrameBuffer.prototype = Object.create(System.prototype);
  FrameBuffer.prototype.constructor = FrameBuffer;
  StageWithSystem.prototype = Object.create(System.prototype);
  StageWithSystem.prototype.constructor = StageWithSystem;
  RenderStage.prototype = Object.create(StageWithSystem.prototype);
  RenderStage.prototype.constructor = RenderStage;
  ImGUIRenderStage.prototype = Object.create(RenderStage.prototype);
  ImGUIRenderStage.prototype.constructor = ImGUIRenderStage;
  Key_4.prototype = Object.create(Enum.prototype);
  Key_4.prototype.constructor = Key_4;
  TouchSignal.prototype = Object.create(Enum.prototype);
  TouchSignal.prototype.constructor = TouchSignal;
  InternalTouchEventObjectPool.prototype = Object.create(ObjectPool.prototype);
  InternalTouchEventObjectPool.prototype.constructor = InternalTouchEventObjectPool;
  InternalTouchEventWay.prototype = Object.create(Enum.prototype);
  InternalTouchEventWay.prototype.constructor = InternalTouchEventWay;
  LogLevel.prototype = Object.create(Enum.prototype);
  LogLevel.prototype.constructor = LogLevel;
  AnimatedModelRenderStage.prototype = Object.create(RenderStage.prototype);
  AnimatedModelRenderStage.prototype.constructor = AnimatedModelRenderStage;
  BoundingBoxRenderStage.prototype = Object.create(RenderStage.prototype);
  BoundingBoxRenderStage.prototype.constructor = BoundingBoxRenderStage;
  ClearBufferRenderStage.prototype = Object.create(RenderStage.prototype);
  ClearBufferRenderStage.prototype.constructor = ClearBufferRenderStage;
  EmptyVertexShader.prototype = Object.create(VertexShader.prototype);
  EmptyVertexShader.prototype.constructor = EmptyVertexShader;
  EmptyFragmentShader.prototype = Object.create(FragmentShader.prototype);
  EmptyFragmentShader.prototype.constructor = EmptyFragmentShader;
  ModelComponentRenderStage.prototype = Object.create(RenderStage.prototype);
  ModelComponentRenderStage.prototype.constructor = ModelComponentRenderStage;
  FloatDataSource.prototype = Object.create(DataSource.prototype);
  FloatDataSource.prototype.constructor = FloatDataSource;
  IntDataSource.prototype = Object.create(DataSource.prototype);
  IntDataSource.prototype.constructor = IntDataSource;
  ShortDataSource.prototype = Object.create(DataSource.prototype);
  ShortDataSource.prototype.constructor = ShortDataSource;
  UIntDataSource.prototype = Object.create(DataSource.prototype);
  UIntDataSource.prototype.constructor = UIntDataSource;
  DoubleDataSource.prototype = Object.create(DataSource.prototype);
  DoubleDataSource.prototype.constructor = DoubleDataSource;
  UniformMat4.prototype = Object.create(ShaderParameter.prototype);
  UniformMat4.prototype.constructor = UniformMat4;
  UniformArrayMat4.prototype = Object.create(ShaderParameter.prototype);
  UniformArrayMat4.prototype.constructor = UniformArrayMat4;
  UniformVec3.prototype = Object.create(ShaderParameter.prototype);
  UniformVec3.prototype.constructor = UniformVec3;
  UniformVec4.prototype = Object.create(ShaderParameter.prototype);
  UniformVec4.prototype.constructor = UniformVec4;
  UniformFloat.prototype = Object.create(ShaderParameter.prototype);
  UniformFloat.prototype.constructor = UniformFloat;
  AttributeVec2.prototype = Object.create(ShaderParameter.prototype);
  AttributeVec2.prototype.constructor = AttributeVec2;
  AttributeVec3.prototype = Object.create(ShaderParameter.prototype);
  AttributeVec3.prototype.constructor = AttributeVec3;
  AttributeVec4.prototype = Object.create(ShaderParameter.prototype);
  AttributeVec4.prototype.constructor = AttributeVec4;
  UniformSample2D.prototype = Object.create(ShaderParameter.prototype);
  UniformSample2D.prototype.constructor = UniformSample2D;
  ColorFragmentShader.prototype = Object.create(FragmentShader.prototype);
  ColorFragmentShader.prototype.constructor = ColorFragmentShader;
  UVFragmentShader.prototype = Object.create(FragmentShader.prototype);
  UVFragmentShader.prototype.constructor = UVFragmentShader;
  AnimatedMeshVertexShader.prototype = Object.create(VertexShader.prototype);
  AnimatedMeshVertexShader.prototype.constructor = AnimatedMeshVertexShader;
  BoundingBoxVertexShader.prototype = Object.create(VertexShader.prototype);
  BoundingBoxVertexShader.prototype.constructor = BoundingBoxVertexShader;
  MeshVertexShader.prototype = Object.create(VertexShader.prototype);
  MeshVertexShader.prototype.constructor = MeshVertexShader;
  ScoreSystem.prototype = Object.create(System.prototype);
  ScoreSystem.prototype.constructor = ScoreSystem;
  TrackSystem.prototype = Object.create(System.prototype);
  TrackSystem.prototype.constructor = TrackSystem;
  EnemySpawner.prototype = Object.create(TemporalSystem.prototype);
  EnemySpawner.prototype.constructor = EnemySpawner;
  EnemyMove.prototype = Object.create(System.prototype);
  EnemyMove.prototype.constructor = EnemyMove;
  EnemyDying.prototype = Object.create(System.prototype);
  EnemyDying.prototype.constructor = EnemyDying;
  PlayerSystem.prototype = Object.create(System.prototype);
  PlayerSystem.prototype.constructor = PlayerSystem;
  ChronoSystem.prototype = Object.create(TemporalSystem.prototype);
  ChronoSystem.prototype.constructor = ChronoSystem;
  StartGameSystem.prototype = Object.create(System.prototype);
  StartGameSystem.prototype.constructor = StartGameSystem;
  BlinkingSystem.prototype = Object.create(TemporalSystem.prototype);
  BlinkingSystem.prototype.constructor = BlinkingSystem;
  function toList(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList(_this_);
    }
  }
  function withIndex(_this_) {
    return new IndexingIterable(_no_name_provided_$factory(_this_));
  }
  function _get_indices_(_this_) {
    return new IntRange(0, _get_lastIndex_(_this_));
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(asCollection(_this_));
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last_2 = _this_.length - 1 | 0;
      if (inductionVariable <= last_2)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last_2);
    } else {
      var inductionVariable_0 = 0;
      var last_3 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_3)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals_1(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_3);
    }
    return -1;
  }
  function toSet(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_[0]);
      default:return toCollection(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_.length)));
    }
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function contains(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function toCollection(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_19(item);
      Unit_getInstance();
    }
    return destination;
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function toList_0(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList_0(_this_);
    }
  }
  function toMutableList_0(_this_) {
    var list = ArrayList_init_$Create$_0(_this_.length);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_19(item);
      Unit_getInstance();
    }
    return list;
  }
  function _get_lastIndex__0(_this_) {
    return _this_.length - 1 | 0;
  }
  function _no_name_provided_($this_withIndex) {
    this._$this_withIndex = $this_withIndex;
  }
  _no_name_provided_.prototype.invoke_274 = function () {
    return arrayIterator(this._$this_withIndex);
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory($this_withIndex) {
    var i = new _no_name_provided_($this_withIndex);
    return function () {
      return i.invoke_274();
    };
  }
  function toBooleanArray(_this_) {
    var result = booleanArray(_this_._get_size__32());
    var index = 0;
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function first(_this_) {
    if (_this_.isEmpty_35())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_57(0);
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinTo$default(_this_, buffer, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      separator = ', ';
    if (!(($mask0 & 4) === 0))
      prefix = '';
    if (!(($mask0 & 8) === 0))
      postfix = '';
    if (!(($mask0 & 16) === 0))
      limit = -1;
    if (!(($mask0 & 32) === 0))
      truncated = '...';
    if (!(($mask0 & 64) === 0))
      transform = null;
    return joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform);
  }
  function sortedWith(_this_, comparator) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__32() <= 1)
        return toList_1(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sortWith_0(tmp1_apply_0, comparator);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_1(_this_);
    sortWith(tmp2_apply_0, comparator);
    return tmp2_apply_0;
  }
  function random(_this_, random_0) {
    if (_this_.isEmpty_35())
      throw NoSuchElementException_init_$Create$_0('Collection is empty.');
    return elementAt(_this_, random_0.nextInt_6(_this_._get_size__32()));
  }
  function toList_1(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__32();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_57(0);
          } else {
            {
              tmp_0 = _this_.iterator_52().next_30();
            }
          }

          tmp = listOf_0(tmp_0);
          break;
        default:tmp = toMutableList_2(_this_);
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyList(toMutableList_1(_this_));
  }
  function toMutableList_1(_this_) {
    if (isInterface(_this_, Collection))
      return toMutableList_2(_this_);
    else {
    }
    return toCollection_0(_this_, ArrayList_init_$Create$());
  }
  function elementAt(_this_, index) {
    if (isInterface(_this_, List))
      return _this_.get_57(index);
    else {
    }
    return elementAtOrElse(_this_, index, _no_name_provided_$factory_0(index));
  }
  function toMutableList_2(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var item = tmp0_iterator.next_30();
      destination.add_19(item);
      Unit_getInstance();
    }
    return destination;
  }
  function elementAtOrElse(_this_, index, defaultValue) {
    if (isInterface(_this_, List)) {
      var tmp0_getOrElse_0 = _this_;
      return (index >= 0 ? index <= _get_lastIndex__1(tmp0_getOrElse_0) : false) ? tmp0_getOrElse_0.get_57(index) : defaultValue(index);
    } else {
    }
    if (index < 0)
      return defaultValue(index);
    var iterator_0 = _this_.iterator_52();
    var count = 0;
    while (iterator_0.hasNext_27()) {
      var element = iterator_0.next_30();
      var tmp0 = count;
      count = tmp0 + 1 | 0;
      if (index === tmp0)
        return element;
      else {
      }
    }
    return defaultValue(index);
  }
  function minOrNull(_this_) {
    var iterator_0 = _this_.iterator_52();
    if (!iterator_0.hasNext_27())
      return null;
    var min = iterator_0.next_30();
    while (iterator_0.hasNext_27()) {
      var e = iterator_0.next_30();
      if (compareTo(min, e) > 0)
        min = e;
    }
    return min;
  }
  function single(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return single_0(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_52();
        if (!iterator_0.hasNext_27())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var single_2 = iterator_0.next_30();
        if (iterator_0.hasNext_27())
          throw IllegalArgumentException_init_$Create$('Collection has more than one element.');
        return single_2;
      }
    }
  }
  function single_0(_this_) {
    var tmp0_subject = _this_._get_size__32();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this_.get_57(0);
        break;
      default:throw IllegalArgumentException_init_$Create$('List has more than one element.');
    }
    return tmp;
  }
  function toSet_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__32();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_57(0);
          } else {
            {
              tmp_0 = _this_.iterator_52().next_30();
            }
          }

          tmp = setOf_0(tmp_0);
          break;
        default:tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__32())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlySet(toCollection_0(_this_, LinkedHashSet_init_$Create$()));
  }
  function asSequence(_this_) {
    return new _no_name_provided__1(_this_);
  }
  function plus(_this_, elements) {
    if (isInterface(elements, Collection)) {
      var result = ArrayList_init_$Create$_0(_this_._get_size__32() + elements._get_size__32() | 0);
      result.addAll_11(_this_);
      Unit_getInstance();
      result.addAll_11(elements);
      Unit_getInstance();
      return result;
    } else {
      {
        var result_0 = ArrayList_init_$Create$_1(_this_);
        addAll(result_0, elements);
        Unit_getInstance();
        return result_0;
      }
    }
  }
  function firstOrNull(_this_) {
    return _this_.isEmpty_35() ? null : _this_.get_57(0);
  }
  function firstOrNull_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List)) {
      if (_this_.isEmpty_35())
        return null;
      else
        return _this_.get_57(0);
    } else {
      {
        var iterator_0 = _this_.iterator_52();
        if (!iterator_0.hasNext_27())
          return null;
        return iterator_0.next_30();
      }
    }
  }
  function plus_0(_this_, element) {
    var result = ArrayList_init_$Create$_0(_this_._get_size__32() + 1 | 0);
    result.addAll_11(_this_);
    Unit_getInstance();
    result.add_19(element);
    Unit_getInstance();
    return result;
  }
  function minus(_this_, element) {
    var result = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this_, 10));
    var removed = false;
    var tmp0_iterator_1 = _this_.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var tmp;
      if (!removed ? equals_1(element_2, element) : false) {
        removed = true;
        tmp = false;
      } else {
        tmp = true;
      }
      if (tmp) {
        result.add_19(element_2);
        Unit_getInstance();
      } else {
      }
    }
    return result;
  }
  function minus_0(_this_, elements) {
    var other = convertToSetForSetOperationWith(elements, _this_);
    if (other.isEmpty_35())
      return toList_1(_this_);
    var tmp0_filterNotTo_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = _this_.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      if (!other.contains_35(element_2)) {
        tmp0_filterNotTo_0.add_19(element_2);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterNotTo_0;
  }
  function toFloatArray(_this_) {
    var result = new Float32Array(_this_._get_size__32());
    var index = 0;
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function toShortArray(_this_) {
    var result = new Int16Array(_this_._get_size__32());
    var index = 0;
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function sum(_this_) {
    var sum_0 = 0;
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      sum_0 = sum_0 + element | 0;
    }
    return sum_0;
  }
  function last(_this_) {
    if (_this_.isEmpty_35())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_57(_get_lastIndex__1(_this_));
  }
  function dropLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return take(_this_, coerceAtLeast(_this_._get_size__32() - n | 0, 0));
  }
  function first_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return first(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_52();
        if (!iterator_0.hasNext_27())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        return iterator_0.next_30();
      }
    }
  }
  function chunked(_this_, size_0) {
    return windowed(_this_, size_0, size_0, true);
  }
  function lastOrNull(_this_) {
    return _this_.isEmpty_35() ? null : _this_.get_57(_this_._get_size__32() - 1 | 0);
  }
  function drop(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return toList_1(_this_);
    var list;
    if (isInterface(_this_, Collection)) {
      var resultSize = _this_._get_size__32() - n | 0;
      if (resultSize <= 0)
        return emptyList();
      if (resultSize === 1)
        return listOf_0(last_0(_this_));
      list = ArrayList_init_$Create$_0(resultSize);
      if (isInterface(_this_, List)) {
        if (isInterface(_this_, RandomAccess)) {
          var untilArg = _this_._get_size__32();
          var inductionVariable = n;
          var last_2 = untilArg - 1 | 0;
          if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              list.add_19(_this_.get_57(index));
              Unit_getInstance();
            }
             while (inductionVariable <= last_2);
        } else {
          {
            var tmp1_iterator_0 = _this_.listIterator_5(n);
            var tmp1_iterator = tmp1_iterator_0;
            while (tmp1_iterator.hasNext_27()) {
              var item = tmp1_iterator.next_30();
              list.add_19(item);
              Unit_getInstance();
            }
          }
        }
        return list;
      } else {
      }
    } else {
      {
        list = ArrayList_init_$Create$();
      }
    }
    var count = 0;
    var tmp2_iterator = _this_.iterator_52();
    while (tmp2_iterator.hasNext_27()) {
      var item_0 = tmp2_iterator.next_30();
      if (count >= n) {
        list.add_19(item_0);
        Unit_getInstance();
      } else {
        count = count + 1 | 0;
        Unit_getInstance();
      }
    }
    return optimizeReadOnlyList(list);
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return emptyList();
    if (isInterface(_this_, Collection)) {
      if (n >= _this_._get_size__32())
        return toList_1(_this_);
      if (n === 1)
        return listOf_0(first_0(_this_));
    } else {
    }
    var count = 0;
    var list = ArrayList_init_$Create$_0(n);
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var item = tmp0_iterator.next_30();
      list.add_19(item);
      Unit_getInstance();
      count = count + 1 | 0;
      if (count === n)
        break;
      else {
      }
    }
    return optimizeReadOnlyList(list);
  }
  function windowed(_this_, size_0, step, partialWindows) {
    checkWindowSizeStep(size_0, step);
    var tmp;
    if (isInterface(_this_, RandomAccess)) {
      tmp = isInterface(_this_, List);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var thisSize = _this_._get_size__32();
      var resultCapacity = (thisSize / step | 0) + (thisSize % step === 0 ? 0 : 1) | 0;
      var result = ArrayList_init_$Create$_0(resultCapacity);
      var index = 0;
      while ((0 <= index ? index <= (thisSize - 1 | 0) : false) ? !(thisSize === -2147483648) : false) {
        var windowSize = coerceAtMost(size_0, thisSize - index | 0);
        if (windowSize < size_0 ? !partialWindows : false)
          break;
        var list_1 = ArrayList_init_$Create$_0(windowSize);
        var inductionVariable = 0;
        var last_2 = windowSize - 1 | 0;
        if (!(windowSize === -2147483648) ? inductionVariable <= last_2 : false)
          do {
            var index_3 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            list_1.add_19(_this_.get_57(index_3 + index | 0));
            Unit_getInstance();
          }
           while (inductionVariable <= last_2);
        result.add_19(list_1);
        Unit_getInstance();
        index = index + step | 0;
      }
      return result;
    } else {
    }
    var result_0 = ArrayList_init_$Create$();
    var tmp0_forEach_0 = windowedIterator(_this_.iterator_52(), size_0, step, partialWindows, false);
    var tmp0_iterator_1 = tmp0_forEach_0;
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      result_0.add_19(element_2);
      Unit_getInstance();
    }
    return result_0;
  }
  function last_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return last(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_52();
        if (!iterator_0.hasNext_27())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var last_2 = iterator_0.next_30();
        while (iterator_0.hasNext_27())
          last_2 = iterator_0.next_30();
        return last_2;
      }
    }
  }
  function toHashSet(_this_) {
    return toCollection_0(_this_, HashSet_init_$Create$_1(mapCapacity(collectionSizeOrDefault(_this_, 12))));
  }
  function toIntArray(_this_) {
    var result = new Int32Array(_this_._get_size__32());
    var index = 0;
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function _no_name_provided__0($index) {
    this._$index = $index;
  }
  _no_name_provided__0.prototype.invoke_113 = function (it) {
    throw IndexOutOfBoundsException_init_$Create$('' + "Collection doesn't contain element at index " + this._$index + '.');
  };
  _no_name_provided__0.prototype.invoke_276 = function (p1) {
    return this.invoke_113((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1($this_asSequence) {
    this._$this_asSequence = $this_asSequence;
  }
  _no_name_provided__1.prototype.iterator_2_1 = function () {
    return this._$this_asSequence.iterator_52();
  };
  _no_name_provided__1.prototype.iterator_52 = function () {
    return this.iterator_2_1();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function _no_name_provided_$factory_0($index) {
    var i = new _no_name_provided__0($index);
    return function (p1) {
      return i.invoke_113(p1);
    };
  }
  function asSequence_0(_this_) {
    return asSequence(_this_._get_entries__5());
  }
  function until(_this_, to_0) {
    if (to_0 <= IntCompanionObject_getInstance()._MIN_VALUE_1)
      return Companion_getInstance_5()._EMPTY;
    return numberRangeToNumber(_this_, to_0 - 1 | 0);
  }
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function downTo(_this_, to_0) {
    return Companion_getInstance_4().fromClosedRange(_this_, to_0, -1);
  }
  function coerceIn(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function until_0(_this_, to_0) {
    if (to_0.compareTo_48(new Long(0, -2147483648)) <= 0)
      return Companion_getInstance_6()._EMPTY_0;
    var tmp = toLong_0(_this_);
    var tmp0_minus_0 = 1;
    return tmp.rangeTo_11(to_0.minus_28(toLong_0(tmp0_minus_0)).toLong_4());
  }
  function toList_2(_this_) {
    return optimizeReadOnlyList(toMutableList_3(_this_));
  }
  function map(_this_, transform) {
    return new TransformingSequence(_this_, transform);
  }
  function take_0(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp;
    if (n === 0) {
      tmp = emptySequence();
    } else {
      if (isInterface(_this_, DropTakeSequence)) {
        tmp = _this_.take_1(n);
      } else {
        {
          tmp = new TakeSequence(_this_, n);
        }
      }
    }
    return tmp;
  }
  function toMutableList_3(_this_) {
    return toCollection_1(_this_, ArrayList_init_$Create$());
  }
  function toCollection_1(_this_, destination) {
    var tmp0_iterator = _this_.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var item = tmp0_iterator.next_30();
      destination.add_19(item);
      Unit_getInstance();
    }
    return destination;
  }
  function filter(_this_, predicate) {
    return new FilteringSequence(_this_, true, predicate);
  }
  function flatMap(_this_, transform) {
    return new FlatteningSequence(_this_, transform, _no_name_provided_$factory_1());
  }
  function asIterable(_this_) {
    return new _no_name_provided__1_0(_this_);
  }
  function _no_name_provided__2() {
  }
  _no_name_provided__2.prototype.invoke_3 = function (p0) {
    return p0.iterator_52();
  };
  _no_name_provided__2.prototype.invoke_276 = function (p1) {
    return this.invoke_3((!(p1 == null) ? isInterface(p1, Iterable) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__2.prototype._get_name__24 = function () {
    return 'iterator';
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_0($this_asIterable) {
    this._$this_asIterable = $this_asIterable;
  }
  _no_name_provided__1_0.prototype.iterator_2_1 = function () {
    return this._$this_asIterable.iterator_52();
  };
  _no_name_provided__1_0.prototype.iterator_52 = function () {
    return this.iterator_2_1();
  };
  _no_name_provided__1_0.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function _no_name_provided_$factory_1() {
    var i = new _no_name_provided__2();
    var l = function (p1) {
      return i.invoke_3(p1);
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function plus_1(_this_, element) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__32() + 1 | 0));
    result.addAll_11(_this_);
    Unit_getInstance();
    result.add_19(element);
    Unit_getInstance();
    return result;
  }
  function minus_1(_this_, element) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__32()));
    var removed = false;
    var tmp0_iterator_1 = _this_.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var tmp;
      if (!removed ? equals_1(element_2, element) : false) {
        removed = true;
        tmp = false;
      } else {
        tmp = true;
      }
      if (tmp) {
        result.add_19(element_2);
        Unit_getInstance();
      } else {
      }
    }
    return result;
  }
  function last_1(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, _get_lastIndex__2(_this_));
  }
  function drop_0(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0);
  }
  function single_1(_this_) {
    var tmp0_subject = charSequenceLength(_this_);
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
      case 1:
        tmp = charSequenceGet(_this_, 0);
        break;
      default:throw IllegalArgumentException_init_$Create$('Char sequence has more than one element.');
    }
    return tmp;
  }
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_35 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (equals_1(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_26 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (!this.contains_35(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_35 = function () {
    return this._get_size__32() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory_2(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory_2(this$0) {
    var i = new _no_name_provided__3(this$0);
    return function (p1) {
      return i.invoke_5(p1);
    };
  }
  function _no_name_provided__3(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided__3.prototype.invoke_5 = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided__3.prototype.invoke_276 = function (p1) {
    return this.invoke_5((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractIterator() {
    this._state = State_NotReady_getInstance();
    this._nextValue = null;
  }
  AbstractIterator.prototype.hasNext_27 = function () {
    var tmp0_require_0 = !this._state.equals(State_Failed_getInstance());
    if (!tmp0_require_0) {
      var message_2 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp0_subject = this._state;
    return tmp0_subject.equals(State_Done_getInstance()) ? false : tmp0_subject.equals(State_Ready_getInstance()) ? true : tryToComputeNext(this);
  };
  AbstractIterator.prototype.next_30 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    this._state = State_NotReady_getInstance();
    var tmp = this._nextValue;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  AbstractIterator.prototype.setNext_0 = function (value) {
    this._nextValue = value;
    this._state = State_Ready_getInstance();
  };
  AbstractIterator.prototype.done_0 = function () {
    this._state = State_Done_getInstance();
  };
  AbstractIterator.$metadata$ = {
    simpleName: 'AbstractIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function State(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  State.$metadata$ = {
    simpleName: 'State',
    kind: 'class',
    interfaces: []
  };
  function State_Ready_getInstance() {
    State_initEntries();
    return State_Ready_instance;
  }
  function State_NotReady_getInstance() {
    State_initEntries();
    return State_NotReady_instance;
  }
  function State_Done_getInstance() {
    State_initEntries();
    return State_Done_instance;
  }
  function State_Failed_getInstance() {
    State_initEntries();
    return State_Failed_instance;
  }
  function tryToComputeNext($this) {
    $this._state = State_Failed_getInstance();
    $this.computeNext_0();
    return $this._state.equals(State_Ready_getInstance());
  }
  var State_Ready_instance;
  var State_NotReady_instance;
  var State_Done_instance;
  var State_Failed_instance;
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_getInstance();
    State_entriesInitialized = true;
    State_Ready_instance = new State('Ready', 0);
    State_NotReady_instance = new State('NotReady', 1);
    State_Done_instance = new State('Done', 2);
    State_Failed_instance = new State('Failed', 3);
  }
  function AbstractList() {
    AbstractCollection.call(this);
  }
  AbstractList.prototype.iterator_52 = function () {
    return new IteratorImpl(this);
  };
  AbstractList.prototype.listIterator_5 = function (index) {
    return new ListIteratorImpl(this, index);
  };
  AbstractList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractList.$metadata$ = {
    simpleName: 'AbstractList',
    kind: 'class',
    interfaces: [List]
  };
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index = 0;
  }
  IteratorImpl.prototype._set_index__2 = function (_set___) {
    this._index = _set___;
  };
  IteratorImpl.prototype._get_index__2 = function () {
    return this._index;
  };
  IteratorImpl.prototype.hasNext_27 = function () {
    return this._index < this._$this._get_size__32();
  };
  IteratorImpl.prototype.next_30 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._index;
    tmp0_this._index = tmp1 + 1 | 0;
    return this._$this.get_57(tmp1);
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [Iterator]
  };
  function ListIteratorImpl($outer, index) {
    this._$this_0 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_getInstance().checkPositionIndex(index, this._$this_0._get_size__32());
    this._set_index__2(index);
  }
  ListIteratorImpl.prototype.hasPrevious_2 = function () {
    return this._get_index__2() > 0;
  };
  ListIteratorImpl.prototype.previous_2 = function () {
    if (!this.hasPrevious_2())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    tmp0_this._set_index__2(tmp0_this._get_index__2() - 1 | 0);
    return this._$this_0.get_57(tmp0_this._get_index__2());
  };
  ListIteratorImpl.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [ListIterator]
  };
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size_0) {
    if (index < 0 ? true : index >= size_0) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size_0);
    }};
  Companion_0.prototype.checkPositionIndex = function (index, size_0) {
    if (index < 0 ? true : index > size_0) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size_0);
    }};
  Companion_0.prototype.checkRangeIndexes = function (fromIndex, toIndex, size_0) {
    if (fromIndex < 0 ? true : toIndex > size_0) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size_0);
    }if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }};
  Companion_0.prototype.checkBoundsIndexes = function (startIndex, endIndex, size_0) {
    if (startIndex < 0 ? true : endIndex > size_0) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size_0);
    }if (startIndex > endIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var e = tmp0_iterator.next_30();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__32() === other._get_size__32()))
      return false;
    var otherIterator = other.iterator_52();
    var tmp0_iterator = c.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var elem = tmp0_iterator.next_30();
      var elemOther = otherIterator.next_30();
      if (!equals_1(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function AbstractMap() {
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_8 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsValue_2 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._get_entries__5();
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (equals_1(element_2._get_value__12(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.containsEntry_2 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__20();
    var value = entry._get_value__12();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_27(key);
    if (!equals_1(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_8(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__32() === other._get_size__32()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__5();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (!this.containsEntry_2(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_27 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__12();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__5());
  };
  AbstractMap.prototype.isEmpty_35 = function () {
    return this._get_size__32() === 0;
  };
  AbstractMap.prototype._get_size__32 = function () {
    return this._get_entries__5()._get_size__32();
  };
  AbstractMap.prototype._get_keys__5 = function () {
    if (this.__keys == null) {
      var tmp = this;
      tmp.__keys = new _no_name_provided__6(this);
    }return ensureNotNull(this.__keys);
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__5();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_3(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__20()) + '=' + toString(this, entry._get_value__12());
  };
  AbstractMap.prototype._get_values__6 = function () {
    if (this.__values == null) {
      var tmp = this;
      tmp.__values = new _no_name_provided__8(this);
    }return ensureNotNull(this.__values);
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_3(this$0) {
    var i = new _no_name_provided__7(this$0);
    return function (p1) {
      return i.invoke_7(p1);
    };
  }
  function _no_name_provided__4($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__4.prototype.hasNext_27 = function () {
    return this._$entryIterator.hasNext_27();
  };
  _no_name_provided__4.prototype.next_30 = function () {
    return this._$entryIterator.next_30()._get_key__20();
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__5($entryIterator) {
    this._$entryIterator_0 = $entryIterator;
  }
  _no_name_provided__5.prototype.hasNext_27 = function () {
    return this._$entryIterator_0.hasNext_27();
  };
  _no_name_provided__5.prototype.next_30 = function () {
    return this._$entryIterator_0.next_30()._get_value__12();
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__5();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (equals_1(element_2._get_key__20(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__20();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__12();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__20() + '=' + e._get_value__12();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals_1(e._get_key__20(), other._get_key__20()) ? equals_1(e._get_value__12(), other._get_value__12()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__6(this$0) {
    this._this$0_0 = this$0;
    AbstractSet.call(this);
  }
  _no_name_provided__6.prototype.contains_26 = function (element) {
    return this._this$0_0.containsKey_8(element);
  };
  _no_name_provided__6.prototype.contains_35 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_26((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__6.prototype.iterator_52 = function () {
    var entryIterator = this._this$0_0._get_entries__5().iterator_52();
    return new _no_name_provided__4(entryIterator);
  };
  _no_name_provided__6.prototype._get_size__32 = function () {
    return this._this$0_0._get_size__32();
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__7(this$0) {
    this._this$0_1 = this$0;
  }
  _no_name_provided__7.prototype.invoke_7 = function (it) {
    return this._this$0_1.toString_0(it);
  };
  _no_name_provided__7.prototype.invoke_276 = function (p1) {
    return this.invoke_7((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__8(this$0) {
    this._this$0_2 = this$0;
    AbstractCollection.call(this);
  }
  _no_name_provided__8.prototype.contains_18 = function (element) {
    return this._this$0_2.containsValue_2(element);
  };
  _no_name_provided__8.prototype.contains_35 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_18((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__8.prototype.iterator_52 = function () {
    var entryIterator = this._this$0_2._get_entries__5().iterator_52();
    return new _no_name_provided__5(entryIterator);
  };
  _no_name_provided__8.prototype._get_size__32 = function () {
    return this._this$0_2._get_size__32();
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractSet() {
    AbstractCollection.call(this);
  }
  AbstractSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractSet.$metadata$ = {
    simpleName: 'AbstractSet',
    kind: 'class',
    interfaces: [Set]
  };
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__32() === other._get_size__32()))
      return false;
    return c.containsAll_26(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_35();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__32 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_35 = function () {
    return true;
  };
  EmptyList.prototype.contains_11 = function (element) {
    return false;
  };
  EmptyList.prototype.contains_35 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_11(tmp);
  };
  EmptyList.prototype.containsAll_8 = function (elements) {
    return elements.isEmpty_35();
  };
  EmptyList.prototype.containsAll_26 = function (elements) {
    return this.containsAll_8(elements);
  };
  EmptyList.prototype.get_57 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_52 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.prototype.listIterator_5 = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$('' + 'Index: ' + index);
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_27 = function () {
    return false;
  };
  EmptyIterator.prototype.hasPrevious_2 = function () {
    return false;
  };
  EmptyIterator.prototype.next_30 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.prototype.previous_2 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function asCollection(_this_) {
    return new ArrayAsCollection(_this_, false);
  }
  function _get_lastIndex__1(_this_) {
    return _this_._get_size__32() - 1 | 0;
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__32();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_.get_57(0));
      default:return _this_;
    }
  }
  function ArrayAsCollection(values_1, isVarargs) {
    this._values = values_1;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__32 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_35 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_13 = function (element) {
    return contains(this._values, element);
  };
  ArrayAsCollection.prototype.contains_35 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_13((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayAsCollection.prototype.containsAll_10 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (!this.contains_13(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_26 = function (elements) {
    return this.containsAll_10(elements);
  };
  ArrayAsCollection.prototype.iterator_52 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _get_indices__0(_this_) {
    return numberRangeToNumber(0, _this_._get_size__32() - 1 | 0);
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$('Index overflow has happened.');
  }
  function IndexedValue(index, value) {
    this._index_0 = index;
    this._value = value;
  }
  IndexedValue.prototype.toString = function () {
    return '' + 'IndexedValue(index=' + this._index_0 + ', value=' + this._value + ')';
  };
  IndexedValue.prototype.hashCode = function () {
    return imul(this._index_0, 31) + (this._value == null ? 0 : hashCode(this._value)) | 0;
  };
  IndexedValue.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndexedValue))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof IndexedValue ? other : THROW_CCE();
    if (!(this._index_0 === tmp0_other_with_cast._index_0))
      return false;
    if (!equals_1(this._value, tmp0_other_with_cast._value))
      return false;
    return true;
  };
  IndexedValue.$metadata$ = {
    simpleName: 'IndexedValue',
    kind: 'class',
    interfaces: []
  };
  function IndexingIterable(iteratorFactory) {
    this._iteratorFactory = iteratorFactory;
  }
  IndexingIterable.prototype.iterator_52 = function () {
    return new IndexingIterator(this._iteratorFactory());
  };
  IndexingIterable.$metadata$ = {
    simpleName: 'IndexingIterable',
    kind: 'class',
    interfaces: [Iterable]
  };
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__32();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function convertToSetForSetOperationWith(_this_, source) {
    var tmp0_subject = _this_;
    var tmp;
    if (isInterface(tmp0_subject, Set)) {
      tmp = _this_;
    } else {
      if (isInterface(tmp0_subject, Collection)) {
        var tmp_0;
        var tmp_1;
        if (isInterface(source, Collection)) {
          tmp_1 = source._get_size__32() < 2;
        } else {
          {
            tmp_1 = false;
          }
        }
        if (tmp_1) {
          tmp_0 = _this_;
        } else {
          {
            tmp_0 = safeToConvertToSet(_this_) ? toHashSet(_this_) : _this_;
          }
        }
        tmp = tmp_0;
      } else {
        {
          tmp = toHashSet(_this_);
        }
      }
    }
    return tmp;
  }
  function safeToConvertToSet(_this_) {
    var tmp;
    if (_this_._get_size__32() > 2) {
      tmp = _this_ instanceof ArrayList;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function IndexingIterator(iterator_0) {
    this._iterator = iterator_0;
    this._index_1 = 0;
  }
  IndexingIterator.prototype.hasNext_27 = function () {
    return this._iterator.hasNext_27();
  };
  IndexingIterator.prototype.next_30 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_1;
    tmp0_this._index_1 = tmp1 + 1 | 0;
    return new IndexedValue(checkIndexOverflow(tmp1), this._iterator.next_30());
  };
  IndexingIterator.$metadata$ = {
    simpleName: 'IndexingIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function getOrImplicitDefault(_this_, key) {
    if (isInterface(_this_, MapWithDefault))
      return _this_.getOrImplicitDefault(key);
    else {
    }
    var tmp$ret$0;
    l$ret$1: do {
      var value_1 = _this_.get_27(key);
      if (value_1 == null ? !_this_.containsKey_8(key) : false) {
        throw NoSuchElementException_init_$Create$_0('' + 'Key ' + key + ' is missing in the map.');
      } else {
        tmp$ret$0 = (value_1 == null ? true : isObject(value_1)) ? value_1 : THROW_CCE();
        break l$ret$1;
      }
    }
     while (false);
    return tmp$ret$0;
  }
  function MapWithDefault() {
  }
  MapWithDefault.$metadata$ = {
    simpleName: 'MapWithDefault',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function mapOf(pairs) {
    return pairs.length > 0 ? toMap_0(pairs, LinkedHashMap_init_$Create$_1(mapCapacity(pairs.length))) : emptyMap();
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function toMap(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__32();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_57(0);
          } else {
            {
              tmp_0 = _this_.iterator_52().next_30();
            }
          }

          tmp = mapOf_0(tmp_0);
          break;
        default:tmp = toMap_1(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_._get_size__32())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyMap(toMap_1(_this_, LinkedHashMap_init_$Create$()));
  }
  function toMap_0(_this_, destination) {
    putAll(destination, _this_);
    return destination;
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_35();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__32 = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_35 = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_0 = function (key) {
    return false;
  };
  EmptyMap.prototype.containsKey_8 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return false;
    else {
    }
    return this.containsKey_0((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype.get_3 = function (key) {
    return null;
  };
  EmptyMap.prototype.get_27 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return null;
    else {
    }
    return this.get_3((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__5 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.prototype._get_keys__5 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.prototype._get_values__6 = function () {
    return EmptyList_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function toMap_1(_this_, destination) {
    putAll_0(destination, _this_);
    return destination;
  }
  function optimizeReadOnlyMap(_this_) {
    var tmp0_subject = _this_._get_size__32();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        tmp = _this_;
        break;
      default:tmp = _this_;
        break;
    }
    return tmp;
  }
  function putAll(_this_, pairs) {
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.component1();
      var value = tmp1_loop_parameter.component2();
      _this_.put_5(key, value);
      Unit_getInstance();
    }
  }
  function putAll_0(_this_, pairs) {
    var tmp0_iterator = pairs.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var tmp1_loop_parameter = tmp0_iterator.next_30();
      var key = tmp1_loop_parameter.component1();
      var value = tmp1_loop_parameter.component2();
      _this_.put_5(key, value);
      Unit_getInstance();
    }
  }
  function hashMapOf(pairs) {
    var tmp0_apply_0 = HashMap_init_$Create$_1(mapCapacity(pairs.length));
    putAll(tmp0_apply_0, pairs);
    return tmp0_apply_0;
  }
  function getValue(_this_, key) {
    return getOrImplicitDefault(_this_, key);
  }
  function plus_2(_this_, pair) {
    var tmp;
    if (_this_.isEmpty_35()) {
      tmp = mapOf_0(pair);
    } else {
      var tmp0_apply_0 = LinkedHashMap_init_$Create$_2(_this_);
      tmp0_apply_0.put_5(pair._first, pair._second);
      Unit_getInstance();
      tmp = tmp0_apply_0;
    }
    return tmp;
  }
  function addAll(_this_, elements) {
    var tmp0_subject = elements;
    if (isInterface(tmp0_subject, Collection))
      return _this_.addAll_11(elements);
    else {
      {
        var result = false;
        var tmp1_iterator = elements.iterator_52();
        while (tmp1_iterator.hasNext_27()) {
          var item = tmp1_iterator.next_30();
          if (_this_.add_19(item))
            result = true;
        }
        return result;
      }
    }
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function SequenceScope() {
  }
  SequenceScope.$metadata$ = {
    simpleName: 'SequenceScope',
    kind: 'class',
    interfaces: []
  };
  function iterator(block) {
    var iterator_0 = new SequenceBuilderIterator();
    iterator_0._nextStep = createCoroutineUnintercepted(block, iterator_0, iterator_0);
    return iterator_0;
  }
  function SequenceBuilderIterator() {
    SequenceScope.call(this);
    this._state_0 = 0;
    this._nextValue_0 = null;
    this._nextIterator = null;
    this._nextStep = null;
  }
  SequenceBuilderIterator.prototype.hasNext_27 = function () {
    while (true) {
      var tmp0_subject = this._state_0;
      switch (tmp0_subject) {
        case 0:
          break;
        case 1:
          if (ensureNotNull(this._nextIterator).hasNext_27()) {
            this._state_0 = 2;
            return true;
          } else {
            this._nextIterator = null;
          }

          break;
        case 4:
          return false;
        case 3:
        case 2:
          return true;
        default:throw exceptionalState(this);
      }
      this._state_0 = 5;
      var step = ensureNotNull(this._nextStep);
      this._nextStep = null;
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0 = Companion_getInstance_3();
      step.resumeWith_11(Unit_getInstance());
    }
  };
  SequenceBuilderIterator.prototype.next_30 = function () {
    var tmp0_subject = this._state_0;
    switch (tmp0_subject) {
      case 0:
      case 1:
        return nextNotReady(this);
      case 2:
        this._state_0 = 1;
        return ensureNotNull(this._nextIterator).next_30();
      case 3:
        this._state_0 = 0;
        var tmp = this._nextValue_0;
        var result = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        this._nextValue_0 = null;
        return result;
      default:throw exceptionalState(this);
    }
  };
  SequenceBuilderIterator.prototype.yield_0 = function (value, $cont) {
    this._nextValue_0 = value;
    this._state_0 = 3;
    var tmp0__anonymous__1 = $cont;
    this._nextStep = tmp0__anonymous__1;
    return _get_COROUTINE_SUSPENDED_();
  };
  SequenceBuilderIterator.prototype.resumeWith_9 = function (result) {
    throwOnFailure(result);
    var tmp = _get_value__impl(result);
    if (tmp instanceof Unit)
      tmp;
    else
      THROW_CCE();
    this._state_0 = 4;
  };
  SequenceBuilderIterator.prototype.resumeWith_11 = function (result) {
    return this.resumeWith_9(result);
  };
  SequenceBuilderIterator.prototype._get_context__9 = function () {
    return EmptyCoroutineContext_getInstance();
  };
  SequenceBuilderIterator.$metadata$ = {
    simpleName: 'SequenceBuilderIterator',
    kind: 'class',
    interfaces: [Iterator, Continuation]
  };
  function nextNotReady($this) {
    if (!$this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    else
      return $this.next_30();
  }
  function exceptionalState($this) {
    var tmp0_subject = $this._state_0;
    switch (tmp0_subject) {
      case 4:
        return NoSuchElementException_init_$Create$();
      case 5:
        return IllegalStateException_init_$Create$('Iterator has failed.');
      default:return IllegalStateException_init_$Create$('' + 'Unexpected state of the iterator: ' + $this._state_0);
    }
  }
  function generateSequence(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function TransformingSequence(sequence, transformer) {
    this._sequence = sequence;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_52 = function () {
    return new _no_name_provided__9(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function emptySequence() {
    return EmptySequence_getInstance();
  }
  function DropTakeSequence() {
  }
  DropTakeSequence.$metadata$ = {
    simpleName: 'DropTakeSequence',
    kind: 'interface',
    interfaces: [Sequence]
  };
  function TakeSequence(sequence, count) {
    this._sequence_0 = sequence;
    this._count = count;
    var tmp0_require_0 = this._count >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'count must be non-negative, but was ' + this._count + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }}
  TakeSequence.prototype.take_1 = function (n) {
    return n >= this._count ? this : new TakeSequence(this._sequence_0, n);
  };
  TakeSequence.prototype.iterator_52 = function () {
    return new _no_name_provided__10(this);
  };
  TakeSequence.$metadata$ = {
    simpleName: 'TakeSequence',
    kind: 'class',
    interfaces: [Sequence, DropTakeSequence]
  };
  function GeneratorSequence(getInitialValue, getNextValue) {
    this._getInitialValue = getInitialValue;
    this._getNextValue = getNextValue;
  }
  GeneratorSequence.prototype.iterator_52 = function () {
    return new _no_name_provided__11(this);
  };
  GeneratorSequence.$metadata$ = {
    simpleName: 'GeneratorSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function FlatteningSequence(sequence, transformer, iterator_0) {
    this._sequence_1 = sequence;
    this._transformer_0 = transformer;
    this._iterator_0 = iterator_0;
  }
  FlatteningSequence.prototype.iterator_52 = function () {
    return new _no_name_provided__12(this);
  };
  FlatteningSequence.$metadata$ = {
    simpleName: 'FlatteningSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function EmptySequence() {
    EmptySequence_instance = this;
  }
  EmptySequence.prototype.iterator_52 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySequence.prototype.take_1 = function (n) {
    return EmptySequence_getInstance();
  };
  EmptySequence.$metadata$ = {
    simpleName: 'EmptySequence',
    kind: 'object',
    interfaces: [Sequence, DropTakeSequence]
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    if (EmptySequence_instance == null)
      new EmptySequence();
    return EmptySequence_instance;
  }
  function FilteringSequence(sequence, sendWhen, predicate) {
    this._sequence_2 = sequence;
    this._sendWhen = sendWhen;
    this._predicate = predicate;
  }
  FilteringSequence.prototype.iterator_52 = function () {
    return new _no_name_provided__13(this);
  };
  FilteringSequence.$metadata$ = {
    simpleName: 'FilteringSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function _no_name_provided__9(this$0) {
    this._this$0_3 = this$0;
    this._iterator_1 = this._this$0_3._sequence.iterator_52();
  }
  _no_name_provided__9.prototype.next_30 = function () {
    return this._this$0_3._transformer(this._iterator_1.next_30());
  };
  _no_name_provided__9.prototype.hasNext_27 = function () {
    return this._iterator_1.hasNext_27();
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__10(this$0) {
    this._this$0_4 = this$0;
    this._left = this._this$0_4._count;
    this._iterator_2 = this._this$0_4._sequence_0.iterator_52();
  }
  _no_name_provided__10.prototype.next_30 = function () {
    if (this._left === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._left;
    tmp0_this._left = tmp1 - 1 | 0;
    Unit_getInstance();
    return this._iterator_2.next_30();
  };
  _no_name_provided__10.prototype.hasNext_27 = function () {
    return this._left > 0 ? this._iterator_2.hasNext_27() : false;
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function calcNext($this) {
    $this._nextItem = $this._nextState === -2 ? $this._this$0_5._getInitialValue() : $this._this$0_5._getNextValue(ensureNotNull($this._nextItem));
    $this._nextState = $this._nextItem == null ? 0 : 1;
  }
  function _no_name_provided__11(this$0) {
    this._this$0_5 = this$0;
    this._nextItem = null;
    this._nextState = -2;
  }
  _no_name_provided__11.prototype.next_30 = function () {
    if (this._nextState < 0)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem;
    var result = isObject(tmp) ? tmp : THROW_CCE();
    this._nextState = -1;
    return result;
  };
  _no_name_provided__11.prototype.hasNext_27 = function () {
    if (this._nextState < 0)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function ensureItemIterator($this) {
    var tmp0_safe_receiver = $this._itemIterator;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasNext_27()) === false)
      $this._itemIterator = null;
    else {
    }
    while ($this._itemIterator == null) {
      if (!$this._iterator_3.hasNext_27()) {
        return false;
      } else {
        var element = $this._iterator_3.next_30();
        var nextItemIterator = $this._this$0_6._iterator_0($this._this$0_6._transformer_0(element));
        if (nextItemIterator.hasNext_27()) {
          $this._itemIterator = nextItemIterator;
          return true;
        }}
    }
    return true;
  }
  function _no_name_provided__12(this$0) {
    this._this$0_6 = this$0;
    this._iterator_3 = this._this$0_6._sequence_1.iterator_52();
    this._itemIterator = null;
  }
  _no_name_provided__12.prototype.next_30 = function () {
    if (!ensureItemIterator(this))
      throw NoSuchElementException_init_$Create$();
    return ensureNotNull(this._itemIterator).next_30();
  };
  _no_name_provided__12.prototype.hasNext_27 = function () {
    return ensureItemIterator(this);
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function calcNext_0($this) {
    while ($this._iterator_4.hasNext_27()) {
      var item = $this._iterator_4.next_30();
      if ($this._this$0_7._predicate(item) === $this._this$0_7._sendWhen) {
        $this._nextItem_0 = item;
        $this._nextState_0 = 1;
        return Unit_getInstance();
      }}
    $this._nextState_0 = 0;
  }
  function _no_name_provided__13(this$0) {
    this._this$0_7 = this$0;
    this._iterator_4 = this._this$0_7._sequence_2.iterator_52();
    this._nextState_0 = -1;
    this._nextItem_0 = null;
  }
  _no_name_provided__13.prototype.next_30 = function () {
    if (this._nextState_0 === -1)
      calcNext_0(this);
    if (this._nextState_0 === 0)
      throw NoSuchElementException_init_$Create$();
    var result = this._nextItem_0;
    this._nextItem_0 = null;
    this._nextState_0 = -1;
    return (result == null ? true : isObject(result)) ? result : THROW_CCE();
  };
  _no_name_provided__13.prototype.hasNext_27 = function () {
    if (this._nextState_0 === -1)
      calcNext_0(this);
    return this._nextState_0 === 1;
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function setOf(elements) {
    return elements.length > 0 ? toSet(elements) : emptySet();
  }
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_35();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__32 = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_35 = function () {
    return true;
  };
  EmptySet.prototype.contains_11 = function (element) {
    return false;
  };
  EmptySet.prototype.contains_35 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_11(tmp);
  };
  EmptySet.prototype.containsAll_8 = function (elements) {
    return elements.isEmpty_35();
  };
  EmptySet.prototype.containsAll_26 = function (elements) {
    return this.containsAll_8(elements);
  };
  EmptySet.prototype.iterator_52 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$_1(mapCapacity(elements.length)));
  }
  function optimizeReadOnlySet(_this_) {
    var tmp0_subject = _this_._get_size__32();
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_.iterator_52().next_30());
      default:return _this_;
    }
  }
  function checkWindowSizeStep(size_0, step) {
    var tmp0_require_0 = size_0 > 0 ? step > 0 : false;
    if (!tmp0_require_0) {
      var message_2 = !(size_0 === step) ? '' + 'Both size ' + size_0 + ' and step ' + step + ' must be greater than zero.' : '' + 'size ' + size_0 + ' must be greater than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }}
  function windowedIterator(iterator_0, size_0, step, partialWindows, reuseBuffer) {
    if (!iterator_0.hasNext_27())
      return EmptyIterator_getInstance();
    return iterator(_no_name_provided_$factory_4(size_0, step, iterator_0, reuseBuffer, partialWindows, null));
  }
  function RingBuffer(buffer, filledSize) {
    AbstractList.call(this);
    this._buffer = buffer;
    var tmp0_require_0 = filledSize >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'ring buffer filled size should not be negative but it is ' + filledSize;
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_require_0 = filledSize <= this._buffer.length;
    if (!tmp1_require_0) {
      var message_2_0 = '' + 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + this._buffer.length;
      throw IllegalArgumentException_init_$Create$(toString_1(message_2_0));
    }this._capacity = this._buffer.length;
    this._startIndex = 0;
    this._size = filledSize;
  }
  RingBuffer.prototype._get_size__32 = function () {
    return this._size;
  };
  RingBuffer.prototype.get_57 = function (index) {
    Companion_getInstance().checkElementIndex(index, this._size);
    var tmp0_forward_0 = this._startIndex;
    var tmp = this._buffer[(tmp0_forward_0 + index | 0) % this._capacity];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  RingBuffer.prototype.isFull = function () {
    return this._size === this._capacity;
  };
  RingBuffer.prototype.iterator_52 = function () {
    return new _no_name_provided__15(this);
  };
  RingBuffer.prototype.toArray_0 = function (array) {
    var tmp;
    if (array.length < this._size) {
      tmp = copyOf_7(array, this._size);
    } else {
      tmp = isArray(array) ? array : THROW_CCE();
    }
    var result = tmp;
    var size_0 = this._size;
    var widx = 0;
    var idx = this._startIndex;
    while (widx < size_0 ? idx < this._capacity : false) {
      var tmp_0 = widx;
      var tmp_1 = this._buffer[idx];
      result[tmp_0] = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
      var tmp0 = widx;
      widx = tmp0 + 1 | 0;
      Unit_getInstance();
      var tmp1 = idx;
      idx = tmp1 + 1 | 0;
      Unit_getInstance();
    }
    idx = 0;
    while (widx < size_0) {
      var tmp_2 = widx;
      var tmp_3 = this._buffer[idx];
      result[tmp_2] = (tmp_3 == null ? true : isObject(tmp_3)) ? tmp_3 : THROW_CCE();
      var tmp2 = widx;
      widx = tmp2 + 1 | 0;
      Unit_getInstance();
      var tmp3 = idx;
      idx = tmp3 + 1 | 0;
      Unit_getInstance();
    }
    if (result.length > this._size)
      result[this._size] = null;
    return isArray(result) ? result : THROW_CCE();
  };
  RingBuffer.prototype.toArray_2 = function () {
    var tmp0_arrayOfNulls_0 = this._size;
    return this.toArray_0(fillArrayVal(Array(tmp0_arrayOfNulls_0), null));
  };
  RingBuffer.prototype.toArray = function () {
    return this.toArray_2();
  };
  RingBuffer.prototype.expanded = function (maxCapacity) {
    var newCapacity = coerceAtMost((this._capacity + (this._capacity >> 1) | 0) + 1 | 0, maxCapacity);
    var tmp;
    if (this._startIndex === 0) {
      tmp = copyOf_7(this._buffer, newCapacity);
    } else {
      tmp = this.toArray_0(fillArrayVal(Array(newCapacity), null));
    }
    var newBuffer = tmp;
    return new RingBuffer(newBuffer, this._size);
  };
  RingBuffer.prototype.add_0 = function (element) {
    if (this.isFull()) {
      throw IllegalStateException_init_$Create$('ring buffer is full');
    }var tmp0_forward_0 = this._startIndex;
    var tmp1_forward_0 = this._size;
    this._buffer[(tmp0_forward_0 + tmp1_forward_0 | 0) % this._capacity] = element;
    var tmp0_this = this;
    var tmp1 = tmp0_this._size;
    tmp0_this._size = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  RingBuffer.prototype.removeFirst = function (n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + "n shouldn't be negative but it is " + n;
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_require_0 = n <= this._size;
    if (!tmp1_require_0) {
      var message_2_0 = '' + "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this._size;
      throw IllegalArgumentException_init_$Create$(toString_1(message_2_0));
    }if (n > 0) {
      var start = this._startIndex;
      var end = (start + n | 0) % this._capacity;
      if (start > end) {
        fill(this._buffer, null, start, this._capacity);
        fill(this._buffer, null, 0, end);
      } else {
        fill(this._buffer, null, start, end);
      }
      this._startIndex = end;
      var tmp0_this = this;
      tmp0_this._size = tmp0_this._size - n | 0;
    }};
  RingBuffer.$metadata$ = {
    simpleName: 'RingBuffer',
    kind: 'class',
    interfaces: [RandomAccess]
  };
  function _no_name_provided__14($size, $step, $iterator, $reuseBuffer, $partialWindows, resultContinuation) {
    this._$size = $size;
    this._$step = $step;
    this._$iterator = $iterator;
    this._$reuseBuffer = $reuseBuffer;
    this._$partialWindows = $partialWindows;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__14.prototype.invoke_9 = function (_this__0, $cont) {
    var tmp = this.create(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_3();
  };
  _no_name_provided__14.prototype.invoke_276 = function (p1, $cont) {
    this.invoke_9(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__14.prototype.doResume_3 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_2;
        switch (tmp) {
          case 0:
            this._exceptionState = 21;
            this._bufferInitialCapacity0 = coerceAtMost(this._$size, 1024);
            this._gap1 = this._$step - this._$size | 0;
            if (this._gap1 >= 0) {
              this._buffer2 = ArrayList_init_$Create$_0(this._bufferInitialCapacity0);
              this._skip3 = 0;
              var tmp_0 = this;
              tmp_0._tmp0_iterator4 = this._$iterator;
              this._state_2 = 12;
              continue $sm;
            } else {
              this._buffer5 = RingBuffer_init_$Create$(this._bufferInitialCapacity0);
              var tmp_1 = this;
              tmp_1._tmp1_iterator6 = this._$iterator;
              this._state_2 = 1;
              continue $sm;
            }

            break;
          case 1:
            if (!this._tmp1_iterator6.hasNext_27()) {
              this._state_2 = 5;
              continue $sm;
            }
            this._e7 = this._tmp1_iterator6.next_30();
            this._buffer5.add_0(this._e7);
            if (this._buffer5.isFull()) {
              if (this._buffer5._size < this._$size) {
                this._buffer5 = this._buffer5.expanded(this._$size);
                this._state_2 = 1;
                continue $sm;
              } else {
                this._state_2 = 2;
                continue $sm;
              }
            } else {
              this._state_2 = 4;
              continue $sm;
            }

            break;
          case 2:
            this._state_2 = 3;
            suspendResult = this.__this_.yield_0(this._$reuseBuffer ? this._buffer5 : ArrayList_init_$Create$_1(this._buffer5), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._buffer5.removeFirst(this._$step);
            this._state_2 = 4;
            continue $sm;
          case 4:
            this._state_2 = 1;
            continue $sm;
          case 5:
            if (this._$partialWindows) {
              this._state_2 = 6;
              continue $sm;
            } else {
              this._state_2 = 11;
              continue $sm;
            }

            break;
          case 6:
            if (!(this._buffer5._size > this._$step)) {
              this._state_2 = 8;
              continue $sm;
            }
            this._state_2 = 7;
            suspendResult = this.__this_.yield_0(this._$reuseBuffer ? this._buffer5 : ArrayList_init_$Create$_1(this._buffer5), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            suspendResult;
            this._buffer5.removeFirst(this._$step);
            this._state_2 = 6;
            continue $sm;
          case 8:
            var tmp_2 = this;
            tmp_2._tmp1_isNotEmpty_08 = this._buffer5;
            if (!this._tmp1_isNotEmpty_08.isEmpty_35()) {
              this._state_2 = 9;
              suspendResult = this.__this_.yield_0(this._buffer5, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_2 = 10;
                continue $sm;
              }
            }

            break;
          case 9:
            suspendResult;
            this._state_2 = 10;
            continue $sm;
          case 10:
            this._state_2 = 11;
            continue $sm;
          case 11:
            this._state_2 = 20;
            continue $sm;
          case 12:
            if (!this._tmp0_iterator4.hasNext_27()) {
              this._state_2 = 16;
              continue $sm;
            }
            this._e9 = this._tmp0_iterator4.next_30();
            if (this._skip3 > 0) {
              this._skip3 = this._skip3 - 1 | 0;
              this._state_2 = 12;
              continue $sm;
            } else {
              this._state_2 = 13;
              continue $sm;
            }

            break;
          case 13:
            this._buffer2.add_19(this._e9);
            Unit_getInstance();
            if (this._buffer2._get_size__32() === this._$size) {
              this._state_2 = 14;
              suspendResult = this.__this_.yield_0(this._buffer2, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_2 = 15;
              continue $sm;
            }

            break;
          case 14:
            suspendResult;
            if (this._$reuseBuffer)
              this._buffer2.clear_15();
            else
              this._buffer2 = ArrayList_init_$Create$_0(this._$size);
            this._skip3 = this._gap1;
            this._state_2 = 15;
            continue $sm;
          case 15:
            this._state_2 = 12;
            continue $sm;
          case 16:
            var tmp_3 = this;
            tmp_3._tmp0_isNotEmpty_010 = this._buffer2;
            if (!this._tmp0_isNotEmpty_010.isEmpty_35()) {
              if (this._$partialWindows ? true : this._buffer2._get_size__32() === this._$size) {
                this._state_2 = 17;
                suspendResult = this.__this_.yield_0(this._buffer2, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_2 = 18;
                continue $sm;
              }
            } else {
              {
                this._state_2 = 19;
                continue $sm;
              }
            }

            break;
          case 17:
            suspendResult;
            this._state_2 = 18;
            continue $sm;
          case 18:
            this._state_2 = 19;
            continue $sm;
          case 19:
            this._state_2 = 20;
            continue $sm;
          case 20:
            return Unit_getInstance();
          case 21:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 21) {
          throw $p;
        } else {
          this._state_2 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__14.prototype.create = function (_this__0, completion) {
    var i = new _no_name_provided__14(this._$size, this._$step, this._$iterator, this._$reuseBuffer, this._$partialWindows, completion);
    i.__this_ = _this__0;
    return i;
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_4($size, $step, $iterator, $reuseBuffer, $partialWindows, resultContinuation) {
    var i = new _no_name_provided__14($size, $step, $iterator, $reuseBuffer, $partialWindows, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_9(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function RingBuffer_init_$Init$(capacity, $this) {
    RingBuffer.call($this, fillArrayVal(Array(capacity), null), 0);
    return $this;
  }
  function RingBuffer_init_$Create$(capacity) {
    return RingBuffer_init_$Init$(capacity, Object.create(RingBuffer.prototype));
  }
  function _no_name_provided__15(this$0) {
    this._this$0_8 = this$0;
    AbstractIterator.call(this);
    this._count_0 = this._this$0_8._size;
    this._index_2 = this._this$0_8._startIndex;
  }
  _no_name_provided__15.prototype.computeNext_0 = function () {
    if (this._count_0 === 0) {
      this.done_0();
    } else {
      var tmp = this._this$0_8._buffer[this._index_2];
      this.setNext_0((tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE());
      var tmp_0 = this;
      var tmp0_forward_0 = this._index_2;
      var tmp1_forward_0 = 1;
      tmp_0._index_2 = (tmp0_forward_0 + tmp1_forward_0 | 0) % this._this$0_8._capacity;
      var tmp0_this = this;
      var tmp1 = tmp0_this._count_0;
      tmp0_this._count_0 = tmp1 - 1 | 0;
      Unit_getInstance();
    }
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function Continuation() {
  }
  Continuation.$metadata$ = {
    simpleName: 'Continuation',
    kind: 'interface',
    interfaces: []
  };
  function startCoroutine(_this_, receiver, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_3();
    tmp0_resume_0.resumeWith_11(Unit_getInstance());
  }
  function ContinuationInterceptor() {
  }
  ContinuationInterceptor.prototype.releaseInterceptedContinuation_9 = function (continuation) {
  };
  ContinuationInterceptor.prototype.get_42 = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key.isSubKey(this._get_key__20())) {
        var tmp_0 = key.tryCast(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    } else {
    }
    var tmp_1;
    if (Key_getInstance() === key) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  ContinuationInterceptor.prototype.minusKey_18 = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      return (key.isSubKey(this._get_key__20()) ? !(key.tryCast(this) == null) : false) ? EmptyCoroutineContext_getInstance() : this;
    } else {
    }
    return Key_getInstance() === key ? EmptyCoroutineContext_getInstance() : this;
  };
  ContinuationInterceptor.$metadata$ = {
    simpleName: 'ContinuationInterceptor',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function Key() {
    Key_instance = this;
  }
  Key.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance;
  function Key_getInstance() {
    if (Key_instance == null)
      new Key();
    return Key_instance;
  }
  function CoroutineContext() {
  }
  CoroutineContext.prototype.plus_17 = function (context) {
    var tmp;
    if (context === EmptyCoroutineContext_getInstance()) {
      tmp = this;
    } else {
      tmp = context.fold_17(this, _no_name_provided_$factory_5());
    }
    return tmp;
  };
  CoroutineContext.$metadata$ = {
    simpleName: 'CoroutineContext',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__16();
    return function (p1, p2) {
      return i.invoke_11(p1, p2);
    };
  }
  function Key_0() {
  }
  Key_0.$metadata$ = {
    simpleName: 'Key',
    kind: 'interface',
    interfaces: []
  };
  function Element_0() {
  }
  Element_0.prototype.get_42 = function (key) {
    var tmp;
    if (equals_1(this._get_key__20(), key)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  Element_0.prototype.fold_17 = function (initial, operation) {
    return operation(initial, this);
  };
  Element_0.prototype.minusKey_18 = function (key) {
    return equals_1(this._get_key__20(), key) ? EmptyCoroutineContext_getInstance() : this;
  };
  Element_0.$metadata$ = {
    simpleName: 'Element',
    kind: 'interface',
    interfaces: [CoroutineContext]
  };
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_11 = function (acc, element) {
    var removed = acc.minusKey_18(element._get_key__20());
    var tmp;
    if (removed === EmptyCoroutineContext_getInstance()) {
      tmp = element;
    } else {
      var interceptor = removed.get_42(Key_getInstance());
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left = removed.minusKey_18(Key_getInstance());
        tmp_0 = left === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  _no_name_provided__16.prototype.invoke_270 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineContext) : false) ? p1 : THROW_CCE();
    return this.invoke_11(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function EmptyCoroutineContext() {
    EmptyCoroutineContext_instance = this;
    this._serialVersionUID_2 = new Long(0, 0);
  }
  EmptyCoroutineContext.prototype.get_42 = function (key) {
    return null;
  };
  EmptyCoroutineContext.prototype.fold_17 = function (initial, operation) {
    return initial;
  };
  EmptyCoroutineContext.prototype.plus_17 = function (context) {
    return context;
  };
  EmptyCoroutineContext.prototype.minusKey_18 = function (key) {
    return this;
  };
  EmptyCoroutineContext.prototype.hashCode = function () {
    return 0;
  };
  EmptyCoroutineContext.prototype.toString = function () {
    return 'EmptyCoroutineContext';
  };
  EmptyCoroutineContext.$metadata$ = {
    simpleName: 'EmptyCoroutineContext',
    kind: 'object',
    interfaces: [CoroutineContext, Serializable]
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    if (EmptyCoroutineContext_instance == null)
      new EmptyCoroutineContext();
    return EmptyCoroutineContext_instance;
  }
  function CombinedContext(left, element) {
    this._left_0 = left;
    this._element = element;
  }
  CombinedContext.prototype.get_42 = function (key) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur._element.get_42(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
      var next = cur._left_0;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        {
          return next.get_42(key);
        }
      }
    }
  };
  CombinedContext.prototype.fold_17 = function (initial, operation) {
    return operation(this._left_0.fold_17(initial, operation), this._element);
  };
  CombinedContext.prototype.minusKey_18 = function (key) {
    var tmp0_safe_receiver = this._element.get_42(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return this._left_0;
    }
    Unit_getInstance();
    var newLeft = this._left_0.minusKey_18(key);
    return newLeft === this._left_0 ? this : newLeft === EmptyCoroutineContext_getInstance() ? this._element : new CombinedContext(newLeft, this._element);
  };
  CombinedContext.prototype.equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size(other) === size(this);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CombinedContext.prototype.hashCode = function () {
    return hashCode(this._left_0) + hashCode(this._element) | 0;
  };
  CombinedContext.prototype.toString = function () {
    return '[' + this.fold_17('', _no_name_provided_$factory_6()) + ']';
  };
  CombinedContext.$metadata$ = {
    simpleName: 'CombinedContext',
    kind: 'class',
    interfaces: [CoroutineContext, Serializable]
  };
  function AbstractCoroutineContextKey() {
  }
  AbstractCoroutineContextKey.prototype.tryCast = function (element) {
    return this._safeCast(element);
  };
  AbstractCoroutineContextKey.prototype.isSubKey = function (key) {
    return key === this ? true : this._topmostKey === key;
  };
  AbstractCoroutineContextKey.$metadata$ = {
    simpleName: 'AbstractCoroutineContextKey',
    kind: 'class',
    interfaces: [Key_0]
  };
  function AbstractCoroutineContextElement(key) {
    this._key = key;
  }
  AbstractCoroutineContextElement.prototype._get_key__20 = function () {
    return this._key;
  };
  AbstractCoroutineContextElement.$metadata$ = {
    simpleName: 'AbstractCoroutineContextElement',
    kind: 'class',
    interfaces: [Element_0]
  };
  function _no_name_provided_$factory_6() {
    var i = new _no_name_provided__17();
    return function (p1, p2) {
      return i.invoke_13(p1, p2);
    };
  }
  function size($this) {
    var cur = $this;
    var size_0 = 2;
    while (true) {
      var tmp = cur._left_0;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      var tmp1 = size_0;
      size_0 = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function contains_0($this, element) {
    return equals_1($this.get_42(element._get_key__20()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_0($this, cur._element))
        return false;
      var next = cur._left_0;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        {
          return contains_0($this, isInterface(next, Element_0) ? next : THROW_CCE());
        }
      }
    }
  }
  function _no_name_provided__17() {
  }
  _no_name_provided__17.prototype.invoke_13 = function (acc, element) {
    var tmp;
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      {
        tmp = '' + acc + ', ' + element;
      }
    }
    return tmp;
  };
  _no_name_provided__17.prototype.invoke_270 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    return this.invoke_13(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _get_COROUTINE_SUSPENDED_() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineSingletons.$metadata$ = {
    simpleName: 'CoroutineSingletons',
    kind: 'class',
    interfaces: []
  };
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_getInstance();
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function Random() {
  }
  Random.prototype.nextInt_9 = function () {
    return this.nextBits_1(32);
  };
  Random.prototype.nextInt_6 = function (until_1) {
    return this.nextInt_7(0, until_1);
  };
  Random.prototype.nextInt_7 = function (from, until_1) {
    checkRangeBounds(from, until_1);
    var n = until_1 - from | 0;
    if (n > 0 ? true : n === IntCompanionObject_getInstance()._MIN_VALUE_1) {
      var tmp;
      if ((n & (-n | 0)) === n) {
        var bitCount = fastLog2(n);
        tmp = this.nextBits_1(bitCount);
      } else {
        var v;
        do {
          var bits = this.nextInt_9() >>> 1;
          v = bits % n;
        }
         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
        tmp = v;
      }
      var rnd = tmp;
      return from + rnd | 0;
    } else {
      while (true) {
        var rnd_0 = this.nextInt_9();
        if ((from <= rnd_0 ? rnd_0 <= (until_1 - 1 | 0) : false) ? !(until_1 === -2147483648) : false)
          return rnd_0;
      }
    }
  };
  Random.prototype.nextFloat_1 = function () {
    return this.nextBits_1(24) / 16777216;
  };
  Random.prototype.nextBytes_3 = function (array, fromIndex, toIndex) {
    var tmp0_require_0 = (0 <= fromIndex ? fromIndex <= array.length : false) ? 0 <= toIndex ? toIndex <= array.length : false : false;
    if (!tmp0_require_0) {
      var message_2 = '' + 'fromIndex (' + fromIndex + ') or toIndex (' + toIndex + ') are out of range: 0..' + array.length + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_require_0 = fromIndex <= toIndex;
    if (!tmp1_require_0) {
      var message_2_0 = '' + 'fromIndex (' + fromIndex + ') must be not greater than toIndex (' + toIndex + ').';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2_0));
    }var steps = (toIndex - fromIndex | 0) / 4 | 0;
    var position = fromIndex;
    var inductionVariable = 0;
    var last_2 = steps - 1 | 0;
    if (!(steps === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v_5 = this.nextInt_9();
        array[position] = toByte_0(v_5);
        array[position + 1 | 0] = toByte_0(v_5 >>> 8);
        array[position + 2 | 0] = toByte_0(v_5 >>> 16);
        array[position + 3 | 0] = toByte_0(v_5 >>> 24);
        position = position + 4 | 0;
      }
       while (inductionVariable <= last_2);
    var remainder = toIndex - position | 0;
    var vr = this.nextBits_1(imul(remainder, 8));
    var inductionVariable_0 = 0;
    var last_3 = remainder - 1 | 0;
    if (!(remainder === -2147483648) ? inductionVariable_0 <= last_3 : false)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        array[position + i | 0] = toByte_0(vr >>> imul(i, 8));
      }
       while (inductionVariable_0 <= last_3);
    return array;
  };
  Random.prototype.nextBytes_4 = function (array) {
    return this.nextBytes_3(array, 0, array.length);
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function checkRangeBounds(from, until_1) {
    var tmp0_require_0 = until_1 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_1);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function fastLog2(value) {
    return 31 - Math.clz32(value) | 0;
  }
  function boundsErrorMessage(from, until_1) {
    return '' + 'Random range is empty: [' + from + ', ' + until_1 + ').';
  }
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_1 = function (bitCount) {
    return this._defaultRandom.nextBits_1(bitCount);
  };
  Default.prototype.nextInt_9 = function () {
    return this._defaultRandom.nextInt_9();
  };
  Default.prototype.nextInt_6 = function (until_1) {
    return this._defaultRandom.nextInt_6(until_1);
  };
  Default.prototype.nextInt_7 = function (from, until_1) {
    return this._defaultRandom.nextInt_7(from, until_1);
  };
  Default.prototype.nextFloat_1 = function () {
    return this._defaultRandom.nextFloat_1();
  };
  Default.prototype.nextBytes_4 = function (array) {
    return this._defaultRandom.nextBytes_4(array);
  };
  Default.prototype.nextBytes_3 = function (array, fromIndex, toIndex) {
    return this._defaultRandom.nextBytes_3(array, fromIndex, toIndex);
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x | this._y | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_repeat_0 = 64;
    var inductionVariable = 0;
    var last_2 = tmp1_repeat_0 - 1 | 0;
    if (!(tmp1_repeat_0 === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_9();
        Unit_getInstance();
      }
       while (inductionVariable <= last_2);
  }
  XorWowRandom.prototype.nextInt_9 = function () {
    var t = this._x;
    t = t ^ t >>> 2;
    this._x = this._y;
    this._y = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_1 = function (bitCount) {
    return takeUpperBits(this.nextInt_9(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: []
  };
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function KTypeProjection(variance, type) {
    this._variance = variance;
    this._type = type;
    var tmp0_require_0 = this._variance == null === (this._type == null);
    if (!tmp0_require_0) {
      var message_2 = this._variance == null ? 'Star projection must have no type specified.' : '' + 'The projection variance ' + this._variance + ' requires type to be specified.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }}
  KTypeProjection.prototype.toString = function () {
    var tmp0_subject = this._variance;
    var tmp;
    if (tmp0_subject == null) {
      tmp = '*';
    } else if (equals_1(tmp0_subject, KVariance_INVARIANT_getInstance())) {
      tmp = toString_0(this._type);
    } else if (equals_1(tmp0_subject, KVariance_IN_getInstance())) {
      tmp = '' + 'in ' + this._type;
    } else if (equals_1(tmp0_subject, KVariance_OUT_getInstance())) {
      tmp = '' + 'out ' + this._type;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  KTypeProjection.prototype.hashCode = function () {
    return imul(this._variance == null ? 0 : this._variance.hashCode(), 31) + (this._type == null ? 0 : hashCode(this._type)) | 0;
  };
  KTypeProjection.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KTypeProjection))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KTypeProjection ? other : THROW_CCE();
    if (!equals_1(this._variance, tmp0_other_with_cast._variance))
      return false;
    if (!equals_1(this._type, tmp0_other_with_cast._type))
      return false;
    return true;
  };
  KTypeProjection.$metadata$ = {
    simpleName: 'KTypeProjection',
    kind: 'class',
    interfaces: []
  };
  function Companion_3() {
    Companion_instance_2 = this;
    this._star = new KTypeProjection(null, null);
  }
  Companion_3.prototype.invariant = function (type) {
    return new KTypeProjection(KVariance_INVARIANT_getInstance(), type);
  };
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function KVariance(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  KVariance.$metadata$ = {
    simpleName: 'KVariance',
    kind: 'class',
    interfaces: []
  };
  function KVariance_INVARIANT_getInstance() {
    KVariance_initEntries();
    return KVariance_INVARIANT_instance;
  }
  function KVariance_IN_getInstance() {
    KVariance_initEntries();
    return KVariance_IN_instance;
  }
  function KVariance_OUT_getInstance() {
    KVariance_initEntries();
    return KVariance_OUT_instance;
  }
  var KVariance_INVARIANT_instance;
  var KVariance_IN_instance;
  var KVariance_OUT_instance;
  var KVariance_entriesInitialized;
  function KVariance_initEntries() {
    if (KVariance_entriesInitialized)
      return Unit_getInstance();
    KVariance_entriesInitialized = true;
    KVariance_INVARIANT_instance = new KVariance('INVARIANT', 0);
    KVariance_IN_instance = new KVariance('IN', 1);
    KVariance_OUT_instance = new KVariance('OUT', 2);
  }
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function equals(_this_, other, ignoreCase) {
    if (_this_.equals(other))
      return true;
    if (!ignoreCase)
      return false;
    var tmp0_unsafeCast_0 = String.fromCharCode(_this_.toInt_5()).toUpperCase().charCodeAt(0);
    var tmp = numberToChar(tmp0_unsafeCast_0);
    var tmp1_unsafeCast_0 = String.fromCharCode(other.toInt_5()).toUpperCase().charCodeAt(0);
    if (tmp.equals(numberToChar(tmp1_unsafeCast_0)))
      return true;
    else {
    }
    var tmp2_unsafeCast_0 = String.fromCharCode(_this_.toInt_5()).toLowerCase().charCodeAt(0);
    var tmp_0 = numberToChar(tmp2_unsafeCast_0);
    var tmp3_unsafeCast_0 = String.fromCharCode(other.toInt_5()).toLowerCase().charCodeAt(0);
    if (tmp_0.equals(numberToChar(tmp3_unsafeCast_0)))
      return true;
    else {
    }
    return false;
  }
  function trimIndent(_this_) {
    return replaceIndent(_this_, '');
  }
  function replaceIndent(_this_, newIndent) {
    var lines_0 = lines(_this_);
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = lines_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      if (isNotBlank(element_2_3)) {
        tmp0_filterTo_0_1.add_19(element_2_3);
        Unit_getInstance();
      }}
    var tmp0_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_30();
      tmp0_mapTo_0_1.add_19(indentWidth(item_2_3));
      Unit_getInstance();
    }
    var tmp0_elvis_lhs = minOrNull(tmp0_mapTo_0_1);
    var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_reindent_0 = _this_.length + imul(newIndent.length, lines_0._get_size__32()) | 0;
    var tmp2_reindent_0 = getIndentFunction(newIndent);
    var lastIndex_1 = _get_lastIndex__1(lines_0);
    var tmp1_mapIndexedNotNullTo_0_1 = ArrayList_init_$Create$();
    var index_1_2 = 0;
    var tmp0_iterator_2_3 = lines_0.iterator_52();
    while (tmp0_iterator_2_3.hasNext_27()) {
      var item_3_4 = tmp0_iterator_2_3.next_30();
      var tmp1_4_6 = index_1_2;
      index_1_2 = tmp1_4_6 + 1 | 0;
      var tmp0__anonymous__1_5_5 = checkIndexOverflow(tmp1_4_6);
      var tmp;
      if ((tmp0__anonymous__1_5_5 === 0 ? true : tmp0__anonymous__1_5_5 === lastIndex_1) ? isBlank(item_3_4) : false) {
        tmp = null;
      } else {
        var tmp0_safe_receiver_4_10 = drop_0(item_3_4, minCommonIndent);
        var tmp_0;
        if (tmp0_safe_receiver_4_10 == null) {
          tmp_0 = null;
        } else {
          tmp_0 = tmp2_reindent_0(tmp0_safe_receiver_4_10);
        }
        var tmp1_elvis_lhs_3_9 = tmp_0;
        tmp = tmp1_elvis_lhs_3_9 == null ? item_3_4 : tmp1_elvis_lhs_3_9;
      }
      var tmp0_safe_receiver_2_6_7 = tmp;
      if (tmp0_safe_receiver_2_6_7 == null)
        null;
      else {
        tmp1_mapIndexedNotNullTo_0_1.add_19(tmp0_safe_receiver_2_6_7);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    var tmp_1 = StringBuilder_init_$Create$(tmp1_reindent_0);
    return joinTo$default(tmp1_mapIndexedNotNullTo_0_1, tmp_1, '\n', null, null, 0, null, null, 124, null).toString();
  }
  function indentWidth(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = 0;
      var last_2 = charSequenceLength(_this_) - 1 | 0;
      if (inductionVariable <= last_2)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0__anonymous__3 = charSequenceGet(_this_, index_2);
          if (!isWhitespace(tmp0__anonymous__3)) {
            tmp$ret$0 = index_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_2);
      tmp$ret$0 = -1;
    }
     while (false);
    var tmp1_let_0 = tmp$ret$0;
    return tmp1_let_0 === -1 ? _this_.length : tmp1_let_0;
  }
  function getIndentFunction(indent) {
    var tmp;
    if (charSequenceLength(indent) === 0) {
      tmp = _no_name_provided_$factory_7();
    } else {
      {
        tmp = _no_name_provided_$factory_8(indent);
      }
    }
    return tmp;
  }
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_172 = function (line) {
    return line;
  };
  _no_name_provided__18.prototype.invoke_276 = function (p1) {
    return this.invoke_172((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19($indent) {
    this._$indent = $indent;
  }
  _no_name_provided__19.prototype.invoke_172 = function (line) {
    return this._$indent + line;
  };
  _no_name_provided__19.prototype.invoke_276 = function (p1) {
    return this.invoke_172((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__18();
    return function (p1) {
      return i.invoke_172(p1);
    };
  }
  function _no_name_provided_$factory_8($indent) {
    var i = new _no_name_provided__19($indent);
    return function (p1) {
      return i.invoke_172(p1);
    };
  }
  function toIntOrNull(_this_) {
    return toIntOrNull_0(_this_, 10);
  }
  function toLongOrNull(_this_) {
    return toLongOrNull_0(_this_, 10);
  }
  function toIntOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_4(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = IntCompanionObject_getInstance()._MIN_VALUE_1;
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = -IntCompanionObject_getInstance()._MAX_VALUE_1 | 0;
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = -IntCompanionObject_getInstance()._MAX_VALUE_1 | 0;
    }
    var limitForMaxRadix = (-IntCompanionObject_getInstance()._MAX_VALUE_1 | 0) / 36 | 0;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    var last_2 = length - 1 | 0;
    if (!(length === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }} else {
            return null;
          }
        }result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable <= last_2);
    return isNegative_0 ? result : -result | 0;
  }
  function toLongOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_4(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = new Long(0, -2147483648);
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = new Long(1, -2147483648);
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = new Long(1, -2147483648);
    }
    var tmp0_div_0 = new Long(1, -2147483648);
    var tmp1_div_0 = 36;
    var limitForMaxRadix = tmp0_div_0.div_28(toLong_0(tmp1_div_0));
    var limitBeforeMul = limitForMaxRadix;
    var result = new Long(0, 0);
    var inductionVariable = start;
    var last_2 = length - 1 | 0;
    if (!(length === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result.compareTo_48(limitBeforeMul) < 0) {
          if (limitBeforeMul.equals(limitForMaxRadix)) {
            limitBeforeMul = limit.div_28(toLong_0(radix));
            if (result.compareTo_48(limitBeforeMul) < 0) {
              return null;
            }} else {
            return null;
          }
        }var tmp2_times_0 = result;
        result = tmp2_times_0.times_28(toLong_0(radix));
        var tmp = result;
        if (tmp.compareTo_48(limit.plus_45(toLong_0(digit))) < 0)
          return null;
        else {
        }
        var tmp3_minus_0 = result;
        result = tmp3_minus_0.minus_28(toLong_0(digit));
      }
       while (inductionVariable <= last_2);
    return isNegative_0 ? result : result.unaryMinus_4();
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$('' + "Invalid number format: '" + input + "'");
  }
  function toByteOrNull(_this_) {
    return toByteOrNull_0(_this_, 10);
  }
  function toShortOrNull(_this_) {
    return toShortOrNull_0(_this_, 10);
  }
  function toByteOrNull_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < ByteCompanionObject_getInstance()._MIN_VALUE ? true : int > ByteCompanionObject_getInstance()._MAX_VALUE)
      return null;
    return toByte_0(int);
  }
  function toShortOrNull_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < ShortCompanionObject_getInstance()._MIN_VALUE_0 ? true : int > ShortCompanionObject_getInstance()._MAX_VALUE_0)
      return null;
    return toShort_0(int);
  }
  function isNotBlank(_this_) {
    return !isBlank(_this_);
  }
  function contains_1(_this_, other, ignoreCase) {
    var tmp;
    if (typeof other === 'string') {
      var tmp_0 = other;
      tmp = indexOf$default(_this_, tmp_0, 0, ignoreCase, 2, null) >= 0;
    } else {
      {
        var tmp_1 = charSequenceLength(_this_);
        tmp = indexOf$default_0(_this_, other, 0, tmp_1, ignoreCase, false, 16, null) >= 0;
      }
    }
    return tmp;
  }
  function contains$default(_this_, other, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_1(_this_, other, ignoreCase);
  }
  function indexOf_0(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp_1 = charSequenceLength(_this_);
      tmp = indexOf$default_0(_this_, string, startIndex, tmp_1, ignoreCase, false, 16, null);
    } else {
      {
        var tmp0_nativeIndexOf_0 = _this_;
        tmp = tmp0_nativeIndexOf_0.indexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_0(_this_, string, startIndex, ignoreCase);
  }
  function indexOf_1(_this_, other, startIndex, endIndex, ignoreCase, last_2) {
    var indices = !last_2 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this_))) : downTo(coerceAtMost(startIndex, _get_lastIndex__2(_this_)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this_ === 'string') {
      tmp = typeof other === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var inductionVariable = indices._first_1;
      var last_3 = indices._last;
      var step = indices._step_1;
      if ((step > 0 ? inductionVariable <= last_3 : false) ? true : step < 0 ? last_3 <= inductionVariable : false)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          if (regionMatches(other, 0, _this_, index, charSequenceLength(other), ignoreCase))
            return index;
        }
         while (!(index === last_3));
    } else {
      {
        var inductionVariable_0 = indices._first_1;
        var last_4 = indices._last;
        var step_0 = indices._step_1;
        if ((step_0 > 0 ? inductionVariable_0 <= last_4 : false) ? true : step_0 < 0 ? last_4 <= inductionVariable_0 : false)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_0 | 0;
            if (regionMatchesImpl(other, 0, _this_, index_0, charSequenceLength(other), ignoreCase))
              return index_0;
          }
           while (!(index_0 === last_4));
      }
    }
    return -1;
  }
  function indexOf$default_0(_this_, other, startIndex, endIndex, ignoreCase, last_2, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      last_2 = false;
    return indexOf_1(_this_, other, startIndex, endIndex, ignoreCase, last_2);
  }
  function _get_lastIndex__2(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this_) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }var inductionVariable = 0;
    var last_2 = length - 1 | 0;
    if (!(length === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charSequenceGet(_this_, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable <= last_2);
    return true;
  }
  function lines(_this_) {
    return toList_2(lineSequence(_this_));
  }
  function lineSequence(_this_) {
    var tmp = ['\r\n', '\n', '\r'];
    return splitToSequence$default(_this_, tmp, false, 0, 6, null);
  }
  function splitToSequence(_this_, delimiters, ignoreCase, limit) {
    var tmp = rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null);
    return map(tmp, _no_name_provided_$factory_9(_this_));
  }
  function splitToSequence$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return splitToSequence(_this_, delimiters, ignoreCase, limit);
  }
  function substring(_this_, range) {
    return toString_1(charSequenceSubSequence(_this_, range._get_start_(), range._get_endInclusive_() + 1 | 0));
  }
  function rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_10(delimitersList, ignoreCase));
  }
  function rangesDelimitedBy$default(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this._input = input;
    this._startIndex_0 = startIndex;
    this._limit = limit;
    this._getNextMatch = getNextMatch;
  }
  DelimitedRangesSequence.prototype.iterator_52 = function () {
    return new _no_name_provided__22(this);
  };
  DelimitedRangesSequence.$metadata$ = {
    simpleName: 'DelimitedRangesSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function findAnyOf(_this_, strings, startIndex, ignoreCase, last_2) {
    if (!ignoreCase ? strings._get_size__32() === 1 : false) {
      var string = single(strings);
      var tmp;
      if (!last_2) {
        tmp = indexOf$default(_this_, string, startIndex, false, 4, null);
      } else {
        tmp = lastIndexOf$default(_this_, string, startIndex, false, 4, null);
      }
      var index = tmp;
      return index < 0 ? null : to(index, string);
    }var indices = !last_2 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this_)) : downTo(coerceAtMost(startIndex, _get_lastIndex__2(_this_)), 0);
    if (typeof _this_ === 'string') {
      var inductionVariable = indices._first_1;
      var last_3 = indices._last;
      var step = indices._step_1;
      if ((step > 0 ? inductionVariable <= last_3 : false) ? true : step < 0 ? last_3 <= inductionVariable : false)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_iterator_1 = strings.iterator_52();
            while (tmp0_iterator_1.hasNext_27()) {
              var element_2 = tmp0_iterator_1.next_30();
              if (regionMatches(element_2, 0, _this_, index_0, element_2.length, ignoreCase)) {
                tmp$ret$0 = element_2;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var matchingString = tmp$ret$0;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_3));
    } else {
      {
        var inductionVariable_0 = indices._first_1;
        var last_4 = indices._last;
        var step_0 = indices._step_1;
        if ((step_0 > 0 ? inductionVariable_0 <= last_4 : false) ? true : step_0 < 0 ? last_4 <= inductionVariable_0 : false)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_0 | 0;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp0_iterator_1_0 = strings.iterator_52();
              while (tmp0_iterator_1_0.hasNext_27()) {
                var element_2_0 = tmp0_iterator_1_0.next_30();
                if (regionMatchesImpl(element_2_0, 0, _this_, index_1, element_2_0.length, ignoreCase)) {
                  tmp$ret$2 = element_2_0;
                  break l$ret$3;
                } else {
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var matchingString_0 = tmp$ret$2;
            if (!(matchingString_0 == null))
              return to(index_1, matchingString_0);
          }
           while (!(index_1 === last_4));
      }
    }
    return null;
  }
  function lastIndexOf(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_1(_this_, string, startIndex, 0, ignoreCase, true);
    } else {
      {
        var tmp0_nativeLastIndexOf_0 = _this_;
        tmp = tmp0_nativeLastIndexOf_0.lastIndexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__2(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf(_this_, string, startIndex, ignoreCase);
  }
  function split(_this_, delimiters, ignoreCase, limit) {
    if (delimiters.length === 1) {
      var delimiter = delimiters[0];
      if (!(charSequenceLength(delimiter) === 0)) {
        return split_0(_this_, delimiter, ignoreCase, limit);
      } else {
      }
    }var tmp0_map_0 = asIterable(rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null));
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      tmp0_mapTo_0_1.add_19(substring(_this_, item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function split$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return split(_this_, delimiters, ignoreCase, limit);
  }
  function split_0(_this_, delimiter, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var currentOffset = 0;
    var nextIndex = indexOf_0(_this_, delimiter, currentOffset, ignoreCase);
    if (nextIndex === -1 ? true : limit === 1) {
      return listOf_0(toString_1(_this_));
    }var isLimited = limit > 0;
    var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
    do {
      var tmp1_substring_0 = currentOffset;
      var tmp2_substring_0 = nextIndex;
      result.add_19(toString_1(charSequenceSubSequence(_this_, tmp1_substring_0, tmp2_substring_0)));
      Unit_getInstance();
      currentOffset = nextIndex + delimiter.length | 0;
      if (isLimited ? result._get_size__32() === (limit - 1 | 0) : false)
        break;
      nextIndex = indexOf_0(_this_, delimiter, currentOffset, ignoreCase);
    }
     while (!(nextIndex === -1));
    var tmp3_substring_0 = currentOffset;
    var tmp4_substring_0 = charSequenceLength(_this_);
    result.add_19(toString_1(charSequenceSubSequence(_this_, tmp3_substring_0, tmp4_substring_0)));
    Unit_getInstance();
    return result;
  }
  function _no_name_provided__20($this_splitToSequence) {
    this._$this_splitToSequence = $this_splitToSequence;
  }
  _no_name_provided__20.prototype.invoke_19 = function (it) {
    return substring(this._$this_splitToSequence, it);
  };
  _no_name_provided__20.prototype.invoke_276 = function (p1) {
    return this.invoke_19(p1 instanceof IntRange ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__21($delimitersList, $ignoreCase) {
    this._$delimitersList = $delimitersList;
    this._$ignoreCase = $ignoreCase;
  }
  _no_name_provided__21.prototype.invoke_21 = function (_this__0, currentIndex) {
    var tmp0_safe_receiver = findAnyOf(_this__0, this._$delimitersList, currentIndex, this._$ignoreCase, false);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = to(tmp0_safe_receiver._first, tmp0_safe_receiver._second.length);
    }
    return tmp;
  };
  _no_name_provided__21.prototype.invoke_270 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_21(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_9($this_splitToSequence) {
    var i = new _no_name_provided__20($this_splitToSequence);
    return function (p1) {
      return i.invoke_19(p1);
    };
  }
  function _no_name_provided_$factory_10($delimitersList, $ignoreCase) {
    var i = new _no_name_provided__21($delimitersList, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_21(p1, p2);
    };
  }
  function calcNext_1($this) {
    if ($this._nextSearchIndex < 0) {
      $this._nextState_1 = 0;
      $this._nextItem_1 = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this._this$0_9._limit > 0) {
        var tmp0_this = $this;
        tmp0_this._counter = tmp0_this._counter + 1 | 0;
        tmp_0 = tmp0_this._counter >= $this._this$0_9._limit;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = $this._nextSearchIndex > charSequenceLength($this._this$0_9._input);
        }
      }
      if (tmp) {
        $this._nextItem_1 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__2($this._this$0_9._input));
        $this._nextSearchIndex = -1;
      } else {
        {
          var match = $this._this$0_9._getNextMatch($this._this$0_9._input, $this._nextSearchIndex);
          if (match == null) {
            $this._nextItem_1 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__2($this._this$0_9._input));
            $this._nextSearchIndex = -1;
          } else {
            var tmp1_container = match;
            var index = tmp1_container.component1();
            var length = tmp1_container.component2();
            $this._nextItem_1 = until($this._currentStartIndex, index);
            $this._currentStartIndex = index + length | 0;
            $this._nextSearchIndex = $this._currentStartIndex + (length === 0 ? 1 : 0) | 0;
          }
        }
      }
      $this._nextState_1 = 1;
    }
  }
  function _no_name_provided__22(this$0) {
    this._this$0_9 = this$0;
    this._nextState_1 = -1;
    this._currentStartIndex = coerceIn(this._this$0_9._startIndex_0, 0, charSequenceLength(this._this$0_9._input));
    this._nextSearchIndex = this._currentStartIndex;
    this._nextItem_1 = null;
    this._counter = 0;
  }
  _no_name_provided__22.prototype.next_30 = function () {
    if (this._nextState_1 === -1)
      calcNext_1(this);
    if (this._nextState_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem_1;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this._nextItem_1 = null;
    this._nextState_1 = -1;
    return result;
  };
  _no_name_provided__22.prototype.hasNext_27 = function () {
    if (this._nextState_1 === -1)
      calcNext_1(this);
    return this._nextState_1 === 1;
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function MatchResult() {
  }
  MatchResult.$metadata$ = {
    simpleName: 'MatchResult',
    kind: 'interface',
    interfaces: []
  };
  function MatchGroupCollection() {
  }
  MatchGroupCollection.$metadata$ = {
    simpleName: 'MatchGroupCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Lazy() {
  }
  Lazy.$metadata$ = {
    simpleName: 'Lazy',
    kind: 'interface',
    interfaces: []
  };
  function UnsafeLazyImpl(initializer) {
    this._initializer = initializer;
    this.__value = UNINITIALIZED_VALUE_getInstance();
  }
  UnsafeLazyImpl.prototype._get_value__12 = function () {
    if (this.__value === UNINITIALIZED_VALUE_getInstance()) {
      this.__value = ensureNotNull(this._initializer)();
      this._initializer = null;
    }var tmp = this.__value;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  UnsafeLazyImpl.prototype.isInitialized = function () {
    return !(this.__value === UNINITIALIZED_VALUE_getInstance());
  };
  UnsafeLazyImpl.prototype.toString = function () {
    return this.isInitialized() ? toString_0(this._get_value__12()) : 'Lazy value not initialized yet.';
  };
  UnsafeLazyImpl.$metadata$ = {
    simpleName: 'UnsafeLazyImpl',
    kind: 'class',
    interfaces: [Lazy, Serializable]
  };
  function UNINITIALIZED_VALUE() {
    UNINITIALIZED_VALUE_instance = this;
  }
  UNINITIALIZED_VALUE.$metadata$ = {
    simpleName: 'UNINITIALIZED_VALUE',
    kind: 'object',
    interfaces: []
  };
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    if (UNINITIALIZED_VALUE_instance == null)
      new UNINITIALIZED_VALUE();
    return UNINITIALIZED_VALUE_instance;
  }
  function LazyThreadSafetyMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LazyThreadSafetyMode.$metadata$ = {
    simpleName: 'LazyThreadSafetyMode',
    kind: 'class',
    interfaces: []
  };
  function LazyThreadSafetyMode_NONE_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_NONE_instance;
  }
  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
  var LazyThreadSafetyMode_PUBLICATION_instance;
  var LazyThreadSafetyMode_NONE_instance;
  var LazyThreadSafetyMode_entriesInitialized;
  function LazyThreadSafetyMode_initEntries() {
    if (LazyThreadSafetyMode_entriesInitialized)
      return Unit_getInstance();
    LazyThreadSafetyMode_entriesInitialized = true;
    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
  }
  function Result(value) {
    this._value_0 = value;
  }
  Result.prototype.toString = function () {
    var tmp = this;
    return toString_impl(tmp == null ? null : tmp._value_0);
  };
  Result.prototype.hashCode = function () {
    var tmp = this;
    return hashCode_impl(tmp == null ? null : tmp._value_0);
  };
  Result.prototype.equals = function (other) {
    var tmp = this;
    return equals_impl(tmp == null ? null : tmp._value_0, other);
  };
  Result.$metadata$ = {
    simpleName: 'Result',
    kind: 'class',
    interfaces: [Serializable]
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function throwOnFailure(_this_) {
    var tmp = _get_value__impl(_this_);
    if (tmp instanceof Failure)
      throw _get_value__impl(_this_)._exception;
    else {
    }
  }
  function _get_value__impl(this_0) {
    return this_0;
  }
  function _get_isFailure__impl(this_0) {
    var tmp = _get_value__impl(this_0);
    return tmp instanceof Failure;
  }
  function exceptionOrNull_impl(this_0) {
    var tmp0_subject = _get_value__impl(this_0);
    var tmp;
    if (tmp0_subject instanceof Failure) {
      tmp = _get_value__impl(this_0)._exception;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function toString_impl(this_0) {
    var tmp0_subject = _get_value__impl(this_0);
    var tmp;
    if (tmp0_subject instanceof Failure) {
      tmp = toString_1(_get_value__impl(this_0));
    } else {
      {
        tmp = '' + 'Success(' + _get_value__impl(this_0) + ')';
      }
    }
    return tmp;
  }
  function Companion_4() {
    Companion_instance_3 = this;
  }
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function Failure(exception) {
    this._exception = exception;
  }
  Failure.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals_1(this._exception, other._exception);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Failure.prototype.hashCode = function () {
    return hashCode(this._exception);
  };
  Failure.prototype.toString = function () {
    return '' + 'Failure(' + this._exception + ')';
  };
  Failure.$metadata$ = {
    simpleName: 'Failure',
    kind: 'class',
    interfaces: [Serializable]
  };
  function hashCode_impl(this_0) {
    return this_0 == null ? 0 : hashCode(this_0);
  }
  function equals_impl(this_0, other) {
    if (!(other instanceof Result))
      return false;
    else {
    }
    var tmp;
    if (other instanceof Result) {
      var tmp_0 = other;
      tmp = tmp_0 == null ? null : tmp_0._value_0;
    } else {
      tmp = THROW_CCE();
    }
    var tmp0_other_with_cast = tmp;
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function NotImplementedError(message) {
    Error_init_$Init$(message, this);
    captureStack(this, NotImplementedError);
  }
  NotImplementedError.$metadata$ = {
    simpleName: 'NotImplementedError',
    kind: 'class',
    interfaces: []
  };
  function Pair(first_1, second) {
    this._first = first_1;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1 = function () {
    return this._first;
  };
  Pair.prototype.component2 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    return imul(this._first == null ? 0 : hashCode(this._first), 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals_1(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals_1(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function Triple(first_1, second, third) {
    this._first_0 = first_1;
    this._second_0 = second;
    this._third = third;
  }
  Triple.prototype.toString = function () {
    return '' + '(' + this._first_0 + ', ' + this._second_0 + ', ' + this._third + ')';
  };
  Triple.prototype.hashCode = function () {
    return imul(imul(this._first_0 == null ? 0 : hashCode(this._first_0), 31) + (this._second_0 == null ? 0 : hashCode(this._second_0)) | 0, 31) + (this._third == null ? 0 : hashCode(this._third)) | 0;
  };
  Triple.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Triple))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Triple ? other : THROW_CCE();
    if (!equals_1(this._first_0, tmp0_other_with_cast._first_0))
      return false;
    if (!equals_1(this._second_0, tmp0_other_with_cast._second_0))
      return false;
    if (!equals_1(this._third, tmp0_other_with_cast._third))
      return false;
    return true;
  };
  Triple.$metadata$ = {
    simpleName: 'Triple',
    kind: 'class',
    interfaces: [Serializable]
  };
  function Annotation() {
  }
  Annotation.$metadata$ = {
    simpleName: 'Annotation',
    kind: 'interface',
    interfaces: []
  };
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableListIterator() {
  }
  MutableListIterator.$metadata$ = {
    simpleName: 'MutableListIterator',
    kind: 'interface',
    interfaces: [ListIterator, MutableIterator]
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_30 = function () {
    return this.nextInt_9();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function LongIterator() {
  }
  LongIterator.prototype.next_30 = function () {
    return this.nextLong_0();
  };
  LongIterator.$metadata$ = {
    simpleName: 'LongIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function IntProgressionIterator(first_1, last_2, step) {
    IntIterator.call(this);
    this._step = step;
    this._finalElement = last_2;
    this._hasNext = this._step > 0 ? first_1 <= last_2 : first_1 >= last_2;
    this._next_0 = this._hasNext ? first_1 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_27 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_9 = function () {
    var value = this._next_0;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_0 = tmp0_this._next_0 + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function LongProgressionIterator(first_1, last_2, step) {
    LongIterator.call(this);
    this._step_0 = step;
    this._finalElement_0 = last_2;
    this._hasNext_0 = this._step_0.compareTo_48(new Long(0, 0)) > 0 ? first_1.compareTo_48(last_2) <= 0 : first_1.compareTo_48(last_2) >= 0;
    this._next_1 = this._hasNext_0 ? first_1 : this._finalElement_0;
  }
  LongProgressionIterator.prototype.hasNext_27 = function () {
    return this._hasNext_0;
  };
  LongProgressionIterator.prototype.nextLong_0 = function () {
    var value = this._next_1;
    if (value.equals(this._finalElement_0)) {
      if (!this._hasNext_0)
        throw NoSuchElementException_init_$Create$();
      this._hasNext_0 = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_1 = tmp0_this._next_1.plus_45(this._step_0);
    }
    return value;
  };
  LongProgressionIterator.$metadata$ = {
    simpleName: 'LongProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function IntProgression(start, endInclusive, step) {
    if (step === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step === IntCompanionObject_getInstance()._MIN_VALUE_1)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_1 = start;
    this._last = getProgressionLastElement(start, endInclusive, step);
    this._step_1 = step;
  }
  IntProgression.prototype._get_first__2 = function () {
    return this._first_1;
  };
  IntProgression.prototype._get_last__4 = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_52 = function () {
    return new IntProgressionIterator(this._first_1, this._last, this._step_1);
  };
  IntProgression.prototype.isEmpty_35 = function () {
    return this._step_1 > 0 ? this._first_1 > this._last : this._first_1 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_35() ? other.isEmpty_35() : false) ? true : (this._first_1 === other._first_1 ? this._last === other._last : false) ? this._step_1 === other._step_1 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_35() ? -1 : imul(31, imul(31, this._first_1) + this._last | 0) + this._step_1 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_1 > 0 ? '' + this._first_1 + '..' + this._last + ' step ' + this._step_1 : '' + this._first_1 + ' downTo ' + this._last + ' step ' + (-this._step_1 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function LongProgression(start, endInclusive, step) {
    if (step.equals(new Long(0, 0)))
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step.equals(new Long(0, -2147483648)))
      throw IllegalArgumentException_init_$Create$('Step must be greater than Long.MIN_VALUE to avoid overflow on negation.');
    this._first_2 = start;
    this._last_0 = getProgressionLastElement_0(start.toLong_4(), endInclusive.toLong_4(), step).toLong_4();
    this._step_2 = step;
  }
  LongProgression.prototype._get_first__2 = function () {
    return this._first_2;
  };
  LongProgression.prototype._get_last__4 = function () {
    return this._last_0;
  };
  LongProgression.prototype.iterator_52 = function () {
    return new LongProgressionIterator(this._first_2, this._last_0, this._step_2);
  };
  LongProgression.prototype.isEmpty_35 = function () {
    return this._step_2.compareTo_48(new Long(0, 0)) > 0 ? this._first_2.compareTo_48(this._last_0) > 0 : this._first_2.compareTo_48(this._last_0) < 0;
  };
  LongProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof LongProgression) {
      tmp = (this.isEmpty_35() ? other.isEmpty_35() : false) ? true : (this._first_2.equals(other._first_2) ? this._last_0.equals(other._last_0) : false) ? this._step_2.equals(other._step_2) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  LongProgression.prototype.hashCode = function () {
    return this.isEmpty_35() ? -1 : numberToLong(31).times_28(numberToLong(31).times_28(this._first_2.xor(this._first_2.ushr_0(32))).plus_45(this._last_0.xor(this._last_0.ushr_0(32)))).plus_45(this._step_2.xor(this._step_2.ushr_0(32))).toInt_5();
  };
  LongProgression.prototype.toString = function () {
    return this._step_2.compareTo_48(new Long(0, 0)) > 0 ? '' + this._first_2 + '..' + this._last_0 + ' step ' + this._step_2 : '' + this._first_2 + ' downTo ' + this._last_0 + ' step ' + this._step_2.unaryMinus_4();
  };
  LongProgression.$metadata$ = {
    simpleName: 'LongProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Companion_5() {
    Companion_instance_4 = this;
  }
  Companion_5.prototype.fromClosedRange = function (rangeStart, rangeEnd, step) {
    return new IntProgression(rangeStart, rangeEnd, step);
  };
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function IntRange(start, endInclusive) {
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start_ = function () {
    return this._get_first__2();
  };
  IntRange.prototype._get_endInclusive_ = function () {
    return this._get_last__4();
  };
  IntRange.prototype.isEmpty_35 = function () {
    return this._get_first__2() > this._get_last__4();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_35() ? other.isEmpty_35() : false) ? true : this._get_first__2() === other._get_first__2() ? this._get_last__4() === other._get_last__4() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_35() ? -1 : imul(31, this._get_first__2()) + this._get_last__4() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__2() + '..' + this._get_last__4();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function LongRange(start, endInclusive) {
    LongProgression.call(this, start, endInclusive, new Long(1, 0));
  }
  LongRange.prototype.isEmpty_35 = function () {
    return this._get_first__2().compareTo_48(this._get_last__4()) > 0;
  };
  LongRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof LongRange) {
      tmp = (this.isEmpty_35() ? other.isEmpty_35() : false) ? true : this._get_first__2().equals(other._get_first__2()) ? this._get_last__4().equals(other._get_last__4()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  LongRange.prototype.hashCode = function () {
    return this.isEmpty_35() ? -1 : numberToLong(31).times_28(this._get_first__2().xor(this._get_first__2().ushr_0(32))).plus_45(this._get_last__4().xor(this._get_last__4().ushr_0(32))).toInt_5();
  };
  LongRange.prototype.toString = function () {
    return '' + this._get_first__2() + '..' + this._get_last__4();
  };
  LongRange.$metadata$ = {
    simpleName: 'LongRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Companion_6() {
    Companion_instance_5 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function Companion_7() {
    Companion_instance_6 = this;
    this._EMPTY_0 = new LongRange(new Long(1, 0), new Long(0, 0));
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function getProgressionLastElement_0(start, end, step) {
    var tmp;
    if (step.compareTo_48(new Long(0, 0)) > 0) {
      tmp = start.compareTo_48(end) >= 0 ? end : end.minus_28(differenceModulo_0(end, start, step));
    } else if (step.compareTo_48(new Long(0, 0)) < 0) {
      tmp = start.compareTo_48(end) <= 0 ? end : end.plus_45(differenceModulo_0(start, end, step.unaryMinus_4()));
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function differenceModulo_0(a, b, c) {
    return mod_0(mod_0(a, c).minus_28(mod_0(b, c)), c);
  }
  function mod(a, b) {
    var mod_1 = a % b;
    return mod_1 >= 0 ? mod_1 : mod_1 + b | 0;
  }
  function mod_0(a, b) {
    var mod_1 = a.rem_27(b);
    return mod_1.compareTo_48(new Long(0, 0)) >= 0 ? mod_1 : mod_1.plus_45(b);
  }
  function ByteCompanionObject_0() {
    ByteCompanionObject_instance = this;
    this._MIN_VALUE = -128;
    this._MAX_VALUE = 127;
    this._SIZE_BYTES = 1;
    this._SIZE_BITS = 8;
  }
  ByteCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE;
  };
  ByteCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE;
  };
  ByteCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES;
  };
  ByteCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS;
  };
  ByteCompanionObject_0.$metadata$ = {
    simpleName: 'ByteCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ByteCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(ByteCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ByteCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var ByteCompanionObject_instance;
  function ByteCompanionObject_getInstance() {
    if (ByteCompanionObject_instance == null)
      new ByteCompanionObject_0();
    return ByteCompanionObject_instance;
  }
  function ShortCompanionObject_0() {
    ShortCompanionObject_instance = this;
    this._MIN_VALUE_0 = -32768;
    this._MAX_VALUE_0 = 32767;
    this._SIZE_BYTES_0 = 2;
    this._SIZE_BITS_0 = 16;
  }
  ShortCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_0;
  };
  ShortCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_0;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_0;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_0;
  };
  ShortCompanionObject_0.$metadata$ = {
    simpleName: 'ShortCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var ShortCompanionObject_instance;
  function ShortCompanionObject_getInstance() {
    if (ShortCompanionObject_instance == null)
      new ShortCompanionObject_0();
    return ShortCompanionObject_instance;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE_1 = -2147483648;
    this._MAX_VALUE_1 = 2147483647;
    this._SIZE_BYTES_1 = 4;
    this._SIZE_BITS_1 = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_1;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_1;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_1;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_1;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function FloatCompanionObject_0() {
    FloatCompanionObject_instance = this;
    this._MIN_VALUE_2 = 1.4E-45;
    this._MAX_VALUE_2 = 3.4028235E38;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES_2 = 4;
    this._SIZE_BITS_2 = 32;
  }
  FloatCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_2;
  };
  FloatCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_2;
  };
  FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0 = function () {
    return this._POSITIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0 = function () {
    return this._NEGATIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NaN__0 = function () {
    return this._NaN;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_2;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_2;
  };
  FloatCompanionObject_0.$metadata$ = {
    simpleName: 'FloatCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NaN__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var FloatCompanionObject_instance;
  function FloatCompanionObject_getInstance() {
    if (FloatCompanionObject_instance == null)
      new FloatCompanionObject_0();
    return FloatCompanionObject_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE_3 = 4.9E-324;
    this._MAX_VALUE_3 = 1.7976931348623157E308;
    this._POSITIVE_INFINITY_0 = Infinity;
    this._NEGATIVE_INFINITY_0 = -Infinity;
    this._NaN_0 = NaN;
    this._SIZE_BYTES_3 = 8;
    this._SIZE_BITS_3 = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE__3 = function () {
    return this._MIN_VALUE_3;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE__3 = function () {
    return this._MAX_VALUE_3;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0 = function () {
    return this._POSITIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0 = function () {
    return this._NEGATIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NaN__0 = function () {
    return this._NaN_0;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES__3 = function () {
    return this._SIZE_BYTES_3;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS__3 = function () {
    return this._SIZE_BITS_3;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE__3
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE__3
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES__3
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS__3
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function StringCompanionObject() {
    StringCompanionObject_instance = this;
  }
  StringCompanionObject.$metadata$ = {
    simpleName: 'StringCompanionObject',
    kind: 'object',
    interfaces: []
  };
  var StringCompanionObject_instance;
  function StringCompanionObject_getInstance() {
    if (StringCompanionObject_instance == null)
      new StringCompanionObject();
    return StringCompanionObject_instance;
  }
  function BooleanCompanionObject() {
    BooleanCompanionObject_instance = this;
  }
  BooleanCompanionObject.$metadata$ = {
    simpleName: 'BooleanCompanionObject',
    kind: 'object',
    interfaces: []
  };
  var BooleanCompanionObject_instance;
  function BooleanCompanionObject_getInstance() {
    if (BooleanCompanionObject_instance == null)
      new BooleanCompanionObject();
    return BooleanCompanionObject_instance;
  }
  function Comparator() {
  }
  Comparator.$metadata$ = {
    simpleName: 'Comparator',
    kind: 'interface',
    interfaces: []
  };
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function mapOf_0(pair) {
    return hashMapOf([pair]);
  }
  function arrayCopy_0(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_getInstance().checkRangeIndexes(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_getInstance().checkRangeIndexes(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (ArrayBuffer.isView(destination) && ArrayBuffer.isView(source)) {
      var subrange = source.subarray(startIndex, endIndex);
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) ? true : destinationOffset <= startIndex) {
        var inductionVariable = 0;
        var last_2 = rangeSize - 1 | 0;
        if (!(rangeSize === -2147483648) ? inductionVariable <= last_2 : false)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index | 0] = source[startIndex + index | 0];
          }
           while (inductionVariable <= last_2);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        var last_3 = 0;
        if (last_3 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (last_3 <= inductionVariable_0);
      }
    }
  }
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator_0 = collection.iterator_52();
    while (iterator_0.hasNext_27()) {
      array.push(iterator_0.next_30());
    }
    return array;
  }
  function sortWith(_this_, comparator) {
    collectionsSort(_this_, comparator);
  }
  function setOf_0(element) {
    return hashSetOf([element]);
  }
  function collectionsSort(list, comparator) {
    if (list._get_size__32() <= 1)
      return Unit_getInstance();
    var array = copyToArray_0(list);
    sortArrayWith(array, comparator);
    var untilArg = array.length;
    var inductionVariable = 0;
    var last_2 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.set_2(i, array[i]);
        Unit_getInstance();
      }
       while (inductionVariable <= last_2);
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }return index;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.remove_16 = function (element) {
    this.checkIsMutable_11();
    var iterator_0 = this.iterator_52();
    while (iterator_0.hasNext_27()) {
      if (equals_1(iterator_0.next_30(), element)) {
        iterator_0.remove_15();
        return true;
      }}
    return false;
  };
  AbstractMutableCollection.prototype.addAll_11 = function (elements) {
    this.checkIsMutable_11();
    var modified = false;
    var tmp0_iterator = elements.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var element = tmp0_iterator.next_30();
      if (this.add_19(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.clear_15 = function () {
    this.checkIsMutable_11();
    var iterator_0 = this.iterator_52();
    while (iterator_0.hasNext_27()) {
      iterator_0.next_30();
      Unit_getInstance();
      iterator_0.remove_15();
    }
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_11 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__0 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_19 = function (element) {
    this.checkIsMutable_11();
    this.add_10(this._get_size__32(), element);
    return true;
  };
  AbstractMutableList.prototype.clear_15 = function () {
    this.checkIsMutable_11();
    this.removeRange_0(0, this._get_size__32());
  };
  AbstractMutableList.prototype.iterator_52 = function () {
    return new IteratorImpl_0(this);
  };
  AbstractMutableList.prototype.contains_35 = function (element) {
    return this.indexOf_0(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_0 = function (element) {
    var inductionVariable = 0;
    var last_2 = _get_lastIndex__1(this);
    if (inductionVariable <= last_2)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this.get_57(index), element)) {
          return index;
        }}
       while (!(index === last_2));
    return -1;
  };
  AbstractMutableList.prototype.listIterator_5 = function (index) {
    return new ListIteratorImpl_0(this, index);
  };
  AbstractMutableList.prototype.removeRange_0 = function (fromIndex, toIndex) {
    var iterator_0 = this.listIterator_5(fromIndex);
    var tmp0_repeat_0 = toIndex - fromIndex | 0;
    var inductionVariable = 0;
    var last_2 = tmp0_repeat_0 - 1 | 0;
    if (!(tmp0_repeat_0 === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        iterator_0.next_30();
        Unit_getInstance();
        iterator_0.remove_15();
      }
       while (inductionVariable <= last_2);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function IteratorImpl_0($outer) {
    this._$this_1 = $outer;
    this._index_3 = 0;
    this._last_1 = -1;
  }
  IteratorImpl_0.prototype._set_index__2 = function (_set___) {
    this._index_3 = _set___;
  };
  IteratorImpl_0.prototype._get_index__2 = function () {
    return this._index_3;
  };
  IteratorImpl_0.prototype._set_last__0 = function (_set___) {
    this._last_1 = _set___;
  };
  IteratorImpl_0.prototype._get_last__4 = function () {
    return this._last_1;
  };
  IteratorImpl_0.prototype.hasNext_27 = function () {
    return this._index_3 < this._$this_1._get_size__32();
  };
  IteratorImpl_0.prototype.next_30 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_3;
    tmp0_this._index_3 = tmp1 + 1 | 0;
    tmp._last_1 = tmp1;
    return this._$this_1.get_57(this._last_1);
  };
  IteratorImpl_0.prototype.remove_15 = function () {
    var tmp0_check_0 = !(this._last_1 === -1);
    if (!tmp0_check_0) {
      var message_1 = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this._$this_1.removeAt_1(this._last_1);
    Unit_getInstance();
    this._index_3 = this._last_1;
    this._last_1 = -1;
  };
  IteratorImpl_0.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ListIteratorImpl_0($outer, index) {
    this._$this_2 = $outer;
    IteratorImpl_0.call(this, $outer);
    Companion_getInstance().checkPositionIndex(index, this._$this_2._get_size__32());
    this._set_index__2(index);
  }
  ListIteratorImpl_0.prototype.hasPrevious_2 = function () {
    return this._get_index__2() > 0;
  };
  ListIteratorImpl_0.prototype.previous_2 = function () {
    if (!this.hasPrevious_2())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    tmp0_this._set_index__2(tmp0_this._get_index__2() - 1 | 0);
    this._set_last__0(tmp0_this._get_index__2());
    return this._$this_2.get_57(this._get_last__4());
  };
  ListIteratorImpl_0.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype.clear_15 = function () {
    this._get_entries__5().clear_15();
  };
  AbstractMutableMap.prototype._get_keys__5 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__25(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype.putAll_1 = function (from) {
    this.checkIsMutable_11();
    var tmp0_iterator = from._get_entries__5().iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var tmp1_loop_parameter = tmp0_iterator.next_30();
      var key = tmp1_loop_parameter._get_key__20();
      var value = tmp1_loop_parameter._get_value__12();
      this.put_5(key, value);
      Unit_getInstance();
    }
  };
  AbstractMutableMap.prototype._get_values__6 = function () {
    if (this.__values_0 == null) {
      var tmp = this;
      tmp.__values_0 = new _no_name_provided__26(this);
    }return ensureNotNull(this.__values_0);
  };
  AbstractMutableMap.prototype.remove_17 = function (key) {
    this.checkIsMutable_11();
    var iter = this._get_entries__5().iterator_52();
    while (iter.hasNext_27()) {
      var entry = iter.next_30();
      var k = entry._get_key__20();
      if (equals_1(key, k)) {
        var value = entry._get_value__12();
        iter.remove_15();
        return value;
      }}
    return null;
  };
  AbstractMutableMap.prototype.checkIsMutable_11 = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function _no_name_provided__23($entryIterator) {
    this._$entryIterator_1 = $entryIterator;
  }
  _no_name_provided__23.prototype.hasNext_27 = function () {
    return this._$entryIterator_1.hasNext_27();
  };
  _no_name_provided__23.prototype.next_30 = function () {
    return this._$entryIterator_1.next_30()._get_key__20();
  };
  _no_name_provided__23.prototype.remove_15 = function () {
    return this._$entryIterator_1.remove_15();
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function _no_name_provided__24($entryIterator) {
    this._$entryIterator_2 = $entryIterator;
  }
  _no_name_provided__24.prototype.hasNext_27 = function () {
    return this._$entryIterator_2.hasNext_27();
  };
  _no_name_provided__24.prototype.next_30 = function () {
    return this._$entryIterator_2.next_30()._get_value__12();
  };
  _no_name_provided__24.prototype.remove_15 = function () {
    return this._$entryIterator_2.remove_15();
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key_0 = key;
    this.__value_0 = value;
  }
  SimpleEntry.prototype._get_key__20 = function () {
    return this._key_0;
  };
  SimpleEntry.prototype._get_value__12 = function () {
    return this.__value_0;
  };
  SimpleEntry.prototype.setValue_1 = function (newValue) {
    var oldValue = this.__value_0;
    this.__value_0 = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function _no_name_provided__25(this$0) {
    this._this$0_10 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__25.prototype.add_4 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__25.prototype.add_19 = function (element) {
    return this.add_4((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__25.prototype.clear_15 = function () {
    this._this$0_10.clear_15();
  };
  _no_name_provided__25.prototype.contains_26 = function (element) {
    return this._this$0_10.containsKey_8(element);
  };
  _no_name_provided__25.prototype.contains_35 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_26((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__25.prototype.iterator_52 = function () {
    var entryIterator = this._this$0_10._get_entries__5().iterator_52();
    return new _no_name_provided__23(entryIterator);
  };
  _no_name_provided__25.prototype._get_size__32 = function () {
    return this._this$0_10._get_size__32();
  };
  _no_name_provided__25.prototype.checkIsMutable_11 = function () {
    return this._this$0_10.checkIsMutable_11();
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26(this$0) {
    this._this$0_11 = this$0;
    AbstractMutableCollection.call(this);
  }
  _no_name_provided__26.prototype.add_6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  _no_name_provided__26.prototype.add_19 = function (element) {
    return this.add_6((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__26.prototype.contains_18 = function (element) {
    return this._this$0_11.containsValue_2(element);
  };
  _no_name_provided__26.prototype.contains_35 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_18((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__26.prototype.iterator_52 = function () {
    var entryIterator = this._this$0_11._get_entries__5().iterator_52();
    return new _no_name_provided__24(entryIterator);
  };
  _no_name_provided__26.prototype._get_size__32 = function () {
    return this._this$0_11._get_size__32();
  };
  _no_name_provided__26.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  _no_name_provided__26.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  _no_name_provided__26.prototype.checkIsMutable_11 = function () {
    return this._this$0_11.checkIsMutable_11();
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype.ensureCapacity_8 = function (minCapacity) {
  };
  ArrayList.prototype._get_size__32 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_57 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.set_2 = function (index, element) {
    this.checkIsMutable_11();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_apply_0 = this._array[index];
    this._array[index] = element;
    var tmp = tmp0_apply_0;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_19 = function (element) {
    this.checkIsMutable_11();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_10 = function (index, element) {
    this.checkIsMutable_11();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.addAll_11 = function (elements) {
    this.checkIsMutable_11();
    if (elements.isEmpty_35())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__0();
    tmp1_this._set_modCount__0(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.removeAt_1 = function (index) {
    this.checkIsMutable_11();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex__1(this)) {
      var tmp0_asDynamic_0 = this._array;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.remove_16 = function (element) {
    this.checkIsMutable_11();
    var inductionVariable = 0;
    var last_2 = this._array.length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._array[index], element)) {
          var tmp0_asDynamic_0 = this._array;
          tmp0_asDynamic_0.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__0();
          tmp1_this._set_modCount__0(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last_2);
    return false;
  };
  ArrayList.prototype.removeRange_0 = function (fromIndex, toIndex) {
    this.checkIsMutable_11();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(fromIndex, toIndex - fromIndex | 0);
  };
  ArrayList.prototype.clear_15 = function () {
    this.checkIsMutable_11();
    var tmp = this;
    tmp._array = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_0 = function (element) {
    return indexOf(this._array, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_2 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_2();
  };
  ArrayList.prototype.checkIsMutable_11 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__32());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex(index, $this._get_size__32());
    return index;
  }
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_11(comparator);
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex_(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    _stableSortingIsSupported = false;
    var tmp0_unsafeCast_0 = [];
    var array = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    var last_2 = 599;
    if (inductionVariable <= last_2)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array.push(index);
      }
       while (inductionVariable <= last_2);
    var comparison = _no_name_provided_$factory_12();
    array.sort(comparison);
    var untilArg = array.length;
    var inductionVariable_0 = 1;
    var last_3 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable_0 <= last_3 : false)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) ? a >= b : false)
          return false;
      }
       while (inductionVariable_0 <= last_3);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    var tmp0_arrayOfNulls_0 = array.length;
    var tmp1_unsafeCast_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var buffer = tmp1_unsafeCast_0;
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      var last_2 = endInclusive;
      if (inductionVariable <= last_2)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === last_2));
    }}
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    var last_2 = end;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median ? rightIndex <= end : false) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            var tmp1 = leftIndex;
            leftIndex = tmp1 + 1 | 0;
            Unit_getInstance();
          } else {
            target[i] = rightValue;
            var tmp2 = rightIndex;
            rightIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          var tmp3 = leftIndex;
          leftIndex = tmp3 + 1 | 0;
          Unit_getInstance();
        } else {
          target[i] = right[rightIndex];
          var tmp4 = rightIndex;
          rightIndex = tmp4 + 1 | 0;
          Unit_getInstance();
          Unit_getInstance();
        }
      }
       while (!(i === last_2));
    return target;
  }
  function _no_name_provided__27($comparator) {
    this._$comparator = $comparator;
  }
  _no_name_provided__27.prototype.invoke_23 = function (a, b) {
    return this._$comparator.compare(a, b);
  };
  _no_name_provided__27.prototype.invoke_270 = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_23(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_25 = function (a, b) {
    return (a & 3) - (b & 3) | 0;
  };
  _no_name_provided__28.prototype.invoke_270 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_25(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_11($comparator) {
    var i = new _no_name_provided__27($comparator);
    return function (p1, p2) {
      return i.invoke_23(p1, p2);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__28();
    return function (p1, p2) {
      return i.invoke_25(p1, p2);
    };
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals_1(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  HashMap.prototype.clear_15 = function () {
    this._internalMap.clear_15();
  };
  HashMap.prototype.containsKey_8 = function (key) {
    return this._internalMap.contains_26(key);
  };
  HashMap.prototype.containsValue_2 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._internalMap;
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (this._equality.equals_1(element_2._get_value__12(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  HashMap.prototype._get_entries__5 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_27 = function (key) {
    return this._internalMap.get_27(key);
  };
  HashMap.prototype.put_5 = function (key, value) {
    return this._internalMap.put_5(key, value);
  };
  HashMap.prototype.remove_17 = function (key) {
    return this._internalMap.remove_17(key);
  };
  HashMap.prototype._get_size__32 = function () {
    return this._internalMap._get_size__32();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function EntrySet($outer) {
    this._$this_3 = $outer;
    AbstractMutableSet.call(this);
  }
  EntrySet.prototype.add_14 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_19 = function (element) {
    return this.add_14((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.clear_15 = function () {
    this._$this_3.clear_15();
  };
  EntrySet.prototype.contains_27 = function (element) {
    return this._$this_3.containsEntry_2(element);
  };
  EntrySet.prototype.contains_35 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_27((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.iterator_52 = function () {
    return this._$this_3._internalMap.iterator_52();
  };
  EntrySet.prototype._get_size__32 = function () {
    return this._$this_3._get_size__32();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_1(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$_0($this);
    $this.putAll_1(original);
    return $this;
  }
  function HashMap_init_$Create$_2(original) {
    return HashMap_init_$Init$_3(original, Object.create(HashMap.prototype));
  }
  HashSet.prototype._get_map__0 = function () {
    return this._map;
  };
  HashSet.prototype.add_19 = function (element) {
    var old = this._map.put_5(element, this);
    return old == null;
  };
  HashSet.prototype.clear_15 = function () {
    this._map.clear_15();
  };
  HashSet.prototype.contains_35 = function (element) {
    return this._map.containsKey_8(element);
  };
  HashSet.prototype.isEmpty_35 = function () {
    return this._map.isEmpty_35();
  };
  HashSet.prototype.iterator_52 = function () {
    return this._map._get_keys__5().iterator_52();
  };
  HashSet.prototype._get_size__32 = function () {
    return this._map._get_size__32();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function HashSet_init_$Init$($this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$();
    return $this;
  }
  function HashSet_init_$Create$() {
    return HashSet_init_$Init$(Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_0(elements, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_1(elements._get_size__32());
    $this.addAll_11(elements);
    Unit_getInstance();
    return $this;
  }
  function HashSet_init_$Create$_0(elements) {
    return HashSet_init_$Init$_0(elements, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_2(initialCapacity, $this) {
    HashSet_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$_1(initialCapacity) {
    return HashSet_init_$Init$_2(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_3(map_0, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map_0;
    return $this;
  }
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size_0 = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__32 = function () {
    return this._size_0;
  };
  InternalHashCodeMap.prototype.put_5 = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__20(), key)) {
          return entry.setValue_1(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size_0;
          tmp0_this._size_0 = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_1(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size_0;
    tmp2_this._size_0 = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.remove_17 = function (key) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var tmp0_elvis_lhs = getChainOrEntryOrNull(this, hashCode_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if (this._equality_0.equals_1(entry._get_key__20(), key)) {
        jsDeleteProperty(this._backingMap, hashCode_1);
        var tmp1_this = this;
        var tmp2 = tmp1_this._size_0;
        tmp1_this._size_0 = tmp2 - 1 | 0;
        Unit_getInstance();
        return entry._get_value__12();
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        var inductionVariable = 0;
        var last_2 = chain.length - 1 | 0;
        if (inductionVariable <= last_2)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var entry_0 = chain[index];
            if (this._equality_0.equals_1(key, entry_0._get_key__20())) {
              if (chain.length === 1) {
                chain.length = 0;
                jsDeleteProperty(this._backingMap, hashCode_1);
              } else {
                chain.splice(index, 1);
              }
              var tmp4_this = this;
              var tmp5 = tmp4_this._size_0;
              tmp4_this._size_0 = tmp5 - 1 | 0;
              Unit_getInstance();
              return entry_0._get_value__12();
            }}
           while (inductionVariable <= last_2);
      }
    }
    return null;
  };
  InternalHashCodeMap.prototype.clear_15 = function () {
    this._backingMap = this.createJsMap_0();
    this._size_0 = 0;
  };
  InternalHashCodeMap.prototype.contains_26 = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_27 = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__12();
  };
  InternalHashCodeMap.prototype.iterator_52 = function () {
    return new _no_name_provided__29(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_12._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__20(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last_2 = indexedObject.length;
      while (inductionVariable < last_2) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__20(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__29(this$0) {
    this._this$0_12 = this$0;
    this._state_1 = -1;
    this._keys = Object.keys(this._this$0_12._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__29.prototype.hasNext_27 = function () {
    if (this._state_1 === -1)
      this._state_1 = computeNext(this);
    return this._state_1 === 0;
  };
  _no_name_provided__29.prototype.next_30 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state_1 = -1;
    return lastEntry;
  };
  _no_name_provided__29.prototype.remove_15 = function () {
    var tmp0_checkNotNull_0 = this._lastEntry;
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_checkNotNull_0 == null) {
        var message_2_1 = 'Required value was null.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1));
      } else {
        tmp$ret$0 = tmp0_checkNotNull_0;
        break l$ret$1;
      }
    }
     while (false);
    Unit_getInstance();
    this._this$0_12.remove_17(ensureNotNull(this._lastEntry)._get_key__20());
    Unit_getInstance();
    this._lastEntry = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._itemIndex;
    tmp0_this._itemIndex = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  LinkedHashMap.prototype.clear_15 = function () {
    this.checkIsMutable_11();
    this._map_0.clear_15();
    this._head = null;
  };
  LinkedHashMap.prototype.containsKey_8 = function (key) {
    return this._map_0.containsKey_8(key);
  };
  LinkedHashMap.prototype.containsValue_2 = function (value) {
    var tmp0_elvis_lhs = this._head;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    do {
      if (equals_1(node._get_value__12(), value)) {
        return true;
      }node = ensureNotNull(node._next_3);
    }
     while (!(node === this._head));
    return false;
  };
  LinkedHashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_27 = function (key) {
    var tmp0_safe_receiver = this._map_0.get_27(key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__12();
  };
  LinkedHashMap.prototype.put_5 = function (key, value) {
    this.checkIsMutable_11();
    var old = this._map_0.get_27(key);
    if (old == null) {
      var newEntry = new ChainEntry(this, key, value);
      this._map_0.put_5(key, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_1(value);
    }
  };
  LinkedHashMap.prototype.remove_17 = function (key) {
    this.checkIsMutable_11();
    var entry = this._map_0.remove_17(key);
    if (!(entry == null)) {
      remove(entry, this);
      return entry._get_value__12();
    }return null;
  };
  LinkedHashMap.prototype._get_size__32 = function () {
    return this._map_0._get_size__32();
  };
  LinkedHashMap.prototype.checkIsMutable_11 = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function EntryIterator($outer) {
    this._$this_4 = $outer;
    this._last_2 = null;
    this._next_2 = null;
    this._next_2 = this._$this_4._$this_6._head;
  }
  EntryIterator.prototype.hasNext_27 = function () {
    return !(this._next_2 === null);
  };
  EntryIterator.prototype.next_30 = function () {
    if (!this.hasNext_27())
      throw NoSuchElementException_init_$Create$();
    var current = ensureNotNull(this._next_2);
    this._last_2 = current;
    var tmp = this;
    var tmp0_takeIf_0 = current._next_3;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_4._$this_6._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_2 = tmp_0;
    return current;
  };
  EntryIterator.prototype.remove_15 = function () {
    var tmp0_check_0 = !(this._last_2 == null);
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }this._$this_4.checkIsMutable_11();
    remove(ensureNotNull(this._last_2), this._$this_4._$this_6);
    this._$this_4._$this_6._map_0.remove_17(ensureNotNull(this._last_2)._get_key__20());
    Unit_getInstance();
    this._last_2 = null;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key, value) {
    this._$this_5 = $outer;
    SimpleEntry.call(this, key, value);
    this._next_3 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_1 = function (newValue) {
    this._$this_5.checkIsMutable_11();
    return SimpleEntry.prototype.setValue_1.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_6 = $outer;
    AbstractMutableSet.call(this);
  }
  EntrySet_0.prototype.add_14 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_19 = function (element) {
    return this.add_14((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.clear_15 = function () {
    this._$this_6.clear_15();
  };
  EntrySet_0.prototype.contains_27 = function (element) {
    return this._$this_6.containsEntry_2(element);
  };
  EntrySet_0.prototype.contains_35 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_27((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.iterator_52 = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype._get_size__32 = function () {
    return this._$this_6._get_size__32();
  };
  EntrySet_0.prototype.checkIsMutable_11 = function () {
    return this._$this_6.checkIsMutable_11();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_3 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_3 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_3 = _head;
      _head._prev = _this_;
      _tail._next_3 = _this_;
    }
  }
  function remove(_this_, $this) {
    if (_this_._next_3 === _this_) {
      $this._head = null;
    } else {
      if ($this._head === _this_) {
        $this._head = _this_._next_3;
      }ensureNotNull(_this_._next_3)._prev = _this_._prev;
      ensureNotNull(_this_._prev)._next_3 = _this_._next_3;
    }
    _this_._next_3 = null;
    _this_._prev = null;
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_1(initialCapacity, loadFactor, $this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_1(initialCapacity, $this) {
    LinkedHashMap_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(initialCapacity) {
    return LinkedHashMap_init_$Init$_1(initialCapacity, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_2(original, $this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    $this.putAll_1(original);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(original) {
    return LinkedHashMap_init_$Init$_2(original, Object.create(LinkedHashMap.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_11 = function () {
    return this._get_map__0().checkIsMutable_11();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_3(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_0(elements, $this) {
    HashSet_init_$Init$_3(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    $this.addAll_11(elements);
    Unit_getInstance();
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(elements) {
    return LinkedHashSet_init_$Init$_0(elements, Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_3(LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_1(initialCapacity) {
    return LinkedHashSet_init_$Init$_2(initialCapacity, Object.create(LinkedHashSet.prototype));
  }
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function roundToInt(_this_) {
    var tmp;
    if (isNaN_0(_this_)) {
      throw IllegalArgumentException_init_$Create$('Cannot round NaN value.');
    } else if (_this_ > IntCompanionObject_getInstance()._MAX_VALUE_1) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE_1;
    } else if (_this_ < IntCompanionObject_getInstance()._MIN_VALUE_1) {
      tmp = IntCompanionObject_getInstance()._MIN_VALUE_1;
    } else {
      var tmp0_unsafeCast_0 = Math.round(_this_);
      tmp = numberToInt(tmp0_unsafeCast_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function isInfinite(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isFinite(_this_) {
    return !isInfinite(_this_) ? !isNaN_0(_this_) : false;
  }
  function isFinite_0(_this_) {
    return !isInfinite_0(_this_) ? !isNaN_1(_this_) : false;
  }
  function isInfinite_0(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isNaN_1(_this_) {
    return !(_this_ === _this_);
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp0_unsafeCast_0);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals_1(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__4();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__4();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__4 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.prototype.isInstance_4 = function (value) {
    return this._isInstanceFunction(value);
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype.isInstance_4 = function (value) {
    return false;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype._get_simpleName__4 = function () {
    var tmp0_error_0 = 'Unknown simpleName for ErrorKClass';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  ErrorKClass.prototype.isInstance_4 = function (value) {
    var tmp0_error_0 = "Can's check isInstance on ErrorKClass";
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.prototype.isInstance_4 = function (value) {
    return jsIsType(value, this._get_jClass__2());
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KFunction() {
  }
  KFunction.$metadata$ = {
    simpleName: 'KFunction',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KProperty1() {
  }
  KProperty1.$metadata$ = {
    simpleName: 'KProperty1',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty() {
  }
  KProperty.$metadata$ = {
    simpleName: 'KProperty',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KProperty0() {
  }
  KProperty0.$metadata$ = {
    simpleName: 'KProperty0',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KMutableProperty0() {
  }
  KMutableProperty0.$metadata$ = {
    simpleName: 'KMutableProperty0',
    kind: 'interface',
    interfaces: [KProperty0, KMutableProperty]
  };
  function KMutableProperty() {
  }
  KMutableProperty.$metadata$ = {
    simpleName: 'KMutableProperty',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KType() {
  }
  KType.$metadata$ = {
    simpleName: 'KType',
    kind: 'interface',
    interfaces: []
  };
  function createKType_0(classifier, arguments_0, isMarkedNullable) {
    return new KTypeImpl(classifier, asList(arguments_0), isMarkedNullable);
  }
  function createInvariantKTypeProjection_0(type) {
    return Companion_getInstance_2().invariant(type);
  }
  function KTypeImpl(classifier, arguments_0, isMarkedNullable) {
    this._classifier = classifier;
    this._arguments = arguments_0;
    this._isMarkedNullable = isMarkedNullable;
  }
  KTypeImpl.prototype._get_classifier__0 = function () {
    return this._classifier;
  };
  KTypeImpl.prototype._get_arguments__0 = function () {
    return this._arguments;
  };
  KTypeImpl.prototype._get_isMarkedNullable__0 = function () {
    return this._isMarkedNullable;
  };
  KTypeImpl.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof KTypeImpl) {
      tmp_1 = equals_1(this._classifier, other._classifier);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = equals_1(this._arguments, other._arguments);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._isMarkedNullable === other._isMarkedNullable;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KTypeImpl.prototype.hashCode = function () {
    return imul(imul(hashCode(this._classifier), 31) + hashCode(this._arguments) | 0, 31) + (this._isMarkedNullable | 0) | 0;
  };
  KTypeImpl.prototype.toString = function () {
    var tmp = this._classifier;
    var kClass = isInterface(tmp, KClass) ? tmp : null;
    var classifierName = kClass == null ? toString_1(this._classifier) : !(kClass._get_simpleName__4() == null) ? kClass._get_simpleName__4() : '(non-denotable type)';
    var tmp_0;
    if (this._arguments.isEmpty_35()) {
      tmp_0 = '';
    } else {
      tmp_0 = joinToString$default_0(this._arguments, ', ', '<', '>', 0, null, _no_name_provided_$factory_13(this), 24, null);
    }
    var args = tmp_0;
    var nullable_0 = this._isMarkedNullable ? '?' : '';
    return plus_3(classifierName, args) + nullable_0;
  };
  KTypeImpl.$metadata$ = {
    simpleName: 'KTypeImpl',
    kind: 'class',
    interfaces: [KType]
  };
  function prefixString(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(KVariance_INVARIANT_getInstance())) {
      tmp = '';
    } else if (tmp0_subject.equals(KVariance_IN_getInstance())) {
      tmp = 'in ';
    } else if (tmp0_subject.equals(KVariance_OUT_getInstance())) {
      tmp = 'out ';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function _no_name_provided_$factory_13(this$0) {
    var i = new _no_name_provided__30(this$0);
    return function (p1) {
      return i.invoke_27(p1);
    };
  }
  function asString(_this_, $this) {
    if (_this_._variance == null)
      return '*';
    return prefixString(_this_._variance) + toString_0(_this_._type);
  }
  function _no_name_provided__30(this$0) {
    this._this$0_13 = this$0;
  }
  _no_name_provided__30.prototype.invoke_27 = function (it) {
    return asString(it, this._this$0_13);
  };
  _no_name_provided__30.prototype.invoke_276 = function (p1) {
    return this.invoke_27(p1 instanceof KTypeProjection ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var functionClasses;
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_14());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_15());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_16());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_17());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_18());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_19());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_20());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_21());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_22());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_23());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_24());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_25());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_26());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_27());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_28());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_29());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_30());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_31());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_32());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_33(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__31();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__32();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__33();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__34();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__35();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__36();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__37();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__38();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_22() {
    var i = new _no_name_provided__39();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__40();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__41();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_25() {
    var i = new _no_name_provided__42();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__43();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_27() {
    var i = new _no_name_provided__44();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_28() {
    var i = new _no_name_provided__45();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_29() {
    var i = new _no_name_provided__46();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_30() {
    var i = new _no_name_provided__47();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_31() {
    var i = new _no_name_provided__48();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_32() {
    var i = new _no_name_provided__49();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function _no_name_provided_$factory_33($arity) {
    var i = new _no_name_provided__50($arity);
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function _no_name_provided__31() {
  }
  _no_name_provided__31.prototype.invoke_74 = function (it) {
    return isObject(it);
  };
  _no_name_provided__31.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__32() {
  }
  _no_name_provided__32.prototype.invoke_74 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__32.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__33() {
  }
  _no_name_provided__33.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__33.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__34.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__35() {
  }
  _no_name_provided__35.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__35.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36() {
  }
  _no_name_provided__36.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__36.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__37() {
  }
  _no_name_provided__37.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__37.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__38() {
  }
  _no_name_provided__38.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__38.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__39() {
  }
  _no_name_provided__39.prototype.invoke_74 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__39.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__40() {
  }
  _no_name_provided__40.prototype.invoke_74 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__40.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__41() {
  }
  _no_name_provided__41.prototype.invoke_74 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__41.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__42() {
  }
  _no_name_provided__42.prototype.invoke_74 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__42.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__43() {
  }
  _no_name_provided__43.prototype.invoke_74 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__43.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_74 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__44.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__45() {
  }
  _no_name_provided__45.prototype.invoke_74 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__45.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46() {
  }
  _no_name_provided__46.prototype.invoke_74 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__46.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__47() {
  }
  _no_name_provided__47.prototype.invoke_74 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__47.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__48() {
  }
  _no_name_provided__48.prototype.invoke_74 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__48.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__49() {
  }
  _no_name_provided__49.prototype.invoke_74 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__49.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__50($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__50.prototype.invoke_74 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__50.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression_0(e) {
    var tmp0_subject = typeof e;
    var tmp;
    switch (tmp0_subject) {
      case 'string':
        tmp = PrimitiveClasses_getInstance()._stringClass;
        break;
      case 'number':
        var tmp_0;
        var tmp0_asDynamic_0 = jsBitwiseOr(e, 0);
        if (tmp0_asDynamic_0 === e) {
          tmp_0 = PrimitiveClasses_getInstance()._intClass;
        } else {
          {
            tmp_0 = PrimitiveClasses_getInstance()._doubleClass;
          }
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance()._booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        tmp = tmp_1.functionClass(e.length);
        break;
      default:var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance()._booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance()._charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance()._byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance()._shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance()._intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance()._longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance()._floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance()._doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass_0(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance()._arrayClass;
                          } else {
                            {
                              var constructor = Object.getPrototypeOf(e).constructor;
                              var tmp_3;
                              if (constructor === Object) {
                                tmp_3 = PrimitiveClasses_getInstance()._anyClass;
                              } else if (constructor === Error) {
                                tmp_3 = PrimitiveClasses_getInstance()._throwableClass;
                              } else {
                                var jsClass_0 = constructor;
                                tmp_3 = getKClass1_0(jsClass_0);
                              }
                              tmp_2 = tmp_3;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    var tmp1_unsafeCast_0 = tmp;
    return tmp1_unsafeCast_0;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function CharacterCodingException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, CharacterCodingException);
  }
  CharacterCodingException.$metadata$ = {
    simpleName: 'CharacterCodingException',
    kind: 'class',
    interfaces: []
  };
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__0 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_57 = function (index) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__2(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', length: ' + this._get_length__0() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_1 = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_2 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_4 = function (value, startIndex, endIndex) {
    var tmp0_elvis_lhs = value;
    return this.appendRange(tmp0_elvis_lhs == null ? 'null' : tmp0_elvis_lhs, startIndex, endIndex);
  };
  StringBuilder.prototype.append_5 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_6 = function (value) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.prototype.appendRange = function (value, startIndex, endIndex) {
    var stringCsq = toString_1(value);
    Companion_getInstance().checkBoundsIndexes(startIndex, endIndex, stringCsq.length);
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    tmp._string = tmp_0 + stringCsq.substring(startIndex, endIndex);
    return this;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_0($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, Object.create(StringBuilder.prototype));
  }
  function StringBuilder_init_$Init$_0($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_0() {
    return StringBuilder_init_$Init$_0(Object.create(StringBuilder.prototype));
  }
  function isWhitespace(_this_) {
    return matches(_this_.toString(), '[\\s\\xA0]');
  }
  function toInt(_this_) {
    var tmp0_elvis_lhs = toIntOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$('' + 'radix ' + radix + ' was not in valid range 2..36');
    }return radix;
  }
  function digitOf(char, radix) {
    var tmp0_let_0 = (char.compareTo_4(new Char(48)) >= 0 ? char.compareTo_4(new Char(57)) <= 0 : false) ? char.minus(new Char(48)) : (char.compareTo_4(new Char(65)) >= 0 ? char.compareTo_4(new Char(90)) <= 0 : false) ? char.minus(new Char(65)) + 10 | 0 : (char.compareTo_4(new Char(97)) >= 0 ? char.compareTo_4(new Char(122)) <= 0 : false) ? char.minus(new Char(97)) + 10 | 0 : -1;
    return tmp0_let_0 >= radix ? -1 : tmp0_let_0;
  }
  function toByte(_this_) {
    var tmp0_elvis_lhs = toByteOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toShort(_this_) {
    var tmp0_elvis_lhs = toShortOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toLong(_this_) {
    var tmp0_elvis_lhs = toLongOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDouble(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_also_0 = tmp0_unsafeCast_0;
    if ((isNaN_0(tmp1_also_0) ? !isNaN_2(_this_) : false) ? true : tmp1_also_0 === 0.0 ? isBlank(_this_) : false) {
      numberFormatError(_this_);
    }return tmp1_also_0;
  }
  function isNaN_2(_this_) {
    var tmp0_subject = _this_.toLowerCase();
    switch (tmp0_subject) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:return false;
    }
  }
  function Regex(pattern, options) {
    this._pattern = pattern;
    this._options = toSet_0(options);
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(options, 10));
    var tmp0_iterator_1_2 = options.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      tmp0_mapTo_0_1.add_19(item_2_3.value__error);
      Unit_getInstance();
    }
    tmp._nativePattern = new RegExp(pattern, joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null) + 'g');
  }
  Regex.prototype.find = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }return findNext(this._nativePattern, toString_1(input), startIndex);
  };
  Regex.prototype.findAll = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }var tmp = _no_name_provided_$factory_34(this, input, startIndex);
    return generateSequence(tmp, _no_name_provided_$factory_35());
  };
  Regex.prototype.findAll$default = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.findAll(input, startIndex);
  };
  Regex.prototype.split = function (input, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Limit must be non-negative, but was ' + limit;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_let_0 = this.findAll$default(input, 0, 2, null);
    var matches_0 = limit === 0 ? tmp1_let_0 : take_0(tmp1_let_0, limit - 1 | 0);
    var result = ArrayList_init_$Create$();
    var lastStart = 0;
    var tmp0_iterator = matches_0.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var match = tmp0_iterator.next_30();
      result.add_19(toString_1(charSequenceSubSequence(input, lastStart, match._get_range__0()._get_start_())));
      Unit_getInstance();
      lastStart = match._get_range__0()._get_endInclusive_() + 1 | 0;
    }
    result.add_19(toString_1(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
    Unit_getInstance();
    return result;
  };
  Regex.prototype.toString = function () {
    return this._nativePattern.toString();
  };
  Regex.$metadata$ = {
    simpleName: 'Regex',
    kind: 'class',
    interfaces: []
  };
  function findNext(_this_, input, from) {
    _this_.lastIndex = from;
    var match = _this_.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this_.lastIndex - 1 | 0);
    return new _no_name_provided__51(range, match, _this_, input);
  }
  function MatchGroup(value) {
    this._value_1 = value;
  }
  MatchGroup.prototype.toString = function () {
    return '' + 'MatchGroup(value=' + this._value_1 + ')';
  };
  MatchGroup.prototype.hashCode = function () {
    return getStringHashCode(this._value_1);
  };
  MatchGroup.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this._value_1 === tmp0_other_with_cast._value_1))
      return false;
    return true;
  };
  MatchGroup.$metadata$ = {
    simpleName: 'MatchGroup',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__51($range, $match, $this_findNext, $input) {
    this._$range = $range;
    this._$match = $match;
    this._$this_findNext = $this_findNext;
    this._$input = $input;
    this._range = this._$range;
    var tmp = this;
    tmp._groups = new _no_name_provided__55(this._$match);
    this._groupValues_ = null;
  }
  _no_name_provided__51.prototype._get_range__0 = function () {
    return this._range;
  };
  _no_name_provided__51.prototype.next_30 = function () {
    return findNext(this._$this_findNext, this._$input, this._$range.isEmpty_35() ? this._$range._get_start_() + 1 | 0 : this._$range._get_endInclusive_() + 1 | 0);
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: [MatchResult]
  };
  function _no_name_provided_$factory_34(this$0, $input, $startIndex) {
    var i = new _no_name_provided__52(this$0, $input, $startIndex);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_35() {
    var i = new _no_name_provided__53();
    return function (p1) {
      return i.invoke_70(p1);
    };
  }
  function _no_name_provided_$factory_36(this$0) {
    var i = new _no_name_provided__54(this$0);
    return function (p1) {
      return i.invoke_113(p1);
    };
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, Object.create(Regex.prototype));
  }
  function Companion_8() {
    Companion_instance_7 = this;
    this._patternEscape = new RegExp('[-\\\\^$*+?.()|[\\]{}]', 'g');
    this._replacementEscape = new RegExp('\\$', 'g');
  }
  Companion_8.prototype.escape = function (literal) {
    var tmp0_nativeReplace_0 = this._patternEscape;
    var tmp1_nativeReplace_0 = '\\$&';
    return literal.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  };
  Companion_8.prototype.escapeReplacement = function (literal) {
    var tmp0_nativeReplace_0 = this._replacementEscape;
    var tmp1_nativeReplace_0 = '$$$$';
    return literal.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  };
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function _no_name_provided__52(this$0, $input, $startIndex) {
    this._this$0_14 = this$0;
    this._$input_0 = $input;
    this._$startIndex = $startIndex;
  }
  _no_name_provided__52.prototype.invoke_274 = function () {
    return this._this$0_14.find(this._$input_0, this._$startIndex);
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__53() {
  }
  _no_name_provided__53.prototype.invoke_70 = function (match) {
    return match.next_30();
  };
  _no_name_provided__53.prototype.invoke_276 = function (p1) {
    return this.invoke_70((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__54(this$0) {
    this._this$0_15 = this$0;
  }
  _no_name_provided__54.prototype.invoke_113 = function (it) {
    return this._this$0_15.get_57(it);
  };
  _no_name_provided__54.prototype.invoke_276 = function (p1) {
    return this.invoke_113((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__55($match) {
    this._$match_0 = $match;
    AbstractCollection.call(this);
  }
  _no_name_provided__55.prototype._get_size__32 = function () {
    return this._$match_0.length;
  };
  _no_name_provided__55.prototype.iterator_52 = function () {
    var tmp = asSequence(_get_indices__0(this));
    return map(tmp, _no_name_provided_$factory_36(this)).iterator_52();
  };
  _no_name_provided__55.prototype.get_57 = function (index) {
    var tmp0_safe_receiver = this._$match_0[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: [MatchGroupCollection]
  };
  function concatToString(_this_, startIndex, endIndex) {
    Companion_getInstance().checkBoundsIndexes(startIndex, endIndex, _this_.length);
    var result = '';
    var inductionVariable = startIndex;
    var last_2 = endIndex - 1 | 0;
    if (!(endIndex === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + _this_[index];
      }
       while (inductionVariable <= last_2);
    return result;
  }
  function decodeToString(_this_) {
    return decodeUtf8(_this_, 0, _this_.length, false);
  }
  function decodeToString_0(_this_, startIndex, endIndex, throwOnInvalidSequence) {
    Companion_getInstance().checkBoundsIndexes(startIndex, endIndex, _this_.length);
    return decodeUtf8(_this_, startIndex, endIndex, throwOnInvalidSequence);
  }
  function decodeToString$default(_this_, startIndex, endIndex, throwOnInvalidSequence, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      startIndex = 0;
    if (!(($mask0 & 2) === 0))
      endIndex = _this_.length;
    if (!(($mask0 & 4) === 0))
      throwOnInvalidSequence = false;
    return decodeToString_0(_this_, startIndex, endIndex, throwOnInvalidSequence);
  }
  function startsWith(_this_, prefix, ignoreCase) {
    if (!ignoreCase) {
      var tmp0_nativeStartsWith_0 = 0;
      return _this_.startsWith(prefix, tmp0_nativeStartsWith_0);
    } else
      return regionMatches(_this_, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function startsWith$default(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith(_this_, prefix, ignoreCase);
  }
  function replace(_this_, oldValue, newValue, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_7().escape(oldValue), ignoreCase ? 'gi' : 'g');
    var tmp1_nativeReplace_0 = Companion_getInstance_7().escapeReplacement(newValue);
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default(_this_, oldValue, newValue, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return replace(_this_, oldValue, newValue, ignoreCase);
  }
  function isBlank(_this_) {
    var tmp;
    if (charSequenceLength(_this_) === 0) {
      tmp = true;
    } else {
      var tmp_0;
      if (typeof _this_ === 'string') {
        tmp_0 = _this_;
      } else {
        {
          tmp_0 = toString_1(_this_);
        }
      }
      tmp = matches(tmp_0, '^[\\s\\xA0]+$');
    }
    return tmp;
  }
  function regionMatches(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    return regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function matches(_this_, regex) {
    var result = _this_.match(regex);
    return !(result == null) ? !(result.length === 0) : false;
  }
  function endsWith(_this_, suffix, ignoreCase) {
    if (!ignoreCase) {
      return _this_.endsWith(suffix);
    } else
      return regionMatches(_this_, _this_.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function endsWith$default(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith(_this_, suffix, ignoreCase);
  }
  function equals_0(_this_, other, ignoreCase) {
    var tmp;
    if (_this_ == null) {
      tmp = other == null;
    } else if (!ignoreCase) {
      tmp = _this_ == other;
    } else {
      var tmp_0;
      if (!(other == null)) {
        var tmp_1 = _this_.toLowerCase();
        tmp_0 = tmp_1 === other.toLowerCase();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function capitalize(_this_) {
    var tmp;
    if (charSequenceLength(_this_) > 0) {
      var tmp0_substring_0 = 0;
      var tmp1_substring_0 = 1;
      var tmp2_toUpperCase_0 = _this_.substring(tmp0_substring_0, tmp1_substring_0);
      var tmp_0 = tmp2_toUpperCase_0.toUpperCase();
      var tmp3_substring_0 = 1;
      tmp = tmp_0 + _this_.substring(tmp3_substring_0);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function decodeUtf8(bytes, startIndex, endIndex, throwOnMalformed) {
    var tmp0_require_0 = (startIndex >= 0 ? endIndex <= bytes.length : false) ? startIndex <= endIndex : false;
    if (!tmp0_require_0) {
      var message_1_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_1));
    }var byteIndex = startIndex;
    var stringBuilder = StringBuilder_init_$Create$_0();
    while (byteIndex < endIndex) {
      var tmp0 = byteIndex;
      byteIndex = tmp0 + 1 | 0;
      var byte = bytes[tmp0];
      if (byte >= 0) {
        stringBuilder.append_2(numberToChar(byte));
        Unit_getInstance();
      } else if (byte >> 5 === -2) {
        var code = codePointFrom2(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code <= 0) {
          stringBuilder.append_2(new Char(65533));
          Unit_getInstance();
          byteIndex = byteIndex + (-code | 0) | 0;
        } else {
          stringBuilder.append_2(numberToChar(code));
          Unit_getInstance();
          byteIndex = byteIndex + 1 | 0;
        }
      } else if (byte >> 4 === -2) {
        var code_0 = codePointFrom3(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code_0 <= 0) {
          stringBuilder.append_2(new Char(65533));
          Unit_getInstance();
          byteIndex = byteIndex + (-code_0 | 0) | 0;
        } else {
          stringBuilder.append_2(numberToChar(code_0));
          Unit_getInstance();
          byteIndex = byteIndex + 2 | 0;
        }
      } else if (byte >> 3 === -2) {
        var code_1 = codePointFrom4(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code_1 <= 0) {
          stringBuilder.append_2(new Char(65533));
          Unit_getInstance();
          byteIndex = byteIndex + (-code_1 | 0) | 0;
        } else {
          var high = (code_1 - 65536 | 0) >> 10 | 55296;
          var low = code_1 & 1023 | 56320;
          stringBuilder.append_2(numberToChar(high));
          Unit_getInstance();
          stringBuilder.append_2(numberToChar(low));
          Unit_getInstance();
          byteIndex = byteIndex + 3 | 0;
        }
      } else {
        malformed(0, byteIndex, throwOnMalformed);
        Unit_getInstance();
        stringBuilder.append_2(new Char(65533));
        Unit_getInstance();
      }
    }
    return stringBuilder.toString();
  }
  function codePointFrom2(bytes, byte1, index, endIndex, throwOnMalformed) {
    if ((byte1 & 30) === 0 ? true : index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }var byte2 = bytes[index];
    if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }return byte1 << 6 ^ byte2 ^ 3968;
  }
  function codePointFrom3(bytes, byte1, index, endIndex, throwOnMalformed) {
    if (index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }var byte2 = bytes[index];
    if ((byte1 & 15) === 0) {
      if (!((byte2 & 224) === 160)) {
        return malformed(0, index, throwOnMalformed);
      }} else if ((byte1 & 15) === 13) {
      if (!((byte2 & 224) === 128)) {
        return malformed(0, index, throwOnMalformed);
      }} else if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }if ((index + 1 | 0) === endIndex) {
      return malformed(1, index, throwOnMalformed);
    }var byte3 = bytes[index + 1 | 0];
    if (!((byte3 & 192) === 128)) {
      return malformed(1, index, throwOnMalformed);
    }return byte1 << 12 ^ byte2 << 6 ^ byte3 ^ -123008;
  }
  function codePointFrom4(bytes, byte1, index, endIndex, throwOnMalformed) {
    if (index >= endIndex) {
      malformed(0, index, throwOnMalformed);
      Unit_getInstance();
    }var byte2 = bytes[index];
    if ((byte1 & 15) === 0) {
      if ((byte2 & 240) <= 128) {
        return malformed(0, index, throwOnMalformed);
      }} else if ((byte1 & 15) === 4) {
      if (!((byte2 & 240) === 128)) {
        return malformed(0, index, throwOnMalformed);
      }} else if ((byte1 & 15) > 4) {
      return malformed(0, index, throwOnMalformed);
    } else if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }if ((index + 1 | 0) === endIndex) {
      return malformed(1, index, throwOnMalformed);
    }var byte3 = bytes[index + 1 | 0];
    if (!((byte3 & 192) === 128)) {
      return malformed(1, index, throwOnMalformed);
    }if ((index + 2 | 0) === endIndex) {
      return malformed(2, index, throwOnMalformed);
    }var byte4 = bytes[index + 2 | 0];
    if (!((byte4 & 192) === 128)) {
      return malformed(2, index, throwOnMalformed);
    }return byte1 << 18 ^ byte2 << 12 ^ byte3 << 6 ^ byte4 ^ 3678080;
  }
  function malformed(size_0, index, throwOnMalformed) {
    if (throwOnMalformed)
      throw new CharacterCodingException('' + 'Malformed sequence starting at ' + (index - 1 | 0));
    return -size_0 | 0;
  }
  function Char(value) {
    this._value_2 = value;
  }
  Char.prototype.compareTo_4 = function (other) {
    return this._value_2 - other._value_2 | 0;
  };
  Char.prototype.compareTo_9 = function (other) {
    return this.compareTo_4(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.minus = function (other) {
    return this._value_2 - other._value_2 | 0;
  };
  Char.prototype.toInt_5 = function () {
    return this._value_2;
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value_2 === other._value_2;
  };
  Char.prototype.hashCode = function () {
    return this._value_2;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value_2);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Companion_9() {
    Companion_instance_8 = this;
    this._MIN_VALUE_4 = new Char(0);
    this._MAX_VALUE_4 = new Char(65535);
    this._MIN_HIGH_SURROGATE = new Char(55296);
    this._MAX_HIGH_SURROGATE = new Char(56319);
    this._MIN_LOW_SURROGATE = new Char(56320);
    this._MAX_LOW_SURROGATE = new Char(57343);
    this._MIN_SURROGATE = new Char(55296);
    this._MAX_SURROGATE = new Char(57343);
    this._SIZE_BYTES_4 = 2;
    this._SIZE_BITS_4 = 16;
  }
  Companion_9.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_9();
    return Companion_instance_8;
  }
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function Enum(name, ordinal) {
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype._get_ordinal__1 = function () {
    return this._ordinal;
  };
  Enum.prototype.compareTo_6 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_9 = function (other) {
    return this.compareTo_6(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function plus_3(_this_, other) {
    var tmp2_safe_receiver = _this_;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toString_1(tmp2_safe_receiver);
    var tmp = tmp3_elvis_lhs == null ? 'null' : tmp3_elvis_lhs;
    var tmp0_safe_receiver = other;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last_2 = array.length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last_2));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__56(array);
  }
  function booleanArray(size_0) {
    var tmp0_withType_0 = 'BooleanArray';
    var tmp1_withType_0 = fillArrayVal(Array(size_0), false);
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function charArray(size_0) {
    var tmp0_withType_0 = 'CharArray';
    var tmp1_withType_0 = fillArrayVal(Array(size_0), new Char(0));
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function longArray(size_0) {
    var tmp0_withType_0 = 'LongArray';
    var tmp1_withType_0 = fillArrayVal(Array(size_0), new Long(0, 0));
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function _no_name_provided__56($array) {
    this._$array = $array;
    this._index_4 = 0;
  }
  _no_name_provided__56.prototype.hasNext_27 = function () {
    return !(this._index_4 === this._$array.length);
  };
  _no_name_provided__56.prototype.next_30 = function () {
    var tmp;
    if (!(this._index_4 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_4;
      tmp0_this._index_4 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_4);
    }
    return tmp;
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  var buf;
  var bufFloat64;
  var bufFloat32;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function doubleFromBits(value) {
    bufInt32[lowIndex] = value._low;
    bufInt32[highIndex] = value._high;
    return bufFloat64[0];
  }
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function floatFromBits(value) {
    bufInt32[0] = value;
    return bufFloat32[0];
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufFloat32$init$() {
    var tmp0_unsafeCast_0 = new Float32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index);
      tmp = new Char(tmp0_unsafeCast_0);
    } else {
      tmp = a.get_57(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__0();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_1(startIndex, endIndex);
    }
    return tmp;
  }
  function contentEqualsInternal(_this_, other) {
    var a = _this_;
    var b = other;
    if (a === b)
      return true;
    if (((a == null ? true : b == null) ? true : !isArrayish(b)) ? true : a.length != b.length)
      return false;
    var untilArg = a.length;
    var inductionVariable = 0;
    var last_2 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(a[i], b[i])) {
          return false;
        }}
       while (inductionVariable <= last_2);
    return true;
  }
  function contentHashCodeInternal(_this_) {
    var a = _this_;
    if (a == null)
      return 0;
    var result = 1;
    var untilArg = a.length;
    var inductionVariable = 0;
    var last_2 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = imul(result, 31) + hashCode(a[i]) | 0;
      }
       while (inductionVariable <= last_2);
    return result;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_37(), 24, null);
  }
  function _no_name_provided__57() {
  }
  _no_name_provided__57.prototype.invoke_74 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__57.prototype.invoke_276 = function (p1) {
    return this.invoke_74((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_37() {
    var i = new _no_name_provided__57();
    return function (p1) {
      return i.invoke_74(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_4());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_9(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function equals_1(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last_2 = length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last_2));
    return hash;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function unboxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp1_elvis_lhs = message;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        var tmp0_safe_receiver = cause;
        tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var tmp2_elvis_lhs = tmp;
      this_.message = tmp2_elvis_lhs == null ? undefined : tmp2_elvis_lhs;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function getContinuation() {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function lazy(initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    var arr = dst;
    while (index < srcLen ? index < dstLen : false) {
      var tmp = index;
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      arr[tmp] = src[tmp0];
    }
    return dst;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    var tmp0_unsafeCast_0 = source.slice(0, newSize);
    var result = tmp0_unsafeCast_0;
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }var index = source.length;
    if (newSize > index) {
      result.length = newSize;
      while (index < newSize) {
        var tmp0 = index;
        index = tmp0 + 1 | 0;
        result[tmp0] = defaultValue;
      }
    }return result;
  }
  function lazy_0(mode, initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function Long(low, high) {
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_48 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_9 = function (other) {
    return this.compareTo_48(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_45 = function (other) {
    return add(this, other);
  };
  Long.prototype.minus_28 = function (other) {
    return subtract(this, other);
  };
  Long.prototype.times_28 = function (other) {
    return multiply(this, other);
  };
  Long.prototype.div_28 = function (other) {
    return divide(this, other);
  };
  Long.prototype.rem_27 = function (other) {
    return modulo(this, other);
  };
  Long.prototype.inc_4 = function () {
    return this.plus_45(new Long(1, 0));
  };
  Long.prototype.dec_4 = function () {
    return this.minus_28(new Long(1, 0));
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_45(new Long(1, 0));
  };
  Long.prototype.rangeTo_11 = function (other) {
    return new LongRange(this, other);
  };
  Long.prototype.shl_0 = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  Long.prototype.shr_0 = function (bitCount) {
    return shiftRight(this, bitCount);
  };
  Long.prototype.ushr_0 = function (bitCount) {
    return shiftRightUnsigned(this, bitCount);
  };
  Long.prototype.and = function (other) {
    return new Long(this._low & other._low, this._high & other._high);
  };
  Long.prototype.or = function (other) {
    return new Long(this._low | other._low, this._high | other._high);
  };
  Long.prototype.xor = function (other) {
    return new Long(this._low ^ other._low, this._high ^ other._high);
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_5 = function () {
    return this._low;
  };
  Long.prototype.toLong_4 = function () {
    return this;
  };
  Long.prototype.toFloat_4 = function () {
    return this.toDouble_4();
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Companion_10() {
    Companion_instance_9 = this;
    this._MIN_VALUE_5 = new Long(0, -2147483648);
    this._MAX_VALUE_5 = new Long(-1, 2147483647);
    this._SIZE_BYTES_5 = 8;
    this._SIZE_BITS_5 = 64;
  }
  Companion_10.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_10();
    return Companion_instance_9;
  }
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_28(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_28(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_28(negate(other));
      } else {
        tmp = negate(negate(_this_).div_28(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_28(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta_0 = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta_0;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function modulo(_this_, other) {
    return subtract(_this_, multiply(_this_.div_28(other), other));
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function shiftRightUnsigned(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >>> numBits_0);
      } else {
        var tmp;
        if (numBits_0 === 32) {
          tmp = new Long(_this_._high, 0);
        } else {
          tmp = new Long(_this_._high >>> (numBits_0 - 32 | 0), 0);
        }
        return tmp;
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_28(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_5();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_28(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_5();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function primitiveArrayConcat(args) {
    var size_local = 0;
    var inductionVariable = 0;
    var last_2 = args.length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = size_local;
        var tmp0_unsafeCast_0 = args[i];
        size_local = tmp + tmp0_unsafeCast_0.length | 0;
      }
       while (!(i === last_2));
    var a = args[0];
    var tmp1_unsafeCast_0 = new a.constructor(size_local);
    var result = tmp1_unsafeCast_0;
    if (a.$type$ != null) {
      var tmp2_withType_0 = a.$type$;
      result.$type$ = tmp2_withType_0;
    } else {
    }
    size_local = 0;
    var inductionVariable_0 = 0;
    var last_3 = args.length - 1 | 0;
    if (inductionVariable_0 <= last_3)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp3_unsafeCast_0 = args[i_0];
        var arr = tmp3_unsafeCast_0;
        var inductionVariable_1 = 0;
        var last_4 = arr.length - 1 | 0;
        if (inductionVariable_1 <= last_4)
          do {
            var j = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp3 = size_local;
            size_local = tmp3 + 1 | 0;
            result[tmp3] = arr[j];
          }
           while (!(j === last_4));
      }
       while (!(i_0 === last_3));
    return result;
  }
  function toByte_0(a) {
    var tmp0_unsafeCast_0 = a << 24 >> 24;
    return tmp0_unsafeCast_0;
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_5();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function numberToDouble(a) {
    var tmp0_unsafeCast_0 = +a;
    return tmp0_unsafeCast_0;
  }
  function toShort_0(a) {
    var tmp0_unsafeCast_0 = a << 16 >> 16;
    return tmp0_unsafeCast_0;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      {
        tmp = fromNumber(a);
      }
    }
    return tmp;
  }
  function numberToChar(a) {
    return new Char(numberToInt(a) & 65535);
  }
  function toLong_0(a) {
    return fromInt(a);
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  var propertyRefClassMetadataCache;
  function getPropertyCallableRef(name, paramCount, type, getter, setter) {
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    var tmp0_unsafeCast_0 = getPropertyRefClass(getter, getKPropMetadata(paramCount, setter, type));
    return tmp0_unsafeCast_0;
  }
  function getPropertyRefClass(obj, metadata) {
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    return obj;
  }
  function getKPropMetadata(paramCount, setter, type) {
    var mdata = propertyRefClassMetadataCache[paramCount][setter == null ? 0 : 1];
    if (mdata.interfaces.length == 0) {
      mdata.interfaces.push(type);
    }return mdata;
  }
  function propertyRefClassMetadataCache$init$() {
    var tmp = {kind: 'class', interfaces: []};
    var tmp0_arrayOf_0 = [tmp, {kind: 'class', interfaces: []}];
    var tmp_0 = tmp0_arrayOf_0;
    var tmp_1 = {kind: 'class', interfaces: []};
    var tmp1_arrayOf_0 = [tmp_1, {kind: 'class', interfaces: []}];
    var tmp_2 = tmp1_arrayOf_0;
    var tmp_3 = {kind: 'class', interfaces: []};
    var tmp2_arrayOf_0 = [tmp_3, {kind: 'class', interfaces: []}];
    var tmp3_arrayOf_0 = [tmp_0, tmp_2, tmp2_arrayOf_0];
    return tmp3_arrayOf_0;
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last_2 = indexedObject.length;
      while (inductionVariable < last_2) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return ((type === 'string' ? true : type === 'boolean') ? true : isNumber(value)) ? true : isInterface(value, _get_js_(getKClass_0(Comparable)));
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function jsIsType(obj, jsClass_0) {
    if (jsClass_0 === Object) {
      return isObject(obj);
    }if ((obj == null ? true : jsClass_0 == null) ? true : !(typeof obj === 'object') ? !(typeof obj === 'function') : false) {
      return false;
    }if (typeof jsClass_0 === 'function' ? jsInstanceOf(obj, jsClass_0) : false) {
      return true;
    }var proto = jsGetPrototypeOf(jsClass_0);
    var tmp0_safe_receiver = proto;
    var constructor = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.constructor;
    if (constructor != null ? jsIn('$metadata$', constructor) : false) {
      var metadata = constructor.$metadata$;
      if (metadata.kind === 'object') {
        return obj === jsClass_0;
      }}var klassMetadata = jsClass_0.$metadata$;
    if (klassMetadata == null) {
      return jsInstanceOf(obj, jsClass_0);
    }if (klassMetadata.kind === 'interface' ? obj.constructor != null : false) {
      return isInterfaceImpl(obj.constructor, jsClass_0);
    }return false;
  }
  function jsGetPrototypeOf(jsClass_0) {
    return Object.getPrototypeOf(jsClass_0);
  }
  function copyOf(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_withType_0 = 'CharArray';
    var tmp2_withType_0 = fillFrom(_this_, charArray(newSize));
    tmp2_withType_0.$type$ = tmp1_withType_0;
    return tmp2_withType_0;
  }
  function copyOf_0(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Float64Array(newSize));
  }
  function copyOf_1(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Float32Array(newSize));
  }
  function copyOf_2(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_withType_0 = 'LongArray';
    var tmp2_withType_0 = arrayCopyResize(_this_, newSize, new Long(0, 0));
    tmp2_withType_0.$type$ = tmp1_withType_0;
    return tmp2_withType_0;
  }
  function copyOf_3(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int32Array(newSize));
  }
  function copyOf_4(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int16Array(newSize));
  }
  function copyOf_5(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int8Array(newSize));
  }
  function copyOf_6(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_withType_0 = 'BooleanArray';
    var tmp2_withType_0 = arrayCopyResize(_this_, newSize, false);
    tmp2_withType_0.$type$ = tmp1_withType_0;
    return tmp2_withType_0;
  }
  function contentEquals(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function sortWith_0(_this_, comparator) {
    if (_this_.length > 1)
      sortArrayWith(_this_, comparator);
  }
  function toTypedArray(_this_) {
    return [].slice.call(_this_);
  }
  function toTypedArray_0(_this_) {
    return [].slice.call(_this_);
  }
  function toTypedArray_1(_this_) {
    return [].slice.call(_this_);
  }
  function toTypedArray_2(_this_) {
    return [].slice.call(_this_);
  }
  function copyOf_7(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return arrayCopyResize(_this_, newSize, null);
  }
  function fill(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function CoroutineImpl_0(resultContinuation) {
    this._resultContinuation = resultContinuation;
    this._state_2 = 0;
    this._exceptionState = 0;
    this._result = null;
    this._exception_0 = null;
    this._finallyPath = null;
    var tmp = this;
    var tmp0_safe_receiver = this._resultContinuation;
    tmp.__context = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_context__9();
    this._intercepted_ = null;
  }
  CoroutineImpl_0.prototype._get_exception_ = function () {
    return this._exception_0;
  };
  CoroutineImpl_0.prototype._get_context__9 = function () {
    return ensureNotNull(this.__context);
  };
  CoroutineImpl_0.prototype.intercepted_1 = function () {
    var tmp2_elvis_lhs = this._intercepted_;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_safe_receiver = this._get_context__9().get_42(Key_getInstance());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptContinuation_9(this);
      var tmp0_also_0 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
      this._intercepted_ = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  };
  CoroutineImpl_0.prototype.resumeWith_12 = function (result) {
    var current = this;
    var tmp;
    if (_get_isFailure__impl(result)) {
      tmp = null;
    } else {
      var tmp_0 = _get_value__impl(result);
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = exceptionOrNull_impl(result);
    while (true) {
      var tmp0_with_0 = current;
      if (currentException == null) {
        tmp0_with_0._result = currentResult;
      } else {
        tmp0_with_0._state_2 = tmp0_with_0._exceptionState;
        tmp0_with_0._exception_0 = currentException;
      }
      try {
        var outcome_2 = tmp0_with_0.doResume_3();
        if (outcome_2 === _get_COROUTINE_SUSPENDED_())
          return Unit_getInstance();
        currentResult = outcome_2;
        currentException = null;
      } catch ($p) {
        currentResult = null;
        currentException = $p;
      }
      releaseIntercepted(tmp0_with_0);
      var completion_4 = ensureNotNull(tmp0_with_0._resultContinuation);
      if (completion_4 instanceof CoroutineImpl_0) {
        current = completion_4;
      } else {
        {
          if (!(currentException == null)) {
            var tmp0_resumeWithException_0_5 = ensureNotNull(currentException);
            var tmp0_failure_0_1_6 = Companion_getInstance_3();
            completion_4.resumeWith_11(createFailure(tmp0_resumeWithException_0_5));
          } else {
            var tmp1_resume_0_7 = currentResult;
            var tmp0_success_0_1_8 = Companion_getInstance_3();
            completion_4.resumeWith_11(tmp1_resume_0_7);
          }
          return Unit_getInstance();
        }
      }
    }
  };
  CoroutineImpl_0.prototype.resumeWith_11 = function (result) {
    return this.resumeWith_12(result);
  };
  CoroutineImpl_0.$metadata$ = {
    simpleName: 'CoroutineImpl',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompletedContinuation() {
    CompletedContinuation_instance = this;
  }
  CompletedContinuation.prototype._get_context__9 = function () {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_12 = function (result) {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_11 = function (result) {
    return this.resumeWith_12(result);
  };
  CompletedContinuation.prototype.toString = function () {
    return 'This continuation is already complete';
  };
  CompletedContinuation.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'object',
    interfaces: [Continuation]
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    if (CompletedContinuation_instance == null)
      new CompletedContinuation();
    return CompletedContinuation_instance;
  }
  function releaseIntercepted($this) {
    var intercepted_0 = $this._intercepted_;
    if (!(intercepted_0 == null) ? !(intercepted_0 === $this) : false) {
      ensureNotNull($this._get_context__9().get_42(Key_getInstance())).releaseInterceptedContinuation_9(intercepted_0);
    }$this._intercepted_ = CompletedContinuation_getInstance();
  }
  function intercepted(_this_) {
    var tmp0_safe_receiver = _this_ instanceof CoroutineImpl_0 ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.intercepted_1();
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this_, receiver, completion) {
    return new _no_name_provided__1_1(_this_, receiver, completion);
  }
  function _no_name_provided__1_1($this_createCoroutineUnintercepted, $receiver, $completion) {
    this._$this_createCoroutineUnintercepted = $this_createCoroutineUnintercepted;
    this._$receiver = $receiver;
    this._$completion = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_1.prototype.doResume_2 = function () {
    if (this._get_exception_() != null)
      throw this._get_exception_();
    return this._$this_createCoroutineUnintercepted(this._$receiver, this._$completion);
  };
  _no_name_provided__1_1.prototype.doResume_3 = function () {
    return this.doResume_2();
  };
  _no_name_provided__1_1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function Error_0() {
    captureStack(this, Error_0);
  }
  Error_0.$metadata$ = {
    simpleName: 'Error',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  NumberFormatException.$metadata$ = {
    simpleName: 'NumberFormatException',
    kind: 'class',
    interfaces: []
  };
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  ArithmeticException.$metadata$ = {
    simpleName: 'ArithmeticException',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  NoWhenBranchMatchedException.$metadata$ = {
    simpleName: 'NoWhenBranchMatchedException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this, null, null);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, null);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Error_init_$Init$(message, $this) {
    extendThrowable($this, message, null);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Init$_0(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$(message) {
    var tmp = RuntimeException_init_$Init$_0(message, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_0(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$(message) {
    var tmp = IllegalStateException_init_$Init$(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message, cause) {
    var tmp = IllegalStateException_init_$Init$_0(message, cause, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function NumberFormatException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$(message) {
    var tmp = NumberFormatException_init_$Init$(message, Object.create(NumberFormatException.prototype));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function ArithmeticException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$(message) {
    var tmp = ArithmeticException_init_$Init$(message, Object.create(ArithmeticException.prototype));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(Object.create(NoWhenBranchMatchedException.prototype));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack in rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    delete obj_hack[property_hack];
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function findAssociatedObject(_this_, annotationClass) {
    var tmp;
    var tmp_0;
    if (_this_ instanceof KClassImpl) {
      tmp_0 = annotationClass instanceof KClassImpl;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp0_asDynamic_0 = annotationClass._get_jClass__2();
      var tmp0_safe_receiver = tmp0_asDynamic_0.$metadata$;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        tmp_1 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var key = tmp_2;
      var tmp1_asDynamic_0 = _this_._get_jClass__2();
      var tmp3_safe_receiver = tmp1_asDynamic_0.$metadata$;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.associatedObjects;
      var tmp_3;
      if (tmp4_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp4_elvis_lhs;
      }
      var map_0 = tmp_3;
      var tmp5_elvis_lhs = map_0[key];
      var tmp_4;
      if (tmp5_elvis_lhs == null) {
        return null;
      } else {
        tmp_4 = tmp5_elvis_lhs;
      }
      var factory = tmp_4;
      return factory();
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Mat4(x, y, z, w) {
    this._x_0 = x;
    this._y_0 = y;
    this._z_0 = z;
    this._w_0 = w;
  }
  Mat4.prototype._get_rotation_ = function () {
    var toEulerAngles = Companion_getInstance_11().from_0(this).toEulerAngles();
    var tmp0_degrees_0 = toEulerAngles._x_2;
    var tmp = tmp0_degrees_0 * 57.29577720165253;
    var tmp1_degrees_0 = toEulerAngles._y_2;
    var tmp_0 = tmp1_degrees_0 * 57.29577720165253;
    var tmp2_degrees_0 = toEulerAngles._z_2;
    return new Float3(tmp, tmp_0, tmp2_degrees_0 * 57.29577720165253);
  };
  Mat4.prototype.div_29 = function (v) {
    var tmp0_div_0 = this._x_0;
    var tmp = new Float4(tmp0_div_0._x_3 / v, tmp0_div_0._y_3 / v, tmp0_div_0._z_3 / v, tmp0_div_0._w_2 / v);
    var tmp1_div_0 = this._y_0;
    var tmp_0 = new Float4(tmp1_div_0._x_3 / v, tmp1_div_0._y_3 / v, tmp1_div_0._z_3 / v, tmp1_div_0._w_2 / v);
    var tmp2_div_0 = this._z_0;
    var tmp_1 = new Float4(tmp2_div_0._x_3 / v, tmp2_div_0._y_3 / v, tmp2_div_0._z_3 / v, tmp2_div_0._w_2 / v);
    var tmp3_div_0 = this._w_0;
    return new Mat4(tmp, tmp_0, tmp_1, new Float4(tmp3_div_0._x_3 / v, tmp3_div_0._y_3 / v, tmp3_div_0._z_3 / v, tmp3_div_0._w_2 / v));
  };
  Mat4.prototype.times_0 = function (m) {
    var t = transpose(this);
    var tmp0_dot_0 = t._x_0;
    var tmp1_dot_0 = m._x_0;
    var tmp = tmp0_dot_0._x_3 * tmp1_dot_0._x_3 + tmp0_dot_0._y_3 * tmp1_dot_0._y_3 + tmp0_dot_0._z_3 * tmp1_dot_0._z_3 + tmp0_dot_0._w_2 * tmp1_dot_0._w_2;
    var tmp2_dot_0 = t._y_0;
    var tmp3_dot_0 = m._x_0;
    var tmp_0 = tmp2_dot_0._x_3 * tmp3_dot_0._x_3 + tmp2_dot_0._y_3 * tmp3_dot_0._y_3 + tmp2_dot_0._z_3 * tmp3_dot_0._z_3 + tmp2_dot_0._w_2 * tmp3_dot_0._w_2;
    var tmp4_dot_0 = t._z_0;
    var tmp5_dot_0 = m._x_0;
    var tmp_1 = tmp4_dot_0._x_3 * tmp5_dot_0._x_3 + tmp4_dot_0._y_3 * tmp5_dot_0._y_3 + tmp4_dot_0._z_3 * tmp5_dot_0._z_3 + tmp4_dot_0._w_2 * tmp5_dot_0._w_2;
    var tmp6_dot_0 = t._w_0;
    var tmp7_dot_0 = m._x_0;
    var tmp_2 = new Float4(tmp, tmp_0, tmp_1, tmp6_dot_0._x_3 * tmp7_dot_0._x_3 + tmp6_dot_0._y_3 * tmp7_dot_0._y_3 + tmp6_dot_0._z_3 * tmp7_dot_0._z_3 + tmp6_dot_0._w_2 * tmp7_dot_0._w_2);
    var tmp8_dot_0 = t._x_0;
    var tmp9_dot_0 = m._y_0;
    var tmp_3 = tmp8_dot_0._x_3 * tmp9_dot_0._x_3 + tmp8_dot_0._y_3 * tmp9_dot_0._y_3 + tmp8_dot_0._z_3 * tmp9_dot_0._z_3 + tmp8_dot_0._w_2 * tmp9_dot_0._w_2;
    var tmp10_dot_0 = t._y_0;
    var tmp11_dot_0 = m._y_0;
    var tmp_4 = tmp10_dot_0._x_3 * tmp11_dot_0._x_3 + tmp10_dot_0._y_3 * tmp11_dot_0._y_3 + tmp10_dot_0._z_3 * tmp11_dot_0._z_3 + tmp10_dot_0._w_2 * tmp11_dot_0._w_2;
    var tmp12_dot_0 = t._z_0;
    var tmp13_dot_0 = m._y_0;
    var tmp_5 = tmp12_dot_0._x_3 * tmp13_dot_0._x_3 + tmp12_dot_0._y_3 * tmp13_dot_0._y_3 + tmp12_dot_0._z_3 * tmp13_dot_0._z_3 + tmp12_dot_0._w_2 * tmp13_dot_0._w_2;
    var tmp14_dot_0 = t._w_0;
    var tmp15_dot_0 = m._y_0;
    var tmp_6 = new Float4(tmp_3, tmp_4, tmp_5, tmp14_dot_0._x_3 * tmp15_dot_0._x_3 + tmp14_dot_0._y_3 * tmp15_dot_0._y_3 + tmp14_dot_0._z_3 * tmp15_dot_0._z_3 + tmp14_dot_0._w_2 * tmp15_dot_0._w_2);
    var tmp16_dot_0 = t._x_0;
    var tmp17_dot_0 = m._z_0;
    var tmp_7 = tmp16_dot_0._x_3 * tmp17_dot_0._x_3 + tmp16_dot_0._y_3 * tmp17_dot_0._y_3 + tmp16_dot_0._z_3 * tmp17_dot_0._z_3 + tmp16_dot_0._w_2 * tmp17_dot_0._w_2;
    var tmp18_dot_0 = t._y_0;
    var tmp19_dot_0 = m._z_0;
    var tmp_8 = tmp18_dot_0._x_3 * tmp19_dot_0._x_3 + tmp18_dot_0._y_3 * tmp19_dot_0._y_3 + tmp18_dot_0._z_3 * tmp19_dot_0._z_3 + tmp18_dot_0._w_2 * tmp19_dot_0._w_2;
    var tmp20_dot_0 = t._z_0;
    var tmp21_dot_0 = m._z_0;
    var tmp_9 = tmp20_dot_0._x_3 * tmp21_dot_0._x_3 + tmp20_dot_0._y_3 * tmp21_dot_0._y_3 + tmp20_dot_0._z_3 * tmp21_dot_0._z_3 + tmp20_dot_0._w_2 * tmp21_dot_0._w_2;
    var tmp22_dot_0 = t._w_0;
    var tmp23_dot_0 = m._z_0;
    var tmp_10 = new Float4(tmp_7, tmp_8, tmp_9, tmp22_dot_0._x_3 * tmp23_dot_0._x_3 + tmp22_dot_0._y_3 * tmp23_dot_0._y_3 + tmp22_dot_0._z_3 * tmp23_dot_0._z_3 + tmp22_dot_0._w_2 * tmp23_dot_0._w_2);
    var tmp24_dot_0 = t._x_0;
    var tmp25_dot_0 = m._w_0;
    var tmp_11 = tmp24_dot_0._x_3 * tmp25_dot_0._x_3 + tmp24_dot_0._y_3 * tmp25_dot_0._y_3 + tmp24_dot_0._z_3 * tmp25_dot_0._z_3 + tmp24_dot_0._w_2 * tmp25_dot_0._w_2;
    var tmp26_dot_0 = t._y_0;
    var tmp27_dot_0 = m._w_0;
    var tmp_12 = tmp26_dot_0._x_3 * tmp27_dot_0._x_3 + tmp26_dot_0._y_3 * tmp27_dot_0._y_3 + tmp26_dot_0._z_3 * tmp27_dot_0._z_3 + tmp26_dot_0._w_2 * tmp27_dot_0._w_2;
    var tmp28_dot_0 = t._z_0;
    var tmp29_dot_0 = m._w_0;
    var tmp_13 = tmp28_dot_0._x_3 * tmp29_dot_0._x_3 + tmp28_dot_0._y_3 * tmp29_dot_0._y_3 + tmp28_dot_0._z_3 * tmp29_dot_0._z_3 + tmp28_dot_0._w_2 * tmp29_dot_0._w_2;
    var tmp30_dot_0 = t._w_0;
    var tmp31_dot_0 = m._w_0;
    return new Mat4(tmp_2, tmp_6, tmp_10, new Float4(tmp_11, tmp_12, tmp_13, tmp30_dot_0._x_3 * tmp31_dot_0._x_3 + tmp30_dot_0._y_3 * tmp31_dot_0._y_3 + tmp30_dot_0._z_3 * tmp31_dot_0._z_3 + tmp30_dot_0._w_2 * tmp31_dot_0._w_2));
  };
  Mat4.prototype.asGLArray = function () {
    var tmp0_arrayOf_0 = [this._x_0._x_3, this._x_0._y_3, this._x_0._z_3, this._x_0._w_2, this._y_0._x_3, this._y_0._y_3, this._y_0._z_3, this._y_0._w_2, this._z_0._x_3, this._z_0._y_3, this._z_0._z_3, this._z_0._w_2, this._w_0._x_3, this._w_0._y_3, this._w_0._z_3, this._w_0._w_2];
    return tmp0_arrayOf_0;
  };
  Mat4.prototype.toString = function () {
    return trimIndent('' + '\n            [' + this._x_0._x_3 + '|' + this._y_0._x_3 + '|' + this._z_0._x_3 + '|' + this._w_0._x_3 + ']\n            [' + this._x_0._y_3 + '|' + this._y_0._y_3 + '|' + this._z_0._y_3 + '|' + this._w_0._y_3 + ']\n            [' + this._x_0._z_3 + '|' + this._y_0._z_3 + '|' + this._z_0._z_3 + '|' + this._w_0._z_3 + ']\n            [' + this._x_0._w_2 + '|' + this._y_0._w_2 + '|' + this._z_0._w_2 + '|' + this._w_0._w_2 + ']\n        ');
  };
  Mat4.prototype.hashCode = function () {
    var result = this._x_0.hashCode();
    result = imul(result, 31) + this._y_0.hashCode() | 0;
    result = imul(result, 31) + this._z_0.hashCode() | 0;
    result = imul(result, 31) + this._w_0.hashCode() | 0;
    return result;
  };
  Mat4.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mat4))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Mat4 ? other : THROW_CCE();
    if (!this._x_0.equals(tmp0_other_with_cast._x_0))
      return false;
    if (!this._y_0.equals(tmp0_other_with_cast._y_0))
      return false;
    if (!this._z_0.equals(tmp0_other_with_cast._z_0))
      return false;
    if (!this._w_0.equals(tmp0_other_with_cast._w_0))
      return false;
    return true;
  };
  Mat4.$metadata$ = {
    simpleName: 'Mat4',
    kind: 'class',
    interfaces: []
  };
  function translation(t) {
    return Mat4_init_$Create$(null, null, null, Float4_init_$Create$_0(t, 1.0), 7, null);
  }
  function inverse(m) {
    var result = Mat4_init_$Create$(null, null, null, null, 15, null);
    var pair0 = m._z_0._z_3 * m._w_0._w_2;
    var pair1 = m._w_0._z_3 * m._z_0._w_2;
    var pair2 = m._y_0._z_3 * m._w_0._w_2;
    var pair3 = m._w_0._z_3 * m._y_0._w_2;
    var pair4 = m._y_0._z_3 * m._z_0._w_2;
    var pair5 = m._z_0._z_3 * m._y_0._w_2;
    var pair6 = m._x_0._z_3 * m._w_0._w_2;
    var pair7 = m._w_0._z_3 * m._x_0._w_2;
    var pair8 = m._x_0._z_3 * m._z_0._w_2;
    var pair9 = m._z_0._z_3 * m._x_0._w_2;
    var pair10 = m._x_0._z_3 * m._y_0._w_2;
    var pair11 = m._y_0._z_3 * m._x_0._w_2;
    result._x_0._x_3 = pair0 * m._y_0._y_3 + pair3 * m._z_0._y_3 + pair4 * m._w_0._y_3;
    var tmp0_this = result._x_0;
    tmp0_this._x_3 = tmp0_this._x_3 - (pair1 * m._y_0._y_3 + pair2 * m._z_0._y_3 + pair5 * m._w_0._y_3);
    result._x_0._y_3 = pair1 * m._x_0._y_3 + pair6 * m._z_0._y_3 + pair9 * m._w_0._y_3;
    var tmp1_this = result._x_0;
    tmp1_this._y_3 = tmp1_this._y_3 - (pair0 * m._x_0._y_3 + pair7 * m._z_0._y_3 + pair8 * m._w_0._y_3);
    result._x_0._z_3 = pair2 * m._x_0._y_3 + pair7 * m._y_0._y_3 + pair10 * m._w_0._y_3;
    var tmp2_this = result._x_0;
    tmp2_this._z_3 = tmp2_this._z_3 - (pair3 * m._x_0._y_3 + pair6 * m._y_0._y_3 + pair11 * m._w_0._y_3);
    result._x_0._w_2 = pair5 * m._x_0._y_3 + pair8 * m._y_0._y_3 + pair11 * m._z_0._y_3;
    var tmp3_this = result._x_0;
    tmp3_this._w_2 = tmp3_this._w_2 - (pair4 * m._x_0._y_3 + pair9 * m._y_0._y_3 + pair10 * m._z_0._y_3);
    result._y_0._x_3 = pair1 * m._y_0._x_3 + pair2 * m._z_0._x_3 + pair5 * m._w_0._x_3;
    var tmp4_this = result._y_0;
    tmp4_this._x_3 = tmp4_this._x_3 - (pair0 * m._y_0._x_3 + pair3 * m._z_0._x_3 + pair4 * m._w_0._x_3);
    result._y_0._y_3 = pair0 * m._x_0._x_3 + pair7 * m._z_0._x_3 + pair8 * m._w_0._x_3;
    var tmp5_this = result._y_0;
    tmp5_this._y_3 = tmp5_this._y_3 - (pair1 * m._x_0._x_3 + pair6 * m._z_0._x_3 + pair9 * m._w_0._x_3);
    result._y_0._z_3 = pair3 * m._x_0._x_3 + pair6 * m._y_0._x_3 + pair11 * m._w_0._x_3;
    var tmp6_this = result._y_0;
    tmp6_this._z_3 = tmp6_this._z_3 - (pair2 * m._x_0._x_3 + pair7 * m._y_0._x_3 + pair10 * m._w_0._x_3);
    result._y_0._w_2 = pair4 * m._x_0._x_3 + pair9 * m._y_0._x_3 + pair10 * m._z_0._x_3;
    var tmp7_this = result._y_0;
    tmp7_this._w_2 = tmp7_this._w_2 - (pair5 * m._x_0._x_3 + pair8 * m._y_0._x_3 + pair11 * m._z_0._x_3);
    pair0 = m._z_0._x_3 * m._w_0._y_3;
    pair1 = m._w_0._x_3 * m._z_0._y_3;
    pair2 = m._y_0._x_3 * m._w_0._y_3;
    pair3 = m._w_0._x_3 * m._y_0._y_3;
    pair4 = m._y_0._x_3 * m._z_0._y_3;
    pair5 = m._z_0._x_3 * m._y_0._y_3;
    pair6 = m._x_0._x_3 * m._w_0._y_3;
    pair7 = m._w_0._x_3 * m._x_0._y_3;
    pair8 = m._x_0._x_3 * m._z_0._y_3;
    pair9 = m._z_0._x_3 * m._x_0._y_3;
    pair10 = m._x_0._x_3 * m._y_0._y_3;
    pair11 = m._y_0._x_3 * m._x_0._y_3;
    result._z_0._x_3 = pair0 * m._y_0._w_2 + pair3 * m._z_0._w_2 + pair4 * m._w_0._w_2;
    var tmp8_this = result._z_0;
    tmp8_this._x_3 = tmp8_this._x_3 - (pair1 * m._y_0._w_2 + pair2 * m._z_0._w_2 + pair5 * m._w_0._w_2);
    result._z_0._y_3 = pair1 * m._x_0._w_2 + pair6 * m._z_0._w_2 + pair9 * m._w_0._w_2;
    var tmp9_this = result._z_0;
    tmp9_this._y_3 = tmp9_this._y_3 - (pair0 * m._x_0._w_2 + pair7 * m._z_0._w_2 + pair8 * m._w_0._w_2);
    result._z_0._z_3 = pair2 * m._x_0._w_2 + pair7 * m._y_0._w_2 + pair10 * m._w_0._w_2;
    var tmp10_this = result._z_0;
    tmp10_this._z_3 = tmp10_this._z_3 - (pair3 * m._x_0._w_2 + pair6 * m._y_0._w_2 + pair11 * m._w_0._w_2);
    result._z_0._w_2 = pair5 * m._x_0._w_2 + pair8 * m._y_0._w_2 + pair11 * m._z_0._w_2;
    var tmp11_this = result._z_0;
    tmp11_this._w_2 = tmp11_this._w_2 - (pair4 * m._x_0._w_2 + pair9 * m._y_0._w_2 + pair10 * m._z_0._w_2);
    result._w_0._x_3 = pair2 * m._z_0._z_3 + pair5 * m._w_0._z_3 + pair1 * m._y_0._z_3;
    var tmp12_this = result._w_0;
    tmp12_this._x_3 = tmp12_this._x_3 - (pair4 * m._w_0._z_3 + pair0 * m._y_0._z_3 + pair3 * m._z_0._z_3);
    result._w_0._y_3 = pair8 * m._w_0._z_3 + pair0 * m._x_0._z_3 + pair7 * m._z_0._z_3;
    var tmp13_this = result._w_0;
    tmp13_this._y_3 = tmp13_this._y_3 - (pair6 * m._z_0._z_3 + pair9 * m._w_0._z_3 + pair1 * m._x_0._z_3);
    result._w_0._z_3 = pair6 * m._y_0._z_3 + pair11 * m._w_0._z_3 + pair3 * m._x_0._z_3;
    var tmp14_this = result._w_0;
    tmp14_this._z_3 = tmp14_this._z_3 - (pair10 * m._w_0._z_3 + pair2 * m._x_0._z_3 + pair7 * m._y_0._z_3);
    result._w_0._w_2 = pair10 * m._z_0._z_3 + pair4 * m._x_0._z_3 + pair9 * m._y_0._z_3;
    var tmp15_this = result._w_0;
    tmp15_this._w_2 = tmp15_this._w_2 - (pair8 * m._y_0._z_3 + pair11 * m._z_0._z_3 + pair5 * m._x_0._z_3);
    var determinant = m._x_0._x_3 * result._x_0._x_3 + m._y_0._x_3 * result._x_0._y_3 + m._z_0._x_3 * result._x_0._z_3 + m._w_0._x_3 * result._x_0._w_2;
    return result.div_29(determinant);
  }
  function scale(s) {
    var tmp = s._x_2;
    var tmp_0 = Float4_init_$Create$(tmp, 0.0, 0.0, 0.0, 14, null);
    var tmp_1 = s._y_2;
    var tmp_2 = Float4_init_$Create$(0.0, tmp_1, 0.0, 0.0, 13, null);
    var tmp_3 = s._z_2;
    var tmp_4 = Float4_init_$Create$(0.0, 0.0, tmp_3, 0.0, 11, null);
    return Mat4_init_$Create$(tmp_0, tmp_2, tmp_4, null, 8, null);
  }
  function rotation(m) {
    var tmp0__get_xyz__0_1 = m._x_0;
    var tmp = normalize(new Float3(tmp0__get_xyz__0_1._x_3, tmp0__get_xyz__0_1._y_3, tmp0__get_xyz__0_1._z_3));
    var tmp0__get_xyz__0_1_0 = m._y_0;
    var tmp_0 = normalize(new Float3(tmp0__get_xyz__0_1_0._x_3, tmp0__get_xyz__0_1_0._y_3, tmp0__get_xyz__0_1_0._z_3));
    var tmp0__get_xyz__0_1_1 = m._z_0;
    var tmp_1 = normalize(new Float3(tmp0__get_xyz__0_1_1._x_3, tmp0__get_xyz__0_1_1._y_3, tmp0__get_xyz__0_1_1._z_3));
    return Mat4_init_$Create$_0(tmp, tmp_0, tmp_1, null, 8, null);
  }
  function translation_0(m) {
    var tmp0__get_xyz__0_1 = m._w_0;
    return translation(new Float3(tmp0__get_xyz__0_1._x_3, tmp0__get_xyz__0_1._y_3, tmp0__get_xyz__0_1._z_3));
  }
  function scale_0(m) {
    var tmp0__get_xyz__0_2 = m._x_0;
    var tmp2_length_0_1 = new Float3(tmp0__get_xyz__0_2._x_3, tmp0__get_xyz__0_2._y_3, tmp0__get_xyz__0_2._z_3);
    var tmp1_sqrt_0_3 = tmp2_length_0_1._x_2 * tmp2_length_0_1._x_2 + tmp2_length_0_1._y_2 * tmp2_length_0_1._y_2 + tmp2_length_0_1._z_2 * tmp2_length_0_1._z_2;
    var tmp = Math.sqrt(tmp1_sqrt_0_3);
    var tmp3__get_xyz__0_5 = m._y_0;
    var tmp5_length_0_4 = new Float3(tmp3__get_xyz__0_5._x_3, tmp3__get_xyz__0_5._y_3, tmp3__get_xyz__0_5._z_3);
    var tmp4_sqrt_0_6 = tmp5_length_0_4._x_2 * tmp5_length_0_4._x_2 + tmp5_length_0_4._y_2 * tmp5_length_0_4._y_2 + tmp5_length_0_4._z_2 * tmp5_length_0_4._z_2;
    var tmp_0 = Math.sqrt(tmp4_sqrt_0_6);
    var tmp6__get_xyz__0_8 = m._z_0;
    var tmp8_length_0_7 = new Float3(tmp6__get_xyz__0_8._x_3, tmp6__get_xyz__0_8._y_3, tmp6__get_xyz__0_8._z_3);
    var tmp7_sqrt_0_9 = tmp8_length_0_7._x_2 * tmp8_length_0_7._x_2 + tmp8_length_0_7._y_2 * tmp8_length_0_7._y_2 + tmp8_length_0_7._z_2 * tmp8_length_0_7._z_2;
    return scale(new Float3(tmp, tmp_0, Math.sqrt(tmp7_sqrt_0_9)));
  }
  function lookAt(eye, target, up) {
    return lookTowards(eye, new Float3(target._x_2 - eye._x_2, target._y_2 - eye._y_2, target._z_2 - eye._z_2), up);
  }
  function perspective(fov, aspect, near, far) {
    var tmp0_tan_0 = fov * 0.01745329277777778 * 0.5;
    var f = 1.0 / Math.tan(tmp0_tan_0);
    var tmp = f / aspect;
    var tmp_0 = Float4_init_$Create$(tmp, 0.0, 0.0, 0.0, 14, null);
    var tmp_1 = Float4_init_$Create$(0.0, f, 0.0, 0.0, 13, null);
    var tmp_2 = Float4_init_$Create$(0.0, 0.0, (far + near) / (near - far), -1.0, 3, null);
    var tmp_3 = 2.0 * (far * near) / (near - far);
    return new Mat4(tmp_0, tmp_1, tmp_2, Float4_init_$Create$(0.0, 0.0, tmp_3, 0.0, 11, null));
  }
  function ortho(l, r, b, t, n, f) {
    var tmp = 2.0 / (r - l);
    var tmp_0 = Float4_init_$Create$(tmp, 0.0, 0.0, 0.0, 14, null);
    var tmp_1 = 2.0 / (t - b);
    var tmp_2 = Float4_init_$Create$(0.0, tmp_1, 0.0, 0.0, 13, null);
    var tmp_3 = -2.0 / (f - n);
    return new Mat4(tmp_0, tmp_2, Float4_init_$Create$(0.0, 0.0, tmp_3, 0.0, 11, null), new Float4(-(r + l) / (r - l), -(t + b) / (t - b), -(f + n) / (f - n), 1.0));
  }
  function transpose(m) {
    return new Mat4(new Float4(m._x_0._x_3, m._y_0._x_3, m._z_0._x_3, m._w_0._x_3), new Float4(m._x_0._y_3, m._y_0._y_3, m._z_0._y_3, m._w_0._y_3), new Float4(m._x_0._z_3, m._y_0._z_3, m._z_0._z_3, m._w_0._z_3), new Float4(m._x_0._w_2, m._y_0._w_2, m._z_0._w_2, m._w_0._w_2));
  }
  function lookTowards(eye, direction, up) {
    var f = normalize(direction);
    var r = normalize(new Float3(f._y_2 * up._z_2 - f._z_2 * up._y_2, f._z_2 * up._x_2 - f._x_2 * up._z_2, f._x_2 * up._y_2 - f._y_2 * up._x_2));
    var u = new Float3(r._y_2 * f._z_2 - r._z_2 * f._y_2, r._z_2 * f._x_2 - r._x_2 * f._z_2, r._x_2 * f._y_2 - r._y_2 * f._x_2);
    var tmp = new Float4(r._x_2, u._x_2, -f._x_2, 0.0);
    var tmp_0 = new Float4(r._y_2, u._y_2, -f._y_2, 0.0);
    var tmp_1 = new Float4(r._z_2, u._z_2, -f._z_2, 0.0);
    var tmp_2 = -(r._x_2 * eye._x_2 + r._y_2 * eye._y_2 + r._z_2 * eye._z_2);
    var tmp_3 = -(u._x_2 * eye._x_2 + u._y_2 * eye._y_2 + u._z_2 * eye._z_2);
    return new Mat4(tmp, tmp_0, tmp_1, new Float4(tmp_2, tmp_3, f._x_2 * eye._x_2 + f._y_2 * eye._y_2 + f._z_2 * eye._z_2, 1.0));
  }
  function Mat4_init_$Init$(x, y, z, w, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      x = Float4_init_$Create$(1.0, 0.0, 0.0, 0.0, 14, null);
    }if (!(($mask0 & 2) === 0)) {
      y = Float4_init_$Create$(0.0, 1.0, 0.0, 0.0, 13, null);
    }if (!(($mask0 & 4) === 0)) {
      z = Float4_init_$Create$(0.0, 0.0, 1.0, 0.0, 11, null);
    }if (!(($mask0 & 8) === 0)) {
      w = Float4_init_$Create$(0.0, 0.0, 0.0, 1.0, 7, null);
    }Mat4.call($this, x, y, z, w);
    return $this;
  }
  function Mat4_init_$Create$(x, y, z, w, $mask0, $marker) {
    return Mat4_init_$Init$(x, y, z, w, $mask0, $marker, Object.create(Mat4.prototype));
  }
  function Mat4_init_$Init$_0(right, up, forward, position, $this) {
    var tmp = Float4_init_$Create$_1(right, 0.0, 2, null);
    var tmp_0 = Float4_init_$Create$_1(up, 0.0, 2, null);
    Mat4.call($this, tmp, tmp_0, Float4_init_$Create$_1(forward, 0.0, 2, null), Float4_init_$Create$_0(position, 1.0));
    return $this;
  }
  function Mat4_init_$Init$_1(right, up, forward, position, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0)) {
      position = Float3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    }Mat4_init_$Init$_0(right, up, forward, position, $this);
    return $this;
  }
  function Mat4_init_$Create$_0(right, up, forward, position, $mask0, $marker) {
    return Mat4_init_$Init$_1(right, up, forward, position, $mask0, $marker, Object.create(Mat4.prototype));
  }
  function Companion_11() {
    Companion_instance_10 = this;
  }
  Companion_11.prototype.fromColumnMajor = function (a) {
    var tmp0_require_0 = a.length >= 16;
    if (!tmp0_require_0) {
      var message_1_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_1));
    }return new Mat4(new Float4(a[0], a[1], a[2], a[3]), new Float4(a[4], a[5], a[6], a[7]), new Float4(a[8], a[9], a[10], a[11]), new Float4(a[12], a[13], a[14], a[15]));
  };
  Companion_11.prototype.identity_0 = function () {
    return Mat4_init_$Create$(null, null, null, null, 15, null);
  };
  Companion_11.prototype.from = function (quaternion) {
    var xx_2 = quaternion._x_1 * quaternion._x_1;
    var xy_3 = quaternion._x_1 * quaternion._y_1;
    var xz_4 = quaternion._x_1 * quaternion._z_1;
    var xw_5 = quaternion._x_1 * quaternion._w_1;
    var yy_6 = quaternion._y_1 * quaternion._y_1;
    var yz_7 = quaternion._y_1 * quaternion._z_1;
    var yw_8 = quaternion._y_1 * quaternion._w_1;
    var zz_9 = quaternion._z_1 * quaternion._z_1;
    var zw_10 = quaternion._z_1 * quaternion._w_1;
    var mx_11 = new Float4(1.0 - 2.0 * (yy_6 + zz_9), 2.0 * (xy_3 - zw_10), 2.0 * (xz_4 + yw_8), 0.0);
    var my_12 = new Float4(2.0 * (xy_3 + zw_10), 1.0 - 2.0 * (xx_2 + zz_9), 2.0 * (yz_7 - xw_5), 0.0);
    var mz_13 = new Float4(2.0 * (xz_4 - yw_8), 2.0 * (yz_7 + xw_5), 1.0 - 2.0 * (xx_2 + yy_6), 0.0);
    var mw_14 = new Float4(0.0, 0.0, 0.0, 1.0);
    return transpose(new Mat4(mx_11, my_12, mz_13, mw_14));
  };
  Companion_11.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_11();
    return Companion_instance_10;
  }
  function Quaternion(x, y, z, w) {
    this._x_1 = x;
    this._y_1 = y;
    this._z_1 = z;
    this._w_1 = w;
  }
  Quaternion.prototype.toEulerAngles = function () {
    var sinrCosp = 2.0 * (this._w_1 * this._x_1 + this._y_1 * this._z_1);
    var cosrCosp = 1.0 - 2.0 * (this._x_1 * this._x_1 + this._y_1 * this._y_1);
    var roll = Math.atan2(sinrCosp, cosrCosp);
    var sinp = 2.0 * (this._w_1 * this._y_1 - this._z_1 * this._x_1);
    var tmp;
    if (Math.abs(sinp) >= 1.0) {
      tmp = 1.57079635 * Math.sign(sinp);
    } else {
      {
        tmp = Math.asin(sinp);
      }
    }
    var pitch = tmp;
    var sinyCosp = 2.0 * (this._w_1 * this._z_1 + this._x_1 * this._y_1);
    var cosyCosp = 1.0 - 2.0 * (this._y_1 * this._y_1 + this._z_1 * this._z_1);
    var yaw = Math.atan2(sinyCosp, cosyCosp);
    return new Float3(roll, pitch, yaw);
  };
  Quaternion.prototype.toString = function () {
    return '' + '(' + this._x_1 + ' ' + this._y_1 + ' ' + this._z_1 + ' ' + this._w_1 + ')';
  };
  Quaternion.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_1);
    result = imul(result, 31) + getNumberHashCode(this._y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._w_1) | 0;
    return result;
  };
  Quaternion.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Quaternion))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Quaternion ? other : THROW_CCE();
    if (!equals_1(this._x_1, tmp0_other_with_cast._x_1))
      return false;
    if (!equals_1(this._y_1, tmp0_other_with_cast._y_1))
      return false;
    if (!equals_1(this._z_1, tmp0_other_with_cast._z_1))
      return false;
    if (!equals_1(this._w_1, tmp0_other_with_cast._w_1))
      return false;
    return true;
  };
  Quaternion.$metadata$ = {
    simpleName: 'Quaternion',
    kind: 'class',
    interfaces: []
  };
  function Companion_12() {
    Companion_instance_11 = this;
  }
  Companion_12.prototype.identity_0 = function () {
    return new Quaternion(0.0, 0.0, 0.0, 1.0);
  };
  Companion_12.prototype.from_0 = function (m2) {
    var m = transpose(m2);
    var tr = m._x_0._x_3 + m._y_0._y_3 + m._z_0._z_3;
    var tmp;
    if (tr > 0) {
      var tmp0_sqrt_0 = tr + 1.0;
      var s = Math.sqrt(tmp0_sqrt_0);
      var qw = s * 0.5;
      s = 0.5 / s;
      var qx = (m._z_0._y_3 - m._y_0._z_3) * s;
      var qy = (m._x_0._z_3 - m._z_0._x_3) * s;
      var qz = (m._y_0._x_3 - m._x_0._y_3) * s;
      tmp = new Quaternion(qx, qy, qz, qw);
    } else if (m._x_0._x_3 > m._y_0._y_3 ? m._x_0._x_3 > m._z_0._z_3 : false) {
      var tmp1_sqrt_0 = 1.0 + m._x_0._x_3 - m._y_0._y_3 - m._z_0._z_3;
      var s_0 = Math.sqrt(tmp1_sqrt_0);
      var qx_0 = s_0 * 0.5;
      s_0 = 0.5 / s_0;
      var qy_0 = (m._y_0._x_3 + m._x_0._y_3) * s_0;
      var qz_0 = (m._x_0._z_3 + m._z_0._x_3) * s_0;
      var qw_0 = (m._z_0._y_3 - m._y_0._z_3) * s_0;
      tmp = new Quaternion(qx_0, qy_0, qz_0, qw_0);
    } else if (m._y_0._y_3 > m._z_0._z_3) {
      var tmp2_sqrt_0 = 1.0 + m._y_0._y_3 - m._x_0._x_3 - m._z_0._z_3;
      var s_1 = Math.sqrt(tmp2_sqrt_0);
      var qy_1 = s_1 * 0.5;
      s_1 = 0.5 / s_1;
      var qx_1 = (m._y_0._x_3 + m._x_0._y_3) * s_1;
      var qz_1 = (m._y_0._z_3 + m._z_0._y_3) * s_1;
      var qw_1 = (m._x_0._z_3 - m._z_0._x_3) * s_1;
      tmp = new Quaternion(qx_1, qy_1, qz_1, qw_1);
    } else {
      var tmp3_sqrt_0 = 1.0 + m._z_0._z_3 - m._x_0._x_3 - m._y_0._y_3;
      var s_2 = Math.sqrt(tmp3_sqrt_0);
      var qz_2 = s_2 * 0.5;
      s_2 = 0.5 / s_2;
      var qx_2 = (m._x_0._z_3 + m._z_0._x_3) * s_2;
      var qy_2 = (m._z_0._y_3 + m._y_0._z_3) * s_2;
      var qw_2 = (m._y_0._x_3 - m._x_0._y_3) * s_2;
      tmp = new Quaternion(qx_2, qy_2, qz_2, qw_2);
    }
    return tmp;
  };
  Companion_12.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_12();
    return Companion_instance_11;
  }
  function Float3(x, y, z) {
    this._x_2 = x;
    this._y_2 = y;
    this._z_2 = z;
  }
  Float3.prototype.toString = function () {
    return '' + 'Float3(x=' + this._x_2 + ', y=' + this._y_2 + ', z=' + this._z_2 + ')';
  };
  Float3.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_2);
    result = imul(result, 31) + getNumberHashCode(this._y_2) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_2) | 0;
    return result;
  };
  Float3.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Float3))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Float3 ? other : THROW_CCE();
    if (!equals_1(this._x_2, tmp0_other_with_cast._x_2))
      return false;
    if (!equals_1(this._y_2, tmp0_other_with_cast._y_2))
      return false;
    if (!equals_1(this._z_2, tmp0_other_with_cast._z_2))
      return false;
    return true;
  };
  Float3.$metadata$ = {
    simpleName: 'Float3',
    kind: 'class',
    interfaces: []
  };
  function Float4(x, y, z, w) {
    this._x_3 = x;
    this._y_3 = y;
    this._z_3 = z;
    this._w_2 = w;
  }
  Float4.prototype.toString = function () {
    return '' + 'Float4(x=' + this._x_3 + ', y=' + this._y_3 + ', z=' + this._z_3 + ', w=' + this._w_2 + ')';
  };
  Float4.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_3);
    result = imul(result, 31) + getNumberHashCode(this._y_3) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_3) | 0;
    result = imul(result, 31) + getNumberHashCode(this._w_2) | 0;
    return result;
  };
  Float4.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Float4))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Float4 ? other : THROW_CCE();
    if (!equals_1(this._x_3, tmp0_other_with_cast._x_3))
      return false;
    if (!equals_1(this._y_3, tmp0_other_with_cast._y_3))
      return false;
    if (!equals_1(this._z_3, tmp0_other_with_cast._z_3))
      return false;
    if (!equals_1(this._w_2, tmp0_other_with_cast._w_2))
      return false;
    return true;
  };
  Float4.$metadata$ = {
    simpleName: 'Float4',
    kind: 'class',
    interfaces: []
  };
  function normalize(v) {
    var tmp0_sqrt_0_1 = v._x_2 * v._x_2 + v._y_2 * v._y_2 + v._z_2 * v._z_2;
    var l = 1.0 / Math.sqrt(tmp0_sqrt_0_1);
    return new Float3(v._x_2 * l, v._y_2 * l, v._z_2 * l);
  }
  function Float3_init_$Init$(x, y, z, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    if (!(($mask0 & 4) === 0))
      z = 0.0;
    Float3.call($this, x, y, z);
    return $this;
  }
  function Float3_init_$Create$(x, y, z, $mask0, $marker) {
    return Float3_init_$Init$(x, y, z, $mask0, $marker, Object.create(Float3.prototype));
  }
  function Float4_init_$Init$(x, y, z, w, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    if (!(($mask0 & 4) === 0))
      z = 0.0;
    if (!(($mask0 & 8) === 0))
      w = 0.0;
    Float4.call($this, x, y, z, w);
    return $this;
  }
  function Float4_init_$Create$(x, y, z, w, $mask0, $marker) {
    return Float4_init_$Init$(x, y, z, w, $mask0, $marker, Object.create(Float4.prototype));
  }
  function Float4_init_$Init$_0(v, w, $this) {
    Float4.call($this, v._x_2, v._y_2, v._z_2, w);
    return $this;
  }
  function Float4_init_$Create$_0(v, w) {
    return Float4_init_$Init$_0(v, w, Object.create(Float4.prototype));
  }
  function Float4_init_$Init$_1(v, w, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      w = 0.0;
    Float4_init_$Init$_0(v, w, $this);
    return $this;
  }
  function Float4_init_$Create$_1(v, w, $mask0, $marker) {
    return Float4_init_$Init$_1(v, w, $mask0, $marker, Object.create(Float4.prototype));
  }
  function KSerializer() {
  }
  KSerializer.$metadata$ = {
    simpleName: 'KSerializer',
    kind: 'interface',
    interfaces: [SerializationStrategy, DeserializationStrategy]
  };
  function DeserializationStrategy() {
  }
  DeserializationStrategy.$metadata$ = {
    simpleName: 'DeserializationStrategy',
    kind: 'interface',
    interfaces: []
  };
  function SerializationStrategy() {
  }
  SerializationStrategy.$metadata$ = {
    simpleName: 'SerializationStrategy',
    kind: 'interface',
    interfaces: []
  };
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this._baseClass = baseClass;
    var tmp = this;
    var tmp_0 = OPEN_getInstance();
    var tmp_1 = [];
    tmp._descriptor = withContext(buildSerialDescriptor$default('kotlinx.serialization.Polymorphic', tmp_0, tmp_1, _no_name_provided_$factory_38(this), 4, null), this._baseClass);
  }
  PolymorphicSerializer.prototype._get_baseClass__0 = function () {
    return this._baseClass;
  };
  PolymorphicSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor;
  };
  PolymorphicSerializer.prototype.toString = function () {
    return '' + 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + this._baseClass + ')';
  };
  PolymorphicSerializer.$metadata$ = {
    simpleName: 'PolymorphicSerializer',
    kind: 'class',
    interfaces: []
  };
  function findPolymorphicSerializer(_this_, decoder, klassName) {
    var tmp0_elvis_lhs = _this_.findPolymorphicSerializerOrNull_0(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(klassName, _this_._get_baseClass__0());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _no_name_provided_$factory_38(this$0) {
    var i = new _no_name_provided__58(this$0);
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__58(this$0) {
    this._this$0_16 = this$0;
  }
  _no_name_provided__58.prototype.invoke_107 = function (_this__0) {
    var tmp = serializer_1(StringCompanionObject_getInstance())._get_descriptor__68();
    _this__0.element$default('type', tmp, null, false, 12, null);
    var tmp_0 = '' + 'kotlinx.serialization.Polymorphic<' + this._this$0_16._baseClass._get_simpleName__4() + '>';
    var tmp_1 = CONTEXTUAL_getInstance();
    var tmp_2 = [];
    var tmp_3 = buildSerialDescriptor$default(tmp_0, tmp_1, tmp_2, null, 12, null);
    _this__0.element$default('value', tmp_3, null, false, 12, null);
  };
  _no_name_provided__58.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BinaryFormat() {
  }
  BinaryFormat.$metadata$ = {
    simpleName: 'BinaryFormat',
    kind: 'interface',
    interfaces: [SerialFormat]
  };
  function StringFormat() {
  }
  StringFormat.$metadata$ = {
    simpleName: 'StringFormat',
    kind: 'interface',
    interfaces: [SerialFormat]
  };
  function SerialFormat() {
  }
  SerialFormat.$metadata$ = {
    simpleName: 'SerialFormat',
    kind: 'interface',
    interfaces: []
  };
  function UnknownFieldException(index) {
    SerializationException_init_$Init$('' + 'An unknown field for index ' + index, this);
    captureStack(this, UnknownFieldException);
  }
  UnknownFieldException.$metadata$ = {
    simpleName: 'UnknownFieldException',
    kind: 'class',
    interfaces: []
  };
  function MissingFieldException(fieldName) {
    SerializationException_init_$Init$('' + "Field '" + fieldName + "' is required, but it was missing", this);
    captureStack(this, MissingFieldException);
  }
  MissingFieldException.$metadata$ = {
    simpleName: 'MissingFieldException',
    kind: 'class',
    interfaces: []
  };
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  SerializationException.$metadata$ = {
    simpleName: 'SerializationException',
    kind: 'class',
    interfaces: []
  };
  function SerializationException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$(message) {
    var tmp = SerializationException_init_$Init$(message, Object.create(SerializationException.prototype));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function serializer(type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(EmptySerializersModule, type);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    return nullable(result, type._get_isMarkedNullable__0());
  }
  function serializer_0(_this_, type) {
    var kclass_0 = kclass(type);
    var isNullable = type._get_isMarkedNullable__0();
    var builtin = serializerByKTypeImpl(_this_, type);
    if (!(builtin == null)) {
      var tmp0_cast_0 = nullable(builtin, isNullable);
      return isInterface(tmp0_cast_0, KSerializer) ? tmp0_cast_0 : THROW_CCE();
    }var tmp0_safe_receiver = _this_.getContextual_0(kclass_0);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : nullable(tmp0_safe_receiver, isNullable);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = (!(tmp1_safe_receiver == null) ? isInterface(tmp1_safe_receiver, KSerializer) : false) ? tmp1_safe_receiver : THROW_CCE();
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  function serializerByKTypeImpl(_this_, type) {
    var rootClass = kclass(type);
    var tmp0_map_0 = type._get_arguments__0();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_requireNotNull_0_5 = item_2_3._type;
        if (tmp0_requireNotNull_0_5 == null) {
          var message_1_6 = '' + 'Star projections in type arguments are not allowed, but had ' + type;
          throw IllegalArgumentException_init_$Create$(toString_1(message_1_6));
        } else {
          tmp$ret$0 = tmp0_requireNotNull_0_5;
          break l$ret$1;
        }
      }
       while (false);
      tmp0_mapTo_0_1.add_19(tmp$ret$0);
      Unit_getInstance();
    }
    var typeArguments = tmp0_mapTo_0_1;
    var tmp;
    if (typeArguments.isEmpty_35()) {
      var tmp0_elvis_lhs = serializerOrNull(rootClass);
      tmp = tmp0_elvis_lhs == null ? _this_.getContextual_0(rootClass) : tmp0_elvis_lhs;
    } else {
      tmp = builtinSerializerOrNull(_this_, typeArguments, rootClass);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = (!(tmp1_safe_receiver == null) ? isInterface(tmp1_safe_receiver, KSerializer) : false) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp_0;
  }
  function nullable(_this_, shouldBeNullable) {
    if (shouldBeNullable)
      return _get_nullable_(_this_);
    return isInterface(_this_, KSerializer) ? _this_ : THROW_CCE();
  }
  function serializerOrNull(_this_) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this_);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull_0(_this_) : tmp0_elvis_lhs;
  }
  function builtinSerializerOrNull(_this_, typeArguments, rootClass) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
    var tmp0_iterator_1_2 = typeArguments.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      tmp0_mapTo_0_1.add_19(serializer_0(_this_, item_2_3));
      Unit_getInstance();
    }
    var serializers = tmp0_mapTo_0_1;
    var tmp0_subject = rootClass;
    var tmp;
    if ((tmp0_subject.equals(getKClass_0(List)) ? true : tmp0_subject.equals(getKClass_0(MutableList))) ? true : tmp0_subject.equals(getKClass_0(ArrayList))) {
      tmp = new ArrayListSerializer(serializers.get_57(0));
    } else if (tmp0_subject.equals(getKClass_0(HashSet))) {
      tmp = new HashSetSerializer(serializers.get_57(0));
    } else if ((tmp0_subject.equals(getKClass_0(Set)) ? true : tmp0_subject.equals(getKClass_0(MutableSet))) ? true : tmp0_subject.equals(getKClass_0(LinkedHashSet))) {
      tmp = new LinkedHashSetSerializer(serializers.get_57(0));
    } else if (tmp0_subject.equals(getKClass_0(HashMap))) {
      tmp = new HashMapSerializer(serializers.get_57(0), serializers.get_57(1));
    } else if ((tmp0_subject.equals(getKClass_0(Map_0)) ? true : tmp0_subject.equals(getKClass_0(MutableMap))) ? true : tmp0_subject.equals(getKClass_0(LinkedHashMap))) {
      tmp = new LinkedHashMapSerializer(serializers.get_57(0), serializers.get_57(1));
    } else if (tmp0_subject.equals(getKClass_0(Entry))) {
      tmp = MapEntrySerializer(serializers.get_57(0), serializers.get_57(1));
    } else if (tmp0_subject.equals(getKClass_0(Pair))) {
      tmp = PairSerializer(serializers.get_57(0), serializers.get_57(1));
    } else if (tmp0_subject.equals(getKClass_0(Triple))) {
      tmp = TripleSerializer(serializers.get_57(0), serializers.get_57(1), serializers.get_57(2));
    } else {
      if (isReferenceArray(rootClass)) {
        var tmp_0 = typeArguments.get_57(0)._get_classifier__0();
        var tmp0_cast_0 = ArraySerializer((!(tmp_0 == null) ? isInterface(tmp_0, KClass) : false) ? tmp_0 : THROW_CCE(), serializers.get_57(0));
        return isInterface(tmp0_cast_0, KSerializer) ? tmp0_cast_0 : THROW_CCE();
      }var tmp$ret$0;
      l$ret$1: do {
        var tmp1_requireNotNull_0 = constructSerializerForGivenTypeArgs(rootClass, copyToArray_0(serializers).slice());
        if (tmp1_requireNotNull_0 == null) {
          var message_1 = '' + "Can't find a method to construct serializer for type " + rootClass._get_simpleName__4() + '. ' + 'Make sure this class is marked as @Serializable or provide serializer explicitly.';
          throw IllegalArgumentException_init_$Create$(toString_1(message_1));
        } else {
          tmp$ret$0 = tmp1_requireNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function serializer_1(_this_) {
    return StringSerializer_getInstance();
  }
  function serializer_2(_this_) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_3(_this_) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_4(_this_) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_5(_this_) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_6(_this_) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_7(_this_) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_8(_this_) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_9(_this_) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_10(_this_) {
    return UnitSerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function _get_nullable_(_this_) {
    var tmp;
    if (_this_._get_descriptor__68()._get_isNullable__16()) {
      tmp = isInterface(_this_, KSerializer) ? _this_ : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this_);
    }
    return tmp;
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function withContext(_this_, context) {
    return new ContextDescriptor(_this_, context);
  }
  function ContextDescriptor(original, kClass) {
    this._original = original;
    this._kClass = kClass;
    this._serialName = '' + this._original._get_serialName__16() + '<' + this._kClass._get_simpleName__4() + '>';
  }
  ContextDescriptor.prototype.getElementAnnotations_16 = function (index) {
    return this._original.getElementAnnotations_16(index);
  };
  ContextDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return this._original.getElementDescriptor_16(index);
  };
  ContextDescriptor.prototype.getElementIndex_16 = function (name) {
    return this._original.getElementIndex_16(name);
  };
  ContextDescriptor.prototype.getElementName_16 = function (index) {
    return this._original.getElementName_16(index);
  };
  ContextDescriptor.prototype._get_elementsCount__16 = function () {
    return this._original._get_elementsCount__16();
  };
  ContextDescriptor.prototype._get_isNullable__16 = function () {
    return this._original._get_isNullable__16();
  };
  ContextDescriptor.prototype._get_kind__16 = function () {
    return this._original._get_kind__16();
  };
  ContextDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName;
  };
  ContextDescriptor.prototype.equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals_1(this._original, another._original) ? another._kClass.equals(this._kClass) : false;
  };
  ContextDescriptor.prototype.hashCode = function () {
    var result = this._kClass.hashCode();
    result = imul(31, result) + getStringHashCode(this._serialName) | 0;
    return result;
  };
  ContextDescriptor.prototype.toString = function () {
    return '' + 'ContextDescriptor(kClass: ' + this._kClass + ', original: ' + this._original + ')';
  };
  ContextDescriptor.$metadata$ = {
    simpleName: 'ContextDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function SerialDescriptor() {
  }
  SerialDescriptor.prototype._get_isNullable__16 = function () {
    return false;
  };
  SerialDescriptor.$metadata$ = {
    simpleName: 'SerialDescriptor',
    kind: 'interface',
    interfaces: []
  };
  function _get_elementDescriptors_(_this_) {
    return new _no_name_provided__1_2(_this_);
  }
  function _no_name_provided__59($this_elementDescriptors) {
    this._$this_elementDescriptors = $this_elementDescriptors;
    this._elementsLeft = this._$this_elementDescriptors._get_elementsCount__16();
  }
  _no_name_provided__59.prototype.hasNext_27 = function () {
    return this._elementsLeft > 0;
  };
  _no_name_provided__59.prototype.next_30 = function () {
    var tmp = this._$this_elementDescriptors._get_elementsCount__16();
    var tmp0_this = this;
    var tmp1 = tmp0_this._elementsLeft;
    tmp0_this._elementsLeft = tmp1 - 1 | 0;
    return this._$this_elementDescriptors.getElementDescriptor_16(tmp - tmp1 | 0);
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function _no_name_provided__1_2($this_elementDescriptors) {
    this._$this_elementDescriptors_0 = $this_elementDescriptors;
  }
  _no_name_provided__1_2.prototype.iterator_2_1 = function () {
    return new _no_name_provided__59(this._$this_elementDescriptors_0);
  };
  _no_name_provided__1_2.prototype.iterator_52 = function () {
    return this.iterator_2_1();
  };
  _no_name_provided__1_2.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp0_require_0 = !isBlank(serialName);
    if (!tmp0_require_0) {
      var message_1 = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = !equals_1(kind, CLASS_getInstance());
    if (!tmp1_require_0) {
      var message_1_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder._elementNames._get_size__32(), toList(typeParameters), sdBuilder);
  }
  function buildSerialDescriptor$default(serialName, kind, typeParameters, builder, $mask0, $handler) {
    if (!(($mask0 & 8) === 0)) {
      builder = _no_name_provided_$factory_39();
    }return buildSerialDescriptor(serialName, kind, typeParameters, builder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this._serialName_0 = serialName;
    this._isNullable = false;
    this._annotations = emptyList();
    this._elementNames = ArrayList_init_$Create$();
    this._uniqueNames = HashSet_init_$Create$();
    this._elementDescriptors = ArrayList_init_$Create$();
    this._elementAnnotations = ArrayList_init_$Create$();
    this._elementOptionality = ArrayList_init_$Create$();
  }
  ClassSerialDescriptorBuilder.prototype.element = function (elementName, descriptor, annotations, isOptional) {
    var tmp0_require_0 = this._uniqueNames.add_19(elementName);
    if (!tmp0_require_0) {
      var message_1 = '' + "Element with name '" + elementName + "' is already registered";
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp0_this = this;
    var tmp1_plusAssign_0 = tmp0_this._elementNames;
    tmp1_plusAssign_0.add_19(elementName);
    Unit_getInstance();
    var tmp1_this = this;
    var tmp2_plusAssign_0 = tmp1_this._elementDescriptors;
    tmp2_plusAssign_0.add_19(descriptor);
    Unit_getInstance();
    var tmp2_this = this;
    var tmp3_plusAssign_0 = tmp2_this._elementAnnotations;
    tmp3_plusAssign_0.add_19(annotations);
    Unit_getInstance();
    var tmp3_this = this;
    var tmp4_plusAssign_0 = tmp3_this._elementOptionality;
    tmp4_plusAssign_0.add_19(isOptional);
    Unit_getInstance();
  };
  ClassSerialDescriptorBuilder.prototype.element$default = function (elementName, descriptor, annotations, isOptional, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      annotations = emptyList();
    if (!(($mask0 & 8) === 0))
      isOptional = false;
    return this.element(elementName, descriptor, annotations, isOptional);
  };
  ClassSerialDescriptorBuilder.$metadata$ = {
    simpleName: 'ClassSerialDescriptorBuilder',
    kind: 'class',
    interfaces: []
  };
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this._serialName_1 = serialName;
    this._kind = kind;
    this._elementsCount = elementsCount;
    this._annotations_0 = builder._annotations;
    var tmp = this;
    var tmp0_toTypedArray_0 = builder._elementNames;
    tmp._elementNames_0 = copyToArray_0(tmp0_toTypedArray_0);
    this._elementDescriptors_0 = compactArray(builder._elementDescriptors);
    var tmp_0 = this;
    var tmp0_toTypedArray_0_0 = builder._elementAnnotations;
    tmp_0._elementAnnotations_0 = copyToArray_0(tmp0_toTypedArray_0_0);
    this._elementOptionality_0 = toBooleanArray(builder._elementOptionality);
    var tmp_1 = this;
    var tmp0_map_0 = withIndex(this._elementNames_0);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      tmp0_mapTo_0_1.add_19(to(item_2_3._value, item_2_3._index_0));
      Unit_getInstance();
    }
    tmp_1._name2Index = toMap(tmp0_mapTo_0_1);
    this._typeParametersDescriptors = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.__hashCode$delegate = lazy(_no_name_provided_$factory_40(this));
  }
  SerialDescriptorImpl.prototype._get_serialName__16 = function () {
    return this._serialName_1;
  };
  SerialDescriptorImpl.prototype._get_kind__16 = function () {
    return this._kind;
  };
  SerialDescriptorImpl.prototype._get_elementsCount__16 = function () {
    return this._elementsCount;
  };
  SerialDescriptorImpl.prototype.getElementName_16 = function (index) {
    return getChecked(this._elementNames_0, index);
  };
  SerialDescriptorImpl.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = this._name2Index.get_27(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  SerialDescriptorImpl.prototype.getElementAnnotations_16 = function (index) {
    return getChecked(this._elementAnnotations_0, index);
  };
  SerialDescriptorImpl.prototype.getElementDescriptor_16 = function (index) {
    return getChecked(this._elementDescriptors_0, index);
  };
  SerialDescriptorImpl.prototype.equals = function (other) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this === other) {
        tmp$ret$0 = true;
        break l$ret$1;
      }if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_serialName__16() === other._get_serialName__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var tmp0__anonymous__3 = other;
      if (!contentEquals(this._typeParametersDescriptors, tmp0__anonymous__3._typeParametersDescriptors)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_elementsCount__16() === other._get_elementsCount__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var untilArg = this._get_elementsCount__16();
      var inductionVariable = 0;
      var last_2 = untilArg - 1 | 0;
      if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.getElementDescriptor_16(index_2)._get_serialName__16() === other.getElementDescriptor_16(index_2)._get_serialName__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }if (!equals_1(this.getElementDescriptor_16(index_2)._get_kind__16(), other.getElementDescriptor_16(index_2)._get_kind__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }}
         while (inductionVariable <= last_2);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  SerialDescriptorImpl.prototype.hashCode = function () {
    return _get__hashCode_(this);
  };
  SerialDescriptorImpl.prototype.toString = function () {
    var tmp = until(0, this._elementsCount);
    var tmp_0 = '' + this._serialName_1 + '(';
    return joinToString$default_0(tmp, ', ', tmp_0, ')', 0, null, _no_name_provided_$factory_41(this), 24, null);
  };
  SerialDescriptorImpl.$metadata$ = {
    simpleName: 'SerialDescriptorImpl',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp0_require_0 = !isBlank(serialName);
    if (!tmp0_require_0) {
      var message_1 = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder._elementNames._get_size__32(), toList(typeParameters), sdBuilder);
  }
  function buildClassSerialDescriptor$default(serialName, typeParameters, builderAction, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      builderAction = _no_name_provided_$factory_42();
    }return buildClassSerialDescriptor(serialName, typeParameters, builderAction);
  }
  function PrimitiveSerialDescriptor(serialName, kind) {
    var tmp0_require_0 = !isBlank(serialName);
    if (!tmp0_require_0) {
      var message_1 = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return PrimitiveDescriptorSafe(serialName, kind);
  }
  function _no_name_provided__60() {
  }
  _no_name_provided__60.prototype.invoke_107 = function (_this__0) {
    return Unit_getInstance();
  };
  _no_name_provided__60.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__61() {
  }
  _no_name_provided__61.prototype.invoke_107 = function (_this__0) {
    return Unit_getInstance();
  };
  _no_name_provided__61.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_39() {
    var i = new _no_name_provided__60();
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_40(this$0) {
    var i = new _no_name_provided__62(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_41(this$0) {
    var i = new _no_name_provided__63(this$0);
    return function (p1) {
      return i.invoke_113(p1);
    };
  }
  function _no_name_provided_$factory_42() {
    var i = new _no_name_provided__61();
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _get__hashCode_($this) {
    var tmp0_getValue_0 = $this.__hashCode$delegate;
    var tmp1_getValue_0 = _hashCode$factory();
    return tmp0_getValue_0._get_value__12();
  }
  function _no_name_provided__62(this$0) {
    this._this$0_17 = this$0;
  }
  _no_name_provided__62.prototype.invoke_274 = function () {
    return hashCodeImpl(this._this$0_17, this._this$0_17._typeParametersDescriptors);
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__63(this$0) {
    this._this$0_18 = this$0;
  }
  _no_name_provided__63.prototype.invoke_113 = function (it) {
    return this._this$0_18.getElementName_16(it) + ': ' + this._this$0_18.getElementDescriptor_16(it)._get_serialName__16();
  };
  _no_name_provided__63.prototype.invoke_276 = function (p1) {
    return this.invoke_113((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SerialKind() {
  }
  SerialKind.prototype.toString = function () {
    return ensureNotNull(getKClassFromExpression_0(this)._get_simpleName__4());
  };
  SerialKind.prototype.hashCode = function () {
    return getStringHashCode(this.toString());
  };
  SerialKind.$metadata$ = {
    simpleName: 'SerialKind',
    kind: 'class',
    interfaces: []
  };
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  PrimitiveKind.$metadata$ = {
    simpleName: 'PrimitiveKind',
    kind: 'class',
    interfaces: []
  };
  function StructureKind() {
    SerialKind.call(this);
  }
  StructureKind.$metadata$ = {
    simpleName: 'StructureKind',
    kind: 'class',
    interfaces: []
  };
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  PolymorphicKind.$metadata$ = {
    simpleName: 'PolymorphicKind',
    kind: 'class',
    interfaces: []
  };
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  ENUM.$metadata$ = {
    simpleName: 'ENUM',
    kind: 'object',
    interfaces: []
  };
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  CONTEXTUAL.$metadata$ = {
    simpleName: 'CONTEXTUAL',
    kind: 'object',
    interfaces: []
  };
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  BOOLEAN.$metadata$ = {
    simpleName: 'BOOLEAN',
    kind: 'object',
    interfaces: []
  };
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  BYTE.$metadata$ = {
    simpleName: 'BYTE',
    kind: 'object',
    interfaces: []
  };
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  CHAR.$metadata$ = {
    simpleName: 'CHAR',
    kind: 'object',
    interfaces: []
  };
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  SHORT.$metadata$ = {
    simpleName: 'SHORT',
    kind: 'object',
    interfaces: []
  };
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  INT.$metadata$ = {
    simpleName: 'INT',
    kind: 'object',
    interfaces: []
  };
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  LONG.$metadata$ = {
    simpleName: 'LONG',
    kind: 'object',
    interfaces: []
  };
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  FLOAT.$metadata$ = {
    simpleName: 'FLOAT',
    kind: 'object',
    interfaces: []
  };
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  DOUBLE.$metadata$ = {
    simpleName: 'DOUBLE',
    kind: 'object',
    interfaces: []
  };
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  STRING.$metadata$ = {
    simpleName: 'STRING',
    kind: 'object',
    interfaces: []
  };
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  CLASS.$metadata$ = {
    simpleName: 'CLASS',
    kind: 'object',
    interfaces: []
  };
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  LIST.$metadata$ = {
    simpleName: 'LIST',
    kind: 'object',
    interfaces: []
  };
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  MAP.$metadata$ = {
    simpleName: 'MAP',
    kind: 'object',
    interfaces: []
  };
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  OBJECT.$metadata$ = {
    simpleName: 'OBJECT',
    kind: 'object',
    interfaces: []
  };
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  SEALED.$metadata$ = {
    simpleName: 'SEALED',
    kind: 'object',
    interfaces: []
  };
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  OPEN.$metadata$ = {
    simpleName: 'OPEN',
    kind: 'object',
    interfaces: []
  };
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function AbstractDecoder() {
  }
  AbstractDecoder.prototype.decodeValue_0 = function () {
    throw SerializationException_init_$Create$('' + getKClassFromExpression_0(this) + " can't retrieve untyped values");
  };
  AbstractDecoder.prototype.decodeNotNullMark_11 = function () {
    return true;
  };
  AbstractDecoder.prototype.decodeNull_11 = function () {
    return null;
  };
  AbstractDecoder.prototype.decodeBoolean_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeByte_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeShort_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeInt_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeLong_11 = function () {
    var tmp = this.decodeValue_0();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeFloat_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeDouble_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeChar_11 = function () {
    var tmp = this.decodeValue_0();
    return tmp instanceof Char ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeString_11 = function () {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeEnum_11 = function (enumDescriptor) {
    var tmp = this.decodeValue_0();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  AbstractDecoder.prototype.decodeSerializableValue_22 = function (deserializer, previousValue) {
    return this.decodeSerializableValue_23(deserializer);
  };
  AbstractDecoder.prototype.beginStructure_11 = function (descriptor) {
    return this;
  };
  AbstractDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  AbstractDecoder.prototype.decodeBooleanElement_11 = function (descriptor, index) {
    return this.decodeBoolean_11();
  };
  AbstractDecoder.prototype.decodeByteElement_11 = function (descriptor, index) {
    return this.decodeByte_11();
  };
  AbstractDecoder.prototype.decodeShortElement_11 = function (descriptor, index) {
    return this.decodeShort_11();
  };
  AbstractDecoder.prototype.decodeIntElement_11 = function (descriptor, index) {
    return this.decodeInt_11();
  };
  AbstractDecoder.prototype.decodeLongElement_11 = function (descriptor, index) {
    return this.decodeLong_11();
  };
  AbstractDecoder.prototype.decodeFloatElement_11 = function (descriptor, index) {
    return this.decodeFloat_11();
  };
  AbstractDecoder.prototype.decodeDoubleElement_11 = function (descriptor, index) {
    return this.decodeDouble_11();
  };
  AbstractDecoder.prototype.decodeCharElement_11 = function (descriptor, index) {
    return this.decodeChar_11();
  };
  AbstractDecoder.prototype.decodeStringElement_11 = function (descriptor, index) {
    return this.decodeString_11();
  };
  AbstractDecoder.prototype.decodeSerializableElement_11 = function (descriptor, index, deserializer, previousValue) {
    return this.decodeSerializableValue_22(deserializer, previousValue);
  };
  AbstractDecoder.$metadata$ = {
    simpleName: 'AbstractDecoder',
    kind: 'class',
    interfaces: [Decoder, CompositeDecoder]
  };
  function Decoder() {
  }
  Decoder.prototype.decodeSerializableValue_23 = function (deserializer) {
    return deserializer.deserialize_69(this);
  };
  Decoder.$metadata$ = {
    simpleName: 'Decoder',
    kind: 'interface',
    interfaces: []
  };
  function CompositeDecoder() {
  }
  CompositeDecoder.prototype.decodeSequentially_11 = function () {
    return false;
  };
  CompositeDecoder.prototype.decodeCollectionSize_11 = function (descriptor) {
    return -1;
  };
  CompositeDecoder.prototype.decodeSerializableElement$default_11 = function (descriptor, index, deserializer, previousValue, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      previousValue = null;
    return $handler == null ? this.decodeSerializableElement_11(descriptor, index, deserializer, previousValue) : $handler(descriptor, index, deserializer, previousValue);
  };
  CompositeDecoder.$metadata$ = {
    simpleName: 'CompositeDecoder',
    kind: 'interface',
    interfaces: []
  };
  function AbstractPolymorphicSerializer() {
  }
  AbstractPolymorphicSerializer.prototype.deserialize_69 = function (decoder) {
    var tmp$ret$4;
    l$ret$5: do {
      var tmp0_decodeStructure_0 = this._get_descriptor__68();
      var composite_1 = decoder.beginStructure_11(tmp0_decodeStructure_0);
      try {
        var klassName_3 = null;
        var value_4 = null;
        if (composite_1.decodeSequentially_11()) {
          return decodeSequentially(this, composite_1);
        }mainLoop: while (true) {
          var index_5 = composite_1.decodeElementIndex_11(this._get_descriptor__68());
          switch (index_5) {
            case -1:
              break mainLoop;
            case 0:
              klassName_3 = composite_1.decodeStringElement_11(this._get_descriptor__68(), index_5);
              break;
            case 1:
              var tmp$ret$0;
              l$ret$1: do {
                var tmp0_requireNotNull_0_6 = klassName_3;
                if (tmp0_requireNotNull_0_6 == null) {
                  var message_1_7 = 'Cannot read polymorphic value before its type token';
                  throw IllegalArgumentException_init_$Create$(toString_1(message_1_7));
                } else {
                  tmp$ret$0 = tmp0_requireNotNull_0_6;
                  break l$ret$1;
                }
              }
               while (false);
              klassName_3 = tmp$ret$0;
              var serializer_8_0 = findPolymorphicSerializer(this, composite_1, klassName_3);
              var tmp = this._get_descriptor__68();
              value_4 = composite_1.decodeSerializableElement$default_11(tmp, index_5, serializer_8_0, null, 8, null);
              break;
            default:var tmp0_elvis_lhs_9 = klassName_3;
              throw SerializationException_init_$Create$('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs_9 == null ? 'unknown class' : tmp0_elvis_lhs_9) + ('' + '\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index_5));
          }
        }
        var tmp$ret$2;
        l$ret$3: do {
          var tmp1_requireNotNull_0_10 = value_4;
          if (tmp1_requireNotNull_0_10 == null) {
            var message_1_11 = '' + 'Polymorphic value has not been read for class ' + klassName_3;
            throw IllegalArgumentException_init_$Create$(toString_1(message_1_11));
          } else {
            tmp$ret$2 = tmp1_requireNotNull_0_10;
            break l$ret$3;
          }
        }
         while (false);
        var tmp_0 = tmp$ret$2;
        tmp$ret$4 = isObject(tmp_0) ? tmp_0 : THROW_CCE();
        break l$ret$5;
      }finally {
        composite_1.endStructure_11(tmp0_decodeStructure_0);
      }
    }
     while (false);
    return tmp$ret$4;
  };
  AbstractPolymorphicSerializer.prototype.findPolymorphicSerializerOrNull_0 = function (decoder, klassName) {
    return decoder._get_serializersModule__19().getPolymorphic_0(this._get_baseClass__0(), klassName);
  };
  AbstractPolymorphicSerializer.$metadata$ = {
    simpleName: 'AbstractPolymorphicSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function throwSubtypeNotRegistered(subClassName, baseClass) {
    var scope = '' + "in the scope of '" + baseClass._get_simpleName__4() + "'";
    throw SerializationException_init_$Create$(subClassName == null ? '' + 'Class discriminator was missing and no default polymorphic serializers were registered ' + scope : '' + "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + "Mark the base class as 'sealed' or register the serializer explicitly.");
  }
  function decodeSequentially($this, compositeDecoder) {
    var klassName = compositeDecoder.decodeStringElement_11($this._get_descriptor__68(), 0);
    var serializer_11 = findPolymorphicSerializer($this, compositeDecoder, klassName);
    var tmp = $this._get_descriptor__68();
    return compositeDecoder.decodeSerializableElement$default_11(tmp, 1, serializer_11, null, 8, null);
  }
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this._serialName_2 = '' + primitive._get_serialName__16() + 'Array';
  }
  PrimitiveArrayDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_2;
  };
  PrimitiveArrayDescriptor.$metadata$ = {
    simpleName: 'PrimitiveArrayDescriptor',
    kind: 'class',
    interfaces: []
  };
  function ListLikeDescriptor(elementDescriptor) {
    this._elementDescriptor = elementDescriptor;
    this._elementsCount_0 = 1;
  }
  ListLikeDescriptor.prototype._get_kind__16 = function () {
    return LIST_getInstance();
  };
  ListLikeDescriptor.prototype._get_elementsCount__16 = function () {
    return this._elementsCount_0;
  };
  ListLikeDescriptor.prototype.getElementName_16 = function (index) {
    return index.toString();
  };
  ListLikeDescriptor.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('' + name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ListLikeDescriptor.prototype.getElementAnnotations_16 = function (index) {
    var tmp0_require_0 = index >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Illegal index ' + index + ', ' + this._get_serialName__16() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return emptyList();
  };
  ListLikeDescriptor.prototype.getElementDescriptor_16 = function (index) {
    var tmp0_require_0 = index >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Illegal index ' + index + ', ' + this._get_serialName__16() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return this._elementDescriptor;
  };
  ListLikeDescriptor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    else {
    }
    if (equals_1(this._elementDescriptor, other._elementDescriptor) ? this._get_serialName__16() === other._get_serialName__16() : false)
      return true;
    return false;
  };
  ListLikeDescriptor.prototype.hashCode = function () {
    return imul(hashCode(this._elementDescriptor), 31) + getStringHashCode(this._get_serialName__16()) | 0;
  };
  ListLikeDescriptor.prototype.toString = function () {
    return '' + this._get_serialName__16() + '(' + this._elementDescriptor + ')';
  };
  ListLikeDescriptor.$metadata$ = {
    simpleName: 'ListLikeDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  ArrayListClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.collections.ArrayList';
  };
  ArrayListClassDesc.$metadata$ = {
    simpleName: 'ArrayListClassDesc',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  LinkedHashMapClassDesc.$metadata$ = {
    simpleName: 'LinkedHashMapClassDesc',
    kind: 'class',
    interfaces: []
  };
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  ArrayClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.Array';
  };
  ArrayClassDesc.$metadata$ = {
    simpleName: 'ArrayClassDesc',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  LinkedHashSetClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  LinkedHashSetClassDesc.$metadata$ = {
    simpleName: 'LinkedHashSetClassDesc',
    kind: 'class',
    interfaces: []
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this._serialName_3 = serialName;
    this._keyDescriptor = keyDescriptor;
    this._valueDescriptor = valueDescriptor;
    this._elementsCount_1 = 2;
  }
  MapLikeDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_3;
  };
  MapLikeDescriptor.prototype._get_kind__16 = function () {
    return MAP_getInstance();
  };
  MapLikeDescriptor.prototype._get_elementsCount__16 = function () {
    return this._elementsCount_1;
  };
  MapLikeDescriptor.prototype.getElementName_16 = function (index) {
    return index.toString();
  };
  MapLikeDescriptor.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('' + name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  MapLikeDescriptor.prototype.getElementAnnotations_16 = function (index) {
    var tmp0_require_0 = index >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Illegal index ' + index + ', ' + this._get_serialName__16() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return emptyList();
  };
  MapLikeDescriptor.prototype.getElementDescriptor_16 = function (index) {
    var tmp0_require_0 = index >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Illegal index ' + index + ', ' + this._get_serialName__16() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp0_subject = index % 2;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = this._keyDescriptor;
        break;
      case 1:
        tmp = this._valueDescriptor;
        break;
      default:var tmp1_error_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
    }
    return tmp;
  };
  MapLikeDescriptor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    else {
    }
    if (!(this._get_serialName__16() === other._get_serialName__16()))
      return false;
    if (!equals_1(this._keyDescriptor, other._keyDescriptor))
      return false;
    if (!equals_1(this._valueDescriptor, other._valueDescriptor))
      return false;
    return true;
  };
  MapLikeDescriptor.prototype.hashCode = function () {
    var result = getStringHashCode(this._get_serialName__16());
    result = imul(31, result) + hashCode(this._keyDescriptor) | 0;
    result = imul(31, result) + hashCode(this._valueDescriptor) | 0;
    return result;
  };
  MapLikeDescriptor.prototype.toString = function () {
    return '' + this._get_serialName__16() + '(' + this._keyDescriptor + ', ' + this._valueDescriptor + ')';
  };
  MapLikeDescriptor.$metadata$ = {
    simpleName: 'MapLikeDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  HashSetClassDesc.prototype._get_serialName__16 = function () {
    return 'kotlin.collections.HashSet';
  };
  HashSetClassDesc.$metadata$ = {
    simpleName: 'HashSetClassDesc',
    kind: 'class',
    interfaces: []
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  HashMapClassDesc.$metadata$ = {
    simpleName: 'HashMapClassDesc',
    kind: 'class',
    interfaces: []
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    ListLikeSerializer.call(this, primitiveSerializer);
    this._descriptor_0 = new PrimitiveArrayDescriptor(primitiveSerializer._get_descriptor__68());
  }
  PrimitiveArraySerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_0;
  };
  PrimitiveArraySerializer.prototype.builderSize_14 = function (_this__0) {
    return _this__0._get_position__7();
  };
  PrimitiveArraySerializer.prototype.toResult_14 = function (_this__0) {
    return _this__0.build_10();
  };
  PrimitiveArraySerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return _this__0.ensureCapacity_8(size_0);
  };
  PrimitiveArraySerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp0_error_0 = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  };
  PrimitiveArraySerializer.prototype.builder_16 = function () {
    return this.toBuilder_30(this.empty_7());
  };
  PrimitiveArraySerializer.prototype.deserialize_69 = function (decoder) {
    return this.merge_5(decoder, null);
  };
  PrimitiveArraySerializer.$metadata$ = {
    simpleName: 'PrimitiveArraySerializer',
    kind: 'class',
    interfaces: []
  };
  function PrimitiveArrayBuilder() {
  }
  PrimitiveArrayBuilder.prototype.ensureCapacity$default_7 = function (requiredCapacity, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      requiredCapacity = this._get_position__7() + 1 | 0;
    return $handler == null ? this.ensureCapacity_8(requiredCapacity) : $handler(requiredCapacity);
  };
  PrimitiveArrayBuilder.$metadata$ = {
    simpleName: 'PrimitiveArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function ListLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this._elementSerializer = elementSerializer;
  }
  ListLikeSerializer.prototype.readAll_5 = function (decoder, builder, startIndex, size_0) {
    var tmp0_require_0 = size_0 >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var inductionVariable = 0;
    var last_2 = size_0 - 1 | 0;
    if (!(size_0 === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.readElement_24(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable <= last_2);
  };
  ListLikeSerializer.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    var tmp = this._get_descriptor__68();
    this.insert_8(builder, index, decoder.decodeSerializableElement$default_11(tmp, index, this._elementSerializer, null, 8, null));
  };
  ListLikeSerializer.$metadata$ = {
    simpleName: 'ListLikeSerializer',
    kind: 'class',
    interfaces: []
  };
  function AbstractCollectionSerializer() {
  }
  AbstractCollectionSerializer.prototype.merge_5 = function (decoder, previous) {
    var tmp0_safe_receiver = previous;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toBuilder_30(tmp0_safe_receiver);
    var builder = tmp1_elvis_lhs == null ? this.builder_16() : tmp1_elvis_lhs;
    var startIndex = this.builderSize_14(builder);
    var compositeDecoder = decoder.beginStructure_11(this._get_descriptor__68());
    if (compositeDecoder.decodeSequentially_11()) {
      this.readAll_5(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      while (true) {
        var index = compositeDecoder.decodeElementIndex_11(this._get_descriptor__68());
        if (index === -1)
          break;
        var tmp = startIndex + index | 0;
        this.readElement$default_5(compositeDecoder, tmp, builder, false, 8, null);
      }
    }
    compositeDecoder.endStructure_11(this._get_descriptor__68());
    return this.toResult_14(builder);
  };
  AbstractCollectionSerializer.prototype.deserialize_69 = function (decoder) {
    return this.merge_5(decoder, null);
  };
  AbstractCollectionSerializer.prototype.readElement$default_5 = function (decoder, index, builder, checkIndex, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      checkIndex = true;
    return $handler == null ? this.readElement_24(decoder, index, builder, checkIndex) : $handler(decoder, index, builder, checkIndex);
  };
  AbstractCollectionSerializer.$metadata$ = {
    simpleName: 'AbstractCollectionSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function ArrayListSerializer(element) {
    ListLikeSerializer.call(this, element);
    this._descriptor_1 = new ArrayListClassDesc(element._get_descriptor__68());
  }
  ArrayListSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_1;
  };
  ArrayListSerializer.prototype.builder_16 = function () {
    return ArrayList_init_$Create$();
  };
  ArrayListSerializer.prototype.builderSize_2 = function (_this__0) {
    return _this__0._get_size__32();
  };
  ArrayListSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_2(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.toResult_2 = function (_this__0) {
    return _this__0;
  };
  ArrayListSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_2(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.toBuilder_2 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof ArrayList ? _this__0 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__0) : tmp0_elvis_lhs;
  };
  ArrayListSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_2((!(_this__0 == null) ? isInterface(_this__0, List) : false) ? _this__0 : THROW_CCE());
  };
  ArrayListSerializer.prototype.checkCapacity_2 = function (_this__0, size_0) {
    return _this__0.ensureCapacity_8(size_0);
  };
  ArrayListSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_2(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE(), size_0);
  };
  ArrayListSerializer.prototype.insert_1 = function (_this__0, index, element) {
    _this__0.add_10(index, element);
  };
  ArrayListSerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof ArrayList ? _this__0 : THROW_CCE();
    return this.insert_1(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayListSerializer.$metadata$ = {
    simpleName: 'ArrayListSerializer',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this._descriptor_2 = new LinkedHashMapClassDesc(kSerializer._get_descriptor__68(), vSerializer._get_descriptor__68());
  }
  LinkedHashMapSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_2;
  };
  LinkedHashMapSerializer.prototype.builder_16 = function () {
    return LinkedHashMap_init_$Create$();
  };
  LinkedHashMapSerializer.prototype.builderSize_4 = function (_this__0) {
    return _this__0._get_size__32();
  };
  LinkedHashMapSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_4(_this__0 instanceof LinkedHashMap ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.toResult_4 = function (_this__0) {
    return _this__0;
  };
  LinkedHashMapSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_4(_this__0 instanceof LinkedHashMap ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.toBuilder_13 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof LinkedHashMap ? _this__0 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_2(_this__0) : tmp0_elvis_lhs;
  };
  LinkedHashMapSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_13((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashMapSerializer.prototype.checkCapacity_4 = function (_this__0, size_0) {
  };
  LinkedHashMapSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_4(_this__0 instanceof LinkedHashMap ? _this__0 : THROW_CCE(), size_0);
  };
  LinkedHashMapSerializer.$metadata$ = {
    simpleName: 'LinkedHashMapSerializer',
    kind: 'class',
    interfaces: []
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    ListLikeSerializer.call(this, eSerializer);
    this._kClass_0 = kClass;
    this._descriptor_3 = new ArrayClassDesc(eSerializer._get_descriptor__68());
  }
  ReferenceArraySerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_3;
  };
  ReferenceArraySerializer.prototype.builder_16 = function () {
    return ArrayList_init_$Create$();
  };
  ReferenceArraySerializer.prototype.builderSize_6 = function (_this__0) {
    return _this__0._get_size__32();
  };
  ReferenceArraySerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_6(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.toResult_6 = function (_this__0) {
    return toNativeArrayImpl(_this__0, this._kClass_0);
  };
  ReferenceArraySerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_6(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.toBuilder_6 = function (_this__0) {
    return ArrayList_init_$Create$_1(asList(_this__0));
  };
  ReferenceArraySerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_6((!(_this__0 == null) ? isArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ReferenceArraySerializer.prototype.checkCapacity_6 = function (_this__0, size_0) {
    return _this__0.ensureCapacity_8(size_0);
  };
  ReferenceArraySerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_6(_this__0 instanceof ArrayList ? _this__0 : THROW_CCE(), size_0);
  };
  ReferenceArraySerializer.prototype.insert_3 = function (_this__0, index, element) {
    _this__0.add_10(index, element);
  };
  ReferenceArraySerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof ArrayList ? _this__0 : THROW_CCE();
    return this.insert_3(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ReferenceArraySerializer.$metadata$ = {
    simpleName: 'ReferenceArraySerializer',
    kind: 'class',
    interfaces: []
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this._keySerializer = keySerializer;
    this._valueSerializer = valueSerializer;
  }
  MapLikeSerializer.prototype.readAll_5 = function (decoder, builder, startIndex, size_0) {
    var tmp0_require_0 = size_0 >= 0;
    if (!tmp0_require_0) {
      var message_1 = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var untilArg = imul(size_0, 2);
    var nestedLast = untilArg - 1 | 0;
    var inductionVariable = 0;
    var last_2 = getProgressionLastElement(0, nestedLast, 2);
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 2 | 0;
        this.readElement_24(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last_2));
  };
  MapLikeSerializer.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    var tmp = this._get_descriptor__68();
    var key = decoder.decodeSerializableElement$default_11(tmp, index, this._keySerializer, null, 8, null);
    var tmp_0;
    if (checkIndex) {
      var tmp0_also_0 = decoder.decodeElementIndex_11(this._get_descriptor__68());
      var tmp0_require_0_2 = tmp0_also_0 === (index + 1 | 0);
      if (!tmp0_require_0_2) {
        var message_1_3 = '' + 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + tmp0_also_0;
        throw IllegalArgumentException_init_$Create$(toString_1(message_1_3));
      }tmp_0 = tmp0_also_0;
    } else {
      tmp_0 = index + 1 | 0;
    }
    var vIndex = tmp_0;
    var tmp_1;
    var tmp_2;
    if (builder.containsKey_8(key)) {
      var tmp_3 = this._valueSerializer._get_descriptor__68()._get_kind__16();
      tmp_2 = !(tmp_3 instanceof PrimitiveKind);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = decoder.decodeSerializableElement_11(this._get_descriptor__68(), vIndex, this._valueSerializer, getValue(builder, key));
    } else {
      {
        var tmp_4 = this._get_descriptor__68();
        tmp_1 = decoder.decodeSerializableElement$default_11(tmp_4, vIndex, this._valueSerializer, null, 8, null);
      }
    }
    var value = tmp_1;
    builder.put_5(key, value);
    Unit_getInstance();
  };
  MapLikeSerializer.$metadata$ = {
    simpleName: 'MapLikeSerializer',
    kind: 'class',
    interfaces: []
  };
  function LinkedHashSetSerializer(eSerializer) {
    ListLikeSerializer.call(this, eSerializer);
    this._descriptor_4 = new LinkedHashSetClassDesc(eSerializer._get_descriptor__68());
  }
  LinkedHashSetSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_4;
  };
  LinkedHashSetSerializer.prototype.builder_16 = function () {
    return LinkedHashSet_init_$Create$();
  };
  LinkedHashSetSerializer.prototype.builderSize_9 = function (_this__0) {
    return _this__0._get_size__32();
  };
  LinkedHashSetSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_9(_this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.toResult_9 = function (_this__0) {
    return _this__0;
  };
  LinkedHashSetSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_9(_this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.toBuilder_11 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof LinkedHashSet ? _this__0 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__0) : tmp0_elvis_lhs;
  };
  LinkedHashSetSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_11((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  LinkedHashSetSerializer.prototype.checkCapacity_9 = function (_this__0, size_0) {
  };
  LinkedHashSetSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_9(_this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE(), size_0);
  };
  LinkedHashSetSerializer.prototype.insert_5 = function (_this__0, index, element) {
    _this__0.add_19(element);
    Unit_getInstance();
  };
  LinkedHashSetSerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof LinkedHashSet ? _this__0 : THROW_CCE();
    return this.insert_5(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  LinkedHashSetSerializer.$metadata$ = {
    simpleName: 'LinkedHashSetSerializer',
    kind: 'class',
    interfaces: []
  };
  function HashSetSerializer(eSerializer) {
    ListLikeSerializer.call(this, eSerializer);
    this._descriptor_5 = new HashSetClassDesc(eSerializer._get_descriptor__68());
  }
  HashSetSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_5;
  };
  HashSetSerializer.prototype.builder_16 = function () {
    return HashSet_init_$Create$();
  };
  HashSetSerializer.prototype.builderSize_11 = function (_this__0) {
    return _this__0._get_size__32();
  };
  HashSetSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_11(_this__0 instanceof HashSet ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.toResult_11 = function (_this__0) {
    return _this__0;
  };
  HashSetSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_11(_this__0 instanceof HashSet ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.toBuilder_11 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof HashSet ? _this__0 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__0) : tmp0_elvis_lhs;
  };
  HashSetSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_11((!(_this__0 == null) ? isInterface(_this__0, Set) : false) ? _this__0 : THROW_CCE());
  };
  HashSetSerializer.prototype.checkCapacity_11 = function (_this__0, size_0) {
  };
  HashSetSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_11(_this__0 instanceof HashSet ? _this__0 : THROW_CCE(), size_0);
  };
  HashSetSerializer.prototype.insert_7 = function (_this__0, index, element) {
    _this__0.add_19(element);
    Unit_getInstance();
  };
  HashSetSerializer.prototype.insert_8 = function (_this__0, index, element) {
    var tmp = _this__0 instanceof HashSet ? _this__0 : THROW_CCE();
    return this.insert_7(tmp, index, (element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  HashSetSerializer.$metadata$ = {
    simpleName: 'HashSetSerializer',
    kind: 'class',
    interfaces: []
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this._descriptor_6 = new HashMapClassDesc(kSerializer._get_descriptor__68(), vSerializer._get_descriptor__68());
  }
  HashMapSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_6;
  };
  HashMapSerializer.prototype.builder_16 = function () {
    return HashMap_init_$Create$();
  };
  HashMapSerializer.prototype.builderSize_13 = function (_this__0) {
    return _this__0._get_size__32();
  };
  HashMapSerializer.prototype.builderSize_14 = function (_this__0) {
    return this.builderSize_13(_this__0 instanceof HashMap ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.toResult_13 = function (_this__0) {
    return _this__0;
  };
  HashMapSerializer.prototype.toResult_14 = function (_this__0) {
    return this.toResult_13(_this__0 instanceof HashMap ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.toBuilder_13 = function (_this__0) {
    var tmp0_elvis_lhs = _this__0 instanceof HashMap ? _this__0 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_2(_this__0) : tmp0_elvis_lhs;
  };
  HashMapSerializer.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_13((!(_this__0 == null) ? isInterface(_this__0, Map_0) : false) ? _this__0 : THROW_CCE());
  };
  HashMapSerializer.prototype.checkCapacity_13 = function (_this__0, size_0) {
  };
  HashMapSerializer.prototype.checkCapacity_14 = function (_this__0, size_0) {
    return this.checkCapacity_13(_this__0 instanceof HashMap ? _this__0 : THROW_CCE(), size_0);
  };
  HashMapSerializer.$metadata$ = {
    simpleName: 'HashMapSerializer',
    kind: 'class',
    interfaces: []
  };
  function readSize($this, decoder, builder) {
    var size_0 = decoder.decodeCollectionSize_11($this._get_descriptor__68());
    $this.checkCapacity_14(builder, size_0);
    return size_0;
  }
  function EnumSerializer(serialName, values_1) {
    this._values_0 = values_1;
    var tmp = this;
    var tmp_0 = ENUM_getInstance();
    var tmp_1 = [];
    tmp._descriptor_7 = buildSerialDescriptor$default(serialName, tmp_0, tmp_1, _no_name_provided_$factory_43(this, serialName), 4, null);
  }
  EnumSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_7;
  };
  EnumSerializer.prototype.deserialize_69 = function (decoder) {
    var index = decoder.decodeEnum_11(this._descriptor_7);
    var tmp0_check_0 = 0 <= index ? index <= (this._values_0.length - 1 | 0) : false;
    if (!tmp0_check_0) {
      var message_1 = '' + index + ' is not among valid $' + this._descriptor_7._get_serialName__16() + ' enum values, values size is ' + this._values_0.length;
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }return this._values_0[index];
  };
  EnumSerializer.prototype.toString = function () {
    return '' + 'kotlinx.serialization.internal.EnumSerializer<' + this._descriptor_7._get_serialName__16() + '>';
  };
  EnumSerializer.$metadata$ = {
    simpleName: 'EnumSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function _no_name_provided_$factory_43(this$0, $serialName) {
    var i = new _no_name_provided__64(this$0, $serialName);
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__64(this$0, $serialName) {
    this._this$0_19 = this$0;
    this._$serialName = $serialName;
  }
  _no_name_provided__64.prototype.invoke_107 = function (_this__0) {
    var tmp0_forEach_0 = this._this$0_19._values_0;
    var indexedObject = tmp0_forEach_0;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var element_2 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var fqn_4 = '' + this._$serialName + '.' + element_2._name;
      var tmp = OBJECT_getInstance();
      var tmp_0 = [];
      var enumMemberDescriptor_5 = buildSerialDescriptor$default(fqn_4, tmp, tmp_0, null, 12, null);
      _this__0.element$default(element_2._name, enumMemberDescriptor_5, null, false, 12, null);
    }
  };
  _no_name_provided__64.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function jsonCachedSerialNames(_this_) {
    return cachedSerialNames(_this_);
  }
  function NullableSerializer(serializer_11) {
    this._serializer = serializer_11;
    this._descriptor_8 = new SerialDescriptorForNullable(this._serializer._get_descriptor__68());
  }
  NullableSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_8;
  };
  NullableSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeNotNullMark_11() ? decoder.decodeSerializableValue_23(this._serializer) : decoder.decodeNull_11();
  };
  NullableSerializer.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression_0(this).equals(getKClassFromExpression_0(other)))
      return false;
    if (other instanceof NullableSerializer)
      other;
    else
      THROW_CCE();
    Unit_getInstance();
    if (!equals_1(this._serializer, other._serializer))
      return false;
    return true;
  };
  NullableSerializer.prototype.hashCode = function () {
    return hashCode(this._serializer);
  };
  NullableSerializer.$metadata$ = {
    simpleName: 'NullableSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function SerialDescriptorForNullable(original) {
    this._original_0 = original;
    this._serialName_4 = this._original_0._get_serialName__16() + '?';
  }
  SerialDescriptorForNullable.prototype.getElementAnnotations_16 = function (index) {
    return this._original_0.getElementAnnotations_16(index);
  };
  SerialDescriptorForNullable.prototype.getElementDescriptor_16 = function (index) {
    return this._original_0.getElementDescriptor_16(index);
  };
  SerialDescriptorForNullable.prototype.getElementIndex_16 = function (name) {
    return this._original_0.getElementIndex_16(name);
  };
  SerialDescriptorForNullable.prototype.getElementName_16 = function (index) {
    return this._original_0.getElementName_16(index);
  };
  SerialDescriptorForNullable.prototype._get_elementsCount__16 = function () {
    return this._original_0._get_elementsCount__16();
  };
  SerialDescriptorForNullable.prototype._get_kind__16 = function () {
    return this._original_0._get_kind__16();
  };
  SerialDescriptorForNullable.prototype._get_serialName__16 = function () {
    return this._serialName_4;
  };
  SerialDescriptorForNullable.prototype._get_isNullable__16 = function () {
    return true;
  };
  SerialDescriptorForNullable.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    else {
    }
    if (!equals_1(this._original_0, other._original_0))
      return false;
    return true;
  };
  SerialDescriptorForNullable.prototype.toString = function () {
    return '' + this._original_0 + '?';
  };
  SerialDescriptorForNullable.prototype.hashCode = function () {
    return imul(hashCode(this._original_0), 31);
  };
  SerialDescriptorForNullable.$metadata$ = {
    simpleName: 'SerialDescriptorForNullable',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function ObjectSerializer(serialName, objectInstance) {
    this._objectInstance = objectInstance;
    var tmp = this;
    var tmp_0 = OBJECT_getInstance();
    var tmp_1 = [];
    tmp._descriptor_9 = buildSerialDescriptor$default(serialName, tmp_0, tmp_1, null, 12, null);
  }
  ObjectSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_9;
  };
  ObjectSerializer.prototype.deserialize_69 = function (decoder) {
    decoder.beginStructure_11(this._descriptor_9).endStructure_11(this._descriptor_9);
    return this._objectInstance;
  };
  ObjectSerializer.$metadata$ = {
    simpleName: 'ObjectSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  var EMPTY_DESCRIPTOR_ARRAY;
  function compactArray(_this_) {
    var tmp;
    if (!(_this_ == null ? true : _this_.isEmpty_35())) {
      tmp = _this_;
    } else {
      {
        tmp = null;
      }
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = copyToArray_0(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? EMPTY_DESCRIPTOR_ARRAY : tmp1_elvis_lhs;
  }
  function kclass(_this_) {
    var t = _this_._get_classifier__0();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      {
        var tmp0_error_0 = '' + 'Only KClass supported as classifier, got ' + t;
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function cachedSerialNames(_this_) {
    if (_this_ instanceof PluginGeneratedSerialDescriptor)
      return _this_._get_namesSet_();
    else {
    }
    var result = HashSet_init_$Create$_1(_this_._get_elementsCount__16());
    var untilArg = _this_._get_elementsCount__16();
    var inductionVariable = 0;
    var last_2 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_plusAssign_0 = _this_.getElementName_16(i);
        result.add_19(tmp0_plusAssign_0);
        Unit_getInstance();
      }
       while (inductionVariable <= last_2);
    return result;
  }
  function EMPTY_DESCRIPTOR_ARRAY$init$() {
    var tmp0_arrayOf_0 = [];
    return tmp0_arrayOf_0;
  }
  function hashCodeImpl(_this_, typeParams) {
    var result = getStringHashCode(_this_._get_serialName__16());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = _get_elementDescriptors_(_this_);
    var tmp0_fold_0_1 = 1;
    var accumulator_1_2 = tmp0_fold_0_1;
    var tmp0_iterator_2_3 = elementDescriptors.iterator_52();
    while (tmp0_iterator_2_3.hasNext_27()) {
      var element_3_4 = tmp0_iterator_2_3.next_30();
      var tmp1__anonymous__4_5 = accumulator_1_2;
      var tmp = imul(31, tmp1__anonymous__4_5);
      var tmp0_hashCode_0_5_6 = element_3_4._get_serialName__16();
      var tmp0_safe_receiver_2_7_8 = tmp0_hashCode_0_5_6;
      var tmp1_elvis_lhs_1_6_7 = tmp0_safe_receiver_2_7_8 == null ? null : hashCode(tmp0_safe_receiver_2_7_8);
      accumulator_1_2 = tmp + (tmp1_elvis_lhs_1_6_7 == null ? 0 : tmp1_elvis_lhs_1_6_7) | 0;
    }
    var namesHash = accumulator_1_2;
    var tmp0_fold_0_1_0 = 1;
    var accumulator_1_2_0 = tmp0_fold_0_1_0;
    var tmp0_iterator_2_3_0 = elementDescriptors.iterator_52();
    while (tmp0_iterator_2_3_0.hasNext_27()) {
      var element_3_4_0 = tmp0_iterator_2_3_0.next_30();
      var tmp1__anonymous__4_5_0 = accumulator_1_2_0;
      var tmp_0 = imul(31, tmp1__anonymous__4_5_0);
      var tmp0_hashCode_0_5_6_0 = element_3_4_0._get_kind__16();
      var tmp0_safe_receiver_2_7_8_0 = tmp0_hashCode_0_5_6_0;
      var tmp1_elvis_lhs_1_6_7_0 = tmp0_safe_receiver_2_7_8_0 == null ? null : hashCode(tmp0_safe_receiver_2_7_8_0);
      accumulator_1_2_0 = tmp_0 + (tmp1_elvis_lhs_1_6_7_0 == null ? 0 : tmp1_elvis_lhs_1_6_7_0) | 0;
    }
    var kindHash = accumulator_1_2_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    this._serialName_5 = serialName;
    this._generatedSerializer = generatedSerializer;
    this._elementsCount_2 = elementsCount;
    this._added = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._elementsCount_2;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._names = tmp_2;
    var tmp_4 = this;
    var tmp0_arrayOfNulls_0 = this._elementsCount_2;
    tmp_4._propertiesAnnotations = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._classAnnotations = null;
    this._elementsOptionality = booleanArray(this._elementsCount_2);
    var tmp_5 = this;
    tmp_5._indices$delegate = lazy(_no_name_provided_$factory_44(this));
    var tmp_6 = this;
    tmp_6._childSerializers$delegate = lazy(_no_name_provided_$factory_45(this));
    var tmp_7 = this;
    tmp_7._typeParameterDescriptors$delegate = lazy(_no_name_provided_$factory_46(this));
    var tmp_8 = this;
    tmp_8.__hashCode$delegate_0 = lazy(_no_name_provided_$factory_47(this));
  }
  PluginGeneratedSerialDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_5;
  };
  PluginGeneratedSerialDescriptor.prototype._get_elementsCount__16 = function () {
    return this._elementsCount_2;
  };
  PluginGeneratedSerialDescriptor.prototype._get_kind__16 = function () {
    return CLASS_getInstance();
  };
  PluginGeneratedSerialDescriptor.prototype._get_namesSet_ = function () {
    return _get_indices__1(this)._get_keys__5();
  };
  PluginGeneratedSerialDescriptor.prototype.addElement = function (name, isOptional) {
    var tmp0_this = this;
    tmp0_this._added = tmp0_this._added + 1 | 0;
    this._names[tmp0_this._added] = name;
    this._elementsOptionality[this._added] = isOptional;
    this._propertiesAnnotations[this._added] = null;
  };
  PluginGeneratedSerialDescriptor.prototype.pushAnnotation = function (annotation) {
    var tmp0_let_0 = this._propertiesAnnotations[this._added];
    var tmp;
    if (tmp0_let_0 == null) {
      var result_2 = ArrayList_init_$Create$_0(1);
      this._propertiesAnnotations[this._added] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_let_0;
    }
    var list = tmp;
    list.add_19(annotation);
    Unit_getInstance();
  };
  PluginGeneratedSerialDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return getChecked(_get_childSerializers_(this), index)._get_descriptor__68();
  };
  PluginGeneratedSerialDescriptor.prototype.getElementAnnotations_16 = function (index) {
    var tmp0_elvis_lhs = getChecked(this._propertiesAnnotations, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  PluginGeneratedSerialDescriptor.prototype.getElementName_16 = function (index) {
    return getChecked(this._names, index);
  };
  PluginGeneratedSerialDescriptor.prototype.getElementIndex_16 = function (name) {
    var tmp0_elvis_lhs = _get_indices__1(this).get_27(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  PluginGeneratedSerialDescriptor.prototype.equals = function (other) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this === other) {
        tmp$ret$0 = true;
        break l$ret$1;
      }if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_serialName__16() === other._get_serialName__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var tmp0__anonymous__3 = other;
      if (!contentEquals(_get_typeParameterDescriptors_(this), _get_typeParameterDescriptors_(tmp0__anonymous__3))) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      if (!(this._get_elementsCount__16() === other._get_elementsCount__16())) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var untilArg = this._get_elementsCount__16();
      var inductionVariable = 0;
      var last_2 = untilArg - 1 | 0;
      if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.getElementDescriptor_16(index_2)._get_serialName__16() === other.getElementDescriptor_16(index_2)._get_serialName__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }if (!equals_1(this.getElementDescriptor_16(index_2)._get_kind__16(), other.getElementDescriptor_16(index_2)._get_kind__16())) {
            tmp$ret$0 = false;
            break l$ret$1;
          }}
         while (inductionVariable <= last_2);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  PluginGeneratedSerialDescriptor.prototype.hashCode = function () {
    return _get__hashCode__0(this);
  };
  PluginGeneratedSerialDescriptor.prototype.toString = function () {
    var tmp = _get_indices__1(this)._get_entries__5();
    var tmp_0 = '' + this._get_serialName__16() + '(';
    return joinToString$default_0(tmp, ', ', tmp_0, ')', 0, null, _no_name_provided_$factory_48(this), 24, null);
  };
  PluginGeneratedSerialDescriptor.$metadata$ = {
    simpleName: 'PluginGeneratedSerialDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function indices$factory() {
    return getPropertyCallableRef('indices', 1, KProperty1, function (receiver) {
      return _get_indices__1(receiver);
    }, null);
  }
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers_(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return _get_typeParameterDescriptors_(receiver);
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__0(receiver);
    }, null);
  }
  function _no_name_provided_$factory_44(this$0) {
    var i = new _no_name_provided__65(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_45(this$0) {
    var i = new _no_name_provided__66(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_46(this$0) {
    var i = new _no_name_provided__67(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_47(this$0) {
    var i = new _no_name_provided__68(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_48(this$0) {
    var i = new _no_name_provided__69(this$0);
    return function (p1) {
      return i.invoke_91(p1);
    };
  }
  function _get_indices__1($this) {
    var tmp0_getValue_0 = $this._indices$delegate;
    var tmp1_getValue_0 = indices$factory();
    return tmp0_getValue_0._get_value__12();
  }
  function _get_childSerializers_($this) {
    var tmp0_getValue_0 = $this._childSerializers$delegate;
    var tmp1_getValue_0 = childSerializers$factory();
    return tmp0_getValue_0._get_value__12();
  }
  function _get_typeParameterDescriptors_($this) {
    var tmp0_getValue_0 = $this._typeParameterDescriptors$delegate;
    var tmp1_getValue_0 = typeParameterDescriptors$factory();
    return tmp0_getValue_0._get_value__12();
  }
  function _get__hashCode__0($this) {
    var tmp0_getValue_0 = $this.__hashCode$delegate_0;
    var tmp1_getValue_0 = _hashCode$factory_0();
    return tmp0_getValue_0._get_value__12();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last_2 = $this._names.length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0 = $this._names[i];
        indices.put_5(tmp0_set_0, i);
        Unit_getInstance();
      }
       while (inductionVariable <= last_2);
    return indices;
  }
  function _no_name_provided__65(this$0) {
    this._this$0_20 = this$0;
  }
  _no_name_provided__65.prototype.invoke_274 = function () {
    return buildIndices(this._this$0_20);
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__66(this$0) {
    this._this$0_21 = this$0;
  }
  _no_name_provided__66.prototype.invoke_274 = function () {
    var tmp0_safe_receiver = this._this$0_21._generatedSerializer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.childSerializers_24();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__67(this$0) {
    this._this$0_22 = this$0;
  }
  _no_name_provided__67.prototype.invoke_274 = function () {
    var tmp0_safe_receiver = this._this$0_22._generatedSerializer;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.typeParametersSerializers_24();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
      var tmp0_iterator_1_2 = arrayIterator(tmp1_safe_receiver);
      while (tmp0_iterator_1_2.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2.next_30();
        tmp0_mapTo_0_1.add_19(item_2_3._get_descriptor__68());
        Unit_getInstance();
      }
      tmp = tmp0_mapTo_0_1;
    }
    return compactArray(tmp);
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68(this$0) {
    this._this$0_23 = this$0;
  }
  _no_name_provided__68.prototype.invoke_274 = function () {
    return hashCodeImpl(this._this$0_23, _get_typeParameterDescriptors_(this._this$0_23));
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__69(this$0) {
    this._this$0_24 = this$0;
  }
  _no_name_provided__69.prototype.invoke_91 = function (it) {
    return it._get_key__20() + ': ' + this._this$0_24.getElementDescriptor_16(it._get_value__12())._get_serialName__16();
  };
  _no_name_provided__69.prototype.invoke_276 = function (p1) {
    return this.invoke_91((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var EMPTY_SERIALIZER_ARRAY;
  function GeneratedSerializer() {
  }
  GeneratedSerializer.prototype.typeParametersSerializers_24 = function () {
    return EMPTY_SERIALIZER_ARRAY;
  };
  GeneratedSerializer.$metadata$ = {
    simpleName: 'GeneratedSerializer',
    kind: 'interface',
    interfaces: [KSerializer]
  };
  function SerializerFactory() {
  }
  SerializerFactory.$metadata$ = {
    simpleName: 'SerializerFactory',
    kind: 'interface',
    interfaces: []
  };
  function EMPTY_SERIALIZER_ARRAY$init$() {
    var tmp0_arrayOf_0 = [];
    return tmp0_arrayOf_0;
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_2(Companion_getInstance_8()));
  }
  CharArraySerializer_0.prototype.toBuilder_15 = function (_this__0) {
    return new CharArrayBuilder(_this__0);
  };
  CharArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_15((!(_this__0 == null) ? isCharArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  CharArraySerializer_0.prototype.empty_7 = function () {
    return charArray(0);
  };
  CharArraySerializer_0.prototype.readElement_9 = function (decoder, index, builder, checkIndex) {
    builder.append_7(decoder.decodeCharElement_11(this._get_descriptor__68(), index));
  };
  CharArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_9(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  CharArraySerializer_0.$metadata$ = {
    simpleName: 'CharArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(DoubleCompanionObject_getInstance()));
  }
  DoubleArraySerializer_0.prototype.toBuilder_17 = function (_this__0) {
    return new DoubleArrayBuilder(_this__0);
  };
  DoubleArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_17((!(_this__0 == null) ? isDoubleArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  DoubleArraySerializer_0.prototype.empty_7 = function () {
    return new Float64Array(0);
  };
  DoubleArraySerializer_0.prototype.readElement_11 = function (decoder, index, builder, checkIndex) {
    builder.append_8(decoder.decodeDoubleElement_11(this._get_descriptor__68(), index));
  };
  DoubleArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_11(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  DoubleArraySerializer_0.$metadata$ = {
    simpleName: 'DoubleArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(FloatCompanionObject_getInstance()));
  }
  FloatArraySerializer_0.prototype.toBuilder_19 = function (_this__0) {
    return new FloatArrayBuilder(_this__0);
  };
  FloatArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_19((!(_this__0 == null) ? isFloatArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  FloatArraySerializer_0.prototype.empty_7 = function () {
    return new Float32Array(0);
  };
  FloatArraySerializer_0.prototype.readElement_13 = function (decoder, index, builder, checkIndex) {
    builder.append_9(decoder.decodeFloatElement_11(this._get_descriptor__68(), index));
  };
  FloatArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_13(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  FloatArraySerializer_0.$metadata$ = {
    simpleName: 'FloatArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_9()));
  }
  LongArraySerializer_0.prototype.toBuilder_21 = function (_this__0) {
    return new LongArrayBuilder(_this__0);
  };
  LongArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_21((!(_this__0 == null) ? isLongArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  LongArraySerializer_0.prototype.empty_7 = function () {
    return longArray(0);
  };
  LongArraySerializer_0.prototype.readElement_15 = function (decoder, index, builder, checkIndex) {
    builder.append_10(decoder.decodeLongElement_11(this._get_descriptor__68(), index));
  };
  LongArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_15(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  LongArraySerializer_0.$metadata$ = {
    simpleName: 'LongArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(IntCompanionObject_getInstance()));
  }
  IntArraySerializer_0.prototype.toBuilder_23 = function (_this__0) {
    return new IntArrayBuilder(_this__0);
  };
  IntArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_23((!(_this__0 == null) ? isIntArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  IntArraySerializer_0.prototype.empty_7 = function () {
    return new Int32Array(0);
  };
  IntArraySerializer_0.prototype.readElement_17 = function (decoder, index, builder, checkIndex) {
    builder.append_11(decoder.decodeIntElement_11(this._get_descriptor__68(), index));
  };
  IntArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_17(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  IntArraySerializer_0.$metadata$ = {
    simpleName: 'IntArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(ShortCompanionObject_getInstance()));
  }
  ShortArraySerializer_0.prototype.toBuilder_25 = function (_this__0) {
    return new ShortArrayBuilder(_this__0);
  };
  ShortArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_25((!(_this__0 == null) ? isShortArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ShortArraySerializer_0.prototype.empty_7 = function () {
    return new Int16Array(0);
  };
  ShortArraySerializer_0.prototype.readElement_19 = function (decoder, index, builder, checkIndex) {
    builder.append_12(decoder.decodeShortElement_11(this._get_descriptor__68(), index));
  };
  ShortArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_19(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  ShortArraySerializer_0.$metadata$ = {
    simpleName: 'ShortArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(ByteCompanionObject_getInstance()));
  }
  ByteArraySerializer_0.prototype.toBuilder_27 = function (_this__0) {
    return new ByteArrayBuilder(_this__0);
  };
  ByteArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_27((!(_this__0 == null) ? isByteArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  ByteArraySerializer_0.prototype.empty_7 = function () {
    return new Int8Array(0);
  };
  ByteArraySerializer_0.prototype.readElement_21 = function (decoder, index, builder, checkIndex) {
    builder.append_13(decoder.decodeByteElement_11(this._get_descriptor__68(), index));
  };
  ByteArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_21(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  ByteArraySerializer_0.$metadata$ = {
    simpleName: 'ByteArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(BooleanCompanionObject_getInstance()));
  }
  BooleanArraySerializer_0.prototype.toBuilder_29 = function (_this__0) {
    return new BooleanArrayBuilder(_this__0);
  };
  BooleanArraySerializer_0.prototype.toBuilder_30 = function (_this__0) {
    return this.toBuilder_29((!(_this__0 == null) ? isBooleanArray(_this__0) : false) ? _this__0 : THROW_CCE());
  };
  BooleanArraySerializer_0.prototype.empty_7 = function () {
    return booleanArray(0);
  };
  BooleanArraySerializer_0.prototype.readElement_23 = function (decoder, index, builder, checkIndex) {
    builder.append_14(decoder.decodeBooleanElement_11(this._get_descriptor__68(), index));
  };
  BooleanArraySerializer_0.prototype.readElement_24 = function (decoder, index, builder, checkIndex) {
    return this.readElement_23(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  BooleanArraySerializer_0.$metadata$ = {
    simpleName: 'BooleanArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_0 = bufferWithData;
    this._position = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  CharArrayBuilder.prototype._get_position__7 = function () {
    return this._position;
  };
  CharArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_0.length < requiredCapacity)
      this._buffer_0 = copyOf(this._buffer_0, coerceAtLeast(requiredCapacity, imul(this._buffer_0.length, 2)));
  };
  CharArrayBuilder.prototype.append_7 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_0;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position;
    tmp0_this._position = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  CharArrayBuilder.prototype.build_10 = function () {
    return copyOf(this._buffer_0, this._position);
  };
  CharArrayBuilder.$metadata$ = {
    simpleName: 'CharArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_1 = bufferWithData;
    this._position_0 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  DoubleArrayBuilder.prototype._get_position__7 = function () {
    return this._position_0;
  };
  DoubleArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_1.length < requiredCapacity)
      this._buffer_1 = copyOf_0(this._buffer_1, coerceAtLeast(requiredCapacity, imul(this._buffer_1.length, 2)));
  };
  DoubleArrayBuilder.prototype.append_8 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_1;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_0;
    tmp0_this._position_0 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  DoubleArrayBuilder.prototype.build_10 = function () {
    return copyOf_0(this._buffer_1, this._position_0);
  };
  DoubleArrayBuilder.$metadata$ = {
    simpleName: 'DoubleArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_2 = bufferWithData;
    this._position_1 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  FloatArrayBuilder.prototype._get_position__7 = function () {
    return this._position_1;
  };
  FloatArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_2.length < requiredCapacity)
      this._buffer_2 = copyOf_1(this._buffer_2, coerceAtLeast(requiredCapacity, imul(this._buffer_2.length, 2)));
  };
  FloatArrayBuilder.prototype.append_9 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_2;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_1;
    tmp0_this._position_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  FloatArrayBuilder.prototype.build_10 = function () {
    return copyOf_1(this._buffer_2, this._position_1);
  };
  FloatArrayBuilder.$metadata$ = {
    simpleName: 'FloatArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_3 = bufferWithData;
    this._position_2 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  LongArrayBuilder.prototype._get_position__7 = function () {
    return this._position_2;
  };
  LongArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_3.length < requiredCapacity)
      this._buffer_3 = copyOf_2(this._buffer_3, coerceAtLeast(requiredCapacity, imul(this._buffer_3.length, 2)));
  };
  LongArrayBuilder.prototype.append_10 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_2;
    tmp0_this._position_2 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  LongArrayBuilder.prototype.build_10 = function () {
    return copyOf_2(this._buffer_3, this._position_2);
  };
  LongArrayBuilder.$metadata$ = {
    simpleName: 'LongArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_4 = bufferWithData;
    this._position_3 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  IntArrayBuilder.prototype._get_position__7 = function () {
    return this._position_3;
  };
  IntArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_4.length < requiredCapacity)
      this._buffer_4 = copyOf_3(this._buffer_4, coerceAtLeast(requiredCapacity, imul(this._buffer_4.length, 2)));
  };
  IntArrayBuilder.prototype.append_11 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_3;
    tmp0_this._position_3 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  IntArrayBuilder.prototype.build_10 = function () {
    return copyOf_3(this._buffer_4, this._position_3);
  };
  IntArrayBuilder.$metadata$ = {
    simpleName: 'IntArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_5 = bufferWithData;
    this._position_4 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  ShortArrayBuilder.prototype._get_position__7 = function () {
    return this._position_4;
  };
  ShortArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_5.length < requiredCapacity)
      this._buffer_5 = copyOf_4(this._buffer_5, coerceAtLeast(requiredCapacity, imul(this._buffer_5.length, 2)));
  };
  ShortArrayBuilder.prototype.append_12 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_5;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_4;
    tmp0_this._position_4 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  ShortArrayBuilder.prototype.build_10 = function () {
    return copyOf_4(this._buffer_5, this._position_4);
  };
  ShortArrayBuilder.$metadata$ = {
    simpleName: 'ShortArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_6 = bufferWithData;
    this._position_5 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  ByteArrayBuilder.prototype._get_position__7 = function () {
    return this._position_5;
  };
  ByteArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_6.length < requiredCapacity)
      this._buffer_6 = copyOf_5(this._buffer_6, coerceAtLeast(requiredCapacity, imul(this._buffer_6.length, 2)));
  };
  ByteArrayBuilder.prototype.append_13 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_6;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_5;
    tmp0_this._position_5 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  ByteArrayBuilder.prototype.build_10 = function () {
    return copyOf_5(this._buffer_6, this._position_5);
  };
  ByteArrayBuilder.$metadata$ = {
    simpleName: 'ByteArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this._buffer_7 = bufferWithData;
    this._position_6 = bufferWithData.length;
    this.ensureCapacity_8(10);
  }
  BooleanArrayBuilder.prototype._get_position__7 = function () {
    return this._position_6;
  };
  BooleanArrayBuilder.prototype.ensureCapacity_8 = function (requiredCapacity) {
    if (this._buffer_7.length < requiredCapacity)
      this._buffer_7 = copyOf_6(this._buffer_7, coerceAtLeast(requiredCapacity, imul(this._buffer_7.length, 2)));
  };
  BooleanArrayBuilder.prototype.append_14 = function (c) {
    this.ensureCapacity$default_7(0, 1, null);
    var tmp = this._buffer_7;
    var tmp0_this = this;
    var tmp1 = tmp0_this._position_6;
    tmp0_this._position_6 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  BooleanArrayBuilder.prototype.build_10 = function () {
    return copyOf_6(this._buffer_7, this._position_6);
  };
  BooleanArrayBuilder.$metadata$ = {
    simpleName: 'BooleanArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  var BUILTIN_SERIALIZERS;
  function StringSerializer() {
    StringSerializer_instance = this;
    this._descriptor_10 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  StringSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_10;
  };
  StringSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeString_11();
  };
  StringSerializer.$metadata$ = {
    simpleName: 'StringSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this._descriptor_11 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  CharSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_11;
  };
  CharSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeChar_11();
  };
  CharSerializer.$metadata$ = {
    simpleName: 'CharSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this._descriptor_12 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  DoubleSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_12;
  };
  DoubleSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeDouble_11();
  };
  DoubleSerializer.$metadata$ = {
    simpleName: 'DoubleSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this._descriptor_13 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  FloatSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_13;
  };
  FloatSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeFloat_11();
  };
  FloatSerializer.$metadata$ = {
    simpleName: 'FloatSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this._descriptor_14 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  LongSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_14;
  };
  LongSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeLong_11();
  };
  LongSerializer.$metadata$ = {
    simpleName: 'LongSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this._descriptor_15 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  IntSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_15;
  };
  IntSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeInt_11();
  };
  IntSerializer.$metadata$ = {
    simpleName: 'IntSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this._descriptor_16 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  ShortSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_16;
  };
  ShortSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeShort_11();
  };
  ShortSerializer.$metadata$ = {
    simpleName: 'ShortSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this._descriptor_17 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  ByteSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_17;
  };
  ByteSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeByte_11();
  };
  ByteSerializer.$metadata$ = {
    simpleName: 'ByteSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this._descriptor_18 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  BooleanSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_18;
  };
  BooleanSerializer.prototype.deserialize_69 = function (decoder) {
    return decoder.decodeBoolean_11();
  };
  BooleanSerializer.$metadata$ = {
    simpleName: 'BooleanSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this._$$delegate_0 = new ObjectSerializer('kotlin.Unit', Unit_getInstance());
  }
  UnitSerializer.prototype.deserialize_33 = function (decoder) {
    this._$$delegate_0.deserialize_69(decoder);
  };
  UnitSerializer.prototype.deserialize_69 = function (decoder) {
    this.deserialize_33(decoder);
    return Unit_getInstance();
  };
  UnitSerializer.prototype._get_descriptor__68 = function () {
    return this._$$delegate_0._descriptor_9;
  };
  UnitSerializer.$metadata$ = {
    simpleName: 'UnitSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this._serialName_6 = serialName;
    this._kind_0 = kind;
  }
  PrimitiveSerialDescriptor_0.prototype._get_serialName__16 = function () {
    return this._serialName_6;
  };
  PrimitiveSerialDescriptor_0.prototype._get_kind__16 = function () {
    return this._kind_0;
  };
  PrimitiveSerialDescriptor_0.prototype._get_elementsCount__16 = function () {
    return 0;
  };
  PrimitiveSerialDescriptor_0.prototype.getElementName_16 = function (index) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.getElementIndex_16 = function (name) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.getElementDescriptor_16 = function (index) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.getElementAnnotations_16 = function (index) {
    error(this);
  };
  PrimitiveSerialDescriptor_0.prototype.toString = function () {
    return '' + 'PrimitiveDescriptor(' + this._serialName_6 + ')';
  };
  PrimitiveSerialDescriptor_0.$metadata$ = {
    simpleName: 'PrimitiveSerialDescriptor',
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function builtinSerializerOrNull_0(_this_) {
    var tmp = BUILTIN_SERIALIZERS.get_27(_this_);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function PrimitiveDescriptorSafe(serialName, kind) {
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    var keys = BUILTIN_SERIALIZERS._get_keys__5();
    var tmp0_iterator = keys.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var primitive = tmp0_iterator.next_30();
      var simpleName = capitalize(ensureNotNull(primitive._get_simpleName__4()));
      var qualifiedName = '' + 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) ? true : equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$(trimIndent('' + '\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }}
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  NamedValueDecoder.prototype.getTag_8 = function (_this__0, index) {
    return this.nested_3(this.elementName_3(_this__0, index));
  };
  NamedValueDecoder.prototype.nested_3 = function (nestedName) {
    var tmp0_elvis_lhs = this._get_currentTagOrNull__4();
    return this.composeName_3(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  NamedValueDecoder.prototype.elementName_3 = function (desc, index) {
    return desc.getElementName_16(index);
  };
  NamedValueDecoder.prototype.composeName_3 = function (parentName, childName) {
    var tmp;
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      {
        tmp = '' + parentName + '.' + childName;
      }
    }
    return tmp;
  };
  NamedValueDecoder.$metadata$ = {
    simpleName: 'NamedValueDecoder',
    kind: 'class',
    interfaces: []
  };
  function TaggedDecoder() {
    var tmp = this;
    tmp._tagStack = ArrayList_init_$Create$();
    this._flag = false;
  }
  TaggedDecoder.prototype._get_serializersModule__19 = function () {
    return EmptySerializersModule;
  };
  TaggedDecoder.prototype.decodeTaggedValue_0 = function (tag) {
    throw SerializationException_init_$Create$('' + getKClassFromExpression_0(this) + " can't retrieve untyped values");
  };
  TaggedDecoder.prototype.decodeTaggedNotNullMark_2 = function (tag) {
    return true;
  };
  TaggedDecoder.prototype.decodeTaggedBoolean_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedByte_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedShort_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedInt_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedLong_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedFloat_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedDouble_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedChar_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return tmp instanceof Char ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedString_6 = function (tag) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeTaggedEnum_6 = function (tag, enumDescriptor) {
    var tmp = this.decodeTaggedValue_0(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  TaggedDecoder.prototype.decodeSerializableValue_22 = function (deserializer, previousValue) {
    return this.decodeSerializableValue_23(deserializer);
  };
  TaggedDecoder.prototype.decodeNotNullMark_11 = function () {
    var tmp0_elvis_lhs = this._get_currentTagOrNull__4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.decodeTaggedNotNullMark_2(currentTag);
  };
  TaggedDecoder.prototype.decodeNull_11 = function () {
    return null;
  };
  TaggedDecoder.prototype.decodeBoolean_11 = function () {
    return this.decodeTaggedBoolean_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeByte_11 = function () {
    return this.decodeTaggedByte_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeShort_11 = function () {
    return this.decodeTaggedShort_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeInt_11 = function () {
    return this.decodeTaggedInt_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeLong_11 = function () {
    return this.decodeTaggedLong_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeFloat_11 = function () {
    return this.decodeTaggedFloat_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeDouble_11 = function () {
    return this.decodeTaggedDouble_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeChar_11 = function () {
    return this.decodeTaggedChar_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeString_11 = function () {
    return this.decodeTaggedString_6(this.popTag_4());
  };
  TaggedDecoder.prototype.decodeEnum_11 = function (enumDescriptor) {
    return this.decodeTaggedEnum_6(this.popTag_4(), enumDescriptor);
  };
  TaggedDecoder.prototype.beginStructure_11 = function (descriptor) {
    return this;
  };
  TaggedDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  TaggedDecoder.prototype.decodeBooleanElement_11 = function (descriptor, index) {
    return this.decodeTaggedBoolean_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeByteElement_11 = function (descriptor, index) {
    return this.decodeTaggedByte_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeShortElement_11 = function (descriptor, index) {
    return this.decodeTaggedShort_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeIntElement_11 = function (descriptor, index) {
    return this.decodeTaggedInt_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeLongElement_11 = function (descriptor, index) {
    return this.decodeTaggedLong_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeFloatElement_11 = function (descriptor, index) {
    return this.decodeTaggedFloat_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeDoubleElement_11 = function (descriptor, index) {
    return this.decodeTaggedDouble_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeCharElement_11 = function (descriptor, index) {
    return this.decodeTaggedChar_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeStringElement_11 = function (descriptor, index) {
    return this.decodeTaggedString_6(this.getTag_8(descriptor, index));
  };
  TaggedDecoder.prototype.decodeSerializableElement_11 = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.getTag_8(descriptor, index);
    return tagBlock(this, tmp, _no_name_provided_$factory_49(this, deserializer, previousValue));
  };
  TaggedDecoder.prototype._get_currentTagOrNull__4 = function () {
    return lastOrNull(this._tagStack);
  };
  TaggedDecoder.prototype.pushTag_0 = function (name) {
    this._tagStack.add_19(name);
    Unit_getInstance();
  };
  TaggedDecoder.prototype.popTag_4 = function () {
    var r = this._tagStack.removeAt_1(_get_lastIndex__1(this._tagStack));
    this._flag = true;
    return r;
  };
  TaggedDecoder.$metadata$ = {
    simpleName: 'TaggedDecoder',
    kind: 'class',
    interfaces: [Decoder, CompositeDecoder]
  };
  function _no_name_provided_$factory_49(this$0, $deserializer, $previousValue) {
    var i = new _no_name_provided__70(this$0, $deserializer, $previousValue);
    return function () {
      return i.invoke_274();
    };
  }
  function tagBlock($this, tag, block) {
    $this.pushTag_0(tag);
    var r = block();
    if (!$this._flag) {
      $this.popTag_4();
      Unit_getInstance();
    }$this._flag = false;
    return r;
  }
  function _no_name_provided__70(this$0, $deserializer, $previousValue) {
    this._this$0_25 = this$0;
    this._$deserializer = $deserializer;
    this._$previousValue = $previousValue;
  }
  _no_name_provided__70.prototype.invoke_274 = function () {
    return this._this$0_25.decodeSerializableValue_22(this._$deserializer, this._$previousValue);
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var NULL;
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    var tmp_1 = [];
    tmp._descriptor_19 = buildSerialDescriptor$default('kotlin.collections.Map.Entry', tmp_0, tmp_1, _no_name_provided_$factory_50(keySerializer, valueSerializer), 4, null);
  }
  MapEntrySerializer_0.prototype._get_descriptor__68 = function () {
    return this._descriptor_19;
  };
  MapEntrySerializer_0.prototype.toResult_25 = function (key, value) {
    return new MapEntry(key, value);
  };
  MapEntrySerializer_0.$metadata$ = {
    simpleName: 'MapEntrySerializer',
    kind: 'class',
    interfaces: []
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this._keySerializer_0 = keySerializer;
    this._valueSerializer_0 = valueSerializer;
  }
  KeyValueSerializer.prototype.deserialize_69 = function (decoder) {
    var composite = decoder.beginStructure_11(this._get_descriptor__68());
    if (composite.decodeSequentially_11()) {
      var tmp = this._get_descriptor__68();
      var key = composite.decodeSerializableElement$default_11(tmp, 0, this._keySerializer_0, null, 8, null);
      var tmp_0 = this._get_descriptor__68();
      var value = composite.decodeSerializableElement$default_11(tmp_0, 1, this._valueSerializer_0, null, 8, null);
      return this.toResult_25(key, value);
    }var key_0 = NULL;
    var value_0 = NULL;
    mainLoop: while (true) {
      var idx = composite.decodeElementIndex_11(this._get_descriptor__68());
      switch (idx) {
        case -1:
          break mainLoop;
        case 0:
          var tmp_1 = this._get_descriptor__68();
          key_0 = composite.decodeSerializableElement$default_11(tmp_1, 0, this._keySerializer_0, null, 8, null);
          break;
        case 1:
          var tmp_2 = this._get_descriptor__68();
          value_0 = composite.decodeSerializableElement$default_11(tmp_2, 1, this._valueSerializer_0, null, 8, null);
          break;
        default:throw SerializationException_init_$Create$('' + 'Invalid index: ' + idx);
      }
    }
    composite.endStructure_11(this._get_descriptor__68());
    if (key_0 === NULL)
      throw SerializationException_init_$Create$("Element 'key' is missing");
    if (value_0 === NULL)
      throw SerializationException_init_$Create$("Element 'value' is missing");
    var tmp_3 = (key_0 == null ? true : isObject(key_0)) ? key_0 : THROW_CCE();
    return this.toResult_25(tmp_3, (value_0 == null ? true : isObject(value_0)) ? value_0 : THROW_CCE());
  };
  KeyValueSerializer.$metadata$ = {
    simpleName: 'KeyValueSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = [];
    tmp._descriptor_20 = buildClassSerialDescriptor$default('kotlin.Pair', tmp_0, _no_name_provided_$factory_51(keySerializer, valueSerializer), 2, null);
  }
  PairSerializer_0.prototype._get_descriptor__68 = function () {
    return this._descriptor_20;
  };
  PairSerializer_0.prototype.toResult_25 = function (key, value) {
    return to(key, value);
  };
  PairSerializer_0.$metadata$ = {
    simpleName: 'PairSerializer',
    kind: 'class',
    interfaces: []
  };
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this._aSerializer = aSerializer;
    this._bSerializer = bSerializer;
    this._cSerializer = cSerializer;
    var tmp = this;
    var tmp_0 = [];
    tmp._descriptor_21 = buildClassSerialDescriptor$default('kotlin.Triple', tmp_0, _no_name_provided_$factory_52(this), 2, null);
  }
  TripleSerializer_0.prototype._get_descriptor__68 = function () {
    return this._descriptor_21;
  };
  TripleSerializer_0.prototype.deserialize_69 = function (decoder) {
    var composite = decoder.beginStructure_11(this._descriptor_21);
    if (composite.decodeSequentially_11()) {
      return decodeSequentially_0(this, composite);
    }return decodeStructure(this, composite);
  };
  TripleSerializer_0.$metadata$ = {
    simpleName: 'TripleSerializer',
    kind: 'class',
    interfaces: [KSerializer]
  };
  function _no_name_provided_$factory_50($keySerializer, $valueSerializer) {
    var i = new _no_name_provided__71($keySerializer, $valueSerializer);
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_51($keySerializer, $valueSerializer) {
    var i = new _no_name_provided__72($keySerializer, $valueSerializer);
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_52(this$0) {
    var i = new _no_name_provided__73(this$0);
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function MapEntry(key, value) {
    this._key_1 = key;
    this._value_3 = value;
  }
  MapEntry.prototype._get_key__20 = function () {
    return this._key_1;
  };
  MapEntry.prototype._get_value__12 = function () {
    return this._value_3;
  };
  MapEntry.prototype.toString = function () {
    return '' + 'MapEntry(key=' + this._key_1 + ', value=' + this._value_3 + ')';
  };
  MapEntry.prototype.hashCode = function () {
    return imul(this._key_1 == null ? 0 : hashCode(this._key_1), 31) + (this._value_3 == null ? 0 : hashCode(this._value_3)) | 0;
  };
  MapEntry.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals_1(this._key_1, tmp0_other_with_cast._key_1))
      return false;
    if (!equals_1(this._value_3, tmp0_other_with_cast._value_3))
      return false;
    return true;
  };
  MapEntry.$metadata$ = {
    simpleName: 'MapEntry',
    kind: 'class',
    interfaces: [Entry]
  };
  function _no_name_provided__71($keySerializer, $valueSerializer) {
    this._$keySerializer = $keySerializer;
    this._$valueSerializer = $valueSerializer;
  }
  _no_name_provided__71.prototype.invoke_107 = function (_this__0) {
    var tmp = this._$keySerializer._get_descriptor__68();
    _this__0.element$default('key', tmp, null, false, 12, null);
    var tmp_0 = this._$valueSerializer._get_descriptor__68();
    _this__0.element$default('value', tmp_0, null, false, 12, null);
  };
  _no_name_provided__71.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__72($keySerializer, $valueSerializer) {
    this._$keySerializer_0 = $keySerializer;
    this._$valueSerializer_0 = $valueSerializer;
  }
  _no_name_provided__72.prototype.invoke_107 = function (_this__0) {
    var tmp = this._$keySerializer_0._get_descriptor__68();
    _this__0.element$default('first', tmp, null, false, 12, null);
    var tmp_0 = this._$valueSerializer_0._get_descriptor__68();
    _this__0.element$default('second', tmp_0, null, false, 12, null);
  };
  _no_name_provided__72.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function decodeSequentially_0($this, composite) {
    var a = composite.decodeSerializableElement$default_11($this._descriptor_21, 0, $this._aSerializer, null, 8, null);
    var b = composite.decodeSerializableElement$default_11($this._descriptor_21, 1, $this._bSerializer, null, 8, null);
    var c = composite.decodeSerializableElement$default_11($this._descriptor_21, 2, $this._cSerializer, null, 8, null);
    composite.endStructure_11($this._descriptor_21);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = NULL;
    var b = NULL;
    var c = NULL;
    mainLoop: while (true) {
      var index = composite.decodeElementIndex_11($this._descriptor_21);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.decodeSerializableElement$default_11($this._descriptor_21, 0, $this._aSerializer, null, 8, null);
          break;
        case 1:
          b = composite.decodeSerializableElement$default_11($this._descriptor_21, 1, $this._bSerializer, null, 8, null);
          break;
        case 2:
          c = composite.decodeSerializableElement$default_11($this._descriptor_21, 2, $this._cSerializer, null, 8, null);
          break;
        default:throw SerializationException_init_$Create$('' + 'Unexpected index ' + index);
      }
    }
    composite.endStructure_11($this._descriptor_21);
    if (a === NULL)
      throw SerializationException_init_$Create$("Element 'first' is missing");
    if (b === NULL)
      throw SerializationException_init_$Create$("Element 'second' is missing");
    if (c === NULL)
      throw SerializationException_init_$Create$("Element 'third' is missing");
    var tmp = (a == null ? true : isObject(a)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : isObject(b)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : isObject(c)) ? c : THROW_CCE());
  }
  function _no_name_provided__73(this$0) {
    this._this$0_26 = this$0;
  }
  _no_name_provided__73.prototype.invoke_107 = function (_this__0) {
    var tmp = this._this$0_26._aSerializer._get_descriptor__68();
    _this__0.element$default('first', tmp, null, false, 12, null);
    var tmp_0 = this._this$0_26._bSerializer._get_descriptor__68();
    _this__0.element$default('second', tmp_0, null, false, 12, null);
    var tmp_1 = this._this$0_26._cSerializer._get_descriptor__68();
    _this__0.element$default('third', tmp_1, null, false, 12, null);
  };
  _no_name_provided__73.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PolymorphicModuleBuilder(baseClass, baseSerializer) {
    this._baseClass_0 = baseClass;
    this._baseSerializer = baseSerializer;
    var tmp = this;
    tmp._subclasses = ArrayList_init_$Create$();
    this._defaultSerializerProvider = null;
  }
  PolymorphicModuleBuilder.prototype.subclass = function (subclass, serializer_11) {
    this._subclasses.add_19(to(subclass, serializer_11));
    Unit_getInstance();
  };
  PolymorphicModuleBuilder.prototype.buildTo = function (builder) {
    if (!(this._baseSerializer == null)) {
      builder.registerPolymorphicSerializer$default(this._baseClass_0, this._baseClass_0, this._baseSerializer, false, 8, null);
    }var tmp0_forEach_0 = this._subclasses;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var kclass_4 = element_2.component1();
      var serializer_5_0 = element_2.component2();
      var tmp = isInterface(kclass_4, KClass) ? kclass_4 : THROW_CCE();
      var tmp_0 = isInterface(serializer_5_0, KSerializer) ? serializer_5_0 : THROW_CCE();
      builder.registerPolymorphicSerializer$default(this._baseClass_0, tmp, tmp_0, false, 8, null);
    }
    var default_0 = this._defaultSerializerProvider;
    if (!(default_0 == null)) {
      builder.registerDefaultPolymorphicSerializer(this._baseClass_0, default_0, false);
    }};
  PolymorphicModuleBuilder.$metadata$ = {
    simpleName: 'PolymorphicModuleBuilder',
    kind: 'class',
    interfaces: []
  };
  var EmptySerializersModule;
  function SerializersModule() {
  }
  SerializersModule.$metadata$ = {
    simpleName: 'SerializersModule',
    kind: 'class',
    interfaces: []
  };
  function SerialModuleImpl(class2Serializer, polyBase2Serializers, polyBase2NamedSerializers, polyBase2DefaultProvider) {
    SerializersModule.call(this);
    this._class2Serializer = class2Serializer;
    this._polyBase2Serializers = polyBase2Serializers;
    this._polyBase2NamedSerializers = polyBase2NamedSerializers;
    this._polyBase2DefaultProvider = polyBase2DefaultProvider;
  }
  SerialModuleImpl.prototype.getPolymorphic_0 = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this._polyBase2NamedSerializers.get_27(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = ((!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, Map_0) : false) ? tmp0_safe_receiver : THROW_CCE()).get_27(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this._polyBase2DefaultProvider.get_27(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  SerialModuleImpl.prototype.getContextual_0 = function (kclass_0) {
    var tmp = this._class2Serializer.get_27(kclass_0);
    return (!(tmp == null) ? isInterface(tmp, KSerializer) : false) ? tmp : null;
  };
  SerialModuleImpl.prototype.dumpTo_0 = function (collector) {
    var tmp0_forEach_0 = this._class2Serializer;
    var tmp0_iterator_1 = tmp0_forEach_0._get_entries__5().iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var kclass_4 = element_2._get_key__20();
      var serial_5 = element_2._get_value__12();
      var tmp = isInterface(kclass_4, KClass) ? kclass_4 : THROW_CCE();
      collector.contextual_1(tmp, isInterface(serial_5, KSerializer) ? serial_5 : THROW_CCE());
    }
    var tmp1_forEach_0 = this._polyBase2Serializers;
    var tmp0_iterator_1_0 = tmp1_forEach_0._get_entries__5().iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_30();
      var baseClass_4 = element_2_0._get_key__20();
      var classMap_5 = element_2_0._get_value__12();
      var tmp0_iterator_1_6 = classMap_5._get_entries__5().iterator_52();
      while (tmp0_iterator_1_6.hasNext_27()) {
        var element_2_7 = tmp0_iterator_1_6.next_30();
        var actualClass_4_8 = element_2_7._get_key__20();
        var serializer_5_9 = element_2_7._get_value__12();
        var tmp_0 = isInterface(baseClass_4, KClass) ? baseClass_4 : THROW_CCE();
        var tmp_1 = isInterface(actualClass_4_8, KClass) ? actualClass_4_8 : THROW_CCE();
        collector.polymorphic_1(tmp_0, tmp_1, isInterface(serializer_5_9, KSerializer) ? serializer_5_9 : THROW_CCE());
      }
    }
    var tmp2_forEach_0 = this._polyBase2DefaultProvider;
    var tmp0_iterator_1_1 = tmp2_forEach_0._get_entries__5().iterator_52();
    while (tmp0_iterator_1_1.hasNext_27()) {
      var element_2_1 = tmp0_iterator_1_1.next_30();
      var baseClass_4_0 = element_2_1._get_key__20();
      var provider_5 = element_2_1._get_value__12();
      var tmp_2 = isInterface(baseClass_4_0, KClass) ? baseClass_4_0 : THROW_CCE();
      collector.polymorphicDefault_1(tmp_2, typeof provider_5 === 'function' ? provider_5 : THROW_CCE());
    }
  };
  SerialModuleImpl.$metadata$ = {
    simpleName: 'SerialModuleImpl',
    kind: 'class',
    interfaces: []
  };
  function SerializersModuleBuilder() {
    var tmp = this;
    tmp._class2Serializer_0 = HashMap_init_$Create$();
    var tmp_0 = this;
    tmp_0._polyBase2Serializers_0 = HashMap_init_$Create$();
    var tmp_1 = this;
    tmp_1._polyBase2NamedSerializers_0 = HashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2._polyBase2DefaultProvider_0 = HashMap_init_$Create$();
  }
  SerializersModuleBuilder.prototype.contextual_1 = function (kClass, serializer_11) {
    return this.registerSerializer$default(kClass, serializer_11, false, 4, null);
  };
  SerializersModuleBuilder.prototype.polymorphic_1 = function (baseClass, actualClass, actualSerializer) {
    this.registerPolymorphicSerializer$default(baseClass, actualClass, actualSerializer, false, 8, null);
  };
  SerializersModuleBuilder.prototype.polymorphicDefault_1 = function (baseClass, defaultSerializerProvider) {
    this.registerDefaultPolymorphicSerializer(baseClass, defaultSerializerProvider, false);
  };
  SerializersModuleBuilder.prototype.registerSerializer = function (forClass, serializer_11, allowOverwrite) {
    if (!allowOverwrite) {
      var previous = this._class2Serializer_0.get_27(forClass);
      if (!(previous == null) ? !equals_1(previous, serializer_11) : false) {
        var currentName = serializer_11._get_descriptor__68()._get_serialName__16();
        var previousName = previous._get_descriptor__68()._get_serialName__16();
        throw new SerializerAlreadyRegisteredException('' + 'Serializer for ' + forClass + ' already registered in this module: ' + previous + ' (' + previousName + '), ' + ('' + 'attempted to register ' + serializer_11 + ' (' + currentName + ')'));
      }}var tmp0_set_0 = this._class2Serializer_0;
    tmp0_set_0.put_5(forClass, serializer_11);
    Unit_getInstance();
  };
  SerializersModuleBuilder.prototype.registerSerializer$default = function (forClass, serializer_11, allowOverwrite, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      allowOverwrite = false;
    return this.registerSerializer(forClass, serializer_11, allowOverwrite);
  };
  SerializersModuleBuilder.prototype.registerDefaultPolymorphicSerializer = function (baseClass, defaultSerializerProvider, allowOverwrite) {
    var previous = this._polyBase2DefaultProvider_0.get_27(baseClass);
    if ((!(previous == null) ? !equals_1(previous, defaultSerializerProvider) : false) ? !allowOverwrite : false) {
      throw IllegalArgumentException_init_$Create$('' + 'Default serializers provider for class ' + baseClass + ' is already registered: ' + previous);
    }var tmp0_set_0 = this._polyBase2DefaultProvider_0;
    tmp0_set_0.put_5(baseClass, defaultSerializerProvider);
    Unit_getInstance();
  };
  SerializersModuleBuilder.prototype.registerPolymorphicSerializer = function (baseClass, concreteClass, concreteSerializer, allowOverwrite) {
    var name = concreteSerializer._get_descriptor__68()._get_serialName__16();
    var tmp0_getOrPut_0 = this._polyBase2Serializers_0;
    var value_1 = tmp0_getOrPut_0.get_27(baseClass);
    var tmp;
    if (value_1 == null) {
      var answer_2 = HashMap_init_$Create$();
      tmp0_getOrPut_0.put_5(baseClass, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    var baseClassSerializers = tmp;
    var previousSerializer = baseClassSerializers.get_27(concreteClass);
    var tmp1_getOrPut_0 = this._polyBase2NamedSerializers_0;
    var value_1_0 = tmp1_getOrPut_0.get_27(baseClass);
    var tmp_0;
    if (value_1_0 == null) {
      var answer_2_0 = HashMap_init_$Create$();
      tmp1_getOrPut_0.put_5(baseClass, answer_2_0);
      Unit_getInstance();
      tmp_0 = answer_2_0;
    } else {
      tmp_0 = value_1_0;
    }
    var names = tmp_0;
    if (allowOverwrite) {
      if (!(previousSerializer == null)) {
        names.remove_17(previousSerializer._get_descriptor__68()._get_serialName__16());
        Unit_getInstance();
      }baseClassSerializers.put_5(concreteClass, concreteSerializer);
      Unit_getInstance();
      names.put_5(name, concreteSerializer);
      Unit_getInstance();
      return Unit_getInstance();
    }if (!(previousSerializer == null)) {
      if (!equals_1(previousSerializer, concreteSerializer)) {
        throw SerializerAlreadyRegisteredException_init_$Create$(baseClass, concreteClass);
      } else {
        names.remove_17(previousSerializer._get_descriptor__68()._get_serialName__16());
        Unit_getInstance();
      }
    }var previousByName = names.get_27(name);
    if (!(previousByName == null)) {
      var tmp2_find_0 = asSequence_0(ensureNotNull(this._polyBase2Serializers_0.get_27(baseClass)));
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_iterator_1_1 = tmp2_find_0.iterator_52();
        while (tmp0_iterator_1_1.hasNext_27()) {
          var element_2_2 = tmp0_iterator_1_1.next_30();
          if (element_2_2._get_value__12() === previousByName) {
            tmp$ret$0 = element_2_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var conflictingClass = tmp$ret$0;
      throw IllegalArgumentException_init_$Create$('' + "Multiple polymorphic serializers for base class '" + baseClass + "' " + ('' + "have the same serial name '" + name + "': '" + concreteClass + "' and '" + conflictingClass + "'"));
    }baseClassSerializers.put_5(concreteClass, concreteSerializer);
    Unit_getInstance();
    names.put_5(name, concreteSerializer);
    Unit_getInstance();
  };
  SerializersModuleBuilder.prototype.registerPolymorphicSerializer$default = function (baseClass, concreteClass, concreteSerializer, allowOverwrite, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      allowOverwrite = false;
    return this.registerPolymorphicSerializer(baseClass, concreteClass, concreteSerializer, allowOverwrite);
  };
  SerializersModuleBuilder.prototype.build_10 = function () {
    return new SerialModuleImpl(this._class2Serializer_0, this._polyBase2Serializers_0, this._polyBase2NamedSerializers_0, this._polyBase2DefaultProvider_0);
  };
  SerializersModuleBuilder.$metadata$ = {
    simpleName: 'SerializersModuleBuilder',
    kind: 'class',
    interfaces: [SerializersModuleCollector]
  };
  function SerializerAlreadyRegisteredException(msg) {
    IllegalArgumentException_init_$Init$(msg, this);
    captureStack(this, SerializerAlreadyRegisteredException);
  }
  SerializerAlreadyRegisteredException.$metadata$ = {
    simpleName: 'SerializerAlreadyRegisteredException',
    kind: 'class',
    interfaces: []
  };
  function SerializerAlreadyRegisteredException_init_$Init$(baseClass, concreteClass, $this) {
    SerializerAlreadyRegisteredException.call($this, '' + 'Serializer for ' + concreteClass + ' already registered in the scope of ' + baseClass);
    return $this;
  }
  function SerializerAlreadyRegisteredException_init_$Create$(baseClass, concreteClass) {
    var tmp = SerializerAlreadyRegisteredException_init_$Init$(baseClass, concreteClass, Object.create(SerializerAlreadyRegisteredException.prototype));
    captureStack(tmp, SerializerAlreadyRegisteredException_init_$Create$);
    return tmp;
  }
  function SerializersModuleCollector() {
  }
  SerializersModuleCollector.$metadata$ = {
    simpleName: 'SerializersModuleCollector',
    kind: 'interface',
    interfaces: []
  };
  function SerializableWith() {
  }
  SerializableWith.$metadata$ = {
    simpleName: 'SerializableWith',
    kind: 'class',
    interfaces: [Annotation],
    associatedObjectKey: 0
  };
  function getChecked(_this_, index) {
    if (!(0 <= index ? index <= (_this_.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('' + 'Index ' + index + ' out of bounds ' + _get_indices_(_this_));
    return _this_[index];
  }
  function toNativeArrayImpl(_this_, eClass) {
    return copyToArray_0(_this_);
  }
  function platformSpecificSerializerNotRegistered(_this_) {
    throw SerializationException_init_$Create$('' + "Serializer for class '" + _this_._get_simpleName__4() + "' is not found.\n" + 'Mark the class as @Serializable or provide the serializer explicitly.\n' + 'On Kotlin/JS explicitly declared serializer should be used for interfaces and enums without @Serializable annotation');
  }
  function compiledSerializerImpl(_this_) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this_, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_asDynamic_0 = _get_js_(_this_);
      var tmp0_safe_receiver = tmp0_asDynamic_0.Companion;
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      tmp = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance()._get_arrayClass_());
  }
  function constructSerializerForGivenTypeArgs(_this_, args) {
    var tmp;
    try {
      var assocObject = findAssociatedObject(_this_, getKClass_0(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.serializer(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      {
        tmp_2 = null;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function ProtoBuf(encodeDefaults, serializersModule) {
    this._encodeDefaults = encodeDefaults;
    this._serializersModule = serializersModule;
  }
  ProtoBuf.prototype._get_serializersModule__19 = function () {
    return this._serializersModule;
  };
  ProtoBuf.prototype.decodeFromByteArray_2 = function (deserializer, bytes) {
    var input = ByteArrayInput_init_$Create$(bytes, 0, 2, null);
    var decoder = new ProtobufDecoder(this, new ProtobufReader(input), deserializer._get_descriptor__68());
    return decoder.decodeSerializableValue_23(deserializer);
  };
  ProtoBuf.$metadata$ = {
    simpleName: 'ProtoBuf',
    kind: 'class',
    interfaces: [BinaryFormat]
  };
  function ProtoBuf_0(from, builderAction) {
    var b = new ProtoBufBuilder(from);
    builderAction(b);
    return new ProtoBufImpl(b._encodeDefaults_0, b._serializersModule_0);
  }
  function ProtoBuf$default(from, builderAction, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      from = Default_getInstance_0();
    return ProtoBuf_0(from, builderAction);
  }
  function ProtoBufBuilder(proto) {
    this._encodeDefaults_0 = proto._encodeDefaults;
    this._serializersModule_0 = proto._get_serializersModule__19();
  }
  ProtoBufBuilder.$metadata$ = {
    simpleName: 'ProtoBufBuilder',
    kind: 'class',
    interfaces: []
  };
  function ProtoBufImpl(encodeDefaults, serializersModule) {
    ProtoBuf.call(this, encodeDefaults, serializersModule);
  }
  ProtoBufImpl.$metadata$ = {
    simpleName: 'ProtoBufImpl',
    kind: 'class',
    interfaces: []
  };
  function Default_0() {
    Default_instance_0 = this;
    ProtoBuf.call(this, false, EmptySerializersModule);
  }
  Default_0.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance_0;
  function Default_getInstance_0() {
    if (Default_instance_0 == null)
      new Default_0();
    return Default_instance_0;
  }
  function ProtoNumber(number) {
    this._number = number;
  }
  ProtoNumber.$metadata$ = {
    simpleName: 'ProtoNumber',
    kind: 'class',
    interfaces: [Annotation]
  };
  function ProtoIntegerType(name, ordinal, signature) {
    Enum.call(this, name, ordinal);
    this._signature = signature;
  }
  ProtoIntegerType.$metadata$ = {
    simpleName: 'ProtoIntegerType',
    kind: 'class',
    interfaces: []
  };
  function ProtoType() {
  }
  ProtoType.$metadata$ = {
    simpleName: 'ProtoType',
    kind: 'class',
    interfaces: [Annotation]
  };
  function ProtoIntegerType_DEFAULT_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_DEFAULT_instance;
  }
  function ProtoIntegerType_SIGNED_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_SIGNED_instance;
  }
  function ProtoIntegerType_FIXED_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_FIXED_instance;
  }
  var ProtoIntegerType_DEFAULT_instance;
  var ProtoIntegerType_SIGNED_instance;
  var ProtoIntegerType_FIXED_instance;
  var ProtoIntegerType_entriesInitialized;
  function ProtoIntegerType_initEntries() {
    if (ProtoIntegerType_entriesInitialized)
      return Unit_getInstance();
    ProtoIntegerType_entriesInitialized = true;
    ProtoIntegerType_DEFAULT_instance = new ProtoIntegerType('DEFAULT', 0, new Long(0, 0));
    ProtoIntegerType_SIGNED_instance = new ProtoIntegerType('SIGNED', 1, new Long(0, 1));
    ProtoIntegerType_FIXED_instance = new ProtoIntegerType('FIXED', 2, new Long(0, 2));
  }
  function _get_integerType_(_this_) {
    var tmp0_subject = _this_.and(new Long(0, 2147483647));
    return tmp0_subject.equals(ProtoIntegerType_DEFAULT_getInstance()._signature) ? ProtoIntegerType_DEFAULT_getInstance() : tmp0_subject.equals(ProtoIntegerType_SIGNED_getInstance()._signature) ? ProtoIntegerType_SIGNED_getInstance() : ProtoIntegerType_FIXED_getInstance();
  }
  function extractProtoId(descriptor, index, zeroBasedDefault) {
    var annotations = descriptor.getElementAnnotations_16(index);
    var inductionVariable = 0;
    var last_2 = annotations._get_size__32() - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var annotation = annotations.get_57(i);
        if (annotation instanceof ProtoNumber) {
          return annotation._number;
        } else {
        }
      }
       while (inductionVariable <= last_2);
    return zeroBasedDefault ? index : index + 1 | 0;
  }
  function extractParameters(_this_, index) {
    var annotations = _this_.getElementAnnotations_16(index);
    var protoId = index + 1 | 0;
    var format = ProtoIntegerType_DEFAULT_getInstance();
    var inductionVariable = 0;
    var last_2 = annotations._get_size__32() - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var annotation = annotations.get_57(i);
        if (annotation instanceof ProtoNumber) {
          protoId = annotation._number;
        } else {
          if (annotation instanceof ProtoType) {
            format = annotation._type_0;
          } else {
          }
        }
      }
       while (inductionVariable <= last_2);
    var tmp0_ProtoDesc_0 = protoId;
    var tmp1_ProtoDesc_0 = format;
    return tmp1_ProtoDesc_0._signature.or(toLong_0(tmp0_ProtoDesc_0));
  }
  function ProtobufDecodingException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, ProtobufDecodingException);
  }
  ProtobufDecodingException.$metadata$ = {
    simpleName: 'ProtobufDecodingException',
    kind: 'class',
    interfaces: []
  };
  function ProtobufDecoder(proto, reader, descriptor) {
    ProtobufTaggedDecoder.call(this);
    this._proto = proto;
    this._reader = reader;
    this._descriptor_22 = descriptor;
    this._indexCache = null;
    this._sparseIndexCache = null;
    this.populateCache_1(this._descriptor_22);
  }
  ProtobufDecoder.prototype._get_reader__0 = function () {
    return this._reader;
  };
  ProtobufDecoder.prototype._get_serializersModule__19 = function () {
    return this._proto._get_serializersModule__19();
  };
  ProtobufDecoder.prototype.populateCache_1 = function (descriptor) {
    var elements = descriptor._get_elementsCount__16();
    if (elements < 32) {
      var cache_0 = new Int32Array(elements + 1 | 0);
      var inductionVariable = 0;
      var last_2 = elements - 1 | 0;
      if (!(elements === -2147483648) ? inductionVariable <= last_2 : false)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var protoId = extractProtoId(descriptor, i, false);
          if (protoId <= elements) {
            cache_0[protoId] = i;
          } else {
            return populateCacheMap(this, descriptor, elements);
          }
        }
         while (inductionVariable <= last_2);
      this._indexCache = cache_0;
    } else {
      populateCacheMap(this, descriptor, elements);
    }
  };
  ProtobufDecoder.prototype.beginStructure_11 = function (descriptor) {
    var tmp0_subject = descriptor._get_kind__16();
    var tmp;
    if (equals_1(tmp0_subject, LIST_getInstance())) {
      tmp = new RepeatedDecoder(this._proto, this._reader, this._get_currentTagOrDefault__2(), descriptor);
    } else {
      var tmp_0;
      if (equals_1(tmp0_subject, CLASS_getInstance()) ? true : equals_1(tmp0_subject, OBJECT_getInstance())) {
        tmp_0 = true;
      } else {
        tmp_0 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_0) {
        var tag = this._get_currentTagOrDefault__2();
        if (tag.equals(new Long(19500, 0)) ? equals_1(this._descriptor_22, descriptor) : false)
          return this;
        return new ProtobufDecoder(this._proto, makeDelimited(this._reader, tag), descriptor);
      } else {
        if (equals_1(tmp0_subject, MAP_getInstance())) {
          tmp = new MapEntryReader(this._proto, makeDelimitedForced(this._reader, this._get_currentTagOrDefault__2()), this._get_currentTagOrDefault__2(), descriptor);
        } else {
          {
            throw SerializationException_init_$Create$('Primitives are not supported at top-level');
          }
        }
      }
    }
    return tmp;
  };
  ProtobufDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  ProtobufDecoder.prototype.decodeTaggedBoolean_4 = function (tag) {
    var value = this.decodeTaggedInt_4(tag);
    var tmp;
    switch (value) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = true;
        break;
      default:throw SerializationException_init_$Create$('' + 'Unexpected boolean value: ' + value);
    }
    return tmp;
  };
  ProtobufDecoder.prototype.decodeTaggedByte_4 = function (tag) {
    return toByte_0(this.decodeTaggedInt_4(tag));
  };
  ProtobufDecoder.prototype.decodeTaggedShort_4 = function (tag) {
    return toShort_0(this.decodeTaggedInt_4(tag));
  };
  ProtobufDecoder.prototype.decodeTaggedInt_4 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this._reader.readInt32NoTag();
    } else {
      tmp = this._reader.readInt(_get_integerType_(tag));
    }
    return tmp;
  };
  ProtobufDecoder.prototype.decodeTaggedLong_4 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this._reader.readLongNoTag();
    } else {
      tmp = this._reader.readLong(_get_integerType_(tag));
    }
    return tmp;
  };
  ProtobufDecoder.prototype.decodeTaggedFloat_4 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this._reader.readFloatNoTag();
    } else {
      tmp = this._reader.readFloat();
    }
    return tmp;
  };
  ProtobufDecoder.prototype.decodeTaggedDouble_4 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this._reader.readDoubleNoTag();
    } else {
      tmp = this._reader.readDouble();
    }
    return tmp;
  };
  ProtobufDecoder.prototype.decodeTaggedChar_4 = function (tag) {
    return numberToChar(this.decodeTaggedInt_4(tag));
  };
  ProtobufDecoder.prototype.decodeTaggedString_4 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this._reader.readStringNoTag();
    } else {
      tmp = this._reader.readString();
    }
    return tmp;
  };
  ProtobufDecoder.prototype.decodeTaggedEnum_4 = function (tag, enumDescription) {
    return findIndexByTag(this, enumDescription, this.decodeTaggedInt_4(tag));
  };
  ProtobufDecoder.prototype.decodeSerializableValue_23 = function (deserializer) {
    return this.decodeSerializableValue_22(deserializer, null);
  };
  ProtobufDecoder.prototype.decodeSerializableValue_22 = function (deserializer, previousValue) {
    var tmp;
    if (deserializer instanceof MapLikeSerializer) {
      tmp = deserializeMap(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE(), previousValue);
    } else {
      if (equals_1(deserializer._get_descriptor__68(), ByteArraySerializer()._get_descriptor__68())) {
        var tmp_0 = deserializeByteArray(this, (previousValue == null ? true : isByteArray(previousValue)) ? previousValue : THROW_CCE());
        tmp = isObject(tmp_0) ? tmp_0 : THROW_CCE();
      } else {
        if (deserializer instanceof AbstractCollectionSerializer) {
          tmp = (deserializer instanceof AbstractCollectionSerializer ? deserializer : THROW_CCE()).merge_5(this, previousValue);
        } else {
          {
            tmp = deserializer.deserialize_69(this);
          }
        }
      }
    }
    return tmp;
  };
  ProtobufDecoder.prototype.getTag_8 = function (_this__0, index) {
    return extractParameters(_this__0, index);
  };
  ProtobufDecoder.prototype.decodeElementIndex_11 = function (descriptor) {
    while (true) {
      var protoId = this._reader.readTag();
      if (protoId === -1) {
        return -1;
      }var index = getIndexByTag(this, protoId);
      if (index === -1) {
        this._reader.skipElement_0();
      } else {
        return index;
      }
    }
  };
  ProtobufDecoder.$metadata$ = {
    simpleName: 'ProtobufDecoder',
    kind: 'class',
    interfaces: []
  };
  function RepeatedDecoder(proto, decoder, currentTag, descriptor) {
    ProtobufDecoder.call(this, proto, decoder, descriptor);
    this._index_5 = -1;
    var tmp = this;
    var tmp_0;
    if (currentTag.equals(new Long(19500, 0))) {
      var length = this._get_reader__0().readInt32NoTag();
      var tmp0_require_0 = length >= 0;
      if (!tmp0_require_0) {
        var message_1 = '' + 'Expected positive length for ' + descriptor + ', but got ' + length;
        throw IllegalArgumentException_init_$Create$(toString_1(message_1));
      }tmp_0 = toLong_0(length).unaryMinus_4();
    } else {
      tmp_0 = currentTag;
    }
    tmp._tagOrSize = tmp_0;
  }
  RepeatedDecoder.prototype.decodeElementIndex_11 = function (descriptor) {
    if (this._tagOrSize.compareTo_48(new Long(0, 0)) > 0) {
      return decodeTaggedListIndex(this);
    }return decodeListIndexNoTag(this);
  };
  RepeatedDecoder.prototype.getTag_8 = function (_this__0, index) {
    if (this._tagOrSize.compareTo_48(new Long(0, 0)) > 0)
      return this._tagOrSize;
    return new Long(19500, 0);
  };
  RepeatedDecoder.$metadata$ = {
    simpleName: 'RepeatedDecoder',
    kind: 'class',
    interfaces: []
  };
  function makeDelimited(decoder, parentTag) {
    var tagless = parentTag.equals(new Long(19500, 0));
    var input = tagless ? decoder.objectTaglessInput() : decoder.objectInput();
    return new ProtobufReader(input);
  }
  function MapEntryReader(proto, decoder, parentTag, descriptor) {
    ProtobufDecoder.call(this, proto, decoder, descriptor);
    this._parentTag = parentTag;
  }
  MapEntryReader.prototype.getTag_8 = function (_this__0, index) {
    var tmp;
    if (index % 2 === 0) {
      var tmp0_ProtoDesc_0 = 1;
      var tmp1_ProtoDesc_0 = _get_integerType_(this._parentTag);
      tmp = tmp1_ProtoDesc_0._signature.or(toLong_0(tmp0_ProtoDesc_0));
    } else {
      var tmp2_ProtoDesc_0 = 2;
      var tmp3_ProtoDesc_0 = _get_integerType_(this._parentTag);
      tmp = tmp3_ProtoDesc_0._signature.or(toLong_0(tmp2_ProtoDesc_0));
    }
    return tmp;
  };
  MapEntryReader.$metadata$ = {
    simpleName: 'MapEntryReader',
    kind: 'class',
    interfaces: []
  };
  function makeDelimitedForced(decoder, parentTag) {
    var tagless = parentTag.equals(new Long(19500, 0));
    var input = tagless ? decoder.objectTaglessInput() : decoder.objectInput();
    return new ProtobufReader(input);
  }
  function populateCacheMap($this, descriptor, elements) {
    var map_0 = HashMap_init_$Create$_1(elements);
    var inductionVariable = 0;
    var last_2 = elements - 1 | 0;
    if (!(elements === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0 = extractProtoId(descriptor, i, false);
        map_0.put_5(tmp0_set_0, i);
        Unit_getInstance();
      }
       while (inductionVariable <= last_2);
    $this._sparseIndexCache = map_0;
  }
  function getIndexByTag($this, protoTag) {
    var array = $this._indexCache;
    if (!(array == null)) {
      var tmp;
      if (protoTag >= 0 ? protoTag <= _get_lastIndex__0(array) : false) {
        tmp = array[protoTag];
      } else {
        tmp = -1;
      }
      return tmp;
    }return getIndexByTagSlowPath($this, protoTag);
  }
  function getIndexByTagSlowPath($this, protoTag) {
    var tmp0_getOrElse_0 = ensureNotNull($this._sparseIndexCache);
    var tmp0_elvis_lhs_1 = tmp0_getOrElse_0.get_27(protoTag);
    var tmp;
    if (tmp0_elvis_lhs_1 == null) {
      tmp = -1;
    } else {
      tmp = tmp0_elvis_lhs_1;
    }
    return tmp;
  }
  function findIndexByTag($this, descriptor, protoTag) {
    if (protoTag < descriptor._get_elementsCount__16()) {
      var protoId = extractProtoId(descriptor, protoTag, true);
      if (protoId === protoTag)
        return protoTag;
    }return findIndexByTagSlowPath($this, descriptor, protoTag);
  }
  function findIndexByTagSlowPath($this, desc, protoTag) {
    var untilArg = desc._get_elementsCount__16();
    var inductionVariable = 0;
    var last_2 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var protoId = extractProtoId(desc, i, true);
        if (protoId === protoTag)
          return i;
      }
       while (inductionVariable <= last_2);
    return -1;
  }
  function deserializeByteArray($this, previousValue) {
    var tag = $this._get_currentTagOrDefault__2();
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = $this._reader.readByteArrayNoTag();
    } else {
      tmp = $this._reader.readByteArray();
    }
    var array = tmp;
    var tmp_0;
    if (previousValue == null) {
      tmp_0 = array;
    } else {
      tmp_0 = primitiveArrayConcat([previousValue, array]);
    }
    return tmp_0;
  }
  function deserializeMap($this, deserializer, previousValue) {
    var serializer_11 = deserializer instanceof MapLikeSerializer ? deserializer : THROW_CCE();
    var mapEntrySerial = MapEntrySerializer(serializer_11._keySerializer, serializer_11._valueSerializer);
    var tmp0_safe_receiver = (!(previousValue == null) ? isInterface(previousValue, Map_0) : false) ? previousValue : null;
    var oldSet = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_entries__5();
    var setOfEntries = (new LinkedHashSetSerializer(mapEntrySerial)).merge_5($this, oldSet);
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(setOfEntries, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = setOfEntries.iterator_52();
    while (tmp0_iterator_1_3.hasNext_27()) {
      var element_2_4 = tmp0_iterator_1_3.next_30();
      var tmp = element_2_4._get_key__20();
      tmp0_associateByTo_0_2.put_5(tmp, element_2_4._get_value__12());
      Unit_getInstance();
    }
    var tmp_0 = tmp0_associateByTo_0_2;
    return isObject(tmp_0) ? tmp_0 : THROW_CCE();
  }
  function decodeListIndexNoTag($this) {
    var size_0 = $this._tagOrSize.unaryMinus_4();
    var tmp0_this = $this;
    tmp0_this._index_5 = tmp0_this._index_5 + 1 | 0;
    var idx = tmp0_this._index_5;
    if (toLong_0(idx).equals(size_0))
      return -1;
    return idx;
  }
  function decodeTaggedListIndex($this) {
    var tmp;
    if ($this._index_5 === -1) {
      tmp = $this._get_reader__0()._currentId;
    } else {
      tmp = $this._get_reader__0().readTag();
    }
    var protoId = tmp;
    var tmp_0;
    var tmp0__get_protoId__0 = $this._tagOrSize;
    if (protoId === tmp0__get_protoId__0.and(toLong_0(IntCompanionObject_getInstance()._MAX_VALUE_1)).toInt_5()) {
      var tmp0_this = $this;
      tmp0_this._index_5 = tmp0_this._index_5 + 1 | 0;
      tmp_0 = tmp0_this._index_5;
    } else {
      {
        $this._get_reader__0().pushBackTag();
        tmp_0 = -1;
      }
    }
    return tmp_0;
  }
  function ProtobufReader(input) {
    this._input_0 = input;
    this._currentId = -1;
    this._currentType = -1;
    this._pushBack = false;
  }
  ProtobufReader.prototype.readTag = function () {
    if (this._pushBack) {
      this._pushBack = false;
      return this._currentId;
    }var header = this._input_0.readVarint64(true).toInt_5();
    var tmp;
    if (header === -1) {
      this._currentId = -1;
      this._currentType = -1;
      tmp = -1;
    } else {
      this._currentId = header >>> 3;
      this._currentType = header & 7;
      tmp = this._currentId;
    }
    return tmp;
  };
  ProtobufReader.prototype.pushBackTag = function () {
    this._pushBack = true;
  };
  ProtobufReader.prototype.skipElement_0 = function () {
    var tmp0_subject = this._currentType;
    switch (tmp0_subject) {
      case 0:
        this.readInt(ProtoIntegerType_DEFAULT_getInstance());
        Unit_getInstance();
        break;
      case 1:
        this.readLong(ProtoIntegerType_FIXED_getInstance());
        Unit_getInstance();
        break;
      case 2:
        this.readByteArray();
        Unit_getInstance();
        break;
      case 5:
        this.readInt(ProtoIntegerType_FIXED_getInstance());
        Unit_getInstance();
        break;
      default:throw new ProtobufDecodingException('' + 'Unsupported start group or end group wire type: ' + this._currentType);
    }
  };
  ProtobufReader.prototype.readByteArray = function () {
    var tmp0_assertWireType_0 = 2;
    if (!(this._currentType === tmp0_assertWireType_0))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + tmp0_assertWireType_0 + ', but found ' + this._currentType);
    return this.readByteArrayNoTag();
  };
  ProtobufReader.prototype.readByteArrayNoTag = function () {
    var length = decode32$default(this, null, 2, null);
    checkLength(this, length);
    return this._input_0.readExactNBytes(length);
  };
  ProtobufReader.prototype.objectInput = function () {
    var tmp0_assertWireType_0 = 2;
    if (!(this._currentType === tmp0_assertWireType_0))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + tmp0_assertWireType_0 + ', but found ' + this._currentType);
    return this.objectTaglessInput();
  };
  ProtobufReader.prototype.objectTaglessInput = function () {
    var length = decode32$default(this, null, 2, null);
    checkLength(this, length);
    return this._input_0.slice_0(length);
  };
  ProtobufReader.prototype.readInt = function (format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    if (!(this._currentType === wireType))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + wireType + ', but found ' + this._currentType);
    return decode32(this, format);
  };
  ProtobufReader.prototype.readInt32NoTag = function () {
    return decode32$default(this, null, 2, null);
  };
  ProtobufReader.prototype.readLong = function (format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 1 : 0;
    if (!(this._currentType === wireType))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + wireType + ', but found ' + this._currentType);
    return decode64(this, format);
  };
  ProtobufReader.prototype.readLongNoTag = function () {
    return decode64(this, ProtoIntegerType_DEFAULT_getInstance());
  };
  ProtobufReader.prototype.readFloat = function () {
    var tmp0_assertWireType_0 = 5;
    if (!(this._currentType === tmp0_assertWireType_0))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + tmp0_assertWireType_0 + ', but found ' + this._currentType);
    var tmp1_fromBits_0 = FloatCompanionObject_getInstance();
    var tmp2_fromBits_0 = readIntLittleEndian(this);
    return floatFromBits(tmp2_fromBits_0);
  };
  ProtobufReader.prototype.readFloatNoTag = function () {
    var tmp0_fromBits_0 = FloatCompanionObject_getInstance();
    var tmp1_fromBits_0 = readIntLittleEndian(this);
    return floatFromBits(tmp1_fromBits_0);
  };
  ProtobufReader.prototype.readDouble = function () {
    var tmp0_assertWireType_0 = 1;
    if (!(this._currentType === tmp0_assertWireType_0))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + tmp0_assertWireType_0 + ', but found ' + this._currentType);
    var tmp1_fromBits_0 = DoubleCompanionObject_getInstance();
    var tmp2_fromBits_0 = readLongLittleEndian(this);
    return doubleFromBits(tmp2_fromBits_0);
  };
  ProtobufReader.prototype.readDoubleNoTag = function () {
    var tmp0_fromBits_0 = DoubleCompanionObject_getInstance();
    var tmp1_fromBits_0 = readLongLittleEndian(this);
    return doubleFromBits(tmp1_fromBits_0);
  };
  ProtobufReader.prototype.readString = function () {
    var tmp0_assertWireType_0 = 2;
    if (!(this._currentType === tmp0_assertWireType_0))
      throw new ProtobufDecodingException('' + 'Expected wire type ' + tmp0_assertWireType_0 + ', but found ' + this._currentType);
    var length = decode32$default(this, null, 2, null);
    checkLength(this, length);
    return this._input_0.readString_0(length);
  };
  ProtobufReader.prototype.readStringNoTag = function () {
    var length = decode32$default(this, null, 2, null);
    checkLength(this, length);
    return this._input_0.readString_0(length);
  };
  ProtobufReader.$metadata$ = {
    simpleName: 'ProtobufReader',
    kind: 'class',
    interfaces: []
  };
  function readIntLittleEndian($this) {
    var result = 0;
    var inductionVariable = 0;
    var last_2 = 3;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var byte = $this._input_0.read_1() & 255;
        result = result | byte << imul(i, 8);
      }
       while (inductionVariable <= last_2);
    return result;
  }
  function readLongLittleEndian($this) {
    var result = new Long(0, 0);
    var inductionVariable = 0;
    var last_2 = 7;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var byte = toLong_0($this._input_0.read_1() & 255);
        result = result.or(byte.shl_0(imul(i, 8)));
      }
       while (inductionVariable <= last_2);
    return result;
  }
  function checkLength($this, length) {
    if (length < 0) {
      throw new ProtobufDecodingException('' + 'Unexpected negative length: ' + length);
    }}
  function decode32($this, format) {
    var tmp0_subject = format;
    var tmp;
    if (tmp0_subject.equals(ProtoIntegerType_DEFAULT_getInstance())) {
      tmp = $this._input_0.readVarint64(false).toInt_5();
    } else if (tmp0_subject.equals(ProtoIntegerType_SIGNED_getInstance())) {
      tmp = decodeSignedVarintInt($this, $this._input_0);
    } else if (tmp0_subject.equals(ProtoIntegerType_FIXED_getInstance())) {
      tmp = readIntLittleEndian($this);
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function decode32$default($this, format, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      format = ProtoIntegerType_DEFAULT_getInstance();
    return decode32($this, format);
  }
  function decode64($this, format) {
    var tmp0_subject = format;
    var tmp;
    if (tmp0_subject.equals(ProtoIntegerType_DEFAULT_getInstance())) {
      tmp = $this._input_0.readVarint64(false);
    } else if (tmp0_subject.equals(ProtoIntegerType_SIGNED_getInstance())) {
      tmp = decodeSignedVarintLong($this, $this._input_0);
    } else if (tmp0_subject.equals(ProtoIntegerType_FIXED_getInstance())) {
      tmp = readLongLittleEndian($this);
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function decodeSignedVarintInt($this, input) {
    var raw = input.readVarint32();
    var temp = (raw << 31 >> 31 ^ raw) >> 1;
    return temp ^ raw & -2147483648;
  }
  function decodeSignedVarintLong($this, input) {
    var raw = input.readVarint64(false);
    var temp = raw.shl_0(63).shr_0(63).xor(raw).shr_0(1);
    return temp.xor(raw.and(new Long(0, -2147483648)));
  }
  function ProtobufTaggedBase() {
    this._tagsStack = longArray(8);
    this._stackSize = -1;
  }
  ProtobufTaggedBase.prototype._get_currentTagOrDefault__2 = function () {
    return this._stackSize === -1 ? new Long(19500, 0) : this._tagsStack[this._stackSize];
  };
  ProtobufTaggedBase.prototype.popTagOrDefault_3 = function () {
    var tmp;
    if (this._stackSize === -1) {
      tmp = new Long(19500, 0);
    } else {
      var tmp_0 = this._tagsStack;
      var tmp0_this = this;
      var tmp1 = tmp0_this._stackSize;
      tmp0_this._stackSize = tmp1 - 1 | 0;
      tmp = tmp_0[tmp1];
    }
    return tmp;
  };
  ProtobufTaggedBase.prototype.pushTag_5 = function (tag) {
    if (tag.equals(new Long(19500, 0)))
      return Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._stackSize = tmp0_this._stackSize + 1 | 0;
    var idx = tmp0_this._stackSize;
    if (this._stackSize >= this._tagsStack.length) {
      expand(this);
    }this._tagsStack[idx] = tag;
  };
  ProtobufTaggedBase.$metadata$ = {
    simpleName: 'ProtobufTaggedBase',
    kind: 'class',
    interfaces: []
  };
  function expand($this) {
    $this._tagsStack = copyOf_2($this._tagsStack, imul($this._tagsStack.length, 2));
  }
  function ProtobufTaggedDecoder() {
    ProtobufTaggedBase.call(this);
  }
  ProtobufTaggedDecoder.prototype.decodeNotNullMark_11 = function () {
    return true;
  };
  ProtobufTaggedDecoder.prototype.decodeNull_11 = function () {
    return null;
  };
  ProtobufTaggedDecoder.prototype.decodeBoolean_11 = function () {
    return this.decodeTaggedBoolean_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeByte_11 = function () {
    return this.decodeTaggedByte_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeShort_11 = function () {
    return this.decodeTaggedShort_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeInt_11 = function () {
    return this.decodeTaggedInt_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeLong_11 = function () {
    return this.decodeTaggedLong_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeFloat_11 = function () {
    return this.decodeTaggedFloat_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeDouble_11 = function () {
    return this.decodeTaggedDouble_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeChar_11 = function () {
    return this.decodeTaggedChar_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeString_11 = function () {
    return this.decodeTaggedString_4(this.popTagOrDefault_3());
  };
  ProtobufTaggedDecoder.prototype.decodeEnum_11 = function (enumDescriptor) {
    return this.decodeTaggedEnum_4(this.popTagOrDefault_3(), enumDescriptor);
  };
  ProtobufTaggedDecoder.prototype.beginStructure_11 = function (descriptor) {
    return this;
  };
  ProtobufTaggedDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  ProtobufTaggedDecoder.prototype.decodeBooleanElement_11 = function (descriptor, index) {
    return this.decodeTaggedBoolean_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeByteElement_11 = function (descriptor, index) {
    return this.decodeTaggedByte_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeShortElement_11 = function (descriptor, index) {
    return this.decodeTaggedShort_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeIntElement_11 = function (descriptor, index) {
    return this.decodeTaggedInt_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeLongElement_11 = function (descriptor, index) {
    return this.decodeTaggedLong_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeFloatElement_11 = function (descriptor, index) {
    return this.decodeTaggedFloat_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeDoubleElement_11 = function (descriptor, index) {
    return this.decodeTaggedDouble_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeCharElement_11 = function (descriptor, index) {
    return this.decodeTaggedChar_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeStringElement_11 = function (descriptor, index) {
    return this.decodeTaggedString_4(this.getTag_8(descriptor, index));
  };
  ProtobufTaggedDecoder.prototype.decodeSerializableElement_11 = function (descriptor, index, deserializer, previousValue) {
    var tmp0_tagBlock_0 = this.getTag_8(descriptor, index);
    this.pushTag_5(tmp0_tagBlock_0);
    return this.decodeSerializableValue_22(deserializer, previousValue);
  };
  ProtobufTaggedDecoder.$metadata$ = {
    simpleName: 'ProtobufTaggedDecoder',
    kind: 'class',
    interfaces: [Decoder, CompositeDecoder]
  };
  function ByteArrayInput(array, endIndex) {
    this._array_0 = array;
    this._endIndex = endIndex;
    this._position_7 = 0;
  }
  ByteArrayInput.prototype._get_availableBytes_ = function () {
    return this._endIndex - this._position_7 | 0;
  };
  ByteArrayInput.prototype.slice_0 = function (size_0) {
    ensureEnoughBytes(this, size_0);
    var result = new ByteArrayInput(this._array_0, this._position_7 + size_0 | 0);
    result._position_7 = this._position_7;
    var tmp0_this = this;
    tmp0_this._position_7 = tmp0_this._position_7 + size_0 | 0;
    return result;
  };
  ByteArrayInput.prototype.read_1 = function () {
    var tmp;
    if (this._position_7 < this._endIndex) {
      var tmp_0 = this._array_0;
      var tmp0_this = this;
      var tmp1 = tmp0_this._position_7;
      tmp0_this._position_7 = tmp1 + 1 | 0;
      tmp = tmp_0[tmp1] & 255;
    } else {
      tmp = -1;
    }
    return tmp;
  };
  ByteArrayInput.prototype.readExactNBytes = function (bytesCount) {
    ensureEnoughBytes(this, bytesCount);
    var b = new Int8Array(bytesCount);
    var length = b.length;
    var copied = (this._endIndex - this._position_7 | 0) < length ? this._endIndex - this._position_7 | 0 : length;
    var tmp0_copyInto_0 = this._array_0;
    var tmp1_copyInto_0 = 0;
    var tmp2_copyInto_0 = this._position_7;
    var tmp3_copyInto_0 = this._position_7 + copied | 0;
    var tmp = tmp0_copyInto_0;
    arrayCopy_0(tmp, b, tmp1_copyInto_0, tmp2_copyInto_0, tmp3_copyInto_0);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._position_7 = tmp0_this._position_7 + copied | 0;
    return b;
  };
  ByteArrayInput.prototype.readString_0 = function (length) {
    var tmp = this._array_0;
    var tmp_0 = this._position_7;
    var tmp_1 = this._position_7 + length | 0;
    var result = decodeToString$default(tmp, tmp_0, tmp_1, false, 4, null);
    var tmp0_this = this;
    tmp0_this._position_7 = tmp0_this._position_7 + length | 0;
    return result;
  };
  ByteArrayInput.prototype.readVarint32 = function () {
    if (this._position_7 === this._endIndex) {
      eof(this);
    }var currentPosition = this._position_7;
    var tmp = this._array_0;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = tmp[tmp0];
    if (result >= 0) {
      this._position_7 = currentPosition;
      return result;
    } else if ((this._endIndex - this._position_7 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this._array_0;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0 ^ tmp_1[tmp1] << 7;
      if (result < 0) {
        this._position_7 = currentPosition;
        return result ^ -128;
      }}return readVarint32SlowPath(this);
  };
  ByteArrayInput.prototype.readVarint64 = function (eofAllowed) {
    if (this._position_7 === this._endIndex) {
      if (eofAllowed)
        return new Long(-1, -1);
      else
        eof(this);
    }var currentPosition = this._position_7;
    var tmp = this._array_0;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = toLong_0(tmp[tmp0]);
    if (result.compareTo_48(new Long(0, 0)) >= 0) {
      this._position_7 = currentPosition;
      return result;
    } else if ((this._endIndex - this._position_7 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this._array_0;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0.xor(toLong_0(tmp_1[tmp1]).shl_0(7));
      if (result.compareTo_48(new Long(0, 0)) < 0) {
        this._position_7 = currentPosition;
        return result.xor(new Long(-128, -1));
      }}return readVarint64SlowPath(this);
  };
  ByteArrayInput.$metadata$ = {
    simpleName: 'ByteArrayInput',
    kind: 'class',
    interfaces: []
  };
  function ByteArrayInput_init_$Init$(array, endIndex, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      endIndex = array.length;
    ByteArrayInput.call($this, array, endIndex);
    return $this;
  }
  function ByteArrayInput_init_$Create$(array, endIndex, $mask0, $marker) {
    return ByteArrayInput_init_$Init$(array, endIndex, $mask0, $marker, Object.create(ByteArrayInput.prototype));
  }
  function ensureEnoughBytes($this, bytesCount) {
    if (bytesCount > $this._get_availableBytes_()) {
      throw SerializationException_init_$Create$('' + 'Unexpected EOF, available ' + $this._get_availableBytes_() + ' bytes, requested: ' + bytesCount);
    }}
  function eof($this) {
    throw SerializationException_init_$Create$('Unexpected EOF');
  }
  function readVarint64SlowPath($this) {
    var result = new Long(0, 0);
    var shift = 0;
    while (!(shift === 64)) {
      var byte = $this.read_1();
      result = result.or(toLong_0(byte & 127).shl_0(shift));
      if ((byte & 128) === 0) {
        return result;
      }shift = shift + 7 | 0;
    }
    throw SerializationException_init_$Create$('Varint too long: exceeded 64 bits');
  }
  function readVarint32SlowPath($this) {
    var result = 0;
    var shift = 0;
    while (!(shift === 32)) {
      var byte = $this.read_1();
      result = result | (byte & 127) << shift;
      if ((byte & 128) === 0) {
        return result;
      }shift = shift + 7 | 0;
    }
    throw SerializationException_init_$Create$('Varint too long: exceeded 32 bits');
  }
  function Json(configuration) {
    this._configuration = configuration;
  }
  Json.prototype._get_configuration__4 = function () {
    return this._configuration;
  };
  Json.prototype._get_serializersModule__19 = function () {
    return this._configuration._serializersModule_2;
  };
  Json.prototype.decodeFromString_2 = function (deserializer, string) {
    var reader = new JsonReader(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), reader);
    var result = input.decodeSerializableValue_23(deserializer);
    if (!reader._get_isDone_()) {
      var tmp0_error_0 = '' + 'Reader has not consumed the whole input: ' + reader;
      throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
    }return result;
  };
  Json.$metadata$ = {
    simpleName: 'Json',
    kind: 'class',
    interfaces: [StringFormat]
  };
  function Json_0(from, builderAction) {
    var builder = new JsonBuilder(from._configuration);
    builderAction(builder);
    var conf = builder.build_10();
    return new JsonImpl(conf);
  }
  function Json$default(from, builderAction, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      from = Default_getInstance_1();
    return Json_0(from, builderAction);
  }
  function JsonBuilder(conf) {
    this._encodeDefaults_1 = conf._encodeDefaults_2;
    this._ignoreUnknownKeys = conf._ignoreUnknownKeys_0;
    this._isLenient = conf._isLenient_0;
    this._allowStructuredMapKeys = conf._allowStructuredMapKeys_0;
    this._prettyPrint = conf._prettyPrint_0;
    this._prettyPrintIndent = conf._prettyPrintIndent_0;
    this._coerceInputValues = conf._coerceInputValues_0;
    this._useArrayPolymorphism = conf._useArrayPolymorphism_0;
    this._classDiscriminator = conf._classDiscriminator_0;
    this._allowSpecialFloatingPointValues = conf._allowSpecialFloatingPointValues_0;
    this._serializersModule_1 = conf._serializersModule_2;
  }
  JsonBuilder.prototype.build_10 = function () {
    if (this._useArrayPolymorphism) {
      var tmp0_require_0 = this._classDiscriminator === 'type';
      if (!tmp0_require_0) {
        var message_1 = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1));
      }}if (!this._prettyPrint) {
      var tmp1_require_0 = this._prettyPrintIndent === '    ';
      if (!tmp1_require_0) {
        var message_1_0 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
      }} else if (!(this._prettyPrintIndent === '    ')) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp2_all_0 = this._prettyPrintIndent;
        var indexedObject = tmp2_all_0;
        var inductionVariable = 0;
        var last_2 = indexedObject.length;
        while (inductionVariable < last_2) {
          var element_2 = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          if (!(((element_2.equals(new Char(32)) ? true : element_2.equals(new Char(9))) ? true : element_2.equals(new Char(13))) ? true : element_2.equals(new Char(10)))) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = true;
      }
       while (false);
      var allWhitespaces = tmp$ret$0;
      if (!allWhitespaces) {
        var message_1_1 = '' + 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this._prettyPrintIndent;
        throw IllegalArgumentException_init_$Create$(toString_1(message_1_1));
      }}return new JsonConf(this._encodeDefaults_1, this._ignoreUnknownKeys, this._isLenient, this._allowStructuredMapKeys, this._prettyPrint, this._prettyPrintIndent, this._coerceInputValues, this._useArrayPolymorphism, this._classDiscriminator, this._allowSpecialFloatingPointValues, this._serializersModule_1);
  };
  JsonBuilder.$metadata$ = {
    simpleName: 'JsonBuilder',
    kind: 'class',
    interfaces: []
  };
  function JsonImpl(configuration) {
    Json.call(this, configuration);
    validateConfiguration(this);
  }
  JsonImpl.$metadata$ = {
    simpleName: 'JsonImpl',
    kind: 'class',
    interfaces: []
  };
  function Default_1() {
    Default_instance_1 = this;
    Json.call(this, JsonConf_init_$Create$(false, false, false, false, false, null, false, false, null, false, null, 2047, null));
  }
  Default_1.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance_1;
  function Default_getInstance_1() {
    if (Default_instance_1 == null)
      new Default_1();
    return Default_instance_1;
  }
  function validateConfiguration($this) {
    if (equals_1($this._get_serializersModule__19(), EmptySerializersModule))
      return Unit_getInstance();
    var collector = new PolymorphismValidator($this._get_configuration__4()._useArrayPolymorphism_0, $this._get_configuration__4()._classDiscriminator_0);
    $this._get_serializersModule__19().dumpTo_0(collector);
  }
  function JsonDecoder() {
  }
  JsonDecoder.$metadata$ = {
    simpleName: 'JsonDecoder',
    kind: 'interface',
    interfaces: [Decoder, CompositeDecoder]
  };
  function JsonElement() {
  }
  JsonElement.$metadata$ = {
    simpleName: 'JsonElement',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: JsonElementSerializer_getInstance}
  };
  function JsonObject(content) {
    JsonElement.call(this);
    this._content = content;
  }
  JsonObject.prototype.containsKey_7 = function (key) {
    return this._content.containsKey_8(key);
  };
  JsonObject.prototype.containsKey_8 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_7((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  JsonObject.prototype.get_26 = function (key) {
    return this._content.get_27(key);
  };
  JsonObject.prototype.get_27 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_26((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  JsonObject.prototype.isEmpty_35 = function () {
    return this._content.isEmpty_35();
  };
  JsonObject.prototype._get_entries__5 = function () {
    return this._content._get_entries__5();
  };
  JsonObject.prototype._get_keys__5 = function () {
    return this._content._get_keys__5();
  };
  JsonObject.prototype._get_size__32 = function () {
    return this._content._get_size__32();
  };
  JsonObject.prototype._get_values__6 = function () {
    return this._content._get_values__6();
  };
  JsonObject.prototype.equals = function (other) {
    return equals_1(this._content, other);
  };
  JsonObject.prototype.hashCode = function () {
    return hashCode(this._content);
  };
  JsonObject.prototype.toString = function () {
    var tmp = this._content._get_entries__5();
    return joinToString$default_0(tmp, ',', '{', '}', 0, null, _no_name_provided_$factory_53(), 24, null);
  };
  JsonObject.$metadata$ = {
    simpleName: 'JsonObject',
    kind: 'class',
    interfaces: [Map_0],
    associatedObjects: {0: JsonObjectSerializer_getInstance}
  };
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this._content_0 = 'null';
  }
  JsonNull.prototype._get_content__3 = function () {
    return this._content_0;
  };
  JsonNull.$metadata$ = {
    simpleName: 'JsonNull',
    kind: 'object',
    interfaces: []
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  JsonPrimitive.prototype.toString = function () {
    return this._get_content__3();
  };
  JsonPrimitive.$metadata$ = {
    simpleName: 'JsonPrimitive',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: JsonPrimitiveSerializer_getInstance}
  };
  function JsonPrimitive_0(value) {
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this._content_1 = content;
  }
  JsonArray.prototype.contains_34 = function (element) {
    return this._content_1.contains_35(element);
  };
  JsonArray.prototype.contains_35 = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    else {
    }
    return this.contains_34(element instanceof JsonElement ? element : THROW_CCE());
  };
  JsonArray.prototype.containsAll_25 = function (elements) {
    return this._content_1.containsAll_26(elements);
  };
  JsonArray.prototype.containsAll_26 = function (elements) {
    return this.containsAll_25(elements);
  };
  JsonArray.prototype.get_57 = function (index) {
    return this._content_1.get_57(index);
  };
  JsonArray.prototype.isEmpty_35 = function () {
    return this._content_1.isEmpty_35();
  };
  JsonArray.prototype.iterator_52 = function () {
    return this._content_1.iterator_52();
  };
  JsonArray.prototype.listIterator_5 = function (index) {
    return this._content_1.listIterator_5(index);
  };
  JsonArray.prototype._get_size__32 = function () {
    return this._content_1._get_size__32();
  };
  JsonArray.prototype.equals = function (other) {
    return equals_1(this._content_1, other);
  };
  JsonArray.prototype.hashCode = function () {
    return hashCode(this._content_1);
  };
  JsonArray.prototype.toString = function () {
    return joinToString$default_0(this._content_1, ',', '[', ']', 0, null, null, 56, null);
  };
  JsonArray.$metadata$ = {
    simpleName: 'JsonArray',
    kind: 'class',
    interfaces: [List],
    associatedObjects: {0: JsonArraySerializer_getInstance}
  };
  function JsonLiteral(body, isString_0) {
    JsonPrimitive.call(this);
    this._isString = isString_0;
    this._content_2 = toString_1(body);
  }
  JsonLiteral.prototype._get_content__3 = function () {
    return this._content_2;
  };
  JsonLiteral.prototype.toString = function () {
    var tmp;
    if (this._isString) {
      var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
      printQuoted(tmp0_apply_0_1, this._content_2);
      tmp = tmp0_apply_0_1.toString();
    } else {
      tmp = this._content_2;
    }
    return tmp;
  };
  JsonLiteral.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression_0(this).equals(getKClassFromExpression_0(other)))
      return false;
    if (other instanceof JsonLiteral)
      other;
    else
      THROW_CCE();
    Unit_getInstance();
    if (!(this._isString === other._isString))
      return false;
    if (!(this._content_2 === other._content_2))
      return false;
    return true;
  };
  JsonLiteral.prototype.hashCode = function () {
    var result = this._isString | 0;
    result = imul(31, result) + getStringHashCode(this._content_2) | 0;
    return result;
  };
  JsonLiteral.$metadata$ = {
    simpleName: 'JsonLiteral',
    kind: 'class',
    interfaces: []
  };
  function _get_boolean_(_this_) {
    return toBooleanStrict(_this_._get_content__3());
  }
  function _get_int_(_this_) {
    return toInt(_this_._get_content__3());
  }
  function _get_long_(_this_) {
    return toLong(_this_._get_content__3());
  }
  function _get_float_(_this_) {
    var tmp0_toFloat_0 = _this_._get_content__3();
    var tmp0_unsafeCast_0_1 = toDouble(tmp0_toFloat_0);
    return tmp0_unsafeCast_0_1;
  }
  function _get_double_(_this_) {
    return toDouble(_this_._get_content__3());
  }
  function _get_contentOrNull_(_this_) {
    var tmp;
    if (_this_ instanceof JsonNull) {
      tmp = null;
    } else {
      {
        tmp = _this_._get_content__3();
      }
    }
    return tmp;
  }
  function _get_jsonPrimitive_(_this_) {
    var tmp0_elvis_lhs = _this_ instanceof JsonPrimitive ? _this_ : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error_0(_this_, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error_0(_this_, element) {
    throw IllegalArgumentException_init_$Create$('' + 'Element ' + getKClassFromExpression_0(_this_) + ' is not a ' + element);
  }
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__74();
    return function (p1) {
      return i.invoke_100(p1);
    };
  }
  function _no_name_provided__74() {
  }
  _no_name_provided__74.prototype.invoke_100 = function (_name_for_destructuring_parameter_0_) {
    var k = _name_for_destructuring_parameter_0_._get_key__20();
    var v = _name_for_destructuring_parameter_0_._get_value__12();
    return '' + '"' + k + '":' + v;
  };
  _no_name_provided__74.prototype.invoke_276 = function (p1) {
    return this.invoke_100((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    var tmp_1 = [];
    tmp._descriptor_23 = buildSerialDescriptor$default('kotlinx.serialization.json.JsonElement', tmp_0, tmp_1, _no_name_provided_$factory_54(), 4, null);
  }
  JsonElementSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_23;
  };
  JsonElementSerializer.prototype.deserialize_69 = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.decodeJsonElement_4();
  };
  JsonElementSerializer.$metadata$ = {
    simpleName: 'JsonElementSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this._descriptor_24 = JsonObjectDescriptor_getInstance();
  }
  JsonObjectSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_24;
  };
  JsonObjectSerializer.prototype.deserialize_69 = function (decoder) {
    verify(decoder);
    return new JsonObject(MapSerializer(serializer_1(StringCompanionObject_getInstance()), JsonElementSerializer_getInstance()).deserialize_69(decoder));
  };
  JsonObjectSerializer.$metadata$ = {
    simpleName: 'JsonObjectSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this._descriptor_25 = JsonArrayDescriptor_getInstance();
  }
  JsonArraySerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_25;
  };
  JsonArraySerializer.prototype.deserialize_69 = function (decoder) {
    verify(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).deserialize_69(decoder));
  };
  JsonArraySerializer.$metadata$ = {
    simpleName: 'JsonArraySerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function defer(deferred) {
    return new _no_name_provided__75(deferred);
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    var tmp = this;
    var tmp_0 = STRING_getInstance();
    var tmp_1 = [];
    tmp._descriptor_26 = buildSerialDescriptor$default('kotlinx.serialization.json.JsonPrimitive', tmp_0, tmp_1, null, 12, null);
  }
  JsonPrimitiveSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_26;
  };
  JsonPrimitiveSerializer.prototype.deserialize_69 = function (decoder) {
    var result = asJsonDecoder(decoder).decodeJsonElement_4();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, '' + 'Unexpected JSON element, expected JsonPrimitive, had ' + getKClassFromExpression_0(result), toString_1(result));
    else {
    }
    return result;
  };
  JsonPrimitiveSerializer.$metadata$ = {
    simpleName: 'JsonPrimitiveSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    var tmp = this;
    var tmp_0 = ENUM_getInstance();
    var tmp_1 = [];
    tmp._descriptor_27 = buildSerialDescriptor$default('kotlinx.serialization.json.JsonNull', tmp_0, tmp_1, null, 12, null);
  }
  JsonNullSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_27;
  };
  JsonNullSerializer.prototype.deserialize_69 = function (decoder) {
    verify(decoder);
    decoder.decodeNull_11();
    Unit_getInstance();
    return JsonNull_getInstance();
  };
  JsonNullSerializer.$metadata$ = {
    simpleName: 'JsonNullSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this._descriptor_28 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  JsonLiteralSerializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_28;
  };
  JsonLiteralSerializer.prototype.deserialize_69 = function (decoder) {
    var result = asJsonDecoder(decoder).decodeJsonElement_4();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, '' + 'Unexpected JSON element, expected JsonLiteral, had ' + getKClassFromExpression_0(result), toString_1(result));
    else {
    }
    return result;
  };
  JsonLiteralSerializer.$metadata$ = {
    simpleName: 'JsonLiteralSerializer',
    kind: 'object',
    interfaces: [KSerializer]
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function asJsonDecoder(_this_) {
    var tmp0_elvis_lhs = isInterface(_this_, JsonDecoder) ? _this_ : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('' + 'Expected Decoder to be JsonDecoder, got ' + getKClassFromExpression_0(_this_)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify(decoder) {
    asJsonDecoder(decoder);
    Unit_getInstance();
  }
  function _no_name_provided__75($deferred) {
    this._$deferred = $deferred;
    this._original$delegate = lazy(this._$deferred);
  }
  _no_name_provided__75.prototype._get_serialName__16 = function () {
    return _get_original_(this)._get_serialName__16();
  };
  _no_name_provided__75.prototype._get_kind__16 = function () {
    return _get_original_(this)._get_kind__16();
  };
  _no_name_provided__75.prototype._get_elementsCount__16 = function () {
    return _get_original_(this)._get_elementsCount__16();
  };
  _no_name_provided__75.prototype.getElementName_16 = function (index) {
    return _get_original_(this).getElementName_16(index);
  };
  _no_name_provided__75.prototype.getElementIndex_16 = function (name) {
    return _get_original_(this).getElementIndex_16(name);
  };
  _no_name_provided__75.prototype.getElementAnnotations_16 = function (index) {
    return _get_original_(this).getElementAnnotations_16(index);
  };
  _no_name_provided__75.prototype.getElementDescriptor_16 = function (index) {
    return _get_original_(this).getElementDescriptor_16(index);
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: [SerialDescriptor]
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_54() {
    var i = new _no_name_provided__81();
    return function (p1) {
      i.invoke_107(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_55() {
    var i = new _no_name_provided__76();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_56() {
    var i = new _no_name_provided__77();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_57() {
    var i = new _no_name_provided__78();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_58() {
    var i = new _no_name_provided__79();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_59() {
    var i = new _no_name_provided__80();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided__76() {
  }
  _no_name_provided__76.prototype.invoke_274 = function () {
    return JsonPrimitiveSerializer_getInstance()._descriptor_26;
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__77() {
  }
  _no_name_provided__77.prototype.invoke_274 = function () {
    return JsonNullSerializer_getInstance()._descriptor_27;
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__78() {
  }
  _no_name_provided__78.prototype.invoke_274 = function () {
    return JsonLiteralSerializer_getInstance()._descriptor_28;
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__79() {
  }
  _no_name_provided__79.prototype.invoke_274 = function () {
    return JsonObjectSerializer_getInstance()._descriptor_24;
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__80() {
  }
  _no_name_provided__80.prototype.invoke_274 = function () {
    return JsonArraySerializer_getInstance()._descriptor_25;
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__81() {
  }
  _no_name_provided__81.prototype.invoke_107 = function (_this__0) {
    var tmp = defer(_no_name_provided_$factory_55());
    _this__0.element$default('JsonPrimitive', tmp, null, false, 12, null);
    var tmp_0 = defer(_no_name_provided_$factory_56());
    _this__0.element$default('JsonNull', tmp_0, null, false, 12, null);
    var tmp_1 = defer(_no_name_provided_$factory_57());
    _this__0.element$default('JsonLiteral', tmp_1, null, false, 12, null);
    var tmp_2 = defer(_no_name_provided_$factory_58());
    _this__0.element$default('JsonObject', tmp_2, null, false, 12, null);
    var tmp_3 = defer(_no_name_provided_$factory_59());
    _this__0.element$default('JsonArray', tmp_3, null, false, 12, null);
  };
  _no_name_provided__81.prototype.invoke_276 = function (p1) {
    this.invoke_107(p1 instanceof ClassSerialDescriptorBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    var tmp = this;
    var tmp0_cast_0_1_1 = serializer(createKType_0(getKClass_0(HashMap), [createInvariantKTypeProjection_0(createKType_0(PrimitiveClasses_getInstance()._get_stringClass_(), [], false)), createInvariantKTypeProjection_0(createKType_0(getKClass_0(JsonElement), [], false))], false));
    tmp._$$delegate_0_0 = (isInterface(tmp0_cast_0_1_1, KSerializer) ? tmp0_cast_0_1_1 : THROW_CCE())._get_descriptor__68();
    this._serialName_7 = 'kotlinx.serialization.json.JsonObject';
  }
  JsonObjectDescriptor.prototype.getElementAnnotations_16 = function (index) {
    return this._$$delegate_0_0.getElementAnnotations_16(index);
  };
  JsonObjectDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return this._$$delegate_0_0.getElementDescriptor_16(index);
  };
  JsonObjectDescriptor.prototype.getElementIndex_16 = function (name) {
    return this._$$delegate_0_0.getElementIndex_16(name);
  };
  JsonObjectDescriptor.prototype.getElementName_16 = function (index) {
    return this._$$delegate_0_0.getElementName_16(index);
  };
  JsonObjectDescriptor.prototype._get_elementsCount__16 = function () {
    return this._$$delegate_0_0._get_elementsCount__16();
  };
  JsonObjectDescriptor.prototype._get_isNullable__16 = function () {
    return this._$$delegate_0_0._get_isNullable__16();
  };
  JsonObjectDescriptor.prototype._get_kind__16 = function () {
    return this._$$delegate_0_0._get_kind__16();
  };
  JsonObjectDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_7;
  };
  JsonObjectDescriptor.$metadata$ = {
    simpleName: 'JsonObjectDescriptor',
    kind: 'object',
    interfaces: [SerialDescriptor]
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    var tmp = this;
    var tmp0_cast_0_1_1 = serializer(createKType_0(getKClass_0(List), [createInvariantKTypeProjection_0(createKType_0(getKClass_0(JsonElement), [], false))], false));
    tmp._$$delegate_0_1 = (isInterface(tmp0_cast_0_1_1, KSerializer) ? tmp0_cast_0_1_1 : THROW_CCE())._get_descriptor__68();
    this._serialName_8 = 'kotlinx.serialization.json.JsonArray';
  }
  JsonArrayDescriptor.prototype.getElementAnnotations_16 = function (index) {
    return this._$$delegate_0_1.getElementAnnotations_16(index);
  };
  JsonArrayDescriptor.prototype.getElementDescriptor_16 = function (index) {
    return this._$$delegate_0_1.getElementDescriptor_16(index);
  };
  JsonArrayDescriptor.prototype.getElementIndex_16 = function (name) {
    return this._$$delegate_0_1.getElementIndex_16(name);
  };
  JsonArrayDescriptor.prototype.getElementName_16 = function (index) {
    return this._$$delegate_0_1.getElementName_16(index);
  };
  JsonArrayDescriptor.prototype._get_elementsCount__16 = function () {
    return this._$$delegate_0_1._get_elementsCount__16();
  };
  JsonArrayDescriptor.prototype._get_isNullable__16 = function () {
    return this._$$delegate_0_1._get_isNullable__16();
  };
  JsonArrayDescriptor.prototype._get_kind__16 = function () {
    return this._$$delegate_0_1._get_kind__16();
  };
  JsonArrayDescriptor.prototype._get_serialName__16 = function () {
    return this._serialName_8;
  };
  JsonArrayDescriptor.$metadata$ = {
    simpleName: 'JsonArrayDescriptor',
    kind: 'object',
    interfaces: [SerialDescriptor]
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function _get_original_($this) {
    var tmp0_getValue_0 = $this._original$delegate;
    var tmp1_getValue_0 = original$factory();
    return tmp0_getValue_0._get_value__12();
  }
  function JsonConf(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule) {
    this._encodeDefaults_2 = encodeDefaults;
    this._ignoreUnknownKeys_0 = ignoreUnknownKeys;
    this._isLenient_0 = isLenient;
    this._allowStructuredMapKeys_0 = allowStructuredMapKeys;
    this._prettyPrint_0 = prettyPrint;
    this._prettyPrintIndent_0 = prettyPrintIndent;
    this._coerceInputValues_0 = coerceInputValues;
    this._useArrayPolymorphism_0 = useArrayPolymorphism;
    this._classDiscriminator_0 = classDiscriminator;
    this._allowSpecialFloatingPointValues_0 = allowSpecialFloatingPointValues;
    this._serializersModule_2 = serializersModule;
  }
  JsonConf.prototype.toString = function () {
    return '' + 'JsonConf(encodeDefaults=' + this._encodeDefaults_2 + ', ignoreUnknownKeys=' + this._ignoreUnknownKeys_0 + ', isLenient=' + this._isLenient_0 + ', allowStructuredMapKeys=' + this._allowStructuredMapKeys_0 + ', prettyPrint=' + this._prettyPrint_0 + ', prettyPrintIndent=' + this._prettyPrintIndent_0 + ', coerceInputValues=' + this._coerceInputValues_0 + ', useArrayPolymorphism=' + this._useArrayPolymorphism_0 + ', classDiscriminator=' + this._classDiscriminator_0 + ', allowSpecialFloatingPointValues=' + this._allowSpecialFloatingPointValues_0 + ', serializersModule=' + this._serializersModule_2 + ')';
  };
  JsonConf.prototype.hashCode = function () {
    return imul(imul(imul(imul(imul(imul(imul(imul(imul(imul(this._encodeDefaults_2 | 0, 31) + (this._ignoreUnknownKeys_0 | 0) | 0, 31) + (this._isLenient_0 | 0) | 0, 31) + (this._allowStructuredMapKeys_0 | 0) | 0, 31) + (this._prettyPrint_0 | 0) | 0, 31) + getStringHashCode(this._prettyPrintIndent_0) | 0, 31) + (this._coerceInputValues_0 | 0) | 0, 31) + (this._useArrayPolymorphism_0 | 0) | 0, 31) + getStringHashCode(this._classDiscriminator_0) | 0, 31) + (this._allowSpecialFloatingPointValues_0 | 0) | 0, 31) + hashCode(this._serializersModule_2) | 0;
  };
  JsonConf.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonConf))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof JsonConf ? other : THROW_CCE();
    if (!(this._encodeDefaults_2 === tmp0_other_with_cast._encodeDefaults_2))
      return false;
    if (!(this._ignoreUnknownKeys_0 === tmp0_other_with_cast._ignoreUnknownKeys_0))
      return false;
    if (!(this._isLenient_0 === tmp0_other_with_cast._isLenient_0))
      return false;
    if (!(this._allowStructuredMapKeys_0 === tmp0_other_with_cast._allowStructuredMapKeys_0))
      return false;
    if (!(this._prettyPrint_0 === tmp0_other_with_cast._prettyPrint_0))
      return false;
    if (!(this._prettyPrintIndent_0 === tmp0_other_with_cast._prettyPrintIndent_0))
      return false;
    if (!(this._coerceInputValues_0 === tmp0_other_with_cast._coerceInputValues_0))
      return false;
    if (!(this._useArrayPolymorphism_0 === tmp0_other_with_cast._useArrayPolymorphism_0))
      return false;
    if (!(this._classDiscriminator_0 === tmp0_other_with_cast._classDiscriminator_0))
      return false;
    if (!(this._allowSpecialFloatingPointValues_0 === tmp0_other_with_cast._allowSpecialFloatingPointValues_0))
      return false;
    if (!equals_1(this._serializersModule_2, tmp0_other_with_cast._serializersModule_2))
      return false;
    return true;
  };
  JsonConf.$metadata$ = {
    simpleName: 'JsonConf',
    kind: 'class',
    interfaces: []
  };
  function JsonConf_init_$Init$(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      encodeDefaults = false;
    if (!(($mask0 & 2) === 0))
      ignoreUnknownKeys = false;
    if (!(($mask0 & 4) === 0))
      isLenient = false;
    if (!(($mask0 & 8) === 0))
      allowStructuredMapKeys = false;
    if (!(($mask0 & 16) === 0))
      prettyPrint = false;
    if (!(($mask0 & 32) === 0))
      prettyPrintIndent = '    ';
    if (!(($mask0 & 64) === 0))
      coerceInputValues = false;
    if (!(($mask0 & 128) === 0))
      useArrayPolymorphism = false;
    if (!(($mask0 & 256) === 0))
      classDiscriminator = 'type';
    if (!(($mask0 & 512) === 0))
      allowSpecialFloatingPointValues = false;
    if (!(($mask0 & 1024) === 0))
      serializersModule = EmptySerializersModule;
    JsonConf.call($this, encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule);
    return $this;
  }
  function JsonConf_init_$Create$(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule, $mask0, $marker) {
    return JsonConf_init_$Init$(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, serializersModule, $mask0, $marker, Object.create(JsonConf.prototype));
  }
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  JsonEncodingException.$metadata$ = {
    simpleName: 'JsonEncodingException',
    kind: 'class',
    interfaces: []
  };
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException('' + "Value of type '" + keyDescriptor._get_serialName__16() + "' can't be used in JSON as a key in the map. " + ('' + "It should have either primitive or enum kind, but its kind is '" + keyDescriptor._get_kind__16() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  JsonDecodingException.$metadata$ = {
    simpleName: 'JsonDecodingException',
    kind: 'class',
    interfaces: []
  };
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, '' + message + '\nJSON input: ' + minify(input, offset));
  }
  function throwInvalidFloatingPointDecoded(_this_, result) {
    var tmp = '' + 'Unexpected special floating-point value ' + result + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
    _this_.fail$default(tmp, 0, 2, null);
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function UnknownKeyException(key, input) {
    var tmp = '' + "Encountered unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n";
    return JsonDecodingException_1(-1, tmp + ('' + 'Current input: ' + minify$default(input, 0, 1, null)));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  JsonException.$metadata$ = {
    simpleName: 'JsonException',
    kind: 'class',
    interfaces: []
  };
  function minify(_this_, offset) {
    if (_this_.length < 200)
      return _this_;
    if (offset === -1) {
      var start = _this_.length - 60 | 0;
      if (start <= 0)
        return _this_;
      return '.....' + _this_.substring(start);
    }var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= _this_.length ? '' : '.....';
    var tmp0_substring_0 = coerceAtLeast(start_0, 0);
    var tmp1_substring_0 = coerceAtMost(end, _this_.length);
    return prefix + _this_.substring(tmp0_substring_0, tmp1_substring_0) + suffix;
  }
  function minify$default(_this_, offset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = -1;
    return minify(_this_, offset);
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? '' + 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function unexpectedFpErrorMessage(value, key, output) {
    var tmp = '' + 'Unexpected special floating-point value ' + value + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n";
    return tmp + ('' + 'Current output: ' + minify$default(output, 0, 1, null));
  }
  function JsonParser(configuration, reader) {
    this._reader_0 = reader;
    this._isLenient_1 = configuration._isLenient_0;
  }
  JsonParser.prototype.read_1 = function () {
    if (!this._reader_0._get_canBeginValue_()) {
      this._reader_0.fail$default("Can't begin reading value from here", 0, 2, null);
    }var tmp0_subject = this._reader_0._tokenClass;
    var tmp;
    if (tmp0_subject === 10) {
      var tmp0_also_0 = JsonNull_getInstance();
      this._reader_0.nextToken();
      tmp = tmp0_also_0;
    } else if (tmp0_subject === 1) {
      tmp = readValue(this, true);
    } else if (tmp0_subject === 0) {
      tmp = readValue(this, false);
    } else if (tmp0_subject === 6) {
      tmp = readObject(this);
    } else if (tmp0_subject === 8) {
      tmp = readArray(this);
    } else {
      this._reader_0.fail$default("Can't begin reading element, unexpected token", 0, 2, null);
    }
    return tmp;
  };
  JsonParser.$metadata$ = {
    simpleName: 'JsonParser',
    kind: 'class',
    interfaces: []
  };
  function readObject($this) {
    var tmp0_requireTokenClass_0 = $this._reader_0;
    var tmp1_requireTokenClass_0 = 6;
    if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
      var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
      tmp0_requireTokenClass_0.fail('Expected start of the object', tmp0_requireTokenClass_0._tokenPosition);
    }$this._reader_0.nextToken();
    var tmp3_require_0 = $this._reader_0;
    var tmp4_require_0 = !($this._reader_0._tokenClass === 4);
    var tmp5_require_0 = $this._reader_0._currentPosition;
    if (!tmp4_require_0) {
      tmp3_require_0.fail('Unexpected leading comma', tmp5_require_0);
    }var result = LinkedHashMap_init_$Create$();
    var valueExpected = false;
    while ($this._reader_0._get_canBeginValue_()) {
      valueExpected = false;
      var key = $this._isLenient_1 ? $this._reader_0.takeString() : $this._reader_0.takeStringQuoted();
      var tmp6_requireTokenClass_0 = $this._reader_0;
      var tmp7_requireTokenClass_0 = 5;
      if (!(tmp6_requireTokenClass_0._tokenClass === tmp7_requireTokenClass_0)) {
        var tmp8__anonymous__1 = numberToChar(tmp6_requireTokenClass_0._tokenClass);
        tmp6_requireTokenClass_0.fail("Expected ':'", tmp6_requireTokenClass_0._tokenPosition);
      }$this._reader_0.nextToken();
      var element = $this.read_1();
      result.put_5(key, element);
      Unit_getInstance();
      if (!($this._reader_0._tokenClass === 4)) {
        var tmp9_requireTokenClass_0 = $this._reader_0;
        var tmp10_requireTokenClass_0 = 7;
        if (!(tmp9_requireTokenClass_0._tokenClass === tmp10_requireTokenClass_0)) {
          var tmp11__anonymous__1 = numberToChar(tmp9_requireTokenClass_0._tokenClass);
          tmp9_requireTokenClass_0.fail('Expected end of the object or comma', tmp9_requireTokenClass_0._tokenPosition);
        }} else {
        valueExpected = true;
        $this._reader_0.nextToken();
      }
    }
    var tmp12_require_0 = $this._reader_0;
    var tmp13_require_0 = !valueExpected ? $this._reader_0._tokenClass === 7 : false;
    var tmp14_require_0 = $this._reader_0._currentPosition;
    if (!tmp13_require_0) {
      tmp12_require_0.fail('Expected end of the object', tmp14_require_0);
    }$this._reader_0.nextToken();
    return new JsonObject(result);
  }
  function readArray($this) {
    var tmp0_requireTokenClass_0 = $this._reader_0;
    var tmp1_requireTokenClass_0 = 8;
    if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
      var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
      tmp0_requireTokenClass_0.fail('Expected start of the array', tmp0_requireTokenClass_0._tokenPosition);
    }$this._reader_0.nextToken();
    var tmp3_require_0 = $this._reader_0;
    var tmp4_require_0 = !($this._reader_0._tokenClass === 4);
    var tmp5_require_0 = $this._reader_0._currentPosition;
    if (!tmp4_require_0) {
      tmp3_require_0.fail('Unexpected leading comma', tmp5_require_0);
    }var result = ArrayList_init_$Create$();
    var valueExpected = false;
    while ($this._reader_0._get_canBeginValue_()) {
      valueExpected = false;
      var element = $this.read_1();
      result.add_19(element);
      Unit_getInstance();
      if (!($this._reader_0._tokenClass === 4)) {
        var tmp6_requireTokenClass_0 = $this._reader_0;
        var tmp7_requireTokenClass_0 = 9;
        if (!(tmp6_requireTokenClass_0._tokenClass === tmp7_requireTokenClass_0)) {
          var tmp8__anonymous__1 = numberToChar(tmp6_requireTokenClass_0._tokenClass);
          tmp6_requireTokenClass_0.fail('Expected end of the array or comma', tmp6_requireTokenClass_0._tokenPosition);
        }} else {
        valueExpected = true;
        $this._reader_0.nextToken();
      }
    }
    var tmp9_require_0 = $this._reader_0;
    var tmp10_require_0 = !valueExpected;
    var tmp11_require_0 = $this._reader_0._currentPosition;
    if (!tmp10_require_0) {
      tmp9_require_0.fail('Unexpected trailing comma', tmp11_require_0);
    }$this._reader_0.nextToken();
    return new JsonArray(result);
  }
  function readValue($this, isString_0) {
    var tmp;
    if ($this._isLenient_1) {
      tmp = $this._reader_0.takeString();
    } else {
      tmp = isString_0 ? $this._reader_0.takeStringQuoted() : $this._reader_0.takeString();
    }
    var str = tmp;
    return new JsonLiteral(str, isString_0);
  }
  var C2TC;
  function initC2TC(_this_, c, cl) {
    _this_[c] = cl;
  }
  function initC2TC_0(_this_, c, cl) {
    initC2TC(_this_, c.toInt_5(), cl);
  }
  function JsonReader(source) {
    this._source = source;
    this._currentPosition = 0;
    this._tokenClass = 12;
    this._tokenPosition = 0;
    this._offset = -1;
    this._length = 0;
    this._buf = charArray(16);
    this.nextToken();
  }
  JsonReader.prototype._get_isDone_ = function () {
    return this._tokenClass === 12;
  };
  JsonReader.prototype._get_canBeginValue_ = function () {
    var tmp0_subject = this._tokenClass;
    return ((((tmp0_subject === 8 ? true : tmp0_subject === 6) ? true : tmp0_subject === 0) ? true : tmp0_subject === 1) ? true : tmp0_subject === 10) ? true : false;
  };
  JsonReader.prototype.takeString = function () {
    if (!(this._tokenClass === 0) ? !(this._tokenClass === 1) : false) {
      this.fail('Expected string or non-null literal', this._tokenPosition);
    }return takeStringInternal$default(this, false, 2, null);
  };
  JsonReader.prototype.peekString = function (isLenient) {
    return (!(this._tokenClass === 1) ? !isLenient ? true : !(this._tokenClass === 0) : false) ? null : takeStringInternal(this, false);
  };
  JsonReader.prototype.takeStringQuoted = function () {
    var tmp0_subject = this._tokenClass;
    if (tmp0_subject === 1) {
    } else if (tmp0_subject === 10) {
      this.fail("Expected string literal but 'null' literal was found.\nUse 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.", this._tokenPosition);
    } else {
      this.fail("Expected string literal with quotes.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", this._tokenPosition);
    }
    return takeStringInternal$default(this, false, 2, null);
  };
  JsonReader.prototype.takeBooleanStringUnquoted = function () {
    if (!(this._tokenClass === 0)) {
      this.fail("Expected start of the unquoted boolean literal.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", this._tokenPosition);
    }return takeStringInternal$default(this, false, 2, null);
  };
  JsonReader.prototype.nextToken = function () {
    var source = this._source;
    var currentPosition = this._currentPosition;
    while (currentPosition < source.length) {
      var ch = charSequenceGet(source, currentPosition);
      var tc = charToTokenClass(ch);
      if (tc === 3) {
        var tmp0 = currentPosition;
        currentPosition = tmp0 + 1 | 0;
        Unit_getInstance();
      } else if (tc === 0) {
        nextLiteral(this, source, currentPosition);
        return Unit_getInstance();
      } else if (tc === 1) {
        nextString(this, source, currentPosition);
        return Unit_getInstance();
      } else {
        this._tokenPosition = currentPosition;
        this._tokenClass = tc;
        this._currentPosition = currentPosition + 1 | 0;
        return Unit_getInstance();
      }
    }
    this._tokenPosition = currentPosition;
    this._tokenClass = 12;
  };
  JsonReader.prototype.skipElement_0 = function () {
    if (!(this._tokenClass === 6) ? !(this._tokenClass === 8) : false) {
      this.nextToken();
      return Unit_getInstance();
    }var tokenStack = ArrayList_init_$Create$();
    $l$1: do {
      $l$0: do {
        var tmp0_subject = this._tokenClass;
        if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
          tokenStack.add_19(this._tokenClass);
          Unit_getInstance();
        } else if (tmp0_subject === 9) {
          if (!(last(tokenStack) === 8))
            throw JsonDecodingException_0(this._currentPosition, 'found ] instead of }', this._source);
          tokenStack.removeAt_1(tokenStack._get_size__32() - 1 | 0);
          Unit_getInstance();
        } else if (tmp0_subject === 7) {
          if (!(last(tokenStack) === 6))
            throw JsonDecodingException_0(this._currentPosition, 'found } instead of ]', this._source);
          tokenStack.removeAt_1(tokenStack._get_size__32() - 1 | 0);
          Unit_getInstance();
        }this.nextToken();
      }
       while (false);
    }
     while (!tokenStack.isEmpty_35());
  };
  JsonReader.prototype.toString = function () {
    return '' + "JsonReader(source='" + this._source + "', currentPosition=" + this._currentPosition + ', tokenClass=' + this._tokenClass + ', tokenPosition=' + this._tokenPosition + ', offset=' + this._offset + ')';
  };
  JsonReader.prototype.fail = function (message, position) {
    throw JsonDecodingException_0(position, message, this._source);
  };
  JsonReader.prototype.fail$default = function (message, position, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      position = this._currentPosition;
    return this.fail(message, position);
  };
  JsonReader.$metadata$ = {
    simpleName: 'JsonReader',
    kind: 'class',
    interfaces: []
  };
  function charToTokenClass(c) {
    return c.toInt_5() < 126 ? C2TC[c.toInt_5()] : 0;
  }
  function rangeEquals(source, start, length, str) {
    var n = str.length;
    if (!(length === n))
      return false;
    var inductionVariable = 0;
    var last_2 = n - 1 | 0;
    if (!(n === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!charSequenceGet(source, start + i | 0).equals(charSequenceGet(str, i)))
          return false;
      }
       while (inductionVariable <= last_2);
    return true;
  }
  function escapeToChar(c) {
    return c < 117 ? EscapeCharMappings_getInstance()._ESCAPE_2_CHAR[c] : new Char(0);
  }
  function EscapeCharMappings() {
    EscapeCharMappings_instance = this;
    this._ESCAPE_2_CHAR = charArray(117);
    var inductionVariable = 0;
    var last_2 = 31;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC(this, i, new Char(117));
      }
       while (inductionVariable <= last_2);
    initC2ESC(this, 8, new Char(98));
    initC2ESC(this, 9, new Char(116));
    initC2ESC(this, 10, new Char(110));
    initC2ESC(this, 12, new Char(102));
    initC2ESC(this, 13, new Char(114));
    initC2ESC_0(this, new Char(47), new Char(47));
    initC2ESC_0(this, new Char(34), new Char(34));
    initC2ESC_0(this, new Char(92), new Char(92));
  }
  EscapeCharMappings.$metadata$ = {
    simpleName: 'EscapeCharMappings',
    kind: 'object',
    interfaces: []
  };
  var EscapeCharMappings_instance;
  function EscapeCharMappings_getInstance() {
    if (EscapeCharMappings_instance == null)
      new EscapeCharMappings();
    return EscapeCharMappings_instance;
  }
  function C2TC$init$() {
    var tmp0_apply_0 = new Int8Array(126);
    var inductionVariable = 0;
    var last_2 = 32;
    if (inductionVariable <= last_2)
      do {
        var i_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC(tmp0_apply_0, i_3, 11);
      }
       while (inductionVariable <= last_2);
    initC2TC(tmp0_apply_0, 9, 3);
    initC2TC(tmp0_apply_0, 10, 3);
    initC2TC(tmp0_apply_0, 13, 3);
    initC2TC(tmp0_apply_0, 32, 3);
    initC2TC_0(tmp0_apply_0, new Char(44), 4);
    initC2TC_0(tmp0_apply_0, new Char(58), 5);
    initC2TC_0(tmp0_apply_0, new Char(123), 6);
    initC2TC_0(tmp0_apply_0, new Char(125), 7);
    initC2TC_0(tmp0_apply_0, new Char(91), 8);
    initC2TC_0(tmp0_apply_0, new Char(93), 9);
    initC2TC_0(tmp0_apply_0, new Char(34), 1);
    initC2TC_0(tmp0_apply_0, new Char(92), 2);
    return tmp0_apply_0;
  }
  function takeStringInternal($this, advance) {
    var tmp;
    if ($this._offset < 0) {
      tmp = concatToString($this._buf, 0, 0 + $this._length | 0);
    } else {
      var tmp0_substring_0 = $this._source;
      var tmp1_substring_0 = $this._offset;
      var tmp2_substring_0 = $this._offset + $this._length | 0;
      tmp = tmp0_substring_0.substring(tmp1_substring_0, tmp2_substring_0);
    }
    var prevStr = tmp;
    if (advance)
      $this.nextToken();
    return prevStr;
  }
  function takeStringInternal$default($this, advance, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      advance = true;
    return takeStringInternal($this, advance);
  }
  function append($this, ch) {
    if ($this._length >= $this._buf.length)
      $this._buf = copyOf($this._buf, imul(2, $this._buf.length));
    var tmp = $this._buf;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = ch;
  }
  function appendRange($this, source, fromIndex, toIndex) {
    var addLen = toIndex - fromIndex | 0;
    var oldLen = $this._length;
    var newLen = oldLen + addLen | 0;
    if (newLen > $this._buf.length)
      $this._buf = copyOf($this._buf, coerceAtLeast(newLen, imul(2, $this._buf.length)));
    var inductionVariable = 0;
    var last_2 = addLen - 1 | 0;
    if (!(addLen === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this._buf[oldLen + i | 0] = charSequenceGet(source, fromIndex + i | 0);
      }
       while (inductionVariable <= last_2);
    var tmp1_this = $this;
    tmp1_this._length = tmp1_this._length + addLen | 0;
  }
  function nextLiteral($this, source, startPos) {
    $this._tokenPosition = startPos;
    $this._offset = startPos;
    var currentPosition = startPos;
    while (currentPosition < source.length ? charToTokenClass(charSequenceGet(source, currentPosition)) === 0 : false) {
      var tmp0 = currentPosition;
      currentPosition = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    $this._currentPosition = currentPosition;
    $this._length = currentPosition - $this._offset | 0;
    $this._tokenClass = rangeEquals(source, $this._offset, $this._length, 'null') ? 10 : 0;
  }
  function nextString($this, source, startPosition) {
    $this._tokenPosition = startPosition;
    $this._length = 0;
    var currentPosition = startPosition + 1 | 0;
    if (currentPosition >= source.length) {
      $this.fail('EOF', currentPosition);
    }var lastPosition = currentPosition;
    while (!charSequenceGet(source, currentPosition).equals(new Char(34))) {
      if (charSequenceGet(source, currentPosition).equals(new Char(92))) {
        appendRange($this, source, lastPosition, currentPosition);
        var newPosition = appendEsc($this, source, currentPosition + 1 | 0);
        currentPosition = newPosition;
        lastPosition = newPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= source.length) {
          $this.fail('EOF', currentPosition);
        } else {
        }
      }
    }
    if (lastPosition === (startPosition + 1 | 0)) {
      $this._offset = lastPosition;
      $this._length = currentPosition - lastPosition | 0;
    } else {
      appendRange($this, source, lastPosition, currentPosition);
      $this._offset = -1;
    }
    $this._currentPosition = currentPosition + 1 | 0;
    $this._tokenClass = 1;
  }
  function appendEsc($this, source, startPosition) {
    var currentPosition = startPosition;
    var tmp0_require_0 = currentPosition < source.length;
    var tmp1_require_0 = currentPosition;
    if (!tmp0_require_0) {
      $this.fail('Unexpected EOF after escape character', tmp1_require_0);
    }var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(source, tmp0);
    if (currentChar.equals(new Char(117))) {
      return appendHex($this, source, currentPosition);
    }var c = escapeToChar(currentChar.toInt_5());
    var tmp2_require_0 = !c.equals(new Char(0));
    var tmp3_require_0 = currentPosition;
    if (!tmp2_require_0) {
      $this.fail('' + "Invalid escaped char '" + currentChar + "'", tmp3_require_0);
    }append($this, c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    var curPos = startPos;
    var tmp3 = curPos;
    curPos = tmp3 + 1 | 0;
    var tmp = fromHexChar($this, source, tmp3) << 12;
    var tmp2 = curPos;
    curPos = tmp2 + 1 | 0;
    var tmp_0 = tmp + (fromHexChar($this, source, tmp2) << 8) | 0;
    var tmp1 = curPos;
    curPos = tmp1 + 1 | 0;
    var tmp_1 = tmp_0 + (fromHexChar($this, source, tmp1) << 4) | 0;
    var tmp0 = curPos;
    curPos = tmp0 + 1 | 0;
    append($this, numberToChar(tmp_1 + fromHexChar($this, source, tmp0) | 0));
    return curPos;
  }
  function fromHexChar($this, source, currentPosition) {
    var tmp0_require_0 = currentPosition < source.length;
    if (!tmp0_require_0) {
      $this.fail('Unexpected EOF during unicode escape', currentPosition);
    }var curChar = charSequenceGet(source, currentPosition);
    var tmp;
    if (new Char(48) <= curChar ? curChar <= new Char(57) : false) {
      tmp = curChar.toInt_5() - 48 | 0;
    } else if (new Char(97) <= curChar ? curChar <= new Char(102) : false) {
      tmp = (curChar.toInt_5() - 97 | 0) + 10 | 0;
    } else if (new Char(65) <= curChar ? curChar <= new Char(70) : false) {
      tmp = (curChar.toInt_5() - 65 | 0) + 10 | 0;
    } else {
      var tmp_0 = '' + "Invalid toHexChar char '" + curChar + "' in unicode escape";
      $this.fail$default(tmp_0, 0, 2, null);
    }
    return tmp;
  }
  function initC2ESC($this, c, esc) {
    if (!esc.equals(new Char(117)))
      $this._ESCAPE_2_CHAR[esc.toInt_5()] = numberToChar(c);
  }
  function initC2ESC_0($this, c, esc) {
    return initC2ESC($this, c.toInt_5(), esc);
  }
  function decodeSerializableValuePolymorphic(_this_, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      {
        tmp = _this_._get_json__4()._configuration._useArrayPolymorphism_0;
      }
    }
    if (tmp) {
      return deserializer.deserialize_69(_this_);
    } else {
    }
    var tmp0_cast_0 = _this_.decodeJsonElement_4();
    var tmp1_cast_0 = deserializer._get_descriptor__68();
    if (!(tmp0_cast_0 instanceof JsonObject)) {
      throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonObject) + ' as the serialized body of ' + tmp1_cast_0._get_serialName__16() + ', but had ' + getKClassFromExpression_0(tmp0_cast_0));
    } else {
    }
    var jsonTree = tmp0_cast_0;
    var discriminator = _this_._get_json__4()._configuration._classDiscriminator_0;
    var tmp0_safe_receiver = jsonTree.get_26(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : _get_jsonPrimitive_(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_content__3();
    var tmp2_elvis_lhs = deserializer.findPolymorphicSerializerOrNull_0(_this_, type);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      throwSerializerNotFound(type, jsonTree);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualSerializer = tmp_0;
    var tmp_1 = _this_._get_json__4();
    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
  }
  function throwSerializerNotFound(type, jsonTree) {
    var suffix = type == null ? "missing class discriminator ('null')" : '' + "class discriminator '" + type + "'";
    throw JsonDecodingException_0(-1, '' + 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this._useArrayPolymorphism_1 = useArrayPolymorphism;
    this._discriminator = discriminator;
  }
  PolymorphismValidator.prototype.contextual_1 = function (kClass, serializer_11) {
  };
  PolymorphismValidator.prototype.polymorphic_1 = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer._get_descriptor__68();
    checkKind(this, descriptor, actualClass);
    if (!this._useArrayPolymorphism_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }};
  PolymorphismValidator.prototype.polymorphicDefault_1 = function (baseClass, defaultSerializerProvider) {
  };
  PolymorphismValidator.$metadata$ = {
    simpleName: 'PolymorphismValidator',
    kind: 'class',
    interfaces: [SerializersModuleCollector]
  };
  function checkKind($this, descriptor, actualClass) {
    var kind = descriptor._get_kind__16();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      {
        tmp = equals_1(kind, CONTEXTUAL_getInstance());
      }
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('' + 'Serializer for ' + actualClass._get_simpleName__4() + " can't be registered as a subclass for polymorphic serialization " + ('' + 'because its kind ' + kind + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    } else {
    }
    if ($this._useArrayPolymorphism_1)
      return Unit_getInstance();
    var tmp_0;
    var tmp_1;
    if (equals_1(kind, LIST_getInstance()) ? true : equals_1(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      {
        tmp_0 = kind instanceof ENUM;
      }
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('' + 'Serializer for ' + actualClass._get_simpleName__4() + ' of kind ' + kind + ' cannot be serialized polymorphically with class discriminator.');
    } else {
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var untilArg = descriptor._get_elementsCount__16();
    var inductionVariable = 0;
    var last_2 = untilArg - 1 | 0;
    if (!(untilArg === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.getElementName_16(i);
        if (name === $this._discriminator) {
          throw IllegalArgumentException_init_$Create$('' + 'Polymorphic serializer for ' + actualClass + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }}
       while (inductionVariable <= last_2);
  }
  function StreamingJsonDecoder(json, mode, reader) {
    AbstractDecoder.call(this);
    this._json = json;
    this._mode = mode;
    this._reader_1 = reader;
    this._serializersModule_3 = this._json._get_serializersModule__19();
    this._currentIndex = -1;
    this._configuration_0 = this._json._configuration;
  }
  StreamingJsonDecoder.prototype._get_json__4 = function () {
    return this._json;
  };
  StreamingJsonDecoder.prototype._get_serializersModule__19 = function () {
    return this._serializersModule_3;
  };
  StreamingJsonDecoder.prototype.decodeJsonElement_4 = function () {
    return (new JsonParser(this._json._configuration, this._reader_1)).read_1();
  };
  StreamingJsonDecoder.prototype.decodeSerializableValue_23 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  StreamingJsonDecoder.prototype.beginStructure_11 = function (descriptor) {
    var newMode = switchMode(this._json, descriptor);
    if (!newMode._begin.equals(new Char(0))) {
      var tmp0_requireTokenClass_0 = this._reader_1;
      var tmp1_requireTokenClass_0 = newMode._beginTc;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('' + "Expected '" + newMode._begin + ', kind: ' + descriptor._get_kind__16() + "'", tmp0_requireTokenClass_0._tokenPosition);
      }this._reader_1.nextToken();
    }var tmp0_subject = newMode;
    return ((tmp0_subject.equals(WriteMode_LIST_getInstance()) ? true : tmp0_subject.equals(WriteMode_MAP_getInstance())) ? true : tmp0_subject.equals(WriteMode_POLY_OBJ_getInstance())) ? new StreamingJsonDecoder(this._json, newMode, this._reader_1) : this._mode.equals(newMode) ? this : new StreamingJsonDecoder(this._json, newMode, this._reader_1);
  };
  StreamingJsonDecoder.prototype.endStructure_11 = function (descriptor) {
    if (!this._mode._end.equals(new Char(0))) {
      var tmp0_requireTokenClass_0 = this._reader_1;
      var tmp1_requireTokenClass_0 = this._mode._endTc;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('' + "Expected '" + this._mode._end + "'", tmp0_requireTokenClass_0._tokenPosition);
      }this._reader_1.nextToken();
    }};
  StreamingJsonDecoder.prototype.decodeNotNullMark_11 = function () {
    return !(this._reader_1._tokenClass === 10);
  };
  StreamingJsonDecoder.prototype.decodeNull_11 = function () {
    var tmp0_requireTokenClass_0 = this._reader_1;
    var tmp1_requireTokenClass_0 = 10;
    if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
      var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
      tmp0_requireTokenClass_0.fail("Expected 'null' literal", tmp0_requireTokenClass_0._tokenPosition);
    }this._reader_1.nextToken();
    return null;
  };
  StreamingJsonDecoder.prototype.decodeElementIndex_11 = function (descriptor) {
    var tokenClass = this._reader_1._tokenClass;
    if (tokenClass === 4) {
      var tmp0_require_0 = this._reader_1;
      var tmp1_require_0 = !(this._currentIndex === -1);
      var tmp2_require_0 = this._reader_1._currentPosition;
      if (!tmp1_require_0) {
        tmp0_require_0.fail('Unexpected leading comma', tmp2_require_0);
      }this._reader_1.nextToken();
    }var tmp0_subject = this._mode;
    var tmp;
    if (tmp0_subject.equals(WriteMode_LIST_getInstance())) {
      tmp = decodeListIndex(this, tokenClass);
    } else if (tmp0_subject.equals(WriteMode_MAP_getInstance())) {
      tmp = decodeMapIndex(this, tokenClass);
    } else if (tmp0_subject.equals(WriteMode_POLY_OBJ_getInstance())) {
      var tmp1_this = this;
      tmp1_this._currentIndex = tmp1_this._currentIndex + 1 | 0;
      var tmp2_subject = tmp1_this._currentIndex;
      var tmp_0;
      switch (tmp2_subject) {
        case 0:
          tmp_0 = 0;
          break;
        case 1:
          tmp_0 = 1;
          break;
        default:tmp_0 = -1;
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = decodeObjectIndex(this, tokenClass, descriptor);
    }
    return tmp;
  };
  StreamingJsonDecoder.prototype.decodeBoolean_11 = function () {
    var tmp;
    if (this._configuration_0._isLenient_0) {
      tmp = toBooleanStrict(this._reader_1.takeString());
    } else {
      tmp = toBooleanStrict(this._reader_1.takeBooleanStringUnquoted());
    }
    return tmp;
  };
  StreamingJsonDecoder.prototype.decodeByte_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'byte';
      try {
        tmp$ret$0 = toByte(tmp0_parse_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeShort_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'short';
      try {
        tmp$ret$0 = toShort(tmp0_parse_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeInt_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'int';
      try {
        tmp$ret$0 = toInt(tmp0_parse_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeLong_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'long';
      try {
        tmp$ret$0 = toLong(tmp0_parse_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeFloat_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'float';
      try {
        var tmp0_unsafeCast_0_1_3 = toDouble(tmp0_parse_0);
        tmp$ret$0 = tmp0_unsafeCast_0_1_3;
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._json._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this._reader_1, result);
  };
  StreamingJsonDecoder.prototype.decodeDouble_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'double';
      try {
        tmp$ret$0 = toDouble(tmp0_parse_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._json._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this._reader_1, result);
  };
  StreamingJsonDecoder.prototype.decodeChar_11 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_parse_0 = this._reader_1.takeString();
      var tmp1_parse_0 = 'char';
      try {
        tmp$ret$0 = single_1(tmp0_parse_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp = '' + "Failed to parse '" + tmp1_parse_0 + "'";
          this._reader_1.fail$default(tmp, 0, 2, null);
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  StreamingJsonDecoder.prototype.decodeString_11 = function () {
    var tmp;
    if (this._configuration_0._isLenient_0) {
      tmp = this._reader_1.takeString();
    } else {
      tmp = this._reader_1.takeStringQuoted();
    }
    return tmp;
  };
  StreamingJsonDecoder.prototype.decodeEnum_11 = function (enumDescriptor) {
    return getElementIndexOrThrow(enumDescriptor, this.decodeString_11());
  };
  StreamingJsonDecoder.$metadata$ = {
    simpleName: 'StreamingJsonDecoder',
    kind: 'class',
    interfaces: [JsonDecoder]
  };
  function decodeMapIndex($this, tokenClass) {
    if (!(tokenClass === 4) ? $this._currentIndex % 2 === 1 : false) {
      var tmp0_requireTokenClass_0 = $this._reader_1;
      var tmp1_requireTokenClass_0 = 7;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('Expected end of the object or comma', tmp0_requireTokenClass_0._tokenPosition);
      }}if ($this._currentIndex % 2 === 0) {
      var tmp3_requireTokenClass_0 = $this._reader_1;
      var tmp4_requireTokenClass_0 = 5;
      if (!(tmp3_requireTokenClass_0._tokenClass === tmp4_requireTokenClass_0)) {
        var tmp5__anonymous__1 = numberToChar(tmp3_requireTokenClass_0._tokenClass);
        tmp3_requireTokenClass_0.fail("Expected ':' after the key", tmp3_requireTokenClass_0._tokenPosition);
      }$this._reader_1.nextToken();
    }var tmp;
    if (!$this._reader_1._get_canBeginValue_()) {
      var tmp6_require_0 = $this._reader_1;
      var tmp7_require_0 = !(tokenClass === 4);
      var tmp8_require_0 = tmp6_require_0._currentPosition;
      if (!tmp7_require_0) {
        tmp6_require_0.fail('Unexpected trailing comma', tmp8_require_0);
      }tmp = -1;
    } else {
      var tmp0_this = $this;
      tmp0_this._currentIndex = tmp0_this._currentIndex + 1 | 0;
      tmp = tmp0_this._currentIndex;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var elementDescriptor = descriptor.getElementDescriptor_16(index);
    if ($this._reader_1._tokenClass === 10 ? !elementDescriptor._get_isNullable__16() : false)
      return true;
    if (equals_1(elementDescriptor._get_kind__16(), ENUM_getInstance())) {
      var tmp0_elvis_lhs = $this._reader_1.peekString($this._configuration_0._isLenient_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var enumValue = tmp;
      var enumIndex = elementDescriptor.getElementIndex_16(enumValue);
      if (enumIndex === -3)
        return true;
    }return false;
  }
  function decodeObjectIndex($this, tokenClass, descriptor) {
    if (tokenClass === 4 ? !$this._reader_1._get_canBeginValue_() : false) {
      $this._reader_1.fail$default('Unexpected trailing comma', 0, 2, null);
    }while ($this._reader_1._get_canBeginValue_()) {
      var tmp0_this = $this;
      tmp0_this._currentIndex = tmp0_this._currentIndex + 1 | 0;
      Unit_getInstance();
      var key = $this.decodeString_11();
      var tmp0_requireTokenClass_0 = $this._reader_1;
      var tmp1_requireTokenClass_0 = 5;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail("Expected ':'", tmp0_requireTokenClass_0._tokenPosition);
      }$this._reader_1.nextToken();
      var index = descriptor.getElementIndex_16(key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this._configuration_0._coerceInputValues_0 ? coerceInputValue($this, descriptor, index) : false) {
          tmp_0 = false;
        } else {
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown ? !$this._configuration_0._ignoreUnknownKeys_0 : false) {
        var tmp_1 = '' + "Encountered an unknown key '" + key + "'.\nUse 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.";
        $this._reader_1.fail$default(tmp_1, 0, 2, null);
      } else {
        $this._reader_1.skipElement_0();
      }
      if ($this._reader_1._tokenClass === 4) {
        $this._reader_1.nextToken();
        var tmp3_require_0 = $this._reader_1;
        var tmp4_require_0 = $this._reader_1._get_canBeginValue_();
        var tmp5_require_0 = $this._reader_1._currentPosition;
        if (!tmp4_require_0) {
          tmp3_require_0.fail('Unexpected trailing comma', tmp5_require_0);
        }}}
    return -1;
  }
  function decodeListIndex($this, tokenClass) {
    if (!(tokenClass === 4) ? !($this._currentIndex === -1) : false) {
      var tmp0_requireTokenClass_0 = $this._reader_1;
      var tmp1_requireTokenClass_0 = 9;
      if (!(tmp0_requireTokenClass_0._tokenClass === tmp1_requireTokenClass_0)) {
        var tmp2__anonymous__1 = numberToChar(tmp0_requireTokenClass_0._tokenClass);
        tmp0_requireTokenClass_0.fail('Expected end of the array or comma', tmp0_requireTokenClass_0._tokenPosition);
      }}var tmp;
    if (!$this._reader_1._get_canBeginValue_()) {
      var tmp3_require_0 = $this._reader_1;
      var tmp4_require_0 = !(tokenClass === 4);
      var tmp5_require_0 = tmp3_require_0._currentPosition;
      if (!tmp4_require_0) {
        tmp3_require_0.fail('Unexpected trailing comma', tmp5_require_0);
      }tmp = -1;
    } else {
      var tmp0_this = $this;
      tmp0_this._currentIndex = tmp0_this._currentIndex + 1 | 0;
      tmp = tmp0_this._currentIndex;
    }
    return tmp;
  }
  var ESCAPE_CHARS;
  function toHexChar(i) {
    var d = i & 15;
    return d < 10 ? numberToChar(d + 48 | 0) : numberToChar((d - 10 | 0) + 97 | 0);
  }
  function printQuoted(_this_, value) {
    _this_.append_2(new Char(34));
    Unit_getInstance();
    var lastPos = 0;
    var length = value.length;
    var inductionVariable = 0;
    var last_2 = length - 1 | 0;
    if (!(length === -2147483648) ? inductionVariable <= last_2 : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(value, i).toInt_5();
        if (c >= ESCAPE_CHARS.length)
          continue;
        var tmp1_elvis_lhs = ESCAPE_CHARS[c];
        var tmp;
        if (tmp1_elvis_lhs == null) {
          continue;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var esc = tmp;
        _this_.append_4(value, lastPos, i);
        Unit_getInstance();
        _this_.append_6(esc);
        Unit_getInstance();
        lastPos = i + 1 | 0;
      }
       while (inductionVariable <= last_2);
    _this_.append_4(value, lastPos, length);
    Unit_getInstance();
    _this_.append_2(new Char(34));
    Unit_getInstance();
  }
  function toBooleanStrict(_this_) {
    var tmp0_elvis_lhs = toBooleanStrictOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('' + _this_ + ' does not represent a Boolean');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toBooleanStrictOrNull(_this_) {
    return equals_0(_this_, 'true', true) ? true : equals_0(_this_, 'false', true) ? false : null;
  }
  function ESCAPE_CHARS$init$() {
    var tmp0_arrayOfNulls_0 = 128;
    var tmp1_apply_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var inductionVariable = 0;
    var last_2 = 31;
    if (inductionVariable <= last_2)
      do {
        var c_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1_4 = toHexChar(c_3 >> 12);
        var c2_5 = toHexChar(c_3 >> 8);
        var c3_6 = toHexChar(c_3 >> 4);
        var c4_7 = toHexChar(c_3);
        tmp1_apply_0[c_3] = '' + '\\u' + c1_4 + c2_5 + c3_6 + c4_7;
      }
       while (inductionVariable <= last_2);
    tmp1_apply_0[34] = '\\"';
    tmp1_apply_0[92] = '\\\\';
    tmp1_apply_0[9] = '\\t';
    tmp1_apply_0[8] = '\\b';
    tmp1_apply_0[10] = '\\n';
    tmp1_apply_0[13] = '\\r';
    tmp1_apply_0[12] = '\\f';
    return tmp1_apply_0;
  }
  function getElementIndexOrThrow(_this_, name) {
    var index = _this_.getElementIndex_16(name);
    if (index === -3)
      throw SerializationException_init_$Create$('' + _this_._get_serialName__16() + " does not contain element with name '" + name + "'");
    return index;
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this._json_0 = json;
    this._value_4 = value;
    this._configuration_1 = this._get_json__4()._configuration;
  }
  AbstractJsonTreeDecoder.prototype._get_json__4 = function () {
    return this._json_0;
  };
  AbstractJsonTreeDecoder.prototype._get_value__12 = function () {
    return this._value_4;
  };
  AbstractJsonTreeDecoder.prototype._get_serializersModule__19 = function () {
    return this._get_json__4()._get_serializersModule__19();
  };
  AbstractJsonTreeDecoder.prototype._get_configuration__4 = function () {
    return this._configuration_1;
  };
  AbstractJsonTreeDecoder.prototype.decodeJsonElement_4 = function () {
    return currentObject(this);
  };
  AbstractJsonTreeDecoder.prototype.decodeSerializableValue_23 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  AbstractJsonTreeDecoder.prototype.composeName_3 = function (parentName, childName) {
    return childName;
  };
  AbstractJsonTreeDecoder.prototype.beginStructure_11 = function (descriptor) {
    var currentObject_0 = currentObject(this);
    var tmp0_subject = descriptor._get_kind__16();
    var tmp;
    var tmp_0;
    if (equals_1(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this._get_json__4();
      if (!(currentObject_0 instanceof JsonArray)) {
        throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonArray) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
      } else {
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject_0);
    } else {
      if (equals_1(tmp0_subject, MAP_getInstance())) {
        var tmp0_selectMapMode_0 = this._get_json__4();
        var keyDescriptor_1 = descriptor.getElementDescriptor_16(0);
        var keyKind_2 = keyDescriptor_1._get_kind__16();
        var tmp_2;
        var tmp_3;
        if (keyKind_2 instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          {
            tmp_3 = equals_1(keyKind_2, ENUM_getInstance());
          }
        }
        if (tmp_3) {
          var tmp_4 = this._get_json__4();
          if (!(currentObject_0 instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonObject) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
          } else {
          }
          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject_0);
        } else {
          if (tmp0_selectMapMode_0._configuration._allowStructuredMapKeys_0) {
            var tmp_5 = this._get_json__4();
            if (!(currentObject_0 instanceof JsonArray)) {
              throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonArray) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
            } else {
            }
            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject_0);
          } else {
            {
              throw InvalidKeyKindException(keyDescriptor_1);
            }
          }
        }
        tmp = tmp_2;
      } else {
        {
          var tmp_6 = this._get_json__4();
          if (!(currentObject_0 instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, '' + 'Expected ' + getKClass_0(JsonObject) + ' as the serialized body of ' + descriptor._get_serialName__16() + ', but had ' + getKClassFromExpression_0(currentObject_0));
          } else {
          }
          var tmp_7 = currentObject_0;
          tmp = JsonTreeDecoder_init_$Create$(tmp_6, tmp_7, null, null, 12, null);
        }
      }
    }
    return tmp;
  };
  AbstractJsonTreeDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  AbstractJsonTreeDecoder.prototype.decodeNotNullMark_11 = function () {
    var tmp = currentObject(this);
    return !(tmp instanceof JsonNull);
  };
  AbstractJsonTreeDecoder.prototype.getValue_2 = function (tag) {
    var currentElement = this.currentElement_2(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, '' + 'Expected JsonPrimitive at ' + tag + ', found ' + currentElement, toString_1(currentObject(this)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedEnum_9 = function (tag, enumDescriptor) {
    return getElementIndexOrThrow(enumDescriptor, this.getValue_2(tag)._get_content__3());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedEnum_6 = function (tag, enumDescriptor) {
    return this.decodeTaggedEnum_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_5 = function (tag) {
    return !(this.currentElement_2(tag) === JsonNull_getInstance());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_2 = function (tag) {
    return this.decodeTaggedNotNullMark_5((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_9 = function (tag) {
    var value = this.getValue_2(tag);
    if (!this._get_json__4()._configuration._isLenient_0) {
      var literal = value instanceof JsonLiteral ? value : THROW_CCE();
      if (literal._isString)
        throw JsonDecodingException_0(-1, '' + "Boolean literal for key '" + tag + "' should be unquoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }return _get_boolean_(value);
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_6 = function (tag) {
    return this.decodeTaggedBoolean_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedByte_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'byte';
      try {
        tmp$ret$0 = toByte_0(_get_int_(tmp0_primitive_0));
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedByte_6 = function (tag) {
    return this.decodeTaggedByte_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedShort_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'short';
      try {
        tmp$ret$0 = toShort_0(_get_int_(tmp0_primitive_0));
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedShort_6 = function (tag) {
    return this.decodeTaggedShort_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedInt_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'int';
      try {
        tmp$ret$0 = _get_int_(tmp0_primitive_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedInt_6 = function (tag) {
    return this.decodeTaggedInt_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedLong_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'long';
      try {
        tmp$ret$0 = _get_long_(tmp0_primitive_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedLong_6 = function (tag) {
    return this.decodeTaggedLong_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'float';
      try {
        tmp$ret$0 = _get_float_(tmp0_primitive_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._get_json__4()._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_6 = function (tag) {
    return this.decodeTaggedFloat_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'double';
      try {
        tmp$ret$0 = _get_double_(tmp0_primitive_0);
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    var result = tmp$ret$0;
    var specialFp = this._get_json__4()._configuration._allowSpecialFloatingPointValues_0;
    if (specialFp ? true : isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_6 = function (tag) {
    return this.decodeTaggedDouble_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedChar_9 = function (tag) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_primitive_0 = this.getValue_2(tag);
      var tmp1_primitive_0 = 'char';
      try {
        tmp$ret$0 = single_1(tmp0_primitive_0._get_content__3());
        break l$ret$1;
      } catch ($p) {
        if ($p instanceof Error) {
          throw JsonDecodingException_0(-1, '' + "Failed to parse '" + tmp1_primitive_0 + "'", toString_1(currentObject(this)));
        } else {
          {
            throw $p;
          }
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedChar_6 = function (tag) {
    return this.decodeTaggedChar_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedString_9 = function (tag) {
    var value = this.getValue_2(tag);
    if (!this._get_json__4()._configuration._isLenient_0) {
      var literal = value instanceof JsonLiteral ? value : THROW_CCE();
      if (!literal._isString)
        throw JsonDecodingException_0(-1, '' + "String literal for key '" + tag + "' should be quoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }return value._get_content__3();
  };
  AbstractJsonTreeDecoder.prototype.decodeTaggedString_6 = function (tag) {
    return this.decodeTaggedString_9((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  AbstractJsonTreeDecoder.$metadata$ = {
    simpleName: 'AbstractJsonTreeDecoder',
    kind: 'class',
    interfaces: [JsonDecoder]
  };
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this._value_5 = value;
    this._polyDiscriminator = polyDiscriminator;
    this._polyDescriptor = polyDescriptor;
    this._position_8 = 0;
  }
  JsonTreeDecoder.prototype._get_value__12 = function () {
    return this._value_5;
  };
  JsonTreeDecoder.prototype.decodeElementIndex_11 = function (descriptor) {
    while (this._position_8 < descriptor._get_elementsCount__16()) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._position_8;
      tmp0_this._position_8 = tmp1 + 1 | 0;
      var name = this.getTag_8(descriptor, tmp1);
      var tmp;
      var tmp0_contains_0 = this._get_value__12();
      if ((isInterface(tmp0_contains_0, Map_0) ? tmp0_contains_0 : THROW_CCE()).containsKey_8(name)) {
        tmp = !this._get_configuration__4()._coerceInputValues_0 ? true : !coerceInputValue_0(this, descriptor, this._position_8 - 1 | 0, name);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        return this._position_8 - 1 | 0;
      } else {
      }
    }
    return -1;
  };
  JsonTreeDecoder.prototype.currentElement_2 = function (tag) {
    return getValue(this._get_value__12(), tag);
  };
  JsonTreeDecoder.prototype.beginStructure_11 = function (descriptor) {
    if (descriptor === this._polyDescriptor)
      return this;
    return AbstractJsonTreeDecoder.prototype.beginStructure_11.call(this, descriptor);
  };
  JsonTreeDecoder.prototype.endStructure_11 = function (descriptor) {
    var tmp;
    if (this._get_configuration__4()._ignoreUnknownKeys_0) {
      tmp = true;
    } else {
      var tmp_0 = descriptor._get_kind__16();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_getInstance();
    else {
    }
    var names = jsonCachedSerialNames(descriptor);
    var tmp0_iterator = this._get_value__12()._get_keys__5().iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var key = tmp0_iterator.next_30();
      if (!names.contains_35(key) ? !(key === this._polyDiscriminator) : false) {
        throw UnknownKeyException(key, this._get_value__12().toString());
      }}
  };
  JsonTreeDecoder.$metadata$ = {
    simpleName: 'JsonTreeDecoder',
    kind: 'class',
    interfaces: []
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this._value_6 = value;
    this._size_1 = this._value_6._get_size__32();
    this._currentIndex_0 = -1;
  }
  JsonTreeListDecoder.prototype._get_value__12 = function () {
    return this._value_6;
  };
  JsonTreeListDecoder.prototype.elementName_3 = function (desc, index) {
    return index.toString();
  };
  JsonTreeListDecoder.prototype.currentElement_2 = function (tag) {
    return this._value_6.get_57(toInt(tag));
  };
  JsonTreeListDecoder.prototype.decodeElementIndex_11 = function (descriptor) {
    while (this._currentIndex_0 < (this._size_1 - 1 | 0)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._currentIndex_0;
      tmp0_this._currentIndex_0 = tmp1 + 1 | 0;
      Unit_getInstance();
      return this._currentIndex_0;
    }
    return -1;
  };
  JsonTreeListDecoder.$metadata$ = {
    simpleName: 'JsonTreeListDecoder',
    kind: 'class',
    interfaces: []
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder_init_$Init$(json, value, null, null, 12, null, this);
    this._value_7 = value;
    this._keys_0 = toList_1(this._value_7._get_keys__5());
    this._size_2 = imul(this._keys_0._get_size__32(), 2);
    this._position_9 = -1;
  }
  JsonTreeMapDecoder.prototype._get_value__12 = function () {
    return this._value_7;
  };
  JsonTreeMapDecoder.prototype.elementName_3 = function (desc, index) {
    var i = index / 2 | 0;
    return this._keys_0.get_57(i);
  };
  JsonTreeMapDecoder.prototype.decodeElementIndex_11 = function (descriptor) {
    while (this._position_9 < (this._size_2 - 1 | 0)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._position_9;
      tmp0_this._position_9 = tmp1 + 1 | 0;
      Unit_getInstance();
      return this._position_9;
    }
    return -1;
  };
  JsonTreeMapDecoder.prototype.currentElement_2 = function (tag) {
    return this._position_9 % 2 === 0 ? JsonPrimitive_0(tag) : getValue(this._value_7, tag);
  };
  JsonTreeMapDecoder.prototype.endStructure_11 = function (descriptor) {
  };
  JsonTreeMapDecoder.$metadata$ = {
    simpleName: 'JsonTreeMapDecoder',
    kind: 'class',
    interfaces: []
  };
  function readPolymorphicJson(_this_, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this_, element, discriminator, deserializer._get_descriptor__68())).decodeSerializableValue_23(deserializer);
  }
  function currentObject($this) {
    var tmp0_safe_receiver = $this._get_currentTagOrNull__4();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = $this.currentElement_2(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this._get_value__12() : tmp1_elvis_lhs;
  }
  function JsonTreeDecoder_init_$Init$(json, value, polyDiscriminator, polyDescriptor, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      polyDiscriminator = null;
    if (!(($mask0 & 8) === 0))
      polyDescriptor = null;
    JsonTreeDecoder.call($this, json, value, polyDiscriminator, polyDescriptor);
    return $this;
  }
  function JsonTreeDecoder_init_$Create$(json, value, polyDiscriminator, polyDescriptor, $mask0, $marker) {
    return JsonTreeDecoder_init_$Init$(json, value, polyDiscriminator, polyDescriptor, $mask0, $marker, Object.create(JsonTreeDecoder.prototype));
  }
  function coerceInputValue_0($this, descriptor, index, tag) {
    var elementDescriptor = descriptor.getElementDescriptor_16(index);
    var tmp;
    var tmp_0 = $this.currentElement_2(tag);
    if (tmp_0 instanceof JsonNull) {
      tmp = !elementDescriptor._get_isNullable__16();
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      return true;
    else {
    }
    if (equals_1(elementDescriptor._get_kind__16(), ENUM_getInstance())) {
      var tmp_1 = $this.currentElement_2(tag);
      var tmp0_safe_receiver = tmp_1 instanceof JsonPrimitive ? tmp_1 : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : _get_contentOrNull_(tmp0_safe_receiver);
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var enumValue = tmp_2;
      var enumIndex = elementDescriptor.getElementIndex_16(enumValue);
      if (enumIndex === -3)
        return true;
    }return false;
  }
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this._begin = begin;
    this._end = end;
    this._beginTc = charToTokenClass(this._begin);
    this._endTc = charToTokenClass(this._end);
  }
  WriteMode.$metadata$ = {
    simpleName: 'WriteMode',
    kind: 'class',
    interfaces: []
  };
  function switchMode(_this_, desc) {
    var tmp0_subject = desc._get_kind__16();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals_1(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals_1(tmp0_subject, MAP_getInstance())) {
          var keyDescriptor_1 = desc.getElementDescriptor_16(0);
          var keyKind_2 = keyDescriptor_1._get_kind__16();
          var tmp_0;
          var tmp_1;
          if (keyKind_2 instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            {
              tmp_1 = equals_1(keyKind_2, ENUM_getInstance());
            }
          }
          if (tmp_1) {
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this_._configuration._allowStructuredMapKeys_0) {
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              {
                throw InvalidKeyKindException(keyDescriptor_1);
              }
            }
          }
          tmp = tmp_0;
        } else {
          {
            tmp = WriteMode_OBJ_getInstance();
          }
        }
      }
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_getInstance();
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, new Char(123), new Char(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, new Char(91), new Char(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, new Char(123), new Char(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, new Char(91), new Char(93));
  }
  function Scene() {
  }
  Scene.prototype.toString = function () {
    return '' + 'Scene(perspectiveCameras=' + this._perspectiveCameras + ', orthographicCameras=' + this._orthographicCameras + ', models=' + this._models + ', materials=' + this._materials + ', pointLights=' + this._pointLights + ', armatures=' + this._armatures + ', animations=' + this._animations + ', boxes=' + this._boxes + ', children=' + this._children + ', sprites=' + this._sprites + ')';
  };
  Scene.prototype.hashCode = function () {
    var result = hashCode(this._perspectiveCameras);
    result = imul(result, 31) + hashCode(this._orthographicCameras) | 0;
    result = imul(result, 31) + hashCode(this._models) | 0;
    result = imul(result, 31) + hashCode(this._materials) | 0;
    result = imul(result, 31) + hashCode(this._pointLights) | 0;
    result = imul(result, 31) + hashCode(this._armatures) | 0;
    result = imul(result, 31) + hashCode(this._animations) | 0;
    result = imul(result, 31) + hashCode(this._boxes) | 0;
    result = imul(result, 31) + hashCode(this._children) | 0;
    result = imul(result, 31) + hashCode(this._sprites) | 0;
    return result;
  };
  Scene.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Scene))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Scene ? other : THROW_CCE();
    if (!equals_1(this._perspectiveCameras, tmp0_other_with_cast._perspectiveCameras))
      return false;
    if (!equals_1(this._orthographicCameras, tmp0_other_with_cast._orthographicCameras))
      return false;
    if (!equals_1(this._models, tmp0_other_with_cast._models))
      return false;
    if (!equals_1(this._materials, tmp0_other_with_cast._materials))
      return false;
    if (!equals_1(this._pointLights, tmp0_other_with_cast._pointLights))
      return false;
    if (!equals_1(this._armatures, tmp0_other_with_cast._armatures))
      return false;
    if (!equals_1(this._animations, tmp0_other_with_cast._animations))
      return false;
    if (!equals_1(this._boxes, tmp0_other_with_cast._boxes))
      return false;
    if (!equals_1(this._children, tmp0_other_with_cast._children))
      return false;
    if (!equals_1(this._sprites, tmp0_other_with_cast._sprites))
      return false;
    return true;
  };
  Scene.$metadata$ = {
    simpleName: 'Scene',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance}
  };
  function _no_name_provided_$factory_60() {
    var i = new _no_name_provided__82();
    return function (p1) {
      i.invoke_109(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_61() {
    var i = new _no_name_provided__83();
    return function (p1) {
      i.invoke_111(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__82() {
  }
  _no_name_provided__82.prototype.invoke_109 = function (_this__0) {
    _this__0._serializersModule_1 = Companion_getInstance_12()._serialModule;
  };
  _no_name_provided__82.prototype.invoke_276 = function (p1) {
    this.invoke_109(p1 instanceof JsonBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__83() {
  }
  _no_name_provided__83.prototype.invoke_111 = function (_this__0) {
    _this__0._serializersModule_0 = Companion_getInstance_12()._serialModule;
  };
  _no_name_provided__83.prototype.invoke_276 = function (p1) {
    this.invoke_111(p1 instanceof ProtoBufBuilder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_13() {
    Companion_instance_12 = this;
    var tmp = this;
    var builder_1 = new SerializersModuleBuilder();
    var tmp0_polymorphic_0_3 = getKClass_0(Camera);
    var tmp1_polymorphic_0_4 = null;
    var builder_2_5 = new PolymorphicModuleBuilder(tmp0_polymorphic_0_3, tmp1_polymorphic_0_4);
    var tmp0_subclass_0_4_6 = getKClass_0(PerspectiveCamera);
    var tmp0_cast_0_1_1_5_7 = serializer(createKType_0(getKClass_0(PerspectiveCamera), [], false));
    builder_2_5.subclass(tmp0_subclass_0_4_6, isInterface(tmp0_cast_0_1_1_5_7, KSerializer) ? tmp0_cast_0_1_1_5_7 : THROW_CCE());
    var tmp1_subclass_0_6_8 = getKClass_0(OrthographicCamera);
    var tmp0_cast_0_1_1_7_9 = serializer(createKType_0(getKClass_0(OrthographicCamera), [], false));
    builder_2_5.subclass(tmp1_subclass_0_6_8, isInterface(tmp0_cast_0_1_1_7_9, KSerializer) ? tmp0_cast_0_1_1_7_9 : THROW_CCE());
    builder_2_5.buildTo(builder_1);
    tmp._serialModule = builder_1.build_10();
  }
  Companion_13.prototype.readJson = function (data) {
    var json = Json$default(null, _no_name_provided_$factory_60(), 1, null);
    var tmp0_decodeFromString_0 = decodeToString(data);
    var tmp1_serializer_0_1 = json._get_serializersModule__19();
    var tmp0_cast_0_2 = serializer_0(tmp1_serializer_0_1, createKType_0(getKClass_0(Scene), [], false));
    return json.decodeFromString_2(isInterface(tmp0_cast_0_2, KSerializer) ? tmp0_cast_0_2 : THROW_CCE(), tmp0_decodeFromString_0);
  };
  Companion_13.prototype.readProtobuf = function (data) {
    var protoBuf = ProtoBuf$default(null, _no_name_provided_$factory_61(), 1, null);
    var tmp1_serializer_0_1 = protoBuf._get_serializersModule__19();
    var tmp0_cast_0_2 = serializer_0(tmp1_serializer_0_1, createKType_0(getKClass_0(Scene), [], false));
    return protoBuf.decodeFromByteArray_2(isInterface(tmp0_cast_0_2, KSerializer) ? tmp0_cast_0_2 : THROW_CCE(), data);
  };
  Companion_13.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_13();
    return Companion_instance_12;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.Scene', this, 10);
    tmp0_serialDesc.addElement('perspectiveCameras', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('orthographicCameras', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('models', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('materials', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('pointLights', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    tmp0_serialDesc.addElement('armatures', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(6));
    tmp0_serialDesc.addElement('animations', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(7));
    tmp0_serialDesc.addElement('boxes', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(8));
    tmp0_serialDesc.addElement('children', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(9));
    tmp0_serialDesc.addElement('sprites', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(10));
    this._descriptor_29 = tmp0_serialDesc;
  }
  $serializer.prototype._get_descriptor__68 = function () {
    return this._descriptor_29;
  };
  $serializer.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [new LinkedHashMapSerializer($serializer_getInstance_6(), new PolymorphicSerializer(getKClass_0(Camera))), new LinkedHashMapSerializer($serializer_getInstance_6(), new PolymorphicSerializer(getKClass_0(Camera))), new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_15()), new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_9()), new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_8()), new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_2()), new LinkedHashMapSerializer($serializer_getInstance_6(), new ArrayListSerializer($serializer_getInstance_0())), new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_19()), new ArrayListSerializer($serializer_getInstance_20()), new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_21())];
    return tmp0_arrayOf_0;
  };
  $serializer.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_29;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp14_input.decodeSequentially_11()) {
      tmp4_local0 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 0, new LinkedHashMapSerializer($serializer_getInstance_6(), new PolymorphicSerializer(getKClass_0(Camera))), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 1, new LinkedHashMapSerializer($serializer_getInstance_6(), new PolymorphicSerializer(getKClass_0(Camera))), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 2, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_15()), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 3, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_9()), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 4, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_8()), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 5, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_2()), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 6, new LinkedHashMapSerializer($serializer_getInstance_6(), new ArrayListSerializer($serializer_getInstance_0())), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 7, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_19()), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 8, new ArrayListSerializer($serializer_getInstance_20()), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 9, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_21()), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 0, new LinkedHashMapSerializer($serializer_getInstance_6(), new PolymorphicSerializer(getKClass_0(Camera))), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 1, new LinkedHashMapSerializer($serializer_getInstance_6(), new PolymorphicSerializer(getKClass_0(Camera))), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 2, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_15()), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 3, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_9()), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 4, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_8()), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 5, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_2()), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 6, new LinkedHashMapSerializer($serializer_getInstance_6(), new ArrayListSerializer($serializer_getInstance_0())), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 7, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_19()), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 8, new ArrayListSerializer($serializer_getInstance_20()), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.decodeSerializableElement_11(tmp0_desc, 9, new LinkedHashMapSerializer($serializer_getInstance_6(), $serializer_getInstance_21()), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp14_input.endStructure_11(tmp0_desc);
    return Scene_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  $serializer.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function Scene_init_$Init$(seen1, perspectiveCameras, orthographicCameras, models, materials, pointLights, armatures, animations, boxes, children, sprites, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      $this._perspectiveCameras = emptyMap();
    else
      $this._perspectiveCameras = perspectiveCameras;
    if (0 === (seen1 & 2))
      $this._orthographicCameras = emptyMap();
    else
      $this._orthographicCameras = orthographicCameras;
    if (0 === (seen1 & 4))
      $this._models = emptyMap();
    else
      $this._models = models;
    if (0 === (seen1 & 8))
      $this._materials = emptyMap();
    else
      $this._materials = materials;
    if (0 === (seen1 & 16))
      $this._pointLights = emptyMap();
    else
      $this._pointLights = pointLights;
    if (0 === (seen1 & 32))
      $this._armatures = emptyMap();
    else
      $this._armatures = armatures;
    if (0 === (seen1 & 64))
      $this._animations = emptyMap();
    else
      $this._animations = animations;
    if (0 === (seen1 & 128))
      $this._boxes = emptyMap();
    else
      $this._boxes = boxes;
    if (0 === (seen1 & 256))
      $this._children = emptyList();
    else
      $this._children = children;
    if (0 === (seen1 & 512))
      $this._sprites = emptyMap();
    else
      $this._sprites = sprites;
    return $this;
  }
  function Scene_init_$Create$(seen1, perspectiveCameras, orthographicCameras, models, materials, pointLights, armatures, animations, boxes, children, sprites, serializationConstructorMarker) {
    return Scene_init_$Init$(seen1, perspectiveCameras, orthographicCameras, models, materials, pointLights, armatures, animations, boxes, children, sprites, serializationConstructorMarker, Object.create(Scene.prototype));
  }
  function Animation() {
  }
  Animation.$metadata$ = {
    simpleName: 'Animation',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_0}
  };
  function Frame() {
  }
  Frame.$metadata$ = {
    simpleName: 'Frame',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_1}
  };
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.armature.Animation', this, 5);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('armatureId', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('duration', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('frames', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    this._descriptor_30 = tmp0_serialDesc;
  }
  $serializer_0.prototype._get_descriptor__68 = function () {
    return this._descriptor_30;
  };
  $serializer_0.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), $serializer_getInstance_6(), StringSerializer_getInstance(), FloatSerializer_getInstance(), new ArrayListSerializer($serializer_getInstance_1())];
    return tmp0_arrayOf_0;
  };
  $serializer_0.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_30;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp9_input.decodeSequentially_11()) {
      tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.decodeStringElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.decodeFloatElement_11(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 4, new ArrayListSerializer($serializer_getInstance_1()), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.decodeStringElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.decodeFloatElement_11(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 4, new ArrayListSerializer($serializer_getInstance_1()), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp9_input.endStructure_11(tmp0_desc);
    return Animation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  $serializer_0.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function Animation_init_$Init$(seen1, id, armatureId, name, duration, frames, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('armatureId');
    else
      $this._armatureId = armatureId;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('name');
    else
      $this._name_0 = name;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('duration');
    else
      $this._duration = duration;
    if (0 === (seen1 & 16))
      $this._frames = emptyList();
    else
      $this._frames = frames;
    return $this;
  }
  function Animation_init_$Create$(seen1, id, armatureId, name, duration, frames, serializationConstructorMarker) {
    return Animation_init_$Init$(seen1, id, armatureId, name, duration, frames, serializationConstructorMarker, Object.create(Animation.prototype));
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.armature.Frame', this, 2);
    tmp0_serialDesc.addElement('time', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('globalTransformations', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    this._descriptor_31 = tmp0_serialDesc;
  }
  $serializer_1.prototype._get_descriptor__68 = function () {
    return this._descriptor_31;
  };
  $serializer_1.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [FloatSerializer_getInstance(), new ReferenceArraySerializer(getKClass_0(Transformation), $serializer_getInstance_7())];
    return tmp0_arrayOf_0;
  };
  $serializer_1.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_31;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_11()) {
      tmp4_local0 = tmp6_input.decodeFloatElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeSerializableElement_11(tmp0_desc, 1, new ReferenceArraySerializer(getKClass_0(Transformation), $serializer_getInstance_7()), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeFloatElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeSerializableElement_11(tmp0_desc, 1, new ReferenceArraySerializer(getKClass_0(Transformation), $serializer_getInstance_7()), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return Frame_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_1.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function Frame_init_$Init$(seen1, time, globalTransformations, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('time');
    else
      $this._time = time;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('globalTransformations');
    else
      $this._globalTransformations = globalTransformations;
    return $this;
  }
  function Frame_init_$Create$(seen1, time, globalTransformations, serializationConstructorMarker) {
    return Frame_init_$Init$(seen1, time, globalTransformations, serializationConstructorMarker, Object.create(Frame.prototype));
  }
  function Armature() {
  }
  Armature.$metadata$ = {
    simpleName: 'Armature',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_2}
  };
  function Joint() {
  }
  Joint.$metadata$ = {
    simpleName: 'Joint',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_3}
  };
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.armature.Armature', this, 3);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('joints', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    this._descriptor_32 = tmp0_serialDesc;
  }
  $serializer_2.prototype._get_descriptor__68 = function () {
    return this._descriptor_32;
  };
  $serializer_2.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), new ReferenceArraySerializer(getKClass_0(Joint), $serializer_getInstance_3())];
    return tmp0_arrayOf_0;
  };
  $serializer_2.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_32;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp7_input.decodeSequentially_11()) {
      tmp4_local0 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, new ReferenceArraySerializer(getKClass_0(Joint), $serializer_getInstance_3()), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, new ReferenceArraySerializer(getKClass_0(Joint), $serializer_getInstance_3()), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp7_input.endStructure_11(tmp0_desc);
    return Armature_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  $serializer_2.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function Armature_init_$Init$(seen1, id, name, joints, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_0 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_1 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('joints');
    else
      $this._joints = joints;
    return $this;
  }
  function Armature_init_$Create$(seen1, id, name, joints, serializationConstructorMarker) {
    return Armature_init_$Init$(seen1, id, name, joints, serializationConstructorMarker, Object.create(Armature.prototype));
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.armature.Joint', this, 2);
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('inverseGlobalTransformation', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    this._descriptor_33 = tmp0_serialDesc;
  }
  $serializer_3.prototype._get_descriptor__68 = function () {
    return this._descriptor_33;
  };
  $serializer_3.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [StringSerializer_getInstance(), $serializer_getInstance_7()];
    return tmp0_arrayOf_0;
  };
  $serializer_3.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_33;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_11()) {
      tmp4_local0 = tmp6_input.decodeStringElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeStringElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return Joint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_3.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function Joint_init_$Init$(seen1, name, inverseGlobalTransformation, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('name');
    else
      $this._name_2 = name;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('inverseGlobalTransformation');
    else
      $this._inverseGlobalTransformation = inverseGlobalTransformation;
    return $this;
  }
  function Joint_init_$Create$(seen1, name, inverseGlobalTransformation, serializationConstructorMarker) {
    return Joint_init_$Init$(seen1, name, inverseGlobalTransformation, serializationConstructorMarker, Object.create(Joint.prototype));
  }
  function Camera() {
  }
  Camera.$metadata$ = {
    simpleName: 'Camera',
    kind: 'interface',
    interfaces: []
  };
  function PerspectiveCamera() {
  }
  PerspectiveCamera.prototype.toString = function () {
    return '' + 'PerspectiveCamera(id=' + this._id_1 + ', name=' + this._name_3 + ', far=' + this._far + ', near=' + this._near + ', fov=' + this._fov + ')';
  };
  PerspectiveCamera.prototype.hashCode = function () {
    var result = this._id_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_3) | 0;
    result = imul(result, 31) + getNumberHashCode(this._far) | 0;
    result = imul(result, 31) + getNumberHashCode(this._near) | 0;
    result = imul(result, 31) + getNumberHashCode(this._fov) | 0;
    return result;
  };
  PerspectiveCamera.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PerspectiveCamera))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PerspectiveCamera ? other : THROW_CCE();
    if (!this._id_1.equals(tmp0_other_with_cast._id_1))
      return false;
    if (!(this._name_3 === tmp0_other_with_cast._name_3))
      return false;
    if (!equals_1(this._far, tmp0_other_with_cast._far))
      return false;
    if (!equals_1(this._near, tmp0_other_with_cast._near))
      return false;
    if (!equals_1(this._fov, tmp0_other_with_cast._fov))
      return false;
    return true;
  };
  PerspectiveCamera.$metadata$ = {
    simpleName: 'PerspectiveCamera',
    kind: 'class',
    interfaces: [Camera],
    associatedObjects: {0: $serializer_getInstance_4}
  };
  function OrthographicCamera() {
  }
  OrthographicCamera.prototype.toString = function () {
    return '' + 'OrthographicCamera(id=' + this._id_2 + ', name=' + this._name_4 + ', far=' + this._far_0 + ', near=' + this._near_0 + ', scale=' + this._scale + ')';
  };
  OrthographicCamera.prototype.hashCode = function () {
    var result = this._id_2.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_4) | 0;
    result = imul(result, 31) + getNumberHashCode(this._far_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._near_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale) | 0;
    return result;
  };
  OrthographicCamera.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrthographicCamera))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof OrthographicCamera ? other : THROW_CCE();
    if (!this._id_2.equals(tmp0_other_with_cast._id_2))
      return false;
    if (!(this._name_4 === tmp0_other_with_cast._name_4))
      return false;
    if (!equals_1(this._far_0, tmp0_other_with_cast._far_0))
      return false;
    if (!equals_1(this._near_0, tmp0_other_with_cast._near_0))
      return false;
    if (!equals_1(this._scale, tmp0_other_with_cast._scale))
      return false;
    return true;
  };
  OrthographicCamera.$metadata$ = {
    simpleName: 'OrthographicCamera',
    kind: 'class',
    interfaces: [Camera],
    associatedObjects: {0: $serializer_getInstance_5}
  };
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.camera.PerspectiveCamera', this, 5);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('far', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('near', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('fov', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    this._descriptor_34 = tmp0_serialDesc;
  }
  $serializer_4.prototype._get_descriptor__68 = function () {
    return this._descriptor_34;
  };
  $serializer_4.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_4.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_34;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp9_input.decodeSequentially_11()) {
      tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.decodeFloatElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.decodeFloatElement_11(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.decodeFloatElement_11(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.decodeFloatElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.decodeFloatElement_11(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.decodeFloatElement_11(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp9_input.endStructure_11(tmp0_desc);
    return PerspectiveCamera_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  $serializer_4.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function PerspectiveCamera_init_$Init$(seen1, id, name, far, near, fov, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_1 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_3 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('far');
    else
      $this._far = far;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('near');
    else
      $this._near = near;
    if (0 === (seen1 & 16))
      throw new MissingFieldException('fov');
    else
      $this._fov = fov;
    return $this;
  }
  function PerspectiveCamera_init_$Create$(seen1, id, name, far, near, fov, serializationConstructorMarker) {
    return PerspectiveCamera_init_$Init$(seen1, id, name, far, near, fov, serializationConstructorMarker, Object.create(PerspectiveCamera.prototype));
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.camera.OrthographicCamera', this, 5);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('far', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('near', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('scale', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    this._descriptor_35 = tmp0_serialDesc;
  }
  $serializer_5.prototype._get_descriptor__68 = function () {
    return this._descriptor_35;
  };
  $serializer_5.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_5.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_35;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = 0.0;
    var tmp9_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp9_input.decodeSequentially_11()) {
      tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.decodeFloatElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.decodeFloatElement_11(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.decodeFloatElement_11(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.decodeFloatElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.decodeFloatElement_11(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.decodeFloatElement_11(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp9_input.endStructure_11(tmp0_desc);
    return OrthographicCamera_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  $serializer_5.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function OrthographicCamera_init_$Init$(seen1, id, name, far, near, scale_1, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_2 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_4 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('far');
    else
      $this._far_0 = far;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('near');
    else
      $this._near_0 = near;
    if (0 === (seen1 & 16))
      throw new MissingFieldException('scale');
    else
      $this._scale = scale_1;
    return $this;
  }
  function OrthographicCamera_init_$Create$(seen1, id, name, far, near, scale_1, serializationConstructorMarker) {
    return OrthographicCamera_init_$Init$(seen1, id, name, far, near, scale_1, serializationConstructorMarker, Object.create(OrthographicCamera.prototype));
  }
  function Id(value) {
    this._value_8 = value;
  }
  Id.prototype.toString = function () {
    return '' + 'Id(value=' + this._value_8 + ')';
  };
  Id.prototype.hashCode = function () {
    return getStringHashCode(this._value_8);
  };
  Id.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Id))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Id ? other : THROW_CCE();
    if (!(this._value_8 === tmp0_other_with_cast._value_8))
      return false;
    return true;
  };
  Id.$metadata$ = {
    simpleName: 'Id',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_6}
  };
  function _no_name_provided_$factory_62() {
    var i = new _no_name_provided__84();
    return function (p1) {
      return i.invoke_113(p1);
    };
  }
  function generate($this) {
    var randomValues = new Int8Array(8);
    Default_getInstance().nextBytes_4(randomValues);
    Unit_getInstance();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(randomValues.length);
    var indexedObject = randomValues;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_19(item_2_3 & 15);
      Unit_getInstance();
    }
    return joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, _no_name_provided_$factory_62(), 30, null);
  }
  function _no_name_provided__84() {
  }
  _no_name_provided__84.prototype.invoke_113 = function (it) {
    return Companion_getInstance_13()._CONVERT[it];
  };
  _no_name_provided__84.prototype.invoke_276 = function (p1) {
    return this.invoke_113((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Id_init_$Init$(value, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      value = generate(Companion_getInstance_13());
    Id.call($this, value);
    return $this;
  }
  function Id_init_$Create$(value, $mask0, $marker) {
    return Id_init_$Init$(value, $mask0, $marker, Object.create(Id.prototype));
  }
  function Companion_14() {
    Companion_instance_13 = this;
    this._ID_SIZE = 8;
    var tmp = this;
    var tmp0_arrayOf_0 = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
    tmp._CONVERT = tmp0_arrayOf_0;
    this._None = new Id('NONE');
  }
  Companion_14.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_14();
    return Companion_instance_13;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.common.Id', this, 1);
    tmp0_serialDesc.addElement('value', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    this._descriptor_36 = tmp0_serialDesc;
  }
  $serializer_6.prototype._get_descriptor__68 = function () {
    return this._descriptor_36;
  };
  $serializer_6.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [StringSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_6.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_36;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp5_input.decodeSequentially_11()) {
      tmp4_local0 = tmp5_input.decodeStringElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.decodeStringElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp5_input.endStructure_11(tmp0_desc);
    return Id_init_$Create$_0(tmp3_bitMask0, tmp4_local0, null);
  };
  $serializer_6.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function Id_init_$Init$_0(seen1, value, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      $this._value_8 = generate(Companion_getInstance_13());
    else
      $this._value_8 = value;
    return $this;
  }
  function Id_init_$Create$_0(seen1, value, serializationConstructorMarker) {
    return Id_init_$Init$_0(seen1, value, serializationConstructorMarker, Object.create(Id.prototype));
  }
  function Transformation() {
  }
  Transformation.$metadata$ = {
    simpleName: 'Transformation',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_7}
  };
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.common.Transformation', this, 3);
    tmp0_serialDesc.addElement('translation', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('rotation', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('scale', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    this._descriptor_37 = tmp0_serialDesc;
  }
  $serializer_7.prototype._get_descriptor__68 = function () {
    return this._descriptor_37;
  };
  $serializer_7.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [FloatArraySerializer_getInstance(), FloatArraySerializer_getInstance(), FloatArraySerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_7.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_37;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp7_input.decodeSequentially_11()) {
      tmp4_local0 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 0, FloatArraySerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 1, FloatArraySerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, FloatArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 0, FloatArraySerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 1, FloatArraySerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, FloatArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp7_input.endStructure_11(tmp0_desc);
    return Transformation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  $serializer_7.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function Transformation_init_$Init$(seen1, translation_1, rotation_0, scale_1, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('translation');
    else
      $this._translation = translation_1;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('rotation');
    else
      $this._rotation = rotation_0;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('scale');
    else
      $this._scale_0 = scale_1;
    return $this;
  }
  function Transformation_init_$Create$(seen1, translation_1, rotation_0, scale_1, serializationConstructorMarker) {
    return Transformation_init_$Init$(seen1, translation_1, rotation_0, scale_1, serializationConstructorMarker, Object.create(Transformation.prototype));
  }
  function PointLight() {
  }
  PointLight.prototype.toString = function () {
    return '' + 'PointLight(id=' + this._id_3 + ', name=' + this._name_5 + ', color=' + this._color + ', intensity=' + this._intensity + ')';
  };
  PointLight.prototype.hashCode = function () {
    var result = this._id_3.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_5) | 0;
    result = imul(result, 31) + this._color.hashCode() | 0;
    result = imul(result, 31) + this._intensity | 0;
    return result;
  };
  PointLight.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointLight))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PointLight ? other : THROW_CCE();
    if (!this._id_3.equals(tmp0_other_with_cast._id_3))
      return false;
    if (!(this._name_5 === tmp0_other_with_cast._name_5))
      return false;
    if (!this._color.equals(tmp0_other_with_cast._color))
      return false;
    if (!(this._intensity === tmp0_other_with_cast._intensity))
      return false;
    return true;
  };
  PointLight.$metadata$ = {
    simpleName: 'PointLight',
    kind: 'class',
    interfaces: [Light],
    associatedObjects: {0: $serializer_getInstance_8}
  };
  function Light() {
  }
  Light.$metadata$ = {
    simpleName: 'Light',
    kind: 'interface',
    interfaces: []
  };
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.light.PointLight', this, 4);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('color', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('intensity', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    this._descriptor_38 = tmp0_serialDesc;
  }
  $serializer_8.prototype._get_descriptor__68 = function () {
    return this._descriptor_38;
  };
  $serializer_8.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), $serializer_getInstance_14(), IntSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_8.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_38;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp8_input.decodeSequentially_11()) {
      tmp4_local0 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 2, $serializer_getInstance_14(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.decodeIntElement_11(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 2, $serializer_getInstance_14(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.decodeIntElement_11(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp8_input.endStructure_11(tmp0_desc);
    return PointLight_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  $serializer_8.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function PointLight_init_$Init$(seen1, id, name, color, intensity, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_3 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_5 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('color');
    else
      $this._color = color;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('intensity');
    else
      $this._intensity = intensity;
    return $this;
  }
  function PointLight_init_$Create$(seen1, id, name, color, intensity, serializationConstructorMarker) {
    return PointLight_init_$Init$(seen1, id, name, color, intensity, serializationConstructorMarker, Object.create(PointLight.prototype));
  }
  function Material() {
  }
  Material.$metadata$ = {
    simpleName: 'Material',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_9}
  };
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.material.Material', this, 6);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('width', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('height', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('data', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    tmp0_serialDesc.addElement('hasAlpha', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(6));
    this._descriptor_39 = tmp0_serialDesc;
  }
  $serializer_9.prototype._get_descriptor__68 = function () {
    return this._descriptor_39;
  };
  $serializer_9.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), ByteArraySerializer_getInstance(), BooleanSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_9.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_39;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp10_input.decodeSequentially_11()) {
      tmp4_local0 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.decodeIntElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.decodeIntElement_11(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 4, ByteArraySerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.decodeBooleanElement_11(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.decodeIntElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.decodeIntElement_11(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 4, ByteArraySerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.decodeBooleanElement_11(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp10_input.endStructure_11(tmp0_desc);
    return Material_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  $serializer_9.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function Material_init_$Init$(seen1, id, name, width, height, data, hasAlpha, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_4 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_6 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('width');
    else
      $this._width = width;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('height');
    else
      $this._height = height;
    if (0 === (seen1 & 16))
      throw new MissingFieldException('data');
    else
      $this._data = data;
    if (0 === (seen1 & 32))
      $this._hasAlpha = false;
    else
      $this._hasAlpha = hasAlpha;
    return $this;
  }
  function Material_init_$Create$(seen1, id, name, width, height, data, hasAlpha, serializationConstructorMarker) {
    return Material_init_$Init$(seen1, id, name, width, height, data, hasAlpha, serializationConstructorMarker, Object.create(Material.prototype));
  }
  function Vertex(position, normal, color, uv, influences) {
    this._position_10 = position;
    this._normal = normal;
    this._color_0 = color;
    this._uv = uv;
    this._influences = influences;
  }
  Vertex.prototype.toString = function () {
    return '' + 'Vertex(position=' + this._position_10 + ', normal=' + this._normal + ', color=' + this._color_0 + ', uv=' + this._uv + ', influences=' + this._influences + ')';
  };
  Vertex.prototype.hashCode = function () {
    var result = this._position_10.hashCode();
    result = imul(result, 31) + this._normal.hashCode() | 0;
    result = imul(result, 31) + this._color_0.hashCode() | 0;
    result = imul(result, 31) + this._uv.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._influences) | 0;
    return result;
  };
  Vertex.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vertex))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Vertex ? other : THROW_CCE();
    if (!this._position_10.equals(tmp0_other_with_cast._position_10))
      return false;
    if (!this._normal.equals(tmp0_other_with_cast._normal))
      return false;
    if (!this._color_0.equals(tmp0_other_with_cast._color_0))
      return false;
    if (!this._uv.equals(tmp0_other_with_cast._uv))
      return false;
    if (!equals_1(this._influences, tmp0_other_with_cast._influences))
      return false;
    return true;
  };
  Vertex.$metadata$ = {
    simpleName: 'Vertex',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_10}
  };
  function Position(x, y, z) {
    this._x_4 = x;
    this._y_4 = y;
    this._z_4 = z;
  }
  Position.prototype.toString = function () {
    return '' + 'Position(x=' + this._x_4 + ', y=' + this._y_4 + ', z=' + this._z_4 + ')';
  };
  Position.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_4);
    result = imul(result, 31) + getNumberHashCode(this._y_4) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_4) | 0;
    return result;
  };
  Position.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Position))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Position ? other : THROW_CCE();
    if (!equals_1(this._x_4, tmp0_other_with_cast._x_4))
      return false;
    if (!equals_1(this._y_4, tmp0_other_with_cast._y_4))
      return false;
    if (!equals_1(this._z_4, tmp0_other_with_cast._z_4))
      return false;
    return true;
  };
  Position.$metadata$ = {
    simpleName: 'Position',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_11}
  };
  function Normal(x, y, z) {
    this._x_5 = x;
    this._y_5 = y;
    this._z_5 = z;
  }
  Normal.prototype.toString = function () {
    return '' + 'Normal(x=' + this._x_5 + ', y=' + this._y_5 + ', z=' + this._z_5 + ')';
  };
  Normal.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_5);
    result = imul(result, 31) + getNumberHashCode(this._y_5) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_5) | 0;
    return result;
  };
  Normal.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Normal))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Normal ? other : THROW_CCE();
    if (!equals_1(this._x_5, tmp0_other_with_cast._x_5))
      return false;
    if (!equals_1(this._y_5, tmp0_other_with_cast._y_5))
      return false;
    if (!equals_1(this._z_5, tmp0_other_with_cast._z_5))
      return false;
    return true;
  };
  Normal.$metadata$ = {
    simpleName: 'Normal',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_12}
  };
  function UV(x, y) {
    this._x_6 = x;
    this._y_6 = y;
  }
  UV.prototype.toString = function () {
    return '' + 'UV(x=' + this._x_6 + ', y=' + this._y_6 + ')';
  };
  UV.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_6);
    result = imul(result, 31) + getNumberHashCode(this._y_6) | 0;
    return result;
  };
  UV.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UV))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UV ? other : THROW_CCE();
    if (!equals_1(this._x_6, tmp0_other_with_cast._x_6))
      return false;
    if (!equals_1(this._y_6, tmp0_other_with_cast._y_6))
      return false;
    return true;
  };
  UV.$metadata$ = {
    simpleName: 'UV',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_13}
  };
  function Color(r, g, b, alpha) {
    this._r = r;
    this._g = g;
    this._b = b;
    this._alpha = alpha;
  }
  Color.prototype.toString = function () {
    return '' + 'Color(r=' + this._r + ', g=' + this._g + ', b=' + this._b + ', alpha=' + this._alpha + ')';
  };
  Color.prototype.hashCode = function () {
    var result = getNumberHashCode(this._r);
    result = imul(result, 31) + getNumberHashCode(this._g) | 0;
    result = imul(result, 31) + getNumberHashCode(this._b) | 0;
    result = imul(result, 31) + getNumberHashCode(this._alpha) | 0;
    return result;
  };
  Color.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Color))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Color ? other : THROW_CCE();
    if (!equals_1(this._r, tmp0_other_with_cast._r))
      return false;
    if (!equals_1(this._g, tmp0_other_with_cast._g))
      return false;
    if (!equals_1(this._b, tmp0_other_with_cast._b))
      return false;
    if (!equals_1(this._alpha, tmp0_other_with_cast._alpha))
      return false;
    return true;
  };
  Color.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_14}
  };
  function Model() {
  }
  Model.prototype.toString = function () {
    return '' + 'Model(id=' + this._id_5 + ', name=' + this._name_7 + ', mesh=' + this._mesh + ')';
  };
  Model.prototype.hashCode = function () {
    var result = this._id_5.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_7) | 0;
    result = imul(result, 31) + this._mesh.hashCode() | 0;
    return result;
  };
  Model.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Model))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Model ? other : THROW_CCE();
    if (!this._id_5.equals(tmp0_other_with_cast._id_5))
      return false;
    if (!(this._name_7 === tmp0_other_with_cast._name_7))
      return false;
    if (!this._mesh.equals(tmp0_other_with_cast._mesh))
      return false;
    return true;
  };
  Model.$metadata$ = {
    simpleName: 'Model',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_15}
  };
  function Primitive() {
  }
  Primitive.prototype.toString = function () {
    return '' + 'Primitive(id=' + this._id_6 + ', vertices=' + this._vertices + ', verticesOrder=' + toString_1(this._verticesOrder) + ', materialId=' + this._materialId + ')';
  };
  Primitive.prototype.hashCode = function () {
    var result = this._id_6.hashCode();
    result = imul(result, 31) + hashCode(this._vertices) | 0;
    result = imul(result, 31) + hashCode(this._verticesOrder) | 0;
    result = imul(result, 31) + this._materialId.hashCode() | 0;
    return result;
  };
  Primitive.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Primitive))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Primitive ? other : THROW_CCE();
    if (!this._id_6.equals(tmp0_other_with_cast._id_6))
      return false;
    if (!equals_1(this._vertices, tmp0_other_with_cast._vertices))
      return false;
    if (!equals_1(this._verticesOrder, tmp0_other_with_cast._verticesOrder))
      return false;
    if (!this._materialId.equals(tmp0_other_with_cast._materialId))
      return false;
    return true;
  };
  Primitive.$metadata$ = {
    simpleName: 'Primitive',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_16}
  };
  function Influence() {
  }
  Influence.prototype.toString = function () {
    return '' + 'Influence(jointId=' + this._jointId + ', weight=' + this._weight + ')';
  };
  Influence.prototype.hashCode = function () {
    var result = this._jointId;
    result = imul(result, 31) + getNumberHashCode(this._weight) | 0;
    return result;
  };
  Influence.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Influence))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Influence ? other : THROW_CCE();
    if (!(this._jointId === tmp0_other_with_cast._jointId))
      return false;
    if (!equals_1(this._weight, tmp0_other_with_cast._weight))
      return false;
    return true;
  };
  Influence.$metadata$ = {
    simpleName: 'Influence',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_17}
  };
  function Mesh() {
  }
  Mesh.prototype.toString = function () {
    return '' + 'Mesh(primitives=' + this._primitives + ')';
  };
  Mesh.prototype.hashCode = function () {
    return hashCode(this._primitives);
  };
  Mesh.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mesh))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Mesh ? other : THROW_CCE();
    if (!equals_1(this._primitives, tmp0_other_with_cast._primitives))
      return false;
    return true;
  };
  Mesh.$metadata$ = {
    simpleName: 'Mesh',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_18}
  };
  function Box() {
  }
  Box.prototype.toString = function () {
    return '' + 'Box(id=' + this._id_7 + ', name=' + this._name_8 + ')';
  };
  Box.prototype.hashCode = function () {
    var result = this._id_7.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_8) | 0;
    return result;
  };
  Box.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Box))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Box ? other : THROW_CCE();
    if (!this._id_7.equals(tmp0_other_with_cast._id_7))
      return false;
    if (!(this._name_8 === tmp0_other_with_cast._name_8))
      return false;
    return true;
  };
  Box.$metadata$ = {
    simpleName: 'Box',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_19}
  };
  function Vertex_init_$Init$(position, normal, color, uv, influences, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      color = Companion_getInstance_15()._INVALID_0;
    if (!(($mask0 & 8) === 0))
      uv = Companion_getInstance_14()._INVALID;
    if (!(($mask0 & 16) === 0))
      influences = emptyList();
    Vertex.call($this, position, normal, color, uv, influences);
    return $this;
  }
  function Vertex_init_$Create$(position, normal, color, uv, influences, $mask0, $marker) {
    return Vertex_init_$Init$(position, normal, color, uv, influences, $mask0, $marker, Object.create(Vertex.prototype));
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Vertex', this, 5);
    tmp0_serialDesc.addElement('position', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('normal', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('color', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('uv', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('influences', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    this._descriptor_40 = tmp0_serialDesc;
  }
  $serializer_10.prototype._get_descriptor__68 = function () {
    return this._descriptor_40;
  };
  $serializer_10.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_11(), $serializer_getInstance_12(), $serializer_getInstance_14(), $serializer_getInstance_13(), new ArrayListSerializer($serializer_getInstance_17())];
    return tmp0_arrayOf_0;
  };
  $serializer_10.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_40;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp9_input.decodeSequentially_11()) {
      tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_12(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 2, $serializer_getInstance_14(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 3, $serializer_getInstance_13(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 4, new ArrayListSerializer($serializer_getInstance_17()), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_12(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 2, $serializer_getInstance_14(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 3, $serializer_getInstance_13(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.decodeSerializableElement_11(tmp0_desc, 4, new ArrayListSerializer($serializer_getInstance_17()), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp9_input.endStructure_11(tmp0_desc);
    return Vertex_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  $serializer_10.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function Vertex_init_$Init$_0(seen1, position, normal, color, uv, influences, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('position');
    else
      $this._position_10 = position;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('normal');
    else
      $this._normal = normal;
    if (0 === (seen1 & 4))
      $this._color_0 = Companion_getInstance_15()._INVALID_0;
    else
      $this._color_0 = color;
    if (0 === (seen1 & 8))
      $this._uv = Companion_getInstance_14()._INVALID;
    else
      $this._uv = uv;
    if (0 === (seen1 & 16))
      $this._influences = emptyList();
    else
      $this._influences = influences;
    return $this;
  }
  function Vertex_init_$Create$_0(seen1, position, normal, color, uv, influences, serializationConstructorMarker) {
    return Vertex_init_$Init$_0(seen1, position, normal, color, uv, influences, serializationConstructorMarker, Object.create(Vertex.prototype));
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Position', this, 3);
    tmp0_serialDesc.addElement('x', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('y', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('z', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    this._descriptor_41 = tmp0_serialDesc;
  }
  $serializer_11.prototype._get_descriptor__68 = function () {
    return this._descriptor_41;
  };
  $serializer_11.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_11.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_41;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp7_input.decodeSequentially_11()) {
      tmp4_local0 = tmp7_input.decodeFloatElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.decodeFloatElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.decodeFloatElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.decodeFloatElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp7_input.endStructure_11(tmp0_desc);
    return Position_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  $serializer_11.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function Position_init_$Init$(seen1, x, y, z, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('x');
    else
      $this._x_4 = x;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('y');
    else
      $this._y_4 = y;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('z');
    else
      $this._z_4 = z;
    return $this;
  }
  function Position_init_$Create$(seen1, x, y, z, serializationConstructorMarker) {
    return Position_init_$Init$(seen1, x, y, z, serializationConstructorMarker, Object.create(Position.prototype));
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Normal', this, 3);
    tmp0_serialDesc.addElement('x', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('y', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('z', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    this._descriptor_42 = tmp0_serialDesc;
  }
  $serializer_12.prototype._get_descriptor__68 = function () {
    return this._descriptor_42;
  };
  $serializer_12.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_12.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_42;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp7_input.decodeSequentially_11()) {
      tmp4_local0 = tmp7_input.decodeFloatElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.decodeFloatElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.decodeFloatElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.decodeFloatElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp7_input.endStructure_11(tmp0_desc);
    return Normal_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  $serializer_12.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function Normal_init_$Init$(seen1, x, y, z, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('x');
    else
      $this._x_5 = x;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('y');
    else
      $this._y_5 = y;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('z');
    else
      $this._z_5 = z;
    return $this;
  }
  function Normal_init_$Create$(seen1, x, y, z, serializationConstructorMarker) {
    return Normal_init_$Init$(seen1, x, y, z, serializationConstructorMarker, Object.create(Normal.prototype));
  }
  function Companion_15() {
    Companion_instance_14 = this;
    this._INVALID = new UV(-1.0, -1.0);
  }
  Companion_15.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_15();
    return Companion_instance_14;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.UV', this, 2);
    tmp0_serialDesc.addElement('x', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('y', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    this._descriptor_43 = tmp0_serialDesc;
  }
  $serializer_13.prototype._get_descriptor__68 = function () {
    return this._descriptor_43;
  };
  $serializer_13.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [FloatSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_13.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_43;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_11()) {
      tmp4_local0 = tmp6_input.decodeFloatElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeFloatElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return UV_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_13.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function UV_init_$Init$(seen1, x, y, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('x');
    else
      $this._x_6 = x;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('y');
    else
      $this._y_6 = y;
    return $this;
  }
  function UV_init_$Create$(seen1, x, y, serializationConstructorMarker) {
    return UV_init_$Init$(seen1, x, y, serializationConstructorMarker, Object.create(UV.prototype));
  }
  function Color_init_$Init$(r, g, b, alpha, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      alpha = 1.0;
    Color.call($this, r, g, b, alpha);
    return $this;
  }
  function Color_init_$Create$(r, g, b, alpha, $mask0, $marker) {
    return Color_init_$Init$(r, g, b, alpha, $mask0, $marker, Object.create(Color.prototype));
  }
  function Companion_16() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp._INVALID_0 = Color_init_$Create$(-1.0, -1.0, -1.0, 0.0, 8, null);
  }
  Companion_16.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_16();
    return Companion_instance_15;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Color', this, 4);
    tmp0_serialDesc.addElement('r', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('g', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('b', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('alpha', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    this._descriptor_44 = tmp0_serialDesc;
  }
  $serializer_14.prototype._get_descriptor__68 = function () {
    return this._descriptor_44;
  };
  $serializer_14.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_14.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_44;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0.0;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp8_input.decodeSequentially_11()) {
      tmp4_local0 = tmp8_input.decodeFloatElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.decodeFloatElement_11(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.decodeFloatElement_11(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.decodeFloatElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.decodeFloatElement_11(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.decodeFloatElement_11(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp8_input.endStructure_11(tmp0_desc);
    return Color_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  $serializer_14.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function Color_init_$Init$_0(seen1, r, g, b, alpha, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('r');
    else
      $this._r = r;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('g');
    else
      $this._g = g;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('b');
    else
      $this._b = b;
    if (0 === (seen1 & 8))
      $this._alpha = 1.0;
    else
      $this._alpha = alpha;
    return $this;
  }
  function Color_init_$Create$_0(seen1, r, g, b, alpha, serializationConstructorMarker) {
    return Color_init_$Init$_0(seen1, r, g, b, alpha, serializationConstructorMarker, Object.create(Color.prototype));
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Model', this, 3);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('mesh', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    this._descriptor_45 = tmp0_serialDesc;
  }
  $serializer_15.prototype._get_descriptor__68 = function () {
    return this._descriptor_45;
  };
  $serializer_15.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), $serializer_getInstance_18()];
    return tmp0_arrayOf_0;
  };
  $serializer_15.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_45;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp7_input.decodeSequentially_11()) {
      tmp4_local0 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, $serializer_getInstance_18(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, $serializer_getInstance_18(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp7_input.endStructure_11(tmp0_desc);
    return Model_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  $serializer_15.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function Model_init_$Init$(seen1, id, name, mesh, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_5 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_7 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('mesh');
    else
      $this._mesh = mesh;
    return $this;
  }
  function Model_init_$Create$(seen1, id, name, mesh, serializationConstructorMarker) {
    return Model_init_$Init$(seen1, id, name, mesh, serializationConstructorMarker, Object.create(Model.prototype));
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Primitive', this, 4);
    tmp0_serialDesc.addElement('id', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('vertices', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('verticesOrder', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('materialId', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    this._descriptor_46 = tmp0_serialDesc;
  }
  $serializer_16.prototype._get_descriptor__68 = function () {
    return this._descriptor_46;
  };
  $serializer_16.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), new ArrayListSerializer($serializer_getInstance_10()), IntArraySerializer_getInstance(), $serializer_getInstance_6()];
    return tmp0_arrayOf_0;
  };
  $serializer_16.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_46;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp8_input.decodeSequentially_11()) {
      tmp4_local0 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 1, new ArrayListSerializer($serializer_getInstance_10()), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 3, $serializer_getInstance_6(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 1, new ArrayListSerializer($serializer_getInstance_10()), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 2, IntArraySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 3, $serializer_getInstance_6(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp8_input.endStructure_11(tmp0_desc);
    return Primitive_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  $serializer_16.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function Primitive_init_$Init$(seen1, id, vertices, verticesOrder, materialId, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1)) {
      var tmp = $this;
      tmp._id_6 = Id_init_$Create$(null, 1, null);
    } else
      $this._id_6 = id;
    if (0 === (seen1 & 2))
      $this._vertices = emptyList();
    else
      $this._vertices = vertices;
    if (0 === (seen1 & 4)) {
      var tmp_0 = $this;
      var tmp0_intArrayOf_0 = new Int32Array([]);
      tmp_0._verticesOrder = tmp0_intArrayOf_0;
    } else
      $this._verticesOrder = verticesOrder;
    if (0 === (seen1 & 8))
      $this._materialId = Companion_getInstance_13()._None;
    else
      $this._materialId = materialId;
    return $this;
  }
  function Primitive_init_$Create$(seen1, id, vertices, verticesOrder, materialId, serializationConstructorMarker) {
    return Primitive_init_$Init$(seen1, id, vertices, verticesOrder, materialId, serializationConstructorMarker, Object.create(Primitive.prototype));
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Influence', this, 2);
    tmp0_serialDesc.addElement('jointId', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('weight', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    this._descriptor_47 = tmp0_serialDesc;
  }
  $serializer_17.prototype._get_descriptor__68 = function () {
    return this._descriptor_47;
  };
  $serializer_17.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [IntSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_17.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_47;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_11()) {
      tmp4_local0 = tmp6_input.decodeIntElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeIntElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return Influence_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_17.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function Influence_init_$Init$(seen1, jointId, weight, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('jointId');
    else
      $this._jointId = jointId;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('weight');
    else
      $this._weight = weight;
    return $this;
  }
  function Influence_init_$Create$(seen1, jointId, weight, serializationConstructorMarker) {
    return Influence_init_$Init$(seen1, jointId, weight, serializationConstructorMarker, Object.create(Influence.prototype));
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Mesh', this, 1);
    tmp0_serialDesc.addElement('primitives', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    this._descriptor_48 = tmp0_serialDesc;
  }
  $serializer_18.prototype._get_descriptor__68 = function () {
    return this._descriptor_48;
  };
  $serializer_18.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [new ArrayListSerializer($serializer_getInstance_16())];
    return tmp0_arrayOf_0;
  };
  $serializer_18.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_48;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp5_input.decodeSequentially_11()) {
      tmp4_local0 = tmp5_input.decodeSerializableElement_11(tmp0_desc, 0, new ArrayListSerializer($serializer_getInstance_16()), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.decodeSerializableElement_11(tmp0_desc, 0, new ArrayListSerializer($serializer_getInstance_16()), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp5_input.endStructure_11(tmp0_desc);
    return Mesh_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  $serializer_18.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function Mesh_init_$Init$(seen1, primitives, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('primitives');
    else
      $this._primitives = primitives;
    return $this;
  }
  function Mesh_init_$Create$(seen1, primitives, serializationConstructorMarker) {
    return Mesh_init_$Init$(seen1, primitives, serializationConstructorMarker, Object.create(Mesh.prototype));
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.model.Box', this, 2);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    this._descriptor_49 = tmp0_serialDesc;
  }
  $serializer_19.prototype._get_descriptor__68 = function () {
    return this._descriptor_49;
  };
  $serializer_19.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_19.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_49;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_11()) {
      tmp4_local0 = tmp6_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return Box_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_19.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function Box_init_$Init$(seen1, id, name, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_7 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_8 = name;
    return $this;
  }
  function Box_init_$Create$(seen1, id, name, serializationConstructorMarker) {
    return Box_init_$Init$(seen1, id, name, serializationConstructorMarker, Object.create(Box.prototype));
  }
  function Node_0() {
  }
  Node_0.prototype.toString = function () {
    return '' + 'Node(reference=' + this._reference + ', name=' + this._name_9 + ', type=' + this._type_1 + ', transformation=' + this._transformation + ', children=' + this._children_0 + ', customProperties=' + this._customProperties + ')';
  };
  Node_0.prototype.hashCode = function () {
    var result = this._reference.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_9) | 0;
    result = imul(result, 31) + this._type_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._transformation) | 0;
    result = imul(result, 31) + hashCode(this._children_0) | 0;
    result = imul(result, 31) + hashCode(this._customProperties) | 0;
    return result;
  };
  Node_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Node_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Node_0 ? other : THROW_CCE();
    if (!this._reference.equals(tmp0_other_with_cast._reference))
      return false;
    if (!(this._name_9 === tmp0_other_with_cast._name_9))
      return false;
    if (!this._type_1.equals(tmp0_other_with_cast._type_1))
      return false;
    if (!equals_1(this._transformation, tmp0_other_with_cast._transformation))
      return false;
    if (!equals_1(this._children_0, tmp0_other_with_cast._children_0))
      return false;
    if (!equals_1(this._customProperties, tmp0_other_with_cast._customProperties))
      return false;
    return true;
  };
  Node_0.$metadata$ = {
    simpleName: 'Node',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_20}
  };
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.relation.Node', this, 6);
    tmp0_serialDesc.addElement('reference', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(1));
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(2));
    tmp0_serialDesc.addElement('type', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(3));
    tmp0_serialDesc.addElement('transformation', false);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(4));
    tmp0_serialDesc.addElement('children', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(5));
    tmp0_serialDesc.addElement('customProperties', true);
    tmp0_serialDesc.pushAnnotation(new ProtoNumber(6));
    this._descriptor_50 = tmp0_serialDesc;
  }
  $serializer_20.prototype._get_descriptor__68 = function () {
    return this._descriptor_50;
  };
  $serializer_20.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), StringSerializer_getInstance(), new EnumSerializer('com.dwursteisen.minigdx.scene.api.relation.ObjectType', values()), $serializer_getInstance_7(), new ArrayListSerializer($serializer_getInstance_20()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
    return tmp0_arrayOf_0;
  };
  $serializer_20.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_50;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp10_input.decodeSequentially_11()) {
      tmp4_local0 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.decodeStringElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 2, new EnumSerializer('com.dwursteisen.minigdx.scene.api.relation.ObjectType', values()), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 3, $serializer_getInstance_7(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 4, new ArrayListSerializer($serializer_getInstance_20()), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 5, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.decodeStringElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 2, new EnumSerializer('com.dwursteisen.minigdx.scene.api.relation.ObjectType', values()), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 3, $serializer_getInstance_7(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 4, new ArrayListSerializer($serializer_getInstance_20()), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.decodeSerializableElement_11(tmp0_desc, 5, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp10_input.endStructure_11(tmp0_desc);
    return Node_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  $serializer_20.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function Node_init_$Init$(seen1, reference, name, type, transformation, children, customProperties, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('reference');
    else
      $this._reference = reference;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('name');
    else
      $this._name_9 = name;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('type');
    else
      $this._type_1 = type;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('transformation');
    else
      $this._transformation = transformation;
    if (0 === (seen1 & 16))
      $this._children_0 = emptyList();
    else
      $this._children_0 = children;
    if (0 === (seen1 & 32))
      $this._customProperties = emptyMap();
    else
      $this._customProperties = customProperties;
    return $this;
  }
  function Node_init_$Create$(seen1, reference, name, type, transformation, children, customProperties, serializationConstructorMarker) {
    return Node_init_$Init$(seen1, reference, name, type, transformation, children, customProperties, serializationConstructorMarker, Object.create(Node_0.prototype));
  }
  function ObjectType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ObjectType.$metadata$ = {
    simpleName: 'ObjectType',
    kind: 'class',
    interfaces: []
  };
  function ObjectType_ARMATURE_getInstance() {
    ObjectType_initEntries();
    return ObjectType_ARMATURE_instance;
  }
  function ObjectType_BOX_getInstance() {
    ObjectType_initEntries();
    return ObjectType_BOX_instance;
  }
  function ObjectType_CAMERA_getInstance() {
    ObjectType_initEntries();
    return ObjectType_CAMERA_instance;
  }
  function ObjectType_LIGHT_getInstance() {
    ObjectType_initEntries();
    return ObjectType_LIGHT_instance;
  }
  function ObjectType_MODEL_getInstance() {
    ObjectType_initEntries();
    return ObjectType_MODEL_instance;
  }
  var ObjectType_ARMATURE_instance;
  var ObjectType_BOX_instance;
  var ObjectType_CAMERA_instance;
  var ObjectType_LIGHT_instance;
  var ObjectType_MODEL_instance;
  function values() {
    return [ObjectType_ARMATURE_getInstance(), ObjectType_BOX_getInstance(), ObjectType_CAMERA_getInstance(), ObjectType_LIGHT_getInstance(), ObjectType_MODEL_getInstance()];
  }
  var ObjectType_entriesInitialized;
  function ObjectType_initEntries() {
    if (ObjectType_entriesInitialized)
      return Unit_getInstance();
    ObjectType_entriesInitialized = true;
    ObjectType_ARMATURE_instance = new ObjectType('ARMATURE', 0);
    ObjectType_BOX_instance = new ObjectType('BOX', 1);
    ObjectType_CAMERA_instance = new ObjectType('CAMERA', 2);
    ObjectType_LIGHT_instance = new ObjectType('LIGHT', 3);
    ObjectType_MODEL_instance = new ObjectType('MODEL', 4);
  }
  function Sprite() {
  }
  Sprite.prototype.toString = function () {
    return '' + 'Sprite(id=' + this._id_8 + ', materialReference=' + this._materialReference + ', animations=' + this._animations_0 + ', uvs=' + this._uvs + ')';
  };
  Sprite.prototype.hashCode = function () {
    var result = this._id_8.hashCode();
    result = imul(result, 31) + this._materialReference.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._animations_0) | 0;
    result = imul(result, 31) + hashCode(this._uvs) | 0;
    return result;
  };
  Sprite.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Sprite))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Sprite ? other : THROW_CCE();
    if (!this._id_8.equals(tmp0_other_with_cast._id_8))
      return false;
    if (!this._materialReference.equals(tmp0_other_with_cast._materialReference))
      return false;
    if (!equals_1(this._animations_0, tmp0_other_with_cast._animations_0))
      return false;
    if (!equals_1(this._uvs, tmp0_other_with_cast._uvs))
      return false;
    return true;
  };
  Sprite.$metadata$ = {
    simpleName: 'Sprite',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_21}
  };
  function SpriteAnimation() {
  }
  SpriteAnimation.prototype.toString = function () {
    return '' + 'SpriteAnimation(name=' + this._name_10 + ', duration=' + this._duration_0 + ', frames=' + this._frames_0 + ')';
  };
  SpriteAnimation.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_10);
    result = imul(result, 31) + getNumberHashCode(this._duration_0) | 0;
    result = imul(result, 31) + hashCode(this._frames_0) | 0;
    return result;
  };
  SpriteAnimation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SpriteAnimation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SpriteAnimation ? other : THROW_CCE();
    if (!(this._name_10 === tmp0_other_with_cast._name_10))
      return false;
    if (!equals_1(this._duration_0, tmp0_other_with_cast._duration_0))
      return false;
    if (!equals_1(this._frames_0, tmp0_other_with_cast._frames_0))
      return false;
    return true;
  };
  SpriteAnimation.$metadata$ = {
    simpleName: 'SpriteAnimation',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_22}
  };
  function Frame_0() {
  }
  Frame_0.prototype.toString = function () {
    return '' + 'Frame(uvIndex=' + this._uvIndex + ', duration=' + this._duration_1 + ')';
  };
  Frame_0.prototype.hashCode = function () {
    var result = this._uvIndex;
    result = imul(result, 31) + getNumberHashCode(this._duration_1) | 0;
    return result;
  };
  Frame_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Frame_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Frame_0 ? other : THROW_CCE();
    if (!(this._uvIndex === tmp0_other_with_cast._uvIndex))
      return false;
    if (!equals_1(this._duration_1, tmp0_other_with_cast._duration_1))
      return false;
    return true;
  };
  Frame_0.$metadata$ = {
    simpleName: 'Frame',
    kind: 'class',
    interfaces: [],
    associatedObjects: {0: $serializer_getInstance_23}
  };
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.sprite.Sprite', this, 4);
    tmp0_serialDesc.addElement('id', false);
    tmp0_serialDesc.addElement('materialReference', false);
    tmp0_serialDesc.addElement('animations', false);
    tmp0_serialDesc.addElement('uvs', false);
    this._descriptor_51 = tmp0_serialDesc;
  }
  $serializer_21.prototype._get_descriptor__68 = function () {
    return this._descriptor_51;
  };
  $serializer_21.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [$serializer_getInstance_6(), $serializer_getInstance_6(), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_22()), new ArrayListSerializer($serializer_getInstance_13())];
    return tmp0_arrayOf_0;
  };
  $serializer_21.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_51;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp8_input.decodeSequentially_11()) {
      tmp4_local0 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 2, new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_22()), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 3, new ArrayListSerializer($serializer_getInstance_13()), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 0, $serializer_getInstance_6(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 1, $serializer_getInstance_6(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 2, new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_22()), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.decodeSerializableElement_11(tmp0_desc, 3, new ArrayListSerializer($serializer_getInstance_13()), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp8_input.endStructure_11(tmp0_desc);
    return Sprite_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  $serializer_21.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function Sprite_init_$Init$(seen1, id, materialReference, animations, uvs, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('id');
    else
      $this._id_8 = id;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('materialReference');
    else
      $this._materialReference = materialReference;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('animations');
    else
      $this._animations_0 = animations;
    if (0 === (seen1 & 8))
      throw new MissingFieldException('uvs');
    else
      $this._uvs = uvs;
    return $this;
  }
  function Sprite_init_$Create$(seen1, id, materialReference, animations, uvs, serializationConstructorMarker) {
    return Sprite_init_$Init$(seen1, id, materialReference, animations, uvs, serializationConstructorMarker, Object.create(Sprite.prototype));
  }
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.sprite.SpriteAnimation', this, 3);
    tmp0_serialDesc.addElement('name', false);
    tmp0_serialDesc.addElement('duration', false);
    tmp0_serialDesc.addElement('frames', false);
    this._descriptor_52 = tmp0_serialDesc;
  }
  $serializer_22.prototype._get_descriptor__68 = function () {
    return this._descriptor_52;
  };
  $serializer_22.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [StringSerializer_getInstance(), FloatSerializer_getInstance(), new ArrayListSerializer($serializer_getInstance_23())];
    return tmp0_arrayOf_0;
  };
  $serializer_22.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_52;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0.0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp7_input.decodeSequentially_11()) {
      tmp4_local0 = tmp7_input.decodeStringElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, new ArrayListSerializer($serializer_getInstance_23()), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.decodeStringElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.decodeSerializableElement_11(tmp0_desc, 2, new ArrayListSerializer($serializer_getInstance_23()), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp7_input.endStructure_11(tmp0_desc);
    return SpriteAnimation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  $serializer_22.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function SpriteAnimation_init_$Init$(seen1, name, duration, frames, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('name');
    else
      $this._name_10 = name;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('duration');
    else
      $this._duration_0 = duration;
    if (0 === (seen1 & 4))
      throw new MissingFieldException('frames');
    else
      $this._frames_0 = frames;
    return $this;
  }
  function SpriteAnimation_init_$Create$(seen1, name, duration, frames, serializationConstructorMarker) {
    return SpriteAnimation_init_$Init$(seen1, name, duration, frames, serializationConstructorMarker, Object.create(SpriteAnimation.prototype));
  }
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.dwursteisen.minigdx.scene.api.sprite.Frame', this, 2);
    tmp0_serialDesc.addElement('uvIndex', false);
    tmp0_serialDesc.addElement('duration', false);
    this._descriptor_53 = tmp0_serialDesc;
  }
  $serializer_23.prototype._get_descriptor__68 = function () {
    return this._descriptor_53;
  };
  $serializer_23.prototype.childSerializers_24 = function () {
    var tmp0_arrayOf_0 = [IntSerializer_getInstance(), FloatSerializer_getInstance()];
    return tmp0_arrayOf_0;
  };
  $serializer_23.prototype.deserialize_69 = function (decoder) {
    var tmp0_desc = this._descriptor_53;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0.0;
    var tmp6_input = decoder.beginStructure_11(tmp0_desc);
    if (tmp6_input.decodeSequentially_11()) {
      tmp4_local0 = tmp6_input.decodeIntElement_11(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.decodeFloatElement_11(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.decodeElementIndex_11(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.decodeIntElement_11(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.decodeFloatElement_11(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:throw new UnknownFieldException(tmp2_index);
        }
      }
    tmp6_input.endStructure_11(tmp0_desc);
    return Frame_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  $serializer_23.$metadata$ = {
    simpleName: '$serializer',
    kind: 'object',
    interfaces: [GeneratedSerializer]
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function Frame_init_$Init$_0(seen1, uvIndex, duration, serializationConstructorMarker, $this) {
    if (0 === (seen1 & 1))
      throw new MissingFieldException('uvIndex');
    else
      $this._uvIndex = uvIndex;
    if (0 === (seen1 & 2))
      throw new MissingFieldException('duration');
    else
      $this._duration_1 = duration;
    return $this;
  }
  function Frame_init_$Create$_0(seen1, uvIndex, duration, serializationConstructorMarker) {
    return Frame_init_$Init$_0(seen1, uvIndex, duration, serializationConstructorMarker, Object.create(Frame_0.prototype));
  }
  function gui(renderer, defaultTexture, inputCapture, gameResolution, widgetBuilder, builder) {
    inputCapture.update_32();
    var widgetDsl = new WidgetDsl(defaultTexture, inputCapture, gameResolution, widgetBuilder);
    builder(widgetDsl);
    var tmp0_forEach_0 = widgetDsl._batchs._get_values__6();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      renderer.render_3(element_2._texture, toFloatArray(element_2._vertices_0), toFloatArray(element_2._uvs_0), toIntArray(element_2._verticesOrder_0));
    }
  }
  function gui$default(renderer, defaultTexture, inputCapture, gameResolution, widgetBuilder, builder, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      widgetBuilder = defaultWidgetAtlas();
    return gui(renderer, defaultTexture, inputCapture, gameResolution, widgetBuilder, builder);
  }
  function WidgetBuilder() {
  }
  WidgetBuilder.$metadata$ = {
    simpleName: 'WidgetBuilder',
    kind: 'interface',
    interfaces: []
  };
  function defaultWidgetAtlas() {
    return new DefaultWidgetAtlas();
  }
  function WidgetDsl(defaultTexture, inputCapture, gameResolution, widgetAtlas) {
    this._defaultTexture = defaultTexture;
    this._inputCapture = inputCapture;
    this._gameResolution = gameResolution;
    this._widgetAtlas = widgetAtlas;
    var tmp = this;
    tmp._defaultBatch = Batch_init_$Create$(null, null, null, this._defaultTexture, 7, null);
    this._defaultQuad = Quad_init_$Create$(this._defaultBatch);
    var tmp_0 = this;
    var tmp0_also_0 = LinkedHashMap_init_$Create$();
    tmp0_also_0.put_5(this._defaultTexture, this._defaultBatch);
    Unit_getInstance();
    tmp_0._batchs = tmp0_also_0;
    var tmp_1 = this;
    var tmp0_also_0_0 = LinkedHashMap_init_$Create$();
    tmp0_also_0_0.put_5(this._defaultTexture, this._defaultQuad);
    Unit_getInstance();
    tmp_1._quads = tmp0_also_0_0;
  }
  WidgetDsl.$metadata$ = {
    simpleName: 'WidgetDsl',
    kind: 'class',
    interfaces: [WidgetBuilder]
  };
  function Batch(vertices, uvs, verticesOrder, texture) {
    this._vertices_0 = vertices;
    this._uvs_0 = uvs;
    this._verticesOrder_0 = verticesOrder;
    this._texture = texture;
  }
  Batch.$metadata$ = {
    simpleName: 'Batch',
    kind: 'class',
    interfaces: []
  };
  function Batch_init_$Init$(vertices, uvs, verticesOrder, texture, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      vertices = ArrayList_init_$Create$();
    }if (!(($mask0 & 2) === 0)) {
      uvs = ArrayList_init_$Create$();
    }if (!(($mask0 & 4) === 0)) {
      verticesOrder = ArrayList_init_$Create$();
    }Batch.call($this, vertices, uvs, verticesOrder, texture);
    return $this;
  }
  function Batch_init_$Create$(vertices, uvs, verticesOrder, texture, $mask0, $marker) {
    return Batch_init_$Init$(vertices, uvs, verticesOrder, texture, $mask0, $marker, Object.create(Batch.prototype));
  }
  function ImGUIRenderer() {
  }
  ImGUIRenderer.$metadata$ = {
    simpleName: 'ImGUIRenderer',
    kind: 'interface',
    interfaces: []
  };
  function InputCapture() {
  }
  InputCapture.$metadata$ = {
    simpleName: 'InputCapture',
    kind: 'interface',
    interfaces: []
  };
  function DefaultButtonAtlas(xOffet, yOffset, resolution) {
    this._xOffet = xOffet;
    this._yOffset = yOffset;
    this._resolution = resolution;
    this._left_1 = to(UVCoordinates_init_$Create$(this._xOffet + 0 | 0, this._yOffset + 33 | 0, this._resolution), UVCoordinates_init_$Create$(this._xOffet + 3 | 0, this._yOffset + 44 | 0, this._resolution));
    this._center = to(UVCoordinates_init_$Create$(this._xOffet + 3 | 0, this._yOffset + 33 | 0, this._resolution), UVCoordinates_init_$Create$(this._xOffet + 5 | 0, this._yOffset + 44 | 0, this._resolution));
    this._right = to(UVCoordinates_init_$Create$(this._xOffet + 5 | 0, this._yOffset + 33 | 0, this._resolution), UVCoordinates_init_$Create$(this._xOffet + 8 | 0, this._yOffset + 44 | 0, this._resolution));
  }
  DefaultButtonAtlas.$metadata$ = {
    simpleName: 'DefaultButtonAtlas',
    kind: 'class',
    interfaces: [ButtonAtlas]
  };
  function DefaultButtonAtlas_init_$Init$(xOffet, yOffset, resolution, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      xOffet = 0;
    if (!(($mask0 & 2) === 0))
      yOffset = 0;
    DefaultButtonAtlas.call($this, xOffet, yOffset, resolution);
    return $this;
  }
  function DefaultButtonAtlas_init_$Create$(xOffet, yOffset, resolution, $mask0, $marker) {
    return DefaultButtonAtlas_init_$Init$(xOffet, yOffset, resolution, $mask0, $marker, Object.create(DefaultButtonAtlas.prototype));
  }
  function DefaultTextAtlas(resolution) {
    this._resolution_0 = resolution;
    this._cache = mapOf([create(this, new Char(97), 0, 11, 6, 11), create(this, new Char(98), 7, 11, 5, 11), create(this, new Char(99), 13, 11, 7, 11), create(this, new Char(100), 21, 11, 6, 11), create(this, new Char(101), 28, 11, 6, 11), create(this, new Char(102), 35, 11, 6, 11), create(this, new Char(103), 42, 11, 6, 11), create(this, new Char(104), 49, 11, 6, 11), create(this, new Char(105), 57, 11, 4, 11), create(this, new Char(106), 63, 11, 6, 11), create(this, new Char(107), 69, 11, 6, 11), create(this, new Char(108), 77, 11, 6, 11), create(this, new Char(109), 82, 11, 6, 11), create(this, new Char(110), 90, 11, 6, 11), create(this, new Char(111), 97, 11, 6, 11), create(this, new Char(112), 104, 11, 6, 11), create(this, new Char(113), 111, 11, 6, 11), create(this, new Char(114), 118, 11, 6, 11), create(this, new Char(115), 125, 11, 6, 11), create(this, new Char(116), 133, 11, 6, 11), create(this, new Char(117), 139, 11, 6, 11), create(this, new Char(118), 147, 11, 6, 11), create(this, new Char(119), 152, 11, 6, 11), create(this, new Char(120), 160, 11, 6, 11), create(this, new Char(121), 167, 11, 6, 11), create(this, new Char(122), 174, 11, 6, 11), create(this, new Char(65), 1, 1, 7, 10), create(this, new Char(66), 8, 1, 7, 10), create(this, new Char(67), 16, 1, 6, 10), create(this, new Char(68), 24, 1, 7, 10), create(this, new Char(69), 32, 1, 6, 10), create(this, new Char(70), 40, 1, 6, 10), create(this, new Char(71), 48, 1, 8, 10), create(this, new Char(72), 56, 1, 6, 10), create(this, new Char(73), 64, 1, 6, 10), create(this, new Char(74), 72, 1, 6, 10), create(this, new Char(75), 80, 1, 8, 10), create(this, new Char(76), 88, 1, 7, 10), create(this, new Char(77), 96, 1, 9, 10), create(this, new Char(78), 104, 1, 8, 10), create(this, new Char(79), 112, 1, 6, 10), create(this, new Char(80), 120, 1, 7, 10), create(this, new Char(81), 128, 1, 7, 10), create(this, new Char(82), 136, 1, 6, 10), create(this, new Char(83), 144, 1, 6, 10), create(this, new Char(84), 152, 1, 7, 10), create(this, new Char(85), 160, 1, 6, 10), create(this, new Char(86), 168, 1, 7, 10), create(this, new Char(87), 176, 1, 8, 10), create(this, new Char(88), 184, 1, 7, 10), create(this, new Char(89), 192, 1, 8, 10), create(this, new Char(90), 200, 1, 8, 10), create(this, new Char(48), 208, 0, 6, 10), create(this, new Char(49), 216, 0, 6, 10), create(this, new Char(50), 224, 0, 6, 10), create(this, new Char(51), 232, 0, 6, 10), create(this, new Char(52), 240, 0, 6, 10), create(this, new Char(53), 208, 11, 6, 10), create(this, new Char(54), 216, 11, 6, 10), create(this, new Char(55), 225, 11, 6, 10), create(this, new Char(56), 232, 11, 6, 10), create(this, new Char(57), 240, 11, 6, 10), create(this, new Char(123), 0, 22, 6, 10), create(this, new Char(125), 6, 22, 6, 10), create(this, new Char(91), 14, 22, 6, 10), create(this, new Char(93), 21, 22, 6, 10), create(this, new Char(40), 28, 22, 6, 10), create(this, new Char(41), 35, 22, 6, 10), create(this, new Char(60), 40, 22, 6, 10), create(this, new Char(62), 48, 22, 6, 10), create(this, new Char(36), 55, 22, 6, 10), create(this, new Char(42), 62, 22, 6, 10), create(this, new Char(45), 69, 22, 6, 10), create(this, new Char(43), 76, 22, 6, 10), create(this, new Char(61), 83, 22, 6, 10), create(this, new Char(47), 90, 22, 6, 10), create(this, new Char(35), 96, 22, 6, 10), create(this, new Char(95), 104, 22, 6, 10), create(this, new Char(37), 111, 22, 6, 10), create(this, new Char(64), 125, 22, 6, 10), create(this, new Char(92), 133, 22, 6, 10), create(this, new Char(38), 139, 22, 6, 10), create(this, new Char(124), 147, 22, 6, 10), create(this, new Char(126), 152, 22, 6, 10), create(this, new Char(63), 161, 22, 6, 10), create(this, new Char(39), 169, 22, 6, 10), create(this, new Char(34), 175, 22, 6, 10), create(this, new Char(33), 189, 22, 6, 10), create(this, new Char(44), 194, 22, 6, 10), create(this, new Char(46), 201, 22, 6, 10), create(this, new Char(59), 208, 22, 6, 10), create(this, new Char(58), 216, 22, 6, 10)]);
    this._default = create(this, new Char(32), 160, 22, 8, 10);
  }
  DefaultTextAtlas.$metadata$ = {
    simpleName: 'DefaultTextAtlas',
    kind: 'class',
    interfaces: [TextAtlas]
  };
  function create($this, char, x, y, with_0, height) {
    var endX = x + with_0 | 0;
    var endY = y + height | 0;
    return to(char, to(UVCoordinates_init_$Create$(x, y, $this._resolution_0), UVCoordinates_init_$Create$(endX, endY, $this._resolution_0)));
  }
  function DefaultWidgetAtlas() {
    this._resolution_1 = Resolution_init_$Create$(256, 64);
    var tmp = this;
    tmp._buttonIdle = DefaultButtonAtlas_init_$Create$(0, 0, this._resolution_1, 3, null);
    var tmp_0 = this;
    tmp_0._buttonOver = DefaultButtonAtlas_init_$Create$(8, 0, this._resolution_1, 2, null);
    var tmp_1 = this;
    tmp_1._buttonActivated = DefaultButtonAtlas_init_$Create$(0, 0, this._resolution_1, 3, null);
    this._text = new DefaultTextAtlas(this._resolution_1);
  }
  DefaultWidgetAtlas.$metadata$ = {
    simpleName: 'DefaultWidgetAtlas',
    kind: 'class',
    interfaces: [WidgetAtlas]
  };
  function WidgetAtlas() {
  }
  WidgetAtlas.$metadata$ = {
    simpleName: 'WidgetAtlas',
    kind: 'interface',
    interfaces: []
  };
  function ButtonAtlas() {
  }
  ButtonAtlas.$metadata$ = {
    simpleName: 'ButtonAtlas',
    kind: 'interface',
    interfaces: []
  };
  function TextAtlas() {
  }
  TextAtlas.$metadata$ = {
    simpleName: 'TextAtlas',
    kind: 'interface',
    interfaces: []
  };
  function Quad(vertices, verticesOrder, uvs) {
    this._vertices_1 = vertices;
    this._verticesOrder_1 = verticesOrder;
    this._uvs_1 = uvs;
  }
  Quad.$metadata$ = {
    simpleName: 'Quad',
    kind: 'class',
    interfaces: []
  };
  function Quad_init_$Init$(batch, $this) {
    Quad.call($this, batch._vertices_0, batch._verticesOrder_0, batch._uvs_0);
    return $this;
  }
  function Quad_init_$Create$(batch) {
    return Quad_init_$Init$(batch, Object.create(Quad.prototype));
  }
  function Resolution(width, height) {
    this._width_0 = width;
    this._height_0 = height;
  }
  Resolution.prototype.toString = function () {
    return '' + 'Resolution(width=' + this._width_0 + ', height=' + this._height_0 + ')';
  };
  Resolution.prototype.hashCode = function () {
    var result = getNumberHashCode(this._width_0);
    result = imul(result, 31) + getNumberHashCode(this._height_0) | 0;
    return result;
  };
  Resolution.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Resolution))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Resolution ? other : THROW_CCE();
    if (!equals_1(this._width_0, tmp0_other_with_cast._width_0))
      return false;
    if (!equals_1(this._height_0, tmp0_other_with_cast._height_0))
      return false;
    return true;
  };
  Resolution.$metadata$ = {
    simpleName: 'Resolution',
    kind: 'class',
    interfaces: []
  };
  function Resolution_init_$Init$(width, height, $this) {
    Resolution.call($this, width, height);
    return $this;
  }
  function Resolution_init_$Create$(width, height) {
    return Resolution_init_$Init$(width, height, Object.create(Resolution.prototype));
  }
  function UVCoordinates(x, y, resolution) {
    this._x_7 = x;
    this._y_7 = y;
    this._resolution_2 = resolution;
  }
  UVCoordinates.prototype.toString = function () {
    return '' + 'UVCoordinates(x=' + this._x_7 + ', y=' + this._y_7 + ', resolution=' + this._resolution_2 + ')';
  };
  UVCoordinates.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_7);
    result = imul(result, 31) + getNumberHashCode(this._y_7) | 0;
    result = imul(result, 31) + this._resolution_2.hashCode() | 0;
    return result;
  };
  UVCoordinates.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UVCoordinates))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UVCoordinates ? other : THROW_CCE();
    if (!equals_1(this._x_7, tmp0_other_with_cast._x_7))
      return false;
    if (!equals_1(this._y_7, tmp0_other_with_cast._y_7))
      return false;
    if (!this._resolution_2.equals(tmp0_other_with_cast._resolution_2))
      return false;
    return true;
  };
  UVCoordinates.$metadata$ = {
    simpleName: 'UVCoordinates',
    kind: 'class',
    interfaces: []
  };
  function UVCoordinates_init_$Init$(x, y, resolution, $this) {
    UVCoordinates.call($this, x / resolution._width_0, y / resolution._height_0, resolution);
    return $this;
  }
  function UVCoordinates_init_$Create$(x, y, resolution) {
    return UVCoordinates_init_$Init$(x, y, resolution, Object.create(UVCoordinates.prototype));
  }
  function AtomicRef(value) {
    this._value_9 = value;
  }
  AtomicRef.prototype._set_value_ = function (_set___) {
    this._value_9 = _set___;
  };
  AtomicRef.prototype._get_value__12 = function () {
    return this._value_9;
  };
  AtomicRef.prototype.compareAndSet$atomicfu = function (expect, update_1) {
    if (!(this._value_9 === expect))
      return false;
    this._value_9 = update_1;
    return true;
  };
  AtomicRef.prototype.getAndSet$atomicfu = function (value) {
    var oldValue = this._value_9;
    this._value_9 = value;
    return oldValue;
  };
  AtomicRef.prototype.toString = function () {
    return toString_0(this._value_9);
  };
  AtomicRef.$metadata$ = {
    simpleName: 'AtomicRef',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicRef.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicRef.prototype._get_value__12,
    set: AtomicRef.prototype._set_value_
  });
  function atomic(initial) {
    return new AtomicRef(initial);
  }
  function AtomicBoolean(value) {
    this._value_10 = value;
  }
  AtomicBoolean.prototype._set_value__0 = function (_set___) {
    this._value_10 = _set___;
  };
  AtomicBoolean.prototype._get_value__12 = function () {
    return this._value_10;
  };
  AtomicBoolean.prototype.compareAndSet$atomicfu = function (expect, update_1) {
    if (!(this._value_10 === expect))
      return false;
    this._value_10 = update_1;
    return true;
  };
  AtomicBoolean.prototype.getAndSet$atomicfu = function (value) {
    var oldValue = this._value_10;
    this._value_10 = value;
    return oldValue;
  };
  AtomicBoolean.prototype.toString = function () {
    return this._value_10.toString();
  };
  AtomicBoolean.$metadata$ = {
    simpleName: 'AtomicBoolean',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicBoolean.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicBoolean.prototype._get_value__12,
    set: AtomicBoolean.prototype._set_value__0
  });
  function atomic_0(initial) {
    return new AtomicBoolean(initial);
  }
  function AtomicInt(value) {
    this._value_11 = value;
  }
  AtomicInt.prototype._set_value__1 = function (_set___) {
    this._value_11 = _set___;
  };
  AtomicInt.prototype._get_value__12 = function () {
    return this._value_11;
  };
  AtomicInt.prototype.compareAndSet$atomicfu = function (expect, update_1) {
    if (!(this._value_11 === expect))
      return false;
    this._value_11 = update_1;
    return true;
  };
  AtomicInt.prototype.getAndSet$atomicfu = function (value) {
    var oldValue = this._value_11;
    this._value_11 = value;
    return oldValue;
  };
  AtomicInt.prototype.getAndIncrement$atomicfu = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_11;
    tmp0_this._value_11 = tmp1 + 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.getAndDecrement$atomicfu = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_11;
    tmp0_this._value_11 = tmp1 - 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.getAndAdd$atomicfu = function (delta_0) {
    var oldValue = this._value_11;
    var tmp0_this = this;
    tmp0_this._value_11 = tmp0_this._value_11 + delta_0 | 0;
    return oldValue;
  };
  AtomicInt.prototype.addAndGet$atomicfu = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._value_11 = tmp0_this._value_11 + delta_0 | 0;
    return this._value_11;
  };
  AtomicInt.prototype.incrementAndGet$atomicfu = function () {
    var tmp0_this = this;
    tmp0_this._value_11 = tmp0_this._value_11 + 1 | 0;
    return tmp0_this._value_11;
  };
  AtomicInt.prototype.decrementAndGet$atomicfu = function () {
    var tmp0_this = this;
    tmp0_this._value_11 = tmp0_this._value_11 - 1 | 0;
    return tmp0_this._value_11;
  };
  AtomicInt.prototype.toString = function () {
    return this._value_11.toString();
  };
  AtomicInt.$metadata$ = {
    simpleName: 'AtomicInt',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicInt.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicInt.prototype._get_value__12,
    set: AtomicInt.prototype._set_value__1
  });
  function atomic_1(initial) {
    return new AtomicInt(initial);
  }
  function AbstractCoroutine(parentContext, active) {
    JobSupport.call(this, active);
    this._parentContext = parentContext;
    this._context = this._parentContext.plus_17(this);
  }
  AbstractCoroutine.prototype._get_context__9 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_coroutineContext__3 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_isActive__15 = function () {
    return JobSupport.prototype._get_isActive__15.call(this);
  };
  AbstractCoroutine.prototype.initParentJob_1 = function () {
    this.initParentJobInternal_2(this._parentContext.get_42(Key_getInstance_1()));
  };
  AbstractCoroutine.prototype.onStart_1 = function () {
  };
  AbstractCoroutine.prototype.onStartInternal_2 = function () {
    this.onStart_1();
  };
  AbstractCoroutine.prototype.onCompleted = function (value) {
  };
  AbstractCoroutine.prototype.onCancelled_1 = function (cause, handled) {
  };
  AbstractCoroutine.prototype.cancellationExceptionMessage_2 = function () {
    return '' + _get_classSimpleName_(this) + ' was cancelled';
  };
  AbstractCoroutine.prototype.onCompletionInternal_2 = function (state) {
    if (state instanceof CompletedExceptionally)
      this.onCancelled_1(state._cause, state._get_handled__0());
    else {
      {
        this.onCompleted((state == null ? true : isObject(state)) ? state : THROW_CCE());
      }
    }
  };
  AbstractCoroutine.prototype.resumeWith_11 = function (result) {
    var state = this.makeCompletingOnce_2(toState$default(result, null, 1, null));
    if (state === COMPLETING_WAITING_CHILDREN)
      return Unit_getInstance();
    this.afterResume_1(state);
  };
  AbstractCoroutine.prototype.afterResume_1 = function (state) {
    return this.afterCompletion_2(state);
  };
  AbstractCoroutine.prototype.handleOnCompletionException_2 = function (exception) {
    handleCoroutineException(this._context, exception);
  };
  AbstractCoroutine.prototype.nameString_3 = function () {
    var tmp0_elvis_lhs = _get_coroutineName_(this._context);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return JobSupport.prototype.nameString_3.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '' + '"' + coroutineName + '":' + JobSupport.prototype.nameString_3.call(this);
  };
  AbstractCoroutine.prototype.start_0 = function (start, receiver, block) {
    this.initParentJob_1();
    start.invoke_117(block, receiver, this);
  };
  AbstractCoroutine.$metadata$ = {
    simpleName: 'AbstractCoroutine',
    kind: 'class',
    interfaces: [Job, Continuation, CoroutineScope]
  };
  function launch(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy_() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.start_0(start, coroutine, block);
    return coroutine;
  }
  function launch$default(_this_, context, start, block, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      context = EmptyCoroutineContext_getInstance();
    if (!(($mask0 & 2) === 0))
      start = CoroutineStart_DEFAULT_getInstance();
    return launch(_this_, context, start, block);
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, active);
  }
  StandaloneCoroutine.prototype.handleJobException_2 = function (exception) {
    handleCoroutineException(this._get_context__9(), exception);
    return true;
  };
  StandaloneCoroutine.$metadata$ = {
    simpleName: 'StandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this._continuation = createCoroutineUnintercepted(block, this, this);
  }
  LazyStandaloneCoroutine.prototype.onStart_1 = function () {
    startCoroutineCancellable_0(this._continuation, this);
  };
  LazyStandaloneCoroutine.$metadata$ = {
    simpleName: 'LazyStandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function CancellableContinuation() {
  }
  CancellableContinuation.$metadata$ = {
    simpleName: 'CancellableContinuation',
    kind: 'interface',
    interfaces: [Continuation]
  };
  function removeOnCancellation(_this_, node) {
    var tmp0__get_asHandler__0 = new RemoveOnCancel(node);
    return _this_.invokeOnCancellation_0(tmp0__get_asHandler__0);
  }
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
    }
    var tmp0_safe_receiver = delegate.claimReusableCancellableContinuation();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0;
      if (tmp0_safe_receiver.resetStateReusable()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function RemoveOnCancel(node) {
    BeforeResumeCancelHandler.call(this);
    this._node = node;
  }
  RemoveOnCancel.prototype.invoke_122 = function (cause) {
    this._node.remove_31();
    Unit_getInstance();
  };
  RemoveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  RemoveOnCancel.prototype.toString = function () {
    return '' + 'RemoveOnCancel[' + this._node + ']';
  };
  RemoveOnCancel.$metadata$ = {
    simpleName: 'RemoveOnCancel',
    kind: 'class',
    interfaces: []
  };
  var RESUME_TOKEN;
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this._delegate = delegate;
    this._context_0 = this._delegate._get_context__9();
    this.__decision = atomic_1(0);
    this.__state = atomic(Active_getInstance());
    this.__parentHandle = atomic(null);
  }
  CancellableContinuationImpl.prototype._get_delegate__1 = function () {
    return this._delegate;
  };
  CancellableContinuationImpl.prototype._get_context__9 = function () {
    return this._context_0;
  };
  CancellableContinuationImpl.prototype._get_state__3 = function () {
    return this.__state._value_9;
  };
  CancellableContinuationImpl.prototype._get_isCompleted__3 = function () {
    var tmp = this._get_state__3();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  CancellableContinuationImpl.prototype.resetStateReusable = function () {
    var state = this.__state._value_9;
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      tmp = !(state._idempotentResume == null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      this.detachChild();
      return false;
    } else {
    }
    this.__decision._value_11 = 0;
    this.__state._value_9 = Active_getInstance();
    return true;
  };
  CancellableContinuationImpl.prototype.takeState_1 = function () {
    return this._get_state__3();
  };
  CancellableContinuationImpl.prototype.cancelCompletedResult_1 = function (takenState, cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
        var tmp0_error_0_3 = 'Not completed';
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      } else {
        if (tmp0_subject_2 instanceof CompletedExceptionally)
          return Unit_getInstance();
        else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp1_check_0_4 = !tmp1__anonymous__1._get_cancelled_();
            if (!tmp1_check_0_4) {
              var message_1_5 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$(toString_1(message_1_5));
            }var tmp = tmp1__anonymous__1;
            var update_6 = tmp.copy$default(null, null, null, null, cause, 15, null);
            if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_6)) {
              tmp1__anonymous__1.invokeHandlers(this, cause);
              return Unit_getInstance();
            }} else {
            {
              if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, CompletedContinuation_init_$Create$(tmp1__anonymous__1, null, null, null, cause, 14, null))) {
                return Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.cancel = function (cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_9;
        if (!(!(tmp1__anonymous__1 == null) ? isInterface(tmp1__anonymous__1, NotCompleted) : false))
          return false;
        else {
        }
        var update_2 = new CancelledContinuation(this, cause, tmp1__anonymous__1 instanceof CancelHandler);
        if (!this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var tmp0_safe_receiver_3 = tmp1__anonymous__1 instanceof CancelHandler ? tmp1__anonymous__1 : null;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          this.callCancelHandler(tmp0_safe_receiver_3, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
        detachChildIfNonResuable(this);
        dispatchResume(this, this._get_resumeMode__0());
        return true;
      }
       while (false);
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.parentCancelled_2 = function (cause) {
    if (cancelLater(this, cause))
      return Unit_getInstance();
    this.cancel(cause);
    Unit_getInstance();
    detachChildIfNonResuable(this);
  };
  CancellableContinuationImpl.prototype.callCancelHandler = function (handler, cause) {
    var tmp;
    try {
      tmp = handler.invoke(cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException(this._get_context__9(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.callOnCancellation = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineException(this._get_context__9(), new CompletionHandlerException('' + 'Exception in resume onCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
    }
  };
  CancellableContinuationImpl.prototype.getContinuationCancellationCause = function (parent) {
    return parent.getCancellationException_3();
  };
  CancellableContinuationImpl.prototype.getResult = function () {
    setupCancellation(this);
    if (trySuspend(this))
      return _get_COROUTINE_SUSPENDED_();
    var state = this._get_state__3();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state._cause, this);
    else {
    }
    if (_get_isCancellableMode_(this._get_resumeMode__0())) {
      var job = this._get_context__9().get_42(Key_getInstance_1());
      if (!(job == null) ? !job._get_isActive__15() : false) {
        var cause = job.getCancellationException_3();
        this.cancelCompletedResult_1(state, cause);
        throw recoverStackTrace(cause, this);
      }}return this.getSuccessfulResult_1(state);
  };
  CancellableContinuationImpl.prototype.resumeWith_11 = function (result) {
    var tmp = toState(result, this);
    var tmp_0 = this._get_resumeMode__0();
    return resumeImpl$default(this, tmp, tmp_0, null, 8, null);
  };
  CancellableContinuationImpl.prototype.resume_0 = function (value, onCancellation) {
    return resumeImpl(this, value, this._get_resumeMode__0(), onCancellation);
  };
  CancellableContinuationImpl.prototype.invokeOnCancellation_0 = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Active) {
        if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, cancelHandler))
          return Unit_getInstance();
      } else {
        if (tmp0_subject_2 instanceof CancelHandler)
          multipleHandlersError(this, handler, tmp1__anonymous__1);
        else {
          if (tmp0_subject_2 instanceof CompletedExceptionally) {
            if (!tmp1__anonymous__1.makeHandled_0())
              multipleHandlersError(this, handler, tmp1__anonymous__1);
            if (tmp1__anonymous__1 instanceof CancelledContinuation) {
              var tmp1_safe_receiver_3 = tmp1__anonymous__1 instanceof CompletedExceptionally ? tmp1__anonymous__1 : null;
              callCancelHandler(this, handler, tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3._cause);
            } else {
            }
            return Unit_getInstance();
          } else {
            if (tmp0_subject_2 instanceof CompletedContinuation_0) {
              if (!(tmp1__anonymous__1._cancelHandler == null))
                multipleHandlersError(this, handler, tmp1__anonymous__1);
              if (cancelHandler instanceof BeforeResumeCancelHandler)
                return Unit_getInstance();
              else {
              }
              if (tmp1__anonymous__1._get_cancelled_()) {
                callCancelHandler(this, handler, tmp1__anonymous__1._cancelCause);
                return Unit_getInstance();
              }var tmp = tmp1__anonymous__1;
              var update_4 = tmp.copy$default(null, cancelHandler, null, null, null, 29, null);
              if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_4))
                return Unit_getInstance();
            } else {
              {
                if (cancelHandler instanceof BeforeResumeCancelHandler)
                  return Unit_getInstance();
                else {
                }
                var update_5 = CompletedContinuation_init_$Create$(tmp1__anonymous__1, cancelHandler, null, null, null, 28, null);
                if (this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_5))
                  return Unit_getInstance();
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.detachChild = function () {
    var handle = _get_parentHandle_(this);
    var tmp0_safe_receiver = handle;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_10();
      Unit_getInstance();
    }
    Unit_getInstance();
    _set_parentHandle_(this, NonDisposableHandle_getInstance());
  };
  CancellableContinuationImpl.prototype.tryResume_0 = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  CancellableContinuationImpl.prototype.completeResume_0 = function (token) {
    dispatchResume(this, this._get_resumeMode__0());
  };
  CancellableContinuationImpl.prototype.getSuccessfulResult_1 = function (state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof CompletedContinuation_0) {
      var tmp_0 = state._result_0;
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    } else {
      {
        tmp = (state == null ? true : isObject(state)) ? state : THROW_CCE();
      }
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.getExceptionalResult_1 = function (state) {
    var tmp0_safe_receiver = DispatchedTask.prototype.getExceptionalResult_1.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = recoverStackTrace(tmp0_safe_receiver, this._delegate);
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.toString = function () {
    return '' + this.nameString_3() + '(' + toDebugString(this._delegate) + '){' + this._get_state__3() + '}@' + _get_hexAddress_(this);
  };
  CancellableContinuationImpl.prototype.nameString_3 = function () {
    return 'CancellableContinuation';
  };
  CancellableContinuationImpl.$metadata$ = {
    simpleName: 'CancellableContinuationImpl',
    kind: 'class',
    interfaces: [CancellableContinuation, CoroutineStackFrame]
  };
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  CancelHandler.$metadata$ = {
    simpleName: 'CancelHandler',
    kind: 'class',
    interfaces: [NotCompleted]
  };
  function Active() {
    Active_instance = this;
  }
  Active.prototype.toString = function () {
    return 'Active';
  };
  Active.$metadata$ = {
    simpleName: 'Active',
    kind: 'object',
    interfaces: [NotCompleted]
  };
  var Active_instance;
  function Active_getInstance() {
    if (Active_instance == null)
      new Active();
    return Active_instance;
  }
  function NotCompleted() {
  }
  NotCompleted.$metadata$ = {
    simpleName: 'NotCompleted',
    kind: 'interface',
    interfaces: []
  };
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    this._result_0 = result;
    this._cancelHandler = cancelHandler;
    this._onCancellation = onCancellation;
    this._idempotentResume = idempotentResume;
    this._cancelCause = cancelCause;
  }
  CompletedContinuation_0.prototype._get_cancelled_ = function () {
    return !(this._cancelCause == null);
  };
  CompletedContinuation_0.prototype.invokeHandlers = function (cont, cause) {
    var tmp0_safe_receiver = this._cancelHandler;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cont.callCancelHandler(tmp0_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._onCancellation;
    if (tmp1_safe_receiver == null)
      null;
    else {
      cont.callOnCancellation(tmp1_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CompletedContinuation_0.prototype.copy = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.copy$default = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      result = this._result_0;
    if (!(($mask0 & 2) === 0))
      cancelHandler = this._cancelHandler;
    if (!(($mask0 & 4) === 0))
      onCancellation = this._onCancellation;
    if (!(($mask0 & 8) === 0))
      idempotentResume = this._idempotentResume;
    if (!(($mask0 & 16) === 0))
      cancelCause = this._cancelCause;
    return this.copy(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.toString = function () {
    return '' + 'CompletedContinuation(result=' + this._result_0 + ', cancelHandler=' + this._cancelHandler + ', onCancellation=' + this._onCancellation + ', idempotentResume=' + this._idempotentResume + ', cancelCause=' + this._cancelCause + ')';
  };
  CompletedContinuation_0.prototype.hashCode = function () {
    return imul(imul(imul(imul(this._result_0 == null ? 0 : hashCode(this._result_0), 31) + (this._cancelHandler == null ? 0 : hashCode(this._cancelHandler)) | 0, 31) + (this._onCancellation == null ? 0 : hashCode(this._onCancellation)) | 0, 31) + (this._idempotentResume == null ? 0 : hashCode(this._idempotentResume)) | 0, 31) + (this._cancelCause == null ? 0 : hashCode(this._cancelCause)) | 0;
  };
  CompletedContinuation_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals_1(this._result_0, tmp0_other_with_cast._result_0))
      return false;
    if (!equals_1(this._cancelHandler, tmp0_other_with_cast._cancelHandler))
      return false;
    if (!equals_1(this._onCancellation, tmp0_other_with_cast._onCancellation))
      return false;
    if (!equals_1(this._idempotentResume, tmp0_other_with_cast._idempotentResume))
      return false;
    if (!equals_1(this._cancelCause, tmp0_other_with_cast._cancelCause))
      return false;
    return true;
  };
  CompletedContinuation_0.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'class',
    interfaces: []
  };
  function BeforeResumeCancelHandler() {
    CancelHandler.call(this);
  }
  BeforeResumeCancelHandler.$metadata$ = {
    simpleName: 'BeforeResumeCancelHandler',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this._handler = handler;
  }
  InvokeOnCancel.prototype.invoke_122 = function (cause) {
    this._handler(cause);
  };
  InvokeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  InvokeOnCancel.prototype.toString = function () {
    return '' + 'InvokeOnCancel[' + _get_classSimpleName_(this._handler) + '@' + _get_hexAddress_(this) + ']';
  };
  InvokeOnCancel.$metadata$ = {
    simpleName: 'InvokeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function _set_parentHandle_($this, value) {
    $this.__parentHandle._value_9 = value;
  }
  function _get_parentHandle_($this) {
    return $this.__parentHandle._value_9;
  }
  function isReusable($this) {
    var tmp;
    var tmp_0 = $this._delegate;
    if (tmp_0 instanceof DispatchedContinuation) {
      tmp = $this._delegate.isReusable($this);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function setupCancellation($this) {
    if (checkCompleted($this))
      return Unit_getInstance();
    if (!(_get_parentHandle_($this) === null))
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this._delegate._get_context__9().get_42(Key_getInstance_1());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var tmp0__get_asHandler__0 = new ChildContinuation(parent, $this);
    var handle = parent.invokeOnCompletion$default_3(true, false, tmp0__get_asHandler__0, 2, null);
    _set_parentHandle_($this, handle);
    if ($this._get_isCompleted__3() ? !isReusable($this) : false) {
      handle.dispose_10();
      _set_parentHandle_($this, NonDisposableHandle_getInstance());
    }}
  function checkCompleted($this) {
    var completed = $this._get_isCompleted__3();
    if (!_get_isReusableMode_($this._get_resumeMode__0()))
      return completed;
    var tmp = $this._delegate;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return completed;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    var tmp1_elvis_lhs = dispatched.checkPostponedCancellation($this);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return completed;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var cause = tmp_1;
    if (!completed) {
      $this.cancel(cause);
      Unit_getInstance();
    }return true;
  }
  function cancelLater($this, cause) {
    if (!_get_isReusableMode_($this._get_resumeMode__0()))
      return false;
    var tmp = $this._delegate;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    return dispatched.postponeCancellation(cause);
  }
  function callCancelHandler($this, handler, cause) {
    var tmp;
    try {
      tmp = invokeIt(handler, cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException($this._get_context__9(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + $this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function trySuspend($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_11;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.compareAndSet$atomicfu(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:var tmp0_error_0_3 = 'Already suspended';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function tryResume($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_11;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.compareAndSet$atomicfu(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:var tmp0_error_0_3 = 'Already resumed';
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function multipleHandlersError($this, handler, state) {
    var tmp0_error_0 = '' + "It's prohibited to register multiple handlers, tried to register " + handler + ', already has ' + state;
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      {
        tmp = new InvokeOnCancel(handler);
      }
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume($this))
      return Unit_getInstance();
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      tmp = proposedUpdate;
    } else {
      if (!_get_isCancellableMode_(resumeMode) ? idempotent == null : false) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (state instanceof CancelHandler) {
            tmp_2 = !(state instanceof BeforeResumeCancelHandler);
          } else {
            {
              tmp_2 = false;
            }
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            tmp_0 = !(idempotent == null);
          }
        }
        if (tmp_0) {
          var tmp_3 = state instanceof CancelHandler ? state : null;
          tmp = CompletedContinuation_init_$Create$(proposedUpdate, tmp_3, onCancellation, idempotent, null, 16, null);
        } else {
          {
            tmp = proposedUpdate;
          }
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_9;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof CancelledContinuation) {
            if (tmp1__anonymous__1.makeResumed()) {
              var tmp1_safe_receiver_4 = onCancellation;
              if (tmp1_safe_receiver_4 == null)
                null;
              else {
                $this.callOnCancellation(tmp1_safe_receiver_4, tmp1__anonymous__1._get_cause__30());
                Unit_getInstance();
              }
              Unit_getInstance();
              return Unit_getInstance();
            }} else {
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
       while (false);
    }
    Unit_getInstance();
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      onCancellation = null;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_9;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, $this._get_resumeMode__0(), onCancellation, idempotent);
          if (!$this.__state.compareAndSet$atomicfu(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          return RESUME_TOKEN;
        } else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp;
            if (!(idempotent == null) ? tmp1__anonymous__1._idempotentResume === idempotent : false) {
              tmp = RESUME_TOKEN;
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function alreadyResumedError($this, proposedUpdate) {
    var tmp0_error_0 = '' + 'Already resumed, but proposed with update ' + proposedUpdate;
    throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this))
      $this.detachChild();
  }
  function CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      cancelHandler = null;
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    if (!(($mask0 & 8) === 0))
      idempotentResume = null;
    if (!(($mask0 & 16) === 0))
      cancelCause = null;
    CompletedContinuation_0.call($this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    return $this;
  }
  function CompletedContinuation_init_$Create$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker) {
    return CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, Object.create(CompletedContinuation_0.prototype));
  }
  function CompletedExceptionally(cause, handled) {
    this._cause = cause;
    this.__handled = atomic_0(handled);
  }
  CompletedExceptionally.prototype._get_cause__30 = function () {
    return this._cause;
  };
  CompletedExceptionally.prototype._get_handled__0 = function () {
    return this.__handled._value_10;
  };
  CompletedExceptionally.prototype.makeHandled_0 = function () {
    return this.__handled.compareAndSet$atomicfu(false, true);
  };
  CompletedExceptionally.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '[' + this._cause + ']';
  };
  CompletedExceptionally.$metadata$ = {
    simpleName: 'CompletedExceptionally',
    kind: 'class',
    interfaces: []
  };
  function CancelledContinuation(continuation, cause, handled) {
    var tmp0_elvis_lhs = cause;
    CompletedExceptionally.call(this, tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + 'Continuation ' + continuation + ' was cancelled normally') : tmp0_elvis_lhs, handled);
    this.__resumed = atomic_0(false);
  }
  CancelledContinuation.prototype.makeResumed = function () {
    return this.__resumed.compareAndSet$atomicfu(false, true);
  };
  CancelledContinuation.$metadata$ = {
    simpleName: 'CancelledContinuation',
    kind: 'class',
    interfaces: []
  };
  function toState(_this_, caller) {
    var exception_1 = exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _get_value__impl(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = tmp0__anonymous__2;
    } else {
      var tmp_1 = recoverStackTrace(exception_1, caller);
      tmp = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
    }
    return tmp;
  }
  function toState_0(_this_, onCancellation) {
    var exception_1 = exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _get_value__impl(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(tmp0__anonymous__2, onCancellation) : tmp0__anonymous__2;
    } else {
      tmp = CompletedExceptionally_init_$Create$(exception_1, false, 2, null);
    }
    return tmp;
  }
  function toState$default(_this_, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancellation = null;
    return toState_0(_this_, onCancellation);
  }
  function CompletedWithCancellation(result, onCancellation) {
    this._result_1 = result;
    this._onCancellation_0 = onCancellation;
  }
  CompletedWithCancellation.prototype.toString = function () {
    return '' + 'CompletedWithCancellation(result=' + this._result_1 + ', onCancellation=' + this._onCancellation_0 + ')';
  };
  CompletedWithCancellation.prototype.hashCode = function () {
    return imul(this._result_1 == null ? 0 : hashCode(this._result_1), 31) + hashCode(this._onCancellation_0) | 0;
  };
  CompletedWithCancellation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals_1(this._result_1, tmp0_other_with_cast._result_1))
      return false;
    if (!equals_1(this._onCancellation_0, tmp0_other_with_cast._onCancellation_0))
      return false;
    return true;
  };
  CompletedWithCancellation.$metadata$ = {
    simpleName: 'CompletedWithCancellation',
    kind: 'class',
    interfaces: []
  };
  function CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      handled = false;
    CompletedExceptionally.call($this, cause, handled);
    return $this;
  }
  function CompletedExceptionally_init_$Create$(cause, handled, $mask0, $marker) {
    return CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, Object.create(CompletedExceptionally.prototype));
  }
  function CoroutineDispatcher() {
    AbstractCoroutineContextElement.call(this, Key_getInstance());
  }
  CoroutineDispatcher.prototype.isDispatchNeeded_8 = function (context) {
    return true;
  };
  CoroutineDispatcher.prototype.interceptContinuation_9 = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  CoroutineDispatcher.prototype.releaseInterceptedContinuation_9 = function (continuation) {
    var tmp0_safe_receiver = (continuation instanceof DispatchedContinuation ? continuation : THROW_CCE())._get_reusableCancellableContinuation_();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.detachChild();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CoroutineDispatcher.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this);
  };
  CoroutineDispatcher.$metadata$ = {
    simpleName: 'CoroutineDispatcher',
    kind: 'class',
    interfaces: [ContinuationInterceptor]
  };
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.get_42(Key_getInstance_0());
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.handleException__error(context, exception);
        return Unit_getInstance();
      }
      Unit_getInstance();
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineExceptionImpl(context, handlerException(exception, $p));
        return Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
    }
    handleCoroutineExceptionImpl(context, exception);
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    var tmp0_apply_0 = RuntimeException_init_$Create$_0('Exception while trying to handle coroutine exception', thrownException);
    return tmp0_apply_0;
  }
  function Key_1() {
    Key_instance_0 = this;
  }
  Key_1.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_1();
    return Key_instance_0;
  }
  function CoroutineScope() {
  }
  CoroutineScope.$metadata$ = {
    simpleName: 'CoroutineScope',
    kind: 'interface',
    interfaces: []
  };
  function GlobalScope() {
    GlobalScope_instance = this;
  }
  GlobalScope.prototype._get_coroutineContext__3 = function () {
    return EmptyCoroutineContext_getInstance();
  };
  GlobalScope.$metadata$ = {
    simpleName: 'GlobalScope',
    kind: 'object',
    interfaces: [CoroutineScope]
  };
  var GlobalScope_instance;
  function GlobalScope_getInstance() {
    if (GlobalScope_instance == null)
      new GlobalScope();
    return GlobalScope_instance;
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineStart.prototype.invoke_117 = function (block, receiver, completion) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CoroutineStart_DEFAULT_getInstance())) {
      tmp = startCoroutineCancellable$default(block, receiver, completion, null, 4, null);
    } else if (tmp0_subject.equals(CoroutineStart_ATOMIC_getInstance())) {
      tmp = startCoroutine(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_UNDISPATCHED_getInstance())) {
      tmp = startCoroutineUndispatched(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_LAZY_getInstance())) {
      tmp = Unit_getInstance();
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CoroutineStart.prototype._get_isLazy_ = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  CoroutineStart.$metadata$ = {
    simpleName: 'CoroutineStart',
    kind: 'class',
    interfaces: []
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_getInstance();
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CopyableThrowable() {
  }
  CopyableThrowable.$metadata$ = {
    simpleName: 'CopyableThrowable',
    kind: 'interface',
    interfaces: []
  };
  function Delay() {
  }
  Delay.$metadata$ = {
    simpleName: 'Delay',
    kind: 'interface',
    interfaces: []
  };
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this._useCount = new Long(0, 0);
    this._shared = false;
    this._unconfinedQueue = null;
  }
  EventLoop.prototype.processUnconfinedEvent_0 = function () {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.removeFirstOrNull_4();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.run_3();
    return true;
  };
  EventLoop.prototype.dispatchUnconfined_0 = function (task) {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new ArrayQueue();
      this._unconfinedQueue = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.addLast_7(task);
  };
  EventLoop.prototype._get_isUnconfinedLoopActive__0 = function () {
    return this._useCount.compareTo_48(delta(this, true)) >= 0;
  };
  EventLoop.prototype._get_isUnconfinedQueueEmpty__0 = function () {
    var tmp0_safe_receiver = this._unconfinedQueue;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isEmpty__4();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  EventLoop.prototype.incrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.plus_45(delta(this, unconfined));
    if (!unconfined)
      this._shared = true;
  };
  EventLoop.prototype.decrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.minus_28(delta(this, unconfined));
    if (this._useCount.compareTo_48(new Long(0, 0)) > 0)
      return Unit_getInstance();
    if (this._shared) {
      this.shutdown_0();
    }};
  EventLoop.prototype.shutdown_0 = function () {
  };
  EventLoop.$metadata$ = {
    simpleName: 'EventLoop',
    kind: 'class',
    interfaces: []
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this._ref = new CommonThreadLocal();
  }
  ThreadLocalEventLoop.prototype._get_eventLoop_ = function () {
    var tmp0_elvis_lhs = this._ref.get_43();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance()._ref.set_3(tmp0_also_0);
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ThreadLocalEventLoop.$metadata$ = {
    simpleName: 'ThreadLocalEventLoop',
    kind: 'object',
    interfaces: []
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  CompletionHandlerException.$metadata$ = {
    simpleName: 'CompletionHandlerException',
    kind: 'class',
    interfaces: []
  };
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_0(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  CoroutinesInternalError.$metadata$ = {
    simpleName: 'CoroutinesInternalError',
    kind: 'class',
    interfaces: []
  };
  function Job() {
  }
  Job.prototype.invokeOnCompletion$default_3 = function (onCancelling, invokeImmediately, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancelling = false;
    if (!(($mask0 & 2) === 0))
      invokeImmediately = true;
    return $handler == null ? this.invokeOnCompletion_3(onCancelling, invokeImmediately, handler) : $handler(onCancelling, invokeImmediately, handler);
  };
  Job.$metadata$ = {
    simpleName: 'Job',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function DisposableHandle() {
  }
  DisposableHandle.$metadata$ = {
    simpleName: 'DisposableHandle',
    kind: 'interface',
    interfaces: []
  };
  function ChildJob() {
  }
  ChildJob.$metadata$ = {
    simpleName: 'ChildJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ParentJob() {
  }
  ParentJob.$metadata$ = {
    simpleName: 'ParentJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChildHandle() {
  }
  ChildHandle.$metadata$ = {
    simpleName: 'ChildHandle',
    kind: 'interface',
    interfaces: [DisposableHandle]
  };
  function NonDisposableHandle() {
    NonDisposableHandle_instance = this;
  }
  NonDisposableHandle.prototype.dispose_10 = function () {
  };
  NonDisposableHandle.prototype.childCancelled_5 = function (cause) {
    return false;
  };
  NonDisposableHandle.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle, ChildHandle]
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    if (NonDisposableHandle_instance == null)
      new NonDisposableHandle();
    return NonDisposableHandle_instance;
  }
  function Key_2() {
    Key_instance_1 = this;
    Key_getInstance_0();
    Unit_getInstance();
  }
  Key_2.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_1;
  function Key_getInstance_1() {
    if (Key_instance_1 == null)
      new Key_2();
    return Key_instance_1;
  }
  var COMPLETING_ALREADY;
  var COMPLETING_WAITING_CHILDREN;
  var COMPLETING_RETRY;
  var TOO_LATE_TO_CANCEL;
  var SEALED_0;
  var EMPTY_NEW;
  var EMPTY_ACTIVE;
  function Empty(isActive) {
    this._isActive = isActive;
  }
  Empty.prototype._get_isActive__15 = function () {
    return this._isActive;
  };
  Empty.prototype._get_list__10 = function () {
    return null;
  };
  Empty.prototype.toString = function () {
    return '' + 'Empty{' + (this._isActive ? 'Active' : 'New') + '}';
  };
  Empty.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function Incomplete() {
  }
  Incomplete.$metadata$ = {
    simpleName: 'Incomplete',
    kind: 'interface',
    interfaces: []
  };
  function NodeList_0() {
    LinkedListHead.call(this);
  }
  NodeList_0.prototype._get_isActive__15 = function () {
    return true;
  };
  NodeList_0.prototype._get_list__10 = function () {
    return this;
  };
  NodeList_0.prototype.getString = function (state) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_6('List{');
    Unit_getInstance();
    tmp0_apply_0_1.append_6(state);
    Unit_getInstance();
    tmp0_apply_0_1.append_6('}[');
    Unit_getInstance();
    var first_3 = true;
    var cur_1_4 = this._get__next__2();
    while (!equals_1(cur_1_4, this)) {
      if (cur_1_4 instanceof JobNode) {
        var tmp0__anonymous__2_5 = cur_1_4;
        if (first_3)
          first_3 = false;
        else {
          tmp0_apply_0_1.append_6(', ');
          Unit_getInstance();
        }
        tmp0_apply_0_1.append_5(tmp0__anonymous__2_5);
        Unit_getInstance();
      } else {
      }
      cur_1_4 = cur_1_4.__next;
    }
    tmp0_apply_0_1.append_6(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  NodeList_0.prototype.toString = function () {
    return DEBUG ? this.getString('Active') : anyToString(this);
  };
  NodeList_0.$metadata$ = {
    simpleName: 'NodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function JobNode(job) {
    CompletionHandlerBase.call(this);
    this._job = job;
  }
  JobNode.prototype._get_job__1 = function () {
    return this._job;
  };
  JobNode.prototype._get_isActive__15 = function () {
    return true;
  };
  JobNode.prototype._get_list__10 = function () {
    return null;
  };
  JobNode.prototype.dispose_10 = function () {
    var tmp = this._job;
    return (tmp instanceof JobSupport ? tmp : THROW_CCE()).removeNode_2(this);
  };
  JobNode.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '[job@' + _get_hexAddress_(this._job) + ']';
  };
  JobNode.$metadata$ = {
    simpleName: 'JobNode',
    kind: 'class',
    interfaces: [DisposableHandle, Incomplete]
  };
  function JobSupport(active) {
    this.__state_0 = atomic(active ? EMPTY_ACTIVE : EMPTY_NEW);
    this.__parentHandle_0 = atomic(null);
  }
  JobSupport.prototype._get_key__20 = function () {
    return Key_getInstance_1();
  };
  JobSupport.prototype._set_parentHandle__2 = function (value) {
    this.__parentHandle_0._value_9 = value;
  };
  JobSupport.prototype._get_parentHandle__2 = function () {
    return this.__parentHandle_0._value_9;
  };
  JobSupport.prototype.initParentJobInternal_2 = function (parent) {
    if (parent == null) {
      this._set_parentHandle__2(NonDisposableHandle_getInstance());
      return Unit_getInstance();
    }parent.start_7();
    Unit_getInstance();
    var handle = parent.attachChild_3(this);
    this._set_parentHandle__2(handle);
    if (this._get_isCompleted__3()) {
      handle.dispose_10();
      this._set_parentHandle__2(NonDisposableHandle_getInstance());
    }};
  JobSupport.prototype._get_state__3 = function () {
    var tmp0_loop_0 = this.__state_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      if (!(tmp1__anonymous__1 instanceof OpDescriptor))
        return tmp1__anonymous__1;
      else {
      }
      tmp1__anonymous__1.perform_1(this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_isActive__15 = function () {
    var state = this._get_state__3();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state._get_isActive__15();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JobSupport.prototype._get_isCompleted__3 = function () {
    var tmp = this._get_state__3();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  JobSupport.prototype.start_7 = function () {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__3();
      var tmp0_subject_2 = startInternal(this, tmp0__anonymous__1);
      if (tmp0_subject_2 === 0)
        return false;
      else if (tmp0_subject_2 === 1)
        return true;
    }
    Unit_getInstance();
  };
  JobSupport.prototype.onStartInternal_2 = function () {
  };
  JobSupport.prototype.getCancellationException_3 = function () {
    var state = this._get_state__3();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause_();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_2(tmp0_safe_receiver, '' + _get_classSimpleName_(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp1_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          var tmp_1 = state._cause;
          tmp = this.toCancellationException$default_2(tmp_1, null, 1, null);
        } else {
          {
            tmp = new JobCancellationException('' + _get_classSimpleName_(this) + ' has completed normally', null, this);
          }
        }
      }
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException_2 = function (_this__0, message) {
    var tmp0_elvis_lhs = _this__0 instanceof CancellationException ? _this__0 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = message;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_2() : tmp0_elvis_lhs_1, _this__0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException$default_2 = function (_this__0, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = null;
    return this.toCancellationException_2(_this__0, message);
  };
  JobSupport.prototype.invokeOnCompletion_3 = function (onCancelling, invokeImmediately, handler) {
    var nodeCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__3();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Empty) {
          if (tmp0__anonymous__1._isActive) {
            var tmp1_elvis_lhs_4 = nodeCache;
            var tmp;
            if (tmp1_elvis_lhs_4 == null) {
              var tmp0_also_0_5 = makeNode(this, handler, onCancelling);
              nodeCache = tmp0_also_0_5;
              tmp = tmp0_also_0_5;
            } else {
              tmp = tmp1_elvis_lhs_4;
            }
            var node_3 = tmp;
            if (this.__state_0.compareAndSet$atomicfu(tmp0__anonymous__1, node_3))
              return node_3;
          } else
            promoteEmptyToNodeList(this, tmp0__anonymous__1);
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var list_6 = tmp0__anonymous__1._get_list__10();
            if (list_6 == null) {
              promoteSingleToNodeList(this, tmp0__anonymous__1 instanceof JobNode ? tmp0__anonymous__1 : THROW_CCE());
            } else {
              var rootCause_7 = null;
              var handle_8 = NonDisposableHandle_getInstance();
              var tmp_0;
              if (onCancelling) {
                tmp_0 = tmp0__anonymous__1 instanceof Finishing;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                rootCause_7 = tmp0__anonymous__1._get_rootCause_();
                var tmp_1;
                if (rootCause_7 == null) {
                  tmp_1 = true;
                } else {
                  var tmp_2;
                  if (handler instanceof ChildHandleNode) {
                    tmp_2 = !tmp0__anonymous__1._get_isCompleting_();
                  } else {
                    {
                      tmp_2 = false;
                    }
                  }
                  tmp_1 = tmp_2;
                }
                if (tmp_1) {
                  var tmp0_elvis_lhs_3_10 = nodeCache;
                  var tmp_3;
                  if (tmp0_elvis_lhs_3_10 == null) {
                    var tmp0_also_0_4_11 = makeNode(this, handler, onCancelling);
                    nodeCache = tmp0_also_0_4_11;
                    tmp_3 = tmp0_also_0_4_11;
                  } else {
                    tmp_3 = tmp0_elvis_lhs_3_10;
                  }
                  var node_2_9 = tmp_3;
                  if (!addLastAtomic(this, tmp0__anonymous__1, list_6, node_2_9)) {
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  }if (rootCause_7 == null)
                    return node_2_9;
                  handle_8 = node_2_9;
                } else {
                }
              } else {
              }
              if (!(rootCause_7 == null)) {
                if (invokeImmediately)
                  invokeIt(handler, rootCause_7);
                return handle_8;
              } else {
                var tmp2_elvis_lhs_13 = nodeCache;
                var tmp_4;
                if (tmp2_elvis_lhs_13 == null) {
                  var tmp1_also_0_14 = makeNode(this, handler, onCancelling);
                  nodeCache = tmp1_also_0_14;
                  tmp_4 = tmp1_also_0_14;
                } else {
                  tmp_4 = tmp2_elvis_lhs_13;
                }
                var node_12 = tmp_4;
                if (addLastAtomic(this, tmp0__anonymous__1, list_6, node_12))
                  return node_12;
              }
            }
          } else {
            {
              if (invokeImmediately) {
                var tmp3_safe_receiver_15 = tmp0__anonymous__1 instanceof CompletedExceptionally ? tmp0__anonymous__1 : null;
                invokeIt(handler, tmp3_safe_receiver_15 == null ? null : tmp3_safe_receiver_15._cause);
              }return NonDisposableHandle_getInstance();
            }
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.removeNode_2 = function (node) {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__3();
      var tmp0_subject_2 = tmp0__anonymous__1;
      if (tmp0_subject_2 instanceof JobNode) {
        if (!(tmp0__anonymous__1 === node))
          return Unit_getInstance();
        if (this.__state_0.compareAndSet$atomicfu(tmp0__anonymous__1, EMPTY_ACTIVE))
          return Unit_getInstance();
      } else {
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
          if (!(tmp0__anonymous__1._get_list__10() == null)) {
            node.remove_31();
            Unit_getInstance();
          }return Unit_getInstance();
        } else {
          return Unit_getInstance();
        }
      }
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_onCancelComplete__2 = function () {
    return false;
  };
  JobSupport.prototype.cancellationExceptionMessage_2 = function () {
    return 'Job was cancelled';
  };
  JobSupport.prototype.parentCancelled_4 = function (parentJob) {
    this.cancelImpl_2(parentJob);
    Unit_getInstance();
  };
  JobSupport.prototype.childCancelled_5 = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    else {
    }
    return this.cancelImpl_2(cause) ? this._get_handlesException__2() : false;
  };
  JobSupport.prototype.cancelImpl_2 = function (cause) {
    var finalState = COMPLETING_ALREADY;
    if (this._get_onCancelComplete__2()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === COMPLETING_WAITING_CHILDREN)
        return true;
    }if (finalState === COMPLETING_ALREADY) {
      finalState = makeCancelling(this, cause);
    }var tmp;
    if (finalState === COMPLETING_ALREADY) {
      tmp = true;
    } else if (finalState === COMPLETING_WAITING_CHILDREN) {
      tmp = true;
    } else if (finalState === TOO_LATE_TO_CANCEL) {
      tmp = false;
    } else {
      this.afterCompletion_2(finalState);
      tmp = true;
    }
    return tmp;
  };
  JobSupport.prototype.getChildJobCancellationCause_3 = function () {
    var state = this._get_state__3();
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_rootCause_();
    } else {
      if (tmp0_subject instanceof CompletedExceptionally) {
        tmp = state._cause;
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
          var tmp0_error_0 = '' + 'Cannot be cancelling child in this state: ' + state;
          throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
        } else {
          {
            tmp = null;
          }
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('' + 'Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  JobSupport.prototype.makeCompletingOnce_2 = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__3();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          throw IllegalStateException_init_$Create$_0('' + 'Job ' + this + ' is already complete or completing, ' + ('' + 'but is being completed with ' + proposedUpdate), _get_exceptionOrNull_(proposedUpdate, this));
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else
          return finalState_2;
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.attachChild_3 = function (child) {
    var tmp0__get_asHandler__0 = new ChildHandleNode(this, child);
    var tmp = this.invokeOnCompletion$default_3(true, false, tmp0__get_asHandler__0, 2, null);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  JobSupport.prototype.handleOnCompletionException_2 = function (exception) {
    throw exception;
  };
  JobSupport.prototype.onCancelling_2 = function (cause) {
  };
  JobSupport.prototype._get_isScopedCoroutine__2 = function () {
    return false;
  };
  JobSupport.prototype._get_handlesException__2 = function () {
    return true;
  };
  JobSupport.prototype.handleJobException_2 = function (exception) {
    return false;
  };
  JobSupport.prototype.onCompletionInternal_2 = function (state) {
  };
  JobSupport.prototype.afterCompletion_2 = function (state) {
  };
  JobSupport.prototype.toString = function () {
    return '' + this.toDebugString_2() + '@' + _get_hexAddress_(this);
  };
  JobSupport.prototype.toDebugString_2 = function () {
    return '' + this.nameString_3() + '{' + stateString(this, this._get_state__3()) + '}';
  };
  JobSupport.prototype.nameString_3 = function () {
    return _get_classSimpleName_(this);
  };
  JobSupport.$metadata$ = {
    simpleName: 'JobSupport',
    kind: 'class',
    interfaces: [Job, ChildJob, ParentJob, SelectClause0]
  };
  function boxIncomplete(_this_) {
    var tmp;
    if (!(_this_ == null) ? isInterface(_this_, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this_);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function JobCancellingNode(job) {
    JobNode.call(this, job);
  }
  JobCancellingNode.$metadata$ = {
    simpleName: 'JobCancellingNode',
    kind: 'class',
    interfaces: []
  };
  function InactiveNodeList(list) {
    this._list = list;
  }
  InactiveNodeList.prototype._get_list__10 = function () {
    return this._list;
  };
  InactiveNodeList.prototype._get_isActive__15 = function () {
    return false;
  };
  InactiveNodeList.prototype.toString = function () {
    return DEBUG ? this._list.getString('New') : anyToString(this);
  };
  InactiveNodeList.$metadata$ = {
    simpleName: 'InactiveNodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildHandleNode(parent, childJob) {
    JobCancellingNode.call(this, parent);
    this._childJob = childJob;
  }
  ChildHandleNode.prototype.invoke_122 = function (cause) {
    return this._childJob.parentCancelled_4(this._get_job__1());
  };
  ChildHandleNode.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  ChildHandleNode.prototype.childCancelled_5 = function (cause) {
    return this._get_job__1().childCancelled_5(cause);
  };
  ChildHandleNode.$metadata$ = {
    simpleName: 'ChildHandleNode',
    kind: 'class',
    interfaces: [ChildHandle]
  };
  function InvokeOnCancelling(job, handler) {
    JobCancellingNode.call(this, job);
    this._handler_0 = handler;
    this.__invoked = atomic_1(0);
  }
  InvokeOnCancelling.prototype.invoke_122 = function (cause) {
    if (this.__invoked.compareAndSet$atomicfu(0, 1))
      this._handler_0(cause);
  };
  InvokeOnCancelling.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  InvokeOnCancelling.$metadata$ = {
    simpleName: 'InvokeOnCancelling',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCompletion(job, handler) {
    JobNode.call(this, job);
    this._handler_1 = handler;
  }
  InvokeOnCompletion.prototype.invoke_122 = function (cause) {
    return this._handler_1(cause);
  };
  InvokeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  InvokeOnCompletion.$metadata$ = {
    simpleName: 'InvokeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function IncompleteStateBox(state) {
    this._state_3 = state;
  }
  IncompleteStateBox.$metadata$ = {
    simpleName: 'IncompleteStateBox',
    kind: 'class',
    interfaces: []
  };
  function ChildContinuation(parent, child) {
    JobCancellingNode.call(this, parent);
    this._child = child;
  }
  ChildContinuation.prototype.invoke_122 = function (cause) {
    this._child.parentCancelled_2(this._child.getContinuationCancellationCause(this._get_job__1()));
  };
  ChildContinuation.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  ChildContinuation.$metadata$ = {
    simpleName: 'ChildContinuation',
    kind: 'class',
    interfaces: []
  };
  function _set_exceptionsHolder_($this, value) {
    $this.__exceptionsHolder._value_9 = value;
  }
  function _get_exceptionsHolder_($this) {
    return $this.__exceptionsHolder._value_9;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
    var wasCancelling = false;
    wasCancelling = state._get_isCancelling_();
    var exceptions_2 = state.sealLocked(proposedException);
    var finalCause_3 = getFinalRootCause($this, state, exceptions_2);
    if (!(finalCause_3 == null))
      addSuppressedExceptions($this, finalCause_3, exceptions_2);
    var finalException = finalCause_3;
    var tmp;
    if (finalException == null) {
      tmp = proposedUpdate;
    } else if (finalException === proposedException) {
      tmp = proposedUpdate;
    } else {
      tmp = CompletedExceptionally_init_$Create$(finalException, false, 2, null);
    }
    var finalState = tmp;
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) ? true : $this.handleJobException_2(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).makeHandled_0();
        Unit_getInstance();
      }}if (!wasCancelling)
      $this.onCancelling_2(finalException);
    $this.onCompletionInternal_2(finalState);
    var casSuccess = $this.__state_0.compareAndSet$atomicfu(state, boxIncomplete(finalState));
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.isEmpty_35()) {
      if (state._get_isCancelling_()) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        return new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_2() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      }return null;
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1 = exceptions.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (!(element_2 instanceof CancellationException)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var firstNonCancellation = tmp$ret$0;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first_1 = exceptions.get_57(0);
    if (first_1 instanceof TimeoutCancellationException) {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_iterator_1_0 = exceptions.iterator_52();
        while (tmp0_iterator_1_0.hasNext_27()) {
          var element_2_0 = tmp0_iterator_1_0.next_30();
          var tmp;
          if (!(element_2_0 === first_1)) {
            tmp = element_2_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$2 = element_2_0;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = null;
      }
       while (false);
      var detailedTimeoutException = tmp$ret$2;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    } else {
    }
    return first_1;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions._get_size__32() <= 1)
      return Unit_getInstance();
    var seenExceptions = identitySet(exceptions._get_size__32());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.iterator_52();
    while (tmp0_iterator.hasNext_27()) {
      var exception = tmp0_iterator.next_30();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) ? !(unwrapped === unwrappedCause) : false) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.add_19(unwrapped);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
      } else {
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update_1) {
    if (!$this.__state_0.compareAndSet$atomicfu(state, boxIncomplete(update_1)))
      return false;
    $this.onCancelling_2(null);
    $this.onCompletionInternal_2(update_1);
    completeStateFinalization($this, state, update_1);
    return true;
  }
  function completeStateFinalization($this, state, update_1) {
    var tmp0_safe_receiver = $this._get_parentHandle__2();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_10();
      $this._set_parentHandle__2(NonDisposableHandle_getInstance());
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = update_1 instanceof CompletedExceptionally ? update_1 : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._cause;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          $this.handleOnCompletionException_2(new CompletionHandlerException('' + 'Exception in completion handler ' + state + ' for ' + $this, $p));
        } else {
          {
            throw $p;
          }
        }
      }
    } else {
      {
        var tmp2_safe_receiver = state._get_list__10();
        if (tmp2_safe_receiver == null)
          null;
        else {
          notifyCompletion(tmp2_safe_receiver, $this, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.onCancelling_2(cause);
    var exception_1 = null;
    var cur_1 = list._get__next__2();
    while (!equals_1(cur_1, list)) {
      if (cur_1 instanceof JobCancellingNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_2(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    Unit_getInstance();
    cancelParent($this, cause);
    Unit_getInstance();
  }
  function cancelParent($this, cause) {
    if ($this._get_isScopedCoroutine__2())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this._get_parentHandle__2();
    if (parent === null ? true : parent === NonDisposableHandle_getInstance()) {
      return isCancellation;
    }return parent.childCancelled_5(cause) ? true : isCancellation;
  }
  function notifyCompletion(_this_, $this, cause) {
    var exception_1 = null;
    var cur_1 = _this_._get__next__2();
    while (!equals_1(cur_1, _this_)) {
      if (cur_1 instanceof JobNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_2(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function startInternal($this, state) {
    var tmp0_subject = state;
    if (tmp0_subject instanceof Empty) {
      if (state._isActive)
        return 0;
      if (!$this.__state_0.compareAndSet$atomicfu(state, EMPTY_ACTIVE))
        return -1;
      $this.onStartInternal_2();
      return 1;
    } else {
      if (tmp0_subject instanceof InactiveNodeList) {
        if (!$this.__state_0.compareAndSet$atomicfu(state, state._list))
          return -1;
        $this.onStartInternal_2();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_safe_receiver = handler instanceof JobCancellingNode ? handler : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? new InvokeOnCancelling($this, handler) : tmp1_elvis_lhs;
    } else {
      var tmp2_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        tmp_1 = tmp2_safe_receiver;
      }
      var tmp3_elvis_lhs = tmp_1;
      tmp = tmp3_elvis_lhs == null ? new InvokeOnCompletion($this, handler) : tmp3_elvis_lhs;
    }
    return tmp;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$0;
    l$ret$1: do {
      if (!($this._get_state__3() === expect)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      list.addLast_16(node);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList_0();
    var update_1 = state._isActive ? list : new InactiveNodeList(list);
    $this.__state_0.compareAndSet$atomicfu(state, update_1);
    Unit_getInstance();
  }
  function promoteSingleToNodeList($this, state) {
    state.addOneIfEmpty_6(new NodeList_0());
    Unit_getInstance();
    var list = state.__next;
    $this.__state_0.compareAndSet$atomicfu(state, list);
    Unit_getInstance();
  }
  function cancelMakeCompleting($this, cause) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__3();
      var tmp;
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false)) {
        tmp = true;
      } else {
        {
          var tmp_0;
          if (tmp0__anonymous__1 instanceof Finishing) {
            tmp_0 = tmp0__anonymous__1._get_isCompleting_();
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
      }
      if (tmp) {
        return COMPLETING_ALREADY;
      } else {
      }
      var tmp_1 = createCauseException($this, cause);
      var proposedUpdate_2 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
      var finalState_3 = tryMakeCompleting($this, tmp0__anonymous__1, proposedUpdate_2);
      if (!(finalState_3 === COMPLETING_RETRY))
        return finalState_3;
    }
    Unit_getInstance();
  }
  function createCauseException($this, cause) {
    var tmp0_subject = cause;
    var tmp;
    if (tmp0_subject == null ? true : tmp0_subject instanceof Error) {
      var tmp1_elvis_lhs = cause;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        tmp_0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_2() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      {
        tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).getChildJobCancellationCause_3();
      }
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = $this._get_state__3();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Finishing) {
          if (tmp0__anonymous__1._get_isSealed_())
            return TOO_LATE_TO_CANCEL;
          var wasCancelling_2_4 = tmp0__anonymous__1._get_isCancelling_();
          if (!(cause == null) ? true : !wasCancelling_2_4) {
            var tmp0_elvis_lhs_4_6 = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs_4_6 == null) {
              var tmp0_also_0_5_7 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_5_7;
              tmp = tmp0_also_0_5_7;
            } else {
              tmp = tmp0_elvis_lhs_4_6;
            }
            var causeException_3_5 = tmp;
            tmp0__anonymous__1.addExceptionLocked(causeException_3_5);
          }var tmp1_takeIf_0_6_8 = tmp0__anonymous__1._get_rootCause_();
          var tmp_0;
          if (!wasCancelling_2_4) {
            tmp_0 = tmp1_takeIf_0_6_8;
          } else {
            {
              tmp_0 = null;
            }
          }
          var notifyRootCause_3 = tmp_0;
          var tmp1_safe_receiver_9 = notifyRootCause_3;
          if (tmp1_safe_receiver_9 == null)
            null;
          else {
            notifyCancelling($this, tmp0__anonymous__1._list_0, tmp1_safe_receiver_9);
            Unit_getInstance();
          }
          Unit_getInstance();
          return COMPLETING_ALREADY;
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var tmp2_elvis_lhs_11 = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs_11 == null) {
              var tmp0_also_0_12 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_12;
              tmp_1 = tmp0_also_0_12;
            } else {
              tmp_1 = tmp2_elvis_lhs_11;
            }
            var causeException_10 = tmp_1;
            if (tmp0__anonymous__1._get_isActive__15()) {
              if (tryMakeCancelling($this, tmp0__anonymous__1, causeException_10))
                return COMPLETING_ALREADY;
            } else {
              var finalState_13 = tryMakeCompleting($this, tmp0__anonymous__1, CompletedExceptionally_init_$Create$(causeException_10, false, 2, null));
              if (finalState_13 === COMPLETING_ALREADY) {
                var tmp1_error_0_14 = '' + 'Cannot happen in ' + tmp0__anonymous__1;
                throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_14));
              } else if (finalState_13 === COMPLETING_RETRY) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              } else
                return finalState_13;
            }
          } else {
            return TOO_LATE_TO_CANCEL;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state._get_list__10();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_subject = state;
      var tmp_0;
      if (tmp0_subject instanceof Empty) {
        tmp_0 = new NodeList_0();
      } else {
        if (tmp0_subject instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          {
            var tmp0_error_0 = '' + 'State should have list: ' + state;
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0));
          }
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.__state_0.compareAndSet$atomicfu(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return COMPLETING_ALREADY;
    else {
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      {
        tmp_1 = state instanceof JobNode;
      }
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }return COMPLETING_RETRY;
    } else {
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return COMPLETING_RETRY;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    if (finishing._get_isCompleting_())
      return COMPLETING_ALREADY;
    finishing._set_isCompleting_(true);
    if (!(finishing === state)) {
      if (!$this.__state_0.compareAndSet$atomicfu(state, finishing))
        return COMPLETING_RETRY;
    }var wasCancelling_2 = finishing._get_isCancelling_();
    var tmp0_safe_receiver_3 = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      finishing.addExceptionLocked(tmp0_safe_receiver_3._cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_takeIf_0_4 = finishing._get_rootCause_();
    var tmp_0;
    if (!wasCancelling_2) {
      tmp_0 = tmp0_takeIf_0_4;
    } else {
      {
        tmp_0 = null;
      }
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCancelling($this, list, tmp2_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var child = firstChild($this, state);
    if (!(child == null) ? tryWaitForChild($this, finishing, child, proposedUpdate) : false)
      return COMPLETING_WAITING_CHILDREN;
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull_(_this_, $this) {
    var tmp0_safe_receiver = _this_ instanceof CompletedExceptionally ? _this_ : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state._get_list__10();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    while (true) {
      var $this_1 = $this_0;
      var state_1 = state_0;
      var child_1 = child_0;
      var proposedUpdate_1 = proposedUpdate_0;
      var tmp0__get_asHandler__0 = new ChildCompletion($this_1, state_1, child_1, proposedUpdate_1);
      var handle = child_1._childJob.invokeOnCompletion$default_3(false, false, tmp0__get_asHandler__0, 1, null);
      if (!(handle === NonDisposableHandle_getInstance()))
        return true;
      var tmp0_elvis_lhs = nextChild(child_1, $this_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      $this_0 = $this_1;
      state_0 = state_1;
      child_0 = nextChild_0;
      proposedUpdate_0 = proposedUpdate_1;
      continue;
    }
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) ? tryWaitForChild($this, state, waitChild, proposedUpdate) : false)
      return Unit_getInstance();
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.afterCompletion_2(finalState);
  }
  function nextChild(_this_, $this) {
    var cur = _this_;
    while (true) {
      var tmp0__get_isRemoved__0 = cur;
      if (!tmp0__get_isRemoved__0.__removed) {
        break;
      }var tmp1__get_prevNode__0 = cur;
      cur = tmp1__get_prevNode__0.__prev;
    }
    while (true) {
      var tmp2__get_nextNode__0 = cur;
      cur = tmp2__get_nextNode__0.__next;
      var tmp3__get_isRemoved__0 = cur;
      if (tmp3__get_isRemoved__0.__removed)
        continue;
      else {
      }
      if (cur instanceof ChildHandleNode)
        return cur;
      else {
      }
      if (cur instanceof NodeList_0)
        return null;
      else {
      }
    }
  }
  function stateString($this, state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_isCancelling_() ? 'Cancelling' : state._get_isCompleting_() ? 'Completing' : 'Active';
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
        tmp = state._get_isActive__15() ? 'Active' : 'New';
      } else {
        if (tmp0_subject instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          {
            tmp = 'Completed';
          }
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this._list_0 = list;
    this.__isCompleting = atomic_0(isCompleting);
    this.__rootCause = atomic(rootCause);
    this.__exceptionsHolder = atomic(null);
  }
  Finishing.prototype._get_list__10 = function () {
    return this._list_0;
  };
  Finishing.prototype._set_isCompleting_ = function (value) {
    this.__isCompleting._value_10 = value;
  };
  Finishing.prototype._get_isCompleting_ = function () {
    return this.__isCompleting._value_10;
  };
  Finishing.prototype._set_rootCause_ = function (value) {
    this.__rootCause._value_9 = value;
  };
  Finishing.prototype._get_rootCause_ = function () {
    return this.__rootCause._value_9;
  };
  Finishing.prototype._get_isSealed_ = function () {
    return _get_exceptionsHolder_(this) === SEALED_0;
  };
  Finishing.prototype._get_isCancelling_ = function () {
    return !(this._get_rootCause_() == null);
  };
  Finishing.prototype._get_isActive__15 = function () {
    return this._get_rootCause_() == null;
  };
  Finishing.prototype.sealLocked = function (proposedException) {
    var eh = _get_exceptionsHolder_(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        var tmp0_also_0 = allocateList(this);
        tmp0_also_0.add_19(eh);
        Unit_getInstance();
        tmp = tmp0_also_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
          }
        }
      }
    }
    var list = tmp;
    var rootCause = this._get_rootCause_();
    var tmp0_safe_receiver = rootCause;
    if (tmp0_safe_receiver == null)
      null;
    else {
      list.add_10(0, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    if (!(proposedException == null) ? !equals_1(proposedException, rootCause) : false) {
      list.add_19(proposedException);
      Unit_getInstance();
    }_set_exceptionsHolder_(this, SEALED_0);
    return list;
  };
  Finishing.prototype.addExceptionLocked = function (exception) {
    var rootCause = this._get_rootCause_();
    if (rootCause == null) {
      this._set_rootCause_(exception);
      return Unit_getInstance();
    }if (exception === rootCause)
      return Unit_getInstance();
    var eh = _get_exceptionsHolder_(this);
    if (eh == null)
      _set_exceptionsHolder_(this, exception);
    else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_getInstance();
        var tmp0_apply_0 = allocateList(this);
        tmp0_apply_0.add_19(eh);
        Unit_getInstance();
        tmp0_apply_0.add_19(exception);
        Unit_getInstance();
        _set_exceptionsHolder_(this, tmp0_apply_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).add_19(exception);
          Unit_getInstance();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0));
          }
        }
      }
    }
  };
  Finishing.prototype.toString = function () {
    return '' + 'Finishing[cancelling=' + this._get_isCancelling_() + ', completing=' + this._get_isCompleting_() + ', rootCause=' + this._get_rootCause_() + ', exceptions=' + _get_exceptionsHolder_(this) + ', list=' + this._list_0 + ']';
  };
  Finishing.$metadata$ = {
    simpleName: 'Finishing',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this, child._childJob);
    this._parent = parent;
    this._state_4 = state;
    this._child_0 = child;
    this._proposedUpdate = proposedUpdate;
  }
  ChildCompletion.prototype.invoke_122 = function (cause) {
    continueCompleting(this._parent, this._state_4, this._child_0, this._proposedUpdate);
  };
  ChildCompletion.prototype.invoke = function (cause) {
    return this.invoke_122(cause);
  };
  ChildCompletion.$metadata$ = {
    simpleName: 'ChildCompletion',
    kind: 'class',
    interfaces: []
  };
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  MainCoroutineDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) : tmp0_elvis_lhs;
  };
  MainCoroutineDispatcher.prototype.toStringInternalImpl_0 = function () {
    var main_0 = Dispatchers_getInstance()._Main;
    if (this === main_0)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main_0._get_immediate__0();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  MainCoroutineDispatcher.$metadata$ = {
    simpleName: 'MainCoroutineDispatcher',
    kind: 'class',
    interfaces: []
  };
  function TimeoutCancellationException() {
  }
  TimeoutCancellationException.$metadata$ = {
    simpleName: 'TimeoutCancellationException',
    kind: 'class',
    interfaces: [CopyableThrowable]
  };
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  Unconfined.prototype.isDispatchNeeded_8 = function (context) {
    return false;
  };
  Unconfined.prototype.dispatch_8 = function (context, block) {
    var yieldContext = context.get_42(Key_getInstance_2());
    if (!(yieldContext == null)) {
      yieldContext.dispatcherWasUnconfined__error = true;
      return Unit_getInstance();
    }throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  Unconfined.prototype.toString = function () {
    return 'Dispatchers.Unconfined';
  };
  Unconfined.$metadata$ = {
    simpleName: 'Unconfined',
    kind: 'object',
    interfaces: []
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_3() {
    Key_instance_2 = this;
  }
  Key_3.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_2;
  function Key_getInstance_2() {
    if (Key_instance_2 == null)
      new Key_3();
    return Key_instance_2;
  }
  function ArrayQueue() {
    var tmp = this;
    var tmp0_arrayOfNulls_0 = 16;
    tmp._elements = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._head_0 = 0;
    this._tail = 0;
  }
  ArrayQueue.prototype._get_isEmpty__4 = function () {
    return this._head_0 === this._tail;
  };
  ArrayQueue.prototype.addLast_7 = function (element) {
    this._elements[this._tail] = element;
    this._tail = (this._tail + 1 | 0) & (this._elements.length - 1 | 0);
    if (this._tail === this._head_0)
      ensureCapacity(this);
  };
  ArrayQueue.prototype.removeFirstOrNull_4 = function () {
    if (this._head_0 === this._tail)
      return null;
    var element = this._elements[this._head_0];
    this._elements[this._head_0] = null;
    this._head_0 = (this._head_0 + 1 | 0) & (this._elements.length - 1 | 0);
    return isObject(element) ? element : THROW_CCE();
  };
  ArrayQueue.$metadata$ = {
    simpleName: 'ArrayQueue',
    kind: 'class',
    interfaces: []
  };
  function ensureCapacity($this) {
    var currentSize = $this._elements.length;
    var newCapacity = currentSize << 1;
    var newElements = fillArrayVal(Array(newCapacity), null);
    var tmp0_copyInto_0 = $this._elements;
    var tmp1_copyInto_0 = $this._head_0;
    var tmp2_copyInto_0 = 0;
    var tmp3_copyInto_0 = tmp0_copyInto_0.length;
    arrayCopy_0(tmp0_copyInto_0, newElements, tmp2_copyInto_0, tmp1_copyInto_0, tmp3_copyInto_0);
    Unit_getInstance();
    var tmp4_copyInto_0 = $this._elements;
    var tmp5_copyInto_0 = $this._elements.length - $this._head_0 | 0;
    var tmp6_copyInto_0 = $this._head_0;
    var tmp7_copyInto_0 = 0;
    arrayCopy_0(tmp4_copyInto_0, newElements, tmp5_copyInto_0, tmp7_copyInto_0, tmp6_copyInto_0);
    Unit_getInstance();
    $this._elements = newElements;
    $this._head_0 = 0;
    $this._tail = currentSize;
  }
  var NO_DECISION;
  function OpDescriptor() {
  }
  OpDescriptor.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this);
  };
  OpDescriptor.$metadata$ = {
    simpleName: 'OpDescriptor',
    kind: 'class',
    interfaces: []
  };
  function AtomicOp() {
    OpDescriptor.call(this);
    this.__consensus = atomic(NO_DECISION);
  }
  AtomicOp.prototype.decide_0 = function (decision) {
    var current = this.__consensus._value_9;
    if (!(current === NO_DECISION))
      return current;
    if (this.__consensus.compareAndSet$atomicfu(NO_DECISION, decision))
      return decision;
    return this.__consensus._value_9;
  };
  AtomicOp.prototype.perform_1 = function (affected) {
    var decision = this.__consensus._value_9;
    if (decision === NO_DECISION) {
      decision = this.decide_0(this.prepare_1((affected == null ? true : isObject(affected)) ? affected : THROW_CCE()));
    }this.complete_2((affected == null ? true : isObject(affected)) ? affected : THROW_CCE(), decision);
    return decision;
  };
  AtomicOp.$metadata$ = {
    simpleName: 'AtomicOp',
    kind: 'class',
    interfaces: []
  };
  var UNDEFINED;
  var REUSABLE_CLAIMED;
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this._dispatcher = dispatcher;
    this._continuation_0 = continuation;
    this.__state_1 = UNDEFINED;
    var tmp = this;
    var tmp_0 = this._continuation_0;
    tmp._callerFrame = isInterface(tmp_0, CoroutineStackFrame) ? tmp_0 : null;
    this._countOrElement = threadContextElements(this._get_context__9());
    this.__reusableCancellableContinuation = atomic(null);
  }
  DispatchedContinuation.prototype._get_context__9 = function () {
    return this._continuation_0._get_context__9();
  };
  DispatchedContinuation.prototype._get_reusableCancellableContinuation_ = function () {
    var tmp = this.__reusableCancellableContinuation._value_9;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  };
  DispatchedContinuation.prototype.isReusable = function (requester) {
    var tmp0_elvis_lhs = this.__reusableCancellableContinuation._value_9;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    if (value instanceof CancellableContinuationImpl)
      return value === requester;
    else {
    }
    return true;
  };
  DispatchedContinuation.prototype.claimReusableCancellableContinuation = function () {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      if (tmp1__anonymous__1 === null) {
        this.__reusableCancellableContinuation._value_9 = REUSABLE_CLAIMED;
        return null;
      } else {
        if (tmp1__anonymous__1 instanceof CancellableContinuationImpl) {
          if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(tmp1__anonymous__1, REUSABLE_CLAIMED)) {
            return tmp1__anonymous__1 instanceof CancellableContinuationImpl ? tmp1__anonymous__1 : THROW_CCE();
          }} else {
          {
            var tmp0_error_0_2 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
            throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_2));
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.checkPostponedCancellation = function (continuation) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      if (tmp1__anonymous__1 === REUSABLE_CLAIMED) {
        if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(REUSABLE_CLAIMED, continuation))
          return null;
      } else {
        if (tmp1__anonymous__1 === null)
          return null;
        else {
          if (tmp1__anonymous__1 instanceof Error) {
            var tmp0_require_0_2 = this.__reusableCancellableContinuation.compareAndSet$atomicfu(tmp1__anonymous__1, null);
            if (!tmp0_require_0_2) {
              var message_1_1_3 = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$(toString_1(message_1_1_3));
            }return tmp1__anonymous__1;
          } else {
            {
              var tmp1_error_0_4 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_4));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.postponeCancellation = function (cause) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (equals_1(tmp0_subject_2, REUSABLE_CLAIMED)) {
        if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(REUSABLE_CLAIMED, cause))
          return true;
      } else {
        if (tmp0_subject_2 instanceof Error)
          return true;
        else {
          {
            if (this.__reusableCancellableContinuation.compareAndSet$atomicfu(tmp1__anonymous__1, null))
              return false;
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.takeState_1 = function () {
    var state = this.__state_1;
    this.__state_1 = UNDEFINED;
    return state;
  };
  DispatchedContinuation.prototype._get_delegate__1 = function () {
    return this;
  };
  DispatchedContinuation.prototype.resumeWith_11 = function (result) {
    var context = this._continuation_0._get_context__9();
    var state = toState$default(result, null, 1, null);
    if (this._dispatcher.isDispatchNeeded_8(context)) {
      this.__state_1 = state;
      this._set_resumeMode__0(0);
      this._dispatcher.dispatch_8(context, this);
    } else {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_executeUnconfined_0 = 0;
        var tmp1_executeUnconfined_0 = false;
        var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
        if (tmp1_executeUnconfined_0 ? eventLoop_2._get_isUnconfinedQueueEmpty__0() : false) {
          tmp$ret$0 = false;
          break l$ret$1;
        }var tmp;
        if (eventLoop_2._get_isUnconfinedLoopActive__0()) {
          this.__state_1 = state;
          this._set_resumeMode__0(tmp0_executeUnconfined_0);
          eventLoop_2.dispatchUnconfined_0(this);
          tmp = true;
        } else {
          eventLoop_2.incrementUseCount_0(true);
          try {
            var tmp0_withCoroutineContext_0_4 = this._get_context__9();
            var tmp1_withCoroutineContext_0_5 = this._countOrElement;
            this._continuation_0.resumeWith_11(result);
            while (true) {
              if (!eventLoop_2.processUnconfinedEvent_0())
                break;
            }
          } catch ($p) {
            if ($p instanceof Error) {
              this.handleFatalException_1($p, null);
            } else {
              {
                throw $p;
              }
            }
          }
          finally {
            eventLoop_2.decrementUseCount_0(true);
          }
          tmp = false;
        }
        tmp$ret$0 = tmp;
      }
       while (false);
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.cancelCompletedResult_1 = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState._onCancellation_0(cause);
    } else {
    }
  };
  DispatchedContinuation.prototype.toString = function () {
    return '' + 'DispatchedContinuation[' + this._dispatcher + ', ' + toDebugString(this._continuation_0) + ']';
  };
  DispatchedContinuation.$metadata$ = {
    simpleName: 'DispatchedContinuation',
    kind: 'class',
    interfaces: [CoroutineStackFrame, Continuation]
  };
  function resumeCancellableWith(_this_, result, onCancellation) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof DispatchedContinuation) {
      var tmp0_resumeCancellableWith_0 = _this_;
      var state_1 = toState_0(result, onCancellation);
      var tmp_0;
      if (tmp0_resumeCancellableWith_0._dispatcher.isDispatchNeeded_8(tmp0_resumeCancellableWith_0._get_context__9())) {
        tmp0_resumeCancellableWith_0.__state_1 = state_1;
        tmp0_resumeCancellableWith_0._set_resumeMode__0(1);
        tmp_0 = tmp0_resumeCancellableWith_0._dispatcher.dispatch_8(tmp0_resumeCancellableWith_0._get_context__9(), tmp0_resumeCancellableWith_0);
      } else {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_executeUnconfined_0_2 = 1;
          var tmp1_executeUnconfined_0_3 = false;
          var eventLoop_2_4 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
          if (tmp1_executeUnconfined_0_3 ? eventLoop_2_4._get_isUnconfinedQueueEmpty__0() : false) {
            tmp$ret$0 = false;
            break l$ret$1;
          }var tmp_1;
          if (eventLoop_2_4._get_isUnconfinedLoopActive__0()) {
            tmp0_resumeCancellableWith_0.__state_1 = state_1;
            tmp0_resumeCancellableWith_0._set_resumeMode__0(tmp0_executeUnconfined_0_2);
            eventLoop_2_4.dispatchUnconfined_0(tmp0_resumeCancellableWith_0);
            tmp_1 = true;
          } else {
            eventLoop_2_4.incrementUseCount_0(true);
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var job_1_4_5 = tmp0_resumeCancellableWith_0._get_context__9().get_42(Key_getInstance_1());
                if (!(job_1_4_5 == null) ? !job_1_4_5._get_isActive__15() : false) {
                  var cause_2_5_6 = job_1_4_5.getCancellationException_3();
                  tmp0_resumeCancellableWith_0.cancelCompletedResult_1(state_1, cause_2_5_6);
                  var tmp0_failure_0_1_6_7 = Companion_getInstance_3();
                  tmp0_resumeCancellableWith_0.resumeWith_11(createFailure(cause_2_5_6));
                  tmp$ret$2 = true;
                  break l$ret$3;
                }tmp$ret$2 = false;
              }
               while (false);
              if (!tmp$ret$2) {
                var tmp0_withCoroutineContext_0_7_8 = tmp0_resumeCancellableWith_0._get_context__9();
                var tmp1_withCoroutineContext_0_8_9 = tmp0_resumeCancellableWith_0._countOrElement;
                tmp0_resumeCancellableWith_0._continuation_0.resumeWith_11(result);
              } else {
              }
              while (true) {
                if (!eventLoop_2_4.processUnconfinedEvent_0())
                  break;
              }
            } catch ($p) {
              if ($p instanceof Error) {
                tmp0_resumeCancellableWith_0.handleFatalException_1($p, null);
              } else {
                {
                  throw $p;
                }
              }
            }
            finally {
              eventLoop_2_4.decrementUseCount_0(true);
            }
            tmp_1 = false;
          }
          tmp$ret$0 = tmp_1;
        }
         while (false);
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = _this_.resumeWith_11(result);
      }
    }
    return tmp;
  }
  function resumeCancellableWith$default(_this_, result, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      onCancellation = null;
    return resumeCancellableWith(_this_, result, onCancellation);
  }
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this._resumeMode = resumeMode;
  }
  DispatchedTask.prototype._set_resumeMode__0 = function (_set___) {
    this._resumeMode = _set___;
  };
  DispatchedTask.prototype._get_resumeMode__0 = function () {
    return this._resumeMode;
  };
  DispatchedTask.prototype.cancelCompletedResult_1 = function (takenState, cause) {
  };
  DispatchedTask.prototype.getSuccessfulResult_1 = function (state) {
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedTask.prototype.getExceptionalResult_1 = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  };
  DispatchedTask.prototype.run_3 = function () {
    var taskContext = _get_taskContext_(this);
    var fatalException = null;
    try {
      var tmp = this._get_delegate__1();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate._continuation_0;
      var context = continuation._get_context__9();
      var state = this.takeState_1();
      var tmp0_withCoroutineContext_0 = delegate._countOrElement;
      var exception_2 = this.getExceptionalResult_1(state);
      var job_3 = (exception_2 == null ? _get_isCancellableMode_(this._resumeMode) : false) ? context.get_42(Key_getInstance_1()) : null;
      if (!(job_3 == null) ? !job_3._get_isActive__15() : false) {
        var cause_4 = job_3.getCancellationException_3();
        this.cancelCompletedResult_1(state, cause_4);
        var tmp0_failure_0_5 = Companion_getInstance_3();
        var tmp1_failure_0_6 = recoverStackTrace(cause_4, continuation);
        continuation.resumeWith_11(createFailure(tmp1_failure_0_6));
      } else {
        if (!(exception_2 == null)) {
          var tmp0_failure_0_1_7 = Companion_getInstance_3();
          continuation.resumeWith_11(createFailure(exception_2));
        } else {
          var tmp2_resume_0_8 = this.getSuccessfulResult_1(state);
          var tmp0_success_0_1_9 = Companion_getInstance_3();
          continuation.resumeWith_11(tmp2_resume_0_8);
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        fatalException = $p;
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      var tmp_0;
      try {
        var tmp0_success_0_1 = Companion_getInstance_3();
        var tmp1_success_0_2 = Unit_getInstance();
        tmp_0 = Unit_getInstance();
      } catch ($p_0) {
        var tmp_1;
        if ($p_0 instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_3();
          tmp_1 = createFailure($p_0);
        } else {
          {
            throw $p_0;
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.handleFatalException_1(fatalException, exceptionOrNull_impl(result));
    }
  };
  DispatchedTask.prototype.handleFatalException_1 = function (exception, finallyException) {
    if (exception === null ? finallyException === null : false)
      return Unit_getInstance();
    if (!(exception === null) ? !(finallyException === null) : false) {
    }var tmp0_elvis_lhs = exception;
    var cause = tmp0_elvis_lhs == null ? finallyException : tmp0_elvis_lhs;
    var reason = new CoroutinesInternalError('' + 'Fatal exception in coroutines machinery for ' + this + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this._get_delegate__1()._get_context__9(), reason);
  };
  DispatchedTask.$metadata$ = {
    simpleName: 'DispatchedTask',
    kind: 'class',
    interfaces: []
  };
  function _get_isCancellableMode_(_this_) {
    return _this_ === 1 ? true : _this_ === 2;
  }
  function _get_isReusableMode_(_this_) {
    return _this_ === 2;
  }
  function dispatch(_this_, mode) {
    var delegate = _this_._get_delegate__1();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _get_isCancellableMode_(mode) === _get_isCancellableMode_(_this_._resumeMode);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var dispatcher = delegate._dispatcher;
      var context = delegate._get_context__9();
      if (dispatcher.isDispatchNeeded_8(context)) {
        dispatcher.dispatch_8(context, _this_);
      } else {
        resumeUnconfined(_this_);
      }
    } else {
      {
        resume(_this_, delegate, undispatched);
      }
    }
  }
  function resumeUnconfined(_this_) {
    var eventLoop = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
    if (eventLoop._get_isUnconfinedLoopActive__0()) {
      eventLoop.dispatchUnconfined_0(_this_);
    } else {
      eventLoop.incrementUseCount_0(true);
      try {
        resume(_this_, _this_._get_delegate__1(), true);
        while (true) {
          if (!eventLoop.processUnconfinedEvent_0())
            break;
        }
      } catch ($p) {
        if ($p instanceof Error) {
          _this_.handleFatalException_1($p, null);
        } else {
          {
            throw $p;
          }
        }
      }
      finally {
        eventLoop.decrementUseCount_0(true);
      }
    }
  }
  function resume(_this_, delegate, undispatched) {
    var state = _this_.takeState_1();
    var exception = _this_.getExceptionalResult_1(state);
    var tmp;
    if (!(exception == null)) {
      var tmp0_failure_0 = Companion_getInstance_3();
      tmp = createFailure(exception);
    } else {
      var tmp1_success_0 = Companion_getInstance_3();
      var tmp2_success_0 = _this_.getSuccessfulResult_1(state);
      tmp = tmp2_success_0;
    }
    var result = tmp;
    if (undispatched) {
      var tmp3_resumeUndispatchedWith_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      var tmp0_withCoroutineContext_0_1 = tmp3_resumeUndispatchedWith_0._get_context__9();
      var tmp1_withCoroutineContext_0_2 = tmp3_resumeUndispatchedWith_0._countOrElement;
      tmp3_resumeUndispatchedWith_0._continuation_0.resumeWith_11(result);
    } else
      delegate.resumeWith_11(result);
  }
  function Symbol(symbol) {
    this._symbol = symbol;
  }
  Symbol.prototype.toString = function () {
    return this._symbol;
  };
  Symbol.$metadata$ = {
    simpleName: 'Symbol',
    kind: 'class',
    interfaces: []
  };
  function startCoroutineCancellable(_this_, receiver, completion, onCancellation) {
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
      var tmp0_success_0_3 = Companion_getInstance_3();
      var tmp1_success_0_4 = Unit_getInstance();
      tmp = resumeCancellableWith(tmp_0, Unit_getInstance(), onCancellation);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp0_failure_0 = Companion_getInstance_3();
        tmp_1 = completion.resumeWith_11(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable$default(_this_, receiver, completion, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    return startCoroutineCancellable(_this_, receiver, completion, onCancellation);
  }
  function startCoroutineCancellable_0(_this_, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this_);
      var tmp0_success_0_4 = Companion_getInstance_3();
      var tmp1_success_0_5 = Unit_getInstance();
      var tmp_1 = Unit_getInstance();
      tmp = resumeCancellableWith$default(tmp_0, tmp_1, null, 2, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var tmp0_failure_0_2 = Companion_getInstance_3();
        tmp_2 = fatalCompletion.resumeWith_11(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function startCoroutineUndispatched(_this_, receiver, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var actualCompletion_1 = completion;
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_8 = completion._get_context__9();
        var tmp1_withCoroutineContext_0_9 = null;
        tmp = _this_(receiver, actualCompletion_1);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1_4 = Companion_getInstance_3();
          actualCompletion_1.resumeWith_11(createFailure($p));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_2 = tmp;
      if (!(value_2 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0_5 = (value_2 == null ? true : isObject(value_2)) ? value_2 : THROW_CCE();
        var tmp0_success_0_1_6 = Companion_getInstance_3();
        actualCompletion_1.resumeWith_11(tmp0_resume_0_5);
      }}
     while (false);
  }
  function SelectClause0() {
  }
  SelectClause0.$metadata$ = {
    simpleName: 'SelectClause0',
    kind: 'interface',
    interfaces: []
  };
  function SelectClause2() {
  }
  SelectClause2.$metadata$ = {
    simpleName: 'SelectClause2',
    kind: 'interface',
    interfaces: []
  };
  var UNLOCK_FAIL;
  var LOCKED;
  var UNLOCKED;
  var EMPTY_LOCKED;
  var EMPTY_UNLOCKED;
  function Empty_0(locked) {
    this._locked = locked;
  }
  Empty_0.prototype.toString = function () {
    return '' + 'Empty[' + this._locked + ']';
  };
  Empty_0.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: []
  };
  function Mutex() {
  }
  Mutex.prototype.unlock$default_0 = function (owner, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      owner = null;
    return $handler == null ? this.unlock_0(owner) : $handler(owner);
  };
  Mutex.$metadata$ = {
    simpleName: 'Mutex',
    kind: 'interface',
    interfaces: []
  };
  function Mutex_0(locked) {
    return new MutexImpl(locked);
  }
  function Mutex$default(locked, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      locked = false;
    return Mutex_0(locked);
  }
  function MutexImpl(locked) {
    this.__state_2 = atomic(locked ? EMPTY_LOCKED : EMPTY_UNLOCKED);
  }
  MutexImpl.prototype._get_isLocked__0 = function () {
    var tmp0_loop_0 = this.__state_2;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Empty_0)
        return !(tmp1__anonymous__1._locked === UNLOCKED);
      else {
        if (tmp0_subject_2 instanceof LockedQueue)
          return true;
        else {
          if (tmp0_subject_2 instanceof OpDescriptor) {
            tmp1__anonymous__1.perform_1(this);
            Unit_getInstance();
          } else {
            {
              var tmp0_error_0_3 = '' + 'Illegal state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  MutexImpl.prototype.tryLock = function (owner) {
    var tmp0_loop_0 = this.__state_2;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Empty_0) {
        if (!(tmp1__anonymous__1._locked === UNLOCKED))
          return false;
        var update_3 = owner == null ? EMPTY_LOCKED : new Empty_0(owner);
        if (this.__state_2.compareAndSet$atomicfu(tmp1__anonymous__1, update_3))
          return true;
      } else {
        if (tmp0_subject_2 instanceof LockedQueue) {
          var tmp0_check_0_4 = !(tmp1__anonymous__1._owner === owner);
          if (!tmp0_check_0_4) {
            var message_1_5 = '' + 'Already locked by ' + owner;
            throw IllegalStateException_init_$Create$(toString_1(message_1_5));
          }return false;
        } else {
          if (tmp0_subject_2 instanceof OpDescriptor) {
            tmp1__anonymous__1.perform_1(this);
            Unit_getInstance();
          } else {
            {
              var tmp1_error_0_6 = '' + 'Illegal state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp1_error_0_6));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  MutexImpl.prototype.lock_0 = function (owner, $cont) {
    if (this.tryLock(owner))
      return Unit_getInstance();
    return lockSuspend(this, owner, $cont);
  };
  MutexImpl.prototype.unlock_0 = function (owner) {
    var tmp0_loop_0 = this.__state_2;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Empty_0) {
        if (owner == null) {
          var tmp0_check_0_3 = !(tmp1__anonymous__1._locked === UNLOCKED);
          if (!tmp0_check_0_3) {
            var message_1_4 = 'Mutex is not locked';
            throw IllegalStateException_init_$Create$(toString_1(message_1_4));
          }} else {
          var tmp1_check_0_5 = tmp1__anonymous__1._locked === owner;
          if (!tmp1_check_0_5) {
            var message_1_6 = '' + 'Mutex is locked by ' + tmp1__anonymous__1._locked + ' but expected ' + owner;
            throw IllegalStateException_init_$Create$(toString_1(message_1_6));
          }}
        if (this.__state_2.compareAndSet$atomicfu(tmp1__anonymous__1, EMPTY_UNLOCKED))
          return Unit_getInstance();
      } else {
        if (tmp0_subject_2 instanceof OpDescriptor) {
          tmp1__anonymous__1.perform_1(this);
          Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof LockedQueue) {
            if (!(owner == null)) {
              var tmp2_check_0_7 = tmp1__anonymous__1._owner === owner;
              if (!tmp2_check_0_7) {
                var message_1_8 = '' + 'Mutex is locked by ' + tmp1__anonymous__1._owner + ' but expected ' + owner;
                throw IllegalStateException_init_$Create$(toString_1(message_1_8));
              }}var waiter_9 = tmp1__anonymous__1.removeFirstOrNull_4();
            if (waiter_9 == null) {
              var op_10 = new UnlockOp(tmp1__anonymous__1);
              if (this.__state_2.compareAndSet$atomicfu(tmp1__anonymous__1, op_10) ? op_10.perform_1(this) == null : false)
                return Unit_getInstance();
            } else {
              var token_11 = (waiter_9 instanceof LockWaiter ? waiter_9 : THROW_CCE()).tryResumeLockWaiter_0();
              if (!(token_11 == null)) {
                var tmp = tmp1__anonymous__1;
                var tmp1_elvis_lhs_12 = waiter_9._owner_0;
                tmp._owner = tmp1_elvis_lhs_12 == null ? LOCKED : tmp1_elvis_lhs_12;
                waiter_9.completeResumeLockWaiter_0(token_11);
                return Unit_getInstance();
              }}
          } else {
            {
              var tmp3_error_0_13 = '' + 'Illegal state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp3_error_0_13));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  MutexImpl.prototype.toString = function () {
    var tmp0_loop_0 = this.__state_2;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_9;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Empty_0)
        return '' + 'Mutex[' + tmp1__anonymous__1._locked + ']';
      else {
        if (tmp0_subject_2 instanceof OpDescriptor) {
          tmp1__anonymous__1.perform_1(this);
          Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof LockedQueue)
            return '' + 'Mutex[' + tmp1__anonymous__1._owner + ']';
          else {
            {
              var tmp0_error_0_3 = '' + 'Illegal state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$(toString_1(tmp0_error_0_3));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  MutexImpl.$metadata$ = {
    simpleName: 'MutexImpl',
    kind: 'class',
    interfaces: [Mutex, SelectClause2]
  };
  function _no_name_provided_$factory_63(this$0, $owner) {
    var i = new _no_name_provided__86(this$0, $owner);
    return function (p1) {
      i.invoke_125(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_64(this$0, this$1) {
    var i = new _no_name_provided__85(this$0, this$1);
    return function (p1) {
      i.invoke_125(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__85(this$0, this$1) {
    this._this$0_27 = this$0;
    this._this$1 = this$1;
  }
  _no_name_provided__85.prototype.invoke_125 = function (it) {
    this._this$0_27.unlock_0(this._this$1._get_owner__0());
  };
  _no_name_provided__85.prototype.invoke_276 = function (p1) {
    this.invoke_125(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function lockSuspend($this, owner, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      var waiter_4 = new LockCont($this, owner, cancellable_2_2);
      var tmp0_loop_0_5 = $this.__state_2;
      while (true) {
        var tmp1__anonymous__1_6 = tmp0_loop_0_5._value_9;
        var tmp0_subject_2_7 = tmp1__anonymous__1_6;
        if (tmp0_subject_2_7 instanceof Empty_0) {
          if (!(tmp1__anonymous__1_6._locked === UNLOCKED)) {
            $this.__state_2.compareAndSet$atomicfu(tmp1__anonymous__1_6, new LockedQueue(tmp1__anonymous__1_6._locked));
            Unit_getInstance();
          } else {
            var update_3_8 = owner == null ? EMPTY_LOCKED : new Empty_0(owner);
            if ($this.__state_2.compareAndSet$atomicfu(tmp1__anonymous__1_6, update_3_8)) {
              cancellable_2_2.resume_0(Unit_getInstance(), _no_name_provided_$factory_63($this, owner));
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            }}
        } else {
          if (tmp0_subject_2_7 instanceof LockedQueue) {
            var curOwner_5_10 = tmp1__anonymous__1_6._owner;
            var tmp0_check_0_6_11 = !(curOwner_5_10 === owner);
            if (!tmp0_check_0_6_11) {
              var message_1_7_12 = '' + 'Already locked by ' + owner;
              throw IllegalStateException_init_$Create$(toString_1(message_1_7_12));
            }var tmp$ret$2;
            l$ret$3: do {
              var tmp1_addLastIf_0_8_13 = tmp1__anonymous__1_6;
              if (!($this.__state_2._value_9 === tmp1__anonymous__1_6)) {
                tmp$ret$2 = false;
                break l$ret$3;
              } else {
              }
              tmp1_addLastIf_0_8_13.addLast_16(waiter_4);
              tmp$ret$2 = true;
            }
             while (false);
            if (tmp$ret$2) {
              removeOnCancellation(cancellable_2_2, waiter_4);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
            }
          } else {
            if (tmp0_subject_2_7 instanceof OpDescriptor) {
              tmp1__anonymous__1_6.perform_1($this);
              Unit_getInstance();
            } else {
              {
                var tmp2_error_0_9_14 = '' + 'Illegal state ' + tmp1__anonymous__1_6;
                throw IllegalStateException_init_$Create$(toString_1(tmp2_error_0_9_14));
              }
            }
          }
        }
      }
      Unit_getInstance();
    }
     while (false);
    return cancellable_2_2.getResult();
  }
  function LockedQueue(owner) {
    LinkedListHead.call(this);
    this._owner = owner;
  }
  LockedQueue.prototype.toString = function () {
    return '' + 'LockedQueue[' + this._owner + ']';
  };
  LockedQueue.$metadata$ = {
    simpleName: 'LockedQueue',
    kind: 'class',
    interfaces: []
  };
  function LockWaiter($outer, owner) {
    this._$this_7 = $outer;
    LinkedListNode.call(this);
    this._owner_0 = owner;
  }
  LockWaiter.prototype._get_owner__0 = function () {
    return this._owner_0;
  };
  LockWaiter.prototype.dispose_10 = function () {
    this.remove_31();
    Unit_getInstance();
  };
  LockWaiter.$metadata$ = {
    simpleName: 'LockWaiter',
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function LockCont($outer, owner, cont) {
    this._$this_8 = $outer;
    LockWaiter.call(this, $outer, owner);
    this._cont = cont;
  }
  LockCont.prototype.tryResumeLockWaiter_0 = function () {
    return this._cont.tryResume_0(Unit_getInstance(), null, _no_name_provided_$factory_64(this._$this_8, this));
  };
  LockCont.prototype.completeResumeLockWaiter_0 = function (token) {
    return this._cont.completeResume_0(token);
  };
  LockCont.prototype.toString = function () {
    return '' + 'LockCont[' + this._get_owner__0() + ', ' + this._cont + '] for ' + this._$this_8;
  };
  LockCont.$metadata$ = {
    simpleName: 'LockCont',
    kind: 'class',
    interfaces: []
  };
  function UnlockOp(queue) {
    AtomicOp.call(this);
    this._queue = queue;
  }
  UnlockOp.prototype.prepare_0 = function (affected) {
    return this._queue._get_isEmpty__4() ? null : UNLOCK_FAIL;
  };
  UnlockOp.prototype.prepare_1 = function (affected) {
    return this.prepare_0(affected instanceof MutexImpl ? affected : THROW_CCE());
  };
  UnlockOp.prototype.complete_1 = function (affected, failure) {
    var update_1 = failure == null ? EMPTY_UNLOCKED : this._queue;
    affected.__state_2.compareAndSet$atomicfu(this, update_1);
    Unit_getInstance();
  };
  UnlockOp.prototype.complete_2 = function (affected, failure) {
    return this.complete_1(affected instanceof MutexImpl ? affected : THROW_CCE(), failure);
  };
  UnlockOp.$metadata$ = {
    simpleName: 'UnlockOp',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__86(this$0, $owner) {
    this._this$0_28 = this$0;
    this._$owner = $owner;
  }
  _no_name_provided__86.prototype.invoke_125 = function (it) {
    this._this$0_28.unlock_0(this._$owner);
  };
  _no_name_provided__86.prototype.invoke_276 = function (p1) {
    this.invoke_125(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  CompletionHandlerBase.$metadata$ = {
    simpleName: 'CompletionHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function invokeIt(_this_, cause) {
    var tmp0_subject = typeof _this_;
    if (tmp0_subject === 'function')
      _this_(cause);
    else {
      _this_.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  CancelHandlerBase.$metadata$ = {
    simpleName: 'CancelHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function toDebugString(_this_) {
    return toString_1(_this_);
  }
  function newCoroutineContext(_this_, context) {
    var combined = _this_._get_coroutineContext__3().plus_17(context);
    return (!(combined === Dispatchers_getInstance()._Default) ? combined.get_42(Key_getInstance()) == null : false) ? combined.plus_17(Dispatchers_getInstance()._Default) : combined;
  }
  function _get_coroutineName_(_this_) {
    return null;
  }
  function createDefaultDispatcher() {
    var tmp;
    if ((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.product == 'ReactNative' : false) {
      tmp = NodeDispatcher_getInstance();
    } else {
      if (isJsdom()) {
        tmp = NodeDispatcher_getInstance();
      } else {
        var tmp_0;
        var tmp_1;
        if (!(typeof window === 'undefined')) {
          var tmp0_asDynamic_0 = window;
          tmp_1 = tmp0_asDynamic_0 != null;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp1_asDynamic_0 = window;
          tmp_0 = !(typeof tmp1_asDynamic_0.addEventListener === 'undefined');
        } else {
          {
            tmp_0 = false;
          }
        }
        if (tmp_0) {
          tmp = asCoroutineDispatcher(window);
        } else {
          if (typeof process === 'undefined') {
            tmp = SetTimeoutDispatcher_getInstance();
          } else {
            {
              tmp = NodeDispatcher_getInstance();
            }
          }
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return ((((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.userAgent != null : false) ? !(typeof navigator.userAgent === 'undefined') : false) ? !(typeof navigator.userAgent.match === 'undefined') : false) ? navigator.userAgent.match('\\bjsdom\\b') : false;
  }
  function handleCoroutineExceptionImpl(context, exception) {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([].slice.call([exception])));
    }.call(this));
  }
  var counter;
  var DEBUG;
  function _get_classSimpleName_(_this_) {
    var tmp0_elvis_lhs = getKClassFromExpression_0(_this_)._get_simpleName__4();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function _get_hexAddress_(_this_) {
    var result = _this_.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      _this_.__debug_counter = result;
    }return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this._Default = createDefaultDispatcher();
    this._Main = new JsMainDispatcher(this._Default, false);
    this._Unconfined = Unconfined_getInstance();
  }
  Dispatchers.$metadata$ = {
    simpleName: 'Dispatchers',
    kind: 'object',
    interfaces: []
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this._delegate_0 = delegate;
    this._invokeImmediately = invokeImmediately;
    this._immediate = this._invokeImmediately ? this : new JsMainDispatcher(this._delegate_0, true);
  }
  JsMainDispatcher.prototype._get_immediate__0 = function () {
    return this._immediate;
  };
  JsMainDispatcher.prototype.isDispatchNeeded_8 = function (context) {
    return !this._invokeImmediately;
  };
  JsMainDispatcher.prototype.dispatch_8 = function (context, block) {
    return this._delegate_0.dispatch_8(context, block);
  };
  JsMainDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? this._delegate_0.toString() : tmp0_elvis_lhs;
  };
  JsMainDispatcher.$metadata$ = {
    simpleName: 'JsMainDispatcher',
    kind: 'class',
    interfaces: []
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  UnconfinedEventLoop.prototype.dispatch_8 = function (context, block) {
    unsupported();
  };
  UnconfinedEventLoop.$metadata$ = {
    simpleName: 'UnconfinedEventLoop',
    kind: 'class',
    interfaces: []
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function JobCancellationException(message, cause, job) {
    CancellationException.call(this, message, cause);
    this._job_0 = job;
    captureStack(this, JobCancellationException);
  }
  JobCancellationException.prototype.toString = function () {
    return '' + CancellationException.prototype.toString.call(this) + '; job=' + this._job_0;
  };
  JobCancellationException.prototype.equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        {
          tmp_2 = false;
        }
      }
      if (tmp_2) {
        tmp_1 = equals_1(other._job_0, this._job_0);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = equals_1(other.cause, this.cause);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  JobCancellationException.prototype.hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this._job_0) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  JobCancellationException.$metadata$ = {
    simpleName: 'JobCancellationException',
    kind: 'class',
    interfaces: []
  };
  function CancellationException(message, cause) {
    IllegalStateException_init_$Init$_0(message, cause, this);
    captureStack(this, CancellationException);
  }
  CancellationException.$metadata$ = {
    simpleName: 'CancellationException',
    kind: 'class',
    interfaces: []
  };
  function CancellationException_init_$Init$(message, $this) {
    CancellationException.call($this, message, null);
    return $this;
  }
  function CancellationException_init_$Create$(message) {
    var tmp = CancellationException_init_$Init$(message, Object.create(CancellationException.prototype));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  NodeDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    process.nextTick(this._get_messageQueue__1()._processQueue);
  };
  NodeDispatcher.$metadata$ = {
    simpleName: 'NodeDispatcher',
    kind: 'object',
    interfaces: []
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  SetTimeoutDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    setTimeout(this._get_messageQueue__1()._processQueue, 0);
    Unit_getInstance();
  };
  SetTimeoutDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutDispatcher',
    kind: 'object',
    interfaces: []
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this._messageQueue = new ScheduledMessageQueue(this);
  }
  SetTimeoutBasedDispatcher.prototype._get_messageQueue__1 = function () {
    return this._messageQueue;
  };
  SetTimeoutBasedDispatcher.prototype.dispatch_8 = function (context, block) {
    this._messageQueue.enqueue_1(block);
  };
  SetTimeoutBasedDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutBasedDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function MessageQueue() {
    ArrayQueue.call(this);
    this._yieldEvery = 16;
    this._scheduled = false;
  }
  MessageQueue.prototype.enqueue_1 = function (element) {
    this.addLast_7(element);
    if (!this._scheduled) {
      this._scheduled = true;
      this.schedule_1();
    }};
  MessageQueue.prototype.process_1 = function () {
    try {
      var tmp0_repeat_0 = this._yieldEvery;
      var inductionVariable = 0;
      var last_2 = tmp0_repeat_0 - 1 | 0;
      if (!(tmp0_repeat_0 === -2147483648) ? inductionVariable <= last_2 : false)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs_5 = this.removeFirstOrNull_4();
          var tmp;
          if (tmp0_elvis_lhs_5 == null) {
            return Unit_getInstance();
          } else {
            tmp = tmp0_elvis_lhs_5;
          }
          var element_4 = tmp;
          element_4.run_3();
        }
         while (inductionVariable <= last_2);
    }finally {
      if (this._get_isEmpty__4()) {
        this._scheduled = false;
      } else {
        this.reschedule_1();
      }
    }
  };
  MessageQueue.$metadata$ = {
    simpleName: 'MessageQueue',
    kind: 'class',
    interfaces: []
  };
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this._window = window_0;
    this._queue_0 = new WindowMessageQueue(this._window);
  }
  WindowDispatcher.prototype.dispatch_8 = function (context, block) {
    return this._queue_0.enqueue_1(block);
  };
  WindowDispatcher.$metadata$ = {
    simpleName: 'WindowDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this._window_0 = window_0;
    this._messageName = 'dispatchCoroutine';
    this._window_0.addEventListener('message', _no_name_provided_$factory_66(this), true);
  }
  WindowMessageQueue.prototype.schedule_1 = function () {
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_67(this));
    Unit_getInstance();
  };
  WindowMessageQueue.prototype.reschedule_1 = function () {
    this._window_0.postMessage(this._messageName, '*', void 1);
  };
  WindowMessageQueue.$metadata$ = {
    simpleName: 'WindowMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_65(this$0) {
    var i = new _no_name_provided__87(this$0);
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_66(this$0) {
    var i = new _no_name_provided__88(this$0);
    return function (p1) {
      i.invoke_129(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_67(this$0) {
    var i = new _no_name_provided__89(this$0);
    return function (p1) {
      i.invoke_131(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__87(this$0) {
    this._this$0_29 = this$0;
  }
  _no_name_provided__87.prototype.invoke_231 = function () {
    this._this$0_29.process_1();
  };
  _no_name_provided__87.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ScheduledMessageQueue($outer) {
    this._$this_9 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp._processQueue = _no_name_provided_$factory_65(this);
  }
  ScheduledMessageQueue.prototype.schedule_1 = function () {
    this._$this_9.scheduleQueueProcessing_1();
  };
  ScheduledMessageQueue.prototype.reschedule_1 = function () {
    setTimeout(this._processQueue, 0);
    Unit_getInstance();
  };
  ScheduledMessageQueue.$metadata$ = {
    simpleName: 'ScheduledMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__88(this$0) {
    this._this$0_30 = this$0;
  }
  _no_name_provided__88.prototype.invoke_129 = function (event) {
    if (event.source == this._this$0_30._window_0 ? event.data == this._this$0_30._messageName : false) {
      event.stopPropagation();
      this._this$0_30.process_1();
    }};
  _no_name_provided__88.prototype.invoke_276 = function (p1) {
    this.invoke_129((p1 == null ? true : p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__89(this$0) {
    this._this$0_31 = this$0;
  }
  _no_name_provided__89.prototype.invoke_131 = function (it) {
    this._this$0_31.process_1();
  };
  _no_name_provided__89.prototype.invoke_276 = function (p1) {
    this.invoke_131(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Runnable() {
  }
  Runnable.$metadata$ = {
    simpleName: 'Runnable',
    kind: 'interface',
    interfaces: []
  };
  function SchedulerTask() {
  }
  SchedulerTask.$metadata$ = {
    simpleName: 'SchedulerTask',
    kind: 'class',
    interfaces: [Runnable]
  };
  function _get_taskContext_(_this_) {
    return Unit_getInstance();
  }
  function asCoroutineDispatcher(_this_) {
    var tmp0_elvis_lhs = _this_.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new WindowDispatcher(_this_);
      _this_.coroutineDispatcher = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function identitySet(expectedSize) {
    return HashSet_init_$Create$_1(expectedSize);
  }
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  LinkedListHead.prototype._get_isEmpty__4 = function () {
    return this._get__next__2() === this;
  };
  LinkedListHead.prototype.remove_31 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  LinkedListHead.$metadata$ = {
    simpleName: 'LinkedListHead',
    kind: 'class',
    interfaces: []
  };
  function LinkedListNode() {
    this.__next = this;
    this.__prev = this;
    this.__removed = false;
  }
  LinkedListNode.prototype._get__next__2 = function () {
    return this.__next;
  };
  LinkedListNode.prototype.addLast_16 = function (node) {
    var prev = this.__prev;
    node.__next = this;
    node.__prev = prev;
    prev.__next = node;
    this.__prev = node;
  };
  LinkedListNode.prototype.remove_31 = function () {
    if (this.__removed)
      return false;
    var prev = this.__prev;
    var next = this.__next;
    prev.__next = next;
    next.__prev = prev;
    this.__removed = true;
    return true;
  };
  LinkedListNode.prototype.addOneIfEmpty_6 = function (node) {
    if (!(this.__next === this))
      return false;
    this.addLast_16(node);
    return true;
  };
  LinkedListNode.prototype.removeFirstOrNull_4 = function () {
    var next = this.__next;
    if (next === this)
      return null;
    var tmp0_check_0 = next.remove_31();
    if (!tmp0_check_0) {
      var message_1 = 'Should remove';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }return next;
  };
  LinkedListNode.$metadata$ = {
    simpleName: 'LinkedListNode',
    kind: 'class',
    interfaces: []
  };
  function unwrap(exception) {
    return exception;
  }
  function CoroutineStackFrame() {
  }
  CoroutineStackFrame.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this._value_12 = null;
  }
  CommonThreadLocal.prototype.get_43 = function () {
    var tmp = this._value_12;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  CommonThreadLocal.prototype.set_3 = function (value) {
    this._value_12 = value;
  };
  CommonThreadLocal.$metadata$ = {
    simpleName: 'CommonThreadLocal',
    kind: 'class',
    interfaces: []
  };
  function GL() {
  }
  GL.prototype.getProgramParameterB_1 = function (shaderProgram, mask) {
    var tmp = this.getProgramParameter_2(shaderProgram, mask);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  GL.prototype.getShaderParameterB_1 = function (shader, mask) {
    var tmp = this.getShaderParameter_2(shader, mask);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  GL.prototype.uniformMatrix4fv_5 = function (uniform, transpose_0, data) {
    return this.uniformMatrix4fv_4(uniform, transpose_0, data.asGLArray());
  };
  GL.$metadata$ = {
    simpleName: 'GL',
    kind: 'interface',
    interfaces: []
  };
  function GameApplicationBuilder(gameConfigurationFactory, gameFactory) {
    this._gameConfigurationFactory = gameConfigurationFactory;
    this._gameFactory = gameFactory;
  }
  GameApplicationBuilder.prototype.start_8 = function () {
    var configuration = this._gameConfigurationFactory();
    var platformContext = new PlatformContextCommon(configuration);
    platformContext.start_9(this._gameFactory);
  };
  GameApplicationBuilder.$metadata$ = {
    simpleName: 'GameApplicationBuilder',
    kind: 'class',
    interfaces: []
  };
  function GameContext(platformContext, gameResolution) {
    this._platformContext = platformContext;
    this._gl = this._platformContext.createGL_0();
    this._logger = this._platformContext.createLogger_0();
    this._fileHandler = this._platformContext.createFileHandler_0(this._logger, this);
    this._input_1 = this._platformContext.createInputHandler_0(this._logger, this);
    this._viewport = this._platformContext.createViewportStrategy_0(this._logger);
    this._assetsManager = new AssetsManager(this);
    this._frameBuffers = emptyMap();
    this._storyboardEvent = null;
    this._gameScreen = new GameScreen(gameResolution._width_3, gameResolution._height_3, gameResolution._ratio_1);
    this._deviceScreen = new DeviceScreen(gameResolution._width_3, gameResolution._height_3);
    this._frameBufferScreen = new DeviceScreen(gameResolution._width_3, gameResolution._height_3);
    this._options_0 = this._platformContext.createOptions_0();
  }
  GameContext.prototype._get_storyboardEvent_ = function () {
    var value = this._storyboardEvent;
    this._storyboardEvent = null;
    return value;
  };
  GameContext.prototype.logPlatform = function () {
    this._logger.info_1('MINIGDX', _no_name_provided_$factory_68());
    this._logger.info_1('MINIGDX', _no_name_provided_$factory_69(this));
    this._logger.info_1('MINIGDX', _no_name_provided_$factory_70(this));
    this._logger.info_1('MINIGDX', _no_name_provided_$factory_71(this));
    this._logger.info_1('MINIGDX', _no_name_provided_$factory_72(this));
    this._logger.info_1('MINIGDX', _no_name_provided_$factory_73(this));
  };
  GameContext.prototype.postRenderLoop_0 = function (block) {
    this._platformContext._set_postRenderLoop__0(block);
  };
  GameContext.$metadata$ = {
    simpleName: 'GameContext',
    kind: 'class',
    interfaces: []
  };
  function Options(debug) {
    this._debug = debug;
  }
  Options.$metadata$ = {
    simpleName: 'Options',
    kind: 'class',
    interfaces: []
  };
  function GameScreen(width, height, ratio) {
    this._width_1 = width;
    this._height_1 = height;
    this._ratio = ratio;
  }
  GameScreen.$metadata$ = {
    simpleName: 'GameScreen',
    kind: 'class',
    interfaces: []
  };
  function DeviceScreen(width, height) {
    this._width_2 = width;
    this._height_2 = height;
  }
  DeviceScreen.$metadata$ = {
    simpleName: 'DeviceScreen',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_68() {
    var i = new _no_name_provided__90();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_69(this$0) {
    var i = new _no_name_provided__91(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_70(this$0) {
    var i = new _no_name_provided__92(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_71(this$0) {
    var i = new _no_name_provided__93(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_72(this$0) {
    var i = new _no_name_provided__94(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_73(this$0) {
    var i = new _no_name_provided__95(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided__90() {
  }
  _no_name_provided__90.prototype.invoke_274 = function () {
    return '--- Platform information ---';
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__91(this$0) {
    this._this$0_32 = this$0;
  }
  _no_name_provided__91.prototype.invoke_274 = function () {
    return 'OpenGL Vendor    : \t' + this._this$0_32._gl.getString_2(7936);
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__92(this$0) {
    this._this$0_33 = this$0;
  }
  _no_name_provided__92.prototype.invoke_274 = function () {
    return 'OpenGL Renderer  : \t' + this._this$0_33._gl.getString_2(7937);
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__93(this$0) {
    this._this$0_34 = this$0;
  }
  _no_name_provided__93.prototype.invoke_274 = function () {
    return 'OpenGL Version   : \t' + this._this$0_34._gl.getString_2(7938);
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__94(this$0) {
    this._this$0_35 = this$0;
  }
  _no_name_provided__94.prototype.invoke_274 = function () {
    return 'OpenGL Shading   : \t' + this._this$0_35._gl.getString_2(35724);
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__95(this$0) {
    this._this$0_36 = this$0;
  }
  _no_name_provided__95.prototype.invoke_274 = function () {
    return 'OpenGL Extensions: \t' + this._this$0_36._gl.getString_2(7939);
  };
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GameScreenConfiguration() {
  }
  GameScreenConfiguration.$metadata$ = {
    simpleName: 'GameScreenConfiguration',
    kind: 'class',
    interfaces: []
  };
  function WithRatio(ratio) {
    GameScreenConfiguration.call(this);
    this._ratio_0 = ratio;
  }
  WithRatio.prototype.screen_1 = function (width, height) {
    return new Resolution_0(numberToInt(height * this._ratio_0), height);
  };
  WithRatio.prototype.toString = function () {
    return '' + 'WithRatio(ratio=' + this._ratio_0 + ')';
  };
  WithRatio.prototype.hashCode = function () {
    return getNumberHashCode(this._ratio_0);
  };
  WithRatio.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WithRatio))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof WithRatio ? other : THROW_CCE();
    if (!equals_1(this._ratio_0, tmp0_other_with_cast._ratio_0))
      return false;
    return true;
  };
  WithRatio.$metadata$ = {
    simpleName: 'WithRatio',
    kind: 'class',
    interfaces: []
  };
  function PlatformContext() {
  }
  PlatformContext.$metadata$ = {
    simpleName: 'PlatformContext',
    kind: 'interface',
    interfaces: []
  };
  function Resolution_0(width, height) {
    this._width_3 = width;
    this._height_3 = height;
    this._ratio_1 = this._width_3 / this._height_3;
  }
  Resolution_0.prototype.toString = function () {
    return '' + 'Resolution(width=' + this._width_3 + ', height=' + this._height_3 + ')';
  };
  Resolution_0.prototype.hashCode = function () {
    var result = this._width_3;
    result = imul(result, 31) + this._height_3 | 0;
    return result;
  };
  Resolution_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Resolution_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Resolution_0 ? other : THROW_CCE();
    if (!(this._width_3 === tmp0_other_with_cast._width_3))
      return false;
    if (!(this._height_3 === tmp0_other_with_cast._height_3))
      return false;
    return true;
  };
  Resolution_0.$metadata$ = {
    simpleName: 'Resolution',
    kind: 'class',
    interfaces: []
  };
  function toPercent(_this_) {
    var v = numberToDouble(_this_);
    var containsArg = v;
    var tmp0_require_0 = 0.0 <= containsArg ? containsArg <= 1.0 : false;
    if (!tmp0_require_0) {
      var message_1_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_1));
    }return v;
  }
  function toMat4(_this_) {
    return _get_t_(_this_).times_0(_get_r_(_this_)).times_0(_get_s_(_this_));
  }
  function _get_t_(_this_) {
    return Companion_getInstance_10().fromColumnMajor(_this_._translation.slice());
  }
  function _get_r_(_this_) {
    return Companion_getInstance_10().fromColumnMajor(_this_._rotation.slice());
  }
  function _get_s_(_this_) {
    return Companion_getInstance_10().fromColumnMajor(_this_._scale_0.slice());
  }
  function Engine(gameContext) {
    this._gameContext = gameContext;
    this._eventQueue = new EventQueue();
    this._systems = listOf_0(this._eventQueue);
    var tmp = this;
    tmp._waitingForUpdate = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._executingForUpdate = ArrayList_init_$Create$();
    var tmp_1 = this;
    var tmp0_let_0 = new EntityFactoryDelegate();
    tmp0_let_0._gameContext_1 = this._gameContext;
    tmp0_let_0._engine_1 = this;
    tmp_1._entityFactory = tmp0_let_0;
  }
  Engine.prototype.onGameStart = function () {
    var tmp0_forEach_0 = this._waitingForUpdate;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2();
    }
    this._waitingForUpdate.clear_15();
    var tmp1_forEach_0 = this._systems;
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_30();
      element_2_0.onGameStarted_25(this);
    }
  };
  Engine.prototype.create_0 = function (configuration) {
    var builder = new InternalEntityBuilder(this);
    configuration(builder);
    var tmp0_also_0 = builder.build_10();
    this.add_53(tmp0_also_0);
    Unit_getInstance();
    return tmp0_also_0;
  };
  Engine.prototype.destroy = function (entity) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_map_0 = this._systems;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
      while (tmp0_iterator_1_2.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2.next_30();
        tmp0_mapTo_0_1.add_19(item_2_3.remove_61(entity));
        Unit_getInstance();
      }
      var tmp1_any_0 = tmp0_mapTo_0_1;
      var tmp;
      if (isInterface(tmp1_any_0, Collection)) {
        tmp = tmp1_any_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp1_any_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (element_2) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  Engine.prototype.destroy_31 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_map_0 = this._systems;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
      while (tmp0_iterator_1_2.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2.next_30();
        tmp0_mapTo_0_1.add_19(item_2_3.destroy_31());
        Unit_getInstance();
      }
      var tmp1_all_0 = tmp0_mapTo_0_1;
      var tmp;
      if (isInterface(tmp1_all_0, Collection)) {
        tmp = tmp1_all_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp1_all_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (!element_2) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  Engine.prototype.addSystem = function (system) {
    var entityQuery = last(this._systems);
    this._systems = plus_0(plus_0(dropLast(this._systems, 1), system), entityQuery);
    system._entityFactory_0 = this._entityFactory;
    this._eventQueue.register_0(system);
  };
  Engine.prototype.add_53 = function (entity) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_map_0 = this._systems;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
      while (tmp0_iterator_1_2.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2.next_30();
        tmp0_mapTo_0_1.add_19(to(item_2_3.add_53(entity), item_2_3.consumeEvents_25()));
        Unit_getInstance();
      }
      var tmp1_onEach_0 = tmp0_mapTo_0_1;
      var tmp0_iterator_3_1 = tmp1_onEach_0.iterator_52();
      while (tmp0_iterator_3_1.hasNext_27()) {
        var element_4_2 = tmp0_iterator_3_1.next_30();
        var events_4 = element_4_2.component2();
        var tmp0_safe_receiver_5 = events_4;
        if (tmp0_safe_receiver_5 == null)
          null;
        else {
          this._eventQueue.emit_16(tmp0_safe_receiver_5);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
      var tmp2_any_0 = tmp1_onEach_0;
      var tmp;
      if (isInterface(tmp2_any_0, Collection)) {
        tmp = tmp2_any_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp2_any_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        var added_4 = element_2.component1();
        if (added_4) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  Engine.prototype.queueEntityUpdate = function (action) {
    this._waitingForUpdate.add_19(action);
    Unit_getInstance();
  };
  Engine.prototype.update_62 = function (delta_0) {
    this._executingForUpdate.addAll_11(this._waitingForUpdate);
    Unit_getInstance();
    this._waitingForUpdate.clear_15();
    var tmp0_forEach_0 = this._executingForUpdate;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2();
    }
    this._executingForUpdate.clear_15();
    var storyboardEvent = null;
    var tmp1_forEach_0 = this._systems;
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_30();
      element_2_0.update_62(delta_0);
      var tmp0_safe_receiver_4 = element_2_0.consumeEvents_25();
      if (tmp0_safe_receiver_4 == null)
        null;
      else {
        this._eventQueue.emit_16(tmp0_safe_receiver_4);
        Unit_getInstance();
      }
      Unit_getInstance();
      var newStoryboardEvent_5 = element_2_0._storyboardEvent_0;
      element_2_0._storyboardEvent_0 = null;
      if (!(newStoryboardEvent_5 == null) ? !(storyboardEvent == null) : false) {
        throw IllegalStateException_init_$Create$('' + "A Storyboard event has already been emitted ('" + getKClassFromExpression_0(ensureNotNull(storyboardEvent))._get_simpleName__4() + "')." + 'Only one event can be emitted at a time. ' + ('' + "This new event ('" + getKClassFromExpression_0(newStoryboardEvent_5)._get_simpleName__4() + "') should not be emitted."));
      } else if (!(newStoryboardEvent_5 == null)) {
        storyboardEvent = newStoryboardEvent_5;
      }}
    this._gameContext._storyboardEvent = storyboardEvent;
  };
  Engine.$metadata$ = {
    simpleName: 'Engine',
    kind: 'class',
    interfaces: []
  };
  function EntityBuilder() {
  }
  EntityBuilder.$metadata$ = {
    simpleName: 'EntityBuilder',
    kind: 'interface',
    interfaces: []
  };
  function InternalEntityBuilder(engine) {
    this._engine = engine;
    this._components = emptyList();
    this._name_11 = '_';
  }
  InternalEntityBuilder.prototype.build_10 = function () {
    return new Entity(this._engine, this._components, this._name_11);
  };
  InternalEntityBuilder.prototype.named_0 = function (name) {
    this._name_11 = name;
  };
  InternalEntityBuilder.prototype.add_22 = function (component) {
    this._components = plus_0(this._components, component);
  };
  InternalEntityBuilder.$metadata$ = {
    simpleName: 'InternalEntityBuilder',
    kind: 'class',
    interfaces: [EntityBuilder]
  };
  function AnimatedComponent(animatedModel, currentAnimation, currentPose, time, duration, loop, pause, hidden) {
    this._animatedModel = animatedModel;
    this._currentAnimation = currentAnimation;
    this._currentPose = currentPose;
    this._time_0 = time;
    this._duration_2 = duration;
    this._loop = loop;
    this._pause = pause;
    this._hidden = hidden;
  }
  AnimatedComponent.$metadata$ = {
    simpleName: 'AnimatedComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function AnimatedComponent_init_$Init$(animatedModel, currentAnimation, currentPose, time, duration, loop, pause, hidden, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      var tmp0_safe_receiver = firstOrNull_0(animatedModel._animations_1._get_values__6());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._frames;
      currentAnimation = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    }if (!(($mask0 & 4) === 0)) {
      var tmp = 0;
      var tmp_0 = 100;
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = Companion_getInstance_10().identity_0();
        tmp = tmp + 1 | 0;
      }
      currentPose = tmp_1;
    }if (!(($mask0 & 8) === 0))
      time = 0.0;
    if (!(($mask0 & 16) === 0)) {
      var tmp2_safe_receiver = lastOrNull(currentAnimation);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._time;
      duration = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
    }if (!(($mask0 & 32) === 0))
      loop = new Long(0, 0);
    if (!(($mask0 & 64) === 0))
      pause = false;
    if (!(($mask0 & 128) === 0))
      hidden = false;
    AnimatedComponent.call($this, animatedModel, currentAnimation, currentPose, time, duration, loop, pause, hidden);
    return $this;
  }
  function AnimatedComponent_init_$Create$(animatedModel, currentAnimation, currentPose, time, duration, loop, pause, hidden, $mask0, $marker) {
    return AnimatedComponent_init_$Init$(animatedModel, currentAnimation, currentPose, time, duration, loop, pause, hidden, $mask0, $marker, Object.create(AnimatedComponent.prototype));
  }
  function BoundingBoxComponent(touch, owner) {
    this._touch = touch;
    this._owner_1 = owner;
    var tmp = this;
    tmp.__rawMin = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_0 = this;
    tmp_0.__rawMax = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_1 = this;
    tmp_1.__min = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_2 = this;
    tmp_2.__max = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_3 = this;
    tmp_3.__center = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_4 = this;
    tmp_4.__size = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    this._localMin = new ImmutableVector3(this.__rawMin);
    this._localMax = new ImmutableVector3(this.__rawMax);
    this._fromDefaultTransformation = Companion_getInstance_10().identity_0();
    this._min = new ImmutableVector3(this.__min);
    this._max = new ImmutableVector3(this.__max);
    this._center_0 = new ImmutableVector3(this.__center);
    this._size_3 = new ImmutableVector3(this.__size);
    this._edges = emptyList();
    this._needsToBeUpdated = true;
  }
  BoundingBoxComponent.prototype._get_min_ = function () {
    updateIfNeeded(this);
    return this._min;
  };
  BoundingBoxComponent.prototype._get_max_ = function () {
    updateIfNeeded(this);
    return this._max;
  };
  BoundingBoxComponent.prototype._get_combinedTransformation_ = function () {
    var tmp0_safe_receiver = this._owner_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : _get_position_(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_transformation__0();
    return tmp2_elvis_lhs == null ? Companion_getInstance_10().identity_0() : tmp2_elvis_lhs;
  };
  BoundingBoxComponent.prototype.onAdded_18 = function (entity) {
    this._owner_1 = entity;
  };
  BoundingBoxComponent.prototype.onRemoved_18 = function (entity) {
    this._owner_1 = null;
  };
  BoundingBoxComponent.prototype.onComponentUpdated_18 = function (componentType) {
    if (componentType.equals(getKClass_0(Position_0))) {
      this._needsToBeUpdated = true;
    }};
  BoundingBoxComponent.prototype.onDetach_18 = function (parent) {
    this._needsToBeUpdated = true;
  };
  BoundingBoxComponent.prototype.onAttach_18 = function (parent) {
    this._needsToBeUpdated = true;
  };
  BoundingBoxComponent.$metadata$ = {
    simpleName: 'BoundingBoxComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function BoxBuilder_init_$Init$(minX, maxX, minY, maxY, minZ, maxZ, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      minX = null;
    if (!(($mask0 & 2) === 0))
      maxX = null;
    if (!(($mask0 & 4) === 0))
      minY = null;
    if (!(($mask0 & 8) === 0))
      maxY = null;
    if (!(($mask0 & 16) === 0))
      minZ = null;
    if (!(($mask0 & 32) === 0))
      maxZ = null;
    BoxBuilder.call($this, minX, maxX, minY, maxY, minZ, maxZ);
    return $this;
  }
  function BoxBuilder_init_$Create$(minX, maxX, minY, maxY, minZ, maxZ, $mask0, $marker) {
    return BoxBuilder_init_$Init$(minX, maxX, minY, maxY, minZ, maxZ, $mask0, $marker, Object.create(BoxBuilder.prototype));
  }
  function minNull($this, a, b) {
    var tmp0_elvis_lhs = a;
    var tmp0_min_0 = tmp0_elvis_lhs == null ? b : tmp0_elvis_lhs;
    return function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float32Array([tmp0_min_0, b]))));
    }.call(this);
  }
  function maxNull($this, a, b) {
    var tmp0_elvis_lhs = a;
    var tmp0_max_0 = tmp0_elvis_lhs == null ? b : tmp0_elvis_lhs;
    return function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float32Array([tmp0_max_0, b]))));
    }.call(this);
  }
  function computeMinMax($this, points) {
    var tmp0_fold_0 = BoxBuilder_init_$Create$(null, null, null, null, null, null, 63, null);
    var accumulator_1 = tmp0_fold_0;
    var tmp0_iterator_2 = points.iterator_52();
    while (tmp0_iterator_2.hasNext_27()) {
      var element_3 = tmp0_iterator_2.next_30();
      var tmp1__anonymous__4 = accumulator_1;
      tmp1__anonymous__4._minX = minNull(Companion_getInstance_16(), tmp1__anonymous__4._minX, element_3._x_11);
      tmp1__anonymous__4._minY = minNull(Companion_getInstance_16(), tmp1__anonymous__4._minY, element_3._y_11);
      tmp1__anonymous__4._minZ = minNull(Companion_getInstance_16(), tmp1__anonymous__4._minZ, element_3._z_7);
      tmp1__anonymous__4._maxX = maxNull(Companion_getInstance_16(), tmp1__anonymous__4._maxX, element_3._x_11);
      tmp1__anonymous__4._maxY = maxNull(Companion_getInstance_16(), tmp1__anonymous__4._maxY, element_3._y_11);
      tmp1__anonymous__4._maxZ = maxNull(Companion_getInstance_16(), tmp1__anonymous__4._maxZ, element_3._z_7);
      accumulator_1 = tmp1__anonymous__4;
    }
    var builder = accumulator_1;
    return to(new Vector3(ensureNotNull(builder._minX), ensureNotNull(builder._minY), ensureNotNull(builder._minZ)), new Vector3(ensureNotNull(builder._maxX), ensureNotNull(builder._maxY), ensureNotNull(builder._maxZ)));
  }
  function BoundingBoxComponent_init_$Init$(touch, owner, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      touch = false;
    if (!(($mask0 & 2) === 0))
      owner = null;
    BoundingBoxComponent.call($this, touch, owner);
    return $this;
  }
  function BoundingBoxComponent_init_$Create$(touch, owner, $mask0, $marker) {
    return BoundingBoxComponent_init_$Init$(touch, owner, $mask0, $marker, Object.create(BoundingBoxComponent.prototype));
  }
  function updateIfNeeded($this) {
    if (!$this._needsToBeUpdated)
      return Unit_getInstance();
    var transformation = $this._get_combinedTransformation_();
    var tmp0__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMin._x_11, $this.__rawMin._y_11, $this.__rawMin._z_7)));
    var tmp0__get_xyz__0_1 = tmp0__get_translation__0._w_0;
    var tmp = toVector3(new Float3(tmp0__get_xyz__0_1._x_3, tmp0__get_xyz__0_1._y_3, tmp0__get_xyz__0_1._z_3));
    var tmp1__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMin._x_11, $this.__rawMin._y_11, $this.__rawMax._z_7)));
    var tmp0__get_xyz__0_1_0 = tmp1__get_translation__0._w_0;
    var tmp_0 = toVector3(new Float3(tmp0__get_xyz__0_1_0._x_3, tmp0__get_xyz__0_1_0._y_3, tmp0__get_xyz__0_1_0._z_3));
    var tmp2__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMin._x_11, $this.__rawMax._y_11, $this.__rawMin._z_7)));
    var tmp0__get_xyz__0_1_1 = tmp2__get_translation__0._w_0;
    var tmp_1 = toVector3(new Float3(tmp0__get_xyz__0_1_1._x_3, tmp0__get_xyz__0_1_1._y_3, tmp0__get_xyz__0_1_1._z_3));
    var tmp3__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMin._x_11, $this.__rawMax._y_11, $this.__rawMax._z_7)));
    var tmp0__get_xyz__0_1_2 = tmp3__get_translation__0._w_0;
    var tmp_2 = toVector3(new Float3(tmp0__get_xyz__0_1_2._x_3, tmp0__get_xyz__0_1_2._y_3, tmp0__get_xyz__0_1_2._z_3));
    var tmp4__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMax._x_11, $this.__rawMin._y_11, $this.__rawMin._z_7)));
    var tmp0__get_xyz__0_1_3 = tmp4__get_translation__0._w_0;
    var tmp_3 = toVector3(new Float3(tmp0__get_xyz__0_1_3._x_3, tmp0__get_xyz__0_1_3._y_3, tmp0__get_xyz__0_1_3._z_3));
    var tmp5__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMax._x_11, $this.__rawMin._y_11, $this.__rawMax._z_7)));
    var tmp0__get_xyz__0_1_4 = tmp5__get_translation__0._w_0;
    var tmp_4 = toVector3(new Float3(tmp0__get_xyz__0_1_4._x_3, tmp0__get_xyz__0_1_4._y_3, tmp0__get_xyz__0_1_4._z_3));
    var tmp6__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMax._x_11, $this.__rawMax._y_11, $this.__rawMin._z_7)));
    var tmp0__get_xyz__0_1_5 = tmp6__get_translation__0._w_0;
    var tmp_5 = toVector3(new Float3(tmp0__get_xyz__0_1_5._x_3, tmp0__get_xyz__0_1_5._y_3, tmp0__get_xyz__0_1_5._z_3));
    var tmp7__get_translation__0 = transformation.times_0(translation(new Float3($this.__rawMax._x_11, $this.__rawMax._y_11, $this.__rawMax._z_7)));
    var tmp0__get_xyz__0_1_6 = tmp7__get_translation__0._w_0;
    var edges = listOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, toVector3(new Float3(tmp0__get_xyz__0_1_6._x_3, tmp0__get_xyz__0_1_6._y_3, tmp0__get_xyz__0_1_6._z_3))]);
    var tmp0_container = computeMinMax(Companion_getInstance_16(), edges);
    var min = tmp0_container.component1();
    var max = tmp0_container.component2();
    $this.__min.set_5(min);
    Unit_getInstance();
    $this.__max.set_5(max);
    Unit_getInstance();
    $this.__size.set_4($this.__max._x_11 - $this.__min._x_11, $this.__max._y_11 - $this.__min._y_11, $this.__max._z_7 - $this.__min._z_7);
    Unit_getInstance();
    $this.__center.set_4($this.__size._x_11 * 0.5 + $this.__min._x_11, $this.__size._y_11 * 0.5 + $this.__min._y_11, $this.__size._z_7 * 0.5 + $this.__min._z_7);
    Unit_getInstance();
    $this._edges = edges;
    $this._needsToBeUpdated = false;
  }
  function BoxBuilder(minX, maxX, minY, maxY, minZ, maxZ) {
    this._minX = minX;
    this._maxX = maxX;
    this._minY = minY;
    this._maxY = maxY;
    this._minZ = minZ;
    this._maxZ = maxZ;
  }
  BoxBuilder.$metadata$ = {
    simpleName: 'BoxBuilder',
    kind: 'class',
    interfaces: []
  };
  function Companion_17() {
    Companion_instance_16 = this;
  }
  Companion_17.prototype.default = function () {
    var boundingBoxComponent = BoundingBoxComponent_init_$Create$(false, null, 3, null);
    boundingBoxComponent.__rawMax.set_4(1, 1, 1);
    Unit_getInstance();
    boundingBoxComponent.__rawMin.set_4(-1, -1, -1);
    Unit_getInstance();
    return boundingBoxComponent;
  };
  Companion_17.prototype.from_1 = function (model) {
    var tmp0_flatMap_0 = model._primitives_0;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_flatMap_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var tmp0_map_0_6 = chunked(toList_0(element_2_3._vertices_3), 3);
      var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6, 10));
      var tmp0_iterator_1_2_8 = tmp0_map_0_6.iterator_52();
      while (tmp0_iterator_1_2_8.hasNext_27()) {
        var item_2_3_9 = tmp0_iterator_1_2_8.next_30();
        var x_5_10 = item_2_3_9.get_57(0);
        var y_6_11 = item_2_3_9.get_57(1);
        var z_7_12 = item_2_3_9.get_57(2);
        tmp0_mapTo_0_1_7.add_19(new Vector3(x_5_10, y_6_11, z_7_12));
        Unit_getInstance();
      }
      var list_3_4 = tmp0_mapTo_0_1_7;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    var vectors = tmp0_flatMapTo_0_1;
    var tmp0_container = computeMinMax(this, vectors);
    var min = tmp0_container.component1();
    var max = tmp0_container.component2();
    var component = BoundingBoxComponent_init_$Create$(false, null, 3, null);
    component.__rawMin.set_5(min);
    Unit_getInstance();
    component.__rawMax.set_5(max);
    Unit_getInstance();
    var scale_1 = scale(new Float3(max._x_11 - min._x_11, max._y_11 - min._y_11, max._z_7 - min._z_7));
    var translation_1 = translation(new Float3((max._x_11 - min._x_11) * 0.5 + min._x_11, (max._y_11 - min._y_11) * 0.5 + min._y_11, (max._z_7 - min._z_7) * 0.5 + min._z_7));
    component._fromDefaultTransformation = translation_1.times_0(scale_1);
    return component;
  };
  Companion_17.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_17();
    return Companion_instance_16;
  }
  function CameraComponent(gameScreen, type, far, near, fov, scale_1, lookAt_0) {
    this._gameScreen_0 = gameScreen;
    this._lookAt = lookAt_0;
    this._needsToBeUpdated_0 = true;
    this.__projection = Companion_getInstance_10().identity_0();
    this._type_2 = type;
    this._far_1 = far;
    this._near_1 = near;
    this._fov_0 = fov;
    this._scale_1 = scale_1;
  }
  CameraComponent.prototype._get_projection_ = function () {
    if (this._needsToBeUpdated_0) {
      this._needsToBeUpdated_0 = false;
      var tmp = this;
      var tmp0_subject = this._type_2;
      var tmp_0;
      if (tmp0_subject.equals(Type_PERSPECTIVE_getInstance())) {
        tmp_0 = perspective(this._fov_0, this._gameScreen_0._ratio, this._near_1, this._far_1);
      } else if (tmp0_subject.equals(Type_ORTHOGRAPHIC_getInstance())) {
        var tmp_1;
        if (this._gameScreen_0._width_1 >= this._gameScreen_0._height_1) {
          tmp_1 = to(1.0, this._gameScreen_0._height_1 / this._gameScreen_0._width_1);
        } else {
          tmp_1 = to(this._gameScreen_0._width_1 / this._gameScreen_0._height_1, 1.0);
        }
        var tmp1_container = tmp_1;
        var w = tmp1_container.component1();
        var h = tmp1_container.component2();
        tmp_0 = ortho(-this._scale_1 * 0.5 * w, this._scale_1 * 0.5 * w, -this._scale_1 * 0.5 * h, this._scale_1 * 0.5 * h, this._near_1, this._far_1);
      } else {
        noWhenBranchMatchedException();
      }
      tmp.__projection = tmp_0;
    }return this.__projection;
  };
  CameraComponent.$metadata$ = {
    simpleName: 'CameraComponent',
    kind: 'class',
    interfaces: [Component]
  };
  var Type_PERSPECTIVE_instance;
  var Type_ORTHOGRAPHIC_instance;
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_getInstance();
    Type_entriesInitialized = true;
    Type_PERSPECTIVE_instance = new Type('PERSPECTIVE', 0);
    Type_ORTHOGRAPHIC_instance = new Type('ORTHOGRAPHIC', 1);
  }
  function CameraComponent_init_$Init$(gameScreen, type, far, near, fov, scale_1, lookAt_0, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      near = 0.0;
    if (!(($mask0 & 16) === 0))
      fov = 0.0;
    if (!(($mask0 & 32) === 0))
      scale_1 = 0.0;
    if (!(($mask0 & 64) === 0))
      lookAt_0 = null;
    CameraComponent.call($this, gameScreen, type, far, near, fov, scale_1, lookAt_0);
    return $this;
  }
  function CameraComponent_init_$Create$(gameScreen, type, far, near, fov, scale_1, lookAt_0, $mask0, $marker) {
    return CameraComponent_init_$Init$(gameScreen, type, far, near, fov, scale_1, lookAt_0, $mask0, $marker, Object.create(CameraComponent.prototype));
  }
  function Type(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_PERSPECTIVE_getInstance() {
    Type_initEntries();
    return Type_PERSPECTIVE_instance;
  }
  function Type_ORTHOGRAPHIC_getInstance() {
    Type_initEntries();
    return Type_ORTHOGRAPHIC_instance;
  }
  function Component() {
  }
  Component.prototype.onAdded_18 = function (entity) {
    return Unit_getInstance();
  };
  Component.prototype.onRemoved_18 = function (entity) {
    return Unit_getInstance();
  };
  Component.prototype.onComponentUpdated_18 = function (componentType) {
    return Unit_getInstance();
  };
  Component.prototype.onDetach_18 = function (parent) {
    return Unit_getInstance();
  };
  Component.prototype.onAttach_18 = function (parent) {
    return Unit_getInstance();
  };
  Component.$metadata$ = {
    simpleName: 'Component',
    kind: 'interface',
    interfaces: []
  };
  function Color_0(red, green, blue, alpha) {
    this._red = red;
    this._green = green;
    this._blue = blue;
    this._alpha_0 = alpha;
  }
  Color_0.prototype.copy_0 = function (red, green, blue, alpha) {
    return new Color_0(red, green, blue, alpha);
  };
  Color_0.prototype.copy$default_0 = function (red, green, blue, alpha, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      red = this._red;
    if (!(($mask0 & 2) === 0))
      green = this._green;
    if (!(($mask0 & 4) === 0))
      blue = this._blue;
    if (!(($mask0 & 8) === 0))
      alpha = this._alpha_0;
    return this.copy_0(red, green, blue, alpha);
  };
  Color_0.prototype.toString = function () {
    return '' + 'Color(red=' + this._red + ', green=' + this._green + ', blue=' + this._blue + ', alpha=' + this._alpha_0 + ')';
  };
  Color_0.prototype.hashCode = function () {
    var result = getNumberHashCode(this._red);
    result = imul(result, 31) + getNumberHashCode(this._green) | 0;
    result = imul(result, 31) + getNumberHashCode(this._blue) | 0;
    result = imul(result, 31) + getNumberHashCode(this._alpha_0) | 0;
    return result;
  };
  Color_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Color_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Color_0 ? other : THROW_CCE();
    if (!equals_1(this._red, tmp0_other_with_cast._red))
      return false;
    if (!equals_1(this._green, tmp0_other_with_cast._green))
      return false;
    if (!equals_1(this._blue, tmp0_other_with_cast._blue))
      return false;
    if (!equals_1(this._alpha_0, tmp0_other_with_cast._alpha_0))
      return false;
    return true;
  };
  Color_0.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: []
  };
  function LightComponent(color, intensity) {
    this._color_1 = color;
    this._intensity_0 = intensity;
  }
  LightComponent.$metadata$ = {
    simpleName: 'LightComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function Color_init_$Init$_1(red, green, blue, alpha, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      red = 0.0;
    if (!(($mask0 & 2) === 0))
      green = 0.0;
    if (!(($mask0 & 4) === 0))
      blue = 0.0;
    if (!(($mask0 & 8) === 0))
      alpha = 1.0;
    Color_0.call($this, red, green, blue, alpha);
    return $this;
  }
  function Color_init_$Create$_1(red, green, blue, alpha, $mask0, $marker) {
    return Color_init_$Init$_1(red, green, blue, alpha, $mask0, $marker, Object.create(Color_0.prototype));
  }
  function Companion_18() {
    Companion_instance_17 = this;
    var tmp = this;
    tmp._ORIGIN = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_0 = this;
    tmp_0._TRANSPARENT_COLOR = Color_init_$Create$_1(0.0, 0.0, 0.0, 0.0, 7, null);
  }
  Companion_18.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_18();
    return Companion_instance_17;
  }
  function ModelComponent(model, hidden) {
    this._model = model;
    this._hidden_0 = hidden;
  }
  ModelComponent.prototype._get_displayable_ = function () {
    return this._model._displayble;
  };
  ModelComponent.$metadata$ = {
    simpleName: 'ModelComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function ModelComponent_init_$Init$(model, hidden, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      hidden = false;
    ModelComponent.call($this, model, hidden);
    return $this;
  }
  function ModelComponent_init_$Create$(model, hidden, $mask0, $marker) {
    return ModelComponent_init_$Init$(model, hidden, $mask0, $marker, Object.create(ModelComponent.prototype));
  }
  function Position_0(translation_1, rotation_0, scale_1) {
    this._owner_2 = null;
    this._needsToBeUpdated_1 = true;
    this._localTransformationHolder = new TransformationHolder(translation_1, rotation_0, scale_1);
    this.__transformation = Companion_getInstance_10().identity_0();
    this.__quaternion = Companion_getInstance_11().identity_0();
    var tmp = this;
    tmp.__translation = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_0 = this;
    tmp_0.__rotation = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    this.__scale = new Vector3(1.0, 1.0, 1.0);
    var tmp_1 = this;
    tmp_1.__localTranslation = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_2 = this;
    tmp_2.__localRotation = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    var tmp_3 = this;
    tmp_3.__localScale = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    this._immutableLocalTranslation = new ImmutableVector3(this.__localTranslation);
    this._immutableLocalRotation = new ImmutableVector3(this.__localRotation);
    this._immutableLocalScale = new ImmutableVector3(this.__localScale);
    this._immutableTranslation = new ImmutableVector3(this.__translation);
    this._immutableRotation = new ImmutableVector3(this.__rotation);
    this._immutableScale = new ImmutableVector3(this.__scale);
    var tmp_4 = this;
    var tmp0_updateOnRead_0 = immutableLocalRotation$factory(this);
    tmp_4._localRotation$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0);
    var tmp_5 = this;
    var tmp0_updateOnRead_0_0 = immutableLocalTranslation$factory(this);
    tmp_5._localTranslation$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_0);
    var tmp_6 = this;
    var tmp0_updateOnRead_0_1 = immutableLocalScale$factory(this);
    tmp_6._localScale$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_1);
    var tmp_7 = this;
    var tmp0_updateOnRead_0_2 = _transformation$factory(this);
    tmp_7._transformation$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_2);
    var tmp_8 = this;
    var tmp0_updateOnRead_0_3 = _quaternion$factory(this);
    tmp_8._quaternion$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_3);
    var tmp_9 = this;
    var tmp0_updateOnRead_0_4 = immutableTranslation$factory(this);
    tmp_9._translation$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_4);
    var tmp_10 = this;
    var tmp0_updateOnRead_0_5 = immutableRotation$factory(this);
    tmp_10._rotation$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_5);
    var tmp_11 = this;
    var tmp0_updateOnRead_0_6 = immutableScale$factory(this);
    tmp_11._scale$delegate = new UpdateOnRead(this, tmp0_updateOnRead_0_6);
    requireUpdate(this);
    Unit_getInstance();
  }
  Position_0.prototype._get_localTranslation_ = function () {
    return this._localTranslation$delegate.getValue_5(this, localTranslation$factory());
  };
  Position_0.prototype._get_localScale_ = function () {
    return this._localScale$delegate.getValue_5(this, localScale$factory());
  };
  Position_0.prototype._get_transformation__0 = function () {
    return this._transformation$delegate.getValue_5(this, transformation$factory());
  };
  Position_0.prototype._get_translation_ = function () {
    return this._translation$delegate.getValue_5(this, translation$factory());
  };
  Position_0.prototype._get_scale_ = function () {
    return this._scale$delegate.getValue_5(this, scale$factory());
  };
  Position_0.prototype.onAdded_18 = function (entity) {
    this._owner_2 = entity;
  };
  Position_0.prototype.onRemoved_18 = function (entity) {
    this._owner_2 = null;
  };
  Position_0.prototype.onComponentUpdated_18 = function (componentType) {
    if (componentType.equals(getKClass_0(Position_0))) {
      this._needsToBeUpdated_1 = true;
    }};
  Position_0.prototype.onDetach_18 = function (parent) {
    this._needsToBeUpdated_1 = true;
  };
  Position_0.prototype.onAttach_18 = function (parent) {
    this._needsToBeUpdated_1 = true;
  };
  Position_0.prototype.setGlobalTranslation = function (x, y, z) {
    var translationInLocalSpace = inverse(_get_parentPosition_(this)._get_transformation__0()).times_0(translation(new Float3(numberToDouble(x), numberToDouble(y), numberToDouble(z))));
    this._localTransformationHolder._set_translation_(translationInLocalSpace);
    return requireUpdate(this);
  };
  Position_0.prototype.setGlobalTranslation_0 = function (translation_1) {
    return this.setGlobalTranslation(translation_1._get_x_(), translation_1._get_y_(), translation_1._get_z_());
  };
  Position_0.prototype.setLocalTranslation = function (translation_1, using) {
    return this.setLocalTranslation_0(translation_1._get_x_(), translation_1._get_y_(), translation_1._get_z_(), using);
  };
  Position_0.prototype.setLocalTranslation$default = function (translation_1, using, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      using = Local_getInstance();
    return this.setLocalTranslation(translation_1, using);
  };
  Position_0.prototype.setLocalTranslation_0 = function (x, y, z, using) {
    var scale_1 = _get_parentPosition_(this)._get_scale_();
    var tmp0_safe_receiver = x;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = using.convert_0(x, scale_1._get_x_());
    }
    var tmp1_elvis_lhs = tmp;
    var xScaled = tmp1_elvis_lhs == null ? this._get_localTranslation_()._get_x_() : tmp1_elvis_lhs;
    var tmp2_safe_receiver = y;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = using.convert_0(y, scale_1._get_y_());
    }
    var tmp3_elvis_lhs = tmp_0;
    var yScaled = tmp3_elvis_lhs == null ? this._get_localTranslation_()._get_y_() : tmp3_elvis_lhs;
    var tmp4_safe_receiver = z;
    var tmp_1;
    if (tmp4_safe_receiver == null) {
      tmp_1 = null;
    } else {
      tmp_1 = using.convert_0(z, scale_1._get_z_());
    }
    var tmp5_elvis_lhs = tmp_1;
    var zScaled = tmp5_elvis_lhs == null ? this._get_localTranslation_()._get_z_() : tmp5_elvis_lhs;
    var translation_1 = new Float3(xScaled, yScaled, zScaled);
    this._localTransformationHolder._set_translation_(translation(translation_1));
    return requireUpdate(this);
  };
  Position_0.prototype.setLocalTranslation$default_0 = function (x, y, z, using, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      x = null;
    if (!(($mask0 & 2) === 0))
      y = null;
    if (!(($mask0 & 4) === 0))
      z = null;
    if (!(($mask0 & 8) === 0))
      using = Local_getInstance();
    return this.setLocalTranslation_0(x, y, z, using);
  };
  Position_0.prototype.setLocalRotation = function (quaternion) {
    this._localTransformationHolder._set_rotation_(quaternion);
    return requireUpdate(this);
  };
  Position_0.prototype.setLocalScale = function (x, y, z) {
    this._localTransformationHolder._set_scale_(scale(new Float3(x, y, z)));
    return requireUpdate(this);
  };
  Position_0.prototype.setLocalScale$default = function (x, y, z, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      x = this._get_localScale_()._get_x_();
    if (!(($mask0 & 2) === 0))
      y = this._get_localScale_()._get_y_();
    if (!(($mask0 & 4) === 0))
      z = this._get_localScale_()._get_z_();
    return this.setLocalScale(x, y, z);
  };
  Position_0.$metadata$ = {
    simpleName: 'Position',
    kind: 'class',
    interfaces: [Component]
  };
  function CoordinateConverter() {
  }
  CoordinateConverter.$metadata$ = {
    simpleName: 'CoordinateConverter',
    kind: 'class',
    interfaces: []
  };
  function immutableLocalRotation$factory($b0) {
    return getPropertyCallableRef('immutableLocalRotation', 0, KProperty0, function () {
      return $b0._immutableLocalRotation;
    }, null);
  }
  function immutableLocalTranslation$factory($b0) {
    return getPropertyCallableRef('immutableLocalTranslation', 0, KProperty0, function () {
      return $b0._immutableLocalTranslation;
    }, null);
  }
  function immutableLocalScale$factory($b0) {
    return getPropertyCallableRef('immutableLocalScale', 0, KProperty0, function () {
      return $b0._immutableLocalScale;
    }, null);
  }
  function _transformation$factory($b0) {
    return getPropertyCallableRef('_transformation', 0, KMutableProperty0, function () {
      return $b0.__transformation;
    }, function (value) {
      $b0.__transformation = value;
      return Unit_getInstance();
    });
  }
  function _quaternion$factory($b0) {
    return getPropertyCallableRef('_quaternion', 0, KMutableProperty0, function () {
      return $b0.__quaternion;
    }, function (value) {
      $b0.__quaternion = value;
      return Unit_getInstance();
    });
  }
  function immutableTranslation$factory($b0) {
    return getPropertyCallableRef('immutableTranslation', 0, KProperty0, function () {
      return $b0._immutableTranslation;
    }, null);
  }
  function immutableRotation$factory($b0) {
    return getPropertyCallableRef('immutableRotation', 0, KProperty0, function () {
      return $b0._immutableRotation;
    }, null);
  }
  function immutableScale$factory($b0) {
    return getPropertyCallableRef('immutableScale', 0, KProperty0, function () {
      return $b0._immutableScale;
    }, null);
  }
  function localTranslation$factory() {
    return getPropertyCallableRef('localTranslation', 1, KProperty1, function (receiver) {
      return receiver._get_localTranslation_();
    }, null);
  }
  function localScale$factory() {
    return getPropertyCallableRef('localScale', 1, KProperty1, function (receiver) {
      return receiver._get_localScale_();
    }, null);
  }
  function transformation$factory() {
    return getPropertyCallableRef('transformation', 1, KProperty1, function (receiver) {
      return receiver._get_transformation__0();
    }, null);
  }
  function translation$factory() {
    return getPropertyCallableRef('translation', 1, KProperty1, function (receiver) {
      return receiver._get_translation_();
    }, null);
  }
  function scale$factory() {
    return getPropertyCallableRef('scale', 1, KProperty1, function (receiver) {
      return receiver._get_scale_();
    }, null);
  }
  function Position_init_$Init$_0(translation_1, rotation_0, scale_1, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      translation_1 = Companion_getInstance_10().identity_0();
    if (!(($mask0 & 2) === 0))
      rotation_0 = Companion_getInstance_10().identity_0();
    if (!(($mask0 & 4) === 0))
      scale_1 = Companion_getInstance_10().identity_0();
    Position_0.call($this, translation_1, rotation_0, scale_1);
    return $this;
  }
  function Position_init_$Create$_0(translation_1, rotation_0, scale_1, $mask0, $marker) {
    return Position_init_$Init$_0(translation_1, rotation_0, scale_1, $mask0, $marker, Object.create(Position_0.prototype));
  }
  function UpdateOnRead($outer, field) {
    this._$this_10 = $outer;
    this._field = field;
  }
  UpdateOnRead.prototype.getValue_5 = function (thisRef, property) {
    if (this._$this_10._needsToBeUpdated_1)
      update(this._$this_10);
    return this._field.get();
  };
  UpdateOnRead.$metadata$ = {
    simpleName: 'UpdateOnRead',
    kind: 'class',
    interfaces: []
  };
  function _get_parentPosition_($this) {
    var tmp0_safe_receiver = $this._owner_2;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._parent_0;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : _get_position_(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? Companion_getInstance_18()._identity : tmp2_elvis_lhs;
  }
  function update($this) {
    var globalTransformation = _get_parentPosition_($this)._get_transformation__0().times_0($this._localTransformationHolder._get_transformation__0());
    var tmp0__get_translation__0 = $this._localTransformationHolder._translation_0;
    var tmp0__get_xyz__0_1 = tmp0__get_translation__0._w_0;
    var localTranslation = new Float3(tmp0__get_xyz__0_1._x_3, tmp0__get_xyz__0_1._y_3, tmp0__get_xyz__0_1._z_3);
    $this.__localTranslation.set_4(localTranslation._x_2, localTranslation._y_2, localTranslation._z_2);
    Unit_getInstance();
    var tmp0__get_xyz__0_1_0 = globalTransformation._w_0;
    var tmp = (new Float3(tmp0__get_xyz__0_1_0._x_3, tmp0__get_xyz__0_1_0._y_3, tmp0__get_xyz__0_1_0._z_3))._x_2;
    var tmp0__get_xyz__0_1_1 = globalTransformation._w_0;
    var tmp_0 = (new Float3(tmp0__get_xyz__0_1_1._x_3, tmp0__get_xyz__0_1_1._y_3, tmp0__get_xyz__0_1_1._z_3))._y_2;
    var tmp0__get_xyz__0_1_2 = globalTransformation._w_0;
    $this.__translation.set_4(tmp, tmp_0, (new Float3(tmp0__get_xyz__0_1_2._x_3, tmp0__get_xyz__0_1_2._y_3, tmp0__get_xyz__0_1_2._z_3))._z_2);
    Unit_getInstance();
    var localRotation = Companion_getInstance_10().from($this._localTransformationHolder._rotation_1);
    $this.__localRotation.set_4(localRotation._get_rotation_()._x_2, localRotation._get_rotation_()._y_2, localRotation._get_rotation_()._z_2);
    Unit_getInstance();
    $this.__rotation.set_4(globalTransformation._get_rotation_()._x_2, globalTransformation._get_rotation_()._y_2, globalTransformation._get_rotation_()._z_2);
    Unit_getInstance();
    var tmp1__get_scale__0 = $this._localTransformationHolder._scale_3;
    var tmp0__get_xyz__0_2 = tmp1__get_scale__0._x_0;
    var tmp2_length_0_1 = new Float3(tmp0__get_xyz__0_2._x_3, tmp0__get_xyz__0_2._y_3, tmp0__get_xyz__0_2._z_3);
    var tmp1_sqrt_0_3 = tmp2_length_0_1._x_2 * tmp2_length_0_1._x_2 + tmp2_length_0_1._y_2 * tmp2_length_0_1._y_2 + tmp2_length_0_1._z_2 * tmp2_length_0_1._z_2;
    var tmp_1 = Math.sqrt(tmp1_sqrt_0_3);
    var tmp3__get_xyz__0_5 = tmp1__get_scale__0._y_0;
    var tmp5_length_0_4 = new Float3(tmp3__get_xyz__0_5._x_3, tmp3__get_xyz__0_5._y_3, tmp3__get_xyz__0_5._z_3);
    var tmp4_sqrt_0_6 = tmp5_length_0_4._x_2 * tmp5_length_0_4._x_2 + tmp5_length_0_4._y_2 * tmp5_length_0_4._y_2 + tmp5_length_0_4._z_2 * tmp5_length_0_4._z_2;
    var tmp_2 = Math.sqrt(tmp4_sqrt_0_6);
    var tmp6__get_xyz__0_8 = tmp1__get_scale__0._z_0;
    var tmp8_length_0_7 = new Float3(tmp6__get_xyz__0_8._x_3, tmp6__get_xyz__0_8._y_3, tmp6__get_xyz__0_8._z_3);
    var tmp7_sqrt_0_9 = tmp8_length_0_7._x_2 * tmp8_length_0_7._x_2 + tmp8_length_0_7._y_2 * tmp8_length_0_7._y_2 + tmp8_length_0_7._z_2 * tmp8_length_0_7._z_2;
    var localScale = new Float3(tmp_1, tmp_2, Math.sqrt(tmp7_sqrt_0_9));
    $this.__localScale.set_4(localScale._x_2, localScale._y_2, localScale._z_2);
    Unit_getInstance();
    var tmp0__get_xyz__0_2_0 = globalTransformation._x_0;
    var tmp2_length_0_1_0 = new Float3(tmp0__get_xyz__0_2_0._x_3, tmp0__get_xyz__0_2_0._y_3, tmp0__get_xyz__0_2_0._z_3);
    var tmp1_sqrt_0_3_0 = tmp2_length_0_1_0._x_2 * tmp2_length_0_1_0._x_2 + tmp2_length_0_1_0._y_2 * tmp2_length_0_1_0._y_2 + tmp2_length_0_1_0._z_2 * tmp2_length_0_1_0._z_2;
    var tmp_3 = Math.sqrt(tmp1_sqrt_0_3_0);
    var tmp3__get_xyz__0_5_0 = globalTransformation._y_0;
    var tmp5_length_0_4_0 = new Float3(tmp3__get_xyz__0_5_0._x_3, tmp3__get_xyz__0_5_0._y_3, tmp3__get_xyz__0_5_0._z_3);
    var tmp4_sqrt_0_6_0 = tmp5_length_0_4_0._x_2 * tmp5_length_0_4_0._x_2 + tmp5_length_0_4_0._y_2 * tmp5_length_0_4_0._y_2 + tmp5_length_0_4_0._z_2 * tmp5_length_0_4_0._z_2;
    var tmp_4 = Math.sqrt(tmp4_sqrt_0_6_0);
    var tmp6__get_xyz__0_8_0 = globalTransformation._z_0;
    var tmp8_length_0_7_0 = new Float3(tmp6__get_xyz__0_8_0._x_3, tmp6__get_xyz__0_8_0._y_3, tmp6__get_xyz__0_8_0._z_3);
    var tmp7_sqrt_0_9_0 = tmp8_length_0_7_0._x_2 * tmp8_length_0_7_0._x_2 + tmp8_length_0_7_0._y_2 * tmp8_length_0_7_0._y_2 + tmp8_length_0_7_0._z_2 * tmp8_length_0_7_0._z_2;
    var tmp_5 = (new Float3(tmp_3, tmp_4, Math.sqrt(tmp7_sqrt_0_9_0)))._x_2;
    var tmp0__get_xyz__0_2_1 = globalTransformation._x_0;
    var tmp2_length_0_1_1 = new Float3(tmp0__get_xyz__0_2_1._x_3, tmp0__get_xyz__0_2_1._y_3, tmp0__get_xyz__0_2_1._z_3);
    var tmp1_sqrt_0_3_1 = tmp2_length_0_1_1._x_2 * tmp2_length_0_1_1._x_2 + tmp2_length_0_1_1._y_2 * tmp2_length_0_1_1._y_2 + tmp2_length_0_1_1._z_2 * tmp2_length_0_1_1._z_2;
    var tmp_6 = Math.sqrt(tmp1_sqrt_0_3_1);
    var tmp3__get_xyz__0_5_1 = globalTransformation._y_0;
    var tmp5_length_0_4_1 = new Float3(tmp3__get_xyz__0_5_1._x_3, tmp3__get_xyz__0_5_1._y_3, tmp3__get_xyz__0_5_1._z_3);
    var tmp4_sqrt_0_6_1 = tmp5_length_0_4_1._x_2 * tmp5_length_0_4_1._x_2 + tmp5_length_0_4_1._y_2 * tmp5_length_0_4_1._y_2 + tmp5_length_0_4_1._z_2 * tmp5_length_0_4_1._z_2;
    var tmp_7 = Math.sqrt(tmp4_sqrt_0_6_1);
    var tmp6__get_xyz__0_8_1 = globalTransformation._z_0;
    var tmp8_length_0_7_1 = new Float3(tmp6__get_xyz__0_8_1._x_3, tmp6__get_xyz__0_8_1._y_3, tmp6__get_xyz__0_8_1._z_3);
    var tmp7_sqrt_0_9_1 = tmp8_length_0_7_1._x_2 * tmp8_length_0_7_1._x_2 + tmp8_length_0_7_1._y_2 * tmp8_length_0_7_1._y_2 + tmp8_length_0_7_1._z_2 * tmp8_length_0_7_1._z_2;
    var tmp_8 = (new Float3(tmp_6, tmp_7, Math.sqrt(tmp7_sqrt_0_9_1)))._y_2;
    var tmp0__get_xyz__0_2_2 = globalTransformation._x_0;
    var tmp2_length_0_1_2 = new Float3(tmp0__get_xyz__0_2_2._x_3, tmp0__get_xyz__0_2_2._y_3, tmp0__get_xyz__0_2_2._z_3);
    var tmp1_sqrt_0_3_2 = tmp2_length_0_1_2._x_2 * tmp2_length_0_1_2._x_2 + tmp2_length_0_1_2._y_2 * tmp2_length_0_1_2._y_2 + tmp2_length_0_1_2._z_2 * tmp2_length_0_1_2._z_2;
    var tmp_9 = Math.sqrt(tmp1_sqrt_0_3_2);
    var tmp3__get_xyz__0_5_2 = globalTransformation._y_0;
    var tmp5_length_0_4_2 = new Float3(tmp3__get_xyz__0_5_2._x_3, tmp3__get_xyz__0_5_2._y_3, tmp3__get_xyz__0_5_2._z_3);
    var tmp4_sqrt_0_6_2 = tmp5_length_0_4_2._x_2 * tmp5_length_0_4_2._x_2 + tmp5_length_0_4_2._y_2 * tmp5_length_0_4_2._y_2 + tmp5_length_0_4_2._z_2 * tmp5_length_0_4_2._z_2;
    var tmp_10 = Math.sqrt(tmp4_sqrt_0_6_2);
    var tmp6__get_xyz__0_8_2 = globalTransformation._z_0;
    var tmp8_length_0_7_2 = new Float3(tmp6__get_xyz__0_8_2._x_3, tmp6__get_xyz__0_8_2._y_3, tmp6__get_xyz__0_8_2._z_3);
    var tmp7_sqrt_0_9_2 = tmp8_length_0_7_2._x_2 * tmp8_length_0_7_2._x_2 + tmp8_length_0_7_2._y_2 * tmp8_length_0_7_2._y_2 + tmp8_length_0_7_2._z_2 * tmp8_length_0_7_2._z_2;
    $this.__scale.set_4(tmp_5, tmp_8, (new Float3(tmp_9, tmp_10, Math.sqrt(tmp7_sqrt_0_9_2)))._z_2);
    Unit_getInstance();
    $this.__transformation = globalTransformation;
    $this.__quaternion = Companion_getInstance_11().from_0(globalTransformation);
    $this._needsToBeUpdated_1 = false;
  }
  function requireUpdate($this) {
    $this._needsToBeUpdated_1 = true;
    var tmp0_safe_receiver = $this._owner_2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.componentUpdated(getKClassFromExpression_0($this));
      Unit_getInstance();
    }
    Unit_getInstance();
    return $this;
  }
  function Companion_19() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp0_also_0 = Position_init_$Create$_0(null, null, null, 7, null);
    tmp0_also_0._needsToBeUpdated_1 = false;
    tmp._identity = tmp0_also_0;
  }
  Companion_19.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_19();
    return Companion_instance_18;
  }
  function Local() {
    Local_instance = this;
    CoordinateConverter.call(this);
  }
  Local.prototype.convert_0 = function (coordinate, scale_1) {
    return numberToDouble(coordinate);
  };
  Local.$metadata$ = {
    simpleName: 'Local',
    kind: 'object',
    interfaces: []
  };
  var Local_instance;
  function Local_getInstance() {
    if (Local_instance == null)
      new Local();
    return Local_instance;
  }
  function ScriptComponent() {
  }
  ScriptComponent.prototype.execute = function (context, $cont) {
    return this._script(context, $cont);
  };
  ScriptComponent.$metadata$ = {
    simpleName: 'ScriptComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function SpriteComponent() {
  }
  SpriteComponent.$metadata$ = {
    simpleName: 'SpriteComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function TextComponent(text, font, gameContext, lineWith, horizontalAlign, verticalAlign) {
    this._gameContext_0 = gameContext;
    this._needsToBeUpdated_2 = true;
    this.__text = text;
    this.__font = font;
    var tmp = this;
    var tmp0_elvis_lhs = lineWith;
    tmp.__lineWith = tmp0_elvis_lhs == null ? findLongestLine(this, text._get_content__3()).length : tmp0_elvis_lhs;
    this.__horizontalAlign = horizontalAlign;
    this.__verticalAlign = verticalAlign;
    this._owner_3 = null;
    var tmp_0 = this;
    tmp_0._textMeshData = TextMeshData_init_$Create$(null, null, 3, null);
  }
  TextComponent.prototype._get_text_ = function () {
    if (this._needsToBeUpdated_2)
      update_0(this);
    return this.__text;
  };
  TextComponent.prototype.onAdded_18 = function (entity) {
    this._owner_3 = entity;
    this._needsToBeUpdated_2 = true;
  };
  TextComponent.prototype.onRemoved_18 = function (entity) {
    this._owner_3 = null;
  };
  TextComponent.prototype.onComponentUpdated_18 = function (componentType) {
    if (componentType.equals(getKClass_0(BoundingBoxComponent))) {
      this._needsToBeUpdated_2 = true;
    }};
  TextComponent.prototype.update_62 = function (delta_0) {
    if (this._needsToBeUpdated_2)
      update_0(this);
    this.__text.update_62(delta_0);
    if (this.__text._get_wasUpdated__0()) {
      update_0(this);
    }};
  TextComponent.prototype.generateVertices = function (scale_1) {
    var boundingBox = ensureNotNull(this._owner_3).get_44(getKClass_0(BoundingBoxComponent));
    var textureHeight = this.__font._fontSprite._height_6;
    var textureWidth = this.__font._fontSprite._width_5;
    var scaleY = scale_1 / ((boundingBox._get_max_()._get_y_() - boundingBox._get_min_()._get_y_()) * 0.5);
    this._textMeshData._vertices_2.clear_15();
    this._textMeshData._verticesOrder_2.clear_15();
    var angelCode = this.__font._angelCode;
    var characterIndex = 0;
    var tmp = this.__text._get_content__3();
    var tmp_0 = ['\n'];
    var lines_0 = split$default(tmp, tmp_0, false, 0, 6, null);
    var lineIndex = 0;
    var startX = this.__horizontalAlign.getHorizontalOffset_0(getTextSize(this, lines_0.get_57(lineIndex), this.__font), scale_1, -1.0, 1.0);
    var startY = 1.0;
    var currentX = 0.0;
    var currentY = 0.0;
    var tmp0_forEachIndexed_0 = this.__text._get_content__3();
    var index_1 = 0;
    var indexedObject = tmp0_forEachIndexed_0;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1_4 = index_1;
        index_1 = tmp1_4 + 1 | 0;
        var tmp1__anonymous__5 = tmp1_4;
        if (item_3.equals(new Char(10))) {
          var tmp0_6 = lineIndex;
          lineIndex = tmp0_6 + 1 | 0;
          Unit_getInstance();
          startX = this.__horizontalAlign.getHorizontalOffset_0(getTextSize(this, lines_0.get_57(lineIndex), this.__font), scale_1, -1.0, 1.0);
          currentX = 0.0;
          currentY = currentY - angelCode._info._lineHeight;
        } else if (item_3.equals(new Char(32))) {
          var tmp_1 = currentX;
          var tmp1_safe_receiver_9 = angelCode._characters.get_27(item_3);
          var tmp3_elvis_lhs_8 = tmp1_safe_receiver_9 == null ? null : tmp1_safe_receiver_9._width_4;
          var tmp_2;
          if (tmp3_elvis_lhs_8 == null) {
            var tmp2_safe_receiver_10 = angelCode._characters.get_27(new Char(97));
            tmp_2 = tmp2_safe_receiver_10 == null ? null : tmp2_safe_receiver_10._width_4;
          } else {
            tmp_2 = tmp3_elvis_lhs_8;
          }
          var tmp4_elvis_lhs_7 = tmp_2;
          currentX = tmp_1 + (tmp4_elvis_lhs_7 == null ? 0 : tmp4_elvis_lhs_7);
        }var alteration_11 = this.__text.getAlteration_0(tmp1__anonymous__5);
        var tmp5_elvis_lhs_13 = angelCode._characters.get_27(item_3);
        var tmp_3;
        if (tmp5_elvis_lhs_13 == null) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          tmp_3 = tmp5_elvis_lhs_13;
        }
        var code_12 = tmp_3;
        var yTop_14 = currentY - code_12._yoffset + alteration_11._y_8;
        var xLeft_15 = currentX + code_12._xoffset + alteration_11._x_8;
        var xRight_16 = xLeft_15 + code_12._width_4 + alteration_11._with;
        var yBottom_17 = yTop_14 - code_12._height_5 + alteration_11._height_4;
        var tmp_4 = new Position(startX + scale_1 * xLeft_15, startY + scaleY * yTop_14, alteration_11._z_6 * scale_1);
        var tmp_5 = Companion_getInstance_19()._DEFAULT_NORMAL;
        var tmp_6 = new UV(code_12._x_9 / textureWidth, code_12._y_9 / textureHeight);
        var a_18 = Vertex_init_$Create$(tmp_4, tmp_5, null, tmp_6, null, 20, null);
        var tmp_7 = new Position(startX + scale_1 * xLeft_15, startY + scaleY * yBottom_17, alteration_11._z_6 * scale_1);
        var tmp_8 = Companion_getInstance_19()._DEFAULT_NORMAL;
        var tmp_9 = new UV(code_12._x_9 / textureWidth, (code_12._y_9 + code_12._height_5 | 0) / textureHeight);
        var b_19 = Vertex_init_$Create$(tmp_7, tmp_8, null, tmp_9, null, 20, null);
        var tmp_10 = new Position(startX + scale_1 * xRight_16, startY + scaleY * yBottom_17, alteration_11._z_6 * scale_1);
        var tmp_11 = Companion_getInstance_19()._DEFAULT_NORMAL;
        var tmp_12 = new UV((code_12._x_9 + code_12._width_4 | 0) / textureWidth, (code_12._y_9 + code_12._height_5 | 0) / textureHeight);
        var c_20 = Vertex_init_$Create$(tmp_10, tmp_11, null, tmp_12, null, 20, null);
        var tmp_13 = new Position(startX + scale_1 * xRight_16, startY + scaleY * yTop_14, alteration_11._z_6 * scale_1);
        var tmp_14 = new Normal(0.0, 0.0, 0.0);
        var tmp_15 = new UV((code_12._x_9 + code_12._width_4 | 0) / textureWidth, code_12._y_9 / textureHeight);
        var d_21 = Vertex_init_$Create$(tmp_13, tmp_14, null, tmp_15, null, 20, null);
        this._textMeshData._vertices_2.addAll_11(listOf([a_18, b_19, c_20, d_21]));
        Unit_getInstance();
        this._textMeshData._verticesOrder_2.addAll_11(listOf([imul(characterIndex, 4) + 0 | 0, imul(characterIndex, 4) + 1 | 0, imul(characterIndex, 4) + 2 | 0, imul(characterIndex, 4) + 0 | 0, imul(characterIndex, 4) + 2 | 0, imul(characterIndex, 4) + 3 | 0]));
        Unit_getInstance();
        currentX = currentX + (code_12._xadvance + code_12._xoffset | 0);
        var tmp6_22 = characterIndex;
        characterIndex = tmp6_22 + 1 | 0;
        Unit_getInstance();
      }
       while (false);
    }
    return this._textMeshData;
  };
  TextComponent.prototype.computeCharacterScale = function (longestLine) {
    var numberOfCharacterByLine = this.__lineWith;
    var lineInPixel = getTextSize(this, longestLine, this.__font);
    if (charSequenceLength(longestLine) === 0) {
      return 0.0;
    } else {
    }
    var characterWidth = lineInPixel / longestLine.length | 0;
    var lineInWorldUnit = 2;
    var scale_1 = lineInWorldUnit / (numberOfCharacterByLine * characterWidth);
    return scale_1;
  };
  TextComponent.$metadata$ = {
    simpleName: 'TextComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function HorizontalAlignment() {
  }
  HorizontalAlignment.$metadata$ = {
    simpleName: 'HorizontalAlignment',
    kind: 'class',
    interfaces: []
  };
  function VerticalAlignment() {
  }
  VerticalAlignment.$metadata$ = {
    simpleName: 'VerticalAlignment',
    kind: 'class',
    interfaces: []
  };
  function TextMeshData(vertices, verticesOrder) {
    this._vertices_2 = vertices;
    this._verticesOrder_2 = verticesOrder;
  }
  TextMeshData.$metadata$ = {
    simpleName: 'TextMeshData',
    kind: 'class',
    interfaces: []
  };
  function TextComponent_init_$Init$(text, font, gameContext, lineWith, horizontalAlign, verticalAlign, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      lineWith = null;
    if (!(($mask0 & 16) === 0))
      horizontalAlign = Left_getInstance();
    if (!(($mask0 & 32) === 0))
      verticalAlign = Top_getInstance();
    TextComponent.call($this, text, font, gameContext, lineWith, horizontalAlign, verticalAlign);
    return $this;
  }
  function TextComponent_init_$Create$(text, font, gameContext, lineWith, horizontalAlign, verticalAlign, $mask0, $marker) {
    return TextComponent_init_$Init$(text, font, gameContext, lineWith, horizontalAlign, verticalAlign, $mask0, $marker, Object.create(TextComponent.prototype));
  }
  function update_0($this) {
    var longestLine = findLongestLine($this, $this.__text._get_content__3());
    var scale_1 = $this.computeCharacterScale(longestLine);
    var textMeshData = $this.generateVertices(scale_1);
    var meshPrimitive = first(ensureNotNull($this._owner_3).get_44(getKClass_0(ModelComponent))._model._primitives_0);
    if (textMeshData._vertices_2.isEmpty_35()) {
      ensureNotNull($this._owner_3).get_44(getKClass_0(ModelComponent))._model._displayble = false;
      $this._needsToBeUpdated_2 = false;
      return Unit_getInstance();
    }var tmp0_flatMap_0 = textMeshData._vertices_2;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_flatMap_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var list_3_4 = listOf([element_2_3._position_10._x_4, element_2_3._position_10._y_4, element_2_3._position_10._z_4]);
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    meshPrimitive._set_vertices_(toFloatArray(tmp0_flatMapTo_0_1));
    var tmp1_map_0 = textMeshData._verticesOrder_2;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_30();
      tmp0_mapTo_0_1.add_19(toShort_0(item_2_3));
      Unit_getInstance();
    }
    meshPrimitive._set_verticesOrder_(toShortArray(tmp0_mapTo_0_1));
    var tmp2_flatMap_0 = textMeshData._vertices_2;
    var tmp0_flatMapTo_0_1_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_1 = tmp2_flatMap_0.iterator_52();
    while (tmp0_iterator_1_2_1.hasNext_27()) {
      var element_2_3_0 = tmp0_iterator_1_2_1.next_30();
      var list_3_4_0 = listOf([element_2_3_0._normal._x_5, element_2_3_0._normal._y_5, element_2_3_0._normal._z_5]);
      addAll(tmp0_flatMapTo_0_1_0, list_3_4_0);
      Unit_getInstance();
    }
    meshPrimitive._set_normals_(toFloatArray(tmp0_flatMapTo_0_1_0));
    var tmp3_flatMap_0 = textMeshData._vertices_2;
    var tmp0_flatMapTo_0_1_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_2 = tmp3_flatMap_0.iterator_52();
    while (tmp0_iterator_1_2_2.hasNext_27()) {
      var element_2_3_1 = tmp0_iterator_1_2_2.next_30();
      var list_3_4_1 = listOf([element_2_3_1._uv._x_6, element_2_3_1._uv._y_6]);
      addAll(tmp0_flatMapTo_0_1_1, list_3_4_1);
      Unit_getInstance();
    }
    meshPrimitive._set_uvs_(toFloatArray(tmp0_flatMapTo_0_1_1));
    $this._gameContext_0._assetsManager.add_35(ensureNotNull($this._owner_3).get_44(getKClass_0(ModelComponent))._model);
    $this._needsToBeUpdated_2 = false;
  }
  function findLongestLine($this, content) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp = ['\n'];
      var tmp0_maxByOrNull_0 = split$default(content, tmp, false, 0, 6, null);
      var iterator_1 = tmp0_maxByOrNull_0.iterator_52();
      if (!iterator_1.hasNext_27()) {
        tmp$ret$0 = null;
        break l$ret$1;
      }var maxElem_2 = iterator_1.next_30();
      if (!iterator_1.hasNext_27()) {
        tmp$ret$0 = maxElem_2;
        break l$ret$1;
      }var tmp1__anonymous__6 = maxElem_2;
      var maxValue_3 = tmp1__anonymous__6.length;
      do {
        var e_4 = iterator_1.next_30();
        var v_5 = e_4.length;
        if (compareTo(maxValue_3, v_5) < 0) {
          maxElem_2 = e_4;
          maxValue_3 = v_5;
        }}
       while (iterator_1.hasNext_27());
      tmp$ret$0 = maxElem_2;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? content : tmp0_elvis_lhs;
  }
  function getTextSize($this, text, font) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(charSequenceLength(text));
    var indexedObject = text;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_2_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var angelCharacter_5 = font.get_47(item_2_3);
      var xAdvance_6 = angelCharacter_5._xadvance;
      xAdvance_6 = xAdvance_6 + angelCharacter_5._xoffset | 0;
      tmp0_mapTo_0_1.add_19(xAdvance_6);
      Unit_getInstance();
    }
    return sum(tmp0_mapTo_0_1);
  }
  function Companion_20() {
    Companion_instance_19 = this;
    this._DEFAULT_NORMAL = new Normal(0.0, 0.0, 1.0);
  }
  Companion_20.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_20();
    return Companion_instance_19;
  }
  function Left() {
    Left_instance = this;
    HorizontalAlignment.call(this);
  }
  Left.prototype.getHorizontalOffset_0 = function (lineWith, scale_1, min, max) {
    return min;
  };
  Left.$metadata$ = {
    simpleName: 'Left',
    kind: 'object',
    interfaces: []
  };
  var Left_instance;
  function Left_getInstance() {
    if (Left_instance == null)
      new Left();
    return Left_instance;
  }
  function Top() {
    Top_instance = this;
    VerticalAlignment.call(this);
  }
  Top.$metadata$ = {
    simpleName: 'Top',
    kind: 'object',
    interfaces: []
  };
  var Top_instance;
  function Top_getInstance() {
    if (Top_instance == null)
      new Top();
    return Top_instance;
  }
  function TextMeshData_init_$Init$(vertices, verticesOrder, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      vertices = ArrayList_init_$Create$();
    }if (!(($mask0 & 2) === 0)) {
      verticesOrder = ArrayList_init_$Create$();
    }TextMeshData.call($this, vertices, verticesOrder);
    return $this;
  }
  function TextMeshData_init_$Create$(vertices, verticesOrder, $mask0, $marker) {
    return TextMeshData_init_$Init$(vertices, verticesOrder, $mask0, $marker, Object.create(TextMeshData.prototype));
  }
  function ParticleComponent(configuration, ttl, direction, rotation_0, scale_1) {
    this._configuration_2 = configuration;
    this._ttl = ttl;
    this._direction = direction;
    this._rotation_0 = rotation_0;
    this._scale_2 = scale_1;
  }
  ParticleComponent.$metadata$ = {
    simpleName: 'ParticleComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function ParticleComponent_init_$Init$(configuration, ttl, direction, rotation_0, scale_1, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      ttl = 1.0;
    if (!(($mask0 & 4) === 0)) {
      direction = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    }if (!(($mask0 & 8) === 0)) {
      rotation_0 = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    }if (!(($mask0 & 16) === 0))
      scale_1 = new Vector3(1.0, 1.0, 1.0);
    ParticleComponent.call($this, configuration, ttl, direction, rotation_0, scale_1);
    return $this;
  }
  function ParticleComponent_init_$Create$(configuration, ttl, direction, rotation_0, scale_1, $mask0, $marker) {
    return ParticleComponent_init_$Init$(configuration, ttl, direction, rotation_0, scale_1, $mask0, $marker, Object.create(ParticleComponent.prototype));
  }
  function ParticleGeneration(emitter) {
    this._emitter = emitter;
    this._particlesIndex = new Long(0, 0);
    this._particlesTotal = new Long(0, 0);
    this._particlesIndexPercent = 0.0;
    this._emmiterProgress = 0.0;
  }
  ParticleGeneration.$metadata$ = {
    simpleName: 'ParticleGeneration',
    kind: 'class',
    interfaces: []
  };
  function MutableParticleConfiguration(duration, time, initialized) {
    this._duration_3 = duration;
    this._time_1 = time;
    this._initialized = initialized;
  }
  MutableParticleConfiguration.$metadata$ = {
    simpleName: 'MutableParticleConfiguration',
    kind: 'class',
    interfaces: []
  };
  function MutableParticleConfiguration_init_$Init$(duration, time, initialized, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      initialized = false;
    MutableParticleConfiguration.call($this, duration, time, initialized);
    return $this;
  }
  function MutableParticleConfiguration_init_$Create$(duration, time, initialized, $mask0, $marker) {
    return MutableParticleConfiguration_init_$Init$(duration, time, initialized, $mask0, $marker, Object.create(MutableParticleConfiguration.prototype));
  }
  function ParticleEmitterActiveComponent() {
  }
  ParticleEmitterActiveComponent.prototype.reset_2 = function () {
    this._current = this._base.toMutable__error();
  };
  ParticleEmitterActiveComponent.$metadata$ = {
    simpleName: 'ParticleEmitterActiveComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function ParticleEmitterComponent() {
  }
  ParticleEmitterComponent.$metadata$ = {
    simpleName: 'ParticleEmitterComponent',
    kind: 'class',
    interfaces: [Component]
  };
  function TransformationHolder(translation_1, rotation_0, scale_1) {
    this._combined = Companion_getInstance_10().identity_0();
    this._translation_0 = translation_0(translation_1);
    this._rotation_1 = Companion_getInstance_11().from_0(rotation_0);
    this._scale_3 = scale_0(scale_1);
    this._combined = updateTransformation(this);
  }
  TransformationHolder.prototype._set_translation_ = function (value) {
    this._translation_0 = translation_0(value);
    this._combined = updateTransformation(this);
  };
  TransformationHolder.prototype._set_rotation_ = function (value) {
    this._rotation_1 = value;
    this._combined = updateTransformation(this);
  };
  TransformationHolder.prototype._set_scale_ = function (value) {
    this._scale_3 = scale_0(value);
    this._combined = updateTransformation(this);
  };
  TransformationHolder.prototype._get_transformation__0 = function () {
    return this._combined;
  };
  TransformationHolder.$metadata$ = {
    simpleName: 'TransformationHolder',
    kind: 'class',
    interfaces: []
  };
  function updateTransformation($this) {
    return $this._translation_0.times_0(Companion_getInstance_10().from($this._rotation_1)).times_0($this._scale_3);
  }
  function TextEffect() {
  }
  TextEffect.$metadata$ = {
    simpleName: 'TextEffect',
    kind: 'interface',
    interfaces: []
  };
  function Alteration(x, y, z, with_0, height) {
    this._x_8 = x;
    this._y_8 = y;
    this._z_6 = z;
    this._with = with_0;
    this._height_4 = height;
  }
  Alteration.$metadata$ = {
    simpleName: 'Alteration',
    kind: 'class',
    interfaces: []
  };
  function Companion_21() {
    Companion_instance_20 = this;
    this._none = new Alteration(0, 0, 0, 0, 0);
  }
  Companion_21.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_21();
    return Companion_instance_20;
  }
  function WriteText(content) {
    this._content_3 = content;
    this._isFinished = true;
    this.__wasUpdated = true;
    this._wasUpdated = true;
  }
  WriteText.prototype._set_content__0 = function (value) {
    this._content_3 = value;
    this.__wasUpdated = true;
  };
  WriteText.prototype._get_content__3 = function () {
    return this._content_3;
  };
  WriteText.prototype._get_wasUpdated__0 = function () {
    return this._wasUpdated;
  };
  WriteText.prototype.update_62 = function (delta_0) {
    this._wasUpdated = this.__wasUpdated;
    this.__wasUpdated = false;
  };
  WriteText.prototype.getAlteration_0 = function (characterIndex) {
    return Companion_getInstance_20()._none;
  };
  WriteText.$metadata$ = {
    simpleName: 'WriteText',
    kind: 'class',
    interfaces: [TextEffect]
  };
  function Entity(engine, components, name) {
    this._engine_0 = engine;
    this._name_12 = name;
    this._components_0 = components;
    var tmp = this;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = components.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var key_3_4 = getKClassFromExpression_0(element_2_3);
      var value_1_6 = tmp0_groupByTo_0_1.get_27(key_3_4);
      var tmp_0;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_5(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp_0 = answer_2_7;
      } else {
        tmp_0 = value_1_6;
      }
      var list_4_5 = tmp_0;
      list_4_5.add_19(element_2_3);
      Unit_getInstance();
    }
    tmp._componentsByType = tmp0_groupByTo_0_1;
    var tmp_1 = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(components, 10));
    var tmp0_iterator_1_2_0 = components.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_30();
      tmp0_mapTo_0_1.add_19(getKClassFromExpression_0(item_2_3));
      Unit_getInstance();
    }
    tmp_1._componentsType = toSet_0(tmp0_mapTo_0_1);
    var tmp_2 = this;
    tmp_2.__inFlightComponents = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3.__children = ArrayList_init_$Create$();
    var tmp_4 = this;
    tmp_4.__namedChildren = LinkedHashMap_init_$Create$();
    this._chidren = this.__children;
    this._parent_0 = null;
    var tmp0_iterator_1 = components.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.onAdded_18(this);
    }
  }
  Entity.prototype.get_44 = function (type) {
    var tmp0_elvis_lhs = this.find_0(type);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = '' + "No components of type '" + type._get_simpleName__4() + "' " + ('' + "found in the entity '" + this._name_12 + "'. The entity contains those components: ");
      var tmp0_map_0 = this._componentsType;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
      while (tmp0_iterator_1_2.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2.next_30();
        tmp0_mapTo_0_1.add_19(item_2_3._get_simpleName__4());
        Unit_getInstance();
      }
      var tmp1_map_0 = this.__inFlightComponents;
      var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
      var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_52();
      while (tmp0_iterator_1_2_0.hasNext_27()) {
        var item_2_3_0 = tmp0_iterator_1_2_0.next_30();
        tmp0_mapTo_0_1_0.add_19(getKClassFromExpression_0(item_2_3_0)._get_simpleName__4());
        Unit_getInstance();
      }
      var tmp2_ifEmpty_0 = plus(tmp0_mapTo_0_1, tmp0_mapTo_0_1_0);
      var tmp_1;
      if (tmp2_ifEmpty_0.isEmpty_35()) {
        tmp_1 = listOf_0('None');
      } else {
        tmp_1 = tmp2_ifEmpty_0;
      }
      var tmp_2 = tmp_1;
      throw IllegalStateException_init_$Create$(tmp_0 + joinToString$default_0(tmp_2, null, null, null, 0, null, null, 63, null));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  Entity.prototype.find_0 = function (type) {
    var tmp0_safe_receiver = this._componentsByType.get_27(type);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toList_1(tmp0_safe_receiver);
    var tmp = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
    var tmp2_elvis_lhs = (tmp == null ? true : isInterface(tmp, Component)) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      var tmp_1 = firstOrNull_0(getFromInFlight(this, type));
      tmp_0 = (tmp_1 == null ? true : isInterface(tmp_1, Component)) ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  };
  Entity.prototype.findAll_0 = function (type) {
    var tmp0_safe_receiver = this._componentsByType.get_27(type);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toList_1(tmp0_safe_receiver);
    var components = tmp1_elvis_lhs == null ? getFromInFlight(this, type) : tmp1_elvis_lhs;
    return isInterface(components, List) ? components : THROW_CCE();
  };
  Entity.prototype.add_23 = function (component) {
    this.__inFlightComponents.add_19(component);
    Unit_getInstance();
    return engineUpdate(this, _no_name_provided_$factory_74(this, component));
  };
  Entity.prototype.remove_32 = function (component) {
    return engineUpdate(this, _no_name_provided_$factory_75(this, component));
  };
  Entity.prototype.remove_33 = function (componentType) {
    return engineUpdate(this, _no_name_provided_$factory_76(this, componentType));
  };
  Entity.prototype.destroy_31 = function () {
    var tmp0_forEach_0 = this.__children;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.destroy_31();
      Unit_getInstance();
    }
    var removed = this._engine_0.destroy(this);
    this._components_0 = emptyList();
    this._componentsByType = emptyMap();
    this._componentsType = emptySet();
    return removed;
  };
  Entity.prototype.hasComponent = function (componentClass) {
    var contains_2 = this._componentsType.contains_35(componentClass);
    if (!contains_2) {
      var tmp0_isNotEmpty_0 = getFromInFlight(this, componentClass);
      return !tmp0_isNotEmpty_0.isEmpty_35();
    }return contains_2;
  };
  Entity.prototype.attachTo = function (other) {
    if (equals_1(other, this)) {
      throw IllegalArgumentException_init_$Create$('' + 'The entity ' + this._name_12 + " can't be attached to itself.");
    }this.detach_0();
    Unit_getInstance();
    this._parent_0 = other;
    var tmp0_safe_receiver = other;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.__children;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.add_19(this);
    Unit_getInstance();
    var tmp2_safe_receiver = other;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.__namedChildren;
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver.put_5(this._name_12, this);
    Unit_getInstance();
    var tmp4_safe_receiver = this._parent_0;
    if (tmp4_safe_receiver == null)
      null;
    else {
      var tmp0_forEach_0_2 = this._components_0;
      var tmp0_iterator_1_3 = tmp0_forEach_0_2.iterator_52();
      while (tmp0_iterator_1_3.hasNext_27()) {
        var element_2_4 = tmp0_iterator_1_3.next_30();
        element_2_4.onAttach_18(tmp4_safe_receiver);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    return this;
  };
  Entity.prototype.detach_0 = function () {
    var tmp0_safe_receiver = this._parent_0;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.__children;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.remove_16(this);
    Unit_getInstance();
    var tmp2_safe_receiver = this._parent_0;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.__namedChildren;
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver.remove_17(this._name_12);
    Unit_getInstance();
    var tmp4_safe_receiver = this._parent_0;
    if (tmp4_safe_receiver == null)
      null;
    else {
      var tmp0_forEach_0_2 = this._components_0;
      var tmp0_iterator_1_3 = tmp0_forEach_0_2.iterator_52();
      while (tmp0_iterator_1_3.hasNext_27()) {
        var element_2_4 = tmp0_iterator_1_3.next_30();
        element_2_4.onDetach_18(tmp4_safe_receiver);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    this._parent_0 = null;
    return this;
  };
  Entity.prototype.componentUpdated = function (componentUpdated) {
    var tmp0_forEach_0 = this._components_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.onComponentUpdated_18(componentUpdated);
    }
    var tmp1_forEach_0 = this._chidren;
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_30();
      element_2_0.componentUpdated(componentUpdated);
    }
  };
  Entity.prototype.toString = function () {
    return this._name_12;
  };
  Entity.$metadata$ = {
    simpleName: 'Entity',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_74(this$0, $component) {
    var i = new _no_name_provided__96(this$0, $component);
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_75(this$0, $component) {
    var i = new _no_name_provided__97(this$0, $component);
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_76(this$0, $componentType) {
    var i = new _no_name_provided__98(this$0, $componentType);
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_77(this$0, $block) {
    var i = new _no_name_provided__99(this$0, $block);
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function engineUpdate($this, block) {
    $this._engine_0.queueEntityUpdate(_no_name_provided_$factory_77($this, block));
    return $this;
  }
  function getFromInFlight($this, type) {
    var tmp0_filter_0 = $this.__inFlightComponents;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      if (type.isInstance_4(element_2_3)) {
        tmp0_filterTo_0_1.add_19(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterTo_0_1;
  }
  function _no_name_provided__96(this$0, $component) {
    this._this$0_37 = this$0;
    this._$component = $component;
  }
  _no_name_provided__96.prototype.invoke_231 = function () {
    this._this$0_37.__inFlightComponents.remove_16(this._$component);
    Unit_getInstance();
    var tmp0_this = this._this$0_37;
    tmp0_this._components_0 = plus_0(tmp0_this._components_0, this._$component);
    this._this$0_37._componentsType = plus_1(this._this$0_37._componentsType, getKClassFromExpression_0(this._$component));
    var tmp = this._this$0_37;
    var tmp0_groupBy_0 = this._this$0_37._components_0;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_groupBy_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var key_3_4 = getKClassFromExpression_0(element_2_3);
      var value_1_6 = tmp0_groupByTo_0_1.get_27(key_3_4);
      var tmp_0;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_5(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp_0 = answer_2_7;
      } else {
        tmp_0 = value_1_6;
      }
      var list_4_5 = tmp_0;
      list_4_5.add_19(element_2_3);
      Unit_getInstance();
    }
    tmp._componentsByType = tmp0_groupByTo_0_1;
    this._$component.onAdded_18(this._this$0_37);
  };
  _no_name_provided__96.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__97(this$0, $component) {
    this._this$0_38 = this$0;
    this._$component_0 = $component;
  }
  _no_name_provided__97.prototype.invoke_231 = function () {
    var tmp0_this = this._this$0_38;
    tmp0_this._components_0 = minus(tmp0_this._components_0, this._$component_0);
    this._this$0_38._componentsType = minus_1(this._this$0_38._componentsType, getKClassFromExpression_0(this._$component_0));
    var tmp = this._this$0_38;
    var tmp0_groupBy_0 = this._this$0_38._components_0;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_groupBy_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var key_3_4 = getKClassFromExpression_0(element_2_3);
      var value_1_6 = tmp0_groupByTo_0_1.get_27(key_3_4);
      var tmp_0;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_5(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp_0 = answer_2_7;
      } else {
        tmp_0 = value_1_6;
      }
      var list_4_5 = tmp_0;
      list_4_5.add_19(element_2_3);
      Unit_getInstance();
    }
    tmp._componentsByType = tmp0_groupByTo_0_1;
    this._$component_0.onRemoved_18(this._this$0_38);
  };
  _no_name_provided__97.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__98(this$0, $componentType) {
    this._this$0_39 = this$0;
    this._$componentType = $componentType;
  }
  _no_name_provided__98.prototype.invoke_231 = function () {
    var tmp0_filter_0 = this._this$0_39._components_0;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      if (getKClassFromExpression_0(element_2_3).equals(this._$componentType)) {
        tmp0_filterTo_0_1.add_19(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    var removed = tmp0_filterTo_0_1;
    var tmp0_this = this._this$0_39;
    tmp0_this._components_0 = minus_0(tmp0_this._components_0, removed);
    this._this$0_39._componentsType = minus_1(this._this$0_39._componentsType, this._$componentType);
    var tmp = this._this$0_39;
    var tmp1_groupBy_0 = this._this$0_39._components_0;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2_0 = tmp1_groupBy_0.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var element_2_3_0 = tmp0_iterator_1_2_0.next_30();
      var key_3_4 = getKClassFromExpression_0(element_2_3_0);
      var value_1_6 = tmp0_groupByTo_0_1.get_27(key_3_4);
      var tmp_0;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_5(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp_0 = answer_2_7;
      } else {
        tmp_0 = value_1_6;
      }
      var list_4_5 = tmp_0;
      list_4_5.add_19(element_2_3_0);
      Unit_getInstance();
    }
    tmp._componentsByType = tmp0_groupByTo_0_1;
    var tmp0_iterator_1 = removed.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.onRemoved_18(this._this$0_39);
    }
  };
  _no_name_provided__98.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__99(this$0, $block) {
    this._this$0_40 = this$0;
    this._$block = $block;
  }
  _no_name_provided__99.prototype.invoke_231 = function () {
    this._this$0_40._engine_0.destroy(this._this$0_40);
    Unit_getInstance();
    this._$block();
    this._this$0_40._engine_0.add_53(this._this$0_40);
    Unit_getInstance();
  };
  _no_name_provided__99.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _get_position_(_this_) {
    return _this_.get_44(getKClass_0(Position_0));
  }
  function EntityFactory() {
  }
  EntityFactory.prototype.createFromNode$default_0 = function (node, parent, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      parent = null;
    return $handler == null ? this.createFromNode_0(node, parent) : $handler(node, parent);
  };
  EntityFactory.$metadata$ = {
    simpleName: 'EntityFactory',
    kind: 'interface',
    interfaces: []
  };
  function EntityFactoryDelegate() {
    this._templates = emptyMap();
  }
  EntityFactoryDelegate.prototype._get_engine_ = function () {
    var tmp = this._engine_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('engine');
    }
  };
  EntityFactoryDelegate.prototype._get_gameContext__32 = function () {
    var tmp = this._gameContext_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('gameContext');
    }
  };
  EntityFactoryDelegate.prototype.createText_2 = function (textEffect, font) {
    var tmp = this._get_engine_();
    var entity = tmp.create_0(_no_name_provided_$factory_78(textEffect, font, this));
    return entity;
  };
  EntityFactoryDelegate.prototype.createFromNode_0 = function (node, parent) {
    var tmp0_subject = node._type_5;
    var tmp;
    if (tmp0_subject.equals(ObjectType_ARMATURE_getInstance())) {
      tmp = this.createAnimatedModel(node);
    } else if (tmp0_subject.equals(ObjectType_BOX_getInstance())) {
      tmp = this.createBox(node);
    } else if (tmp0_subject.equals(ObjectType_CAMERA_getInstance())) {
      tmp = this.createCamera(node);
    } else if (tmp0_subject.equals(ObjectType_LIGHT_getInstance())) {
      tmp = this.createLight(node);
    } else if (tmp0_subject.equals(ObjectType_MODEL_getInstance())) {
      tmp = this.createModel(node);
    } else {
      noWhenBranchMatchedException();
    }
    var tmp0_also_0 = tmp;
    var tmp0_forEach_0_2 = node._children_2;
    var tmp0_iterator_1_3 = tmp0_forEach_0_2.iterator_52();
    while (tmp0_iterator_1_3.hasNext_27()) {
      var element_2_4 = tmp0_iterator_1_3.next_30();
      this.createFromNode_0(element_2_4, tmp0_also_0);
      Unit_getInstance();
    }
    tmp0_also_0.attachTo(parent);
    Unit_getInstance();
    return tmp0_also_0;
  };
  EntityFactoryDelegate.prototype.createBox = function (node) {
    var tmp = this._get_engine_();
    return tmp.create_0(_no_name_provided_$factory_79(node));
  };
  EntityFactoryDelegate.prototype.createText_3 = function (text, font, node) {
    return this.createText_4(new WriteText(text), font, node);
  };
  EntityFactoryDelegate.prototype.createText_4 = function (text, font, node) {
    var tmp = this._get_engine_();
    var entity = tmp.create_0(_no_name_provided_$factory_80(node, text, font, this));
    var tmp0_forEach_0 = node._children_2;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      this.createFromNode_0(element_2, entity);
      Unit_getInstance();
    }
    return entity;
  };
  EntityFactoryDelegate.prototype.createModel = function (node) {
    var tmp = this._get_engine_();
    return tmp.create_0(_no_name_provided_$factory_81(node));
  };
  EntityFactoryDelegate.prototype.createCamera = function (node) {
    var tmp = this._get_engine_();
    return tmp.create_0(_no_name_provided_$factory_82(node, this));
  };
  EntityFactoryDelegate.prototype.createAnimatedModel = function (node) {
    var tmp = this._get_engine_();
    return tmp.create_0(_no_name_provided_$factory_83(node));
  };
  EntityFactoryDelegate.prototype.createLight = function (node) {
    var tmp = this._get_engine_();
    return tmp.create_0(_no_name_provided_$factory_84(node));
  };
  EntityFactoryDelegate.prototype.registerTemplate_0 = function (name, block) {
    this._templates = plus_2(this._templates, to(name, block));
  };
  EntityFactoryDelegate.prototype.createFromTemplate_0 = function (name) {
    var tmp0_elvis_lhs = this._templates.get_27(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = '' + "No template using the name '" + name + "' has been registered. " + 'Check that this template has been registered before and that there is no spelling errors. ';
      var tmp0_ifEmpty_0 = this._templates._get_keys__5();
      var tmp_1;
      if (tmp0_ifEmpty_0.isEmpty_35()) {
        tmp_1 = setOf_0('nothing has been registered');
      } else {
        tmp_1 = tmp0_ifEmpty_0;
      }
      var tmp_2 = tmp_1;
      throw IllegalArgumentException_init_$Create$(tmp_0 + ('' + 'Actual templates are: ' + joinToString$default_0(tmp_2, ',', null, null, 0, null, null, 62, null) + '.'));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var template = tmp;
    return template();
  };
  EntityFactoryDelegate.$metadata$ = {
    simpleName: 'EntityFactoryDelegate',
    kind: 'class',
    interfaces: [EntityFactory]
  };
  function _no_name_provided_$factory_78($textEffect, $font, this$0) {
    var i = new _no_name_provided__100($textEffect, $font, this$0);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_79($node) {
    var i = new _no_name_provided__101($node);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_80($node, $text, $font, this$0) {
    var i = new _no_name_provided__102($node, $text, $font, this$0);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_81($node) {
    var i = new _no_name_provided__103($node);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_82($node, this$0) {
    var i = new _no_name_provided__104($node, this$0);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_83($node) {
    var i = new _no_name_provided__105($node);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_84($node) {
    var i = new _no_name_provided__106($node);
    return function (p1) {
      i.invoke_159(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__100($textEffect, $font, this$0) {
    this._$textEffect = $textEffect;
    this._$font = $font;
    this._this$0_41 = this$0;
  }
  _no_name_provided__100.prototype.invoke_159 = function (_this__0) {
    _this__0.named_0('text node');
    var tmp = this._this$0_41._get_gameContext__32();
    _this__0.add_22(TextComponent_init_$Create$(this._$textEffect, this._$font, tmp, null, null, null, 56, null));
    var tmp_0 = listOf_0(Primitive_init_$Create$_0(this._$font._fontSprite, null, null, null, null, null, null, null, 254, null));
    var tmp_1 = Model_init_$Create$_0(tmp_0, false, 2, null);
    _this__0.add_22(ModelComponent_init_$Create$(tmp_1, false, 2, null));
    _this__0.add_22(Companion_getInstance_16().default());
    _this__0.add_22(Position_init_$Create$_0(null, null, null, 7, null));
  };
  _no_name_provided__100.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__101($node) {
    this._$node = $node;
  }
  _no_name_provided__101.prototype.invoke_159 = function (_this__0) {
    _this__0.named_0(this._$node._name_15);
    _this__0.add_22(Companion_getInstance_16().default());
    _this__0.add_22(new Position_0(this._$node._translation_1, this._$node._rotation_2, this._$node._scale_5));
  };
  _no_name_provided__101.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__102($node, $text, $font, this$0) {
    this._$node_0 = $node;
    this._$text = $text;
    this._$font_0 = $font;
    this._this$0_42 = this$0;
  }
  _no_name_provided__102.prototype.invoke_159 = function (_this__0) {
    _this__0.named_0(this._$node_0._name_15);
    var tmp = this._this$0_42._get_gameContext__32();
    _this__0.add_22(TextComponent_init_$Create$(this._$text, this._$font_0, tmp, null, null, null, 56, null));
    var tmp_0 = listOf_0(Primitive_init_$Create$_0(this._$font_0._fontSprite, null, null, null, null, null, null, null, 254, null));
    var tmp_1 = Model_init_$Create$_0(tmp_0, false, 2, null);
    _this__0.add_22(ModelComponent_init_$Create$(tmp_1, false, 2, null));
    _this__0.add_22(Companion_getInstance_16().default());
    _this__0.add_22(new Position_0(this._$node_0._translation_1, this._$node_0._rotation_2, this._$node_0._scale_5));
  };
  _no_name_provided__102.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__103($node) {
    this._$node_1 = $node;
  }
  _no_name_provided__103.prototype.invoke_159 = function (_this__0) {
    var model = this._$node_1._get_model_();
    _this__0.named_0(this._$node_1._name_15);
    _this__0.add_22(ModelComponent_init_$Create$(model, false, 2, null));
    _this__0.add_22(new Position_0(this._$node_1._translation_1, this._$node_1._rotation_2, this._$node_1._scale_5));
    _this__0.add_22(Companion_getInstance_16().from_1(model));
  };
  _no_name_provided__103.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__104($node, this$0) {
    this._$node_2 = $node;
    this._this$0_43 = this$0;
  }
  _no_name_provided__104.prototype.invoke_159 = function (_this__0) {
    var camera = this._$node_2._get_camera__5();
    _this__0.named_0(this._$node_2._name_15);
    var tmp = this._this$0_43._get_gameContext__32()._gameScreen;
    _this__0.add_22(CameraComponent_init_$Create$(tmp, camera._type_4, camera._far_2, camera._near_2, camera._fov_1, camera._scale_4, null, 64, null));
    _this__0.add_22(new Position_0(this._$node_2._translation_1, this._$node_2._rotation_2, this._$node_2._scale_5));
  };
  _no_name_provided__104.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__105($node) {
    this._$node_3 = $node;
  }
  _no_name_provided__105.prototype.invoke_159 = function (_this__0) {
    var animatedModel = this._$node_3._get_animatedModel_();
    _this__0.named_0(this._$node_3._name_15);
    _this__0.add_22(AnimatedComponent_init_$Create$(animatedModel, null, null, 0.0, 0.0, new Long(0, 0), false, false, 254, null));
    _this__0.add_22(new Position_0(this._$node_3._translation_1, this._$node_3._rotation_2, this._$node_3._scale_5));
  };
  _no_name_provided__105.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__106($node) {
    this._$node_4 = $node;
  }
  _no_name_provided__106.prototype.invoke_159 = function (_this__0) {
    var light = this._$node_4._get_light__2();
    _this__0.named_0(this._$node_4._name_15);
    _this__0.add_22(new LightComponent(light._color_2.copy$default_0(0.0, 0.0, 0.0, 0.0, 15, null), light._intensity_1));
    _this__0.add_22(new Position_0(this._$node_4._translation_1, this._$node_4._rotation_2, this._$node_4._scale_5));
  };
  _no_name_provided__106.prototype.invoke_276 = function (p1) {
    this.invoke_159((!(p1 == null) ? isInterface(p1, EntityBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Event_0() {
  }
  Event_0.$metadata$ = {
    simpleName: 'Event',
    kind: 'interface',
    interfaces: []
  };
  function EventListener_0() {
  }
  EventListener_0.$metadata$ = {
    simpleName: 'EventListener',
    kind: 'interface',
    interfaces: []
  };
  function EventQueue() {
    var tmp = EntityQuery_init_$Create$(null, null, 3, null);
    System_init_$Init$(tmp, null, 2, null, this);
    var tmp_0 = this;
    tmp_0._listeners = ArrayList_init_$Create$();
  }
  EventQueue.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  EventQueue.prototype.update_62 = function (delta_0) {
    var tmp0_safe_receiver = this.consumeEvents_25();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp0_iterator_1 = tmp0_safe_receiver.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        var tmp0_forEach_0_4 = this._listeners;
        var tmp0_iterator_1_5 = tmp0_forEach_0_4.iterator_52();
        while (tmp0_iterator_1_5.hasNext_27()) {
          var element_2_6 = tmp0_iterator_1_5.next_30();
          element_2_6.onEvent_26(element_2._event, element_2._entityQuery);
        }
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  EventQueue.prototype.register_0 = function (listener) {
    this._listeners.add_19(listener);
    Unit_getInstance();
  };
  EventQueue.$metadata$ = {
    simpleName: 'EventQueue',
    kind: 'class',
    interfaces: []
  };
  function EventWithQuery(event, entityQuery) {
    this._event = event;
    this._entityQuery = entityQuery;
  }
  EventWithQuery.$metadata$ = {
    simpleName: 'EventWithQuery',
    kind: 'class',
    interfaces: []
  };
  function NoEvent() {
  }
  NoEvent.$metadata$ = {
    simpleName: 'NoEvent',
    kind: 'class',
    interfaces: [Event_0]
  };
  function EventWithQueryObjectPool() {
    ObjectPool.call(this, 10);
  }
  EventWithQueryObjectPool.prototype.newInstance_1 = function () {
    return new EventWithQuery(Companion_getInstance_21()._NO_EVENT, null);
  };
  EventWithQueryObjectPool.prototype.destroyInstance = function (obj) {
    obj._event = Companion_getInstance_21()._NO_EVENT;
    obj._entityQuery = null;
  };
  EventWithQueryObjectPool.prototype.destroyInstance_3 = function (obj) {
    return this.destroyInstance(obj instanceof EventWithQuery ? obj : THROW_CCE());
  };
  EventWithQueryObjectPool.$metadata$ = {
    simpleName: 'EventWithQueryObjectPool',
    kind: 'class',
    interfaces: []
  };
  function Companion_22() {
    Companion_instance_21 = this;
    this._NO_EVENT = new NoEvent();
    this._objectPool = new EventWithQueryObjectPool();
  }
  Companion_22.prototype.of = function (event, entityQuery) {
    var tmp0_apply_0 = this._objectPool.obtain_0();
    tmp0_apply_0._event = event;
    tmp0_apply_0._entityQuery = entityQuery;
    return tmp0_apply_0;
  };
  Companion_22.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_22();
    return Companion_instance_21;
  }
  function AABBCollisionResolver() {
  }
  AABBCollisionResolver.prototype.collide_2 = function (boxA, boxB) {
    var minXA = boxA._get_min_()._get_x_();
    var maxXA = boxA._get_max_()._get_x_();
    var minYA = boxA._get_min_()._get_y_();
    var maxYA = boxA._get_max_()._get_y_();
    var minZA = boxA._get_min_()._get_z_();
    var maxZA = boxA._get_max_()._get_z_();
    var minXB = boxB._get_min_()._get_x_();
    var maxXB = boxB._get_max_()._get_x_();
    var minYB = boxB._get_min_()._get_y_();
    var maxYB = boxB._get_max_()._get_y_();
    var minZB = boxB._get_min_()._get_z_();
    var maxZB = boxB._get_max_()._get_z_();
    var xCollide = minXA < maxXB ? maxXA > minXB : false;
    var yCollide = minYA < maxYB ? maxYA > minYB : false;
    var zCollide = minZA < maxZB ? maxZA > minZB : false;
    return (xCollide ? yCollide : false) ? zCollide : false;
  };
  AABBCollisionResolver.$metadata$ = {
    simpleName: 'AABBCollisionResolver',
    kind: 'class',
    interfaces: [CollisionResolver]
  };
  function CollisionResolver() {
  }
  CollisionResolver.prototype.collide_1 = function (entityA, entityB) {
    var boxA = entityA.get_44(getKClass_0(BoundingBoxComponent));
    var boxB = entityB.get_44(getKClass_0(BoundingBoxComponent));
    return this.collide_2(boxA, boxB);
  };
  CollisionResolver.$metadata$ = {
    simpleName: 'CollisionResolver',
    kind: 'interface',
    interfaces: []
  };
  function ScriptContext() {
  }
  ScriptContext.$metadata$ = {
    simpleName: 'ScriptContext',
    kind: 'interface',
    interfaces: []
  };
  function ArmatureUpdateSystem() {
    var tmp = EntityQuery_init_$Create$_0([getKClass_0(AnimatedComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  ArmatureUpdateSystem.prototype.update_61 = function (delta_0, entity) {
    var tmp0_forEach_0 = entity.findAll_0(getKClass_0(AnimatedComponent));
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_this_4 = element_2;
        tmp0_this_4._time_0 = tmp0_this_4._time_0 + delta_0;
        if (element_2._time_0 > element_2._duration_2) {
          element_2._time_0 = 0.0;
          var tmp1_this_5 = element_2;
          var tmp2_6 = tmp1_this_5._loop;
          tmp1_this_5._loop = tmp2_6.inc_4();
          Unit_getInstance();
        }var tmp$ret$0;
        l$ret$1: do {
          var tmp0_lastOrNull_0_10 = element_2._currentAnimation;
          var iterator_1_11 = tmp0_lastOrNull_0_10.listIterator_5(tmp0_lastOrNull_0_10._get_size__32());
          while (iterator_1_11.hasPrevious_2()) {
            var element_2_12 = iterator_1_11.previous_2();
            if (element_2_12._time <= element_2._time_0) {
              tmp$ret$0 = element_2_12;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = null;
        }
         while (false);
        var tmp3_elvis_lhs_9 = tmp$ret$0;
        var tmp4_elvis_lhs_8 = tmp3_elvis_lhs_9 == null ? firstOrNull(element_2._currentAnimation) : tmp3_elvis_lhs_9;
        var tmp;
        if (tmp4_elvis_lhs_8 == null) {
          tmp$ret$2 = Unit_getInstance();
          break l$ret$3;
        } else {
          tmp = tmp4_elvis_lhs_8;
        }
        var currentFrame_7 = tmp;
        var tmp1_forEach_0_13 = _get_indices_(element_2._animatedModel._referencePose._joints);
        var inductionVariable = tmp1_forEach_0_13._get_first__2();
        var last_2 = tmp1_forEach_0_13._get_last__4();
        if (inductionVariable <= last_2)
          do {
            var element_2_15 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var globalTransformation_4_16 = currentFrame_7._globalTransformations[element_2_15];
            var inverseGlobalTransformation_5_17 = element_2._animatedModel._referencePose._joints[element_2_15]._inverseGlobalTransformation;
            element_2._currentPose[element_2_15] = toMat4(globalTransformation_4_16).times_0(toMat4(inverseGlobalTransformation_5_17));
          }
           while (!(element_2_15 === last_2));
      }
       while (false);
    }
  };
  ArmatureUpdateSystem.$metadata$ = {
    simpleName: 'ArmatureUpdateSystem',
    kind: 'class',
    interfaces: []
  };
  function CameraTrackSystem() {
    var tmp = EntityQuery_init_$Create$_0([getKClass_0(CameraComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  CameraTrackSystem.prototype.update_61 = function (delta_0, entity) {
    var tmp0_safe_receiver = entity.get_44(getKClass_0(CameraComponent))._lookAt;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var targetPosition_2 = tmp0_safe_receiver.get_44(getKClass_0(Position_0))._get_translation_();
      var cameraPosition_3 = entity.get_44(getKClass_0(Position_0))._get_translation_();
      var rotation_4 = lookAt(cameraPosition_3.toFloat3_0(), targetPosition_2.toFloat3_0(), Companion_getInstance_22()._UP);
      entity.get_44(getKClass_0(Position_0)).setLocalRotation(Companion_getInstance_11().from_0(rotation_4));
    }
    Unit_getInstance();
  };
  CameraTrackSystem.$metadata$ = {
    simpleName: 'CameraTrackSystem',
    kind: 'class',
    interfaces: []
  };
  function Companion_23() {
    Companion_instance_22 = this;
    this._UP = new Float3(0.0, -1.0, 0.0);
  }
  Companion_23.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_23();
    return Companion_instance_22;
  }
  function EntityQuery(include, exclude) {
    this._include = include;
    this._exclude = exclude;
  }
  EntityQuery.prototype.accept = function (entity) {
    var tmp;
    var tmp0_isNotEmpty_0 = this._exclude;
    if (!tmp0_isNotEmpty_0.isEmpty_35()) {
      tmp = entity._componentsType.containsAll_26(this._exclude);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      return false;
    } else {
    }
    if (equals_1(this, Companion_getInstance_23()._all)) {
      return true;
    }if (equals_1(this, Companion_getInstance_23()._none_0)) {
      return false;
    }return entity._componentsType.containsAll_26(this._include);
  };
  EntityQuery.$metadata$ = {
    simpleName: 'EntityQuery',
    kind: 'class',
    interfaces: []
  };
  function EntityQuery_init_$Init$(include, exclude, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      include = emptyList();
    if (!(($mask0 & 2) === 0))
      exclude = emptyList();
    EntityQuery.call($this, include, exclude);
    return $this;
  }
  function EntityQuery_init_$Create$(include, exclude, $mask0, $marker) {
    return EntityQuery_init_$Init$(include, exclude, $mask0, $marker, Object.create(EntityQuery.prototype));
  }
  function EntityQuery_init_$Init$_0(include, $this) {
    EntityQuery.call($this, toList(include), emptyList());
    return $this;
  }
  function EntityQuery_init_$Create$_0(include) {
    return EntityQuery_init_$Init$_0(include, Object.create(EntityQuery.prototype));
  }
  function Companion_24() {
    Companion_instance_23 = this;
    var tmp = this;
    tmp._all = EntityQuery_init_$Create$(null, null, 3, null);
    var tmp_0 = this;
    tmp_0._none_0 = EntityQuery_init_$Create$(null, null, 3, null);
  }
  Companion_24.prototype.none = function () {
    return this._none_0;
  };
  Companion_24.prototype.of_0 = function (include) {
    var tmp = toList(include);
    return EntityQuery_init_$Create$(tmp, null, 2, null);
  };
  Companion_24.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_24();
    return Companion_instance_23;
  }
  function ParticlesEmitterSystem() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(ParticleEmitterComponent), getKClass_0(ParticleEmitterActiveComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  ParticlesEmitterSystem.prototype.update_61 = function (delta_0, entity) {
    var active = entity.get_44(getKClass_0(ParticleEmitterActiveComponent));
    var tmp0_this = active._current;
    tmp0_this._duration_3 = tmp0_this._duration_3 - delta_0;
    if (active._current._duration_3 < 0.0) {
      var tmp1_subject = active._current._time_1;
      if (tmp1_subject.equals(new Long(-1, -1)))
        active.reset_2();
      else if (tmp1_subject.equals(new Long(0, 0))) {
        entity.remove_33(getKClass_0(ParticleEmitterActiveComponent));
        Unit_getInstance();
      } else {
        var tmp2_this = active._current;
        var tmp3 = tmp2_this._time_1;
        tmp2_this._time_1 = tmp3.dec_4();
        Unit_getInstance();
      }
    }var progress = active._current._duration_3 / active._base.duration__error;
    var particles = active._base.emitter__error(entity, progress);
    var tmp0_apply_0 = new ParticleGeneration(entity);
    tmp0_apply_0._emmiterProgress = progress;
    tmp0_apply_0._particlesTotal = particles;
    var generation = tmp0_apply_0;
    var tmp1_forEach_0 = until_0(0, particles);
    var inductionVariable = tmp1_forEach_0._get_first__2();
    var last_2 = tmp1_forEach_0._get_last__4();
    var step = new Long(1, 0);
    if (inductionVariable.compareTo_48(last_2) <= 0)
      do {
        var element_2 = inductionVariable;
        inductionVariable = inductionVariable.plus_45(step);
        var tmp0_minus_0_6 = 1;
        var tmp1_div_0_5 = particles.minus_28(toLong_0(tmp0_minus_0_6)).toFloat_4();
        var creationProgress_4 = element_2.toFloat_4() / tmp1_div_0_5;
        generation._particlesIndex = element_2;
        generation._particlesIndexPercent = creationProgress_4;
        var component_7 = ParticleComponent_init_$Create$(active._base, 0.0, null, null, null, 30, null);
        var particle_8 = active._base.factory__error(entity, generation);
        active._base.particle__error(component_7, generation);
        _get_position_(particle_8).setGlobalTranslation_0(_get_position_(entity)._get_translation_());
        Unit_getInstance();
        particle_8.add_23(component_7);
        Unit_getInstance();
      }
       while (!element_2.equals(last_2));
  };
  ParticlesEmitterSystem.$metadata$ = {
    simpleName: 'ParticlesEmitterSystem',
    kind: 'class',
    interfaces: []
  };
  function ParticlesUpdateSystem() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(ParticleComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  ParticlesUpdateSystem.prototype.update_61 = function (delta_0, entity) {
    var particleComponent = entity.get_44(getKClass_0(ParticleComponent));
    var tmp0_this = particleComponent;
    tmp0_this._ttl = tmp0_this._ttl - delta_0;
    if (particleComponent._ttl < 0.0) {
      entity.destroy_31();
      Unit_getInstance();
      return Unit_getInstance();
    }var configuration = particleComponent._configuration_2;
    configuration.update__error(delta_0, entity);
  };
  ParticlesUpdateSystem.$metadata$ = {
    simpleName: 'ParticlesUpdateSystem',
    kind: 'class',
    interfaces: []
  };
  function ScriptExecutorSystem() {
    var tmp = EntityQuery_init_$Create$_0([getKClass_0(ScriptComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
    this._context_1 = emptyList();
    var tmp_0 = this;
    tmp_0._lock = Mutex$default(false, 1, null);
    var tmp_1 = this;
    tmp_1._toRemoveComponents = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._events = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3._mainThread = ArrayList_init_$Create$();
  }
  ScriptExecutorSystem.prototype.onEntityAdded_25 = function (entity) {
    var tmp0_forEach_0 = entity.findAll_0(getKClass_0(ScriptComponent));
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var scriptContext_4 = new MutexScriptContext(this);
      this._context_1 = plus_0(this._context_1, scriptContext_4);
      var tmp = GlobalScope_getInstance();
      launch$default(tmp, null, null, _no_name_provided_$factory_85(element_2, scriptContext_4, this, entity, null), 3, null);
      Unit_getInstance();
    }
  };
  ScriptExecutorSystem.prototype.update_62 = function (delta_0) {
    var tmp0_forEach_0 = this._context_1;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2._delta = delta_0;
      if (element_2._mutex._get_isLocked__0()) {
        element_2._mutex.unlock$default_0(null, 1, null);
      }}
    execute(this._mainThread, this, _no_name_provided_$factory_86());
    execute(this._events, this, _no_name_provided_$factory_87(this));
    execute(this._toRemoveComponents, this, _no_name_provided_$factory_88());
  };
  ScriptExecutorSystem.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  ScriptExecutorSystem.$metadata$ = {
    simpleName: 'ScriptExecutorSystem',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_85($element_2, $scriptContext_4, this$0, $entity, resultContinuation) {
    var i = new _no_name_provided__107($element_2, $scriptContext_4, this$0, $entity, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_161(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_86() {
    var i = new _no_name_provided__108();
    return function (p1) {
      i.invoke_163(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_87(this$0) {
    var i = new _no_name_provided__109(this$0);
    return function (p1) {
      i.invoke_165(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_88() {
    var i = new _no_name_provided__110();
    return function (p1) {
      i.invoke_167(p1);
      return Unit_getInstance();
    };
  }
  function MutexScriptContext($outer) {
    this._$this_11 = $outer;
    var tmp = this;
    tmp._mutex = Mutex$default(false, 1, null);
    this._delta = 0.0;
  }
  MutexScriptContext.$metadata$ = {
    simpleName: 'MutexScriptContext',
    kind: 'class',
    interfaces: [ScriptContext]
  };
  function execute(_this_, $this, block) {
    var tmp0_iterator_1 = _this_.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      block(element_2);
    }
    _this_.clear_15();
  }
  function _no_name_provided__107($element_2, $scriptContext_4, this$0, $entity, resultContinuation) {
    this._$element_2 = $element_2;
    this._$scriptContext_4 = $scriptContext_4;
    this._this$0_44 = this$0;
    this._$entity = $entity;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__107.prototype.invoke_161 = function (_this__0, $cont) {
    var tmp = this.create_1(_this__0, $cont);
    tmp._result = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_3();
  };
  _no_name_provided__107.prototype.invoke_276 = function (p1, $cont) {
    this.invoke_161((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__107.prototype.doResume_3 = function () {
    var suspendResult = this._result;
    $sm: do
      try {
        var tmp = this._state_2;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._state_2 = 1;
            suspendResult = this._$element_2.execute(this._$scriptContext_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._this$0_44._context_1 = minus(this._this$0_44._context_1, this._$scriptContext_4);
            this._state_2 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0._tmp0_withLock_0_61 = this._this$0_44._lock;
            var tmp_1 = this;
            tmp_1._tmp1_withLock_0_72 = null;
            this._state_2 = 3;
            suspendResult = this._tmp0_withLock_0_61.lock_0(this._tmp1_withLock_0_72, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            var tmp$ret$2;
            this._state_2 = 4;
            continue $sm;
          case 4:
            var tmp$ret$0;
            this._state_2 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 6;
            this._this$0_44._toRemoveComponents.add_19(to(this._$element_2, this._$entity));
            tmp$ret$0 = Unit_getInstance();
            this._exceptionState = 10;
            this._state_2 = 7;
            continue $sm;
          case 6:
            this._exceptionState = 10;
            var t = this._exception_0;
            this._tmp0_withLock_0_61.unlock_0(this._tmp1_withLock_0_72);
            throw t;
          case 7:
            var tmp_2 = this;
            tmp_2._tmp$ret$40 = this._tmp0_withLock_0_61.unlock_0(this._tmp1_withLock_0_72);
            this._state_2 = 9;
            continue $sm;
          case 8:
            this._tmp0_withLock_0_61.unlock_0(this._tmp1_withLock_0_72);
            if (false) {
              this._state_2 = 2;
              continue $sm;
            }
            this._state_2 = 9;
            continue $sm;
          case 9:
            return Unit_getInstance();
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_2 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__107.prototype.create_1 = function (_this__0, completion) {
    var i = new _no_name_provided__107(this._$element_2, this._$scriptContext_4, this._this$0_44, this._$entity, completion);
    i.__this__0 = _this__0;
    return i;
  };
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__108() {
  }
  _no_name_provided__108.prototype.invoke_163 = function (it) {
    it();
  };
  _no_name_provided__108.prototype.invoke_276 = function (p1) {
    this.invoke_163((!(p1 == null) ? typeof p1 === 'function' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__109(this$0) {
    this._this$0_45 = this$0;
  }
  _no_name_provided__109.prototype.invoke_165 = function (_name_for_destructuring_parameter_0_) {
    var event = _name_for_destructuring_parameter_0_.component1();
    var query = _name_for_destructuring_parameter_0_.component2();
    this._this$0_45.emit_56(event, query);
  };
  _no_name_provided__109.prototype.invoke_276 = function (p1) {
    this.invoke_165(p1 instanceof Pair ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__110() {
  }
  _no_name_provided__110.prototype.invoke_167 = function (_name_for_destructuring_parameter_0_) {
    var component = _name_for_destructuring_parameter_0_.component1();
    var entity = _name_for_destructuring_parameter_0_.component2();
    entity.remove_32(component);
    Unit_getInstance();
  };
  _no_name_provided__110.prototype.invoke_276 = function (p1) {
    this.invoke_167(p1 instanceof Pair ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SpriteAnimatedSystem() {
    var tmp = EntityQuery_init_$Create$_0([getKClass_0(SpriteComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  SpriteAnimatedSystem.prototype.update_61 = function (delta_0, entity) {
    var sprite = entity.get_44(getKClass_0(SpriteComponent));
    var spritePrimitive = entity.get_44(getKClass_0(ModelComponent));
    var tmp0_elvis_lhs = sprite._currentAnimation_0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentAnimation = tmp;
    var tmp1_this = sprite;
    tmp1_this._frameDuration = tmp1_this._frameDuration - delta_0;
    if (sprite._frameDuration <= 0.0) {
      sprite._currentFrame = advanceToNextFrame(this, sprite._currentFrame, currentAnimation);
      var frame = currentAnimation._frames_0.get_57(sprite._currentFrame);
      sprite._frameDuration = frame._duration_1;
      if (sprite._uvs_2._get_size__32() < (frame._uvIndex + 3 | 0)) {
        return Unit_getInstance();
      }var a = sprite._uvs_2.get_57(frame._uvIndex);
      var b = sprite._uvs_2.get_57(frame._uvIndex + 1 | 0);
      var c = sprite._uvs_2.get_57(frame._uvIndex + 2 | 0);
      var d = sprite._uvs_2.get_57(frame._uvIndex + 3 | 0);
      var tmp_0 = first(spritePrimitive._model._primitives_0);
      var tmp0_floatArrayOf_0 = new Float32Array([a._x_6, a._y_6, d._x_6, d._y_6, b._x_6, b._y_6, c._x_6, c._y_6]);
      tmp_0._set_uvs_(tmp0_floatArrayOf_0);
      this._get_gameContext__32()._assetsManager.add_35(spritePrimitive._model);
    }};
  SpriteAnimatedSystem.$metadata$ = {
    simpleName: 'SpriteAnimatedSystem',
    kind: 'class',
    interfaces: []
  };
  function advanceToNextFrame($this, currentFrame, animation) {
    var nextFrame = currentFrame + 1 | 0;
    if (nextFrame >= animation._frames_0._get_size__32()) {
      nextFrame = 0;
    }return nextFrame;
  }
  function System(entityQuery, gameContext) {
    this._entityQuery_0 = entityQuery;
    this._entities = emptyList();
    this._listeners_0 = emptyList();
    var tmp = this;
    tmp._events_0 = ArrayList_init_$Create$();
    this._storyboardEvent_0 = null;
    var tmp_0 = this;
    var tmp_1 = LazyThreadSafetyMode_NONE_getInstance();
    tmp_0._logger$delegate = lazy_0(tmp_1, _no_name_provided_$factory_89(gameContext, this));
    var tmp_2 = this;
    var tmp_3 = LazyThreadSafetyMode_NONE_getInstance();
    tmp_2._input$delegate = lazy_0(tmp_3, _no_name_provided_$factory_90(gameContext, this));
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_NONE_getInstance();
    tmp_4._gameContext$delegate = lazy_0(tmp_5, _no_name_provided_$factory_91(gameContext, this));
  }
  System.prototype._get_entities__3 = function () {
    return this._entities;
  };
  System.prototype._get_entityFactory__25 = function () {
    var tmp = this._entityFactory_0;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('entityFactory');
    }
  };
  System.prototype._get_input__25 = function () {
    var tmp0_getValue_0 = this._input$delegate;
    var tmp1_getValue_0 = input$factory();
    return tmp0_getValue_0._get_value__12();
  };
  System.prototype._get_gameContext__32 = function () {
    var tmp0_getValue_0 = this._gameContext$delegate;
    var tmp1_getValue_0 = gameContext$factory();
    return tmp0_getValue_0._get_value__12();
  };
  System.prototype.onGameStarted_25 = function (engine) {
    return Unit_getInstance();
  };
  System.prototype.onEntityAdded_25 = function (entity) {
    return Unit_getInstance();
  };
  System.prototype.onEntityRemoved_25 = function (entity) {
    return Unit_getInstance();
  };
  System.prototype.update_62 = function (delta_0) {
    var tmp0_forEach_0 = this._entities;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      this.update_61(delta_0, element_2);
    }
  };
  System.prototype.add_53 = function (entity) {
    var tmp0_forEach_0 = this._listeners_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.add_32(entity);
    }
    var tmp;
    if (this._entityQuery_0.accept(entity)) {
      this._entities = plus_0(this._entities, entity);
      this.onEntityAdded_25(entity);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  System.prototype.remove_61 = function (entity) {
    var tmp0_forEach_0 = this._listeners_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.remove_42(entity);
    }
    var tmp;
    if (this._entityQuery_0.accept(entity)) {
      var tmp1_count_0 = this._entities;
      var count = tmp1_count_0._get_size__32();
      this._entities = minus(this._entities, entity);
      var tmp2_count_0 = this._entities;
      var wasRemoved = !(count === tmp2_count_0._get_size__32());
      if (wasRemoved) {
        this.onEntityRemoved_25(entity);
      }return wasRemoved;
    } else {
      tmp = false;
    }
    return tmp;
  };
  System.prototype.destroy_31 = function () {
    var tmp0_forEach_0 = this._listeners_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.destroy_10();
    }
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_map_0 = this._entities;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
      var tmp0_iterator_1_2 = tmp1_map_0.iterator_52();
      while (tmp0_iterator_1_2.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2.next_30();
        tmp0_mapTo_0_1.add_19(this.remove_61(item_2_3));
        Unit_getInstance();
      }
      var tmp2_any_0 = tmp0_mapTo_0_1;
      var tmp;
      if (isInterface(tmp2_any_0, Collection)) {
        tmp = tmp2_any_0.isEmpty_35();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1_0 = tmp2_any_0.iterator_52();
      while (tmp0_iterator_1_0.hasNext_27()) {
        var element_2_0 = tmp0_iterator_1_0.next_30();
        if (element_2_0) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  System.prototype.onEvent_26 = function (event, entityQuery) {
    return Unit_getInstance();
  };
  System.prototype.emit_56 = function (event, target) {
    return this.emit_57(Companion_getInstance_21().of(event, target));
  };
  System.prototype.emit$default_25 = function (event, target, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      target = null;
    return this.emit_56(event, target);
  };
  System.prototype.emit_54 = function (storyboardEvent) {
    var tmp0_safe_receiver = this._storyboardEvent_0;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw IllegalStateException_init_$Create$('' + "A Storyboard event has already been emitted ('" + getKClassFromExpression_0(tmp0_safe_receiver)._get_simpleName__4() + "') " + ('' + 'by the system ' + getKClassFromExpression_0(this)._get_simpleName__4() + '. ') + 'Only one event can be emitted at a time. ' + ('' + "This new event ('" + getKClassFromExpression_0(storyboardEvent)._get_simpleName__4() + "') should not be emitted."));
    }
    Unit_getInstance();
    this._storyboardEvent_0 = storyboardEvent;
  };
  System.prototype.emit_16 = function (events) {
    addAll(this._events_0, events);
    Unit_getInstance();
  };
  System.prototype.emit_57 = function (event) {
    this._events_0.add_19(event);
    Unit_getInstance();
  };
  System.prototype.consumeEvents_25 = function () {
    var tmp;
    if (this._events_0.isEmpty_35()) {
      tmp = null;
    } else {
      var tmp0_also_0 = toList_1(this._events_0);
      this._events_0.clear_15();
      tmp = tmp0_also_0;
    }
    return tmp;
  };
  System.prototype.interested = function (query) {
    var delegate = new InterestedDelegate(query);
    this._listeners_0 = plus_0(this._listeners_0, delegate);
    return delegate;
  };
  System.$metadata$ = {
    simpleName: 'System',
    kind: 'class',
    interfaces: [EventListener_0]
  };
  function input$factory() {
    return getPropertyCallableRef('input', 1, KProperty1, function (receiver) {
      return receiver._get_input__25();
    }, null);
  }
  function gameContext$factory() {
    return getPropertyCallableRef('gameContext', 1, KProperty1, function (receiver) {
      return receiver._get_gameContext__32();
    }, null);
  }
  function _no_name_provided_$factory_89($gameContext, this$0) {
    var i = new _no_name_provided__111($gameContext, this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_90($gameContext, this$0) {
    var i = new _no_name_provided__112($gameContext, this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_91($gameContext, this$0) {
    var i = new _no_name_provided__113($gameContext, this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function System_init_$Init$(entityQuery, gameContext, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      entityQuery = Companion_getInstance_23().none();
    if (!(($mask0 & 2) === 0))
      gameContext = null;
    System.call($this, entityQuery, gameContext);
    return $this;
  }
  function InterestedDelegate(query) {
    this._query = query;
    var tmp = this;
    tmp._entities_0 = ArrayList_init_$Create$();
  }
  InterestedDelegate.prototype.add_32 = function (entity) {
    if (this._query.accept(entity)) {
      this._entities_0.add_19(entity);
      Unit_getInstance();
    }};
  InterestedDelegate.prototype.remove_42 = function (entity) {
    if (this._query.accept(entity)) {
      this._entities_0.remove_16(entity);
      Unit_getInstance();
    }};
  InterestedDelegate.prototype.destroy_10 = function () {
    this._entities_0.clear_15();
  };
  InterestedDelegate.prototype.getValue_5 = function (thisRef, property) {
    return this._entities_0;
  };
  InterestedDelegate.$metadata$ = {
    simpleName: 'InterestedDelegate',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__111($gameContext, this$0) {
    this._$gameContext = $gameContext;
    this._this$0_46 = this$0;
  }
  _no_name_provided__111.prototype.invoke_274 = function () {
    var tmp0_safe_receiver = this._$gameContext;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._logger;
    return tmp1_elvis_lhs == null ? this._this$0_46._get_entityFactory__25()._get_gameContext__32()._logger : tmp1_elvis_lhs;
  };
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__112($gameContext, this$0) {
    this._$gameContext_0 = $gameContext;
    this._this$0_47 = this$0;
  }
  _no_name_provided__112.prototype.invoke_274 = function () {
    var tmp0_safe_receiver = this._$gameContext_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._input_1;
    return tmp1_elvis_lhs == null ? this._this$0_47._get_entityFactory__25()._get_gameContext__32()._input_1 : tmp1_elvis_lhs;
  };
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__113($gameContext, this$0) {
    this._$gameContext_1 = $gameContext;
    this._this$0_48 = this$0;
  }
  _no_name_provided__113.prototype.invoke_274 = function () {
    var tmp0_elvis_lhs = this._$gameContext_1;
    return tmp0_elvis_lhs == null ? this._this$0_48._get_entityFactory__25()._get_gameContext__32() : tmp0_elvis_lhs;
  };
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TemporalSystem(frequency, query) {
    System_init_$Init$(query, null, 2, null, this);
    this._frequency = frequency;
    this._timer = this._frequency;
  }
  TemporalSystem.prototype.update_62 = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._timer = tmp0_this._timer - delta_0;
    if (this._timer < 0) {
      var tmp1_this = this;
      tmp1_this._timer = tmp1_this._timer + this._frequency;
      this.timeElapsed_2();
      System.prototype.update_62.call(this, delta_0);
    }};
  TemporalSystem.$metadata$ = {
    simpleName: 'TemporalSystem',
    kind: 'class',
    interfaces: []
  };
  function TemporalSystem_init_$Init$(frequency, query, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      query = EntityQuery_init_$Create$(null, null, 3, null);
    }TemporalSystem.call($this, frequency, query);
    return $this;
  }
  function TextEffectSystem() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(TextComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  TextEffectSystem.prototype.update_61 = function (delta_0, entity) {
    var tmp0_forEach_0 = entity.findAll_0(getKClass_0(TextComponent));
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.update_62(delta_0);
    }
  };
  TextEffectSystem.$metadata$ = {
    simpleName: 'TextEffectSystem',
    kind: 'class',
    interfaces: []
  };
  function AngelCode(info, characters) {
    this._info = info;
    this._characters = characters;
  }
  AngelCode.$metadata$ = {
    simpleName: 'AngelCode',
    kind: 'class',
    interfaces: []
  };
  function FontInfo(face, size_0, lineHeight, base, pages, fontFile, charsCount) {
    this._face = face;
    this._size_4 = size_0;
    this._lineHeight = lineHeight;
    this._base_0 = base;
    this._pages = pages;
    this._fontFile = fontFile;
    this._charsCount = charsCount;
  }
  FontInfo.prototype.toString = function () {
    return '' + 'FontInfo(face=' + this._face + ', size=' + this._size_4 + ', lineHeight=' + this._lineHeight + ', base=' + this._base_0 + ', pages=' + this._pages + ', fontFile=' + this._fontFile + ', charsCount=' + this._charsCount + ')';
  };
  FontInfo.prototype.hashCode = function () {
    var result = getStringHashCode(this._face);
    result = imul(result, 31) + this._size_4 | 0;
    result = imul(result, 31) + this._lineHeight | 0;
    result = imul(result, 31) + this._base_0 | 0;
    result = imul(result, 31) + this._pages | 0;
    result = imul(result, 31) + getStringHashCode(this._fontFile) | 0;
    result = imul(result, 31) + this._charsCount | 0;
    return result;
  };
  FontInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FontInfo ? other : THROW_CCE();
    if (!(this._face === tmp0_other_with_cast._face))
      return false;
    if (!(this._size_4 === tmp0_other_with_cast._size_4))
      return false;
    if (!(this._lineHeight === tmp0_other_with_cast._lineHeight))
      return false;
    if (!(this._base_0 === tmp0_other_with_cast._base_0))
      return false;
    if (!(this._pages === tmp0_other_with_cast._pages))
      return false;
    if (!(this._fontFile === tmp0_other_with_cast._fontFile))
      return false;
    if (!(this._charsCount === tmp0_other_with_cast._charsCount))
      return false;
    return true;
  };
  FontInfo.$metadata$ = {
    simpleName: 'FontInfo',
    kind: 'class',
    interfaces: []
  };
  function AngelCharacter(id, x, y, width, height, xoffset, yoffset, xadvance) {
    this._id_9 = id;
    this._x_9 = x;
    this._y_9 = y;
    this._width_4 = width;
    this._height_5 = height;
    this._xoffset = xoffset;
    this._yoffset = yoffset;
    this._xadvance = xadvance;
  }
  AngelCharacter.prototype.toString = function () {
    return '' + 'AngelCharacter(id=' + this._id_9 + ', x=' + this._x_9 + ', y=' + this._y_9 + ', width=' + this._width_4 + ', height=' + this._height_5 + ', xoffset=' + this._xoffset + ', yoffset=' + this._yoffset + ', xadvance=' + this._xadvance + ')';
  };
  AngelCharacter.prototype.hashCode = function () {
    var result = this._id_9.hashCode();
    result = imul(result, 31) + this._x_9 | 0;
    result = imul(result, 31) + this._y_9 | 0;
    result = imul(result, 31) + this._width_4 | 0;
    result = imul(result, 31) + this._height_5 | 0;
    result = imul(result, 31) + this._xoffset | 0;
    result = imul(result, 31) + this._yoffset | 0;
    result = imul(result, 31) + this._xadvance | 0;
    return result;
  };
  AngelCharacter.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AngelCharacter))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AngelCharacter ? other : THROW_CCE();
    if (!this._id_9.equals(tmp0_other_with_cast._id_9))
      return false;
    if (!(this._x_9 === tmp0_other_with_cast._x_9))
      return false;
    if (!(this._y_9 === tmp0_other_with_cast._y_9))
      return false;
    if (!(this._width_4 === tmp0_other_with_cast._width_4))
      return false;
    if (!(this._height_5 === tmp0_other_with_cast._height_5))
      return false;
    if (!(this._xoffset === tmp0_other_with_cast._xoffset))
      return false;
    if (!(this._yoffset === tmp0_other_with_cast._yoffset))
      return false;
    if (!(this._xadvance === tmp0_other_with_cast._xadvance))
      return false;
    return true;
  };
  AngelCharacter.$metadata$ = {
    simpleName: 'AngelCharacter',
    kind: 'class',
    interfaces: []
  };
  function AngelCodeLoader() {
  }
  AngelCodeLoader.prototype.load_11 = function (filename, handler) {
    var tmp = handler.read_4(filename);
    return tmp.map_0(_no_name_provided_$factory_92(this));
  };
  AngelCodeLoader.$metadata$ = {
    simpleName: 'AngelCodeLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function _no_name_provided_$factory_92(this$0) {
    var i = new _no_name_provided__114(this$0);
    return function (p1) {
      return i.invoke_172(p1);
    };
  }
  function asMap(_this_, $this) {
    var tmp = [' '];
    var tmp0_filter_0 = drop(split$default(_this_, tmp, false, 0, 6, null), 1);
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      if (!isBlank(element_2_3)) {
        tmp0_filterTo_0_1.add_19(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    var tmp1_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_30();
      var tmp_0 = ['='];
      var tmp0_container_5 = split$default(item_2_3, tmp_0, false, 0, 6, null);
      var key_6 = tmp0_container_5.get_57(0);
      var value_7 = tmp0_container_5.get_57(1);
      tmp0_mapTo_0_1.add_19(to(key_6, value_7));
      Unit_getInstance();
    }
    return toMap(tmp0_mapTo_0_1);
  }
  function _no_name_provided__114(this$0) {
    this._this$0_49 = this$0;
  }
  _no_name_provided__114.prototype.invoke_172 = function (it) {
    var tmp0_toRegex_0 = '\r\n|\n|\r';
    var tmp1_split_0 = Regex_init_$Create$(tmp0_toRegex_0);
    var tmp2_split_0 = 0;
    var tmp3_filter_0 = tmp1_split_0.split(it, tmp2_split_0);
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp3_filter_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      if (!isBlank(element_2_3)) {
        tmp0_filterTo_0_1.add_19(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    var tmp4_groupBy_0 = tmp0_filterTo_0_1;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2_0 = tmp4_groupBy_0.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var element_2_3_0 = tmp0_iterator_1_2_0.next_30();
      var tmp = [' '];
      var key_3_4 = first(split$default(element_2_3_0, tmp, false, 0, 6, null));
      var value_1_6 = tmp0_groupByTo_0_1.get_27(key_3_4);
      var tmp_0;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_5(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp_0 = answer_2_7;
      } else {
        tmp_0 = value_1_6;
      }
      var list_4_5 = tmp_0;
      list_4_5.add_19(element_2_3_0);
      Unit_getInstance();
    }
    var groups = tmp0_groupByTo_0_1;
    var info = asMap(first(getValue(groups, 'info')), this._this$0_49);
    var common = asMap(first(getValue(groups, 'common')), this._this$0_49);
    var page = asMap(first(getValue(groups, 'page')), this._this$0_49);
    var chars = asMap(first(getValue(groups, 'chars')), this._this$0_49);
    var tmp0_safe_receiver = groups.get_27('char');
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_safe_receiver, 10));
      var tmp0_iterator_1_2_1 = tmp0_safe_receiver.iterator_52();
      while (tmp0_iterator_1_2_1.hasNext_27()) {
        var item_2_3 = tmp0_iterator_1_2_1.next_30();
        var dic_5 = asMap(item_2_3, this._this$0_49);
        var id_6 = numberToChar(toInt(getValue(dic_5, 'id')));
        tmp0_mapTo_0_1.add_19(to(id_6, new AngelCharacter(id_6, toInt(getValue(dic_5, 'x')), toInt(getValue(dic_5, 'y')), toInt(getValue(dic_5, 'width')), toInt(getValue(dic_5, 'height')), toInt(getValue(dic_5, 'xoffset')), toInt(getValue(dic_5, 'yoffset')), toInt(getValue(dic_5, 'xadvance')))));
        Unit_getInstance();
      }
      tmp_1 = tmp0_mapTo_0_1;
    }
    var tmp1_safe_receiver = tmp_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toMap(tmp1_safe_receiver);
    var char = tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs;
    var tmp_2 = getValue(info, 'face');
    var tmp3_face = replace$default(tmp_2, '"', '', false, 4, null);
    var tmp4_size = toInt(getValue(info, 'size'));
    var tmp5_lineHeight = toInt(getValue(common, 'lineHeight'));
    var tmp6_base = toInt(getValue(common, 'base'));
    var tmp7_charsCount = toInt(getValue(chars, 'count'));
    var tmp8_pages = toInt(getValue(common, 'pages'));
    var tmp_3 = getValue(page, 'file');
    var tmp9_fontFile = replace$default(tmp_3, '"', '', false, 4, null);
    var fontInfo = new FontInfo(tmp3_face, tmp4_size, tmp5_lineHeight, tmp6_base, tmp8_pages, tmp9_fontFile, tmp7_charsCount);
    return new AngelCode(fontInfo, char);
  };
  _no_name_provided__114.prototype.invoke_276 = function (p1) {
    return this.invoke_172((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AssetsManager(gameContext) {
    this._gameContext_2 = gameContext;
    var tmp = this;
    tmp._assets = ArrayList_init_$Create$();
  }
  AssetsManager.prototype.add_35 = function (asset) {
    this._assets.add_19(asset);
    Unit_getInstance();
  };
  AssetsManager.prototype.update_32 = function () {
    var tmp0_forEach_0 = this._assets;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.load_15(this._gameContext_2);
    }
    this._assets.clear_15();
  };
  AssetsManager.$metadata$ = {
    simpleName: 'AssetsManager',
    kind: 'class',
    interfaces: []
  };
  function AssetsManagerSystem(assetsManager) {
    System_init_$Init$(null, null, 3, null, this);
    this._assetsManager_0 = assetsManager;
  }
  AssetsManagerSystem.prototype.update_62 = function (delta_0) {
    this._assetsManager_0.update_32();
  };
  AssetsManagerSystem.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  AssetsManagerSystem.$metadata$ = {
    simpleName: 'AssetsManagerSystem',
    kind: 'class',
    interfaces: []
  };
  function Asset() {
  }
  Asset.$metadata$ = {
    simpleName: 'Asset',
    kind: 'interface',
    interfaces: []
  };
  function Content(filename, logger) {
    this._filename = filename;
    this._logger_0 = logger;
    this._isLoaded = false;
    this._content_4 = null;
    this._onLoaded = emptyList();
  }
  Content.prototype.getValue_5 = function (thisRef, property) {
    if (this._isLoaded) {
      return ensureNotNull(this._content_4);
    } else {
      throw new EarlyAccessException(this._filename, property.callableName);
    }
  };
  Content.prototype.load_2 = function (content) {
    this._content_4 = ensureNotNull(content);
    this._isLoaded = true;
    this._logger_0.info_1('CONTENT', _no_name_provided_$factory_93(this));
    var tmp0_forEach_0 = this._onLoaded;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2(content);
    }
  };
  Content.prototype.onLoaded = function (block) {
    this.map_0(block);
    Unit_getInstance();
  };
  Content.prototype.map_0 = function (block) {
    var result = new Content(this._filename, this._logger_0);
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._onLoaded;
    tmp._onLoaded = plus_0(tmp_0, _no_name_provided_$factory_94(result, block));
    if (this._isLoaded) {
      var tmp0_forEach_0 = this._onLoaded;
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        element_2(ensureNotNull(this._content_4));
      }
    }return result;
  };
  Content.prototype.flatMap = function (block) {
    var result = new Content(this._filename, this._logger_0);
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._onLoaded;
    tmp._onLoaded = plus_0(tmp_0, _no_name_provided_$factory_95(block, result));
    if (this._isLoaded) {
      var tmp0_forEach_0 = this._onLoaded;
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        element_2(ensureNotNull(this._content_4));
      }
    }return result;
  };
  Content.prototype.loaded_0 = function () {
    return this._isLoaded;
  };
  Content.$metadata$ = {
    simpleName: 'Content',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_93(this$0) {
    var i = new _no_name_provided__116(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_94($result, $block) {
    var i = new _no_name_provided__117($result, $block);
    return function (p1) {
      i.invoke_179(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_95($block, $result) {
    var i = new _no_name_provided__118($block, $result);
    return function (p1) {
      i.invoke_179(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_96($result) {
    var i = new _no_name_provided__115($result);
    return function (p1) {
      i.invoke_174(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__115($result) {
    this._$result = $result;
  }
  _no_name_provided__115.prototype.invoke_174 = function (t) {
    this._$result.load_2(t);
  };
  _no_name_provided__115.prototype.invoke_276 = function (p1) {
    this.invoke_174((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__116(this$0) {
    this._this$0_50 = this$0;
  }
  _no_name_provided__116.prototype.invoke_274 = function () {
    return '' + "Loaded '" + this._this$0_50._filename + "' content";
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__117($result, $block) {
    this._$result_0 = $result;
    this._$block_0 = $block;
  }
  _no_name_provided__117.prototype.invoke_179 = function (it) {
    this._$result_0.load_2(this._$block_0(it));
  };
  _no_name_provided__117.prototype.invoke_276 = function (p1) {
    this.invoke_179((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__117.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__118($block, $result) {
    this._$block_1 = $block;
    this._$result_1 = $result;
  }
  _no_name_provided__118.prototype.invoke_179 = function (r) {
    var tmp = this._$block_1(r);
    var unit = tmp.map_0(_no_name_provided_$factory_96(this._$result_1));
  };
  _no_name_provided__118.prototype.invoke_276 = function (p1) {
    this.invoke_179((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__118.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function EarlyAccessException(filename, property) {
    RuntimeException_init_$Init$_0('' + "Content of file '" + filename + "' accessed before being loaded by the property '" + property + "'!", this);
    this._filename_0 = filename;
    this._property = property;
    captureStack(this, EarlyAccessException);
  }
  EarlyAccessException.$metadata$ = {
    simpleName: 'EarlyAccessException',
    kind: 'class',
    interfaces: []
  };
  function FileHandler() {
  }
  FileHandler.$metadata$ = {
    simpleName: 'FileHandler',
    kind: 'interface',
    interfaces: []
  };
  function FileHandlerCommon(gameContext, platformFileHandler, logger, loaders) {
    this._gameContext_3 = gameContext;
    this._platformFileHandler = platformFileHandler;
    this._logger_1 = logger;
    this._loaders = loaders;
    var tmp = this;
    tmp._assets_0 = LinkedHashMap_init_$Create$();
  }
  FileHandlerCommon.prototype._get_gameContext__32 = function () {
    return this._gameContext_3;
  };
  FileHandlerCommon.prototype.create_3 = function (filename, value) {
    var content = new Content(filename, this._logger_1);
    this._assets_0.put_5(filename, content);
    Unit_getInstance();
    content.load_2(value);
    return content;
  };
  FileHandlerCommon.prototype.get_46 = function (filename, clazz) {
    var tmp0_getOrPut_0 = this._assets_0;
    var value_1 = tmp0_getOrPut_0.get_27(filename);
    var tmp;
    if (value_1 == null) {
      var answer_2 = load(this, filename, clazz);
      tmp0_getOrPut_0.put_5(filename, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    var tmp_0 = tmp;
    return tmp_0 instanceof Content ? tmp_0 : THROW_CCE();
  };
  FileHandlerCommon.prototype.read_4 = function (filename) {
    return this._platformFileHandler.read_4(filename);
  };
  FileHandlerCommon.prototype.readData_1 = function (filename) {
    return this._platformFileHandler.readData_1(filename);
  };
  FileHandlerCommon.prototype.readTextureImage_1 = function (filename) {
    return this._platformFileHandler.readTextureImage_1(filename);
  };
  FileHandlerCommon.prototype.readSound_1 = function (filename) {
    return this._platformFileHandler.readSound_1(filename);
  };
  FileHandlerCommon.prototype.isFullyLoaded_0 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = this._assets_0;
      if (tmp0_all_0.isEmpty_35()) {
        tmp$ret$0 = true;
        break l$ret$1;
      }var tmp0_iterator_1 = tmp0_all_0._get_entries__5().iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (!element_2._get_value__12().loaded_0()) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  FileHandlerCommon.prototype.loadingProgress_0 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_count_0 = this._assets_0;
      if (tmp0_count_0.isEmpty_35()) {
        tmp$ret$0 = 0;
        break l$ret$1;
      }var count_1 = 0;
      var tmp0_iterator_2 = tmp0_count_0._get_entries__5().iterator_52();
      while (tmp0_iterator_2.hasNext_27()) {
        var element_3 = tmp0_iterator_2.next_30();
        if (element_3._get_value__12().loaded_0()) {
          count_1 = count_1 + 1 | 0;
          Unit_getInstance();
        } else {
        }
      }
      tmp$ret$0 = count_1;
    }
     while (false);
    var loaded = tmp$ret$0;
    var tmp1_count_0 = this._assets_0;
    return loaded / tmp1_count_0._get_size__32();
  };
  FileHandlerCommon.$metadata$ = {
    simpleName: 'FileHandlerCommon',
    kind: 'class',
    interfaces: [FileHandler]
  };
  function createLoaders() {
    return mapOf([to(getKClass_0(TextureImage), new TextureImageLoader()), to(getKClass_0(Texture), new TextureLoader()), to(getKClass_0(AngelCode), new AngelCodeLoader()), to(getKClass_0(Font), new FontLoader()), to(getKClass_0(Scene), new SceneLoader()), to(getKClass_0(Sound), new SoundLoader()), to(getKClass_0(GraphScene), new GraphSceneLoader()), to(getKClass_0(Sprite_0), new SpriteLoader())]);
  }
  function _no_name_provided_$factory_97($filename, $clazz) {
    var i = new _no_name_provided__119($filename, $clazz);
    return function () {
      return i.invoke_274();
    };
  }
  function FileHandlerCommon_init_$Init$(gameContext, platformFileHandler, logger, loaders, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      loaders = createLoaders();
    FileHandlerCommon.call($this, gameContext, platformFileHandler, logger, loaders);
    return $this;
  }
  function FileHandlerCommon_init_$Create$(gameContext, platformFileHandler, logger, loaders, $mask0, $marker) {
    return FileHandlerCommon_init_$Init$(gameContext, platformFileHandler, logger, loaders, $mask0, $marker, Object.create(FileHandlerCommon.prototype));
  }
  function load($this, filename, clazz) {
    $this._logger_1.info_1('FILE_HANDLER', _no_name_provided_$factory_97(filename, clazz));
    var loader = $this._loaders.get_27(clazz);
    if (loader == null) {
      throw new UnsupportedTypeException(clazz);
    } else {
      var tmp = loader.load_11(filename, $this);
      return tmp instanceof Content ? tmp : THROW_CCE();
    }
  }
  function _no_name_provided__119($filename, $clazz) {
    this._$filename = $filename;
    this._$clazz = $clazz;
  }
  _no_name_provided__119.prototype.invoke_274 = function () {
    return '' + "Loading '" + this._$filename + "' as '" + this._$clazz._get_simpleName__4() + "' type";
  };
  _no_name_provided__119.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function FileLoader() {
  }
  FileLoader.$metadata$ = {
    simpleName: 'FileLoader',
    kind: 'interface',
    interfaces: []
  };
  function Font(angelCode, fontSprite) {
    this._angelCode = angelCode;
    this._fontSprite = fontSprite;
  }
  Font.prototype.get_47 = function (char) {
    var tmp0_getOrElse_0 = this._angelCode._characters;
    var tmp0_elvis_lhs_1 = tmp0_getOrElse_0.get_27(char);
    var tmp;
    if (tmp0_elvis_lhs_1 == null) {
      var tmp0_elvis_lhs_4 = this._angelCode._characters.get_27(new Char(32));
      var tmp1_elvis_lhs_3 = tmp0_elvis_lhs_4 == null ? this._angelCode._characters.get_27(new Char(97)) : tmp0_elvis_lhs_4;
      tmp = tmp1_elvis_lhs_3 == null ? first_0(this._angelCode._characters._get_values__6()) : tmp1_elvis_lhs_3;
    } else {
      tmp = tmp0_elvis_lhs_1;
    }
    return tmp;
  };
  Font.$metadata$ = {
    simpleName: 'Font',
    kind: 'class',
    interfaces: []
  };
  function FontLoader() {
  }
  FontLoader.prototype.load_11 = function (filename, handler) {
    var tmp0_get_0 = '' + filename + '.fnt';
    var angelCode = handler.get_46(tmp0_get_0, getKClass_0(AngelCode));
    var tmp1_get_0 = '' + filename + '.png';
    var textureContent = handler.get_46(tmp1_get_0, getKClass_0(Texture));
    return textureContent.flatMap(_no_name_provided_$factory_98(angelCode));
  };
  FontLoader.$metadata$ = {
    simpleName: 'FontLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function _no_name_provided_$factory_98($angelCode) {
    var i = new _no_name_provided__121($angelCode);
    return function (p1) {
      return i.invoke_184(p1);
    };
  }
  function _no_name_provided_$factory_99($texture) {
    var i = new _no_name_provided__120($texture);
    return function (p1) {
      return i.invoke_182(p1);
    };
  }
  function _no_name_provided__120($texture) {
    this._$texture = $texture;
  }
  _no_name_provided__120.prototype.invoke_182 = function (it) {
    return new Font(it, this._$texture);
  };
  _no_name_provided__120.prototype.invoke_276 = function (p1) {
    return this.invoke_182(p1 instanceof AngelCode ? p1 : THROW_CCE());
  };
  _no_name_provided__120.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__121($angelCode) {
    this._$angelCode = $angelCode;
  }
  _no_name_provided__121.prototype.invoke_184 = function (texture) {
    texture._hasAlpha_0 = true;
    return this._$angelCode.map_0(_no_name_provided_$factory_99(texture));
  };
  _no_name_provided__121.prototype.invoke_276 = function (p1) {
    return this.invoke_184(p1 instanceof Texture ? p1 : THROW_CCE());
  };
  _no_name_provided__121.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GraphSceneLoader() {
    this._sceneLoader = new SceneLoader();
  }
  GraphSceneLoader.prototype.load_11 = function (filename, handler) {
    var tmp = this._sceneLoader.load_11(filename, handler);
    return tmp.map_0(_no_name_provided_$factory_100(handler));
  };
  GraphSceneLoader.$metadata$ = {
    simpleName: 'GraphSceneLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function _no_name_provided_$factory_100($handler) {
    var i = new _no_name_provided__122($handler);
    return function (p1) {
      return i.invoke_186(p1);
    };
  }
  function _no_name_provided__122($handler) {
    this._$handler = $handler;
  }
  _no_name_provided__122.prototype.invoke_186 = function (scene) {
    return new GraphScene(scene, this._$handler._get_gameContext__32()._assetsManager);
  };
  _no_name_provided__122.prototype.invoke_276 = function (p1) {
    return this.invoke_186(p1 instanceof Scene ? p1 : THROW_CCE());
  };
  _no_name_provided__122.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SceneLoader() {
  }
  SceneLoader.prototype.load_11 = function (filename, handler) {
    var tmp = handler.readData_1(filename);
    return tmp.map_0(_no_name_provided_$factory_101(this, filename));
  };
  SceneLoader.$metadata$ = {
    simpleName: 'SceneLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function _no_name_provided_$factory_101(this$0, $filename) {
    var i = new _no_name_provided__123(this$0, $filename);
    return function (p1) {
      return i.invoke_188(p1);
    };
  }
  function load_0($this, filename, content) {
    var tmp;
    if (endsWith$default(filename, '.json', false, 2, null)) {
      tmp = Companion_getInstance_12().readJson(content);
    } else {
      {
        tmp = Companion_getInstance_12().readProtobuf(content);
      }
    }
    return tmp;
  }
  function _no_name_provided__123(this$0, $filename) {
    this._this$0_51 = this$0;
    this._$filename_0 = $filename;
  }
  _no_name_provided__123.prototype.invoke_188 = function (it) {
    return load_0(this._this$0_51, this._$filename_0, it);
  };
  _no_name_provided__123.prototype.invoke_276 = function (p1) {
    return this.invoke_188((!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__123.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SoundLoader() {
  }
  SoundLoader.prototype.load_11 = function (filename, handler) {
    return handler.readSound_1(filename);
  };
  SoundLoader.$metadata$ = {
    simpleName: 'SoundLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function SpriteLoader() {
    this._sceneLoader_0 = new GraphSceneLoader();
  }
  SpriteLoader.prototype.load_11 = function (filename, handler) {
    var tmp = this._sceneLoader_0.load_11(filename, handler);
    return tmp.map_0(_no_name_provided_$factory_102(handler));
  };
  SpriteLoader.$metadata$ = {
    simpleName: 'SpriteLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function _no_name_provided_$factory_102($handler) {
    var i = new _no_name_provided__124($handler);
    return function (p1) {
      return i.invoke_190(p1);
    };
  }
  function _no_name_provided__124($handler) {
    this._$handler_0 = $handler;
  }
  _no_name_provided__124.prototype.invoke_190 = function (graphScene) {
    var spriteFromScene = first_0(graphScene._get_sprites_()._get_values__6());
    var material = ensureNotNull(graphScene._scene_0._materials.get_27(spriteFromScene._materialReference));
    var spriteSheet = Texture_init_$Create$(spriteFromScene._materialReference, material._data, material._width, material._height, material._hasAlpha);
    var animations = spriteFromScene._animations_0;
    var uvs = spriteFromScene._uvs;
    var sprite = new Sprite_0(spriteSheet, animations, uvs);
    this._$handler_0._get_gameContext__32()._assetsManager.add_35(spriteSheet);
    return sprite;
  };
  _no_name_provided__124.prototype.invoke_276 = function (p1) {
    return this.invoke_190(p1 instanceof GraphScene ? p1 : THROW_CCE());
  };
  _no_name_provided__124.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Texture(id, textureImage, textureData, width, height, hasAlpha) {
    this._id_10 = id;
    this._textureImage = textureImage;
    this._textureData = textureData;
    this._width_5 = width;
    this._height_6 = height;
    this._hasAlpha_0 = hasAlpha;
    this._textureReference = null;
    var tmp = this;
    tmp._onLoad = ArrayList_init_$Create$();
  }
  Texture.prototype.load_15 = function (gameContext) {
    var gl = gameContext._gl;
    var tmp0_elvis_lhs = this._textureReference;
    var texture = tmp0_elvis_lhs == null ? gl.createTexture_2() : tmp0_elvis_lhs;
    gl.bindTexture_2(3553, texture);
    gl.texParameteri_2(3553, 10240, 9728);
    gl.texParameteri_2(3553, 10241, 9728);
    var tx = this._textureImage;
    if (!(tx == null)) {
      gl.texImage2D_4(3553, 0, 6408, 6408, 5121, tx);
    } else {
      gl.texImage2D_5(3553, 0, 6408, 6408, this._width_5, this._height_6, 5121, this._textureData);
    }
    this._textureReference = texture;
    var tmp0_forEach_0 = this._onLoad;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2(this);
    }
  };
  Texture.$metadata$ = {
    simpleName: 'Texture',
    kind: 'class',
    interfaces: [Asset]
  };
  function Texture_init_$Init$(id, textureData, width, height, hasAlpha, $this) {
    Texture.call($this, id, null, textureData, width, height, hasAlpha);
    return $this;
  }
  function Texture_init_$Create$(id, textureData, width, height, hasAlpha) {
    return Texture_init_$Init$(id, textureData, width, height, hasAlpha, Object.create(Texture.prototype));
  }
  function TextureImageLoader() {
  }
  TextureImageLoader.prototype.load_11 = function (filename, handler) {
    return handler.readTextureImage_1(filename);
  };
  TextureImageLoader.$metadata$ = {
    simpleName: 'TextureImageLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function TextureLoader() {
    this._textureImageLoader = new TextureImageLoader();
  }
  TextureLoader.prototype.load_11 = function (filename, handler) {
    var tmp = Id_init_$Create$(null, 1, null);
    var tmp0_byteArrayOf_0 = new Int8Array([-1, 0, 0, -1, 0, -1, 0, -1, 0, 0, -1, -1, -1, -1, 0, -1]);
    var result = Texture_init_$Create$(tmp, tmp0_byteArrayOf_0, 2, 2, false);
    handler._get_gameContext__32()._assetsManager.add_35(result);
    var content = handler.create_3(filename, result);
    var tmp_0 = this._textureImageLoader.load_11(filename, handler);
    tmp_0.onLoaded(_no_name_provided_$factory_103(result, handler));
    return content;
  };
  TextureLoader.$metadata$ = {
    simpleName: 'TextureLoader',
    kind: 'class',
    interfaces: [FileLoader]
  };
  function _no_name_provided_$factory_103($result, $handler) {
    var i = new _no_name_provided__125($result, $handler);
    return function (p1) {
      i.invoke_192(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__125($result, $handler) {
    this._$result_2 = $result;
    this._$handler_1 = $handler;
  }
  _no_name_provided__125.prototype.invoke_192 = function (textureImage) {
    this._$result_2._textureImage = textureImage;
    this._$result_2._height_6 = textureImage._height_7;
    this._$result_2._width_5 = textureImage._width_6;
    this._$handler_1._get_gameContext__32()._assetsManager.add_35(this._$result_2);
  };
  _no_name_provided__125.prototype.invoke_276 = function (p1) {
    this.invoke_192(p1 instanceof TextureImage ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__125.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UnsupportedTypeException(type) {
    RuntimeException_init_$Init$_0('' + "Unsupported type '" + getKClassFromExpression_0(type) + "'", this);
    this._type_3 = type;
    captureStack(this, UnsupportedTypeException);
  }
  UnsupportedTypeException.$metadata$ = {
    simpleName: 'UnsupportedTypeException',
    kind: 'class',
    interfaces: []
  };
  function Game() {
  }
  Game.prototype._get_clearColor__1 = function () {
    return new Color_0(1.0, 1.0, 1.0, 1.0);
  };
  Game.prototype.createDefaultSystems_1 = function (engine) {
    return listOf([new SpriteAnimatedSystem(), new ArmatureUpdateSystem(), new ScriptExecutorSystem(), new TextEffectSystem(), new CameraTrackSystem(), new ParticlesEmitterSystem(), new ParticlesUpdateSystem()]);
  };
  Game.prototype.createStoryBoard_1 = function (event) {
    return Storyboard_getInstance().stayHere();
  };
  Game.prototype.createPostRenderSystem_1 = function (engine) {
    return listOf_0(new AssetsManagerSystem(this._get_gameContext__32()._assetsManager));
  };
  Game.prototype.createFrameBuffers_1 = function (gameContext) {
    return emptyList();
  };
  Game.prototype.createRenderStage_1 = function () {
    var stages = ArrayList_init_$Create$();
    var tmp0_safe_receiver = this._get_clearColor__1();
    if (tmp0_safe_receiver == null)
      null;
    else {
      stages.add_19(new ClearBufferRenderStage(this._get_gameContext__32(), tmp0_safe_receiver));
    }
    Unit_getInstance();
    var tmp = this._get_gameContext__32();
    stages.add_19(ModelComponentRenderStage_init_$Create$(tmp, null, null, 6, null));
    Unit_getInstance();
    stages.add_19(new AnimatedModelRenderStage(this._get_gameContext__32()));
    Unit_getInstance();
    return stages;
  };
  Game.prototype.createDebugRenderStage_1 = function (options) {
    var stages = ArrayList_init_$Create$();
    if (options._debug) {
      stages.add_19(new BoundingBoxRenderStage(this._get_gameContext__32()));
      Unit_getInstance();
    }stages.add_19(new ImGUIRenderStage(this._get_gameContext__32()));
    Unit_getInstance();
    return stages;
  };
  Game.prototype.render_5 = function (engine, delta_0) {
    engine.update_62(delta_0);
  };
  Game.prototype.destroy_32 = function (engine) {
    return engine.destroy_31();
  };
  Game.$metadata$ = {
    simpleName: 'Game',
    kind: 'interface',
    interfaces: []
  };
  function GameNode(name, game, engine, parent, children) {
    this._name_13 = name;
    this._game = game;
    this._engine_2 = engine;
    this._parent_1 = parent;
    this._children_1 = children;
  }
  GameNode.prototype.bootstrap = function (gameContext) {
    return gameContext.postRenderLoop_0(_no_name_provided_$factory_104(this, gameContext));
  };
  GameNode.$metadata$ = {
    simpleName: 'GameNode',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_104(this$0, $gameContext) {
    var i = new _no_name_provided__127(this$0, $gameContext);
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_105() {
    var i = new _no_name_provided__126();
    return function (p1) {
      return i.invoke_194(p1);
    };
  }
  function invoke$traverse(frameBuffer) {
    var tmp0_flatMap_0 = frameBuffer._dependencies;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_flatMap_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var list_3_4 = invoke$traverse(element_2_3);
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    return plus_0(tmp0_flatMapTo_0_1, frameBuffer);
  }
  function _no_name_provided__126() {
  }
  _no_name_provided__126.prototype.invoke_194 = function (it) {
    return it._name_16;
  };
  _no_name_provided__126.prototype.invoke_276 = function (p1) {
    return this.invoke_194(p1 instanceof FrameBuffer ? p1 : THROW_CCE());
  };
  _no_name_provided__126.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GameNode_init_$Init$(name, game, engine, parent, children, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      parent = null;
    if (!(($mask0 & 16) === 0))
      children = emptyList();
    GameNode.call($this, name, game, engine, parent, children);
    return $this;
  }
  function GameNode_init_$Create$(name, game, engine, parent, children, $mask0, $marker) {
    return GameNode_init_$Init$(name, game, engine, parent, children, $mask0, $marker, Object.create(GameNode.prototype));
  }
  function _no_name_provided__127(this$0, $gameContext) {
    this._this$0_52 = this$0;
    this._$gameContext_2 = $gameContext;
  }
  _no_name_provided__127.prototype.invoke_231 = function () {
    var tmp0_forEach_0 = this._this$0_52._game.createDefaultSystems_1(this._this$0_52._engine_2);
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      this._this$0_52._engine_2.addSystem(element_2);
    }
    var tmp1_forEach_0 = this._this$0_52._game.createSystems_1(this._this$0_52._engine_2);
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_30();
      this._this$0_52._engine_2.addSystem(element_2_0);
    }
    var tmp2_forEach_0 = this._this$0_52._game.createPostRenderSystem_1(this._this$0_52._engine_2);
    var tmp0_iterator_1_1 = tmp2_forEach_0.iterator_52();
    while (tmp0_iterator_1_1.hasNext_27()) {
      var element_2_1 = tmp0_iterator_1_1.next_30();
      this._this$0_52._engine_2.addSystem(element_2_1);
    }
    var frameBuffers = this._this$0_52._game.createFrameBuffers_1(this._$gameContext_2);
    var tmp = this._$gameContext_2;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = frameBuffers.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var list_3_4 = invoke$traverse(element_2_3);
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    var tmp3_associateBy_0 = tmp0_flatMapTo_0_1;
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp3_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp3_associateBy_0.iterator_52();
    while (tmp0_iterator_1_3.hasNext_27()) {
      var element_2_4 = tmp0_iterator_1_3.next_30();
      tmp0_associateByTo_0_2.put_5(element_2_4._name_16, element_2_4);
      Unit_getInstance();
    }
    tmp._frameBuffers = tmp0_associateByTo_0_2;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_0 = frameBuffers.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var element_2_3_0 = tmp0_iterator_1_2_0.next_30();
      if (element_2_3_0._renderOnScreen) {
        tmp0_filterTo_0_1.add_19(element_2_3_0);
        Unit_getInstance();
      } else {
      }
    }
    var rootFrameBuffers = tmp0_filterTo_0_1;
    var tmp0_subject = rootFrameBuffers._get_size__32();
    var tmp_0;
    switch (tmp0_subject) {
      case 0:
        tmp_0 = this._this$0_52._game.createRenderStage_1();
        break;
      case 1:
        tmp_0 = emptyList();
        break;
      default:throw IllegalStateException_init_$Create$('Only one frame buffer can be render directly on screen.Please configure Frame buffers so only one will render on screen by setting to false the property of one of those frame buffer: ' + ('' + joinToString$default_0(rootFrameBuffers, null, null, null, 0, null, _no_name_provided_$factory_105(), 31, null) + ' '));
    }
    var renderStage = tmp_0;
    if (rootFrameBuffers._get_size__32() === 1) {
      var tmp1_safe_receiver = this._this$0_52._game._get_clearColor__1();
      if (tmp1_safe_receiver == null)
        null;
      else {
        this._this$0_52._engine_2.addSystem(new ClearBufferRenderStage(this._$gameContext_2, tmp1_safe_receiver));
        Unit_getInstance();
      }
      Unit_getInstance();
    }var tmp0_iterator_1_4 = frameBuffers.iterator_52();
    while (tmp0_iterator_1_4.hasNext_27()) {
      var element_2_2 = tmp0_iterator_1_4.next_30();
      this._this$0_52._engine_2.addSystem(element_2_2);
    }
    var debugRenderStage = this._this$0_52._game.createDebugRenderStage_1(this._$gameContext_2._options_0);
    var tmp4_forEach_0 = plus(renderStage, debugRenderStage);
    var tmp0_iterator_1_5 = tmp4_forEach_0.iterator_52();
    while (tmp0_iterator_1_5.hasNext_27()) {
      var element_2_5 = tmp0_iterator_1_5.next_30();
      this._this$0_52._engine_2.addSystem(element_2_5);
    }
    this._this$0_52._game.createEntities_1(this._this$0_52._engine_2._entityFactory);
    this._$gameContext_2._assetsManager.update_32();
    var tmp0_iterator_1_6 = renderStage.iterator_52();
    while (tmp0_iterator_1_6.hasNext_27()) {
      var element_2_6 = tmp0_iterator_1_6.next_30();
      element_2_6.compileShaders_6();
    }
    var tmp0_iterator_1_7 = debugRenderStage.iterator_52();
    while (tmp0_iterator_1_7.hasNext_27()) {
      var element_2_7 = tmp0_iterator_1_7.next_30();
      element_2_7.compileShaders_6();
    }
    var tmp0_iterator_1_8 = frameBuffers.iterator_52();
    while (tmp0_iterator_1_8.hasNext_27()) {
      var element_2_8 = tmp0_iterator_1_8.next_30();
      element_2_8.compileShaders_6();
    }
    this._this$0_52._engine_2.onGameStart();
  };
  _no_name_provided__127.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__127.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GameWrapper(gameContext, game) {
    this._gameContext_4 = gameContext;
    var tmp = this;
    var tmp_0 = new Engine(this._gameContext_4);
    tmp._currentGame = GameNode_init_$Create$('root', game, tmp_0, null, null, 24, null);
  }
  GameWrapper.prototype.create_4 = function () {
    this._currentGame.bootstrap(this._gameContext_4);
  };
  GameWrapper.prototype.resume_1 = function () {
    return Unit_getInstance();
  };
  GameWrapper.prototype.render_1 = function (delta_0) {
    var tmp0_safe_receiver = this._gameContext_4._get_storyboardEvent_();
    if (tmp0_safe_receiver == null)
      null;
    else {
      executeStoryboardEvent(this, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    this._currentGame._game.render_5(this._currentGame._engine_2, delta_0);
  };
  GameWrapper.$metadata$ = {
    simpleName: 'GameWrapper',
    kind: 'class',
    interfaces: []
  };
  function executeStoryboardEvent($this, event) {
    var action = $this._currentGame._game.createStoryBoard_1(event);
    var tmp0_subject = action;
    if (tmp0_subject instanceof Back)
      back($this, action);
    else {
      if (tmp0_subject instanceof SwitchTo)
        switchTo($this, action);
      else {
        if (tmp0_subject instanceof ReplaceWith)
          replaceWith($this, action);
        else {
          if (equals_1(tmp0_subject, StayHere_getInstance()))
            Unit_getInstance();
          else {
            {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  function replaceWith($this, action) {
    var previousGame = $this._currentGame;
    var tmp = $this;
    var tmp_0 = action._factoryMethod_0();
    var tmp_1 = new Engine($this._gameContext_4);
    tmp._currentGame = GameNode_init_$Create$('undefined', tmp_0, tmp_1, null, null, 24, null);
    $this._currentGame.bootstrap($this._gameContext_4);
    previousGame._game.destroy_32(previousGame._engine_2);
    Unit_getInstance();
  }
  function switchTo($this, action) {
    if (action._name_14 == null) {
      var tmp = $this;
      var tmp_0 = action._factoryMethod();
      var tmp_1 = new Engine($this._gameContext_4);
      var tmp_2 = $this._currentGame;
      tmp._currentGame = GameNode_init_$Create$('undefined', tmp_0, tmp_1, tmp_2, null, 16, null);
      $this._currentGame.bootstrap($this._gameContext_4);
    } else {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_firstOrNull_0 = $this._currentGame._children_1;
        var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_52();
        while (tmp0_iterator_1.hasNext_27()) {
          var element_2 = tmp0_iterator_1.next_30();
          if (element_2._name_13 === action._name_14) {
            tmp$ret$0 = element_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var child = tmp$ret$0;
      if (child == null) {
        var tmp_3 = action._factoryMethod();
        var tmp_4 = new Engine($this._gameContext_4);
        var tmp_5 = $this._currentGame;
        var gameNode = GameNode_init_$Create$(action._name_14, tmp_3, tmp_4, tmp_5, null, 16, null);
        $this._currentGame._children_1 = plus_0($this._currentGame._children_1, gameNode);
        $this._currentGame = gameNode;
        $this._currentGame.bootstrap($this._gameContext_4);
      } else {
        $this._currentGame = child;
      }
    }
  }
  function back($this, action) {
    var tmp0_elvis_lhs = $this._currentGame._parent_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Trying to going back to the previous game.But there is not previous game available! The back event is called too early?');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var previousGame = $this._currentGame._game;
    var previousEngine = $this._currentGame._engine_2;
    $this._currentGame = parent;
    if (action._destroyMe) {
      var tmp_0 = $this._currentGame;
      var tmp0_filter_0 = $this._currentGame._children_1;
      var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp0_filter_0.iterator_52();
      while (tmp0_iterator_1_2.hasNext_27()) {
        var element_2_3 = tmp0_iterator_1_2.next_30();
        if (!equals_1(element_2_3._game, previousGame)) {
          tmp0_filterTo_0_1.add_19(element_2_3);
          Unit_getInstance();
        } else {
        }
      }
      tmp_0._children_1 = tmp0_filterTo_0_1;
      previousGame.destroy_32(previousEngine);
      Unit_getInstance();
    }}
  function StoryboardAction() {
  }
  StoryboardAction.$metadata$ = {
    simpleName: 'StoryboardAction',
    kind: 'class',
    interfaces: []
  };
  function StoryboardEvent() {
  }
  StoryboardEvent.$metadata$ = {
    simpleName: 'StoryboardEvent',
    kind: 'interface',
    interfaces: []
  };
  function Storyboard() {
    Storyboard_instance = this;
  }
  Storyboard.prototype.replaceWith_0 = function (factoryMethod) {
    return new ReplaceWith(factoryMethod);
  };
  Storyboard.prototype.stayHere = function () {
    return StayHere_getInstance();
  };
  Storyboard.$metadata$ = {
    simpleName: 'Storyboard',
    kind: 'object',
    interfaces: []
  };
  var Storyboard_instance;
  function Storyboard_getInstance() {
    if (Storyboard_instance == null)
      new Storyboard();
    return Storyboard_instance;
  }
  function StayHere() {
    StayHere_instance = this;
    StoryboardAction.call(this);
  }
  StayHere.$metadata$ = {
    simpleName: 'StayHere',
    kind: 'object',
    interfaces: []
  };
  var StayHere_instance;
  function StayHere_getInstance() {
    if (StayHere_instance == null)
      new StayHere();
    return StayHere_instance;
  }
  function Back() {
  }
  Back.$metadata$ = {
    simpleName: 'Back',
    kind: 'class',
    interfaces: []
  };
  function SwitchTo() {
  }
  SwitchTo.$metadata$ = {
    simpleName: 'SwitchTo',
    kind: 'class',
    interfaces: []
  };
  function ReplaceWith(factoryMethod) {
    StoryboardAction.call(this);
    this._factoryMethod_0 = factoryMethod;
  }
  ReplaceWith.$metadata$ = {
    simpleName: 'ReplaceWith',
    kind: 'class',
    interfaces: []
  };
  function AnimatedModel(models, animations, referencePose) {
    this._models_0 = models;
    this._animations_1 = animations;
    this._referencePose = referencePose;
  }
  AnimatedModel.prototype.load_15 = function (gameContext) {
    return Unit_getInstance();
  };
  AnimatedModel.$metadata$ = {
    simpleName: 'AnimatedModel',
    kind: 'class',
    interfaces: [Asset]
  };
  function CameraNode(type, far, near, fov, scale_1) {
    this._type_4 = type;
    this._far_2 = far;
    this._near_2 = near;
    this._fov_1 = fov;
    this._scale_4 = scale_1;
  }
  CameraNode.$metadata$ = {
    simpleName: 'CameraNode',
    kind: 'class',
    interfaces: []
  };
  function CameraNode_init_$Init$(type, far, near, fov, scale_1, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      near = 0.0;
    if (!(($mask0 & 8) === 0))
      fov = 0.0;
    if (!(($mask0 & 16) === 0))
      scale_1 = 0.0;
    CameraNode.call($this, type, far, near, fov, scale_1);
    return $this;
  }
  function CameraNode_init_$Create$(type, far, near, fov, scale_1, $mask0, $marker) {
    return CameraNode_init_$Init$(type, far, near, fov, scale_1, $mask0, $marker, Object.create(CameraNode.prototype));
  }
  function Empty_1() {
    Empty_instance = this;
  }
  Empty_1.$metadata$ = {
    simpleName: 'Empty',
    kind: 'object',
    interfaces: []
  };
  var Empty_instance;
  function Empty_getInstance() {
    if (Empty_instance == null)
      new Empty_1();
    return Empty_instance;
  }
  function GraphNode(parent, scene, node) {
    this._parent_2 = parent;
    this._scene = scene;
    this._node_0 = node;
    this._name_15 = this._node_0._name_9;
    var tmp = this;
    var tmp0_map_0 = this._node_0._children_0;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      tmp0_mapTo_0_1.add_19(new GraphNode(this._parent_2, this._scene, item_2_3));
      Unit_getInstance();
    }
    tmp._children_2 = tmp0_mapTo_0_1;
    this._type_5 = this._node_0._type_1;
    var tmp_0 = this;
    tmp_0._empty$delegate = cache(_no_name_provided_$factory_106());
    var tmp_1 = this;
    tmp_1._animatedModel$delegate = cache(_no_name_provided_$factory_107(this));
    var tmp_2 = this;
    tmp_2._light$delegate = cache(_no_name_provided_$factory_108(this));
    var tmp_3 = this;
    tmp_3._model$delegate = cache(_no_name_provided_$factory_109(this));
    var tmp_4 = this;
    tmp_4._camera$delegate = cache(_no_name_provided_$factory_110(this));
    this._combinedTransformation = toMat4(this._node_0._transformation);
    this._translation_1 = _get_t_(this._node_0._transformation);
    this._rotation_2 = _get_r_(this._node_0._transformation);
    this._scale_5 = _get_s_(this._node_0._transformation);
  }
  GraphNode.prototype._get_animatedModel_ = function () {
    var tmp0_getValue_0 = this._animatedModel$delegate;
    var tmp1_getValue_0 = animatedModel$factory();
    return tmp0_getValue_0._get_value__12();
  };
  GraphNode.prototype._get_light__2 = function () {
    var tmp0_getValue_0 = this._light$delegate;
    var tmp1_getValue_0 = light$factory();
    return tmp0_getValue_0._get_value__12();
  };
  GraphNode.prototype._get_model_ = function () {
    var tmp0_getValue_0 = this._model$delegate;
    var tmp1_getValue_0 = model$factory();
    return tmp0_getValue_0._get_value__12();
  };
  GraphNode.prototype._get_camera__5 = function () {
    var tmp0_getValue_0 = this._camera$delegate;
    var tmp1_getValue_0 = camera$factory();
    return tmp0_getValue_0._get_value__12();
  };
  GraphNode.$metadata$ = {
    simpleName: 'GraphNode',
    kind: 'class',
    interfaces: []
  };
  function cache(block) {
    return lazy_0(LazyThreadSafetyMode_NONE_getInstance(), block);
  }
  function animatedModel$factory() {
    return getPropertyCallableRef('animatedModel', 1, KProperty1, function (receiver) {
      return receiver._get_animatedModel_();
    }, null);
  }
  function light$factory() {
    return getPropertyCallableRef('light', 1, KProperty1, function (receiver) {
      return receiver._get_light__2();
    }, null);
  }
  function model$factory() {
    return getPropertyCallableRef('model', 1, KProperty1, function (receiver) {
      return receiver._get_model_();
    }, null);
  }
  function camera$factory() {
    return getPropertyCallableRef('camera', 1, KProperty1, function (receiver) {
      return receiver._get_camera__5();
    }, null);
  }
  function _no_name_provided_$factory_106() {
    var i = new _no_name_provided__128();
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_107(this$0) {
    var i = new _no_name_provided__129(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_108(this$0) {
    var i = new _no_name_provided__130(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_109(this$0) {
    var i = new _no_name_provided__131(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_110(this$0) {
    var i = new _no_name_provided__132(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided__128() {
  }
  _no_name_provided__128.prototype.invoke_274 = function () {
    return Empty_getInstance();
  };
  _no_name_provided__128.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__129(this$0) {
    this._this$0_53 = this$0;
  }
  _no_name_provided__129.prototype.invoke_274 = function () {
    var tmp0_filter_0 = this._this$0_53._children_2;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      if (element_2_3._type_5.equals(ObjectType_MODEL_getInstance())) {
        tmp0_filterTo_0_1.add_19(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    var tmp1_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_52();
    while (tmp0_iterator_1_2_0.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_30();
      tmp0_mapTo_0_1.add_19(item_2_3._get_model_());
      Unit_getInstance();
    }
    var models = tmp0_mapTo_0_1;
    var tmp2_getOrElse_0 = this._this$0_53._scene._animations;
    var tmp3_getOrElse_0 = this._this$0_53._node_0._reference;
    var tmp0_elvis_lhs_1 = tmp2_getOrElse_0.get_27(tmp3_getOrElse_0);
    var tmp;
    if (tmp0_elvis_lhs_1 == null) {
      tmp = emptyList();
    } else {
      tmp = tmp0_elvis_lhs_1;
    }
    var allAnimations = tmp;
    var referencePose = getValue(this._this$0_53._scene._armatures, this._this$0_53._node_0._reference);
    if (referencePose._joints.length > 50) {
      throw IllegalArgumentException_init_$Create$('Your armature contains more than 50 joints. MiniGDX support only 50 joints');
    }var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(allAnimations, 10));
    var tmp0_iterator_1_2_1 = allAnimations.iterator_52();
    while (tmp0_iterator_1_2_1.hasNext_27()) {
      var item_2_3_0 = tmp0_iterator_1_2_1.next_30();
      tmp0_mapTo_0_1_0.add_19(to(item_2_3_0._name_0, item_2_3_0));
      Unit_getInstance();
    }
    return new AnimatedModel(models, toMap(tmp0_mapTo_0_1_0), referencePose);
  };
  _no_name_provided__129.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__130(this$0) {
    this._this$0_54 = this$0;
  }
  _no_name_provided__130.prototype.invoke_274 = function () {
    var pointLight = getValue(this._this$0_54._scene._pointLights, this._this$0_54._node_0._reference);
    return new LightDescription(new Color_0(pointLight._color._r, pointLight._color._g, pointLight._color._b, pointLight._color._alpha), pointLight._intensity);
  };
  _no_name_provided__130.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__131(this$0) {
    this._this$0_55 = this$0;
  }
  _no_name_provided__131.prototype.invoke_274 = function () {
    if (!this._this$0_55._node_0._type_1.equals(ObjectType_MODEL_getInstance())) {
      throw IllegalStateException_init_$Create$('' + 'The current GraphNode is not referencing a Model but a ' + this._this$0_55._node_0._type_1 + ' instead.');
    }var id = this._this$0_55._node_0._reference;
    var meshModel = getValue(this._this$0_55._scene._models, id);
    var tmp0_map_0 = meshModel._mesh._primitives;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      var tmp0_elvis_lhs_6 = this._this$0_55._scene._materials.get_27(item_2_3._materialId);
      var tmp;
      if (tmp0_elvis_lhs_6 == null) {
        throw IllegalStateException_init_$Create$('' + 'Model ' + meshModel._name_7 + " doesn't have any material assigned.");
      } else {
        tmp = tmp0_elvis_lhs_6;
      }
      var material_5 = tmp;
      var tmp0_getOrPut_0_8 = this._this$0_55._parent_2._textureCache;
      var tmp1_getOrPut_0_9 = material_5._id_4;
      var value_1_10 = tmp0_getOrPut_0_8.get_27(tmp1_getOrPut_0_9);
      var tmp_0;
      if (value_1_10 == null) {
        var tmp0_also_0_4_12 = Texture_init_$Create$(material_5._id_4, material_5._data, material_5._width, material_5._height, material_5._hasAlpha);
        this._this$0_55._parent_2._assetsManager_1.add_35(tmp0_also_0_4_12);
        var answer_2_11 = tmp0_also_0_4_12;
        tmp0_getOrPut_0_8.put_5(tmp1_getOrPut_0_9, answer_2_11);
        Unit_getInstance();
        tmp_0 = answer_2_11;
      } else {
        tmp_0 = value_1_10;
      }
      var texture_7 = tmp_0;
      var tmp2_flatMap_0_14 = item_2_3._vertices;
      var tmp0_flatMapTo_0_1_15 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_16 = tmp2_flatMap_0_14.iterator_52();
      while (tmp0_iterator_1_2_16.hasNext_27()) {
        var element_2_3_17 = tmp0_iterator_1_2_16.next_30();
        var list_3_4_18 = listOf([element_2_3_17._position_10._x_4, element_2_3_17._position_10._y_4, element_2_3_17._position_10._z_4]);
        addAll(tmp0_flatMapTo_0_1_15, list_3_4_18);
        Unit_getInstance();
      }
      var tmp1_vertices_13 = toFloatArray(tmp0_flatMapTo_0_1_15);
      var tmp3_flatMap_0_20 = item_2_3._vertices;
      var tmp0_flatMapTo_0_1_21 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_22 = tmp3_flatMap_0_20.iterator_52();
      while (tmp0_iterator_1_2_22.hasNext_27()) {
        var element_2_3_23 = tmp0_iterator_1_2_22.next_30();
        var list_3_4_24 = listOf([element_2_3_23._normal._x_5, element_2_3_23._normal._y_5, element_2_3_23._normal._z_5]);
        addAll(tmp0_flatMapTo_0_1_21, list_3_4_24);
        Unit_getInstance();
      }
      var tmp2_normals_19 = toFloatArray(tmp0_flatMapTo_0_1_21);
      var tmp4_flatMap_0_26 = item_2_3._vertices;
      var tmp0_flatMapTo_0_1_27 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_28 = tmp4_flatMap_0_26.iterator_52();
      while (tmp0_iterator_1_2_28.hasNext_27()) {
        var element_2_3_29 = tmp0_iterator_1_2_28.next_30();
        var list_3_4_30 = listOf([element_2_3_29._uv._x_6, element_2_3_29._uv._y_6]);
        addAll(tmp0_flatMapTo_0_1_27, list_3_4_30);
        Unit_getInstance();
      }
      var tmp3_uvs_25 = toFloatArray(tmp0_flatMapTo_0_1_27);
      var tmp5_map_0_32 = item_2_3._verticesOrder;
      var tmp0_mapTo_0_1_33 = ArrayList_init_$Create$_0(tmp5_map_0_32.length);
      var indexedObject = tmp5_map_0_32;
      var inductionVariable = 0;
      var last_2 = indexedObject.length;
      while (inductionVariable < last_2) {
        var item_2_3_35 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1_33.add_19(toShort_0(item_2_3_35));
        Unit_getInstance();
      }
      var tmp4_verticesOrder_31 = toShortArray(tmp0_mapTo_0_1_33);
      var tmp6_flatMap_0_37 = item_2_3._vertices;
      var tmp0_flatMapTo_0_1_38 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_39 = tmp6_flatMap_0_37.iterator_52();
      while (tmp0_iterator_1_2_39.hasNext_27()) {
        var element_2_3_40 = tmp0_iterator_1_2_39.next_30();
        var tmp0_map_0_6_42 = element_2_3_40._influences;
        var tmp0_mapTo_0_1_7_43 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6_42, 10));
        var tmp0_iterator_1_2_8_44 = tmp0_map_0_6_42.iterator_52();
        while (tmp0_iterator_1_2_8_44.hasNext_27()) {
          var item_2_3_9_45 = tmp0_iterator_1_2_8_44.next_30();
          tmp0_mapTo_0_1_7_43.add_19(item_2_3_9_45._weight);
          Unit_getInstance();
        }
        var list_3_4_41 = tmp0_mapTo_0_1_7_43;
        addAll(tmp0_flatMapTo_0_1_38, list_3_4_41);
        Unit_getInstance();
      }
      var tmp5_weights_36 = toFloatArray(tmp0_flatMapTo_0_1_38);
      var tmp7_flatMap_0_47 = item_2_3._vertices;
      var tmp0_flatMapTo_0_1_48 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2_49 = tmp7_flatMap_0_47.iterator_52();
      while (tmp0_iterator_1_2_49.hasNext_27()) {
        var element_2_3_50 = tmp0_iterator_1_2_49.next_30();
        var tmp0_map_0_6_52 = element_2_3_50._influences;
        var tmp0_mapTo_0_1_7_53 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6_52, 10));
        var tmp0_iterator_1_2_8_54 = tmp0_map_0_6_52.iterator_52();
        while (tmp0_iterator_1_2_8_54.hasNext_27()) {
          var item_2_3_9_55 = tmp0_iterator_1_2_8_54.next_30();
          tmp0_mapTo_0_1_7_53.add_19(item_2_3_9_55._jointId);
          Unit_getInstance();
        }
        var list_3_4_51 = tmp0_mapTo_0_1_7_53;
        addAll(tmp0_flatMapTo_0_1_48, list_3_4_51);
        Unit_getInstance();
      }
      var tmp6_joints_46 = toFloatArray(tmp0_flatMapTo_0_1_48);
      tmp0_mapTo_0_1.add_19(Primitive_init_$Create$_0(texture_7, tmp1_vertices_13, tmp2_normals_19, tmp3_uvs_25, tmp5_weights_36, tmp6_joints_46, tmp4_verticesOrder_31, null, 128, null));
      Unit_getInstance();
    }
    var primitives = tmp0_mapTo_0_1;
    var tmp1_also_0 = Model_init_$Create$_0(primitives, false, 2, null);
    this._this$0_55._parent_2._assetsManager_1.add_35(tmp1_also_0);
    return tmp1_also_0;
  };
  _no_name_provided__131.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__132(this$0) {
    this._this$0_56 = this$0;
  }
  _no_name_provided__132.prototype.invoke_274 = function () {
    var tmp0_elvis_lhs = this._this$0_56._scene._perspectiveCameras.get_27(this._this$0_56._node_0._reference);
    var camera = tmp0_elvis_lhs == null ? getValue(this._this$0_56._scene._orthographicCameras, this._this$0_56._node_0._reference) : tmp0_elvis_lhs;
    var tmp1_subject = camera;
    var tmp;
    if (tmp1_subject instanceof PerspectiveCamera) {
      var tmp2_type = Type_PERSPECTIVE_getInstance();
      var tmp3_fov = camera._fov;
      var tmp4_near = camera._near;
      var tmp5_far = camera._far;
      tmp = CameraNode_init_$Create$(tmp2_type, tmp5_far, tmp4_near, tmp3_fov, 0.0, 16, null);
    } else {
      if (tmp1_subject instanceof OrthographicCamera) {
        var tmp6_type = Type_ORTHOGRAPHIC_getInstance();
        var tmp7_near = camera._near_0;
        var tmp8_far = camera._far_0;
        var tmp9_scale = camera._scale;
        tmp = CameraNode_init_$Create$(tmp6_type, tmp8_far, tmp7_near, 0.0, tmp9_scale, 8, null);
      } else {
        {
          throw IllegalArgumentException_init_$Create$('' + getKClassFromExpression_0(camera) + ' is not supported');
        }
      }
    }
    return tmp;
  };
  _no_name_provided__132.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GraphScene(scene, assetsManager) {
    this._scene_0 = scene;
    this._assetsManager_1 = assetsManager;
    var tmp = this;
    tmp._textureCache = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    var tmp0_map_0 = this._scene_0._children;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var item_2_3 = tmp0_iterator_1_2.next_30();
      tmp0_mapTo_0_1.add_19(new GraphNode(this, this._scene_0, item_2_3));
      Unit_getInstance();
    }
    tmp_0._nodes = tmp0_mapTo_0_1;
  }
  GraphScene.prototype._get_sprites_ = function () {
    return this._scene_0._sprites;
  };
  GraphScene.prototype.load_15 = function (gameContext) {
    return Unit_getInstance();
  };
  GraphScene.$metadata$ = {
    simpleName: 'GraphScene',
    kind: 'class',
    interfaces: [Asset]
  };
  function LightDescription(color, intensity) {
    this._color_2 = color;
    this._intensity_1 = intensity;
  }
  LightDescription.$metadata$ = {
    simpleName: 'LightDescription',
    kind: 'class',
    interfaces: []
  };
  function Model_0(primitives, displayble) {
    this._primitives_0 = primitives;
    this._displayble = displayble;
  }
  Model_0.prototype.load_15 = function (gameContext) {
    var tmp0_forEach_0 = this._primitives_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.load_15(gameContext);
    }
    this._displayble = true;
  };
  Model_0.$metadata$ = {
    simpleName: 'Model',
    kind: 'class',
    interfaces: [Asset]
  };
  function Model_init_$Init$_0(primitives, displayble, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      displayble = false;
    Model_0.call($this, primitives, displayble);
    return $this;
  }
  function Model_init_$Create$_0(primitives, displayble, $mask0, $marker) {
    return Model_init_$Init$_0(primitives, displayble, $mask0, $marker, Object.create(Model_0.prototype));
  }
  function Primitive_0(texture, vertices, normals, uvs, weights, joints, verticesOrder, drawingType) {
    this._texture_0 = texture;
    this._drawingType = drawingType;
    this._verticesBuffer = null;
    this._normalsBuffer = null;
    this._uvsBuffer = null;
    this._verticesOrderBuffer = null;
    this._jointsBuffer = null;
    this._weightsBuffer = null;
    this.__verticesUpdated = true;
    this._vertices_3 = vertices;
    this.__normalsUpdated = true;
    this._normals = normals;
    this.__uvsUpdated = true;
    this._uvs_3 = uvs;
    this.__verticesOrderUpdated = true;
    this._verticesOrder_3 = verticesOrder;
    this.__jointsUpdated = true;
    this._joints_0 = joints;
    this.__weightsUpdated = true;
    this._weights = weights;
  }
  Primitive_0.prototype._set_vertices_ = function (value) {
    this.__verticesUpdated = true;
    this._vertices_3 = value;
  };
  Primitive_0.prototype._set_normals_ = function (value) {
    this.__normalsUpdated = true;
    this._normals = value;
  };
  Primitive_0.prototype._set_uvs_ = function (value) {
    this.__uvsUpdated = true;
    this._uvs_3 = value;
  };
  Primitive_0.prototype._set_verticesOrder_ = function (value) {
    this.__verticesOrderUpdated = true;
    this._verticesOrder_3 = value;
  };
  Primitive_0.prototype.load_15 = function (gameContext) {
    var gl = gameContext._gl;
    var tmp = this;
    var tmp0_elvis_lhs = this._verticesBuffer;
    tmp._verticesBuffer = tmp0_elvis_lhs == null ? gl.createBuffer_2() : tmp0_elvis_lhs;
    if (this.__verticesUpdated) {
      gl.bindBuffer_2(34962, ensureNotNull(this._verticesBuffer));
      gl.bufferData_2(34962, new FloatDataSource(this._vertices_3), 35044);
      this.__verticesUpdated = false;
    }var tmp_0 = this;
    var tmp1_elvis_lhs = this._normalsBuffer;
    tmp_0._normalsBuffer = tmp1_elvis_lhs == null ? gl.createBuffer_2() : tmp1_elvis_lhs;
    if (this.__normalsUpdated) {
      gl.bindBuffer_2(34962, ensureNotNull(this._normalsBuffer));
      gl.bufferData_2(34962, new FloatDataSource(this._normals), 35044);
      this.__normalsUpdated = false;
    }var tmp_1 = this;
    var tmp2_elvis_lhs = this._verticesOrderBuffer;
    tmp_1._verticesOrderBuffer = tmp2_elvis_lhs == null ? gl.createBuffer_2() : tmp2_elvis_lhs;
    if (this.__verticesOrderUpdated) {
      this.__verticesOrderUpdated = false;
      gl.bindBuffer_2(34963, ensureNotNull(this._verticesOrderBuffer));
      gl.bufferData_2(34963, new ShortDataSource(this._verticesOrder_3), 35044);
    }var tmp_2 = this;
    var tmp3_elvis_lhs = this._uvsBuffer;
    tmp_2._uvsBuffer = tmp3_elvis_lhs == null ? gl.createBuffer_2() : tmp3_elvis_lhs;
    if (this.__uvsUpdated) {
      this.__uvsUpdated = false;
      gl.bindBuffer_2(34962, ensureNotNull(this._uvsBuffer));
      gl.bufferData_2(34962, new FloatDataSource(this._uvs_3), 35044);
    }if (this.__weightsUpdated) {
      this.__weightsUpdated = false;
      var tmp0_isNotEmpty_0 = this._weights;
      if (!(tmp0_isNotEmpty_0.length === 0)) {
        var tmp_3 = this;
        var tmp4_elvis_lhs = this._weightsBuffer;
        tmp_3._weightsBuffer = tmp4_elvis_lhs == null ? gl.createBuffer_2() : tmp4_elvis_lhs;
        gl.bindBuffer_2(34962, ensureNotNull(this._weightsBuffer));
        gl.bufferData_2(34962, new FloatDataSource(this._weights), 35044);
      } else {
      }
    }if (this.__jointsUpdated) {
      this.__jointsUpdated = false;
      var tmp1_isNotEmpty_0 = this._joints_0;
      if (!(tmp1_isNotEmpty_0.length === 0)) {
        var tmp_4 = this;
        var tmp5_elvis_lhs = this._jointsBuffer;
        tmp_4._jointsBuffer = tmp5_elvis_lhs == null ? gl.createBuffer_2() : tmp5_elvis_lhs;
        gl.bindBuffer_2(34962, ensureNotNull(this._jointsBuffer));
        gl.bufferData_2(34962, new FloatDataSource(this._joints_0), 35044);
      } else {
      }
    }};
  Primitive_0.$metadata$ = {
    simpleName: 'Primitive',
    kind: 'class',
    interfaces: [Asset]
  };
  function DrawingType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  DrawingType.$metadata$ = {
    simpleName: 'DrawingType',
    kind: 'class',
    interfaces: []
  };
  function DrawingType_TRIANGLE_getInstance() {
    DrawingType_initEntries();
    return DrawingType_TRIANGLE_instance;
  }
  function Primitive_init_$Init$_0(texture, vertices, normals, uvs, weights, joints, verticesOrder, drawingType, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      var tmp0_floatArrayOf_0 = new Float32Array([]);
      vertices = tmp0_floatArrayOf_0;
    }if (!(($mask0 & 4) === 0)) {
      var tmp0_floatArrayOf_0_0 = new Float32Array([]);
      normals = tmp0_floatArrayOf_0_0;
    }if (!(($mask0 & 8) === 0)) {
      var tmp0_floatArrayOf_0_1 = new Float32Array([]);
      uvs = tmp0_floatArrayOf_0_1;
    }if (!(($mask0 & 16) === 0)) {
      var tmp0_floatArrayOf_0_2 = new Float32Array([]);
      weights = tmp0_floatArrayOf_0_2;
    }if (!(($mask0 & 32) === 0)) {
      var tmp0_floatArrayOf_0_3 = new Float32Array([]);
      joints = tmp0_floatArrayOf_0_3;
    }if (!(($mask0 & 64) === 0)) {
      var tmp0_shortArrayOf_0 = new Int16Array([]);
      verticesOrder = tmp0_shortArrayOf_0;
    }if (!(($mask0 & 128) === 0))
      drawingType = DrawingType_TRIANGLE_getInstance();
    Primitive_0.call($this, texture, vertices, normals, uvs, weights, joints, verticesOrder, drawingType);
    return $this;
  }
  function Primitive_init_$Create$_0(texture, vertices, normals, uvs, weights, joints, verticesOrder, drawingType, $mask0, $marker) {
    return Primitive_init_$Init$_0(texture, vertices, normals, uvs, weights, joints, verticesOrder, drawingType, $mask0, $marker, Object.create(Primitive_0.prototype));
  }
  var DrawingType_TRIANGLE_instance;
  var DrawingType_LINE_instance;
  var DrawingType_entriesInitialized;
  function DrawingType_initEntries() {
    if (DrawingType_entriesInitialized)
      return Unit_getInstance();
    DrawingType_entriesInitialized = true;
    DrawingType_TRIANGLE_instance = new DrawingType('TRIANGLE', 0);
    DrawingType_LINE_instance = new DrawingType('LINE', 1);
  }
  function Sprite_0(spriteSheet, animations, uvs) {
    this._spriteSheet = spriteSheet;
    this._animations_2 = animations;
    this._uvs_4 = uvs;
  }
  Sprite_0.$metadata$ = {
    simpleName: 'Sprite',
    kind: 'class',
    interfaces: []
  };
  function FrameBuffer() {
  }
  FrameBuffer.prototype.compileShaders_6 = function () {
    if (this._shaderCompiled)
      return Unit_getInstance();
    var tmp0_forEach_0 = this._dependencies;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      element_2.compileShaders_6();
    }
    var tmp1_forEach_0 = this._stages;
    var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1_0.next_30();
      element_2_0.compileShaders_6();
    }
    this._shaderCompiled = true;
  };
  FrameBuffer.$metadata$ = {
    simpleName: 'FrameBuffer',
    kind: 'class',
    interfaces: [Stage, Asset]
  };
  function ViewportStrategy() {
  }
  ViewportStrategy.$metadata$ = {
    simpleName: 'ViewportStrategy',
    kind: 'interface',
    interfaces: []
  };
  function FillViewportStrategy(logger) {
    this._logger_2 = logger;
  }
  FillViewportStrategy.prototype.update_29 = function (gl, width, height, gameWidth, gameHeight) {
    apply(this, width, height, gameWidth, gameHeight, _no_name_provided_$factory_111(gl));
  };
  FillViewportStrategy.prototype.convert_2 = function (deviceX, deviceY, width, height, gameWidth, gameHeight) {
    return apply(this, width, height, gameWidth, gameHeight, _no_name_provided_$factory_112(deviceX, deviceY, gameWidth, gameHeight));
  };
  FillViewportStrategy.$metadata$ = {
    simpleName: 'FillViewportStrategy',
    kind: 'class',
    interfaces: [ViewportStrategy]
  };
  function _no_name_provided_$factory_111($gl) {
    var i = new _no_name_provided__133($gl);
    return function (p1, p2, p3, p4) {
      i.invoke_203(p1, p2, p3, p4);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_112($deviceX, $deviceY, $gameWidth, $gameHeight) {
    var i = new _no_name_provided__134($deviceX, $deviceY, $gameWidth, $gameHeight);
    return function (p1, p2, p3, p4) {
      return i.invoke_205(p1, p2, p3, p4);
    };
  }
  function apply($this, width, height, gameWidth, gameHeight, block) {
    var sw = width;
    var sh = height;
    var ww = gameWidth;
    var wh = gameHeight;
    var tmp0_min_0 = sw / ww;
    var tmp1_min_0 = sh / wh;
    var ref = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float32Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
    var pw = ww * ref;
    var ph = wh * ref;
    var gx = (sw - pw) * 0.5;
    var gy = (sh - ph) * 0.5;
    var x = roundToInt(gx);
    var y = roundToInt(gy);
    var w = roundToInt(pw);
    var h = roundToInt(ph);
    return block(x, y, w, h);
  }
  function _no_name_provided__133($gl) {
    this._$gl = $gl;
  }
  _no_name_provided__133.prototype.invoke_203 = function (x, y, w, h) {
    this._$gl.viewport_2(x, y, w, h);
  };
  _no_name_provided__133.prototype.invoke_206 = function (p1, p2, p3, p4) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    this.invoke_203(tmp, tmp_0, tmp_1, (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__133.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__134($deviceX, $deviceY, $gameWidth, $gameHeight) {
    this._$deviceX = $deviceX;
    this._$deviceY = $deviceY;
    this._$gameWidth = $gameWidth;
    this._$gameHeight = $gameHeight;
  }
  _no_name_provided__134.prototype.invoke_205 = function (x, y, w, h) {
    var xOrigin = this._$deviceX - x;
    var yOrigin = this._$deviceY - y;
    var gameX = xOrigin * this._$gameWidth / w;
    var gameY = yOrigin * this._$gameHeight / h;
    return to(gameX, gameY);
  };
  _no_name_provided__134.prototype.invoke_206 = function (p1, p2, p3, p4) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    return this.invoke_205(tmp, tmp_0, tmp_1, (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE());
  };
  _no_name_provided__134.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ImGUI(gameContext, vertex, fragmentShader) {
    this._vertex = vertex;
    this._fragmentShader = fragmentShader;
    this._gl_0 = gameContext._gl;
    this._verticesBuffer_0 = this._gl_0.createBuffer_2();
    this._verticesOrderBuffer_0 = this._gl_0.createBuffer_2();
    this._verticesUVsBuffer = this._gl_0.createBuffer_2();
    this._normalsBuffer_0 = this._gl_0.createBuffer_2();
  }
  ImGUI.prototype._get_program__5 = function () {
    var tmp = this._program_0;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('program');
    }
  };
  ImGUI.prototype.render_2 = function (texture, vertices, uv, verticesOrder) {
    this._gl_0.disable_2(2929);
    this._gl_0.enable_2(3042);
    this._gl_0.blendFunc_2(770, 771);
    this._gl_0.bindBuffer_2(34962, this._verticesBuffer_0);
    this._gl_0.bufferData_2(34962, new FloatDataSource(vertices), 35044);
    this._gl_0.bindBuffer_2(34962, this._normalsBuffer_0);
    this._gl_0.bufferData_2(34962, new FloatDataSource(new Float32Array(vertices.length)), 35044);
    this._gl_0.bindBuffer_2(34963, this._verticesOrderBuffer_0);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(verticesOrder.length);
    var indexedObject = verticesOrder;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_19(toShort_0(item_2_3));
      Unit_getInstance();
    }
    this._gl_0.bufferData_2(34963, new ShortDataSource(toShortArray(tmp0_mapTo_0_1)), 35044);
    this._gl_0.bindBuffer_2(34962, this._verticesUVsBuffer);
    this._gl_0.bufferData_2(34962, new FloatDataSource(uv), 35044);
    this._vertex._uLightColor_0.apply_4(this._get_program__5(), Companion_getInstance_17()._TRANSPARENT_COLOR);
    this._vertex._uLightPosition_0.apply_2(this._get_program__5(), Companion_getInstance_17()._ORIGIN);
    this._vertex._uModelView_1.apply(this._get_program__5(), Companion_getInstance_10().identity_0());
    this._vertex._aVertexPosition_1.apply_10(this._get_program__5(), this._verticesBuffer_0);
    this._vertex._aVertexNormal_0.apply_10(this._get_program__5(), this._normalsBuffer_0);
    this._vertex._aUVPosition_0.apply_10(this._get_program__5(), this._verticesUVsBuffer);
    this._fragmentShader._uUV.apply_11(this._get_program__5(), ensureNotNull(texture._textureReference), 0);
    this._gl_0.bindBuffer_2(34963, this._verticesOrderBuffer_0);
    this._gl_0.drawElements_2(4, verticesOrder.length, 5123, 0);
    this._gl_0.disable_2(3042);
    this._gl_0.enable_2(2929);
  };
  ImGUI.prototype.render_3 = function (texture, vertices, uv, verticesOrder) {
    return this.render_2(texture instanceof Texture ? texture : THROW_CCE(), vertices, uv, verticesOrder);
  };
  ImGUI.$metadata$ = {
    simpleName: 'ImGUI',
    kind: 'class',
    interfaces: [ImGUIRenderer]
  };
  function ImGUIRenderStage(gameContext) {
    var tmp = new MeshVertexShader();
    var tmp_0 = new UVFragmentShader();
    var tmp_1 = Companion_getInstance_23().none();
    var tmp_2 = Companion_getInstance_23().none();
    RenderStage_init_$Init$(gameContext, tmp, tmp_0, tmp_1, tmp_2, null, 32, null, this);
    this._guiRenderer = new ImGUI(gameContext, this._get_vertex__3(), this._get_fragment__2());
    var tmp_3 = this;
    var tmp0_get_0 = gameContext._fileHandler;
    var tmp1_get_0 = 'internal/widgets.png';
    tmp_3._texture$delegate = tmp0_get_0.get_46(tmp1_get_0, getKClass_0(Texture));
    var tmp_4 = this;
    tmp_4._inputCapture_0 = new ImgCapture(_no_name_provided_$factory_113(this));
    this._systems_0 = emptyList();
  }
  ImGUIRenderStage.prototype.onEvent_26 = function (event, entityQuery) {
    if (event instanceof RegisterImGuiSystem) {
      this._systems_0 = plus_0(this._systems_0, event._system);
    } else {
    }
  };
  ImGUIRenderStage.prototype.update_62 = function (delta_0) {
    this._guiRenderer._program_0 = this._get_program__5();
    this._get_gl__4().useProgram_2(this._get_program__5());
    var tmp0_forEach_0 = this._systems_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var tmp0_defaultTexture_4 = _get_texture_(this);
      var tmp1_renderer_5 = this._guiRenderer;
      var tmp2_inputCapture_6 = this._inputCapture_0;
      var tmp3_gameResolution_7 = Resolution_init_$Create$(this._get_gameContext__32()._gameScreen._width_1, this._get_gameContext__32()._gameScreen._height_1);
      gui$default(tmp1_renderer_5, tmp0_defaultTexture_4, tmp2_inputCapture_6, tmp3_gameResolution_7, null, _no_name_provided_$factory_114(element_2), 16, null);
    }
  };
  ImGUIRenderStage.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  ImGUIRenderStage.$metadata$ = {
    simpleName: 'ImGUIRenderStage',
    kind: 'class',
    interfaces: []
  };
  function texture$factory() {
    return getPropertyCallableRef('texture', 1, KProperty1, function (receiver) {
      return _get_texture_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_113(this$0) {
    var i = new _no_name_provided__135(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_114($element_2) {
    var i = new _no_name_provided__136($element_2);
    return function (p1) {
      i.invoke_208(p1);
      return Unit_getInstance();
    };
  }
  function _get_texture_($this) {
    return $this._texture$delegate.getValue_5($this, texture$factory());
  }
  function _no_name_provided__135(this$0) {
    this._this$0_57 = this$0;
  }
  _no_name_provided__135.prototype.invoke_274 = function () {
    return this._this$0_57._get_input__25();
  };
  _no_name_provided__135.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__136($element_2) {
    this._$element_2_0 = $element_2;
  }
  _no_name_provided__136.prototype.invoke_208 = function (_this__0) {
    this._$element_2_0.gui__error(_this__0);
  };
  _no_name_provided__136.prototype.invoke_276 = function (p1) {
    this.invoke_208((!(p1 == null) ? isInterface(p1, WidgetBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__136.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ImgCapture(input) {
    this._input_2 = input;
    this._pos = new Vector2(-1.0, -1.0);
    this._touch_0 = false;
  }
  ImgCapture.prototype.update_32 = function () {
    var inputHandler = this._input_2();
    var tmp0_safe_receiver = inputHandler.touchIdlePosition_0();
    if (tmp0_safe_receiver == null)
      null;
    else {
      this._pos._x_10 = tmp0_safe_receiver._x_10;
      this._pos._y_10 = tmp0_safe_receiver._y_10;
      Unit_getInstance();
    }
    Unit_getInstance();
    this._touch_0 = false;
    var tmp1_safe_receiver = inputHandler.isJustTouched_1(TouchSignal_TOUCH1_getInstance());
    if (tmp1_safe_receiver == null)
      null;
    else {
      this._pos._x_10 = tmp1_safe_receiver._x_10;
      this._pos._y_10 = tmp1_safe_receiver._y_10;
      this._touch_0 = true;
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  ImgCapture.$metadata$ = {
    simpleName: 'ImgCapture',
    kind: 'class',
    interfaces: [InputCapture]
  };
  function RegisterImGuiSystem() {
  }
  RegisterImGuiSystem.$metadata$ = {
    simpleName: 'RegisterImGuiSystem',
    kind: 'class',
    interfaces: [Event_0]
  };
  function Key_4(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Key_4.$metadata$ = {
    simpleName: 'Key',
    kind: 'class',
    interfaces: []
  };
  function InputHandler() {
  }
  InputHandler.prototype.touchIdlePosition_0 = function () {
    return null;
  };
  InputHandler.$metadata$ = {
    simpleName: 'InputHandler',
    kind: 'interface',
    interfaces: []
  };
  function TouchSignal(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  TouchSignal.$metadata$ = {
    simpleName: 'TouchSignal',
    kind: 'class',
    interfaces: []
  };
  function InputManager() {
  }
  InputManager.$metadata$ = {
    simpleName: 'InputManager',
    kind: 'interface',
    interfaces: []
  };
  function Key_ANY_KEY_getInstance() {
    Key_initEntries();
    return Key_ANY_KEY_instance;
  }
  function Key_BACKSPACE_getInstance() {
    Key_initEntries();
    return Key_BACKSPACE_instance;
  }
  function Key_TAB_getInstance() {
    Key_initEntries();
    return Key_TAB_instance;
  }
  function Key_ENTER_getInstance() {
    Key_initEntries();
    return Key_ENTER_instance;
  }
  function Key_SHIFT_getInstance() {
    Key_initEntries();
    return Key_SHIFT_instance;
  }
  function Key_CTRL_getInstance() {
    Key_initEntries();
    return Key_CTRL_instance;
  }
  function Key_ALT_getInstance() {
    Key_initEntries();
    return Key_ALT_instance;
  }
  function Key_PAUSE_BREAK_getInstance() {
    Key_initEntries();
    return Key_PAUSE_BREAK_instance;
  }
  function Key_CAPS_LOCK_getInstance() {
    Key_initEntries();
    return Key_CAPS_LOCK_instance;
  }
  function Key_ESCAPE_getInstance() {
    Key_initEntries();
    return Key_ESCAPE_instance;
  }
  function Key_PAGE_UP_getInstance() {
    Key_initEntries();
    return Key_PAGE_UP_instance;
  }
  function Key_SPACE_getInstance() {
    Key_initEntries();
    return Key_SPACE_instance;
  }
  function Key_PAGE_DOWN_getInstance() {
    Key_initEntries();
    return Key_PAGE_DOWN_instance;
  }
  function Key_END_getInstance() {
    Key_initEntries();
    return Key_END_instance;
  }
  function Key_HOME_getInstance() {
    Key_initEntries();
    return Key_HOME_instance;
  }
  function Key_ARROW_LEFT_getInstance() {
    Key_initEntries();
    return Key_ARROW_LEFT_instance;
  }
  function Key_ARROW_UP_getInstance() {
    Key_initEntries();
    return Key_ARROW_UP_instance;
  }
  function Key_ARROW_RIGHT_getInstance() {
    Key_initEntries();
    return Key_ARROW_RIGHT_instance;
  }
  function Key_ARROW_DOWN_getInstance() {
    Key_initEntries();
    return Key_ARROW_DOWN_instance;
  }
  function Key_PRINT_SCREEN_getInstance() {
    Key_initEntries();
    return Key_PRINT_SCREEN_instance;
  }
  function Key_INSERT_getInstance() {
    Key_initEntries();
    return Key_INSERT_instance;
  }
  function Key_DELETE_getInstance() {
    Key_initEntries();
    return Key_DELETE_instance;
  }
  function Key_NUM0_getInstance() {
    Key_initEntries();
    return Key_NUM0_instance;
  }
  function Key_NUM1_getInstance() {
    Key_initEntries();
    return Key_NUM1_instance;
  }
  function Key_NUM2_getInstance() {
    Key_initEntries();
    return Key_NUM2_instance;
  }
  function Key_NUM3_getInstance() {
    Key_initEntries();
    return Key_NUM3_instance;
  }
  function Key_NUM4_getInstance() {
    Key_initEntries();
    return Key_NUM4_instance;
  }
  function Key_NUM5_getInstance() {
    Key_initEntries();
    return Key_NUM5_instance;
  }
  function Key_NUM6_getInstance() {
    Key_initEntries();
    return Key_NUM6_instance;
  }
  function Key_NUM7_getInstance() {
    Key_initEntries();
    return Key_NUM7_instance;
  }
  function Key_NUM8_getInstance() {
    Key_initEntries();
    return Key_NUM8_instance;
  }
  function Key_NUM9_getInstance() {
    Key_initEntries();
    return Key_NUM9_instance;
  }
  function Key_A_getInstance() {
    Key_initEntries();
    return Key_A_instance;
  }
  function Key_B_getInstance() {
    Key_initEntries();
    return Key_B_instance;
  }
  function Key_C_getInstance() {
    Key_initEntries();
    return Key_C_instance;
  }
  function Key_D_getInstance() {
    Key_initEntries();
    return Key_D_instance;
  }
  function Key_E_getInstance() {
    Key_initEntries();
    return Key_E_instance;
  }
  function Key_F_getInstance() {
    Key_initEntries();
    return Key_F_instance;
  }
  function Key_G_getInstance() {
    Key_initEntries();
    return Key_G_instance;
  }
  function Key_H_getInstance() {
    Key_initEntries();
    return Key_H_instance;
  }
  function Key_I_getInstance() {
    Key_initEntries();
    return Key_I_instance;
  }
  function Key_J_getInstance() {
    Key_initEntries();
    return Key_J_instance;
  }
  function Key_K_getInstance() {
    Key_initEntries();
    return Key_K_instance;
  }
  function Key_L_getInstance() {
    Key_initEntries();
    return Key_L_instance;
  }
  function Key_M_getInstance() {
    Key_initEntries();
    return Key_M_instance;
  }
  function Key_N_getInstance() {
    Key_initEntries();
    return Key_N_instance;
  }
  function Key_O_getInstance() {
    Key_initEntries();
    return Key_O_instance;
  }
  function Key_P_getInstance() {
    Key_initEntries();
    return Key_P_instance;
  }
  function Key_Q_getInstance() {
    Key_initEntries();
    return Key_Q_instance;
  }
  function Key_R_getInstance() {
    Key_initEntries();
    return Key_R_instance;
  }
  function Key_S_getInstance() {
    Key_initEntries();
    return Key_S_instance;
  }
  function Key_T_getInstance() {
    Key_initEntries();
    return Key_T_instance;
  }
  function Key_U_getInstance() {
    Key_initEntries();
    return Key_U_instance;
  }
  function Key_V_getInstance() {
    Key_initEntries();
    return Key_V_instance;
  }
  function Key_W_getInstance() {
    Key_initEntries();
    return Key_W_instance;
  }
  function Key_X_getInstance() {
    Key_initEntries();
    return Key_X_instance;
  }
  function Key_Y_getInstance() {
    Key_initEntries();
    return Key_Y_instance;
  }
  function Key_Z_getInstance() {
    Key_initEntries();
    return Key_Z_instance;
  }
  function Key_LEFT_WINDOW_KEY_getInstance() {
    Key_initEntries();
    return Key_LEFT_WINDOW_KEY_instance;
  }
  function Key_RIGHT_WINDOW_KEY_getInstance() {
    Key_initEntries();
    return Key_RIGHT_WINDOW_KEY_instance;
  }
  function Key_SELECT_KEY_getInstance() {
    Key_initEntries();
    return Key_SELECT_KEY_instance;
  }
  function Key_NUMPAD0_getInstance() {
    Key_initEntries();
    return Key_NUMPAD0_instance;
  }
  function Key_NUMPAD1_getInstance() {
    Key_initEntries();
    return Key_NUMPAD1_instance;
  }
  function Key_NUMPAD2_getInstance() {
    Key_initEntries();
    return Key_NUMPAD2_instance;
  }
  function Key_NUMPAD3_getInstance() {
    Key_initEntries();
    return Key_NUMPAD3_instance;
  }
  function Key_NUMPAD4_getInstance() {
    Key_initEntries();
    return Key_NUMPAD4_instance;
  }
  function Key_NUMPAD5_getInstance() {
    Key_initEntries();
    return Key_NUMPAD5_instance;
  }
  function Key_NUMPAD6_getInstance() {
    Key_initEntries();
    return Key_NUMPAD6_instance;
  }
  function Key_NUMPAD7_getInstance() {
    Key_initEntries();
    return Key_NUMPAD7_instance;
  }
  function Key_NUMPAD8_getInstance() {
    Key_initEntries();
    return Key_NUMPAD8_instance;
  }
  function Key_NUMPAD9_getInstance() {
    Key_initEntries();
    return Key_NUMPAD9_instance;
  }
  function Key_MULTIPLY_getInstance() {
    Key_initEntries();
    return Key_MULTIPLY_instance;
  }
  function Key_ADD_getInstance() {
    Key_initEntries();
    return Key_ADD_instance;
  }
  function Key_SUBTRACT_getInstance() {
    Key_initEntries();
    return Key_SUBTRACT_instance;
  }
  function Key_DECIMAL_POINT_getInstance() {
    Key_initEntries();
    return Key_DECIMAL_POINT_instance;
  }
  function Key_DIVIDE_getInstance() {
    Key_initEntries();
    return Key_DIVIDE_instance;
  }
  function Key_F1_getInstance() {
    Key_initEntries();
    return Key_F1_instance;
  }
  function Key_F2_getInstance() {
    Key_initEntries();
    return Key_F2_instance;
  }
  function Key_F3_getInstance() {
    Key_initEntries();
    return Key_F3_instance;
  }
  function Key_F4_getInstance() {
    Key_initEntries();
    return Key_F4_instance;
  }
  function Key_F5_getInstance() {
    Key_initEntries();
    return Key_F5_instance;
  }
  function Key_F6_getInstance() {
    Key_initEntries();
    return Key_F6_instance;
  }
  function Key_F7_getInstance() {
    Key_initEntries();
    return Key_F7_instance;
  }
  function Key_F8_getInstance() {
    Key_initEntries();
    return Key_F8_instance;
  }
  function Key_F9_getInstance() {
    Key_initEntries();
    return Key_F9_instance;
  }
  function Key_F10_getInstance() {
    Key_initEntries();
    return Key_F10_instance;
  }
  function Key_F11_getInstance() {
    Key_initEntries();
    return Key_F11_instance;
  }
  function Key_F12_getInstance() {
    Key_initEntries();
    return Key_F12_instance;
  }
  function Key_NUM_LOCK_getInstance() {
    Key_initEntries();
    return Key_NUM_LOCK_instance;
  }
  function Key_SCROLL_LOCK_getInstance() {
    Key_initEntries();
    return Key_SCROLL_LOCK_instance;
  }
  function Key_MY_COMPUTER_getInstance() {
    Key_initEntries();
    return Key_MY_COMPUTER_instance;
  }
  function Key_MY_CALCULATOR_getInstance() {
    Key_initEntries();
    return Key_MY_CALCULATOR_instance;
  }
  function Key_SEMI_COLON_getInstance() {
    Key_initEntries();
    return Key_SEMI_COLON_instance;
  }
  function Key_EQUAL_SIGN_getInstance() {
    Key_initEntries();
    return Key_EQUAL_SIGN_instance;
  }
  function Key_COMMA_getInstance() {
    Key_initEntries();
    return Key_COMMA_instance;
  }
  function Key_DASH_getInstance() {
    Key_initEntries();
    return Key_DASH_instance;
  }
  function Key_PERIOD_getInstance() {
    Key_initEntries();
    return Key_PERIOD_instance;
  }
  function Key_FORWARD_SLASH_getInstance() {
    Key_initEntries();
    return Key_FORWARD_SLASH_instance;
  }
  function Key_OPEN_BRACKET_getInstance() {
    Key_initEntries();
    return Key_OPEN_BRACKET_instance;
  }
  function Key_BACK_SLASH_getInstance() {
    Key_initEntries();
    return Key_BACK_SLASH_instance;
  }
  function Key_CLOSE_BRAKET_getInstance() {
    Key_initEntries();
    return Key_CLOSE_BRAKET_instance;
  }
  function Key_SINGLE_QUOTE_getInstance() {
    Key_initEntries();
    return Key_SINGLE_QUOTE_instance;
  }
  function Key_DPAD_CENTER_getInstance() {
    Key_initEntries();
    return Key_DPAD_CENTER_instance;
  }
  function TouchSignal_TOUCH1_getInstance() {
    TouchSignal_initEntries();
    return TouchSignal_TOUCH1_instance;
  }
  function TouchSignal_TOUCH2_getInstance() {
    TouchSignal_initEntries();
    return TouchSignal_TOUCH2_instance;
  }
  function TouchSignal_TOUCH3_getInstance() {
    TouchSignal_initEntries();
    return TouchSignal_TOUCH3_instance;
  }
  var Key_ANY_KEY_instance;
  var Key_BACKSPACE_instance;
  var Key_TAB_instance;
  var Key_ENTER_instance;
  var Key_SHIFT_instance;
  var Key_CTRL_instance;
  var Key_ALT_instance;
  var Key_PAUSE_BREAK_instance;
  var Key_CAPS_LOCK_instance;
  var Key_ESCAPE_instance;
  var Key_PAGE_UP_instance;
  var Key_SPACE_instance;
  var Key_PAGE_DOWN_instance;
  var Key_END_instance;
  var Key_HOME_instance;
  var Key_ARROW_LEFT_instance;
  var Key_ARROW_UP_instance;
  var Key_ARROW_RIGHT_instance;
  var Key_ARROW_DOWN_instance;
  var Key_PRINT_SCREEN_instance;
  var Key_INSERT_instance;
  var Key_DELETE_instance;
  var Key_NUM0_instance;
  var Key_NUM1_instance;
  var Key_NUM2_instance;
  var Key_NUM3_instance;
  var Key_NUM4_instance;
  var Key_NUM5_instance;
  var Key_NUM6_instance;
  var Key_NUM7_instance;
  var Key_NUM8_instance;
  var Key_NUM9_instance;
  var Key_A_instance;
  var Key_B_instance;
  var Key_C_instance;
  var Key_D_instance;
  var Key_E_instance;
  var Key_F_instance;
  var Key_G_instance;
  var Key_H_instance;
  var Key_I_instance;
  var Key_J_instance;
  var Key_K_instance;
  var Key_L_instance;
  var Key_M_instance;
  var Key_N_instance;
  var Key_O_instance;
  var Key_P_instance;
  var Key_Q_instance;
  var Key_R_instance;
  var Key_S_instance;
  var Key_T_instance;
  var Key_U_instance;
  var Key_V_instance;
  var Key_W_instance;
  var Key_X_instance;
  var Key_Y_instance;
  var Key_Z_instance;
  var Key_LEFT_WINDOW_KEY_instance;
  var Key_RIGHT_WINDOW_KEY_instance;
  var Key_SELECT_KEY_instance;
  var Key_NUMPAD0_instance;
  var Key_NUMPAD1_instance;
  var Key_NUMPAD2_instance;
  var Key_NUMPAD3_instance;
  var Key_NUMPAD4_instance;
  var Key_NUMPAD5_instance;
  var Key_NUMPAD6_instance;
  var Key_NUMPAD7_instance;
  var Key_NUMPAD8_instance;
  var Key_NUMPAD9_instance;
  var Key_MULTIPLY_instance;
  var Key_ADD_instance;
  var Key_SUBTRACT_instance;
  var Key_DECIMAL_POINT_instance;
  var Key_DIVIDE_instance;
  var Key_F1_instance;
  var Key_F2_instance;
  var Key_F3_instance;
  var Key_F4_instance;
  var Key_F5_instance;
  var Key_F6_instance;
  var Key_F7_instance;
  var Key_F8_instance;
  var Key_F9_instance;
  var Key_F10_instance;
  var Key_F11_instance;
  var Key_F12_instance;
  var Key_NUM_LOCK_instance;
  var Key_SCROLL_LOCK_instance;
  var Key_MY_COMPUTER_instance;
  var Key_MY_CALCULATOR_instance;
  var Key_SEMI_COLON_instance;
  var Key_EQUAL_SIGN_instance;
  var Key_COMMA_instance;
  var Key_DASH_instance;
  var Key_PERIOD_instance;
  var Key_FORWARD_SLASH_instance;
  var Key_OPEN_BRACKET_instance;
  var Key_BACK_SLASH_instance;
  var Key_CLOSE_BRAKET_instance;
  var Key_SINGLE_QUOTE_instance;
  var Key_DPAD_CENTER_instance;
  var Key_entriesInitialized;
  function Key_initEntries() {
    if (Key_entriesInitialized)
      return Unit_getInstance();
    Key_entriesInitialized = true;
    Key_ANY_KEY_instance = new Key_4('ANY_KEY', 0);
    Key_BACKSPACE_instance = new Key_4('BACKSPACE', 1);
    Key_TAB_instance = new Key_4('TAB', 2);
    Key_ENTER_instance = new Key_4('ENTER', 3);
    Key_SHIFT_instance = new Key_4('SHIFT', 4);
    Key_CTRL_instance = new Key_4('CTRL', 5);
    Key_ALT_instance = new Key_4('ALT', 6);
    Key_PAUSE_BREAK_instance = new Key_4('PAUSE_BREAK', 7);
    Key_CAPS_LOCK_instance = new Key_4('CAPS_LOCK', 8);
    Key_ESCAPE_instance = new Key_4('ESCAPE', 9);
    Key_PAGE_UP_instance = new Key_4('PAGE_UP', 10);
    Key_SPACE_instance = new Key_4('SPACE', 11);
    Key_PAGE_DOWN_instance = new Key_4('PAGE_DOWN', 12);
    Key_END_instance = new Key_4('END', 13);
    Key_HOME_instance = new Key_4('HOME', 14);
    Key_ARROW_LEFT_instance = new Key_4('ARROW_LEFT', 15);
    Key_ARROW_UP_instance = new Key_4('ARROW_UP', 16);
    Key_ARROW_RIGHT_instance = new Key_4('ARROW_RIGHT', 17);
    Key_ARROW_DOWN_instance = new Key_4('ARROW_DOWN', 18);
    Key_PRINT_SCREEN_instance = new Key_4('PRINT_SCREEN', 19);
    Key_INSERT_instance = new Key_4('INSERT', 20);
    Key_DELETE_instance = new Key_4('DELETE', 21);
    Key_NUM0_instance = new Key_4('NUM0', 22);
    Key_NUM1_instance = new Key_4('NUM1', 23);
    Key_NUM2_instance = new Key_4('NUM2', 24);
    Key_NUM3_instance = new Key_4('NUM3', 25);
    Key_NUM4_instance = new Key_4('NUM4', 26);
    Key_NUM5_instance = new Key_4('NUM5', 27);
    Key_NUM6_instance = new Key_4('NUM6', 28);
    Key_NUM7_instance = new Key_4('NUM7', 29);
    Key_NUM8_instance = new Key_4('NUM8', 30);
    Key_NUM9_instance = new Key_4('NUM9', 31);
    Key_A_instance = new Key_4('A', 32);
    Key_B_instance = new Key_4('B', 33);
    Key_C_instance = new Key_4('C', 34);
    Key_D_instance = new Key_4('D', 35);
    Key_E_instance = new Key_4('E', 36);
    Key_F_instance = new Key_4('F', 37);
    Key_G_instance = new Key_4('G', 38);
    Key_H_instance = new Key_4('H', 39);
    Key_I_instance = new Key_4('I', 40);
    Key_J_instance = new Key_4('J', 41);
    Key_K_instance = new Key_4('K', 42);
    Key_L_instance = new Key_4('L', 43);
    Key_M_instance = new Key_4('M', 44);
    Key_N_instance = new Key_4('N', 45);
    Key_O_instance = new Key_4('O', 46);
    Key_P_instance = new Key_4('P', 47);
    Key_Q_instance = new Key_4('Q', 48);
    Key_R_instance = new Key_4('R', 49);
    Key_S_instance = new Key_4('S', 50);
    Key_T_instance = new Key_4('T', 51);
    Key_U_instance = new Key_4('U', 52);
    Key_V_instance = new Key_4('V', 53);
    Key_W_instance = new Key_4('W', 54);
    Key_X_instance = new Key_4('X', 55);
    Key_Y_instance = new Key_4('Y', 56);
    Key_Z_instance = new Key_4('Z', 57);
    Key_LEFT_WINDOW_KEY_instance = new Key_4('LEFT_WINDOW_KEY', 58);
    Key_RIGHT_WINDOW_KEY_instance = new Key_4('RIGHT_WINDOW_KEY', 59);
    Key_SELECT_KEY_instance = new Key_4('SELECT_KEY', 60);
    Key_NUMPAD0_instance = new Key_4('NUMPAD0', 61);
    Key_NUMPAD1_instance = new Key_4('NUMPAD1', 62);
    Key_NUMPAD2_instance = new Key_4('NUMPAD2', 63);
    Key_NUMPAD3_instance = new Key_4('NUMPAD3', 64);
    Key_NUMPAD4_instance = new Key_4('NUMPAD4', 65);
    Key_NUMPAD5_instance = new Key_4('NUMPAD5', 66);
    Key_NUMPAD6_instance = new Key_4('NUMPAD6', 67);
    Key_NUMPAD7_instance = new Key_4('NUMPAD7', 68);
    Key_NUMPAD8_instance = new Key_4('NUMPAD8', 69);
    Key_NUMPAD9_instance = new Key_4('NUMPAD9', 70);
    Key_MULTIPLY_instance = new Key_4('MULTIPLY', 71);
    Key_ADD_instance = new Key_4('ADD', 72);
    Key_SUBTRACT_instance = new Key_4('SUBTRACT', 73);
    Key_DECIMAL_POINT_instance = new Key_4('DECIMAL_POINT', 74);
    Key_DIVIDE_instance = new Key_4('DIVIDE', 75);
    Key_F1_instance = new Key_4('F1', 76);
    Key_F2_instance = new Key_4('F2', 77);
    Key_F3_instance = new Key_4('F3', 78);
    Key_F4_instance = new Key_4('F4', 79);
    Key_F5_instance = new Key_4('F5', 80);
    Key_F6_instance = new Key_4('F6', 81);
    Key_F7_instance = new Key_4('F7', 82);
    Key_F8_instance = new Key_4('F8', 83);
    Key_F9_instance = new Key_4('F9', 84);
    Key_F10_instance = new Key_4('F10', 85);
    Key_F11_instance = new Key_4('F11', 86);
    Key_F12_instance = new Key_4('F12', 87);
    Key_NUM_LOCK_instance = new Key_4('NUM_LOCK', 88);
    Key_SCROLL_LOCK_instance = new Key_4('SCROLL_LOCK', 89);
    Key_MY_COMPUTER_instance = new Key_4('MY_COMPUTER', 90);
    Key_MY_CALCULATOR_instance = new Key_4('MY_CALCULATOR', 91);
    Key_SEMI_COLON_instance = new Key_4('SEMI_COLON', 92);
    Key_EQUAL_SIGN_instance = new Key_4('EQUAL_SIGN', 93);
    Key_COMMA_instance = new Key_4('COMMA', 94);
    Key_DASH_instance = new Key_4('DASH', 95);
    Key_PERIOD_instance = new Key_4('PERIOD', 96);
    Key_FORWARD_SLASH_instance = new Key_4('FORWARD_SLASH', 97);
    Key_OPEN_BRACKET_instance = new Key_4('OPEN_BRACKET', 98);
    Key_BACK_SLASH_instance = new Key_4('BACK_SLASH', 99);
    Key_CLOSE_BRAKET_instance = new Key_4('CLOSE_BRAKET', 100);
    Key_SINGLE_QUOTE_instance = new Key_4('SINGLE_QUOTE', 101);
    Key_DPAD_CENTER_instance = new Key_4('DPAD_CENTER', 102);
  }
  var TouchSignal_TOUCH1_instance;
  var TouchSignal_TOUCH2_instance;
  var TouchSignal_TOUCH3_instance;
  function values_0() {
    return [TouchSignal_TOUCH1_getInstance(), TouchSignal_TOUCH2_getInstance(), TouchSignal_TOUCH3_getInstance()];
  }
  var TouchSignal_entriesInitialized;
  function TouchSignal_initEntries() {
    if (TouchSignal_entriesInitialized)
      return Unit_getInstance();
    TouchSignal_entriesInitialized = true;
    TouchSignal_TOUCH1_instance = new TouchSignal('TOUCH1', 0);
    TouchSignal_TOUCH2_instance = new TouchSignal('TOUCH2', 1);
    TouchSignal_TOUCH3_instance = new TouchSignal('TOUCH3', 2);
  }
  function TouchManager(lastKeyCode) {
    this._touchSignalCache = values_0();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = values_0().length;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = null;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._type_6 = tmp_2;
    var tmp_4 = this;
    var tmp_5 = 0;
    var tmp_6 = values_0().length;
    var tmp_7 = fillArrayVal(Array(tmp_6), null);
    while (tmp_5 < tmp_6) {
      var tmp_8 = tmp_5;
      tmp_7[tmp_8] = null;
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4._touch_1 = tmp_7;
    var tmp_9 = this;
    var tmp_10 = 0;
    var tmp_11 = values_0().length;
    var tmp_12 = fillArrayVal(Array(tmp_11), null);
    while (tmp_10 < tmp_11) {
      var tmp_13 = tmp_10;
      tmp_12[tmp_13] = null;
      tmp_10 = tmp_10 + 1 | 0;
    }
    tmp_9._justTouch = tmp_12;
    var tmp_14 = this;
    var tmp_15 = 0;
    var tmp_16 = lastKeyCode + 1 | 0;
    var tmp_17 = fillArrayVal(Array(tmp_16), null);
    while (tmp_15 < tmp_16) {
      var tmp_18 = tmp_15;
      tmp_17[tmp_18] = false;
      tmp_15 = tmp_15 + 1 | 0;
    }
    tmp_14._keyPressed = tmp_17;
    var tmp_19 = this;
    var tmp_20 = 0;
    var tmp_21 = lastKeyCode + 1 | 0;
    var tmp_22 = fillArrayVal(Array(tmp_21), null);
    while (tmp_20 < tmp_21) {
      var tmp_23 = tmp_20;
      tmp_22[tmp_23] = false;
      tmp_20 = tmp_20 + 1 | 0;
    }
    tmp_19._justKeyPressed = tmp_22;
    var tmp_24 = this;
    tmp_24._justPressedKeyCode = LinkedHashSet_init_$Create$();
    this._numberOfKeyPressed = 0;
    this._isAnyKeyJustPressed = false;
    this._eventsPool = new InternalTouchEventObjectPool(this);
    var tmp_25 = this;
    tmp_25._queueEvents = ArrayList_init_$Create$();
  }
  TouchManager.prototype.getTouchSignal = function (id) {
    var tmp0_forEachIndexed_0 = this._type_6;
    var index_1 = 0;
    var indexedObject = tmp0_forEachIndexed_0;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_4 = index_1;
      index_1 = tmp1_4 + 1 | 0;
      var tmp1__anonymous__5 = tmp1_4;
      if (equals_1(id, item_3)) {
        return this._touchSignalCache[tmp1__anonymous__5];
      }}
    return assignTouchSignal(this, id);
  };
  TouchManager.prototype.onTouchDown = function (touchSignal, x, y) {
    var event = this._eventsPool.newInstance_1();
    var ordinal = touchSignal._get_ordinal__1();
    var tmp0_elvis_lhs = this._touch_1[ordinal];
    var position = tmp0_elvis_lhs == null ? event._position_11 : tmp0_elvis_lhs;
    event._way = InternalTouchEventWay_DOWN_getInstance();
    event._touchSignal = touchSignal;
    var tmp = event;
    position._x_10 = x;
    position._y_10 = y;
    tmp._position_11 = position;
    this._queueEvents.add_19(event);
    Unit_getInstance();
  };
  TouchManager.prototype.onTouchMove = function (touchSignal, x, y) {
    var event = this._eventsPool.newInstance_1();
    event._way = InternalTouchEventWay_MOVE_getInstance();
    event._position_11._x_10 = x;
    event._position_11._y_10 = y;
    event._touchSignal = touchSignal;
    this._queueEvents.add_19(event);
    Unit_getInstance();
  };
  TouchManager.prototype.onTouchUp = function (touchSignal) {
    var event = this._eventsPool.newInstance_1();
    event._way = InternalTouchEventWay_UP_getInstance();
    event._touchSignal = touchSignal;
    this._queueEvents.add_19(event);
    Unit_getInstance();
  };
  TouchManager.prototype.isJustTouched_1 = function (touchSignal) {
    return this._justTouch[touchSignal._get_ordinal__1()];
  };
  TouchManager.prototype.isKeyJustPressed_0 = function (keyCode) {
    return this._justKeyPressed[keyCode];
  };
  TouchManager.prototype.onKeyPressed = function (keyCode) {
    var event = this._eventsPool.newInstance_1();
    event._way = InternalTouchEventWay_DOWN_getInstance();
    event._keycode = keyCode;
    this._queueEvents.add_19(event);
    Unit_getInstance();
  };
  TouchManager.prototype.onKeyReleased = function (keyCode) {
    var event = this._eventsPool.newInstance_1();
    event._way = InternalTouchEventWay_UP_getInstance();
    event._keycode = keyCode;
    this._queueEvents.add_19(event);
    Unit_getInstance();
  };
  TouchManager.prototype.processReceivedEvent = function () {
    var tmp0_forEach_0 = _get_indices_(this._justTouch);
    var inductionVariable = tmp0_forEach_0._get_first__2();
    var last_2 = tmp0_forEach_0._get_last__4();
    if (inductionVariable <= last_2)
      do {
        var element_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._justTouch[element_2] = null;
      }
       while (!(element_2 === last_2));
    var tmp1_forEach_0 = this._justPressedKeyCode;
    var tmp0_iterator_1 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2_0 = tmp0_iterator_1.next_30();
      this._justKeyPressed[element_2_0] = false;
    }
    this._justPressedKeyCode.clear_15();
    this._isAnyKeyJustPressed = false;
    var tmp2_forEach_0 = this._queueEvents;
    var tmp0_iterator_1_0 = tmp2_forEach_0.iterator_52();
    while (tmp0_iterator_1_0.hasNext_27()) {
      var element_2_1 = tmp0_iterator_1_0.next_30();
      if (element_2_1._get_isTouchEvent_()) {
        processTouchEvent(this, element_2_1);
      } else {
        processKeyEvent(this, element_2_1);
      }
    }
    this._eventsPool.free_3(this._queueEvents);
    this._queueEvents.clear_15();
  };
  TouchManager.$metadata$ = {
    simpleName: 'TouchManager',
    kind: 'class',
    interfaces: []
  };
  function InternalTouchEventObjectPool($outer) {
    this._$this_12 = $outer;
    ObjectPool.call(this, 10);
  }
  InternalTouchEventObjectPool.prototype.newInstance_1 = function () {
    return InternalTouchEvent_init_$Create$(null, null, null, null, 15, null);
  };
  InternalTouchEventObjectPool.prototype.destroyInstance_1 = function (obj) {
    return Unit_getInstance();
  };
  InternalTouchEventObjectPool.prototype.destroyInstance_3 = function (obj) {
    return this.destroyInstance_1(obj instanceof InternalTouchEvent ? obj : THROW_CCE());
  };
  InternalTouchEventObjectPool.$metadata$ = {
    simpleName: 'InternalTouchEventObjectPool',
    kind: 'class',
    interfaces: []
  };
  function assignTouchSignal($this, id) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_indexOfFirst_0 = $this._type_6;
      var inductionVariable = 0;
      var last_2 = tmp0_indexOfFirst_0.length - 1 | 0;
      if (inductionVariable <= last_2)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1__anonymous__3 = tmp0_indexOfFirst_0[index_2];
          if (tmp1__anonymous__3 == null) {
            tmp$ret$0 = index_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_2);
      tmp$ret$0 = -1;
    }
     while (false);
    var ordinal = tmp$ret$0;
    var touchSignal = $this._touchSignalCache[ordinal];
    $this._type_6[ordinal] = id;
    return touchSignal;
  }
  function processKeyEvent($this, event) {
    var keycode = ensureNotNull(event._keycode);
    var tmp0_subject = event._way;
    if (tmp0_subject.equals(InternalTouchEventWay_DOWN_getInstance())) {
      $this._keyPressed[keycode] = true;
      $this._justKeyPressed[keycode] = true;
      $this._justPressedKeyCode.add_19(keycode);
      Unit_getInstance();
      $this._isAnyKeyJustPressed = true;
      var tmp1_this = $this;
      var tmp2 = tmp1_this._numberOfKeyPressed;
      tmp1_this._numberOfKeyPressed = tmp2 + 1 | 0;
      Unit_getInstance();
    } else if (tmp0_subject.equals(InternalTouchEventWay_UP_getInstance())) {
      $this._keyPressed[keycode] = false;
      var tmp3_this = $this;
      var tmp4 = tmp3_this._numberOfKeyPressed;
      tmp3_this._numberOfKeyPressed = tmp4 - 1 | 0;
      Unit_getInstance();
    } else if (tmp0_subject.equals(InternalTouchEventWay_MOVE_getInstance()))
      throw IllegalArgumentException_init_$Create$('' + event._keycode + ' is not supposed to move.');
    else {
      noWhenBranchMatchedException();
    }
  }
  function processTouchEvent($this, event) {
    var tmp0_subject = event._way;
    if (tmp0_subject.equals(InternalTouchEventWay_DOWN_getInstance())) {
      $this._justTouch[event._touchSignal._get_ordinal__1()] = event._position_11;
      $this._touch_1[event._touchSignal._get_ordinal__1()] = event._position_11;
    } else if (tmp0_subject.equals(InternalTouchEventWay_MOVE_getInstance())) {
      var tmp1_safe_receiver = $this._touch_1[event._touchSignal._get_ordinal__1()];
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver._x_10 = event._position_11._x_10;
        tmp1_safe_receiver._y_10 = event._position_11._y_10;
        Unit_getInstance();
      }
      Unit_getInstance();
    } else if (tmp0_subject.equals(InternalTouchEventWay_UP_getInstance())) {
      $this._touch_1[event._touchSignal._get_ordinal__1()] = null;
    } else {
      noWhenBranchMatchedException();
    }
  }
  function InternalTouchEvent(keycode, touchSignal, position, way) {
    this._keycode = keycode;
    this._touchSignal = touchSignal;
    this._position_11 = position;
    this._way = way;
  }
  InternalTouchEvent.prototype._get_isTouchEvent_ = function () {
    return this._keycode == null;
  };
  InternalTouchEvent.$metadata$ = {
    simpleName: 'InternalTouchEvent',
    kind: 'class',
    interfaces: []
  };
  function InternalTouchEvent_init_$Init$(keycode, touchSignal, position, way, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      keycode = null;
    if (!(($mask0 & 2) === 0))
      touchSignal = TouchSignal_TOUCH1_getInstance();
    if (!(($mask0 & 4) === 0))
      position = new Vector2(0.0, 0.0);
    if (!(($mask0 & 8) === 0))
      way = InternalTouchEventWay_DOWN_getInstance();
    InternalTouchEvent.call($this, keycode, touchSignal, position, way);
    return $this;
  }
  function InternalTouchEvent_init_$Create$(keycode, touchSignal, position, way, $mask0, $marker) {
    return InternalTouchEvent_init_$Init$(keycode, touchSignal, position, way, $mask0, $marker, Object.create(InternalTouchEvent.prototype));
  }
  function InternalTouchEventWay(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  InternalTouchEventWay.$metadata$ = {
    simpleName: 'InternalTouchEventWay',
    kind: 'class',
    interfaces: []
  };
  function InternalTouchEventWay_UP_getInstance() {
    InternalTouchEventWay_initEntries();
    return InternalTouchEventWay_UP_instance;
  }
  function InternalTouchEventWay_DOWN_getInstance() {
    InternalTouchEventWay_initEntries();
    return InternalTouchEventWay_DOWN_instance;
  }
  function InternalTouchEventWay_MOVE_getInstance() {
    InternalTouchEventWay_initEntries();
    return InternalTouchEventWay_MOVE_instance;
  }
  var InternalTouchEventWay_UP_instance;
  var InternalTouchEventWay_DOWN_instance;
  var InternalTouchEventWay_MOVE_instance;
  var InternalTouchEventWay_entriesInitialized;
  function InternalTouchEventWay_initEntries() {
    if (InternalTouchEventWay_entriesInitialized)
      return Unit_getInstance();
    InternalTouchEventWay_entriesInitialized = true;
    InternalTouchEventWay_UP_instance = new InternalTouchEventWay('UP', 0);
    InternalTouchEventWay_DOWN_instance = new InternalTouchEventWay('DOWN', 1);
    InternalTouchEventWay_MOVE_instance = new InternalTouchEventWay('MOVE', 2);
  }
  function Logger() {
  }
  Logger.$metadata$ = {
    simpleName: 'Logger',
    kind: 'interface',
    interfaces: []
  };
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARN_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_getInstance();
    LogLevel_entriesInitialized = true;
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 0);
    LogLevel_INFO_instance = new LogLevel('INFO', 1);
    LogLevel_WARN_instance = new LogLevel('WARN', 2);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 3);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LogLevel.$metadata$ = {
    simpleName: 'LogLevel',
    kind: 'class',
    interfaces: []
  };
  function LogLevel_INFO_getInstance() {
    LogLevel_initEntries();
    return LogLevel_INFO_instance;
  }
  function ImmutableVector3(delegate) {
    this._delegate_1 = delegate;
  }
  ImmutableVector3.prototype._get_x_ = function () {
    return this._delegate_1._x_11;
  };
  ImmutableVector3.prototype._get_y_ = function () {
    return this._delegate_1._y_11;
  };
  ImmutableVector3.prototype._get_z_ = function () {
    return this._delegate_1._z_7;
  };
  ImmutableVector3.prototype.toFloat3_0 = function () {
    return new Float3(this._get_x_(), this._get_y_(), this._get_z_());
  };
  ImmutableVector3.prototype.toString = function () {
    return this._delegate_1.toString();
  };
  ImmutableVector3.$metadata$ = {
    simpleName: 'ImmutableVector3',
    kind: 'class',
    interfaces: []
  };
  function Interpolation() {
  }
  Interpolation.prototype.interpolate_6 = function (a, b, percent) {
    return a + (b - a) * this.interpolate_5(percent);
  };
  Interpolation.$metadata$ = {
    simpleName: 'Interpolation',
    kind: 'interface',
    interfaces: []
  };
  function Interpolations() {
    Interpolations_instance = this;
    this._pow = new PowInterpolation(2);
    this._elastic = new ElasticInterpolation(2.0, 10.0, 7, 1.0);
    this._linear = new LinearInterpolation();
  }
  Interpolations.prototype.lerp = function (target, current, step) {
    return target + step * (current - target);
  };
  Interpolations.prototype.lerp$default = function (target, current, step, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      step = 0.9;
    return this.lerp(target, current, step);
  };
  Interpolations.$metadata$ = {
    simpleName: 'Interpolations',
    kind: 'object',
    interfaces: []
  };
  var Interpolations_instance;
  function Interpolations_getInstance() {
    if (Interpolations_instance == null)
      new Interpolations();
    return Interpolations_instance;
  }
  function PowInterpolation(power) {
    this._power = power;
  }
  PowInterpolation.prototype.interpolate_5 = function (percent) {
    var tmp;
    if (percent <= 0.5) {
      var tmp0_pow_0 = percent * 2.0;
      var tmp1_pow_0 = this._power;
      tmp = Math.pow(tmp0_pow_0, tmp1_pow_0) / 2;
    } else {
      var tmp2_pow_0 = (percent - 1) * 2.0;
      var tmp3_pow_0 = this._power;
      tmp = Math.pow(tmp2_pow_0, tmp3_pow_0) / (this._power % 2 === 0 ? -2 : 2) + 1;
    }
    return tmp;
  };
  PowInterpolation.$metadata$ = {
    simpleName: 'PowInterpolation',
    kind: 'class',
    interfaces: [Interpolation]
  };
  function ElasticInterpolation(value, power, bounces, scale_1) {
    this._value_13 = value;
    this._power_0 = power;
    this._scale_6 = scale_1;
    this._bounces = bounces * 3.141592653589793 * (bounces % 2 === 0 ? 1.0 : -1.0);
  }
  ElasticInterpolation.prototype.interpolate_5 = function (percent) {
    var a = percent;
    if (a <= 0.5) {
      a = a * 2.0;
      var tmp0_pow_0 = this._value_13;
      var tmp1_pow_0 = this._power_0 * (a - 1);
      var tmp = Math.pow(tmp0_pow_0, tmp1_pow_0);
      var tmp2_sin_0 = a * this._bounces;
      return tmp * Math.sin(tmp2_sin_0) * this._scale_6 / 2;
    }a = 1 - a;
    a = a * 2.0;
    var tmp3_pow_0 = this._value_13;
    var tmp4_pow_0 = this._power_0 * (a - 1);
    var tmp_0 = Math.pow(tmp3_pow_0, tmp4_pow_0);
    var tmp5_sin_0 = a * this._bounces;
    return 1 - tmp_0 * Math.sin(tmp5_sin_0) * this._scale_6 / 2;
  };
  ElasticInterpolation.$metadata$ = {
    simpleName: 'ElasticInterpolation',
    kind: 'class',
    interfaces: [Interpolation]
  };
  function LinearInterpolation() {
  }
  LinearInterpolation.prototype.interpolate_5 = function (percent) {
    return percent;
  };
  LinearInterpolation.$metadata$ = {
    simpleName: 'LinearInterpolation',
    kind: 'class',
    interfaces: [Interpolation]
  };
  function Vector2(x, y) {
    this._x_10 = x;
    this._y_10 = y;
  }
  Vector2.prototype.toString = function () {
    return '' + 'Vector2(x=' + this._x_10 + ', y=' + this._y_10 + ')';
  };
  Vector2.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_10);
    result = imul(result, 31) + getNumberHashCode(this._y_10) | 0;
    return result;
  };
  Vector2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Vector2 ? other : THROW_CCE();
    if (!equals_1(this._x_10, tmp0_other_with_cast._x_10))
      return false;
    if (!equals_1(this._y_10, tmp0_other_with_cast._y_10))
      return false;
    return true;
  };
  Vector2.$metadata$ = {
    simpleName: 'Vector2',
    kind: 'class',
    interfaces: []
  };
  function Vector2_init_$Init$(x, y, $this) {
    Vector2.call($this, numberToDouble(x), numberToDouble(y));
    return $this;
  }
  function Vector2_init_$Create$(x, y) {
    return Vector2_init_$Init$(x, y, Object.create(Vector2.prototype));
  }
  function Vector3(x, y, z) {
    this._x_11 = x;
    this._y_11 = y;
    this._z_7 = z;
  }
  Vector3.prototype.add_38 = function (x, y, z) {
    var tmp0_this = this;
    tmp0_this._x_11 = tmp0_this._x_11 + numberToDouble(x);
    var tmp1_this = this;
    tmp1_this._y_11 = tmp1_this._y_11 + numberToDouble(y);
    var tmp2_this = this;
    tmp2_this._z_7 = tmp2_this._z_7 + numberToDouble(z);
    return this;
  };
  Vector3.prototype.sub = function (other) {
    return this.add_38(-other._x_11, -other._y_11, -other._z_7);
  };
  Vector3.prototype.negate = function () {
    this._x_11 = -this._x_11;
    this._y_11 = -this._y_11;
    this._z_7 = -this._z_7;
    return this;
  };
  Vector3.prototype.set_4 = function (x, y, z) {
    this._x_11 = numberToDouble(x);
    this._y_11 = numberToDouble(y);
    this._z_7 = numberToDouble(z);
    return this;
  };
  Vector3.prototype.set_5 = function (other) {
    return this.set_4(other._x_11, other._y_11, other._z_7);
  };
  Vector3.prototype.set_6 = function (other) {
    return this.set_4(other._get_x_(), other._get_y_(), other._get_z_());
  };
  Vector3.prototype.dot = function (other) {
    return this._x_11 * other._x_11 + this._y_11 * other._y_11 + this._z_7 * other._z_7;
  };
  Vector3.prototype.project = function (other) {
    var n = this.dot(other);
    var d = other.length2();
    return this.set_5(other).scale_0(n / d);
  };
  Vector3.prototype.scale_0 = function (scalar) {
    var tmp0_this = this;
    tmp0_this._x_11 = tmp0_this._x_11 * scalar;
    var tmp1_this = this;
    tmp1_this._y_11 = tmp1_this._y_11 * scalar;
    var tmp2_this = this;
    tmp2_this._z_7 = tmp2_this._z_7 * scalar;
    return this;
  };
  Vector3.prototype.normalize_0 = function () {
    var len2 = this._x_11 * this._x_11 + this._y_11 * this._y_11 + this._z_7 * this._z_7;
    var tmp;
    switch (len2) {
      case 0.0:
      case 1.0:
        tmp = this;
        break;
      default:var scalar = 1.0 / Math.sqrt(len2);
        tmp = new Vector3(this._x_11 * scalar, this._y_11 * scalar, this._z_7 * scalar);
        break;
    }
    return tmp;
  };
  Vector3.prototype.length2 = function () {
    return this._x_11 * this._x_11 + this._y_11 * this._y_11 + this._z_7 * this._z_7;
  };
  Vector3.prototype.toFloat3_0 = function () {
    return new Float3(this._x_11, this._y_11, this._z_7);
  };
  Vector3.prototype.copy_1 = function (x, y, z) {
    return new Vector3(x, y, z);
  };
  Vector3.prototype.copy$default_1 = function (x, y, z, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      x = this._x_11;
    if (!(($mask0 & 2) === 0))
      y = this._y_11;
    if (!(($mask0 & 4) === 0))
      z = this._z_7;
    return this.copy_1(x, y, z);
  };
  Vector3.prototype.toString = function () {
    return '' + 'Vector3(x=' + this._x_11 + ', y=' + this._y_11 + ', z=' + this._z_7 + ')';
  };
  Vector3.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_11);
    result = imul(result, 31) + getNumberHashCode(this._y_11) | 0;
    result = imul(result, 31) + getNumberHashCode(this._z_7) | 0;
    return result;
  };
  Vector3.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Vector3 ? other : THROW_CCE();
    if (!equals_1(this._x_11, tmp0_other_with_cast._x_11))
      return false;
    if (!equals_1(this._y_11, tmp0_other_with_cast._y_11))
      return false;
    if (!equals_1(this._z_7, tmp0_other_with_cast._z_7))
      return false;
    return true;
  };
  Vector3.$metadata$ = {
    simpleName: 'Vector3',
    kind: 'class',
    interfaces: []
  };
  function toVector3(_this_) {
    return new Vector3(_this_._x_2, _this_._y_2, _this_._z_2);
  }
  function Vector3_init_$Init$(x, y, z, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    if (!(($mask0 & 4) === 0))
      z = 0.0;
    Vector3.call($this, x, y, z);
    return $this;
  }
  function Vector3_init_$Create$(x, y, z, $mask0, $marker) {
    return Vector3_init_$Init$(x, y, z, $mask0, $marker, Object.create(Vector3.prototype));
  }
  function Vector3_init_$Init$_0(x, y, z, $this) {
    Vector3.call($this, numberToDouble(x), numberToDouble(y), numberToDouble(z));
    return $this;
  }
  function Vector3_init_$Create$_0(x, y, z) {
    return Vector3_init_$Init$_0(x, y, z, Object.create(Vector3.prototype));
  }
  function Companion_25() {
    Companion_instance_24 = this;
    this._X = Vector3_init_$Create$_0(1, 0, 0);
    this._Y = Vector3_init_$Create$_0(0, 1, 0);
    this._MINUS_X = Vector3_init_$Create$_0(-1, 0, 0);
    this._MINUS_Y = Vector3_init_$Create$_0(0, -1, 0);
    this._Z = Vector3_init_$Create$_0(0, 0, 1);
    this._ZERO = Vector3_init_$Create$_0(0, 0, 0);
    this._FORWARD = this._Z;
    this._UP_0 = this._Y;
  }
  Companion_25.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_25();
    return Companion_instance_24;
  }
  function AnimatedModelRenderStage(gameContext) {
    var tmp = new AnimatedMeshVertexShader();
    var tmp_0 = new UVFragmentShader();
    var tmp_1 = EntityQuery_init_$Create$_0([getKClass_0(AnimatedComponent)]);
    RenderStage_init_$Init$(gameContext, tmp, tmp_0, tmp_1, null, null, 48, null, this);
  }
  AnimatedModelRenderStage.prototype.update_61 = function (delta_0, entity) {
    var model = entity.get_44(getKClass_0(Position_0))._get_transformation__0();
    var animatedModel = entity.get_44(getKClass_0(AnimatedComponent));
    this._get_vertex__3()._uModelView.apply(this._get_program__5(), this._get_combinedMatrix__2().times_0(model));
    this._get_vertex__3()._uJointTransformationMatrix.apply_0(this._get_program__5(), animatedModel._currentPose);
    var currentLight = this._get_light__2();
    if (currentLight == null) {
      this._get_vertex__3()._uLightColor.apply_4(this._get_program__5(), Companion_getInstance_17()._TRANSPARENT_COLOR);
      this._get_vertex__3()._uLightPosition.apply_2(this._get_program__5(), Companion_getInstance_17()._ORIGIN);
    } else {
      var intensity = currentLight.get_44(getKClass_0(LightComponent))._intensity_0 * 777.0 / 1000.0 / 1000.0;
      this._get_vertex__3()._uLightColor.apply_5(this._get_program__5(), currentLight.get_44(getKClass_0(LightComponent))._color_1, intensity);
      var tmp0__get_translation__0 = inverse(model).times_0(currentLight.get_44(getKClass_0(Position_0))._get_transformation__0());
      var tmp0__get_xyz__0_1 = tmp0__get_translation__0._w_0;
      var translation_1 = new Float3(tmp0__get_xyz__0_1._x_3, tmp0__get_xyz__0_1._y_3, tmp0__get_xyz__0_1._z_3);
      this._get_vertex__3()._uLightPosition.apply_7(this._get_program__5(), new Float32Array([translation_1._x_2, translation_1._y_2, translation_1._z_2]));
    }
    var tmp1_flatMap_0 = animatedModel._animatedModel._models_0;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp1_flatMap_0.iterator_52();
    while (tmp0_iterator_1_2.hasNext_27()) {
      var element_2_3 = tmp0_iterator_1_2.next_30();
      var list_3_4 = element_2_3._primitives_0;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    var tmp2_forEach_0 = tmp0_flatMapTo_0_1;
    var tmp0_iterator_1 = tmp2_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      this._get_vertex__3()._aVertexPosition.apply_10(this._get_program__5(), ensureNotNull(element_2._verticesBuffer));
      this._get_vertex__3()._aVertexNormal.apply_10(this._get_program__5(), ensureNotNull(element_2._normalsBuffer));
      this._get_vertex__3()._aUVPosition.apply_10(this._get_program__5(), ensureNotNull(element_2._uvsBuffer));
      this._get_vertex__3()._aWeights.apply_10(this._get_program__5(), ensureNotNull(element_2._weightsBuffer));
      this._get_vertex__3()._aJoints.apply_10(this._get_program__5(), ensureNotNull(element_2._jointsBuffer));
      this._get_fragment__2()._uUV.apply_11(this._get_program__5(), ensureNotNull(element_2._texture_0._textureReference), 0);
      this._get_gl__4().bindBuffer_2(34963, ensureNotNull(element_2._verticesOrderBuffer));
      this._get_gl__4().drawElements_2(4, element_2._verticesOrder_3.length, 5123, 0);
    }
  };
  AnimatedModelRenderStage.$metadata$ = {
    simpleName: 'AnimatedModelRenderStage',
    kind: 'class',
    interfaces: []
  };
  function BoundingBoxRenderStage(gameContext) {
    var tmp = new BoundingBoxVertexShader();
    var tmp_0 = new ColorFragmentShader();
    var tmp_1 = Companion_getInstance_23().of_0([getKClass_0(BoundingBoxComponent)]);
    RenderStage_init_$Init$(gameContext, tmp, tmp_0, tmp_1, null, null, 48, null, this);
    var tmp_2 = this;
    var tmp_3 = Id_init_$Create$(null, 1, null);
    var tmp0_byteArrayOf_0 = new Int8Array([]);
    var tmp_4 = Texture_init_$Create$(tmp_3, tmp0_byteArrayOf_0, 0, 0, false);
    var tmp1_floatArrayOf_0 = new Float32Array([-1.0, -1.0, -1.0, 1.0, -1.0, -1.0, -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, -1.0, -1.0, 1.0, 1.0, -1.0, 1.0, -1.0, 1.0, 1.0, 1.0, 1.0, 1.0]);
    var tmp2_floatArrayOf_0 = new Float32Array([]);
    var tmp3_floatArrayOf_0 = new Float32Array([]);
    var tmp4_shortArrayOf_0 = new Int16Array([0, 1, 1, 3, 3, 2, 2, 0, 4, 5, 5, 7, 7, 6, 6, 4, 4, 0, 1, 5, 2, 6, 3, 7]);
    var tmp_5 = listOf_0(Primitive_init_$Create$_0(tmp_4, tmp1_floatArrayOf_0, tmp2_floatArrayOf_0, tmp3_floatArrayOf_0, null, null, tmp4_shortArrayOf_0, null, 176, null));
    tmp_2._cube = Model_init_$Create$_0(tmp_5, false, 2, null);
  }
  BoundingBoxRenderStage.prototype.onGameStarted_25 = function (engine) {
    this._get_gameContext__32()._assetsManager.add_35(this._cube);
  };
  BoundingBoxRenderStage.prototype.update_61 = function (delta_0, entity) {
    var model = entity.get_44(getKClass_0(Position_0))._get_transformation__0();
    var box = entity.get_44(getKClass_0(BoundingBoxComponent));
    this._get_vertex__3()._uModelView_0.apply(this._get_program__5(), this._get_combinedMatrix__2().times_0(model).times_0(box._fromDefaultTransformation));
    render(this, box);
    box._touch = false;
  };
  BoundingBoxRenderStage.$metadata$ = {
    simpleName: 'BoundingBoxRenderStage',
    kind: 'class',
    interfaces: []
  };
  function render($this, box) {
    var tmp0_forEach_0 = $this._cube._primitives_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      $this._get_vertex__3()._aVertexPosition_0.apply_10($this._get_program__5(), ensureNotNull(element_2._verticesBuffer));
      if (box._touch) {
        $this._get_vertex__3()._uColor.apply_7($this._get_program__5(), new Float32Array([1.0, 0.0, 0.0, 1.0]));
      } else {
        $this._get_vertex__3()._uColor.apply_7($this._get_program__5(), new Float32Array([-1.0, -1.0, -1.0, -1.0]));
      }
      $this._get_gl__4().bindBuffer_2(34963, ensureNotNull(element_2._verticesOrderBuffer));
      $this._get_gl__4().drawElements_2(1, element_2._verticesOrder_3.length, 5123, 0);
    }
    return Unit_getInstance();
  }
  function ClearBufferRenderStage(gameContext, clearColor) {
    var tmp = EmptyVertexShader_getInstance();
    var tmp_0 = EmptyFragmentShader_getInstance();
    var tmp_1 = Companion_getInstance_23().none();
    RenderStage_init_$Init$(gameContext, tmp, tmp_0, tmp_1, null, null, 48, null, this);
    this._clearColor = clearColor;
  }
  ClearBufferRenderStage.prototype.compileShaders_6 = function () {
    return Unit_getInstance();
  };
  ClearBufferRenderStage.prototype.update_62 = function (delta_0) {
    this._get_gl__4().clearColor_2(this._clearColor._red, this._clearColor._green, this._clearColor._blue, this._clearColor._alpha_0);
    this._get_gl__4().clearDepth_2(1.0);
    this._get_gl__4().enable_2(2929);
    this._get_gl__4().depthFunc_2(515);
    this._get_gl__4().clear_18(16640);
  };
  ClearBufferRenderStage.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  ClearBufferRenderStage.$metadata$ = {
    simpleName: 'ClearBufferRenderStage',
    kind: 'class',
    interfaces: []
  };
  function EmptyVertexShader() {
    EmptyVertexShader_instance = this;
    VertexShader.call(this, '');
  }
  EmptyVertexShader.$metadata$ = {
    simpleName: 'EmptyVertexShader',
    kind: 'object',
    interfaces: []
  };
  var EmptyVertexShader_instance;
  function EmptyVertexShader_getInstance() {
    if (EmptyVertexShader_instance == null)
      new EmptyVertexShader();
    return EmptyVertexShader_instance;
  }
  function EmptyFragmentShader() {
    EmptyFragmentShader_instance = this;
    FragmentShader.call(this, '');
  }
  EmptyFragmentShader.$metadata$ = {
    simpleName: 'EmptyFragmentShader',
    kind: 'object',
    interfaces: []
  };
  var EmptyFragmentShader_instance;
  function EmptyFragmentShader_getInstance() {
    if (EmptyFragmentShader_instance == null)
      new EmptyFragmentShader();
    return EmptyFragmentShader_instance;
  }
  function ModelComponentRenderStage(gameContext, query, cameraQuery) {
    var tmp = new MeshVertexShader();
    var tmp_0 = new UVFragmentShader();
    RenderStage_init_$Init$(gameContext, tmp, tmp_0, query, cameraQuery, null, 32, null, this);
    var tmp_1 = this;
    tmp_1._transparentPrimitive = ArrayList_init_$Create$();
    var tmp_2 = this;
    var tmp_3 = Companion_getInstance_24()._FORWARD;
    tmp_2._cameraDirection = tmp_3.copy$default_1(0.0, 0.0, 0.0, 7, null);
    var tmp_4 = this;
    var tmp_5 = Companion_getInstance_24()._ZERO;
    tmp_4._cameraPosition = tmp_5.copy$default_1(0.0, 0.0, 0.0, 7, null);
  }
  ModelComponentRenderStage.prototype.update_62 = function (delta_0) {
    var tmp0_safe_receiver = this._get_camera__5();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var position_2 = tmp0_safe_receiver.get_44(getKClass_0(Position_0));
      var direction_3 = rotation(position_2._get_transformation__0()).times_0(translation(Companion_getInstance_24()._FORWARD.toFloat3_0()));
      var tmp0__get_xyz__0_1_4 = direction_3._w_0;
      this._cameraDirection.set_5(toVector3(new Float3(tmp0__get_xyz__0_1_4._x_3, tmp0__get_xyz__0_1_4._y_3, tmp0__get_xyz__0_1_4._z_3))).normalize_0().negate();
      Unit_getInstance();
      var tmp0__get_translation__0_5 = position_2._get_transformation__0();
      var tmp0__get_xyz__0_1_6 = tmp0__get_translation__0_5._w_0;
      this._cameraPosition.set_5(toVector3(new Float3(tmp0__get_xyz__0_1_6._x_3, tmp0__get_xyz__0_1_6._y_3, tmp0__get_xyz__0_1_6._z_3)));
    }
    Unit_getInstance();
    RenderStage.prototype.update_62.call(this, delta_0);
    this._get_gl__4().enable_2(3042);
    this._get_gl__4().blendFunc_2(770, 771);
    var tmp0_sortByDescending_0 = this._transparentPrimitive;
    if (tmp0_sortByDescending_0._get_size__32() > 1) {
      var tmp = _no_name_provided_$factory_115(this);
      sortWith(tmp0_sortByDescending_0, new sam$kotlin_Comparator$0(tmp));
    }var tmp1_forEach_0 = this._transparentPrimitive;
    var tmp0_iterator_1 = tmp1_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var position_4 = element_2.component1();
      var primitive_5 = element_2.component2();
      var model_6 = position_4._get_transformation__0();
      drawPrimitive(this, primitive_5, model_6);
    }
    this._transparentPrimitive.clear_15();
    this._get_gl__4().disable_2(3042);
  };
  ModelComponentRenderStage.prototype.update_61 = function (delta_0, entity) {
    var position = entity.get_44(getKClass_0(Position_0));
    var model = position._get_transformation__0();
    var tmp = asSequence(entity.findAll_0(getKClass_0(ModelComponent)));
    var tmp_0 = filter(tmp, _no_name_provided_$factory_116());
    var tmp_1 = flatMap(tmp_0, _no_name_provided_$factory_117());
    var tmp0_forEach_0 = filter(tmp_1, _no_name_provided_$factory_118());
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      if (element_2._texture_0._hasAlpha_0) {
        this._transparentPrimitive.add_19(to(position, element_2));
        Unit_getInstance();
      } else {
        drawPrimitive(this, element_2, model);
      }
    }
  };
  ModelComponentRenderStage.$metadata$ = {
    simpleName: 'ModelComponentRenderStage',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_115(this$0) {
    var i = new _no_name_provided__137(this$0);
    return function (p1, p2) {
      return i.invoke_210(p1, p2);
    };
  }
  function _no_name_provided_$factory_116() {
    var i = new _no_name_provided__138();
    return function (p1) {
      return i.invoke_214(p1);
    };
  }
  function _no_name_provided_$factory_117() {
    var i = new _no_name_provided__139();
    return function (p1) {
      return i.invoke_214(p1);
    };
  }
  function _no_name_provided_$factory_118() {
    var i = new _no_name_provided__140();
    return function (p1) {
      return i.invoke_216(p1);
    };
  }
  function ModelComponentRenderStage_init_$Init$(gameContext, query, cameraQuery, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      query = Companion_getInstance_23().of_0([getKClass_0(ModelComponent)]);
    if (!(($mask0 & 4) === 0))
      cameraQuery = EntityQuery_init_$Create$_0([getKClass_0(CameraComponent)]);
    ModelComponentRenderStage.call($this, gameContext, query, cameraQuery);
    return $this;
  }
  function ModelComponentRenderStage_init_$Create$(gameContext, query, cameraQuery, $mask0, $marker) {
    return ModelComponentRenderStage_init_$Init$(gameContext, query, cameraQuery, $mask0, $marker, Object.create(ModelComponentRenderStage.prototype));
  }
  function drawPrimitive($this, primitive, model) {
    var currentLight = $this._get_light__2();
    if (currentLight == null) {
      $this._get_vertex__3()._uLightColor_0.apply_4($this._get_program__5(), Companion_getInstance_17()._TRANSPARENT_COLOR);
      $this._get_vertex__3()._uLightPosition_0.apply_2($this._get_program__5(), Companion_getInstance_17()._ORIGIN);
    } else {
      var intensity = currentLight.get_44(getKClass_0(LightComponent))._intensity_0 * 777.0 / 1000.0 / 1000.0;
      $this._get_vertex__3()._uLightColor_0.apply_5($this._get_program__5(), currentLight.get_44(getKClass_0(LightComponent))._color_1, intensity);
      var tmp0__get_translation__0 = inverse(model).times_0(currentLight.get_44(getKClass_0(Position_0))._get_transformation__0());
      var tmp0__get_xyz__0_1 = tmp0__get_translation__0._w_0;
      var translation_1 = new Float3(tmp0__get_xyz__0_1._x_3, tmp0__get_xyz__0_1._y_3, tmp0__get_xyz__0_1._z_3);
      $this._get_vertex__3()._uLightPosition_0.apply_7($this._get_program__5(), new Float32Array([translation_1._x_2, translation_1._y_2, translation_1._z_2]));
    }
    $this._get_vertex__3()._uModelView_1.apply($this._get_program__5(), $this._get_combinedMatrix__2().times_0(model));
    $this._get_vertex__3()._aVertexPosition_1.apply_10($this._get_program__5(), ensureNotNull(primitive._verticesBuffer));
    $this._get_vertex__3()._aVertexNormal_0.apply_10($this._get_program__5(), ensureNotNull(primitive._normalsBuffer));
    $this._get_vertex__3()._aUVPosition_0.apply_10($this._get_program__5(), ensureNotNull(primitive._uvsBuffer));
    $this._get_fragment__2()._uUV.apply_11($this._get_program__5(), ensureNotNull(primitive._texture_0._textureReference), 0);
    $this._get_gl__4().bindBuffer_2(34963, ensureNotNull(primitive._verticesOrderBuffer));
    $this._get_gl__4().drawElements_2(4, primitive._verticesOrder_3.length, 5123, 0);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this._function = function_0;
  }
  sam$kotlin_Comparator$0.prototype.compare_1 = function (a, b) {
    return this._function(a, b);
  };
  sam$kotlin_Comparator$0.prototype.compare = function (a, b) {
    return this.compare_1(a, b);
  };
  sam$kotlin_Comparator$0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__137(this$0) {
    this._this$0_58 = this$0;
  }
  _no_name_provided__137.prototype.invoke_210 = function (a, b) {
    var position_3 = b.component1();
    var tmp0__get_translation__0_5 = position_3._get_transformation__0();
    var tmp0__get_xyz__0_1_6 = tmp0__get_translation__0_5._w_0;
    var translation_4 = toVector3(new Float3(tmp0__get_xyz__0_1_6._x_3, tmp0__get_xyz__0_1_6._y_3, tmp0__get_xyz__0_1_6._z_3));
    var relativeToCamera_7 = translation_4.sub(this._this$0_58._cameraPosition);
    var project_8 = relativeToCamera_7.project(this._this$0_58._cameraDirection);
    var tmp = project_8.length2();
    var position_3_0 = a.component1();
    var tmp0__get_translation__0_5_0 = position_3_0._get_transformation__0();
    var tmp0__get_xyz__0_1_6_0 = tmp0__get_translation__0_5_0._w_0;
    var translation_4_0 = toVector3(new Float3(tmp0__get_xyz__0_1_6_0._x_3, tmp0__get_xyz__0_1_6_0._y_3, tmp0__get_xyz__0_1_6_0._z_3));
    var relativeToCamera_7_0 = translation_4_0.sub(this._this$0_58._cameraPosition);
    var project_8_0 = relativeToCamera_7_0.project(this._this$0_58._cameraDirection);
    return compareValues(tmp, project_8_0.length2());
  };
  _no_name_provided__137.prototype.invoke_270 = function (p1, p2) {
    var tmp = p1 instanceof Pair ? p1 : THROW_CCE();
    return this.invoke_210(tmp, p2 instanceof Pair ? p2 : THROW_CCE());
  };
  _no_name_provided__137.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__138() {
  }
  _no_name_provided__138.prototype.invoke_214 = function (component) {
    return component._get_displayable_();
  };
  _no_name_provided__138.prototype.invoke_276 = function (p1) {
    return this.invoke_214(p1 instanceof ModelComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__138.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__139() {
  }
  _no_name_provided__139.prototype.invoke_214 = function (component) {
    return component._model._primitives_0;
  };
  _no_name_provided__139.prototype.invoke_276 = function (p1) {
    return this.invoke_214(p1 instanceof ModelComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__139.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__140() {
  }
  _no_name_provided__140.prototype.invoke_216 = function (primitive) {
    var tmp0_isNotEmpty_0 = primitive._verticesOrder_3;
    return !(tmp0_isNotEmpty_0.length === 0);
  };
  _no_name_provided__140.prototype.invoke_276 = function (p1) {
    return this.invoke_216(p1 instanceof Primitive_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__140.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RenderStage(gameContext, vertex, fragment, query, cameraQuery, lightsQuery) {
    StageWithSystem.call(this, query, gameContext);
    this._vertex_0 = vertex;
    this._fragment = fragment;
    this._cameraQuery = cameraQuery;
    this._gl_1 = gameContext._gl;
    this._lights$delegate = this.interested(lightsQuery);
    this._cameras$delegate = this.interested(this._cameraQuery);
  }
  RenderStage.prototype._get_vertex__3 = function () {
    return this._vertex_0;
  };
  RenderStage.prototype._get_fragment__2 = function () {
    return this._fragment;
  };
  RenderStage.prototype._get_gl__4 = function () {
    return this._gl_1;
  };
  RenderStage.prototype._get_camera__5 = function () {
    return firstOrNull(_get_cameras_(this));
  };
  RenderStage.prototype._get_light__2 = function () {
    return firstOrNull(_get_lights_(this));
  };
  RenderStage.prototype._get_program__5 = function () {
    return this._get__program__4();
  };
  RenderStage.prototype._get__program__4 = function () {
    var tmp = this.__program;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('_program');
    }
  };
  RenderStage.prototype._get_combinedMatrix__2 = function () {
    var tmp0_safe_receiver = this._get_camera__5();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0__get_translation__0_3 = _get_position_(tmp0_safe_receiver)._get_transformation__0();
      var tmp0__get_xyz__0_1_4 = tmp0__get_translation__0_3._w_0;
      var eye_2 = new Float3(tmp0__get_xyz__0_1_4._x_3, tmp0__get_xyz__0_1_4._y_3, tmp0__get_xyz__0_1_4._z_3);
      var cameraRotation_5 = rotation(_get_position_(tmp0_safe_receiver)._get_transformation__0());
      var tmp1__get_translation__0_7 = cameraRotation_5.times_0(translation(Companion_getInstance_25()._FRONT));
      var tmp0__get_xyz__0_1_8 = tmp1__get_translation__0_7._w_0;
      var direction_6 = new Float3(tmp0__get_xyz__0_1_8._x_3, tmp0__get_xyz__0_1_8._y_3, tmp0__get_xyz__0_1_8._z_3);
      var target_9 = new Float3(eye_2._x_2 + direction_6._x_2, eye_2._y_2 + direction_6._y_2, eye_2._z_2 + direction_6._z_2);
      var view_10 = lookAt(eye_2, target_9, Companion_getInstance_25()._UP_1);
      var projection_11 = tmp0_safe_receiver.get_44(getKClass_0(CameraComponent))._get_projection_();
      tmp = projection_11.times_0(view_10);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? Companion_getInstance_10().identity_0() : tmp1_elvis_lhs;
  };
  RenderStage.prototype.compileShaders_6 = function () {
    var tmp = this;
    var tmp0_apply_0 = ShaderUtils_getInstance().createShaderProgram(this._gl_1, this._vertex_0.toString(), this._fragment.toString());
    var tmp0_forEach_0_2 = this._vertex_0._get_parameters__7();
    var tmp0_iterator_1_3 = tmp0_forEach_0_2.iterator_52();
    while (tmp0_iterator_1_3.hasNext_27()) {
      var element_2_4 = tmp0_iterator_1_3.next_30();
      element_2_4.create_14(tmp0_apply_0);
    }
    var tmp1_forEach_0_5 = this._fragment._get_parameters__7();
    var tmp0_iterator_1_6 = tmp1_forEach_0_5.iterator_52();
    while (tmp0_iterator_1_6.hasNext_27()) {
      var element_2_7 = tmp0_iterator_1_6.next_30();
      element_2_7.create_14(tmp0_apply_0);
    }
    tmp.__program = tmp0_apply_0;
  };
  RenderStage.prototype.uniforms_4 = function (delta_0) {
    return Unit_getInstance();
  };
  RenderStage.prototype.update_62 = function (delta_0) {
    this._gl_1.useProgram_2(this._get_program__5());
    this.uniforms_4(delta_0);
    StageWithSystem.prototype.update_62.call(this, delta_0);
  };
  RenderStage.$metadata$ = {
    simpleName: 'RenderStage',
    kind: 'class',
    interfaces: []
  };
  function Stage() {
  }
  Stage.$metadata$ = {
    simpleName: 'Stage',
    kind: 'interface',
    interfaces: []
  };
  function StageWithSystem(query, gameContext) {
    System.call(this, query, gameContext);
  }
  StageWithSystem.$metadata$ = {
    simpleName: 'StageWithSystem',
    kind: 'class',
    interfaces: [Stage]
  };
  function lights$factory() {
    return getPropertyCallableRef('lights', 1, KProperty1, function (receiver) {
      return _get_lights_(receiver);
    }, null);
  }
  function cameras$factory() {
    return getPropertyCallableRef('cameras', 1, KProperty1, function (receiver) {
      return _get_cameras_(receiver);
    }, null);
  }
  function RenderStage_init_$Init$(gameContext, vertex, fragment, query, cameraQuery, lightsQuery, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      cameraQuery = EntityQuery_init_$Create$_0([getKClass_0(CameraComponent)]);
    if (!(($mask0 & 32) === 0))
      lightsQuery = EntityQuery_init_$Create$_0([getKClass_0(LightComponent)]);
    RenderStage.call($this, gameContext, vertex, fragment, query, cameraQuery, lightsQuery);
    return $this;
  }
  function _get_lights_($this) {
    return $this._lights$delegate.getValue_5($this, lights$factory());
  }
  function _get_cameras_($this) {
    return $this._cameras$delegate.getValue_5($this, cameras$factory());
  }
  function Companion_26() {
    Companion_instance_25 = this;
    this._FRONT = new Float3(0.0, 0.0, -1.0);
    this._UP_1 = new Float3(0.0, 1.0, 0.0);
  }
  Companion_26.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_26();
    return Companion_instance_25;
  }
  function DataSource() {
  }
  DataSource.$metadata$ = {
    simpleName: 'DataSource',
    kind: 'class',
    interfaces: []
  };
  function FloatDataSource(floats) {
    DataSource.call(this);
    this._floats = floats;
  }
  FloatDataSource.$metadata$ = {
    simpleName: 'FloatDataSource',
    kind: 'class',
    interfaces: []
  };
  function IntDataSource() {
  }
  IntDataSource.$metadata$ = {
    simpleName: 'IntDataSource',
    kind: 'class',
    interfaces: []
  };
  function ShortDataSource(shorts) {
    DataSource.call(this);
    this._shorts = shorts;
  }
  ShortDataSource.$metadata$ = {
    simpleName: 'ShortDataSource',
    kind: 'class',
    interfaces: []
  };
  function UIntDataSource() {
  }
  UIntDataSource.$metadata$ = {
    simpleName: 'UIntDataSource',
    kind: 'class',
    interfaces: []
  };
  function DoubleDataSource() {
  }
  DoubleDataSource.$metadata$ = {
    simpleName: 'DoubleDataSource',
    kind: 'class',
    interfaces: []
  };
  function ShaderParameter(name) {
    this._name_17 = name;
  }
  ShaderParameter.prototype._get_name__24 = function () {
    return this._name_17;
  };
  ShaderParameter.$metadata$ = {
    simpleName: 'ShaderParameter',
    kind: 'class',
    interfaces: []
  };
  function UniformMat4(name) {
    ShaderParameter.call(this, name);
  }
  UniformMat4.prototype.create_14 = function (program) {
    program.createUniform(this._get_name__24());
  };
  UniformMat4.prototype.apply = function (program, matrix) {
    program.uniformMatrix4fv_5(program.getUniform_0(this._get_name__24()), false, matrix);
  };
  UniformMat4.$metadata$ = {
    simpleName: 'UniformMat4',
    kind: 'class',
    interfaces: []
  };
  function UniformArrayMat4(name) {
    ShaderParameter.call(this, name);
  }
  UniformArrayMat4.prototype.create_14 = function (program) {
    program.createUniform(this._get_name__24());
  };
  UniformArrayMat4.prototype.apply_0 = function (program, matrix) {
    return this.apply_1(program, matrix.slice());
  };
  UniformArrayMat4.prototype.apply_1 = function (program, matrix) {
    var tmp = 0;
    var tmp_0 = imul(matrix.length, 16);
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = 0.0;
      tmp = tmp + 1 | 0;
    }
    var tmpMatrix = tmp_1;
    var index_1 = 0;
    var indexedObject = matrix;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_4 = index_1;
      index_1 = tmp1_4 + 1 | 0;
      var tmp0__anonymous__5 = tmp1_4;
      var values_6 = item_3.asGLArray();
      var tmp0_forEach_0_7 = until(0, 16);
      var inductionVariable_0 = tmp0_forEach_0_7._get_first__2();
      var last_3 = tmp0_forEach_0_7._get_last__4();
      if (inductionVariable_0 <= last_3)
        do {
          var element_2_9 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          tmpMatrix[imul(tmp0__anonymous__5, 16) + element_2_9 | 0] = values_6[element_2_9];
        }
         while (!(element_2_9 === last_3));
    }
    program.uniformMatrix4fv_4(program.getUniform_0(this._get_name__24()), false, tmpMatrix);
  };
  UniformArrayMat4.$metadata$ = {
    simpleName: 'UniformArrayMat4',
    kind: 'class',
    interfaces: []
  };
  function UniformVec3(name) {
    ShaderParameter.call(this, name);
  }
  UniformVec3.prototype.create_14 = function (program) {
    program.createUniform(this._get_name__24());
  };
  UniformVec3.prototype.apply_2 = function (program, vec3) {
    return this.apply_7(program, new Float32Array([vec3._x_11, vec3._y_11, vec3._z_7]));
  };
  UniformVec3.prototype.apply_7 = function (program, vec3) {
    var tmp0_subject = vec3.length;
    if (tmp0_subject === 3)
      program.uniform3f_2(program.getUniform_0(this._get_name__24()), vec3[0], vec3[1], vec3[2]);
    else
      throw IllegalArgumentException_init_$Create$('' + '3 values are expected. ' + vec3.length + ' received');
  };
  UniformVec3.$metadata$ = {
    simpleName: 'UniformVec3',
    kind: 'class',
    interfaces: []
  };
  function UniformVec4(name) {
    ShaderParameter.call(this, name);
  }
  UniformVec4.prototype.create_14 = function (program) {
    program.createUniform(this._get_name__24());
  };
  UniformVec4.prototype.apply_4 = function (program, color) {
    return this.apply_7(program, new Float32Array([color._red, color._green, color._blue, color._alpha_0]));
  };
  UniformVec4.prototype.apply_5 = function (program, color, intensity) {
    return this.apply_7(program, new Float32Array([color._red * intensity, color._green * intensity, color._blue * intensity, color._alpha_0 * intensity]));
  };
  UniformVec4.prototype.apply_7 = function (program, vec4) {
    var tmp0_subject = vec4.length;
    if (tmp0_subject === 4)
      program.uniform4f_2(program.getUniform_0(this._get_name__24()), vec4[0], vec4[1], vec4[2], vec4[3]);
    else
      throw IllegalArgumentException_init_$Create$('' + '4 values are expected. ' + vec4.length + ' received');
  };
  UniformVec4.$metadata$ = {
    simpleName: 'UniformVec4',
    kind: 'class',
    interfaces: []
  };
  function UniformFloat(name) {
    ShaderParameter.call(this, name);
  }
  UniformFloat.prototype.create_14 = function (program) {
    program.createUniform(this._get_name__24());
  };
  UniformFloat.prototype.apply_7 = function (program, value) {
    var tmp0_subject = value.length;
    switch (tmp0_subject) {
      case 0:
        throw IllegalArgumentException_init_$Create$('At least one int is expected');
      case 1:
        program.uniform1f_2(program.getUniform_0(this._get_name__24()), value[0]);
        break;
      case 2:
        program.uniform2f_2(program.getUniform_0(this._get_name__24()), value[0], value[1]);
        break;
      case 3:
        program.uniform3f_2(program.getUniform_0(this._get_name__24()), value[0], value[1], value[2]);
        break;
      case 4:
        program.uniform4f_2(program.getUniform_0(this._get_name__24()), value[0], value[1], value[2], value[3]);
        break;
    }
  };
  UniformFloat.$metadata$ = {
    simpleName: 'UniformFloat',
    kind: 'class',
    interfaces: []
  };
  function AttributeVec2(name) {
    ShaderParameter.call(this, name);
  }
  AttributeVec2.prototype.create_14 = function (program) {
    program.createAttrib(this._get_name__24());
  };
  AttributeVec2.prototype.apply_10 = function (program, source) {
    program.bindBuffer_2(34962, source);
    program.vertexAttribPointer_2(program.getAttrib(this._get_name__24()), 2, 5126, false, 0, 0);
    program.enableVertexAttribArray_2(program.getAttrib(this._get_name__24()));
  };
  AttributeVec2.$metadata$ = {
    simpleName: 'AttributeVec2',
    kind: 'class',
    interfaces: []
  };
  function AttributeVec3(name) {
    ShaderParameter.call(this, name);
  }
  AttributeVec3.prototype.create_14 = function (program) {
    program.createAttrib(this._get_name__24());
  };
  AttributeVec3.prototype.apply_10 = function (program, source) {
    program.bindBuffer_2(34962, source);
    program.vertexAttribPointer_2(program.getAttrib(this._get_name__24()), 3, 5126, false, 0, 0);
    program.enableVertexAttribArray_2(program.getAttrib(this._get_name__24()));
  };
  AttributeVec3.$metadata$ = {
    simpleName: 'AttributeVec3',
    kind: 'class',
    interfaces: []
  };
  function AttributeVec4(name) {
    ShaderParameter.call(this, name);
  }
  AttributeVec4.prototype.create_14 = function (program) {
    program.createAttrib(this._get_name__24());
  };
  AttributeVec4.prototype.apply_10 = function (program, source) {
    program.bindBuffer_2(34962, source);
    program.vertexAttribPointer_2(program.getAttrib(this._get_name__24()), 4, 5126, false, 0, 0);
    program.enableVertexAttribArray_2(program.getAttrib(this._get_name__24()));
  };
  AttributeVec4.$metadata$ = {
    simpleName: 'AttributeVec4',
    kind: 'class',
    interfaces: []
  };
  function UniformSample2D(name) {
    ShaderParameter.call(this, name);
  }
  UniformSample2D.prototype.create_14 = function (program) {
    program.createUniform(this._get_name__24());
  };
  UniformSample2D.prototype.apply_11 = function (program, texture, unit) {
    program.activeTexture_2(33984 + unit | 0);
    program.bindTexture_2(3553, texture);
    program.uniform1i_2(program.getUniform_0(this._get_name__24()), unit);
  };
  UniformSample2D.$metadata$ = {
    simpleName: 'UniformSample2D',
    kind: 'class',
    interfaces: []
  };
  function ShaderProgram(gl, program) {
    this._gl_2 = gl;
    this._program_1 = program;
    var tmp = this;
    tmp._attributes = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    tmp_0._uniforms = LinkedHashMap_init_$Create$();
  }
  ShaderProgram.prototype.activeTexture_2 = function (byteMask) {
    this._gl_2.activeTexture_2(byteMask);
  };
  ShaderProgram.prototype.attachShader_2 = function (shaderProgram, shader) {
    this._gl_2.attachShader_2(shaderProgram, shader);
  };
  ShaderProgram.prototype.bindBuffer_2 = function (target, buffer) {
    this._gl_2.bindBuffer_2(target, buffer);
  };
  ShaderProgram.prototype.bindTexture_2 = function (target, textureReference) {
    this._gl_2.bindTexture_2(target, textureReference);
  };
  ShaderProgram.prototype.blendFunc_2 = function (sfactor, dfactor) {
    this._gl_2.blendFunc_2(sfactor, dfactor);
  };
  ShaderProgram.prototype.bufferData_2 = function (target, data, usage) {
    this._gl_2.bufferData_2(target, data, usage);
  };
  ShaderProgram.prototype.clear_18 = function (mask) {
    this._gl_2.clear_18(mask);
  };
  ShaderProgram.prototype.clearColor_2 = function (r, g, b, a) {
    this._gl_2.clearColor_2(r, g, b, a);
  };
  ShaderProgram.prototype.clearDepth_2 = function (depth) {
    this._gl_2.clearDepth_2(depth);
  };
  ShaderProgram.prototype.compileShader_3 = function (shader) {
    this._gl_2.compileShader_3(shader);
  };
  ShaderProgram.prototype.createBuffer_2 = function () {
    return this._gl_2.createBuffer_2();
  };
  ShaderProgram.prototype.createProgram_2 = function () {
    return this._gl_2.createProgram_2();
  };
  ShaderProgram.prototype.createShader_2 = function (type) {
    return this._gl_2.createShader_2(type);
  };
  ShaderProgram.prototype.createTexture_2 = function () {
    return this._gl_2.createTexture_2();
  };
  ShaderProgram.prototype.deleteShader_2 = function (shader) {
    this._gl_2.deleteShader_2(shader);
  };
  ShaderProgram.prototype.depthFunc_2 = function (target) {
    this._gl_2.depthFunc_2(target);
  };
  ShaderProgram.prototype.disable_2 = function (mask) {
    this._gl_2.disable_2(mask);
  };
  ShaderProgram.prototype.drawElements_2 = function (mask, vertexCount, type, offset) {
    this._gl_2.drawElements_2(mask, vertexCount, type, offset);
  };
  ShaderProgram.prototype.enable_2 = function (mask) {
    this._gl_2.enable_2(mask);
  };
  ShaderProgram.prototype.enableVertexAttribArray_2 = function (index) {
    this._gl_2.enableVertexAttribArray_2(index);
  };
  ShaderProgram.prototype.getAttribLocation_2 = function (shaderProgram, name) {
    return this._gl_2.getAttribLocation_2(shaderProgram, name);
  };
  ShaderProgram.prototype.getProgramInfoLog_2 = function (shader) {
    return this._gl_2.getProgramInfoLog_2(shader);
  };
  ShaderProgram.prototype.getProgramParameter_2 = function (shaderProgram, mask) {
    return this._gl_2.getProgramParameter_2(shaderProgram, mask);
  };
  ShaderProgram.prototype.getProgramParameterB_1 = function (shaderProgram, mask) {
    return this._gl_2.getProgramParameterB_1(shaderProgram, mask);
  };
  ShaderProgram.prototype.getShaderInfoLog_2 = function (shader) {
    return this._gl_2.getShaderInfoLog_2(shader);
  };
  ShaderProgram.prototype.getShaderParameter_2 = function (shader, mask) {
    return this._gl_2.getShaderParameter_2(shader, mask);
  };
  ShaderProgram.prototype.getShaderParameterB_1 = function (shader, mask) {
    return this._gl_2.getShaderParameterB_1(shader, mask);
  };
  ShaderProgram.prototype.getString_2 = function (parameterName) {
    return this._gl_2.getString_2(parameterName);
  };
  ShaderProgram.prototype.getUniformLocation_2 = function (shaderProgram, name) {
    return this._gl_2.getUniformLocation_2(shaderProgram, name);
  };
  ShaderProgram.prototype.linkProgram_2 = function (shaderProgram) {
    this._gl_2.linkProgram_2(shaderProgram);
  };
  ShaderProgram.prototype.shaderSource_2 = function (shader, source) {
    this._gl_2.shaderSource_2(shader, source);
  };
  ShaderProgram.prototype.texImage2D_4 = function (target, level, internalformat, format, type, source) {
    this._gl_2.texImage2D_4(target, level, internalformat, format, type, source);
  };
  ShaderProgram.prototype.texImage2D_5 = function (target, level, internalformat, format, width, height, type, source) {
    this._gl_2.texImage2D_5(target, level, internalformat, format, width, height, type, source);
  };
  ShaderProgram.prototype.texParameteri_2 = function (target, paramName, paramValue) {
    this._gl_2.texParameteri_2(target, paramName, paramValue);
  };
  ShaderProgram.prototype.uniform1f_2 = function (uniform, first_1) {
    this._gl_2.uniform1f_2(uniform, first_1);
  };
  ShaderProgram.prototype.uniform1i_2 = function (uniform, data) {
    this._gl_2.uniform1i_2(uniform, data);
  };
  ShaderProgram.prototype.uniform2f_2 = function (uniform, first_1, second) {
    this._gl_2.uniform2f_2(uniform, first_1, second);
  };
  ShaderProgram.prototype.uniform3f_2 = function (uniform, first_1, second, third) {
    this._gl_2.uniform3f_2(uniform, first_1, second, third);
  };
  ShaderProgram.prototype.uniform4f_2 = function (uniform, first_1, second, third, fourth) {
    this._gl_2.uniform4f_2(uniform, first_1, second, third, fourth);
  };
  ShaderProgram.prototype.uniformMatrix4fv_5 = function (uniform, transpose_0, data) {
    this._gl_2.uniformMatrix4fv_5(uniform, transpose_0, data);
  };
  ShaderProgram.prototype.uniformMatrix4fv_4 = function (uniform, transpose_0, data) {
    this._gl_2.uniformMatrix4fv_4(uniform, transpose_0, data);
  };
  ShaderProgram.prototype.useProgram_2 = function (shaderProgram) {
    this._gl_2.useProgram_2(shaderProgram);
  };
  ShaderProgram.prototype.vertexAttribPointer_2 = function (index, size_0, type, normalized, stride, offset) {
    this._gl_2.vertexAttribPointer_2(index, size_0, type, normalized, stride, offset);
  };
  ShaderProgram.prototype.viewport_2 = function (x, y, width, height) {
    this._gl_2.viewport_2(x, y, width, height);
  };
  ShaderProgram.prototype.createAttrib = function (name) {
    var tmp0_set_0 = this._attributes;
    var tmp1_set_0 = this._gl_2.getAttribLocation_2(this, name);
    tmp0_set_0.put_5(name, tmp1_set_0);
    Unit_getInstance();
  };
  ShaderProgram.prototype.createUniform = function (name) {
    var tmp0_set_0 = this._uniforms;
    var tmp1_set_0 = this._gl_2.getUniformLocation_2(this, name);
    tmp0_set_0.put_5(name, tmp1_set_0);
    Unit_getInstance();
  };
  ShaderProgram.prototype.getAttrib = function (name) {
    var tmp0_elvis_lhs = this._attributes.get_27(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('' + "Attributes '" + name + "' not created!");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ShaderProgram.prototype.getUniform_0 = function (name) {
    var tmp0_elvis_lhs = this._uniforms.get_27(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('' + "Uniform '" + name + "' not created!");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ShaderProgram.$metadata$ = {
    simpleName: 'ShaderProgram',
    kind: 'class',
    interfaces: [GL]
  };
  function ShaderUtils() {
    ShaderUtils_instance = this;
  }
  ShaderUtils.prototype.createShaderProgram = function (gl, vertexShader, fragmentShader) {
    var vertex = this.compileShader_2(gl, vertexShader, 35633);
    var fragment = this.compileShader_2(gl, fragmentShader, 35632);
    var shaderProgram = gl.createProgram_2();
    gl.attachShader_2(shaderProgram, vertex);
    gl.attachShader_2(shaderProgram, fragment);
    gl.linkProgram_2(shaderProgram);
    if (!gl.getProgramParameterB_1(shaderProgram, 35714)) {
      var log = gl.getProgramInfoLog_2(shaderProgram);
      throw RuntimeException_init_$Create$('' + 'Shader compilation error: ' + log);
    }return shaderProgram;
  };
  ShaderUtils.prototype.compileShader_2 = function (gl, vertexShader, type) {
    var shader = gl.createShader_2(type);
    gl.shaderSource_2(shader, vertexShader);
    gl.compileShader_3(shader);
    if (!gl.getShaderParameterB_1(shader, 35713)) {
      var log = gl.getShaderInfoLog_2(shader);
      gl.deleteShader_2(shader);
      var tmp2_substring_0 = 0;
      var tmp0_min_0 = vertexShader.length;
      var tmp1_min_0 = 128;
      var tmp3_substring_0 = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
      }.call(this);
      throw RuntimeException_init_$Create$('' + 'Shader compilation error: ' + log + ' (' + vertexShader.substring(tmp2_substring_0, tmp3_substring_0) + ')');
    }return shader;
  };
  ShaderUtils.$metadata$ = {
    simpleName: 'ShaderUtils',
    kind: 'object',
    interfaces: []
  };
  var ShaderUtils_instance;
  function ShaderUtils_getInstance() {
    if (ShaderUtils_instance == null)
      new ShaderUtils();
    return ShaderUtils_instance;
  }
  var simpleFragmentShader;
  function ColorFragmentShader() {
    FragmentShader.call(this, simpleFragmentShader);
  }
  ColorFragmentShader.$metadata$ = {
    simpleName: 'ColorFragmentShader',
    kind: 'class',
    interfaces: []
  };
  function FragmentShader(shader) {
    this._shader = shader;
    this._parameters = emptyList();
  }
  FragmentShader.prototype._get_parameters__7 = function () {
    return this._parameters;
  };
  FragmentShader.prototype.toString = function () {
    return this._shader;
  };
  FragmentShader.$metadata$ = {
    simpleName: 'FragmentShader',
    kind: 'class',
    interfaces: []
  };
  var simpleFragmentShader_0;
  function UVFragmentShader() {
    FragmentShader.call(this, simpleFragmentShader_0);
    this._uUV = new UniformSample2D('uUV');
    this._parameters_0 = listOf_0(this._uUV);
  }
  UVFragmentShader.prototype._get_parameters__7 = function () {
    return this._parameters_0;
  };
  UVFragmentShader.$metadata$ = {
    simpleName: 'UVFragmentShader',
    kind: 'class',
    interfaces: []
  };
  function AnimatedMeshVertexShader() {
    VertexShader.call(this, '\n        #ifdef GL_ES\n        precision highp float;\n        #endif\n\n        const int MAX_JOINTS = 50;\n        const int MAX_WEIGHTS = 4;\n        \n        uniform mat4 uModelView;\n        // Light information\n        uniform vec3 uLightPosition;\n        uniform vec4 uLightColor;\n        \n        uniform mat4 uJointTransformationMatrix[MAX_JOINTS];\n        \n        attribute vec3 aVertexPosition;\n        attribute vec3 aVertexNormal;\n\n        attribute vec4 aJoints;\n        attribute vec4 aWeights;\n        attribute vec2 aUVPosition;\n        \n        varying vec2 vUVPosition;\n        varying vec4 vLighting;\n        \n        void main() {\n            vec4 totalLocalPos = vec4(0.0);\n            vec4 totalNormalPos = vec4(0.0);\n            \n            for(int i=0;i<MAX_WEIGHTS;i++){\n                int joinId = int(aJoints[i]);\n                mat4 uJointMatrix = uJointTransformationMatrix[joinId];\n                vec4 posePosition = uJointMatrix * vec4(aVertexPosition, 1.0);\n                vec4 poseNormal = uJointMatrix * vec4(aVertexNormal, 1.0);\n                \n                // For an unknown reason, no evaluating aWeights make the \n                // computation not working on some devise (ie: reproduced on an Android TV).\n                // This check is useless but make the things works!\n                if(aWeights[i] >= 0.0) {\n                    totalLocalPos += posePosition * aWeights[i];\n                    totalNormalPos += poseNormal * aWeights[i];\n                }\n            }\n        \n            vec3 vPosToLight = normalize(totalLocalPos.xyz - uLightPosition);\n        \tfloat directional = max(0.0, dot(normalize(totalNormalPos.xyz), -vPosToLight));\n\n            gl_Position = uModelView * totalLocalPos;\n            \n            vUVPosition = aUVPosition;\n            vLighting = uLightColor + uLightColor * directional; \n        }\n');
    this._uModelView = new UniformMat4('uModelView');
    this._uJointTransformationMatrix = new UniformArrayMat4('uJointTransformationMatrix');
    this._uLightPosition = new UniformVec3('uLightPosition');
    this._uLightColor = new UniformVec4('uLightColor');
    this._aVertexPosition = new AttributeVec3('aVertexPosition');
    this._aVertexNormal = new AttributeVec3('aVertexNormal');
    this._aJoints = new AttributeVec4('aJoints');
    this._aWeights = new AttributeVec4('aWeights');
    this._aUVPosition = new AttributeVec2('aUVPosition');
    this._parameters_1 = listOf([this._uModelView, this._uJointTransformationMatrix, this._uLightColor, this._uLightPosition, this._aVertexPosition, this._aVertexNormal, this._aUVPosition, this._aJoints, this._aWeights]);
  }
  AnimatedMeshVertexShader.prototype._get_parameters__7 = function () {
    return this._parameters_1;
  };
  AnimatedMeshVertexShader.$metadata$ = {
    simpleName: 'AnimatedMeshVertexShader',
    kind: 'class',
    interfaces: []
  };
  var simpleVertexShader;
  function BoundingBoxVertexShader() {
    VertexShader.call(this, simpleVertexShader);
    this._uModelView_0 = new UniformMat4('uModelView');
    this._uColor = new UniformFloat('uColor');
    this._aVertexPosition_0 = new AttributeVec3('aVertexPosition');
    this._parameters_2 = listOf([this._uModelView_0, this._uColor, this._aVertexPosition_0]);
  }
  BoundingBoxVertexShader.prototype._get_parameters__7 = function () {
    return this._parameters_2;
  };
  BoundingBoxVertexShader.$metadata$ = {
    simpleName: 'BoundingBoxVertexShader',
    kind: 'class',
    interfaces: []
  };
  var simpleVertexShader_0;
  function MeshVertexShader() {
    VertexShader.call(this, simpleVertexShader_0);
    this._uModelView_1 = new UniformMat4('uModelView');
    this._aVertexPosition_1 = new AttributeVec3('aVertexPosition');
    this._aVertexNormal_0 = new AttributeVec3('aVertexNormal');
    this._aUVPosition_0 = new AttributeVec2('aUVPosition');
    this._uLightPosition_0 = new UniformVec3('uLightPosition');
    this._uLightColor_0 = new UniformVec4('uLightColor');
    this._parameters_3 = listOf([this._uModelView_1, this._aVertexPosition_1, this._aVertexNormal_0, this._aUVPosition_0, this._uLightPosition_0, this._uLightColor_0]);
  }
  MeshVertexShader.prototype._get_parameters__7 = function () {
    return this._parameters_3;
  };
  MeshVertexShader.$metadata$ = {
    simpleName: 'MeshVertexShader',
    kind: 'class',
    interfaces: []
  };
  var simpleVertexShader_1;
  function VertexShader(shader) {
    this._shader_0 = shader;
    this._parameters_4 = emptyList();
  }
  VertexShader.prototype._get_parameters__7 = function () {
    return this._parameters_4;
  };
  VertexShader.prototype.toString = function () {
    return this._shader_0;
  };
  VertexShader.$metadata$ = {
    simpleName: 'VertexShader',
    kind: 'class',
    interfaces: []
  };
  function convert(_this_, x, y) {
    var converted = _this_._viewport.convert_2(x, y, _this_._deviceScreen._width_2, _this_._deviceScreen._height_2, _this_._gameScreen._width_1, _this_._gameScreen._height_1);
    var tmp0_container = converted;
    var gameX = tmp0_container.component1();
    var gameY = tmp0_container.component2();
    var tmp;
    if ((0 <= gameX ? gameX <= _this_._gameScreen._width_1 : false) ? 0 <= gameY ? gameY <= _this_._gameScreen._height_1 : false : false) {
      tmp = converted;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ObjectPool(size_0) {
    this._size_5 = size_0;
    var tmp = this;
    tmp._pool = ArrayList_init_$Create$();
  }
  ObjectPool.prototype.obtain_0 = function () {
    if (this._pool.isEmpty_35()) {
      var inductionVariable = 0;
      var last_2 = this._size_5;
      if (inductionVariable <= last_2)
        do {
          var it = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.free_2(this.newInstance_1());
        }
         while (!(it === last_2));
    }var result = this._pool.get_57(this._pool._get_size__32() - 1 | 0);
    this._pool.removeAt_1(this._pool._get_size__32() - 1 | 0);
    Unit_getInstance();
    return result;
  };
  ObjectPool.prototype.free_2 = function (obj) {
    this.destroyInstance_3(obj);
    this._pool.add_19(obj);
    Unit_getInstance();
  };
  ObjectPool.prototype.free_3 = function (objs) {
    var tmp0_iterator_1 = objs.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      this.destroyInstance_3(element_2);
    }
    addAll(this._pool, objs);
    Unit_getInstance();
  };
  ObjectPool.$metadata$ = {
    simpleName: 'ObjectPool',
    kind: 'class',
    interfaces: []
  };
  function GameConfiguration(gameName, debug, gameScreenConfiguration, loadingListener, canvas, canvasId, rootPath) {
    this._gameName = gameName;
    this._debug_0 = debug;
    this._gameScreenConfiguration = gameScreenConfiguration;
    this._loadingListener = loadingListener;
    this._canvas = canvas;
    this._canvasId = canvasId;
    this._rootPath = rootPath;
  }
  GameConfiguration.$metadata$ = {
    simpleName: 'GameConfiguration',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_119() {
    var i = new _no_name_provided__141();
    return function (p1) {
      i.invoke_218(p1);
      return Unit_getInstance();
    };
  }
  function GameConfiguration_init_$Init$(gameName, debug, gameScreenConfiguration, loadingListener, canvas, canvasId, rootPath, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0)) {
      loadingListener = _no_name_provided_$factory_119();
    }if (!(($mask0 & 16) === 0))
      canvas = null;
    if (!(($mask0 & 32) === 0))
      canvasId = null;
    if (!(($mask0 & 64) === 0))
      rootPath = window.location.protocol + '//' + window.location.host + window.location.pathname;
    GameConfiguration.call($this, gameName, debug, gameScreenConfiguration, loadingListener, canvas, canvasId, rootPath);
    return $this;
  }
  function GameConfiguration_init_$Create$(gameName, debug, gameScreenConfiguration, loadingListener, canvas, canvasId, rootPath, $mask0, $marker) {
    return GameConfiguration_init_$Init$(gameName, debug, gameScreenConfiguration, loadingListener, canvas, canvasId, rootPath, $mask0, $marker, Object.create(GameConfiguration.prototype));
  }
  function _no_name_provided__141() {
  }
  _no_name_provided__141.prototype.invoke_218 = function (_anonymous_parameter_0_) {
    Unit_getInstance();
  };
  _no_name_provided__141.prototype.invoke_276 = function (p1) {
    this.invoke_218((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__141.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PlatformContextCommon(configuration) {
    this._configuration_3 = configuration;
    this._then = 0.0;
    var tmp = this;
    tmp._postRenderLoop = _no_name_provided_$factory_120();
  }
  PlatformContextCommon.prototype._get_configuration__4 = function () {
    return this._configuration_3;
  };
  PlatformContextCommon.prototype._set_postRenderLoop__0 = function (_set___) {
    this._postRenderLoop = _set___;
  };
  PlatformContextCommon.prototype._get_postRenderLoop_ = function () {
    return this._postRenderLoop;
  };
  PlatformContextCommon.prototype.createGL_0 = function () {
    var tmp = function () {
      var $externalVarargReceiverTmp = _get_canvas_(this);
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, [].concat(['webgl2'], [].slice.call([])));
    }.call(this);
    var tmp0_elvis_lhs = (!(tmp == null) ? isObject(tmp) : false) ? tmp : null;
    var context = tmp0_elvis_lhs == null ? oldWebGL(this) : tmp0_elvis_lhs;
    return new WebGL(context);
  };
  PlatformContextCommon.prototype.createFileHandler_0 = function (logger, gameContext) {
    logger.info_1('GL_CONTEXT', _no_name_provided_$factory_121(this));
    var tmp0_get_0 = window;
    var tmp1_get_0 = 'AudioContext';
    if (tmp0_get_0[tmp1_get_0] == undefined) {
      window.AudioContext = webkitAudioContext;
    } else {
    }
    var tmp = new PlatformFileHandler(this._get_configuration__4()._rootPath, new AudioContext(), logger);
    return FileHandlerCommon_init_$Create$(gameContext, tmp, logger, null, 8, null);
  };
  PlatformContextCommon.prototype.createInputHandler_0 = function (logger, gameContext) {
    return new JsInputHandler(_get_canvas_(this), gameContext);
  };
  PlatformContextCommon.prototype.createViewportStrategy_0 = function (logger) {
    return new FillViewportStrategy(logger);
  };
  PlatformContextCommon.prototype.createLogger_0 = function () {
    return new JsLogger(this._get_configuration__4()._gameName);
  };
  PlatformContextCommon.prototype.createOptions_0 = function () {
    return new Options(this._get_configuration__4()._debug_0);
  };
  PlatformContextCommon.prototype.start_9 = function (gameFactory) {
    var tmp = this;
    var tmp0_elvis_lhs = this._get_configuration__4()._canvas;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw RuntimeException_init_$Create$('' + "<canvas> with id '" + this._get_configuration__4()._canvasId + "' not found");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp._canvas_0 = tmp_0;
    var resolution = this._get_configuration__4()._gameScreenConfiguration.screen_1(_get_canvas_(this).clientWidth, _get_canvas_(this).clientHeight);
    this._gameContext_5 = new GameContext(this, resolution);
    _get_gameContext_(this).logPlatform();
    _get_gameContext_(this)._deviceScreen._width_2 = _get_canvas_(this).clientWidth;
    _get_gameContext_(this)._deviceScreen._height_2 = _get_canvas_(this).clientHeight;
    _get_gameContext_(this)._frameBufferScreen._width_2 = _get_canvas_(this).clientWidth;
    _get_gameContext_(this)._frameBufferScreen._height_2 = _get_canvas_(this).clientHeight;
    var tmp_1 = this;
    var tmp_2 = _get_gameContext_(this)._input_1;
    tmp_1._inputManager = isInterface(tmp_2, InputManager) ? tmp_2 : THROW_CCE();
    var game = gameFactory(_get_gameContext_(this));
    this._gameWrapper = new GameWrapper(_get_gameContext_(this), game);
    var tmp_3 = window;
    tmp_3.requestAnimationFrame(_no_name_provided_$factory_122(this));
    Unit_getInstance();
  };
  PlatformContextCommon.$metadata$ = {
    simpleName: 'PlatformContextCommon',
    kind: 'class',
    interfaces: [PlatformContext]
  };
  function _no_name_provided_$factory_120() {
    var i = new _no_name_provided__142();
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_121(this$0) {
    var i = new _no_name_provided__143(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_122($boundThis) {
    var i = new _no_name_provided__144($boundThis);
    var l = function (p1) {
      i.invoke_233(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_123($boundThis) {
    var i = new _no_name_provided__145($boundThis);
    var l = function (p1) {
      i.invoke_233(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_124($boundThis) {
    var i = new _no_name_provided__146($boundThis);
    var l = function (p1) {
      i.invoke_233(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_125($boundThis) {
    var i = new _no_name_provided__147($boundThis);
    var l = function (p1) {
      i.invoke_233(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_126() {
    var i = new _no_name_provided__148();
    return function () {
      i.invoke_231();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_127($boundThis) {
    var i = new _no_name_provided__149($boundThis);
    var l = function (p1) {
      i.invoke_233(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _get_gameWrapper_($this) {
    var tmp = $this._gameWrapper;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('gameWrapper');
    }
  }
  function _get_inputManager_($this) {
    var tmp = $this._inputManager;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('inputManager');
    }
  }
  function _get_canvas_($this) {
    var tmp = $this._canvas_0;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('canvas');
    }
  }
  function _get_gameContext_($this) {
    var tmp = $this._gameContext_5;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('gameContext');
    }
  }
  function oldWebGL($this) {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].concat([].slice.call(['WebGL 2 not detected! Falling back to WebGL 1.'])));
    }.call(this));
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].concat([].slice.call(['MiniGDX might not work as expected as the game is run from a browserthat might not support all features required (like Web GL 2, Audio API, ...)'])));
    }.call(this));
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].concat([].slice.call(['Please warn your user to update their browser or switch to another browser like Firefox, Chrome or Opera.'])));
    }.call(this));
    var tmp = function () {
      var $externalVarargReceiverTmp = _get_canvas_($this);
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, [].concat(['webgl'], [].slice.call([])));
    }.call(this);
    return (!(tmp == null) ? isObject(tmp) : false) ? tmp : THROW_CCE();
  }
  function loading($this, now) {
    if (!_get_gameContext_($this)._fileHandler.isFullyLoaded_0()) {
      $this._get_configuration__4()._loadingListener(_get_gameContext_($this)._fileHandler.loadingProgress_0());
      var tmp = window;
      tmp.requestAnimationFrame(_no_name_provided_$factory_123($this));
      Unit_getInstance();
    } else {
      $this._get_configuration__4()._loadingListener(_get_gameContext_($this)._fileHandler.loadingProgress_0());
      _get_gameContext_($this)._viewport.update_29(_get_gameContext_($this)._gl, _get_gameContext_($this)._frameBufferScreen._width_2, _get_gameContext_($this)._frameBufferScreen._height_2, _get_gameContext_($this)._gameScreen._width_1, _get_gameContext_($this)._gameScreen._height_1);
      _get_gameWrapper_($this).create_4();
      _get_gameWrapper_($this).resume_1();
      var tmp_0 = window;
      tmp_0.requestAnimationFrame(_no_name_provided_$factory_124($this));
      Unit_getInstance();
    }
  }
  function render_0($this, now) {
    if (!(_get_canvas_($this).clientWidth === _get_gameContext_($this)._deviceScreen._width_2) ? true : !(_get_canvas_($this).clientHeight === _get_gameContext_($this)._deviceScreen._height_2)) {
      _get_gameContext_($this)._deviceScreen._width_2 = _get_canvas_($this).clientWidth;
      _get_gameContext_($this)._deviceScreen._height_2 = _get_canvas_($this).clientHeight;
      _get_gameContext_($this)._frameBufferScreen._width_2 = _get_canvas_($this).clientWidth;
      _get_gameContext_($this)._frameBufferScreen._height_2 = _get_canvas_($this).clientHeight;
      _get_canvas_($this).width = _get_canvas_($this).clientWidth;
      _get_canvas_($this).height = _get_canvas_($this).clientHeight;
      _get_gameContext_($this)._viewport.update_29(_get_gameContext_($this)._gl, _get_gameContext_($this)._frameBufferScreen._width_2, _get_gameContext_($this)._frameBufferScreen._height_2, _get_gameContext_($this)._gameScreen._width_1, _get_gameContext_($this)._gameScreen._height_1);
    }var nowInSeconds = now * 0.001;
    var delta_0 = nowInSeconds - $this._then;
    $this._then = nowInSeconds;
    var tmp0_min_0 = 0.016666668;
    var tmp1_min_0 = delta_0;
    var deltaCapped = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float32Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
    _get_inputManager_($this).record_0();
    var tmp2_profile_0 = 'render';
    var result_1 = _get_gameWrapper_($this).render_1(deltaCapped);
    _get_inputManager_($this).reset_2();
    if (!_get_gameContext_($this)._fileHandler.isFullyLoaded_0()) {
      var tmp = window;
      tmp.requestAnimationFrame(_no_name_provided_$factory_125($this));
      Unit_getInstance();
    } else {
      $this._get_postRenderLoop_()();
      $this._set_postRenderLoop__0(_no_name_provided_$factory_126());
      var tmp_0 = window;
      tmp_0.requestAnimationFrame(_no_name_provided_$factory_127($this));
      Unit_getInstance();
    }
  }
  function _no_name_provided__142() {
  }
  _no_name_provided__142.prototype.invoke_231 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__142.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__142.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__143(this$0) {
    this._this$0_59 = this$0;
  }
  _no_name_provided__143.prototype.invoke_274 = function () {
    return '' + "Creating FileHandler with path root '" + this._this$0_59._get_configuration__4()._rootPath + "'";
  };
  _no_name_provided__143.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__144($boundThis) {
    this._$boundThis = $boundThis;
  }
  _no_name_provided__144.prototype.invoke_233 = function (p0) {
    return loading(this._$boundThis, p0);
  };
  _no_name_provided__144.prototype.invoke_276 = function (p1) {
    this.invoke_233((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__144.prototype._get_name__24 = function () {
    return 'loading';
  };
  _no_name_provided__144.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__145($boundThis) {
    this._$boundThis_0 = $boundThis;
  }
  _no_name_provided__145.prototype.invoke_233 = function (p0) {
    return loading(this._$boundThis_0, p0);
  };
  _no_name_provided__145.prototype.invoke_276 = function (p1) {
    this.invoke_233((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__145.prototype._get_name__24 = function () {
    return 'loading';
  };
  _no_name_provided__145.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__146($boundThis) {
    this._$boundThis_1 = $boundThis;
  }
  _no_name_provided__146.prototype.invoke_233 = function (p0) {
    return render_0(this._$boundThis_1, p0);
  };
  _no_name_provided__146.prototype.invoke_276 = function (p1) {
    this.invoke_233((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__146.prototype._get_name__24 = function () {
    return 'render';
  };
  _no_name_provided__146.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__147($boundThis) {
    this._$boundThis_2 = $boundThis;
  }
  _no_name_provided__147.prototype.invoke_233 = function (p0) {
    return loading(this._$boundThis_2, p0);
  };
  _no_name_provided__147.prototype.invoke_276 = function (p1) {
    this.invoke_233((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__147.prototype._get_name__24 = function () {
    return 'loading';
  };
  _no_name_provided__147.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__148() {
  }
  _no_name_provided__148.prototype.invoke_231 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__148.prototype.invoke_274 = function () {
    this.invoke_231();
    return Unit_getInstance();
  };
  _no_name_provided__148.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__149($boundThis) {
    this._$boundThis_3 = $boundThis;
  }
  _no_name_provided__149.prototype.invoke_233 = function (p0) {
    return render_0(this._$boundThis_3, p0);
  };
  _no_name_provided__149.prototype.invoke_276 = function (p1) {
    this.invoke_233((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__149.prototype._get_name__24 = function () {
    return 'render';
  };
  _no_name_provided__149.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WebGL(gl) {
    this._gl_3 = gl;
  }
  WebGL.prototype.clearColor_2 = function (r, g, b, a) {
    this._gl_3.clearColor(toPercent(r), toPercent(g), toPercent(b), toPercent(a));
  };
  WebGL.prototype.clear_18 = function (mask) {
    this._gl_3.clear(mask);
  };
  WebGL.prototype.clearDepth_2 = function (depth) {
    this._gl_3.clearDepth(numberToDouble(depth));
  };
  WebGL.prototype.enable_2 = function (mask) {
    this._gl_3.enable(mask);
  };
  WebGL.prototype.disable_2 = function (mask) {
    this._gl_3.disable(mask);
  };
  WebGL.prototype.blendFunc_2 = function (sfactor, dfactor) {
    this._gl_3.blendFunc(sfactor, dfactor);
  };
  WebGL.prototype.depthFunc_2 = function (target) {
    this._gl_3.depthFunc(target);
  };
  WebGL.prototype.vertexAttribPointer_2 = function (index, size_0, type, normalized, stride, offset) {
    this._gl_3.vertexAttribPointer(index, size_0, type, normalized, stride, offset);
  };
  WebGL.prototype.createProgram_2 = function () {
    return new ShaderProgram(this, new PlatformShaderProgram(ensureNotNull(this._gl_3.createProgram())));
  };
  WebGL.prototype.useProgram_2 = function (shaderProgram) {
    this._gl_3.useProgram(shaderProgram._program_1._delegate_3);
  };
  WebGL.prototype.getAttribLocation_2 = function (shaderProgram, name) {
    return this._gl_3.getAttribLocation(shaderProgram._program_1._delegate_3, name);
  };
  WebGL.prototype.enableVertexAttribArray_2 = function (index) {
    this._gl_3.enableVertexAttribArray(index);
  };
  WebGL.prototype.getUniformLocation_2 = function (shaderProgram, name) {
    var location = this._gl_3.getUniformLocation(shaderProgram._program_1._delegate_3, name);
    var tmp0_elvis_lhs = location;
    if (tmp0_elvis_lhs == null)
      throw RuntimeException_init_$Create$('' + "Uniform '" + name + "' not created. Check that your shader include this uniform.");
    else
      tmp0_elvis_lhs;
    Unit_getInstance();
    return new Uniform(location);
  };
  WebGL.prototype.uniformMatrix4fv_4 = function (uniform, transpose_0, data) {
    this._gl_3.uniformMatrix4fv(uniform._uniformLocation, transpose_0, data);
  };
  WebGL.prototype.uniform1i_2 = function (uniform, data) {
    this._gl_3.uniform1i(uniform._uniformLocation, data);
  };
  WebGL.prototype.uniform1f_2 = function (uniform, first_1) {
    this._gl_3.uniform1f(uniform._uniformLocation, first_1);
  };
  WebGL.prototype.uniform2f_2 = function (uniform, first_1, second) {
    this._gl_3.uniform2f(uniform._uniformLocation, first_1, second);
  };
  WebGL.prototype.uniform3f_2 = function (uniform, first_1, second, third) {
    this._gl_3.uniform3f(uniform._uniformLocation, first_1, second, third);
  };
  WebGL.prototype.uniform4f_2 = function (uniform, first_1, second, third, fourth) {
    this._gl_3.uniform4f(uniform._uniformLocation, first_1, second, third, fourth);
  };
  WebGL.prototype.attachShader_2 = function (shaderProgram, shader) {
    this._gl_3.attachShader(shaderProgram._program_1._delegate_3, shader._delegate_4);
  };
  WebGL.prototype.linkProgram_2 = function (shaderProgram) {
    this._gl_3.linkProgram(shaderProgram._program_1._delegate_3);
  };
  WebGL.prototype.getString_2 = function (parameterName) {
    var tmp = this._gl_3.getParameter(parameterName);
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  };
  WebGL.prototype.getProgramParameter_2 = function (shaderProgram, mask) {
    return ensureNotNull(this._gl_3.getProgramParameter(shaderProgram._program_1._delegate_3, mask));
  };
  WebGL.prototype.getShaderParameter_2 = function (shader, mask) {
    return ensureNotNull(this._gl_3.getShaderParameter(shader._delegate_4, mask));
  };
  WebGL.prototype.createShader_2 = function (type) {
    return new Shader(ensureNotNull(this._gl_3.createShader(type)));
  };
  WebGL.prototype.shaderSource_2 = function (shader, source) {
    this._gl_3.shaderSource(shader._delegate_4, source);
  };
  WebGL.prototype.compileShader_3 = function (shader) {
    this._gl_3.compileShader(shader._delegate_4);
  };
  WebGL.prototype.getShaderInfoLog_2 = function (shader) {
    var tmp0_elvis_lhs = this._gl_3.getShaderInfoLog(shader._delegate_4);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  WebGL.prototype.deleteShader_2 = function (shader) {
    this._gl_3.deleteShader(shader._delegate_4);
  };
  WebGL.prototype.getProgramInfoLog_2 = function (shader) {
    var tmp0_elvis_lhs = this._gl_3.getProgramInfoLog(shader._program_1._delegate_3);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  WebGL.prototype.createBuffer_2 = function () {
    return new Buffer(ensureNotNull(this._gl_3.createBuffer()));
  };
  WebGL.prototype.bindBuffer_2 = function (target, buffer) {
    this._gl_3.bindBuffer(target, buffer._delegate_2);
  };
  WebGL.prototype.bufferData_2 = function (target, data, usage) {
    var tmp0_subject = data;
    var tmp;
    if (tmp0_subject instanceof FloatDataSource) {
      tmp = new Float32Array(toTypedArray(data._floats));
    } else {
      if (tmp0_subject instanceof IntDataSource) {
        tmp = new Uint32Array(toTypedArray_0(data._ints));
      } else {
        if (tmp0_subject instanceof ShortDataSource) {
          tmp = new Uint16Array(toTypedArray_1(data._shorts));
        } else {
          if (tmp0_subject instanceof DoubleDataSource) {
            var tmp0_TODO_0 = 'Not supported';
            throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
          } else {
            if (tmp0_subject instanceof UIntDataSource) {
              tmp = new Uint32Array(toTypedArray_0(data._ints_0));
            } else {
              {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    var converted = tmp;
    this._gl_3.bufferData(target, converted, usage);
  };
  WebGL.prototype.drawElements_2 = function (mask, vertexCount, type, offset) {
    this._gl_3.drawElements(mask, vertexCount, type, offset);
  };
  WebGL.prototype.viewport_2 = function (x, y, width, height) {
    this._gl_3.viewport(x, y, width, height);
  };
  WebGL.prototype.createTexture_2 = function () {
    return new TextureReference(ensureNotNull(this._gl_3.createTexture()));
  };
  WebGL.prototype.activeTexture_2 = function (byteMask) {
    this._gl_3.activeTexture(byteMask);
  };
  WebGL.prototype.bindTexture_2 = function (target, textureReference) {
    this._gl_3.bindTexture(target, textureReference._reference_0);
  };
  WebGL.prototype.texImage2D_4 = function (target, level, internalformat, format, type, source) {
    this._gl_3.texImage2D(target, level, internalformat, format, type, source._source_0);
  };
  WebGL.prototype.texImage2D_5 = function (target, level, internalformat, format, width, height, type, source) {
    this._gl_3.texImage2D(target, level, internalformat, width, height, 0, format, type, new Uint8Array(toTypedArray_2(source)));
  };
  WebGL.prototype.texParameteri_2 = function (target, paramName, paramValue) {
    this._gl_3.texParameteri(target, paramName, paramValue);
  };
  WebGL.$metadata$ = {
    simpleName: 'WebGL',
    kind: 'class',
    interfaces: [GL]
  };
  function PlatformFileHandler(rootPath, audioContext, logger) {
    this._rootPath_0 = rootPath;
    this._audioContext = audioContext;
    this._logger_3 = logger;
  }
  PlatformFileHandler.prototype.read_4 = function (filename) {
    return asyncContent(this, filename, _no_name_provided_$factory_128(this));
  };
  PlatformFileHandler.prototype.readData_1 = function (filename) {
    return asyncContent(this, filename, _no_name_provided_$factory_129(this));
  };
  PlatformFileHandler.prototype.readTextureImage_1 = function (filename) {
    var img = new Image(void 1, void 1);
    img.src = computeUrl(this, filename);
    var content = new Content(filename, this._logger_3);
    img.addEventListener('load', new _no_name_provided__153(content, img), void 1);
    return content;
  };
  PlatformFileHandler.prototype.readSound_1 = function (filename) {
    var tmp = asyncContent(this, filename, _no_name_provided_$factory_130());
    return tmp.flatMap(_no_name_provided_$factory_131(filename, this));
  };
  PlatformFileHandler.prototype.toByteArray = function (_this__0) {
    var tmp0_unsafeCast_0 = new Int8Array(_this__0, void 1, void 1);
    return tmp0_unsafeCast_0;
  };
  PlatformFileHandler.$metadata$ = {
    simpleName: 'PlatformFileHandler',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_128(this$0) {
    var i = new _no_name_provided__151(this$0);
    return function (p1) {
      return i.invoke_243(p1);
    };
  }
  function _no_name_provided_$factory_129(this$0) {
    var i = new _no_name_provided__152(this$0);
    return function (p1) {
      return i.invoke_243(p1);
    };
  }
  function _no_name_provided_$factory_130() {
    var i = new _no_name_provided__154();
    return function (p1) {
      return i.invoke_243(p1);
    };
  }
  function _no_name_provided_$factory_131($filename, this$0) {
    var i = new _no_name_provided__155($filename, this$0);
    return function (p1) {
      return i.invoke_243(p1);
    };
  }
  function _no_name_provided_$factory_132($jsonFile, $enc, $content) {
    var i = new _no_name_provided__156($jsonFile, $enc, $content);
    return function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_133($content, this$0) {
    var i = new _no_name_provided__150($content, this$0);
    return function (p1) {
      i.invoke_235(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__150($content, this$0) {
    this._$content = $content;
    this._this$0_60 = this$0;
  }
  _no_name_provided__150.prototype.invoke_235 = function (buffer) {
    this._$content.load_2(new Sound(buffer, this._this$0_60._audioContext));
  };
  _no_name_provided__150.prototype.invoke_276 = function (p1) {
    this.invoke_235(p1 instanceof JsSound ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__150.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function asyncContent($this, filename, enc) {
    var url = computeUrl($this, filename);
    var jsonFile = new XMLHttpRequest();
    var tmp0__get_ARRAYBUFFER__0 = null;
    var tmp0_asDynamic_0_2 = 'arraybuffer';
    var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2;
    jsonFile.responseType = tmp1_unsafeCast_0_1;
    jsonFile.open('GET', url, true, void 1, void 1);
    var content = new Content(filename, $this._logger_3);
    jsonFile.onload = _no_name_provided_$factory_132(jsonFile, enc, content);
    jsonFile.send(void 1);
    return content;
  }
  function computeUrl($this, filename) {
    var path = $this._rootPath_0;
    var url = path + filename;
    return url;
  }
  function _no_name_provided__151(this$0) {
    this._this$0_61 = this$0;
  }
  _no_name_provided__151.prototype.invoke_243 = function (it) {
    return decodeToString(this._this$0_61.toByteArray(it));
  };
  _no_name_provided__151.prototype.invoke_276 = function (p1) {
    return this.invoke_243(p1 instanceof ArrayBuffer ? p1 : THROW_CCE());
  };
  _no_name_provided__151.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__152(this$0) {
    this._this$0_62 = this$0;
  }
  _no_name_provided__152.prototype.invoke_243 = function (it) {
    return this._this$0_62.toByteArray(it);
  };
  _no_name_provided__152.prototype.invoke_276 = function (p1) {
    return this.invoke_243(p1 instanceof ArrayBuffer ? p1 : THROW_CCE());
  };
  _no_name_provided__152.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__153($content, $img) {
    this._$content_0 = $content;
    this._$img = $img;
  }
  _no_name_provided__153.prototype.handleEvent_0 = function (event) {
    this._$content_0.load_2(new TextureImage(this._$img, this._$img.width, this._$img.height));
  };
  _no_name_provided__153.prototype.handleEvent = function (event) {
    return this.handleEvent_0(event);
  };
  _no_name_provided__153.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__154() {
  }
  _no_name_provided__154.prototype.invoke_243 = function (it) {
    return it;
  };
  _no_name_provided__154.prototype.invoke_276 = function (p1) {
    return this.invoke_243(p1 instanceof ArrayBuffer ? p1 : THROW_CCE());
  };
  _no_name_provided__154.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__155($filename, this$0) {
    this._$filename_1 = $filename;
    this._this$0_63 = this$0;
  }
  _no_name_provided__155.prototype.invoke_243 = function (bytes) {
    var content = new Content(this._$filename_1, this._this$0_63._logger_3);
    this._this$0_63._audioContext.decodeAudioData(bytes, _no_name_provided_$factory_133(content, this._this$0_63));
    return content;
  };
  _no_name_provided__155.prototype.invoke_276 = function (p1) {
    return this.invoke_243(p1 instanceof ArrayBuffer ? p1 : THROW_CCE());
  };
  _no_name_provided__155.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__156($jsonFile, $enc, $content) {
    this._$jsonFile = $jsonFile;
    this._$enc = $enc;
    this._$content_1 = $content;
  }
  _no_name_provided__156.prototype.invoke_265 = function (_anonymous_parameter_0_) {
    if (this._$jsonFile.readyState === 4 ? this._$jsonFile.status === 200 : false) {
      var tmp = this._$jsonFile.response;
      var element = this._$enc(tmp instanceof ArrayBuffer ? tmp : THROW_CCE());
      this._$content_1.load_2(element);
    }};
  _no_name_provided__156.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__156.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Sound(sound, audioContext) {
    this._sound = sound;
    this._audioContext_0 = audioContext;
  }
  Sound.prototype.play = function (loop) {
    var source = this._audioContext_0.createBufferSource();
    source.buffer = this._sound;
    source.connect(this._audioContext_0.destination);
    source.start(0);
  };
  Sound.prototype.play$default = function (loop, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      loop = 1;
    return this.play(loop);
  };
  Sound.$metadata$ = {
    simpleName: 'Sound',
    kind: 'class',
    interfaces: []
  };
  function TextureImage(source, width, height) {
    this._source_0 = source;
    this._width_6 = width;
    this._height_7 = height;
  }
  TextureImage.$metadata$ = {
    simpleName: 'TextureImage',
    kind: 'class',
    interfaces: []
  };
  function JsInputHandler(canvas, gameContext) {
    this._canvas_1 = canvas;
    this._gameContext_6 = gameContext;
    var tmp = document;
    tmp.addEventListener('keydown', _no_name_provided_$factory_134(this), false);
    var tmp_0 = document;
    tmp_0.addEventListener('keyup', _no_name_provided_$factory_135(this), false);
    this._canvas_1.addEventListener('touchstart', _no_name_provided_$factory_136(this), false);
    this._canvas_1.addEventListener('touchend', _no_name_provided_$factory_137(this), false);
    this._canvas_1.addEventListener('touchmove', _no_name_provided_$factory_138(this), false);
    this._canvas_1.addEventListener('mousedown', _no_name_provided_$factory_139(this), false);
    this._canvas_1.addEventListener('mouseup', _no_name_provided_$factory_140(this), false);
    this._canvas_1.addEventListener('mousemove', _no_name_provided_$factory_141(this), false);
    this._canvas_1.addEventListener('mouseleave', _no_name_provided_$factory_142(this), false);
    this._canvas_1.addEventListener('mouseenter', _no_name_provided_$factory_143(this), false);
    this._flagMouse1 = 1;
    this._flagMouse2 = 16;
    this._flagMouse3 = 256;
    var tmp_1 = this;
    var tmp0_arrayOf_0 = [this._flagMouse1, this._flagMouse2, this._flagMouse3];
    tmp_1._flags = tmp0_arrayOf_0;
    this._touchSignals = arrayListOf([TouchSignal_TOUCH1_getInstance(), TouchSignal_TOUCH2_getInstance(), TouchSignal_TOUCH3_getInstance()]);
    this._touchManager = new TouchManager(257);
    this._isMouseInsideCanvas = false;
    this._mousePosition = Vector2_init_$Create$(0, 0);
  }
  JsInputHandler.prototype.isKeyJustPressed_1 = function (key) {
    var tmp;
    if (key.equals(Key_ANY_KEY_getInstance())) {
      tmp = this._touchManager._isAnyKeyJustPressed;
    } else {
      tmp = this._touchManager.isKeyJustPressed_0(_get_keyCode_(key));
    }
    return tmp;
  };
  JsInputHandler.prototype.isJustTouched_1 = function (signal) {
    return this._touchManager.isJustTouched_1(signal);
  };
  JsInputHandler.prototype.touchIdlePosition_0 = function () {
    var tmp;
    if (this._isMouseInsideCanvas) {
      tmp = this._mousePosition;
    } else {
      tmp = null;
    }
    return tmp;
  };
  JsInputHandler.prototype.record_0 = function () {
    return Unit_getInstance();
  };
  JsInputHandler.prototype.reset_2 = function () {
    this._touchManager.processReceivedEvent();
  };
  JsInputHandler.$metadata$ = {
    simpleName: 'JsInputHandler',
    kind: 'class',
    interfaces: [InputHandler, InputManager]
  };
  function _no_name_provided_$factory_134($boundThis) {
    var i = new _no_name_provided__157($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_135($boundThis) {
    var i = new _no_name_provided__158($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_136($boundThis) {
    var i = new _no_name_provided__159($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_137($boundThis) {
    var i = new _no_name_provided__160($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_138($boundThis) {
    var i = new _no_name_provided__161($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_139($boundThis) {
    var i = new _no_name_provided__162($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_140($boundThis) {
    var i = new _no_name_provided__163($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_141($boundThis) {
    var i = new _no_name_provided__164($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_142($boundThis) {
    var i = new _no_name_provided__165($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function _no_name_provided_$factory_143($boundThis) {
    var i = new _no_name_provided__166($boundThis);
    var l = function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__24();
    return l;
  }
  function mouseDown($this, event) {
    if (event instanceof MouseEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var jsTouch = event.buttons;
    var tmp0_forEachIndexed_0 = $this._flags;
    var index_1 = 0;
    var indexedObject = tmp0_forEachIndexed_0;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_4 = index_1;
      index_1 = tmp1_4 + 1 | 0;
      var tmp1__anonymous__5 = tmp1_4;
      if (toShort_0(jsTouch & item_3) === item_3) {
        var touch_6 = $this._touchSignals.get_57(tmp1__anonymous__5);
        var rect_7 = $this._canvas_1.getBoundingClientRect();
        var x_8 = event.clientX - rect_7.left;
        var y_9 = event.clientY - rect_7.top;
        var gamePosition_10 = convert($this._gameContext_6, x_8, y_9);
        var tmp0_safe_receiver_11 = gamePosition_10;
        if (tmp0_safe_receiver_11 == null)
          null;
        else {
          var gameX_2_12 = tmp0_safe_receiver_11.component1();
          var gameY_3_13 = tmp0_safe_receiver_11.component2();
          $this._touchManager.onTouchDown(touch_6, gameX_2_12, gameY_3_13);
          Unit_getInstance();
        }
        Unit_getInstance();
      } else {
      }
    }
  }
  function mouseUp($this, event) {
    if (event instanceof MouseEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var tmp0_forEach_0 = $this._touchSignals;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      $this._touchManager.onTouchUp(element_2);
    }
  }
  function mouseMove($this, event) {
    if (event instanceof MouseEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var jsTouch = event.buttons;
    var tmp0_forEachIndexed_0 = $this._flags;
    var index_1 = 0;
    var indexedObject = tmp0_forEachIndexed_0;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    while (inductionVariable < last_2) {
      var item_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_4 = index_1;
      index_1 = tmp1_4 + 1 | 0;
      var tmp1__anonymous__5 = tmp1_4;
      if (toShort_0(jsTouch & item_3) === item_3) {
        var touch_6 = $this._touchSignals.get_57(tmp1__anonymous__5);
        var rect_7 = $this._canvas_1.getBoundingClientRect();
        var x_8 = event.clientX - rect_7.left;
        var y_9 = event.clientY - rect_7.top;
        var gamePosition_10 = convert($this._gameContext_6, x_8, y_9);
        var tmp0_safe_receiver_11 = gamePosition_10;
        if (tmp0_safe_receiver_11 == null)
          null;
        else {
          var gameX_2_12 = tmp0_safe_receiver_11.component1();
          var gameY_3_13 = tmp0_safe_receiver_11.component2();
          $this._touchManager.onTouchMove(touch_6, gameX_2_12, gameY_3_13);
          Unit_getInstance();
        }
        Unit_getInstance();
      } else {
      }
    }
    if ($this._isMouseInsideCanvas) {
      var rect = $this._canvas_1.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      var gamePosition = convert($this._gameContext_6, x, y);
      if (gamePosition == null) {
        $this._isMouseInsideCanvas = false;
      } else {
        var tmp0_container = gamePosition;
        var gameX = tmp0_container.component1();
        var gameY = tmp0_container.component2();
        $this._mousePosition._x_10 = gameX;
        $this._mousePosition._y_10 = gameY;
      }
    }}
  function mouseLeave($this, event) {
    $this._isMouseInsideCanvas = false;
  }
  function mouseEnter($this, event) {
    $this._isMouseInsideCanvas = true;
  }
  function touchStart($this, event) {
    if (event instanceof TouchEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var tmp0_forEach_0 = until(0, event.targetTouches.length);
    var inductionVariable = tmp0_forEach_0._get_first__2();
    var last_2 = tmp0_forEach_0._get_last__4();
    if (inductionVariable <= last_2)
      do {
        var element_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_5 = event.targetTouches;
        var jsTouch_4 = ensureNotNull(tmp0_get_0_5[element_2]);
        var touch_6 = $this._touchManager.getTouchSignal(jsTouch_4.identifier);
        var rect_7 = $this._canvas_1.getBoundingClientRect();
        var x_8 = jsTouch_4.clientX - rect_7.left;
        var y_9 = jsTouch_4.clientY - rect_7.top;
        var gamePosition_10 = convert($this._gameContext_6, x_8, y_9);
        var tmp0_safe_receiver_11 = gamePosition_10;
        if (tmp0_safe_receiver_11 == null)
          null;
        else {
          var gameX_2_12 = tmp0_safe_receiver_11.component1();
          var gameY_3_13 = tmp0_safe_receiver_11.component2();
          $this._touchManager.onTouchDown(touch_6, gameX_2_12, gameY_3_13);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
       while (!(element_2 === last_2));
  }
  function touchEnd($this, event) {
    if (event instanceof TouchEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var tmp0_forEach_0 = until(0, event.targetTouches.length);
    var inductionVariable = tmp0_forEach_0._get_first__2();
    var last_2 = tmp0_forEach_0._get_last__4();
    if (inductionVariable <= last_2)
      do {
        var element_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_5 = event.targetTouches;
        var jsTouch_4 = ensureNotNull(tmp0_get_0_5[element_2]);
        var touch_6 = $this._touchManager.getTouchSignal(jsTouch_4.identifier);
        $this._touchManager.onTouchUp(touch_6);
      }
       while (!(element_2 === last_2));
  }
  function touchMove($this, event) {
    if (event instanceof TouchEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var tmp0_forEach_0 = until(0, event.targetTouches.length);
    var inductionVariable = tmp0_forEach_0._get_first__2();
    var last_2 = tmp0_forEach_0._get_last__4();
    if (inductionVariable <= last_2)
      do {
        var element_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_5 = event.targetTouches;
        var jsTouch_4 = ensureNotNull(tmp0_get_0_5[element_2]);
        var touch_6 = $this._touchManager.getTouchSignal(jsTouch_4.identifier);
        var rect_7 = $this._canvas_1.getBoundingClientRect();
        var x_8 = jsTouch_4.clientX - rect_7.left;
        var y_9 = jsTouch_4.clientY - rect_7.top;
        var gamePosition_10 = convert($this._gameContext_6, x_8, y_9);
        var tmp0_safe_receiver_11 = gamePosition_10;
        if (tmp0_safe_receiver_11 == null)
          null;
        else {
          var gameX_2_12 = tmp0_safe_receiver_11.component1();
          var gameY_3_13 = tmp0_safe_receiver_11.component2();
          $this._touchManager.onTouchMove(touch_6, gameX_2_12, gameY_3_13);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
       while (!(element_2 === last_2));
  }
  function keyDown($this, event) {
    if (event instanceof KeyboardEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var containsArg = event.keyCode;
    if (0 <= containsArg ? containsArg <= 256 : false) {
      $this._touchManager.onKeyPressed(event.keyCode);
      event.preventDefault();
    } else {
    }
  }
  function keyUp($this, event) {
    if (event instanceof KeyboardEvent)
      event;
    else
      THROW_CCE();
    Unit_getInstance();
    var containsArg = event.keyCode;
    if (0 <= containsArg ? containsArg <= 256 : false) {
      $this._touchManager.onKeyReleased(event.keyCode);
      event.preventDefault();
    } else {
    }
  }
  function _no_name_provided__157($boundThis) {
    this._$boundThis_4 = $boundThis;
  }
  _no_name_provided__157.prototype.invoke_265 = function (p0) {
    return keyDown(this._$boundThis_4, p0);
  };
  _no_name_provided__157.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__157.prototype._get_name__24 = function () {
    return 'keyDown';
  };
  _no_name_provided__157.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__158($boundThis) {
    this._$boundThis_5 = $boundThis;
  }
  _no_name_provided__158.prototype.invoke_265 = function (p0) {
    return keyUp(this._$boundThis_5, p0);
  };
  _no_name_provided__158.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__158.prototype._get_name__24 = function () {
    return 'keyUp';
  };
  _no_name_provided__158.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__159($boundThis) {
    this._$boundThis_6 = $boundThis;
  }
  _no_name_provided__159.prototype.invoke_265 = function (p0) {
    return touchStart(this._$boundThis_6, p0);
  };
  _no_name_provided__159.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__159.prototype._get_name__24 = function () {
    return 'touchStart';
  };
  _no_name_provided__159.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__160($boundThis) {
    this._$boundThis_7 = $boundThis;
  }
  _no_name_provided__160.prototype.invoke_265 = function (p0) {
    return touchEnd(this._$boundThis_7, p0);
  };
  _no_name_provided__160.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__160.prototype._get_name__24 = function () {
    return 'touchEnd';
  };
  _no_name_provided__160.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__161($boundThis) {
    this._$boundThis_8 = $boundThis;
  }
  _no_name_provided__161.prototype.invoke_265 = function (p0) {
    return touchMove(this._$boundThis_8, p0);
  };
  _no_name_provided__161.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__161.prototype._get_name__24 = function () {
    return 'touchMove';
  };
  _no_name_provided__161.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__162($boundThis) {
    this._$boundThis_9 = $boundThis;
  }
  _no_name_provided__162.prototype.invoke_265 = function (p0) {
    return mouseDown(this._$boundThis_9, p0);
  };
  _no_name_provided__162.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__162.prototype._get_name__24 = function () {
    return 'mouseDown';
  };
  _no_name_provided__162.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__163($boundThis) {
    this._$boundThis_10 = $boundThis;
  }
  _no_name_provided__163.prototype.invoke_265 = function (p0) {
    return mouseUp(this._$boundThis_10, p0);
  };
  _no_name_provided__163.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__163.prototype._get_name__24 = function () {
    return 'mouseUp';
  };
  _no_name_provided__163.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__164($boundThis) {
    this._$boundThis_11 = $boundThis;
  }
  _no_name_provided__164.prototype.invoke_265 = function (p0) {
    return mouseMove(this._$boundThis_11, p0);
  };
  _no_name_provided__164.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__164.prototype._get_name__24 = function () {
    return 'mouseMove';
  };
  _no_name_provided__164.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__165($boundThis) {
    this._$boundThis_12 = $boundThis;
  }
  _no_name_provided__165.prototype.invoke_265 = function (p0) {
    return mouseLeave(this._$boundThis_12, p0);
  };
  _no_name_provided__165.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__165.prototype._get_name__24 = function () {
    return 'mouseLeave';
  };
  _no_name_provided__165.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__166($boundThis) {
    this._$boundThis_13 = $boundThis;
  }
  _no_name_provided__166.prototype.invoke_265 = function (p0) {
    return mouseEnter(this._$boundThis_13, p0);
  };
  _no_name_provided__166.prototype.invoke_276 = function (p1) {
    this.invoke_265(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__166.prototype._get_name__24 = function () {
    return 'mouseEnter';
  };
  _no_name_provided__166.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _get_keyCode_(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(Key_ANY_KEY_getInstance())) {
      tmp = 257;
    } else if (tmp0_subject.equals(Key_BACKSPACE_getInstance())) {
      tmp = 8;
    } else if (tmp0_subject.equals(Key_TAB_getInstance())) {
      tmp = 9;
    } else if (tmp0_subject.equals(Key_ENTER_getInstance())) {
      tmp = 13;
    } else if (tmp0_subject.equals(Key_SHIFT_getInstance())) {
      tmp = 16;
    } else if (tmp0_subject.equals(Key_CTRL_getInstance())) {
      tmp = 17;
    } else if (tmp0_subject.equals(Key_ALT_getInstance())) {
      tmp = 18;
    } else if (tmp0_subject.equals(Key_PAUSE_BREAK_getInstance())) {
      tmp = 19;
    } else if (tmp0_subject.equals(Key_CAPS_LOCK_getInstance())) {
      tmp = 20;
    } else if (tmp0_subject.equals(Key_ESCAPE_getInstance())) {
      tmp = 27;
    } else if (tmp0_subject.equals(Key_PAGE_UP_getInstance())) {
      tmp = 33;
    } else if (tmp0_subject.equals(Key_SPACE_getInstance())) {
      tmp = 32;
    } else if (tmp0_subject.equals(Key_PAGE_DOWN_getInstance())) {
      tmp = 34;
    } else if (tmp0_subject.equals(Key_END_getInstance())) {
      tmp = 35;
    } else if (tmp0_subject.equals(Key_HOME_getInstance())) {
      tmp = 36;
    } else if (tmp0_subject.equals(Key_ARROW_LEFT_getInstance())) {
      tmp = 37;
    } else if (tmp0_subject.equals(Key_ARROW_UP_getInstance())) {
      tmp = 38;
    } else if (tmp0_subject.equals(Key_ARROW_RIGHT_getInstance())) {
      tmp = 39;
    } else if (tmp0_subject.equals(Key_ARROW_DOWN_getInstance())) {
      tmp = 40;
    } else if (tmp0_subject.equals(Key_PRINT_SCREEN_getInstance())) {
      tmp = 44;
    } else if (tmp0_subject.equals(Key_INSERT_getInstance())) {
      tmp = 45;
    } else if (tmp0_subject.equals(Key_DELETE_getInstance())) {
      tmp = 46;
    } else if (tmp0_subject.equals(Key_NUM0_getInstance())) {
      tmp = 48;
    } else if (tmp0_subject.equals(Key_NUM1_getInstance())) {
      tmp = 49;
    } else if (tmp0_subject.equals(Key_NUM2_getInstance())) {
      tmp = 50;
    } else if (tmp0_subject.equals(Key_NUM3_getInstance())) {
      tmp = 51;
    } else if (tmp0_subject.equals(Key_NUM4_getInstance())) {
      tmp = 52;
    } else if (tmp0_subject.equals(Key_NUM5_getInstance())) {
      tmp = 53;
    } else if (tmp0_subject.equals(Key_NUM6_getInstance())) {
      tmp = 54;
    } else if (tmp0_subject.equals(Key_NUM7_getInstance())) {
      tmp = 55;
    } else if (tmp0_subject.equals(Key_NUM8_getInstance())) {
      tmp = 56;
    } else if (tmp0_subject.equals(Key_NUM9_getInstance())) {
      tmp = 57;
    } else if (tmp0_subject.equals(Key_A_getInstance())) {
      tmp = 65;
    } else if (tmp0_subject.equals(Key_B_getInstance())) {
      tmp = 66;
    } else if (tmp0_subject.equals(Key_C_getInstance())) {
      tmp = 67;
    } else if (tmp0_subject.equals(Key_D_getInstance())) {
      tmp = 68;
    } else if (tmp0_subject.equals(Key_E_getInstance())) {
      tmp = 69;
    } else if (tmp0_subject.equals(Key_F_getInstance())) {
      tmp = 70;
    } else if (tmp0_subject.equals(Key_G_getInstance())) {
      tmp = 71;
    } else if (tmp0_subject.equals(Key_H_getInstance())) {
      tmp = 72;
    } else if (tmp0_subject.equals(Key_I_getInstance())) {
      tmp = 73;
    } else if (tmp0_subject.equals(Key_J_getInstance())) {
      tmp = 74;
    } else if (tmp0_subject.equals(Key_K_getInstance())) {
      tmp = 75;
    } else if (tmp0_subject.equals(Key_L_getInstance())) {
      tmp = 76;
    } else if (tmp0_subject.equals(Key_M_getInstance())) {
      tmp = 77;
    } else if (tmp0_subject.equals(Key_N_getInstance())) {
      tmp = 78;
    } else if (tmp0_subject.equals(Key_O_getInstance())) {
      tmp = 79;
    } else if (tmp0_subject.equals(Key_P_getInstance())) {
      tmp = 80;
    } else if (tmp0_subject.equals(Key_Q_getInstance())) {
      tmp = 81;
    } else if (tmp0_subject.equals(Key_R_getInstance())) {
      tmp = 82;
    } else if (tmp0_subject.equals(Key_S_getInstance())) {
      tmp = 83;
    } else if (tmp0_subject.equals(Key_T_getInstance())) {
      tmp = 84;
    } else if (tmp0_subject.equals(Key_U_getInstance())) {
      tmp = 85;
    } else if (tmp0_subject.equals(Key_V_getInstance())) {
      tmp = 86;
    } else if (tmp0_subject.equals(Key_W_getInstance())) {
      tmp = 87;
    } else if (tmp0_subject.equals(Key_X_getInstance())) {
      tmp = 88;
    } else if (tmp0_subject.equals(Key_Y_getInstance())) {
      tmp = 89;
    } else if (tmp0_subject.equals(Key_Z_getInstance())) {
      tmp = 90;
    } else if (tmp0_subject.equals(Key_LEFT_WINDOW_KEY_getInstance())) {
      tmp = 91;
    } else if (tmp0_subject.equals(Key_RIGHT_WINDOW_KEY_getInstance())) {
      tmp = 92;
    } else if (tmp0_subject.equals(Key_SELECT_KEY_getInstance())) {
      tmp = 93;
    } else if (tmp0_subject.equals(Key_NUMPAD0_getInstance())) {
      tmp = 96;
    } else if (tmp0_subject.equals(Key_NUMPAD1_getInstance())) {
      tmp = 97;
    } else if (tmp0_subject.equals(Key_NUMPAD2_getInstance())) {
      tmp = 98;
    } else if (tmp0_subject.equals(Key_NUMPAD3_getInstance())) {
      tmp = 99;
    } else if (tmp0_subject.equals(Key_NUMPAD4_getInstance())) {
      tmp = 100;
    } else if (tmp0_subject.equals(Key_NUMPAD5_getInstance())) {
      tmp = 101;
    } else if (tmp0_subject.equals(Key_NUMPAD6_getInstance())) {
      tmp = 102;
    } else if (tmp0_subject.equals(Key_NUMPAD7_getInstance())) {
      tmp = 103;
    } else if (tmp0_subject.equals(Key_NUMPAD8_getInstance())) {
      tmp = 104;
    } else if (tmp0_subject.equals(Key_NUMPAD9_getInstance())) {
      tmp = 105;
    } else if (tmp0_subject.equals(Key_MULTIPLY_getInstance())) {
      tmp = 106;
    } else if (tmp0_subject.equals(Key_ADD_getInstance())) {
      tmp = 107;
    } else if (tmp0_subject.equals(Key_SUBTRACT_getInstance())) {
      tmp = 109;
    } else if (tmp0_subject.equals(Key_DECIMAL_POINT_getInstance())) {
      tmp = 110;
    } else if (tmp0_subject.equals(Key_DIVIDE_getInstance())) {
      tmp = 111;
    } else if (tmp0_subject.equals(Key_F1_getInstance())) {
      tmp = 112;
    } else if (tmp0_subject.equals(Key_F2_getInstance())) {
      tmp = 113;
    } else if (tmp0_subject.equals(Key_F3_getInstance())) {
      tmp = 114;
    } else if (tmp0_subject.equals(Key_F4_getInstance())) {
      tmp = 115;
    } else if (tmp0_subject.equals(Key_F5_getInstance())) {
      tmp = 116;
    } else if (tmp0_subject.equals(Key_F6_getInstance())) {
      tmp = 117;
    } else if (tmp0_subject.equals(Key_F7_getInstance())) {
      tmp = 118;
    } else if (tmp0_subject.equals(Key_F8_getInstance())) {
      tmp = 119;
    } else if (tmp0_subject.equals(Key_F9_getInstance())) {
      tmp = 120;
    } else if (tmp0_subject.equals(Key_F10_getInstance())) {
      tmp = 121;
    } else if (tmp0_subject.equals(Key_F11_getInstance())) {
      tmp = 122;
    } else if (tmp0_subject.equals(Key_F12_getInstance())) {
      tmp = 123;
    } else if (tmp0_subject.equals(Key_NUM_LOCK_getInstance())) {
      tmp = 144;
    } else if (tmp0_subject.equals(Key_SCROLL_LOCK_getInstance())) {
      tmp = 145;
    } else if (tmp0_subject.equals(Key_MY_COMPUTER_getInstance())) {
      tmp = 257;
    } else if (tmp0_subject.equals(Key_MY_CALCULATOR_getInstance())) {
      tmp = 257;
    } else if (tmp0_subject.equals(Key_SEMI_COLON_getInstance())) {
      tmp = 186;
    } else if (tmp0_subject.equals(Key_EQUAL_SIGN_getInstance())) {
      tmp = 187;
    } else if (tmp0_subject.equals(Key_COMMA_getInstance())) {
      tmp = 188;
    } else if (tmp0_subject.equals(Key_DASH_getInstance())) {
      tmp = 189;
    } else if (tmp0_subject.equals(Key_PERIOD_getInstance())) {
      tmp = 190;
    } else if (tmp0_subject.equals(Key_FORWARD_SLASH_getInstance())) {
      tmp = 191;
    } else if (tmp0_subject.equals(Key_OPEN_BRACKET_getInstance())) {
      tmp = 219;
    } else if (tmp0_subject.equals(Key_BACK_SLASH_getInstance())) {
      tmp = 220;
    } else if (tmp0_subject.equals(Key_CLOSE_BRAKET_getInstance())) {
      tmp = 221;
    } else if (tmp0_subject.equals(Key_SINGLE_QUOTE_getInstance())) {
      tmp = 222;
    } else if (tmp0_subject.equals(Key_DPAD_CENTER_getInstance())) {
      tmp = 257;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function JsLogger(gameName) {
    this._gameName_0 = gameName;
    this._rootLevel = LogLevel_INFO_getInstance();
  }
  JsLogger.prototype.info_1 = function (tag, message) {
    if (this._rootLevel._get_ordinal__1() >= LogLevel_INFO_getInstance()._get_ordinal__1()) {
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([].slice.call(['' + '(' + this._gameName_0 + ')[' + tag + '] ' + message()])));
      }.call(this));
    }};
  JsLogger.$metadata$ = {
    simpleName: 'JsLogger',
    kind: 'class',
    interfaces: [Logger]
  };
  function Buffer(delegate) {
    this._delegate_2 = delegate;
  }
  Buffer.$metadata$ = {
    simpleName: 'Buffer',
    kind: 'class',
    interfaces: []
  };
  function PlatformShaderProgram(delegate) {
    this._delegate_3 = delegate;
  }
  PlatformShaderProgram.$metadata$ = {
    simpleName: 'PlatformShaderProgram',
    kind: 'class',
    interfaces: []
  };
  function Shader(delegate) {
    this._delegate_4 = delegate;
  }
  Shader.$metadata$ = {
    simpleName: 'Shader',
    kind: 'class',
    interfaces: []
  };
  function TextureReference(reference) {
    this._reference_0 = reference;
  }
  TextureReference.$metadata$ = {
    simpleName: 'TextureReference',
    kind: 'class',
    interfaces: []
  };
  function Uniform(uniformLocation) {
    this._uniformLocation = uniformLocation;
  }
  Uniform.$metadata$ = {
    simpleName: 'Uniform',
    kind: 'class',
    interfaces: []
  };
  function Chrono(time) {
    this._time_2 = time;
  }
  Chrono.$metadata$ = {
    simpleName: 'Chrono',
    kind: 'class',
    interfaces: [Component]
  };
  function Score(score, coolDown) {
    this._score = score;
    this._coolDown = coolDown;
  }
  Score.$metadata$ = {
    simpleName: 'Score',
    kind: 'class',
    interfaces: [Component]
  };
  function Player(score, life, coolDown) {
    this._score_0 = score;
    this._life = life;
    this._coolDown_0 = coolDown;
  }
  Player.$metadata$ = {
    simpleName: 'Player',
    kind: 'class',
    interfaces: [Component]
  };
  function Enemy(life, key, ttl, duration, start, target, ready, waitingPoint, letter, waitingHit) {
    this._life_0 = life;
    this._key_2 = key;
    this._ttl_0 = ttl;
    this._duration_4 = duration;
    this._start = start;
    this._target = target;
    this._ready = ready;
    this._waitingPoint = waitingPoint;
    this._letter = letter;
    this._waitingHit = waitingHit;
  }
  Enemy.prototype.switchTo = function (waitingPoint) {
    this._target.set_6(_get_position_(waitingPoint)._get_localTranslation_());
    Unit_getInstance();
    this._waitingPoint = waitingPoint;
    waitingPoint.get_44(getKClass_0(Start))._occupied = true;
    this._ready = false;
  };
  Enemy.$metadata$ = {
    simpleName: 'Enemy',
    kind: 'class',
    interfaces: [Component]
  };
  function Dying(letter) {
    this._letter_0 = letter;
  }
  Dying.$metadata$ = {
    simpleName: 'Dying',
    kind: 'class',
    interfaces: [Component]
  };
  function Hit() {
  }
  Hit.$metadata$ = {
    simpleName: 'Hit',
    kind: 'class',
    interfaces: [Component]
  };
  function Spawn() {
  }
  Spawn.$metadata$ = {
    simpleName: 'Spawn',
    kind: 'class',
    interfaces: [Component]
  };
  function Start(intex, occupied) {
    this._intex = intex;
    this._occupied = occupied;
  }
  Start.$metadata$ = {
    simpleName: 'Start',
    kind: 'class',
    interfaces: [Component]
  };
  function Left_0() {
  }
  Left_0.$metadata$ = {
    simpleName: 'Left',
    kind: 'class',
    interfaces: [Component]
  };
  function Right() {
  }
  Right.$metadata$ = {
    simpleName: 'Right',
    kind: 'class',
    interfaces: [Component]
  };
  function Track(target) {
    this._target_0 = target;
  }
  Track.$metadata$ = {
    simpleName: 'Track',
    kind: 'class',
    interfaces: [Component]
  };
  function FreeWaingPoint(index, isLeft, newWaitingPoint) {
    this._index_6 = index;
    this._isLeft = isLeft;
    this._newWaitingPoint = newWaitingPoint;
  }
  FreeWaingPoint.$metadata$ = {
    simpleName: 'FreeWaingPoint',
    kind: 'class',
    interfaces: [Event_0]
  };
  function EnemyHit() {
  }
  EnemyHit.$metadata$ = {
    simpleName: 'EnemyHit',
    kind: 'class',
    interfaces: [Event_0]
  };
  function EndGame() {
  }
  EndGame.$metadata$ = {
    simpleName: 'EndGame',
    kind: 'class',
    interfaces: [Event_0]
  };
  function ScoreSystem() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(Score), getKClass_0(TextComponent)]);
    System_init_$Init$(tmp, null, 2, null, this);
    this._players$delegate = this.interested(Companion_getInstance_23().of_0([getKClass_0(Player)]));
  }
  ScoreSystem.prototype._get_players_ = function () {
    return this._players$delegate.getValue_5(this, players$factory());
  };
  ScoreSystem.prototype.update_61 = function (delta_0, entity) {
    var s = first(this._get_players_()).get_44(getKClass_0(Player))._score_0.toString();
    entity.get_44(getKClass_0(TextComponent))._get_text_()._set_content__0('' + 'score: ' + s + ' pts');
    var score = entity.get_44(getKClass_0(Score));
    var tmp0_this = score;
    tmp0_this._coolDown = tmp0_this._coolDown - delta_0;
    if (score._coolDown <= 0.0) {
      score._coolDown = 0.0;
    }};
  ScoreSystem.prototype.onEvent_26 = function (event, entityQuery) {
    if (event instanceof EnemyHit) {
      var tmp0_forEach_0 = this._get_entities__3();
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        var coolDown_4 = element_2.get_44(getKClass_0(Score))._coolDown;
        if (coolDown_4 <= 0.0) {
          var tmp = _get_position_(element_2);
          tmp.setLocalScale$default(1.5, 1.5, 0.0, 4, null);
          Unit_getInstance();
        }}
    } else {
    }
  };
  ScoreSystem.$metadata$ = {
    simpleName: 'ScoreSystem',
    kind: 'class',
    interfaces: []
  };
  function TrackSystem() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(Track)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  TrackSystem.prototype.update_61 = function (delta_0, entity) {
    var tmp = _get_position_(entity);
    var tmp_0 = _get_position_(entity.get_44(getKClass_0(Track))._target_0)._get_localTranslation_()._get_x_();
    tmp.setLocalTranslation$default_0(tmp_0, null, null, null, 14, null);
    Unit_getInstance();
  };
  TrackSystem.$metadata$ = {
    simpleName: 'TrackSystem',
    kind: 'class',
    interfaces: []
  };
  function EnemySpawner(maxLife, leftKeySet, rightKeySet) {
    TemporalSystem_init_$Init$(0.5, null, 2, null, this);
    this._maxLife = maxLife;
    this._leftKeySet = leftKeySet;
    this._rightKeySet = rightKeySet;
    this._rightSpawn$delegate = this.interested(EntityQuery_init_$Create$_0([getKClass_0(Spawn), getKClass_0(Right)]));
    this._leftSpawn$delegate = this.interested(EntityQuery_init_$Create$_0([getKClass_0(Spawn), getKClass_0(Left_0)]));
    this._rightStart$delegate = this.interested(EntityQuery_init_$Create$_0([getKClass_0(Start), getKClass_0(Right)]));
    this._leftStart$delegate = this.interested(EntityQuery_init_$Create$_0([getKClass_0(Start), getKClass_0(Left_0)]));
    var tmp = this;
    tmp._rightByIndex = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0._leftByIndex = ArrayList_init_$Create$();
    this._keyToStr = mapOf([to(Key_A_getInstance(), 'A'), to(Key_B_getInstance(), 'B'), to(Key_C_getInstance(), 'C'), to(Key_D_getInstance(), 'D'), to(Key_E_getInstance(), 'E'), to(Key_F_getInstance(), 'F'), to(Key_G_getInstance(), 'G'), to(Key_H_getInstance(), 'H'), to(Key_I_getInstance(), 'I'), to(Key_J_getInstance(), 'J'), to(Key_K_getInstance(), 'K'), to(Key_L_getInstance(), 'L'), to(Key_M_getInstance(), 'M'), to(Key_N_getInstance(), 'N'), to(Key_O_getInstance(), 'O'), to(Key_P_getInstance(), 'P'), to(Key_Q_getInstance(), 'Q'), to(Key_R_getInstance(), 'R'), to(Key_S_getInstance(), 'S'), to(Key_T_getInstance(), 'T'), to(Key_U_getInstance(), 'U'), to(Key_V_getInstance(), 'V'), to(Key_W_getInstance(), 'W'), to(Key_X_getInstance(), 'X'), to(Key_Y_getInstance(), 'Y'), to(Key_Z_getInstance(), 'Z')]);
  }
  EnemySpawner.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  EnemySpawner.prototype.onGameStarted_25 = function (engine) {
    var tmp0_sortedBy_0 = _get_rightStart_(this);
    var tmp = _no_name_provided_$factory_144();
    this._rightByIndex.addAll_11(sortedWith(tmp0_sortedBy_0, new sam$kotlin_Comparator$0_0(tmp)));
    Unit_getInstance();
    var tmp1_sortedBy_0 = _get_leftStart_(this);
    var tmp_0 = _no_name_provided_$factory_145();
    this._leftByIndex.addAll_11(sortedWith(tmp1_sortedBy_0, new sam$kotlin_Comparator$0_0(tmp_0)));
    Unit_getInstance();
  };
  EnemySpawner.prototype.timeElapsed_2 = function () {
    var isLeft = Default_getInstance().nextFloat_1() > 0.5;
    if (isLeft) {
      var target = firstAvailable(this, this._leftByIndex);
      if (target == null) {
        return Unit_getInstance();
      }var spawn = first(_get_leftSpawn_(this));
      create_0(this, new Left_0(), spawn, target, this._leftKeySet);
      Unit_getInstance();
    } else {
      var target_0 = firstAvailable(this, this._rightByIndex);
      if (target_0 == null) {
        return Unit_getInstance();
      }var spawn_0 = first(_get_rightSpawn_(this));
      create_0(this, new Right(), spawn_0, target_0, this._rightKeySet);
      Unit_getInstance();
    }
  };
  EnemySpawner.$metadata$ = {
    simpleName: 'EnemySpawner',
    kind: 'class',
    interfaces: []
  };
  function EnemyMove() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(Enemy)]);
    System_init_$Init$(tmp, null, 2, null, this);
    this._collider = new AABBCollisionResolver();
  }
  EnemyMove.prototype.update_61 = function (delta_0, entity) {
    var enemy = entity.get_44(getKClass_0(Enemy));
    if (enemy._ready) {
      if (ensureNotNull(enemy._waitingPoint).get_44(getKClass_0(Start))._intex === 1) {
        var tmp0_this = enemy;
        tmp0_this._waitingHit = tmp0_this._waitingHit - delta_0;
        if (enemy._waitingHit < 0.0) {
          enemy._waitingHit = 1.0;
        }}return Unit_getInstance();
    }var x = Interpolations_getInstance()._linear.interpolate_6(enemy._start._x_11, enemy._target._x_11, enemy._ttl_0 / enemy._duration_4);
    var tmp = _get_position_(entity);
    tmp.setLocalTranslation$default_0(x, null, null, null, 14, null);
    Unit_getInstance();
    var tmp1_this = enemy;
    tmp1_this._ttl_0 = tmp1_this._ttl_0 + delta_0;
    if (this._collider.collide_1(ensureNotNull(enemy._waitingPoint), entity)) {
      enemy._ready = true;
      var tmp_0 = _get_position_(entity);
      var tmp_1 = _get_position_(ensureNotNull(enemy._waitingPoint))._get_localTranslation_();
      tmp_0.setLocalTranslation$default(tmp_1, null, 2, null);
      Unit_getInstance();
    }};
  EnemyMove.prototype.onEvent_26 = function (event, entityQuery) {
    if (event instanceof FreeWaingPoint) {
      var tmp0_forEach_0 = this._get_entities__3();
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        if (ensureNotNull(element_2.get_44(getKClass_0(Enemy))._waitingPoint).get_44(getKClass_0(Start))._intex === event._index_6) {
          if (event._isLeft ? element_2.hasComponent(getKClass_0(Left_0)) : false) {
            freeWaitingPoint(this, element_2);
            element_2.get_44(getKClass_0(Enemy)).switchTo(event._newWaitingPoint);
          } else if (!event._isLeft ? element_2.hasComponent(getKClass_0(Right)) : false) {
            freeWaitingPoint(this, element_2);
            element_2.get_44(getKClass_0(Enemy)).switchTo(event._newWaitingPoint);
          }}}
    } else {
    }
  };
  EnemyMove.$metadata$ = {
    simpleName: 'EnemyMove',
    kind: 'class',
    interfaces: []
  };
  function EnemyDying() {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(Dying)]);
    System_init_$Init$(tmp, null, 2, null, this);
  }
  EnemyDying.prototype.update_61 = function (delta_0, entity) {
    entity.get_44(getKClass_0(Dying))._letter_0.destroy_31();
    Unit_getInstance();
    var tmp = new EnemyHit();
    this.emit$default_25(tmp, null, 2, null);
    entity.destroy_31();
    Unit_getInstance();
  };
  EnemyDying.$metadata$ = {
    simpleName: 'EnemyDying',
    kind: 'class',
    interfaces: []
  };
  function isAnyJustKeyPressed(_this_, keys) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = keys;
      var inductionVariable = 0;
      var last_2 = indexedObject.length;
      while (inductionVariable < last_2) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (_this_.isKeyJustPressed_1(element_2)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  }
  function PlayerSystem(leftKeySet, rightKeySet, sound) {
    var tmp = Companion_getInstance_23().of_0([getKClass_0(Player)]);
    System_init_$Init$(tmp, null, 2, null, this);
    this._sound_0 = sound;
    var tmp_0 = this;
    tmp_0._left_2 = copyToArray_0(leftKeySet);
    var tmp_1 = this;
    tmp_1._right_0 = copyToArray_0(rightKeySet);
    this._leftEnemies$delegate = this.interested(Companion_getInstance_23().of_0([getKClass_0(Enemy), getKClass_0(Left_0)]));
    this._rightEnemies$delegate = this.interested(Companion_getInstance_23().of_0([getKClass_0(Enemy), getKClass_0(Right)]));
    this._hits$delegate = this.interested(Companion_getInstance_23().of_0([getKClass_0(Hit)]));
    this._collider_0 = new AABBCollisionResolver();
  }
  PlayerSystem.prototype._get_leftEnemies_ = function () {
    return this._leftEnemies$delegate.getValue_5(this, leftEnemies$factory());
  };
  PlayerSystem.prototype._get_rightEnemies_ = function () {
    return this._rightEnemies$delegate.getValue_5(this, rightEnemies$factory());
  };
  PlayerSystem.prototype.update_61 = function (delta_0, entity) {
    if (entity.get_44(getKClass_0(Player))._coolDown_0 <= 0.0) {
      if (isAnyJustKeyPressed(this._get_input__25(), this._left_2.slice())) {
        var tmp = _get_position_(entity);
        tmp.setLocalTranslation$default_0(-1.0, null, null, null, 14, null);
        Unit_getInstance();
        entity.get_44(getKClass_0(Player))._coolDown_0 = 0.125;
        var tmp0_forEach_0 = this._get_leftEnemies_();
        var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
        while (tmp0_iterator_1.hasNext_27()) {
          var element_2 = tmp0_iterator_1.next_30();
          if (ensureNotNull(element_2.get_44(getKClass_0(Enemy))._waitingPoint).get_44(getKClass_0(Start))._intex === 1 ? element_2.get_44(getKClass_0(Enemy))._ready : false) {
            if (this._get_input__25().isKeyJustPressed_1(ensureNotNull(element_2.get_44(getKClass_0(Enemy))._key_2))) {
              hitEnemy(this, element_2);
            }}}
      } else if (isAnyJustKeyPressed(this._get_input__25(), this._right_0.slice())) {
        var tmp_0 = _get_position_(entity);
        tmp_0.setLocalTranslation$default_0(1.0, null, null, null, 14, null);
        Unit_getInstance();
        entity.get_44(getKClass_0(Player))._coolDown_0 = 0.125;
        var tmp1_forEach_0 = this._get_rightEnemies_();
        var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_52();
        while (tmp0_iterator_1_0.hasNext_27()) {
          var element_2_0 = tmp0_iterator_1_0.next_30();
          if (ensureNotNull(element_2_0.get_44(getKClass_0(Enemy))._waitingPoint).get_44(getKClass_0(Start))._intex === 1 ? element_2_0.get_44(getKClass_0(Enemy))._ready : false) {
            if (this._get_input__25().isKeyJustPressed_1(ensureNotNull(element_2_0.get_44(getKClass_0(Enemy))._key_2))) {
              hitEnemy(this, element_2_0);
            }}}
      }} else {
      var tmp0_this = entity.get_44(getKClass_0(Player));
      tmp0_this._coolDown_0 = tmp0_this._coolDown_0 - delta_0;
    }
    var tmp_1 = _get_position_(entity);
    var tmp_2 = Interpolations_getInstance();
    var tmp_3 = _get_position_(entity)._get_localTranslation_()._get_x_();
    var tmp_4 = tmp_2.lerp$default(0.0, tmp_3, 0.0, 4, null);
    tmp_1.setLocalTranslation$default_0(tmp_4, null, null, null, 14, null);
    Unit_getInstance();
  };
  PlayerSystem.prototype.onEvent_26 = function (event, entityQuery) {
    if (event instanceof EnemyHit) {
      var tmp0_forEach_0 = this._get_entities__3();
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
      while (tmp0_iterator_1.hasNext_27()) {
        var element_2 = tmp0_iterator_1.next_30();
        var tmp0_this_4 = element_2.get_44(getKClass_0(Player));
        tmp0_this_4._life = tmp0_this_4._life - 1 | 0;
        if (element_2.get_44(getKClass_0(Player))._life < 0) {
          var tmp = new EndGame();
          this.emit$default_25(tmp, null, 2, null);
        }var tmp1_this_5 = element_2.get_44(getKClass_0(Player));
        tmp1_this_5._score_0 = tmp1_this_5._score_0 + 1 | 0;
      }
    } else {
    }
  };
  PlayerSystem.$metadata$ = {
    simpleName: 'PlayerSystem',
    kind: 'class',
    interfaces: []
  };
  function freeWaitingPoint(_this_, enemy) {
    var component = enemy.get_44(getKClass_0(Enemy));
    var waitingPoint = ensureNotNull(component._waitingPoint).get_44(getKClass_0(Start));
    waitingPoint._occupied = false;
    var tmp = new FreeWaingPoint(waitingPoint._intex + 1 | 0, enemy.hasComponent(getKClass_0(Left_0)), ensureNotNull(component._waitingPoint));
    _this_.emit$default_25(tmp, null, 2, null);
  }
  function MyGame(gameContext, isAzerty) {
    this._gameContext_7 = gameContext;
    this._isAzerty = isAzerty;
    var tmp = this;
    var tmp0_get_0 = this._gameContext_7._fileHandler;
    var tmp1_get_0 = 'map.protobuf';
    tmp._scene$delegate = tmp0_get_0.get_46(tmp1_get_0, getKClass_0(GraphScene));
    var tmp_0 = this;
    var tmp0_get_0_0 = this._gameContext_7._fileHandler;
    var tmp1_get_0_0 = 'font3';
    tmp_0._font$delegate = tmp0_get_0_0.get_46(tmp1_get_0_0, getKClass_0(Font));
    var tmp_1 = this;
    var tmp0_get_0_1 = this._gameContext_7._fileHandler;
    var tmp1_get_0_1 = 'a.mp3';
    tmp_1._a$delegate = tmp0_get_0_1.get_46(tmp1_get_0_1, getKClass_0(Sound));
    var tmp_2 = this;
    var tmp0_get_0_2 = this._gameContext_7._fileHandler;
    var tmp1_get_0_2 = 'b.mp3';
    tmp_2._b$delegate = tmp0_get_0_2.get_46(tmp1_get_0_2, getKClass_0(Sound));
    var tmp_3 = this;
    var tmp0_get_0_3 = this._gameContext_7._fileHandler;
    var tmp1_get_0_3 = 'c.mp3';
    tmp_3._c$delegate = tmp0_get_0_3.get_46(tmp1_get_0_3, getKClass_0(Sound));
  }
  MyGame.prototype._get_gameContext__32 = function () {
    return this._gameContext_7;
  };
  MyGame.prototype.createStoryBoard_1 = function (event) {
    var tmp;
    if (event instanceof ShowScoreEvent) {
      var tmp_0 = Storyboard_getInstance();
      tmp = tmp_0.replaceWith_0(_no_name_provided_$factory_146(this, event));
    } else {
      {
        tmp = Storyboard_getInstance().stayHere();
      }
    }
    return tmp;
  };
  MyGame.prototype.createEntities_1 = function (entityFactory) {
    var tmp0_forEach_0 = _get_scene_(this)._nodes;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      if (contains$default(element_2._name_15, 'player', false, 2, null)) {
        var entity_4 = entityFactory.createFromNode$default_0(element_2, null, 2, null);
        entity_4.add_23(Player_init_$Create$(0, 0, 0.0, 7, null));
        Unit_getInstance();
      } else {
        if (startsWith$default(element_2._name_15, 'enemy', false, 2, null)) {
          entityFactory.registerTemplate_0(element_2._name_15, _no_name_provided_$factory_147(entityFactory, element_2, this));
        } else {
          if (element_2._name_15 === 'hit') {
            entityFactory.createFromNode$default_0(element_2, null, 2, null).add_23(new Hit());
            Unit_getInstance();
          } else {
            if (startsWith$default(element_2._name_15, 'spawn-left', false, 2, null)) {
              entityFactory.createFromNode$default_0(element_2, null, 2, null).add_23(new Spawn()).add_23(new Left_0());
              Unit_getInstance();
            } else {
              if (startsWith$default(element_2._name_15, 'spawn-right', false, 2, null)) {
                entityFactory.createFromNode$default_0(element_2, null, 2, null).add_23(new Spawn()).add_23(new Right());
                Unit_getInstance();
              } else {
                if (startsWith$default(element_2._name_15, 'start-left', false, 2, null)) {
                  var tmp = entityFactory.createFromNode$default_0(element_2, null, 2, null);
                  var tmp_0 = extractIndex(this, element_2._name_15);
                  tmp.add_23(Start_init_$Create$(tmp_0, false, 2, null)).add_23(new Left_0());
                  Unit_getInstance();
                } else {
                  if (startsWith$default(element_2._name_15, 'start-right', false, 2, null)) {
                    var tmp_1 = entityFactory.createFromNode$default_0(element_2, null, 2, null);
                    var tmp_2 = extractIndex(this, element_2._name_15);
                    tmp_1.add_23(Start_init_$Create$(tmp_2, false, 2, null)).add_23(new Right());
                    Unit_getInstance();
                  } else {
                    if (startsWith$default(element_2._name_15, 'chrono', false, 2, null)) {
                      var tmp_3 = entityFactory.createText_4(new WriteText('60:00'), _get_font_(this), element_2);
                      tmp_3.add_23(Chrono_init_$Create$(0.0, 1, null));
                      Unit_getInstance();
                    } else {
                      if (startsWith$default(element_2._name_15, 'score', false, 2, null)) {
                        var tmp_4 = entityFactory.createText_4(new WriteText('0000'), _get_font_(this), element_2);
                        tmp_4.add_23(Score_init_$Create$(0, 0.0, 3, null));
                        Unit_getInstance();
                      } else {
                        {
                          entityFactory.createFromNode$default_0(element_2, null, 2, null);
                          Unit_getInstance();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  MyGame.prototype.createSystems_1 = function (engine) {
    var tmp;
    if (this._isAzerty) {
      tmp = to(setOf([Key_S_getInstance(), Key_D_getInstance(), Key_F_getInstance()]), setOf([Key_J_getInstance(), Key_K_getInstance(), Key_L_getInstance()]));
    } else {
      tmp = to(setOf([Key_S_getInstance(), Key_H_getInstance(), Key_T_getInstance()]), setOf([Key_N_getInstance(), Key_E_getInstance(), Key_O_getInstance()]));
    }
    var tmp0_container = tmp;
    var leftKeySet = tmp0_container.component1();
    var rightKeySet = tmp0_container.component2();
    var tmp_0 = new PlayerSystem(leftKeySet, rightKeySet, listOf([_get_a_(this), _get_b_(this), _get_c_(this)]));
    return listOf([tmp_0, EnemySpawner_init_$Create$(0, leftKeySet, rightKeySet, 1, null), new EnemyMove(), new EnemyDying(), new TrackSystem(), new ScoreSystem(), new ChronoSystem()]);
  };
  MyGame.$metadata$ = {
    simpleName: 'MyGame',
    kind: 'class',
    interfaces: [Game]
  };
  function ChronoSystem() {
    TemporalSystem.call(this, 0.01, Companion_getInstance_23().of_0([getKClass_0(Chrono), getKClass_0(TextComponent)]));
    this._score$delegate = this.interested(Companion_getInstance_23().of_0([getKClass_0(Player)]));
  }
  ChronoSystem.prototype._get_score_ = function () {
    return this._score$delegate.getValue_5(this, score$factory());
  };
  ChronoSystem.prototype.update_61 = function (delta_0, entity) {
    var tmp0_this = entity.get_44(getKClass_0(Chrono));
    tmp0_this._time_2 = tmp0_this._time_2 - delta_0;
    if (entity.get_44(getKClass_0(Chrono))._time_2 < 0.0) {
      var s = first(this._get_score_()).get_44(getKClass_0(Player))._score_0;
      this.emit_54(new ShowScoreEvent(s));
    }};
  ChronoSystem.prototype.timeElapsed_2 = function () {
    var tmp0_forEach_0 = this._get_entities__3();
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      var t_4 = element_2.get_44(getKClass_0(Chrono))._time_2;
      var seconds_5 = numberToInt(t_4);
      var millis_6 = numberToInt((t_4 - seconds_5) * 100);
      element_2.get_44(getKClass_0(TextComponent))._get_text_()._set_content__0('' + seconds_5 + ':' + millis_6);
    }
  };
  ChronoSystem.$metadata$ = {
    simpleName: 'ChronoSystem',
    kind: 'class',
    interfaces: []
  };
  function players$factory() {
    return getPropertyCallableRef('players', 1, KProperty1, function (receiver) {
      return receiver._get_players_();
    }, null);
  }
  function rightSpawn$factory() {
    return getPropertyCallableRef('rightSpawn', 1, KProperty1, function (receiver) {
      return _get_rightSpawn_(receiver);
    }, null);
  }
  function leftSpawn$factory() {
    return getPropertyCallableRef('leftSpawn', 1, KProperty1, function (receiver) {
      return _get_leftSpawn_(receiver);
    }, null);
  }
  function rightStart$factory() {
    return getPropertyCallableRef('rightStart', 1, KProperty1, function (receiver) {
      return _get_rightStart_(receiver);
    }, null);
  }
  function leftStart$factory() {
    return getPropertyCallableRef('leftStart', 1, KProperty1, function (receiver) {
      return _get_leftStart_(receiver);
    }, null);
  }
  function leftEnemies$factory() {
    return getPropertyCallableRef('leftEnemies', 1, KProperty1, function (receiver) {
      return receiver._get_leftEnemies_();
    }, null);
  }
  function rightEnemies$factory() {
    return getPropertyCallableRef('rightEnemies', 1, KProperty1, function (receiver) {
      return receiver._get_rightEnemies_();
    }, null);
  }
  function scene$factory() {
    return getPropertyCallableRef('scene', 1, KProperty1, function (receiver) {
      return _get_scene_(receiver);
    }, null);
  }
  function font$factory() {
    return getPropertyCallableRef('font', 1, KProperty1, function (receiver) {
      return _get_font_(receiver);
    }, null);
  }
  function a$factory() {
    return getPropertyCallableRef('a', 1, KProperty1, function (receiver) {
      return _get_a_(receiver);
    }, null);
  }
  function b$factory() {
    return getPropertyCallableRef('b', 1, KProperty1, function (receiver) {
      return _get_b_(receiver);
    }, null);
  }
  function c$factory() {
    return getPropertyCallableRef('c', 1, KProperty1, function (receiver) {
      return _get_c_(receiver);
    }, null);
  }
  function score$factory() {
    return getPropertyCallableRef('score', 1, KProperty1, function (receiver) {
      return receiver._get_score_();
    }, null);
  }
  function _no_name_provided_$factory_144() {
    var i = new _no_name_provided__167();
    return function (p1, p2) {
      return i.invoke_269(p1, p2);
    };
  }
  function _no_name_provided_$factory_145() {
    var i = new _no_name_provided__168();
    return function (p1, p2) {
      return i.invoke_269(p1, p2);
    };
  }
  function _no_name_provided_$factory_146(this$0, $event) {
    var i = new _no_name_provided__169(this$0, $event);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_147($entityFactory, $element_2, this$0) {
    var i = new _no_name_provided__170($entityFactory, $element_2, this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function Chrono_init_$Init$(time, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      time = 60.0;
    Chrono.call($this, time);
    return $this;
  }
  function Chrono_init_$Create$(time, $mask0, $marker) {
    return Chrono_init_$Init$(time, $mask0, $marker, Object.create(Chrono.prototype));
  }
  function Score_init_$Init$(score, coolDown, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      score = 0;
    if (!(($mask0 & 2) === 0))
      coolDown = 0.4;
    Score.call($this, score, coolDown);
    return $this;
  }
  function Score_init_$Create$(score, coolDown, $mask0, $marker) {
    return Score_init_$Init$(score, coolDown, $mask0, $marker, Object.create(Score.prototype));
  }
  function Player_init_$Init$(score, life, coolDown, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      score = 0;
    if (!(($mask0 & 2) === 0))
      life = 3;
    if (!(($mask0 & 4) === 0))
      coolDown = 0.125;
    Player.call($this, score, life, coolDown);
    return $this;
  }
  function Player_init_$Create$(score, life, coolDown, $mask0, $marker) {
    return Player_init_$Init$(score, life, coolDown, $mask0, $marker, Object.create(Player.prototype));
  }
  function Enemy_init_$Init$(life, key, ttl, duration, start, target, ready, waitingPoint, letter, waitingHit, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      life = 1;
    if (!(($mask0 & 2) === 0))
      key = null;
    if (!(($mask0 & 4) === 0))
      ttl = 0.0;
    if (!(($mask0 & 8) === 0))
      duration = 0.3;
    if (!(($mask0 & 16) === 0)) {
      start = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    }if (!(($mask0 & 32) === 0)) {
      target = Vector3_init_$Create$(0.0, 0.0, 0.0, 7, null);
    }if (!(($mask0 & 64) === 0))
      ready = false;
    if (!(($mask0 & 128) === 0))
      waitingPoint = null;
    if (!(($mask0 & 256) === 0))
      letter = null;
    if (!(($mask0 & 512) === 0))
      waitingHit = 1.0;
    Enemy.call($this, life, key, ttl, duration, start, target, ready, waitingPoint, letter, waitingHit);
    return $this;
  }
  function Enemy_init_$Create$(life, key, ttl, duration, start, target, ready, waitingPoint, letter, waitingHit, $mask0, $marker) {
    return Enemy_init_$Init$(life, key, ttl, duration, start, target, ready, waitingPoint, letter, waitingHit, $mask0, $marker, Object.create(Enemy.prototype));
  }
  function Start_init_$Init$(intex, occupied, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      intex = 1;
    if (!(($mask0 & 2) === 0))
      occupied = false;
    Start.call($this, intex, occupied);
    return $this;
  }
  function Start_init_$Create$(intex, occupied, $mask0, $marker) {
    return Start_init_$Init$(intex, occupied, $mask0, $marker, Object.create(Start.prototype));
  }
  function EnemySpawner_init_$Init$(maxLife, leftKeySet, rightKeySet, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      maxLife = 3;
    EnemySpawner.call($this, maxLife, leftKeySet, rightKeySet);
    return $this;
  }
  function EnemySpawner_init_$Create$(maxLife, leftKeySet, rightKeySet, $mask0, $marker) {
    return EnemySpawner_init_$Init$(maxLife, leftKeySet, rightKeySet, $mask0, $marker, Object.create(EnemySpawner.prototype));
  }
  function _get_rightSpawn_($this) {
    return $this._rightSpawn$delegate.getValue_5($this, rightSpawn$factory());
  }
  function _get_leftSpawn_($this) {
    return $this._leftSpawn$delegate.getValue_5($this, leftSpawn$factory());
  }
  function _get_rightStart_($this) {
    return $this._rightStart$delegate.getValue_5($this, rightStart$factory());
  }
  function _get_leftStart_($this) {
    return $this._leftStart$delegate.getValue_5($this, leftStart$factory());
  }
  function firstAvailable($this, points) {
    var tmp$ret$0;
    l$ret$1: do {
      var iterator_1 = points.listIterator_5(points._get_size__32());
      while (iterator_1.hasPrevious_2()) {
        var element_2 = iterator_1.previous_2();
        if (element_2.get_44(getKClass_0(Start))._occupied) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var target = tmp$ret$0;
    var tmp;
    if (target == null) {
      tmp = first(points);
    } else if (target.get_44(getKClass_0(Start))._intex === 5) {
      tmp = null;
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_iterator_1 = points.iterator_52();
        while (tmp0_iterator_1.hasNext_27()) {
          var element_2_0 = tmp0_iterator_1.next_30();
          if (element_2_0.get_44(getKClass_0(Start))._intex === (target.get_44(getKClass_0(Start))._intex + 1 | 0)) {
            tmp$ret$2 = element_2_0;
            break l$ret$3;
          } else {
          }
        }
        throw NoSuchElementException_init_$Create$_0('Collection contains no element matching the predicate.');
      }
       while (false);
      tmp = tmp$ret$2;
    }
    return tmp;
  }
  function create_0($this, side, spawn, waitingPoint, keySet) {
    var entity = $this._get_entityFactory__25().createFromTemplate_0('enemy1');
    entity.add_23(side);
    Unit_getInstance();
    var tmp = entity.get_44(getKClass_0(Enemy));
    tmp._key_2 = random(keySet, Default_getInstance());
    var numberOfLive_0 = numberOfLive($this);
    entity.get_44(getKClass_0(Enemy))._life_0 = numberOfLive_0;
    var tmp_0 = ensureNotNull(entity.get_44(getKClass_0(Enemy))._letter).get_44(getKClass_0(TextComponent))._get_text_();
    var tmp0_get_0 = $this._keyToStr;
    var tmp1_get_0 = entity.get_44(getKClass_0(Enemy))._key_2;
    tmp_0._set_content__0(ensureNotNull((isInterface(tmp0_get_0, Map_0) ? tmp0_get_0 : THROW_CCE()).get_27(tmp1_get_0)));
    var tmp_1 = _get_position_(entity);
    var tmp_2 = Companion_getInstance_26().getScale(numberOfLive_0);
    tmp_1.setLocalScale$default(0.0, tmp_2, 0.0, 5, null);
    Unit_getInstance();
    var tmp_3 = _get_position_(entity);
    var tmp_4 = _get_position_(spawn)._get_localTranslation_();
    tmp_3.setLocalTranslation$default(tmp_4, null, 2, null);
    Unit_getInstance();
    entity.get_44(getKClass_0(Enemy))._start.set_6(_get_position_(spawn)._get_localTranslation_());
    Unit_getInstance();
    entity.get_44(getKClass_0(Enemy))._target.set_6(_get_position_(waitingPoint)._get_localTranslation_());
    Unit_getInstance();
    entity.get_44(getKClass_0(Enemy))._waitingPoint = waitingPoint;
    waitingPoint.get_44(getKClass_0(Start))._occupied = true;
    return entity;
  }
  function Companion_27() {
    Companion_instance_26 = this;
  }
  Companion_27.prototype.getScale = function (life) {
    var tmp0_subject = life;
    switch (tmp0_subject) {
      case 0:
        return 0.5;
      case 1:
        return 0.75;
      case 2:
        return 1.0;
      default:return 1.0;
    }
  };
  Companion_27.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_27();
    return Companion_instance_26;
  }
  function numberOfLive($this) {
    if ($this._maxLife === 1) {
      return 1;
    } else if ($this._maxLife === 2) {
      if (Default_getInstance().nextFloat_1() > 0.75) {
        return 2;
      } else {
        return 1;
      }
    } else {
      if (Default_getInstance().nextFloat_1() < 0.5) {
        return 1;
      } else if (Default_getInstance().nextFloat_1() < 0.8) {
        return 2;
      } else {
        return 3;
      }
    }
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this._function_0 = function_0;
  }
  sam$kotlin_Comparator$0_0.prototype.compare_1 = function (a, b) {
    return this._function_0(a, b);
  };
  sam$kotlin_Comparator$0_0.prototype.compare = function (a, b) {
    return this.compare_1(a, b);
  };
  sam$kotlin_Comparator$0_0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__167() {
  }
  _no_name_provided__167.prototype.invoke_269 = function (a, b) {
    var tmp = a.get_44(getKClass_0(Start))._intex;
    return compareValues(tmp, b.get_44(getKClass_0(Start))._intex);
  };
  _no_name_provided__167.prototype.invoke_270 = function (p1, p2) {
    var tmp = p1 instanceof Entity ? p1 : THROW_CCE();
    return this.invoke_269(tmp, p2 instanceof Entity ? p2 : THROW_CCE());
  };
  _no_name_provided__167.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__168() {
  }
  _no_name_provided__168.prototype.invoke_269 = function (a, b) {
    var tmp = a.get_44(getKClass_0(Start))._intex;
    return compareValues(tmp, b.get_44(getKClass_0(Start))._intex);
  };
  _no_name_provided__168.prototype.invoke_270 = function (p1, p2) {
    var tmp = p1 instanceof Entity ? p1 : THROW_CCE();
    return this.invoke_269(tmp, p2 instanceof Entity ? p2 : THROW_CCE());
  };
  _no_name_provided__168.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function hitEnemy($this, enemy) {
    var component = enemy.get_44(getKClass_0(Enemy));
    var tmp0_this = component;
    var tmp1 = tmp0_this._life_0;
    tmp0_this._life_0 = tmp1 - 1 | 0;
    Unit_getInstance();
    if (component._life_0 < 0) {
      var tmp0_random_0 = $this._sound_0;
      var tmp = random(tmp0_random_0, Default_getInstance());
      tmp.play$default(0, 1, null);
      enemy.remove_33(getKClass_0(Enemy));
      Unit_getInstance();
      enemy.add_23(new Dying(ensureNotNull(component._letter)));
      Unit_getInstance();
      freeWaitingPoint($this, enemy);
    } else {
      var tmp_0 = _get_position_(enemy);
      var tmp_1 = Companion_getInstance_26().getScale(component._life_0);
      tmp_0.setLocalScale$default(0.0, tmp_1, 0.0, 5, null);
      Unit_getInstance();
    }
  }
  function MyGame_init_$Init$(gameContext, isAzerty, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      isAzerty = true;
    MyGame.call($this, gameContext, isAzerty);
    return $this;
  }
  function MyGame_init_$Create$(gameContext, isAzerty, $mask0, $marker) {
    return MyGame_init_$Init$(gameContext, isAzerty, $mask0, $marker, Object.create(MyGame.prototype));
  }
  function _get_scene_($this) {
    return $this._scene$delegate.getValue_5($this, scene$factory());
  }
  function _get_font_($this) {
    return $this._font$delegate.getValue_5($this, font$factory());
  }
  function _get_a_($this) {
    return $this._a$delegate.getValue_5($this, a$factory());
  }
  function _get_b_($this) {
    return $this._b$delegate.getValue_5($this, b$factory());
  }
  function _get_c_($this) {
    return $this._c$delegate.getValue_5($this, c$factory());
  }
  function extractIndex($this, name) {
    return toInt(last_1(name).toString());
  }
  function _no_name_provided__169(this$0, $event) {
    this._this$0_64 = this$0;
    this._$event = $event;
  }
  _no_name_provided__169.prototype.invoke_274 = function () {
    return new Title(this._this$0_64._gameContext_7, '' + 'Share your (incredible) score of ' + this._$event._score_1 + '!\nPress Space to restart');
  };
  _no_name_provided__169.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__170($entityFactory, $element_2, this$0) {
    this._$entityFactory = $entityFactory;
    this._$element_2_1 = $element_2;
    this._this$0_65 = this$0;
  }
  _no_name_provided__170.prototype.invoke_274 = function () {
    var tmp = this._$entityFactory.createFromNode$default_0(this._$element_2_1, null, 2, null);
    var e_6 = tmp.add_23(Enemy_init_$Create$(0, null, 0.0, 0.0, null, null, false, null, null, 0.0, 1023, null));
    var letter_7 = this._$entityFactory.createText_2(new WriteText(' '), _get_font_(this._this$0_65));
    letter_7.add_23(new Track(e_6));
    Unit_getInstance();
    e_6.get_44(getKClass_0(Enemy))._letter = letter_7;
    var tmp_0 = _get_position_(letter_7);
    tmp_0.setLocalTranslation$default_0(null, 4.0, null, null, 13, null);
    Unit_getInstance();
    return e_6;
  };
  _no_name_provided__170.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function StartGameEvent() {
  }
  StartGameEvent.$metadata$ = {
    simpleName: 'StartGameEvent',
    kind: 'class',
    interfaces: [StoryboardEvent]
  };
  function ShowScoreEvent(score) {
    this._score_1 = score;
  }
  ShowScoreEvent.$metadata$ = {
    simpleName: 'ShowScoreEvent',
    kind: 'class',
    interfaces: [StoryboardEvent]
  };
  function StartGameSystem() {
    var tmp = Companion_getInstance_23().none();
    System_init_$Init$(tmp, null, 2, null, this);
  }
  StartGameSystem.prototype.update_61 = function (delta_0, entity) {
    return Unit_getInstance();
  };
  StartGameSystem.prototype.update_62 = function (delta_0) {
    if (this._get_input__25().isKeyJustPressed_1(Key_SPACE_getInstance())) {
      this.emit_54(new StartGameEvent());
    }};
  StartGameSystem.$metadata$ = {
    simpleName: 'StartGameSystem',
    kind: 'class',
    interfaces: []
  };
  function BlinkingSystem() {
    TemporalSystem.call(this, 0.3, Companion_getInstance_23().of_0([getKClass_0(TextComponent)]));
    this._visible = true;
  }
  BlinkingSystem.prototype.update_61 = function (delta_0, entity) {
    if (this._visible) {
      var tmp = _get_position_(entity);
      tmp.setLocalTranslation$default_0(0.0, null, null, null, 14, null);
      Unit_getInstance();
    } else {
      var tmp_0 = _get_position_(entity);
      tmp_0.setLocalTranslation$default_0(60.0, null, null, null, 14, null);
      Unit_getInstance();
    }
  };
  BlinkingSystem.prototype.timeElapsed_2 = function () {
    this._visible = !this._visible;
  };
  BlinkingSystem.$metadata$ = {
    simpleName: 'BlinkingSystem',
    kind: 'class',
    interfaces: []
  };
  function Title(gameContext, text) {
    this._gameContext_8 = gameContext;
    this._text_0 = text;
    var tmp = this;
    var tmp0_get_0 = this._gameContext_8._fileHandler;
    var tmp1_get_0 = 'title.protobuf';
    tmp._scene$delegate_0 = tmp0_get_0.get_46(tmp1_get_0, getKClass_0(GraphScene));
    var tmp_0 = this;
    var tmp0_get_0_0 = this._gameContext_8._fileHandler;
    var tmp1_get_0_0 = 'font3';
    tmp_0._font$delegate_0 = tmp0_get_0_0.get_46(tmp1_get_0_0, getKClass_0(Font));
  }
  Title.prototype._get_gameContext__32 = function () {
    return this._gameContext_8;
  };
  Title.prototype.createStoryBoard_1 = function (event) {
    if (event instanceof StartGameEvent) {
      var tmp = Storyboard_getInstance();
      return tmp.replaceWith_0(_no_name_provided_$factory_148(this));
    } else {
      {
        return Storyboard_getInstance().stayHere();
      }
    }
  };
  Title.prototype.createEntities_1 = function (entityFactory) {
    var tmp0_forEach_0 = _get_scene__0(this)._nodes;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_52();
    while (tmp0_iterator_1.hasNext_27()) {
      var element_2 = tmp0_iterator_1.next_30();
      if (element_2._name_15 === 'chrono') {
        entityFactory.createText_3(this._text_0, _get_font__0(this), element_2);
        Unit_getInstance();
      } else {
        entityFactory.createFromNode$default_0(element_2, null, 2, null);
        Unit_getInstance();
      }
    }
  };
  Title.prototype.createSystems_1 = function (engine) {
    return listOf([new StartGameSystem(), new BlinkingSystem()]);
  };
  Title.$metadata$ = {
    simpleName: 'Title',
    kind: 'class',
    interfaces: [Game]
  };
  function scene$factory_0() {
    return getPropertyCallableRef('scene', 1, KProperty1, function (receiver) {
      return _get_scene__0(receiver);
    }, null);
  }
  function font$factory_0() {
    return getPropertyCallableRef('font', 1, KProperty1, function (receiver) {
      return _get_font__0(receiver);
    }, null);
  }
  function _no_name_provided_$factory_148(this$0) {
    var i = new _no_name_provided__171(this$0);
    return function () {
      return i.invoke_274();
    };
  }
  function Title_init_$Init$(gameContext, text, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      text = 'Press Space to start';
    Title.call($this, gameContext, text);
    return $this;
  }
  function Title_init_$Create$(gameContext, text, $mask0, $marker) {
    return Title_init_$Init$(gameContext, text, $mask0, $marker, Object.create(Title.prototype));
  }
  function _get_scene__0($this) {
    return $this._scene$delegate_0.getValue_5($this, scene$factory_0());
  }
  function _get_font__0($this) {
    return $this._font$delegate_0.getValue_5($this, font$factory_0());
  }
  function _no_name_provided__171(this$0) {
    this._this$0_66 = this$0;
  }
  _no_name_provided__171.prototype.invoke_274 = function () {
    return MyGame_init_$Create$(this._this$0_66._gameContext_8, false, 2, null);
  };
  _no_name_provided__171.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function main() {
    var tmp0_get_0 = document.getElementsByTagName('canvas');
    var tmp1_get_0 = 0;
    var tmp0_elvis_lhs = tmp0_get_0[tmp1_get_0];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('No <canvas> has been found in the current page. Check that the page including your javascript gamehas a <canvas> tag to render the game in.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var canvas = tmp;
    var rootPath = {_v: window.location.protocol + '//' + window.location.host + window.location.pathname};
    var tmp_0 = rootPath._v;
    rootPath._v = replace$default(tmp_0, 'index.html', '', false, 4, null);
    var tmp_1 = _no_name_provided_$factory_149(canvas, rootPath);
    (new GameApplicationBuilder(tmp_1, _no_name_provided_$factory_150())).start_8();
  }
  function _no_name_provided__172($canvas, $rootPath) {
    this._$canvas = $canvas;
    this._$rootPath = $rootPath;
  }
  _no_name_provided__172.prototype.invoke_274 = function () {
    var tmp0_gameScreenConfiguration = new WithRatio(1.7777777777777777);
    var tmp = this._$canvas;
    var tmp1_canvas = tmp instanceof HTMLCanvasElement ? tmp : THROW_CCE();
    return GameConfiguration_init_$Create$('My Game - running in a browser', false, tmp0_gameScreenConfiguration, null, tmp1_canvas, null, this._$rootPath._v, 40, null);
  };
  _no_name_provided__172.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__173() {
  }
  _no_name_provided__173.prototype.invoke_275 = function (it) {
    return Title_init_$Create$(it, null, 2, null);
  };
  _no_name_provided__173.prototype.invoke_276 = function (p1) {
    return this.invoke_275(p1 instanceof GameContext ? p1 : THROW_CCE());
  };
  _no_name_provided__173.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_149($canvas, $rootPath) {
    var i = new _no_name_provided__172($canvas, $rootPath);
    return function () {
      return i.invoke_274();
    };
  }
  function _no_name_provided_$factory_150() {
    var i = new _no_name_provided__173();
    return function (p1) {
      return i.invoke_275(p1);
    };
  }
  AbstractCollection.prototype._get_size__32 = AbstractCollection.prototype._get_size__32;
  AbstractCollection.prototype.iterator_52 = AbstractCollection.prototype.iterator_52;
  AbstractIterator.prototype.computeNext_0 = AbstractIterator.prototype.computeNext_0;
  State.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  State.prototype.equals = Enum.prototype.equals;
  State.prototype.hashCode = Enum.prototype.hashCode;
  State.prototype.toString = Enum.prototype.toString;
  AbstractList.prototype._get_size__32 = AbstractList.prototype._get_size__32;
  AbstractList.prototype.get_57 = AbstractList.prototype.get_57;
  AbstractList.prototype.contains_35 = AbstractCollection.prototype.contains_35;
  AbstractList.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  AbstractList.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  AbstractList.prototype.toString = AbstractCollection.prototype.toString;
  AbstractList.prototype.toArray = AbstractCollection.prototype.toArray;
  ListIteratorImpl.prototype._set_index__2 = IteratorImpl.prototype._set_index__2;
  ListIteratorImpl.prototype._get_index__2 = IteratorImpl.prototype._get_index__2;
  ListIteratorImpl.prototype.hasNext_27 = IteratorImpl.prototype.hasNext_27;
  ListIteratorImpl.prototype.next_30 = IteratorImpl.prototype.next_30;
  AbstractMap.prototype._get_entries__5 = Map_0.prototype._get_entries__5;
  AbstractSet.prototype._get_size__32 = AbstractCollection.prototype._get_size__32;
  AbstractSet.prototype.iterator_52 = AbstractCollection.prototype.iterator_52;
  AbstractSet.prototype.contains_35 = AbstractCollection.prototype.contains_35;
  AbstractSet.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  AbstractSet.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  AbstractSet.prototype.toString = AbstractCollection.prototype.toString;
  AbstractSet.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__6.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__6.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  _no_name_provided__6.prototype.equals = AbstractSet.prototype.equals;
  _no_name_provided__6.prototype.hashCode = AbstractSet.prototype.hashCode;
  _no_name_provided__6.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  _no_name_provided__6.prototype.toString = AbstractCollection.prototype.toString;
  _no_name_provided__8.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__8.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  _no_name_provided__8.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  _no_name_provided__8.prototype.toString = AbstractCollection.prototype.toString;
  SequenceScope.prototype.yield_0 = SequenceScope.prototype.yield_0;
  RingBuffer.prototype.contains_35 = AbstractCollection.prototype.contains_35;
  RingBuffer.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  RingBuffer.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  RingBuffer.prototype.listIterator_5 = AbstractList.prototype.listIterator_5;
  RingBuffer.prototype.equals = AbstractList.prototype.equals;
  RingBuffer.prototype.hashCode = AbstractList.prototype.hashCode;
  RingBuffer.prototype.toString = AbstractCollection.prototype.toString;
  CoroutineImpl_0.prototype.doResume_3 = CoroutineImpl_0.prototype.doResume_3;
  _no_name_provided__14.prototype._get_context__9 = CoroutineImpl_0.prototype._get_context__9;
  _no_name_provided__14.prototype.intercepted_1 = CoroutineImpl_0.prototype.intercepted_1;
  _no_name_provided__14.prototype.resumeWith_12 = CoroutineImpl_0.prototype.resumeWith_12;
  _no_name_provided__15.prototype.done_0 = AbstractIterator.prototype.done_0;
  _no_name_provided__15.prototype.setNext_0 = AbstractIterator.prototype.setNext_0;
  _no_name_provided__15.prototype.hasNext_27 = AbstractIterator.prototype.hasNext_27;
  _no_name_provided__15.prototype.next_30 = AbstractIterator.prototype.next_30;
  CombinedContext.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  AbstractCoroutineContextElement.prototype.get_42 = Element_0.prototype.get_42;
  AbstractCoroutineContextElement.prototype.fold_17 = Element_0.prototype.fold_17;
  AbstractCoroutineContextElement.prototype.minusKey_18 = Element_0.prototype.minusKey_18;
  AbstractCoroutineContextElement.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  CoroutineSingletons.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  CoroutineSingletons.prototype.equals = Enum.prototype.equals;
  CoroutineSingletons.prototype.hashCode = Enum.prototype.hashCode;
  CoroutineSingletons.prototype.toString = Enum.prototype.toString;
  Random.prototype.nextBits_1 = Random.prototype.nextBits_1;
  XorWowRandom.prototype.nextInt_6 = Random.prototype.nextInt_6;
  XorWowRandom.prototype.nextInt_7 = Random.prototype.nextInt_7;
  XorWowRandom.prototype.nextFloat_1 = Random.prototype.nextFloat_1;
  XorWowRandom.prototype.nextBytes_3 = Random.prototype.nextBytes_3;
  XorWowRandom.prototype.nextBytes_4 = Random.prototype.nextBytes_4;
  KVariance.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  KVariance.prototype.equals = Enum.prototype.equals;
  KVariance.prototype.hashCode = Enum.prototype.hashCode;
  KVariance.prototype.toString = Enum.prototype.toString;
  LazyThreadSafetyMode.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  LazyThreadSafetyMode.prototype.equals = Enum.prototype.equals;
  LazyThreadSafetyMode.prototype.hashCode = Enum.prototype.hashCode;
  LazyThreadSafetyMode.prototype.toString = Enum.prototype.toString;
  IntIterator.prototype.nextInt_9 = IntIterator.prototype.nextInt_9;
  IntIterator.prototype.hasNext_27 = Iterator.prototype.hasNext_27;
  LongIterator.prototype.nextLong_0 = LongIterator.prototype.nextLong_0;
  LongIterator.prototype.hasNext_27 = Iterator.prototype.hasNext_27;
  IntProgressionIterator.prototype.next_30 = IntIterator.prototype.next_30;
  LongProgressionIterator.prototype.next_30 = LongIterator.prototype.next_30;
  IntRange.prototype._get_first__2 = IntProgression.prototype._get_first__2;
  IntRange.prototype._get_last__4 = IntProgression.prototype._get_last__4;
  IntRange.prototype.iterator_52 = IntProgression.prototype.iterator_52;
  LongRange.prototype._get_first__2 = LongProgression.prototype._get_first__2;
  LongRange.prototype._get_last__4 = LongProgression.prototype._get_last__4;
  LongRange.prototype.iterator_52 = LongProgression.prototype.iterator_52;
  AbstractMutableCollection.prototype.add_19 = AbstractMutableCollection.prototype.add_19;
  AbstractMutableCollection.prototype._get_size__32 = AbstractCollection.prototype._get_size__32;
  AbstractMutableCollection.prototype.iterator_52 = AbstractCollection.prototype.iterator_52;
  AbstractMutableCollection.prototype.contains_35 = AbstractCollection.prototype.contains_35;
  AbstractMutableCollection.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  AbstractMutableCollection.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  AbstractMutableCollection.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableCollection.prototype.toArray = AbstractCollection.prototype.toArray;
  AbstractMutableList.prototype.add_10 = AbstractMutableList.prototype.add_10;
  AbstractMutableList.prototype.removeAt_1 = AbstractMutableList.prototype.removeAt_1;
  AbstractMutableList.prototype.set_2 = AbstractMutableList.prototype.set_2;
  AbstractMutableList.prototype.remove_16 = AbstractMutableCollection.prototype.remove_16;
  AbstractMutableList.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  AbstractMutableList.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  AbstractMutableList.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  AbstractMutableList.prototype._get_size__32 = AbstractCollection.prototype._get_size__32;
  AbstractMutableList.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  AbstractMutableList.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  AbstractMutableList.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableList.prototype.toArray = AbstractCollection.prototype.toArray;
  AbstractMutableList.prototype.get_57 = List.prototype.get_57;
  ListIteratorImpl_0.prototype._set_index__2 = IteratorImpl_0.prototype._set_index__2;
  ListIteratorImpl_0.prototype._get_index__2 = IteratorImpl_0.prototype._get_index__2;
  ListIteratorImpl_0.prototype._set_last__0 = IteratorImpl_0.prototype._set_last__0;
  ListIteratorImpl_0.prototype._get_last__4 = IteratorImpl_0.prototype._get_last__4;
  ListIteratorImpl_0.prototype.hasNext_27 = IteratorImpl_0.prototype.hasNext_27;
  ListIteratorImpl_0.prototype.next_30 = IteratorImpl_0.prototype.next_30;
  ListIteratorImpl_0.prototype.remove_15 = IteratorImpl_0.prototype.remove_15;
  AbstractMutableMap.prototype.put_5 = AbstractMutableMap.prototype.put_5;
  AbstractMutableMap.prototype.containsKey_8 = AbstractMap.prototype.containsKey_8;
  AbstractMutableMap.prototype.containsValue_2 = AbstractMap.prototype.containsValue_2;
  AbstractMutableMap.prototype.containsEntry_2 = AbstractMap.prototype.containsEntry_2;
  AbstractMutableMap.prototype.equals = AbstractMap.prototype.equals;
  AbstractMutableMap.prototype.get_27 = AbstractMap.prototype.get_27;
  AbstractMutableMap.prototype.hashCode = AbstractMap.prototype.hashCode;
  AbstractMutableMap.prototype.isEmpty_35 = AbstractMap.prototype.isEmpty_35;
  AbstractMutableMap.prototype._get_size__32 = AbstractMap.prototype._get_size__32;
  AbstractMutableMap.prototype.toString = AbstractMap.prototype.toString;
  AbstractMutableMap.prototype._get_entries__5 = MutableMap.prototype._get_entries__5;
  AbstractMutableSet.prototype.add_19 = AbstractMutableCollection.prototype.add_19;
  AbstractMutableSet.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  AbstractMutableSet.prototype.clear_15 = AbstractMutableCollection.prototype.clear_15;
  AbstractMutableSet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  AbstractMutableSet.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  AbstractMutableSet.prototype._get_size__32 = AbstractCollection.prototype._get_size__32;
  AbstractMutableSet.prototype.iterator_52 = AbstractCollection.prototype.iterator_52;
  AbstractMutableSet.prototype.contains_35 = AbstractCollection.prototype.contains_35;
  AbstractMutableSet.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  AbstractMutableSet.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  AbstractMutableSet.prototype.toString = AbstractCollection.prototype.toString;
  AbstractMutableSet.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__25.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__25.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  _no_name_provided__25.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  _no_name_provided__25.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  _no_name_provided__25.prototype.equals = AbstractMutableSet.prototype.equals;
  _no_name_provided__25.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  _no_name_provided__25.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  _no_name_provided__25.prototype.toString = AbstractCollection.prototype.toString;
  _no_name_provided__26.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__26.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  _no_name_provided__26.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  _no_name_provided__26.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  _no_name_provided__26.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  _no_name_provided__26.prototype.toString = AbstractCollection.prototype.toString;
  ArrayList.prototype._set_modCount__0 = AbstractMutableList.prototype._set_modCount__0;
  ArrayList.prototype._get_modCount__0 = AbstractMutableList.prototype._get_modCount__0;
  ArrayList.prototype.iterator_52 = AbstractMutableList.prototype.iterator_52;
  ArrayList.prototype.contains_35 = AbstractMutableList.prototype.contains_35;
  ArrayList.prototype.listIterator_5 = AbstractMutableList.prototype.listIterator_5;
  ArrayList.prototype.equals = AbstractMutableList.prototype.equals;
  ArrayList.prototype.hashCode = AbstractMutableList.prototype.hashCode;
  ArrayList.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  ArrayList.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  ArrayList.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  HashMap.prototype._get_keys__5 = AbstractMutableMap.prototype._get_keys__5;
  HashMap.prototype.putAll_1 = AbstractMutableMap.prototype.putAll_1;
  HashMap.prototype._get_values__6 = AbstractMutableMap.prototype._get_values__6;
  HashMap.prototype.checkIsMutable_11 = AbstractMutableMap.prototype.checkIsMutable_11;
  HashMap.prototype.containsEntry_2 = AbstractMap.prototype.containsEntry_2;
  HashMap.prototype.equals = AbstractMap.prototype.equals;
  HashMap.prototype.hashCode = AbstractMap.prototype.hashCode;
  HashMap.prototype.isEmpty_35 = AbstractMap.prototype.isEmpty_35;
  HashMap.prototype.toString = AbstractMap.prototype.toString;
  EntrySet.prototype.toArray = AbstractCollection.prototype.toArray;
  EntrySet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  EntrySet.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  EntrySet.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  EntrySet.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  EntrySet.prototype.equals = AbstractMutableSet.prototype.equals;
  EntrySet.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  EntrySet.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  EntrySet.prototype.toString = AbstractCollection.prototype.toString;
  HashSet.prototype.equals = AbstractMutableSet.prototype.equals;
  HashSet.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  HashSet.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  HashSet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  HashSet.prototype.checkIsMutable_11 = AbstractMutableCollection.prototype.checkIsMutable_11;
  HashSet.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  HashSet.prototype.toString = AbstractCollection.prototype.toString;
  HashSet.prototype.toArray = AbstractCollection.prototype.toArray;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  LinkedHashMap.prototype._get_entries__5 = HashMap.prototype._get_entries__5;
  LinkedHashMap.prototype._get_keys__5 = AbstractMutableMap.prototype._get_keys__5;
  LinkedHashMap.prototype.putAll_1 = AbstractMutableMap.prototype.putAll_1;
  LinkedHashMap.prototype._get_values__6 = AbstractMutableMap.prototype._get_values__6;
  LinkedHashMap.prototype.containsEntry_2 = AbstractMap.prototype.containsEntry_2;
  LinkedHashMap.prototype.equals = AbstractMap.prototype.equals;
  LinkedHashMap.prototype.hashCode = AbstractMap.prototype.hashCode;
  LinkedHashMap.prototype.isEmpty_35 = AbstractMap.prototype.isEmpty_35;
  LinkedHashMap.prototype.toString = AbstractMap.prototype.toString;
  ChainEntry.prototype.equals = SimpleEntry.prototype.equals;
  ChainEntry.prototype.hashCode = SimpleEntry.prototype.hashCode;
  ChainEntry.prototype.toString = SimpleEntry.prototype.toString;
  ChainEntry.prototype._get_key__20 = SimpleEntry.prototype._get_key__20;
  ChainEntry.prototype._get_value__12 = SimpleEntry.prototype._get_value__12;
  EntrySet_0.prototype.toArray = AbstractCollection.prototype.toArray;
  EntrySet_0.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  EntrySet_0.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  EntrySet_0.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  EntrySet_0.prototype.equals = AbstractMutableSet.prototype.equals;
  EntrySet_0.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  EntrySet_0.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  EntrySet_0.prototype.toString = AbstractCollection.prototype.toString;
  LinkedHashSet.prototype._get_map__0 = HashSet.prototype._get_map__0;
  LinkedHashSet.prototype.add_19 = HashSet.prototype.add_19;
  LinkedHashSet.prototype.clear_15 = HashSet.prototype.clear_15;
  LinkedHashSet.prototype.contains_35 = HashSet.prototype.contains_35;
  LinkedHashSet.prototype.isEmpty_35 = HashSet.prototype.isEmpty_35;
  LinkedHashSet.prototype.iterator_52 = HashSet.prototype.iterator_52;
  LinkedHashSet.prototype._get_size__32 = HashSet.prototype._get_size__32;
  LinkedHashSet.prototype.equals = AbstractMutableSet.prototype.equals;
  LinkedHashSet.prototype.hashCode = AbstractMutableSet.prototype.hashCode;
  LinkedHashSet.prototype.addAll_11 = AbstractMutableCollection.prototype.addAll_11;
  LinkedHashSet.prototype.toJSON = AbstractMutableCollection.prototype.toJSON;
  LinkedHashSet.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  LinkedHashSet.prototype.toString = AbstractCollection.prototype.toString;
  LinkedHashSet.prototype.toArray = AbstractCollection.prototype.toArray;
  KClassImpl.prototype._get_simpleName__4 = KClass.prototype._get_simpleName__4;
  KClassImpl.prototype.isInstance_4 = KClass.prototype.isInstance_4;
  PrimitiveKClassImpl.prototype._get_jClass__2 = KClassImpl.prototype._get_jClass__2;
  PrimitiveKClassImpl.prototype.hashCode = KClassImpl.prototype.hashCode;
  PrimitiveKClassImpl.prototype.toString = KClassImpl.prototype.toString;
  NothingKClassImpl.prototype.toString = KClassImpl.prototype.toString;
  SimpleKClassImpl.prototype._get_jClass__2 = KClassImpl.prototype._get_jClass__2;
  SimpleKClassImpl.prototype.equals = KClassImpl.prototype.equals;
  SimpleKClassImpl.prototype.hashCode = KClassImpl.prototype.hashCode;
  SimpleKClassImpl.prototype.toString = KClassImpl.prototype.toString;
  _no_name_provided__55.prototype.toArray = AbstractCollection.prototype.toArray;
  _no_name_provided__55.prototype.contains_35 = AbstractCollection.prototype.contains_35;
  _no_name_provided__55.prototype.containsAll_26 = AbstractCollection.prototype.containsAll_26;
  _no_name_provided__55.prototype.isEmpty_35 = AbstractCollection.prototype.isEmpty_35;
  _no_name_provided__55.prototype.toString = AbstractCollection.prototype.toString;
  _no_name_provided__1_1.prototype._get_exception_ = CoroutineImpl_0.prototype._get_exception_;
  _no_name_provided__1_1.prototype.intercepted_1 = CoroutineImpl_0.prototype.intercepted_1;
  _no_name_provided__1_1.prototype.resumeWith_12 = CoroutineImpl_0.prototype.resumeWith_12;
  _no_name_provided__1_1.prototype._get_context__9 = CoroutineImpl_0.prototype._get_context__9;
  AbstractPolymorphicSerializer.prototype._get_baseClass__0 = AbstractPolymorphicSerializer.prototype._get_baseClass__0;
  AbstractPolymorphicSerializer.prototype._get_descriptor__68 = KSerializer.prototype._get_descriptor__68;
  PolymorphicSerializer.prototype.deserialize_69 = AbstractPolymorphicSerializer.prototype.deserialize_69;
  PolymorphicSerializer.prototype.findPolymorphicSerializerOrNull_0 = AbstractPolymorphicSerializer.prototype.findPolymorphicSerializerOrNull_0;
  SerialDescriptorImpl.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  PrimitiveKind.prototype.toString = SerialKind.prototype.toString;
  PrimitiveKind.prototype.hashCode = SerialKind.prototype.hashCode;
  StructureKind.prototype.toString = SerialKind.prototype.toString;
  StructureKind.prototype.hashCode = SerialKind.prototype.hashCode;
  PolymorphicKind.prototype.toString = SerialKind.prototype.toString;
  PolymorphicKind.prototype.hashCode = SerialKind.prototype.hashCode;
  ENUM.prototype.toString = SerialKind.prototype.toString;
  ENUM.prototype.hashCode = SerialKind.prototype.hashCode;
  CONTEXTUAL.prototype.toString = SerialKind.prototype.toString;
  CONTEXTUAL.prototype.hashCode = SerialKind.prototype.hashCode;
  BOOLEAN.prototype.toString = SerialKind.prototype.toString;
  BOOLEAN.prototype.hashCode = SerialKind.prototype.hashCode;
  BYTE.prototype.toString = SerialKind.prototype.toString;
  BYTE.prototype.hashCode = SerialKind.prototype.hashCode;
  CHAR.prototype.toString = SerialKind.prototype.toString;
  CHAR.prototype.hashCode = SerialKind.prototype.hashCode;
  SHORT.prototype.toString = SerialKind.prototype.toString;
  SHORT.prototype.hashCode = SerialKind.prototype.hashCode;
  INT.prototype.toString = SerialKind.prototype.toString;
  INT.prototype.hashCode = SerialKind.prototype.hashCode;
  LONG.prototype.toString = SerialKind.prototype.toString;
  LONG.prototype.hashCode = SerialKind.prototype.hashCode;
  FLOAT.prototype.toString = SerialKind.prototype.toString;
  FLOAT.prototype.hashCode = SerialKind.prototype.hashCode;
  DOUBLE.prototype.toString = SerialKind.prototype.toString;
  DOUBLE.prototype.hashCode = SerialKind.prototype.hashCode;
  STRING.prototype.toString = SerialKind.prototype.toString;
  STRING.prototype.hashCode = SerialKind.prototype.hashCode;
  CLASS.prototype.toString = SerialKind.prototype.toString;
  CLASS.prototype.hashCode = SerialKind.prototype.hashCode;
  LIST.prototype.toString = SerialKind.prototype.toString;
  LIST.prototype.hashCode = SerialKind.prototype.hashCode;
  MAP.prototype.toString = SerialKind.prototype.toString;
  MAP.prototype.hashCode = SerialKind.prototype.hashCode;
  OBJECT.prototype.toString = SerialKind.prototype.toString;
  OBJECT.prototype.hashCode = SerialKind.prototype.hashCode;
  SEALED.prototype.toString = SerialKind.prototype.toString;
  SEALED.prototype.hashCode = SerialKind.prototype.hashCode;
  OPEN.prototype.toString = SerialKind.prototype.toString;
  OPEN.prototype.hashCode = SerialKind.prototype.hashCode;
  AbstractDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  AbstractDecoder.prototype._get_serializersModule__19 = Decoder.prototype._get_serializersModule__19;
  AbstractDecoder.prototype.decodeSerializableValue_23 = Decoder.prototype.decodeSerializableValue_23;
  AbstractDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  AbstractDecoder.prototype.decodeElementIndex_11 = CompositeDecoder.prototype.decodeElementIndex_11;
  AbstractDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  ListLikeDescriptor.prototype._get_serialName__16 = SerialDescriptor.prototype._get_serialName__16;
  ListLikeDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  PrimitiveArrayDescriptor.prototype._get_kind__16 = ListLikeDescriptor.prototype._get_kind__16;
  PrimitiveArrayDescriptor.prototype._get_elementsCount__16 = ListLikeDescriptor.prototype._get_elementsCount__16;
  PrimitiveArrayDescriptor.prototype.getElementName_16 = ListLikeDescriptor.prototype.getElementName_16;
  PrimitiveArrayDescriptor.prototype.getElementIndex_16 = ListLikeDescriptor.prototype.getElementIndex_16;
  PrimitiveArrayDescriptor.prototype.getElementAnnotations_16 = ListLikeDescriptor.prototype.getElementAnnotations_16;
  PrimitiveArrayDescriptor.prototype.getElementDescriptor_16 = ListLikeDescriptor.prototype.getElementDescriptor_16;
  PrimitiveArrayDescriptor.prototype.equals = ListLikeDescriptor.prototype.equals;
  PrimitiveArrayDescriptor.prototype.hashCode = ListLikeDescriptor.prototype.hashCode;
  PrimitiveArrayDescriptor.prototype.toString = ListLikeDescriptor.prototype.toString;
  PrimitiveArrayDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  ArrayListClassDesc.prototype._get_kind__16 = ListLikeDescriptor.prototype._get_kind__16;
  ArrayListClassDesc.prototype._get_elementsCount__16 = ListLikeDescriptor.prototype._get_elementsCount__16;
  ArrayListClassDesc.prototype.getElementName_16 = ListLikeDescriptor.prototype.getElementName_16;
  ArrayListClassDesc.prototype.getElementIndex_16 = ListLikeDescriptor.prototype.getElementIndex_16;
  ArrayListClassDesc.prototype.getElementAnnotations_16 = ListLikeDescriptor.prototype.getElementAnnotations_16;
  ArrayListClassDesc.prototype.getElementDescriptor_16 = ListLikeDescriptor.prototype.getElementDescriptor_16;
  ArrayListClassDesc.prototype.equals = ListLikeDescriptor.prototype.equals;
  ArrayListClassDesc.prototype.hashCode = ListLikeDescriptor.prototype.hashCode;
  ArrayListClassDesc.prototype.toString = ListLikeDescriptor.prototype.toString;
  ArrayListClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  MapLikeDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  LinkedHashMapClassDesc.prototype._get_serialName__16 = MapLikeDescriptor.prototype._get_serialName__16;
  LinkedHashMapClassDesc.prototype._get_kind__16 = MapLikeDescriptor.prototype._get_kind__16;
  LinkedHashMapClassDesc.prototype._get_elementsCount__16 = MapLikeDescriptor.prototype._get_elementsCount__16;
  LinkedHashMapClassDesc.prototype.getElementName_16 = MapLikeDescriptor.prototype.getElementName_16;
  LinkedHashMapClassDesc.prototype.getElementIndex_16 = MapLikeDescriptor.prototype.getElementIndex_16;
  LinkedHashMapClassDesc.prototype.getElementAnnotations_16 = MapLikeDescriptor.prototype.getElementAnnotations_16;
  LinkedHashMapClassDesc.prototype.getElementDescriptor_16 = MapLikeDescriptor.prototype.getElementDescriptor_16;
  LinkedHashMapClassDesc.prototype.equals = MapLikeDescriptor.prototype.equals;
  LinkedHashMapClassDesc.prototype.hashCode = MapLikeDescriptor.prototype.hashCode;
  LinkedHashMapClassDesc.prototype.toString = MapLikeDescriptor.prototype.toString;
  LinkedHashMapClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  ArrayClassDesc.prototype._get_kind__16 = ListLikeDescriptor.prototype._get_kind__16;
  ArrayClassDesc.prototype._get_elementsCount__16 = ListLikeDescriptor.prototype._get_elementsCount__16;
  ArrayClassDesc.prototype.getElementName_16 = ListLikeDescriptor.prototype.getElementName_16;
  ArrayClassDesc.prototype.getElementIndex_16 = ListLikeDescriptor.prototype.getElementIndex_16;
  ArrayClassDesc.prototype.getElementAnnotations_16 = ListLikeDescriptor.prototype.getElementAnnotations_16;
  ArrayClassDesc.prototype.getElementDescriptor_16 = ListLikeDescriptor.prototype.getElementDescriptor_16;
  ArrayClassDesc.prototype.equals = ListLikeDescriptor.prototype.equals;
  ArrayClassDesc.prototype.hashCode = ListLikeDescriptor.prototype.hashCode;
  ArrayClassDesc.prototype.toString = ListLikeDescriptor.prototype.toString;
  ArrayClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  LinkedHashSetClassDesc.prototype._get_kind__16 = ListLikeDescriptor.prototype._get_kind__16;
  LinkedHashSetClassDesc.prototype._get_elementsCount__16 = ListLikeDescriptor.prototype._get_elementsCount__16;
  LinkedHashSetClassDesc.prototype.getElementName_16 = ListLikeDescriptor.prototype.getElementName_16;
  LinkedHashSetClassDesc.prototype.getElementIndex_16 = ListLikeDescriptor.prototype.getElementIndex_16;
  LinkedHashSetClassDesc.prototype.getElementAnnotations_16 = ListLikeDescriptor.prototype.getElementAnnotations_16;
  LinkedHashSetClassDesc.prototype.getElementDescriptor_16 = ListLikeDescriptor.prototype.getElementDescriptor_16;
  LinkedHashSetClassDesc.prototype.equals = ListLikeDescriptor.prototype.equals;
  LinkedHashSetClassDesc.prototype.hashCode = ListLikeDescriptor.prototype.hashCode;
  LinkedHashSetClassDesc.prototype.toString = ListLikeDescriptor.prototype.toString;
  LinkedHashSetClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  HashSetClassDesc.prototype._get_kind__16 = ListLikeDescriptor.prototype._get_kind__16;
  HashSetClassDesc.prototype._get_elementsCount__16 = ListLikeDescriptor.prototype._get_elementsCount__16;
  HashSetClassDesc.prototype.getElementName_16 = ListLikeDescriptor.prototype.getElementName_16;
  HashSetClassDesc.prototype.getElementIndex_16 = ListLikeDescriptor.prototype.getElementIndex_16;
  HashSetClassDesc.prototype.getElementAnnotations_16 = ListLikeDescriptor.prototype.getElementAnnotations_16;
  HashSetClassDesc.prototype.getElementDescriptor_16 = ListLikeDescriptor.prototype.getElementDescriptor_16;
  HashSetClassDesc.prototype.equals = ListLikeDescriptor.prototype.equals;
  HashSetClassDesc.prototype.hashCode = ListLikeDescriptor.prototype.hashCode;
  HashSetClassDesc.prototype.toString = ListLikeDescriptor.prototype.toString;
  HashSetClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  HashMapClassDesc.prototype._get_serialName__16 = MapLikeDescriptor.prototype._get_serialName__16;
  HashMapClassDesc.prototype._get_kind__16 = MapLikeDescriptor.prototype._get_kind__16;
  HashMapClassDesc.prototype._get_elementsCount__16 = MapLikeDescriptor.prototype._get_elementsCount__16;
  HashMapClassDesc.prototype.getElementName_16 = MapLikeDescriptor.prototype.getElementName_16;
  HashMapClassDesc.prototype.getElementIndex_16 = MapLikeDescriptor.prototype.getElementIndex_16;
  HashMapClassDesc.prototype.getElementAnnotations_16 = MapLikeDescriptor.prototype.getElementAnnotations_16;
  HashMapClassDesc.prototype.getElementDescriptor_16 = MapLikeDescriptor.prototype.getElementDescriptor_16;
  HashMapClassDesc.prototype.equals = MapLikeDescriptor.prototype.equals;
  HashMapClassDesc.prototype.hashCode = MapLikeDescriptor.prototype.hashCode;
  HashMapClassDesc.prototype.toString = MapLikeDescriptor.prototype.toString;
  HashMapClassDesc.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  AbstractCollectionSerializer.prototype.builder_16 = AbstractCollectionSerializer.prototype.builder_16;
  AbstractCollectionSerializer.prototype.builderSize_14 = AbstractCollectionSerializer.prototype.builderSize_14;
  AbstractCollectionSerializer.prototype.toResult_14 = AbstractCollectionSerializer.prototype.toResult_14;
  AbstractCollectionSerializer.prototype.toBuilder_30 = AbstractCollectionSerializer.prototype.toBuilder_30;
  AbstractCollectionSerializer.prototype.checkCapacity_14 = AbstractCollectionSerializer.prototype.checkCapacity_14;
  AbstractCollectionSerializer.prototype.readElement_24 = AbstractCollectionSerializer.prototype.readElement_24;
  AbstractCollectionSerializer.prototype.readAll_5 = AbstractCollectionSerializer.prototype.readAll_5;
  AbstractCollectionSerializer.prototype._get_descriptor__68 = KSerializer.prototype._get_descriptor__68;
  ListLikeSerializer.prototype.insert_8 = ListLikeSerializer.prototype.insert_8;
  ListLikeSerializer.prototype._get_descriptor__68 = ListLikeSerializer.prototype._get_descriptor__68;
  ListLikeSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  ListLikeSerializer.prototype.builder_16 = AbstractCollectionSerializer.prototype.builder_16;
  ListLikeSerializer.prototype.builderSize_14 = AbstractCollectionSerializer.prototype.builderSize_14;
  ListLikeSerializer.prototype.toResult_14 = AbstractCollectionSerializer.prototype.toResult_14;
  ListLikeSerializer.prototype.toBuilder_30 = AbstractCollectionSerializer.prototype.toBuilder_30;
  ListLikeSerializer.prototype.checkCapacity_14 = AbstractCollectionSerializer.prototype.checkCapacity_14;
  ListLikeSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  ListLikeSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  PrimitiveArraySerializer.prototype.empty_7 = PrimitiveArraySerializer.prototype.empty_7;
  PrimitiveArraySerializer.prototype.readElement_24 = PrimitiveArraySerializer.prototype.readElement_24;
  PrimitiveArraySerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  PrimitiveArraySerializer.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  PrimitiveArraySerializer.prototype.toBuilder_30 = AbstractCollectionSerializer.prototype.toBuilder_30;
  PrimitiveArraySerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  PrimitiveArrayBuilder.prototype._get_position__7 = PrimitiveArrayBuilder.prototype._get_position__7;
  PrimitiveArrayBuilder.prototype.ensureCapacity_8 = PrimitiveArrayBuilder.prototype.ensureCapacity_8;
  PrimitiveArrayBuilder.prototype.build_10 = PrimitiveArrayBuilder.prototype.build_10;
  ArrayListSerializer.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  ArrayListSerializer.prototype.readElement_24 = ListLikeSerializer.prototype.readElement_24;
  ArrayListSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  ArrayListSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  ArrayListSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  MapLikeSerializer.prototype._get_descriptor__68 = MapLikeSerializer.prototype._get_descriptor__68;
  MapLikeSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  MapLikeSerializer.prototype.builder_16 = AbstractCollectionSerializer.prototype.builder_16;
  MapLikeSerializer.prototype.builderSize_14 = AbstractCollectionSerializer.prototype.builderSize_14;
  MapLikeSerializer.prototype.toResult_14 = AbstractCollectionSerializer.prototype.toResult_14;
  MapLikeSerializer.prototype.toBuilder_30 = AbstractCollectionSerializer.prototype.toBuilder_30;
  MapLikeSerializer.prototype.checkCapacity_14 = AbstractCollectionSerializer.prototype.checkCapacity_14;
  MapLikeSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  MapLikeSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  LinkedHashMapSerializer.prototype.readAll_5 = MapLikeSerializer.prototype.readAll_5;
  LinkedHashMapSerializer.prototype.readElement_24 = MapLikeSerializer.prototype.readElement_24;
  LinkedHashMapSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  LinkedHashMapSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  LinkedHashMapSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  ReferenceArraySerializer.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  ReferenceArraySerializer.prototype.readElement_24 = ListLikeSerializer.prototype.readElement_24;
  ReferenceArraySerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  ReferenceArraySerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  ReferenceArraySerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  LinkedHashSetSerializer.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  LinkedHashSetSerializer.prototype.readElement_24 = ListLikeSerializer.prototype.readElement_24;
  LinkedHashSetSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  LinkedHashSetSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  LinkedHashSetSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  HashSetSerializer.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  HashSetSerializer.prototype.readElement_24 = ListLikeSerializer.prototype.readElement_24;
  HashSetSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  HashSetSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  HashSetSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  HashMapSerializer.prototype.readAll_5 = MapLikeSerializer.prototype.readAll_5;
  HashMapSerializer.prototype.readElement_24 = MapLikeSerializer.prototype.readElement_24;
  HashMapSerializer.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  HashMapSerializer.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  HashMapSerializer.prototype.deserialize_69 = AbstractCollectionSerializer.prototype.deserialize_69;
  PluginGeneratedSerialDescriptor.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  CharArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  CharArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  CharArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  CharArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  CharArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  CharArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  CharArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  CharArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  CharArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  CharArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  DoubleArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  DoubleArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  DoubleArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  DoubleArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  DoubleArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  DoubleArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  DoubleArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  DoubleArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  DoubleArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  DoubleArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  FloatArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  FloatArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  FloatArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  FloatArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  FloatArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  FloatArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  FloatArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  FloatArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  FloatArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  FloatArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  LongArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  LongArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  LongArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  LongArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  LongArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  LongArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  LongArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  LongArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  LongArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  LongArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  IntArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  IntArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  IntArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  IntArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  IntArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  IntArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  IntArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  IntArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  IntArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  IntArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  ShortArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  ShortArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  ShortArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  ShortArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  ShortArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  ShortArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  ShortArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  ShortArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  ShortArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  ShortArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  ByteArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  ByteArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  ByteArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  ByteArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  ByteArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  ByteArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  ByteArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  ByteArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  ByteArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  ByteArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  BooleanArraySerializer_0.prototype.readElement$default_5 = AbstractCollectionSerializer.prototype.readElement$default_5;
  BooleanArraySerializer_0.prototype._get_descriptor__68 = PrimitiveArraySerializer.prototype._get_descriptor__68;
  BooleanArraySerializer_0.prototype.deserialize_69 = PrimitiveArraySerializer.prototype.deserialize_69;
  BooleanArraySerializer_0.prototype.builderSize_14 = PrimitiveArraySerializer.prototype.builderSize_14;
  BooleanArraySerializer_0.prototype.toResult_14 = PrimitiveArraySerializer.prototype.toResult_14;
  BooleanArraySerializer_0.prototype.checkCapacity_14 = PrimitiveArraySerializer.prototype.checkCapacity_14;
  BooleanArraySerializer_0.prototype.insert_8 = PrimitiveArraySerializer.prototype.insert_8;
  BooleanArraySerializer_0.prototype.builder_16 = PrimitiveArraySerializer.prototype.builder_16;
  BooleanArraySerializer_0.prototype.readAll_5 = ListLikeSerializer.prototype.readAll_5;
  BooleanArraySerializer_0.prototype.merge_5 = AbstractCollectionSerializer.prototype.merge_5;
  CharArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  DoubleArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  FloatArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  LongArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  IntArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  ShortArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  ByteArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  BooleanArrayBuilder.prototype.ensureCapacity$default_7 = PrimitiveArrayBuilder.prototype.ensureCapacity$default_7;
  PrimitiveSerialDescriptor_0.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  TaggedDecoder.prototype.getTag_8 = TaggedDecoder.prototype.getTag_8;
  TaggedDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  TaggedDecoder.prototype.decodeSerializableValue_23 = Decoder.prototype.decodeSerializableValue_23;
  TaggedDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  TaggedDecoder.prototype.decodeElementIndex_11 = CompositeDecoder.prototype.decodeElementIndex_11;
  TaggedDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  NamedValueDecoder.prototype._get_serializersModule__19 = TaggedDecoder.prototype._get_serializersModule__19;
  NamedValueDecoder.prototype.decodeTaggedValue_0 = TaggedDecoder.prototype.decodeTaggedValue_0;
  NamedValueDecoder.prototype.decodeTaggedNotNullMark_2 = TaggedDecoder.prototype.decodeTaggedNotNullMark_2;
  NamedValueDecoder.prototype.decodeTaggedBoolean_6 = TaggedDecoder.prototype.decodeTaggedBoolean_6;
  NamedValueDecoder.prototype.decodeTaggedByte_6 = TaggedDecoder.prototype.decodeTaggedByte_6;
  NamedValueDecoder.prototype.decodeTaggedShort_6 = TaggedDecoder.prototype.decodeTaggedShort_6;
  NamedValueDecoder.prototype.decodeTaggedInt_6 = TaggedDecoder.prototype.decodeTaggedInt_6;
  NamedValueDecoder.prototype.decodeTaggedLong_6 = TaggedDecoder.prototype.decodeTaggedLong_6;
  NamedValueDecoder.prototype.decodeTaggedFloat_6 = TaggedDecoder.prototype.decodeTaggedFloat_6;
  NamedValueDecoder.prototype.decodeTaggedDouble_6 = TaggedDecoder.prototype.decodeTaggedDouble_6;
  NamedValueDecoder.prototype.decodeTaggedChar_6 = TaggedDecoder.prototype.decodeTaggedChar_6;
  NamedValueDecoder.prototype.decodeTaggedString_6 = TaggedDecoder.prototype.decodeTaggedString_6;
  NamedValueDecoder.prototype.decodeTaggedEnum_6 = TaggedDecoder.prototype.decodeTaggedEnum_6;
  NamedValueDecoder.prototype.decodeSerializableValue_23 = Decoder.prototype.decodeSerializableValue_23;
  NamedValueDecoder.prototype.decodeSerializableValue_22 = TaggedDecoder.prototype.decodeSerializableValue_22;
  NamedValueDecoder.prototype.decodeNotNullMark_11 = TaggedDecoder.prototype.decodeNotNullMark_11;
  NamedValueDecoder.prototype.decodeNull_11 = TaggedDecoder.prototype.decodeNull_11;
  NamedValueDecoder.prototype.decodeBoolean_11 = TaggedDecoder.prototype.decodeBoolean_11;
  NamedValueDecoder.prototype.decodeByte_11 = TaggedDecoder.prototype.decodeByte_11;
  NamedValueDecoder.prototype.decodeShort_11 = TaggedDecoder.prototype.decodeShort_11;
  NamedValueDecoder.prototype.decodeInt_11 = TaggedDecoder.prototype.decodeInt_11;
  NamedValueDecoder.prototype.decodeLong_11 = TaggedDecoder.prototype.decodeLong_11;
  NamedValueDecoder.prototype.decodeFloat_11 = TaggedDecoder.prototype.decodeFloat_11;
  NamedValueDecoder.prototype.decodeDouble_11 = TaggedDecoder.prototype.decodeDouble_11;
  NamedValueDecoder.prototype.decodeChar_11 = TaggedDecoder.prototype.decodeChar_11;
  NamedValueDecoder.prototype.decodeString_11 = TaggedDecoder.prototype.decodeString_11;
  NamedValueDecoder.prototype.decodeEnum_11 = TaggedDecoder.prototype.decodeEnum_11;
  NamedValueDecoder.prototype.beginStructure_11 = TaggedDecoder.prototype.beginStructure_11;
  NamedValueDecoder.prototype.endStructure_11 = TaggedDecoder.prototype.endStructure_11;
  NamedValueDecoder.prototype.decodeBooleanElement_11 = TaggedDecoder.prototype.decodeBooleanElement_11;
  NamedValueDecoder.prototype.decodeByteElement_11 = TaggedDecoder.prototype.decodeByteElement_11;
  NamedValueDecoder.prototype.decodeShortElement_11 = TaggedDecoder.prototype.decodeShortElement_11;
  NamedValueDecoder.prototype.decodeIntElement_11 = TaggedDecoder.prototype.decodeIntElement_11;
  NamedValueDecoder.prototype.decodeLongElement_11 = TaggedDecoder.prototype.decodeLongElement_11;
  NamedValueDecoder.prototype.decodeFloatElement_11 = TaggedDecoder.prototype.decodeFloatElement_11;
  NamedValueDecoder.prototype.decodeDoubleElement_11 = TaggedDecoder.prototype.decodeDoubleElement_11;
  NamedValueDecoder.prototype.decodeCharElement_11 = TaggedDecoder.prototype.decodeCharElement_11;
  NamedValueDecoder.prototype.decodeStringElement_11 = TaggedDecoder.prototype.decodeStringElement_11;
  NamedValueDecoder.prototype.decodeSerializableElement_11 = TaggedDecoder.prototype.decodeSerializableElement_11;
  NamedValueDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  NamedValueDecoder.prototype._get_currentTagOrNull__4 = TaggedDecoder.prototype._get_currentTagOrNull__4;
  NamedValueDecoder.prototype.pushTag_0 = TaggedDecoder.prototype.pushTag_0;
  NamedValueDecoder.prototype.popTag_4 = TaggedDecoder.prototype.popTag_4;
  NamedValueDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  NamedValueDecoder.prototype.decodeElementIndex_11 = CompositeDecoder.prototype.decodeElementIndex_11;
  NamedValueDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  KeyValueSerializer.prototype.toResult_25 = KeyValueSerializer.prototype.toResult_25;
  KeyValueSerializer.prototype._get_descriptor__68 = KSerializer.prototype._get_descriptor__68;
  MapEntrySerializer_0.prototype.deserialize_69 = KeyValueSerializer.prototype.deserialize_69;
  PairSerializer_0.prototype.deserialize_69 = KeyValueSerializer.prototype.deserialize_69;
  SerializersModule.prototype.getContextual_0 = SerializersModule.prototype.getContextual_0;
  SerializersModule.prototype.getPolymorphic_0 = SerializersModule.prototype.getPolymorphic_0;
  SerializersModule.prototype.dumpTo_0 = SerializersModule.prototype.dumpTo_0;
  ProtoBufImpl.prototype.decodeFromByteArray_2 = ProtoBuf.prototype.decodeFromByteArray_2;
  ProtoBufImpl.prototype._get_serializersModule__19 = ProtoBuf.prototype._get_serializersModule__19;
  Default_0.prototype._get_serializersModule__19 = ProtoBuf.prototype._get_serializersModule__19;
  Default_0.prototype.decodeFromByteArray_2 = ProtoBuf.prototype.decodeFromByteArray_2;
  ProtoIntegerType.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  ProtoIntegerType.prototype.equals = Enum.prototype.equals;
  ProtoIntegerType.prototype.hashCode = Enum.prototype.hashCode;
  ProtoIntegerType.prototype.toString = Enum.prototype.toString;
  ProtobufTaggedDecoder.prototype.getTag_8 = ProtobufTaggedDecoder.prototype.getTag_8;
  ProtobufTaggedDecoder.prototype.decodeTaggedBoolean_4 = ProtobufTaggedDecoder.prototype.decodeTaggedBoolean_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedByte_4 = ProtobufTaggedDecoder.prototype.decodeTaggedByte_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedShort_4 = ProtobufTaggedDecoder.prototype.decodeTaggedShort_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedInt_4 = ProtobufTaggedDecoder.prototype.decodeTaggedInt_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedLong_4 = ProtobufTaggedDecoder.prototype.decodeTaggedLong_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedFloat_4 = ProtobufTaggedDecoder.prototype.decodeTaggedFloat_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedDouble_4 = ProtobufTaggedDecoder.prototype.decodeTaggedDouble_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedChar_4 = ProtobufTaggedDecoder.prototype.decodeTaggedChar_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedString_4 = ProtobufTaggedDecoder.prototype.decodeTaggedString_4;
  ProtobufTaggedDecoder.prototype.decodeTaggedEnum_4 = ProtobufTaggedDecoder.prototype.decodeTaggedEnum_4;
  ProtobufTaggedDecoder.prototype.decodeSerializableValue_22 = ProtobufTaggedDecoder.prototype.decodeSerializableValue_22;
  ProtobufTaggedDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  ProtobufTaggedDecoder.prototype.popTagOrDefault_3 = ProtobufTaggedBase.prototype.popTagOrDefault_3;
  ProtobufTaggedDecoder.prototype.pushTag_5 = ProtobufTaggedBase.prototype.pushTag_5;
  ProtobufTaggedDecoder.prototype._get_serializersModule__19 = Decoder.prototype._get_serializersModule__19;
  ProtobufTaggedDecoder.prototype.decodeSerializableValue_23 = Decoder.prototype.decodeSerializableValue_23;
  ProtobufTaggedDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  ProtobufTaggedDecoder.prototype.decodeElementIndex_11 = CompositeDecoder.prototype.decodeElementIndex_11;
  ProtobufTaggedDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  ProtobufDecoder.prototype.decodeNotNullMark_11 = ProtobufTaggedDecoder.prototype.decodeNotNullMark_11;
  ProtobufDecoder.prototype.decodeNull_11 = ProtobufTaggedDecoder.prototype.decodeNull_11;
  ProtobufDecoder.prototype.decodeBoolean_11 = ProtobufTaggedDecoder.prototype.decodeBoolean_11;
  ProtobufDecoder.prototype.decodeByte_11 = ProtobufTaggedDecoder.prototype.decodeByte_11;
  ProtobufDecoder.prototype.decodeShort_11 = ProtobufTaggedDecoder.prototype.decodeShort_11;
  ProtobufDecoder.prototype.decodeInt_11 = ProtobufTaggedDecoder.prototype.decodeInt_11;
  ProtobufDecoder.prototype.decodeLong_11 = ProtobufTaggedDecoder.prototype.decodeLong_11;
  ProtobufDecoder.prototype.decodeFloat_11 = ProtobufTaggedDecoder.prototype.decodeFloat_11;
  ProtobufDecoder.prototype.decodeDouble_11 = ProtobufTaggedDecoder.prototype.decodeDouble_11;
  ProtobufDecoder.prototype.decodeChar_11 = ProtobufTaggedDecoder.prototype.decodeChar_11;
  ProtobufDecoder.prototype.decodeString_11 = ProtobufTaggedDecoder.prototype.decodeString_11;
  ProtobufDecoder.prototype.decodeEnum_11 = ProtobufTaggedDecoder.prototype.decodeEnum_11;
  ProtobufDecoder.prototype.decodeBooleanElement_11 = ProtobufTaggedDecoder.prototype.decodeBooleanElement_11;
  ProtobufDecoder.prototype.decodeByteElement_11 = ProtobufTaggedDecoder.prototype.decodeByteElement_11;
  ProtobufDecoder.prototype.decodeShortElement_11 = ProtobufTaggedDecoder.prototype.decodeShortElement_11;
  ProtobufDecoder.prototype.decodeIntElement_11 = ProtobufTaggedDecoder.prototype.decodeIntElement_11;
  ProtobufDecoder.prototype.decodeLongElement_11 = ProtobufTaggedDecoder.prototype.decodeLongElement_11;
  ProtobufDecoder.prototype.decodeFloatElement_11 = ProtobufTaggedDecoder.prototype.decodeFloatElement_11;
  ProtobufDecoder.prototype.decodeDoubleElement_11 = ProtobufTaggedDecoder.prototype.decodeDoubleElement_11;
  ProtobufDecoder.prototype.decodeCharElement_11 = ProtobufTaggedDecoder.prototype.decodeCharElement_11;
  ProtobufDecoder.prototype.decodeStringElement_11 = ProtobufTaggedDecoder.prototype.decodeStringElement_11;
  ProtobufDecoder.prototype.decodeSerializableElement_11 = ProtobufTaggedDecoder.prototype.decodeSerializableElement_11;
  ProtobufDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  ProtobufDecoder.prototype._get_currentTagOrDefault__2 = ProtobufTaggedBase.prototype._get_currentTagOrDefault__2;
  ProtobufDecoder.prototype.popTagOrDefault_3 = ProtobufTaggedBase.prototype.popTagOrDefault_3;
  ProtobufDecoder.prototype.pushTag_5 = ProtobufTaggedBase.prototype.pushTag_5;
  ProtobufDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  ProtobufDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  RepeatedDecoder.prototype._get_reader__0 = ProtobufDecoder.prototype._get_reader__0;
  RepeatedDecoder.prototype.decodeSerializableValue_22 = ProtobufDecoder.prototype.decodeSerializableValue_22;
  RepeatedDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  RepeatedDecoder.prototype.popTagOrDefault_3 = ProtobufTaggedBase.prototype.popTagOrDefault_3;
  RepeatedDecoder.prototype.pushTag_5 = ProtobufTaggedBase.prototype.pushTag_5;
  RepeatedDecoder.prototype._get_currentTagOrDefault__2 = ProtobufTaggedBase.prototype._get_currentTagOrDefault__2;
  RepeatedDecoder.prototype.decodeTaggedBoolean_4 = ProtobufDecoder.prototype.decodeTaggedBoolean_4;
  RepeatedDecoder.prototype.decodeTaggedByte_4 = ProtobufDecoder.prototype.decodeTaggedByte_4;
  RepeatedDecoder.prototype.decodeTaggedChar_4 = ProtobufDecoder.prototype.decodeTaggedChar_4;
  RepeatedDecoder.prototype.decodeTaggedDouble_4 = ProtobufDecoder.prototype.decodeTaggedDouble_4;
  RepeatedDecoder.prototype.decodeTaggedEnum_4 = ProtobufDecoder.prototype.decodeTaggedEnum_4;
  RepeatedDecoder.prototype.decodeTaggedFloat_4 = ProtobufDecoder.prototype.decodeTaggedFloat_4;
  RepeatedDecoder.prototype.decodeTaggedInt_4 = ProtobufDecoder.prototype.decodeTaggedInt_4;
  RepeatedDecoder.prototype.decodeTaggedLong_4 = ProtobufDecoder.prototype.decodeTaggedLong_4;
  RepeatedDecoder.prototype.decodeTaggedShort_4 = ProtobufDecoder.prototype.decodeTaggedShort_4;
  RepeatedDecoder.prototype.decodeTaggedString_4 = ProtobufDecoder.prototype.decodeTaggedString_4;
  RepeatedDecoder.prototype.decodeSerializableElement_11 = ProtobufTaggedDecoder.prototype.decodeSerializableElement_11;
  RepeatedDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  RepeatedDecoder.prototype.decodeBoolean_11 = ProtobufTaggedDecoder.prototype.decodeBoolean_11;
  RepeatedDecoder.prototype.decodeBooleanElement_11 = ProtobufTaggedDecoder.prototype.decodeBooleanElement_11;
  RepeatedDecoder.prototype.decodeByte_11 = ProtobufTaggedDecoder.prototype.decodeByte_11;
  RepeatedDecoder.prototype.decodeByteElement_11 = ProtobufTaggedDecoder.prototype.decodeByteElement_11;
  RepeatedDecoder.prototype.decodeChar_11 = ProtobufTaggedDecoder.prototype.decodeChar_11;
  RepeatedDecoder.prototype.decodeCharElement_11 = ProtobufTaggedDecoder.prototype.decodeCharElement_11;
  RepeatedDecoder.prototype.decodeDouble_11 = ProtobufTaggedDecoder.prototype.decodeDouble_11;
  RepeatedDecoder.prototype.decodeDoubleElement_11 = ProtobufTaggedDecoder.prototype.decodeDoubleElement_11;
  RepeatedDecoder.prototype.decodeEnum_11 = ProtobufTaggedDecoder.prototype.decodeEnum_11;
  RepeatedDecoder.prototype.decodeFloat_11 = ProtobufTaggedDecoder.prototype.decodeFloat_11;
  RepeatedDecoder.prototype.decodeFloatElement_11 = ProtobufTaggedDecoder.prototype.decodeFloatElement_11;
  RepeatedDecoder.prototype.decodeInt_11 = ProtobufTaggedDecoder.prototype.decodeInt_11;
  RepeatedDecoder.prototype.decodeIntElement_11 = ProtobufTaggedDecoder.prototype.decodeIntElement_11;
  RepeatedDecoder.prototype.decodeLong_11 = ProtobufTaggedDecoder.prototype.decodeLong_11;
  RepeatedDecoder.prototype.decodeLongElement_11 = ProtobufTaggedDecoder.prototype.decodeLongElement_11;
  RepeatedDecoder.prototype.decodeNotNullMark_11 = ProtobufTaggedDecoder.prototype.decodeNotNullMark_11;
  RepeatedDecoder.prototype.decodeNull_11 = ProtobufTaggedDecoder.prototype.decodeNull_11;
  RepeatedDecoder.prototype.decodeShort_11 = ProtobufTaggedDecoder.prototype.decodeShort_11;
  RepeatedDecoder.prototype.decodeShortElement_11 = ProtobufTaggedDecoder.prototype.decodeShortElement_11;
  RepeatedDecoder.prototype.decodeString_11 = ProtobufTaggedDecoder.prototype.decodeString_11;
  RepeatedDecoder.prototype.decodeStringElement_11 = ProtobufTaggedDecoder.prototype.decodeStringElement_11;
  RepeatedDecoder.prototype.populateCache_1 = ProtobufDecoder.prototype.populateCache_1;
  RepeatedDecoder.prototype.decodeSerializableValue_23 = ProtobufDecoder.prototype.decodeSerializableValue_23;
  RepeatedDecoder.prototype.beginStructure_11 = ProtobufDecoder.prototype.beginStructure_11;
  RepeatedDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  RepeatedDecoder.prototype.endStructure_11 = ProtobufDecoder.prototype.endStructure_11;
  RepeatedDecoder.prototype._get_serializersModule__19 = ProtobufDecoder.prototype._get_serializersModule__19;
  MapEntryReader.prototype.decodeSerializableValue_22 = ProtobufDecoder.prototype.decodeSerializableValue_22;
  MapEntryReader.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  MapEntryReader.prototype.popTagOrDefault_3 = ProtobufTaggedBase.prototype.popTagOrDefault_3;
  MapEntryReader.prototype.pushTag_5 = ProtobufTaggedBase.prototype.pushTag_5;
  MapEntryReader.prototype._get_currentTagOrDefault__2 = ProtobufTaggedBase.prototype._get_currentTagOrDefault__2;
  MapEntryReader.prototype.decodeTaggedBoolean_4 = ProtobufDecoder.prototype.decodeTaggedBoolean_4;
  MapEntryReader.prototype.decodeTaggedByte_4 = ProtobufDecoder.prototype.decodeTaggedByte_4;
  MapEntryReader.prototype.decodeTaggedChar_4 = ProtobufDecoder.prototype.decodeTaggedChar_4;
  MapEntryReader.prototype.decodeTaggedDouble_4 = ProtobufDecoder.prototype.decodeTaggedDouble_4;
  MapEntryReader.prototype.decodeTaggedEnum_4 = ProtobufDecoder.prototype.decodeTaggedEnum_4;
  MapEntryReader.prototype.decodeTaggedFloat_4 = ProtobufDecoder.prototype.decodeTaggedFloat_4;
  MapEntryReader.prototype.decodeTaggedInt_4 = ProtobufDecoder.prototype.decodeTaggedInt_4;
  MapEntryReader.prototype.decodeTaggedLong_4 = ProtobufDecoder.prototype.decodeTaggedLong_4;
  MapEntryReader.prototype.decodeTaggedShort_4 = ProtobufDecoder.prototype.decodeTaggedShort_4;
  MapEntryReader.prototype.decodeTaggedString_4 = ProtobufDecoder.prototype.decodeTaggedString_4;
  MapEntryReader.prototype.decodeSerializableElement_11 = ProtobufTaggedDecoder.prototype.decodeSerializableElement_11;
  MapEntryReader.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  MapEntryReader.prototype.decodeBoolean_11 = ProtobufTaggedDecoder.prototype.decodeBoolean_11;
  MapEntryReader.prototype.decodeBooleanElement_11 = ProtobufTaggedDecoder.prototype.decodeBooleanElement_11;
  MapEntryReader.prototype.decodeByte_11 = ProtobufTaggedDecoder.prototype.decodeByte_11;
  MapEntryReader.prototype.decodeByteElement_11 = ProtobufTaggedDecoder.prototype.decodeByteElement_11;
  MapEntryReader.prototype.decodeChar_11 = ProtobufTaggedDecoder.prototype.decodeChar_11;
  MapEntryReader.prototype.decodeCharElement_11 = ProtobufTaggedDecoder.prototype.decodeCharElement_11;
  MapEntryReader.prototype.decodeDouble_11 = ProtobufTaggedDecoder.prototype.decodeDouble_11;
  MapEntryReader.prototype.decodeDoubleElement_11 = ProtobufTaggedDecoder.prototype.decodeDoubleElement_11;
  MapEntryReader.prototype.decodeEnum_11 = ProtobufTaggedDecoder.prototype.decodeEnum_11;
  MapEntryReader.prototype.decodeFloat_11 = ProtobufTaggedDecoder.prototype.decodeFloat_11;
  MapEntryReader.prototype.decodeFloatElement_11 = ProtobufTaggedDecoder.prototype.decodeFloatElement_11;
  MapEntryReader.prototype.decodeInt_11 = ProtobufTaggedDecoder.prototype.decodeInt_11;
  MapEntryReader.prototype.decodeIntElement_11 = ProtobufTaggedDecoder.prototype.decodeIntElement_11;
  MapEntryReader.prototype.decodeLong_11 = ProtobufTaggedDecoder.prototype.decodeLong_11;
  MapEntryReader.prototype.decodeLongElement_11 = ProtobufTaggedDecoder.prototype.decodeLongElement_11;
  MapEntryReader.prototype.decodeNotNullMark_11 = ProtobufTaggedDecoder.prototype.decodeNotNullMark_11;
  MapEntryReader.prototype.decodeNull_11 = ProtobufTaggedDecoder.prototype.decodeNull_11;
  MapEntryReader.prototype.decodeShort_11 = ProtobufTaggedDecoder.prototype.decodeShort_11;
  MapEntryReader.prototype.decodeShortElement_11 = ProtobufTaggedDecoder.prototype.decodeShortElement_11;
  MapEntryReader.prototype.decodeString_11 = ProtobufTaggedDecoder.prototype.decodeString_11;
  MapEntryReader.prototype.decodeStringElement_11 = ProtobufTaggedDecoder.prototype.decodeStringElement_11;
  MapEntryReader.prototype.populateCache_1 = ProtobufDecoder.prototype.populateCache_1;
  MapEntryReader.prototype.decodeSerializableValue_23 = ProtobufDecoder.prototype.decodeSerializableValue_23;
  MapEntryReader.prototype.beginStructure_11 = ProtobufDecoder.prototype.beginStructure_11;
  MapEntryReader.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  MapEntryReader.prototype.decodeElementIndex_11 = ProtobufDecoder.prototype.decodeElementIndex_11;
  MapEntryReader.prototype.endStructure_11 = ProtobufDecoder.prototype.endStructure_11;
  MapEntryReader.prototype._get_serializersModule__19 = ProtobufDecoder.prototype._get_serializersModule__19;
  JsonImpl.prototype._get_configuration__4 = Json.prototype._get_configuration__4;
  JsonImpl.prototype.decodeFromString_2 = Json.prototype.decodeFromString_2;
  JsonImpl.prototype._get_serializersModule__19 = Json.prototype._get_serializersModule__19;
  Default_1.prototype._get_serializersModule__19 = Json.prototype._get_serializersModule__19;
  Default_1.prototype.decodeFromString_2 = Json.prototype.decodeFromString_2;
  JsonPrimitive.prototype._get_content__3 = JsonPrimitive.prototype._get_content__3;
  JsonNull.prototype.toString = JsonPrimitive.prototype.toString;
  _no_name_provided__75.prototype._get_isNullable__16 = SerialDescriptor.prototype._get_isNullable__16;
  StreamingJsonDecoder.prototype.decodeSerializableValue_22 = AbstractDecoder.prototype.decodeSerializableValue_22;
  StreamingJsonDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  StreamingJsonDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  StreamingJsonDecoder.prototype.decodeBooleanElement_11 = AbstractDecoder.prototype.decodeBooleanElement_11;
  StreamingJsonDecoder.prototype.decodeByteElement_11 = AbstractDecoder.prototype.decodeByteElement_11;
  StreamingJsonDecoder.prototype.decodeCharElement_11 = AbstractDecoder.prototype.decodeCharElement_11;
  StreamingJsonDecoder.prototype.decodeShortElement_11 = AbstractDecoder.prototype.decodeShortElement_11;
  StreamingJsonDecoder.prototype.decodeIntElement_11 = AbstractDecoder.prototype.decodeIntElement_11;
  StreamingJsonDecoder.prototype.decodeLongElement_11 = AbstractDecoder.prototype.decodeLongElement_11;
  StreamingJsonDecoder.prototype.decodeFloatElement_11 = AbstractDecoder.prototype.decodeFloatElement_11;
  StreamingJsonDecoder.prototype.decodeDoubleElement_11 = AbstractDecoder.prototype.decodeDoubleElement_11;
  StreamingJsonDecoder.prototype.decodeStringElement_11 = AbstractDecoder.prototype.decodeStringElement_11;
  StreamingJsonDecoder.prototype.decodeSerializableElement_11 = AbstractDecoder.prototype.decodeSerializableElement_11;
  StreamingJsonDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  StreamingJsonDecoder.prototype.decodeValue_0 = AbstractDecoder.prototype.decodeValue_0;
  AbstractJsonTreeDecoder.prototype.currentElement_2 = AbstractJsonTreeDecoder.prototype.currentElement_2;
  AbstractJsonTreeDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  AbstractJsonTreeDecoder.prototype.getTag_8 = NamedValueDecoder.prototype.getTag_8;
  AbstractJsonTreeDecoder.prototype.nested_3 = NamedValueDecoder.prototype.nested_3;
  AbstractJsonTreeDecoder.prototype.popTag_4 = TaggedDecoder.prototype.popTag_4;
  AbstractJsonTreeDecoder.prototype.pushTag_0 = TaggedDecoder.prototype.pushTag_0;
  AbstractJsonTreeDecoder.prototype._get_currentTagOrNull__4 = TaggedDecoder.prototype._get_currentTagOrNull__4;
  AbstractJsonTreeDecoder.prototype.decodeSerializableValue_22 = TaggedDecoder.prototype.decodeSerializableValue_22;
  AbstractJsonTreeDecoder.prototype.decodeTaggedValue_0 = TaggedDecoder.prototype.decodeTaggedValue_0;
  AbstractJsonTreeDecoder.prototype.elementName_3 = NamedValueDecoder.prototype.elementName_3;
  AbstractJsonTreeDecoder.prototype.decodeElementIndex_11 = CompositeDecoder.prototype.decodeElementIndex_11;
  AbstractJsonTreeDecoder.prototype.decodeSerializableElement_11 = TaggedDecoder.prototype.decodeSerializableElement_11;
  AbstractJsonTreeDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  AbstractJsonTreeDecoder.prototype.decodeBoolean_11 = TaggedDecoder.prototype.decodeBoolean_11;
  AbstractJsonTreeDecoder.prototype.decodeBooleanElement_11 = TaggedDecoder.prototype.decodeBooleanElement_11;
  AbstractJsonTreeDecoder.prototype.decodeByte_11 = TaggedDecoder.prototype.decodeByte_11;
  AbstractJsonTreeDecoder.prototype.decodeByteElement_11 = TaggedDecoder.prototype.decodeByteElement_11;
  AbstractJsonTreeDecoder.prototype.decodeChar_11 = TaggedDecoder.prototype.decodeChar_11;
  AbstractJsonTreeDecoder.prototype.decodeCharElement_11 = TaggedDecoder.prototype.decodeCharElement_11;
  AbstractJsonTreeDecoder.prototype.decodeDouble_11 = TaggedDecoder.prototype.decodeDouble_11;
  AbstractJsonTreeDecoder.prototype.decodeDoubleElement_11 = TaggedDecoder.prototype.decodeDoubleElement_11;
  AbstractJsonTreeDecoder.prototype.decodeEnum_11 = TaggedDecoder.prototype.decodeEnum_11;
  AbstractJsonTreeDecoder.prototype.decodeFloat_11 = TaggedDecoder.prototype.decodeFloat_11;
  AbstractJsonTreeDecoder.prototype.decodeFloatElement_11 = TaggedDecoder.prototype.decodeFloatElement_11;
  AbstractJsonTreeDecoder.prototype.decodeInt_11 = TaggedDecoder.prototype.decodeInt_11;
  AbstractJsonTreeDecoder.prototype.decodeIntElement_11 = TaggedDecoder.prototype.decodeIntElement_11;
  AbstractJsonTreeDecoder.prototype.decodeLong_11 = TaggedDecoder.prototype.decodeLong_11;
  AbstractJsonTreeDecoder.prototype.decodeLongElement_11 = TaggedDecoder.prototype.decodeLongElement_11;
  AbstractJsonTreeDecoder.prototype.decodeNull_11 = TaggedDecoder.prototype.decodeNull_11;
  AbstractJsonTreeDecoder.prototype.decodeShort_11 = TaggedDecoder.prototype.decodeShort_11;
  AbstractJsonTreeDecoder.prototype.decodeShortElement_11 = TaggedDecoder.prototype.decodeShortElement_11;
  AbstractJsonTreeDecoder.prototype.decodeString_11 = TaggedDecoder.prototype.decodeString_11;
  AbstractJsonTreeDecoder.prototype.decodeStringElement_11 = TaggedDecoder.prototype.decodeStringElement_11;
  AbstractJsonTreeDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  JsonTreeDecoder.prototype._get_configuration__4 = AbstractJsonTreeDecoder.prototype._get_configuration__4;
  JsonTreeDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  JsonTreeDecoder.prototype.getTag_8 = NamedValueDecoder.prototype.getTag_8;
  JsonTreeDecoder.prototype.nested_3 = NamedValueDecoder.prototype.nested_3;
  JsonTreeDecoder.prototype.popTag_4 = TaggedDecoder.prototype.popTag_4;
  JsonTreeDecoder.prototype.pushTag_0 = TaggedDecoder.prototype.pushTag_0;
  JsonTreeDecoder.prototype._get_currentTagOrNull__4 = TaggedDecoder.prototype._get_currentTagOrNull__4;
  JsonTreeDecoder.prototype.decodeSerializableValue_22 = TaggedDecoder.prototype.decodeSerializableValue_22;
  JsonTreeDecoder.prototype.composeName_3 = AbstractJsonTreeDecoder.prototype.composeName_3;
  JsonTreeDecoder.prototype.decodeTaggedBoolean_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_9;
  JsonTreeDecoder.prototype.decodeTaggedByte_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedByte_9;
  JsonTreeDecoder.prototype.decodeTaggedChar_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedChar_9;
  JsonTreeDecoder.prototype.decodeTaggedDouble_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_9;
  JsonTreeDecoder.prototype.decodeTaggedEnum_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedEnum_9;
  JsonTreeDecoder.prototype.decodeTaggedFloat_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_9;
  JsonTreeDecoder.prototype.decodeTaggedInt_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedInt_9;
  JsonTreeDecoder.prototype.decodeTaggedLong_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedLong_9;
  JsonTreeDecoder.prototype.decodeTaggedNotNullMark_5 = AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_5;
  JsonTreeDecoder.prototype.decodeTaggedShort_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedShort_9;
  JsonTreeDecoder.prototype.decodeTaggedString_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedString_9;
  JsonTreeDecoder.prototype.decodeTaggedValue_0 = TaggedDecoder.prototype.decodeTaggedValue_0;
  JsonTreeDecoder.prototype.elementName_3 = NamedValueDecoder.prototype.elementName_3;
  JsonTreeDecoder.prototype.getValue_2 = AbstractJsonTreeDecoder.prototype.getValue_2;
  JsonTreeDecoder.prototype.decodeSerializableElement_11 = TaggedDecoder.prototype.decodeSerializableElement_11;
  JsonTreeDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  JsonTreeDecoder.prototype.decodeBoolean_11 = TaggedDecoder.prototype.decodeBoolean_11;
  JsonTreeDecoder.prototype.decodeBooleanElement_11 = TaggedDecoder.prototype.decodeBooleanElement_11;
  JsonTreeDecoder.prototype.decodeByte_11 = TaggedDecoder.prototype.decodeByte_11;
  JsonTreeDecoder.prototype.decodeByteElement_11 = TaggedDecoder.prototype.decodeByteElement_11;
  JsonTreeDecoder.prototype.decodeChar_11 = TaggedDecoder.prototype.decodeChar_11;
  JsonTreeDecoder.prototype.decodeCharElement_11 = TaggedDecoder.prototype.decodeCharElement_11;
  JsonTreeDecoder.prototype.decodeDouble_11 = TaggedDecoder.prototype.decodeDouble_11;
  JsonTreeDecoder.prototype.decodeDoubleElement_11 = TaggedDecoder.prototype.decodeDoubleElement_11;
  JsonTreeDecoder.prototype.decodeEnum_11 = TaggedDecoder.prototype.decodeEnum_11;
  JsonTreeDecoder.prototype.decodeFloat_11 = TaggedDecoder.prototype.decodeFloat_11;
  JsonTreeDecoder.prototype.decodeFloatElement_11 = TaggedDecoder.prototype.decodeFloatElement_11;
  JsonTreeDecoder.prototype.decodeInt_11 = TaggedDecoder.prototype.decodeInt_11;
  JsonTreeDecoder.prototype.decodeIntElement_11 = TaggedDecoder.prototype.decodeIntElement_11;
  JsonTreeDecoder.prototype.decodeLong_11 = TaggedDecoder.prototype.decodeLong_11;
  JsonTreeDecoder.prototype.decodeLongElement_11 = TaggedDecoder.prototype.decodeLongElement_11;
  JsonTreeDecoder.prototype.decodeNull_11 = TaggedDecoder.prototype.decodeNull_11;
  JsonTreeDecoder.prototype.decodeShort_11 = TaggedDecoder.prototype.decodeShort_11;
  JsonTreeDecoder.prototype.decodeShortElement_11 = TaggedDecoder.prototype.decodeShortElement_11;
  JsonTreeDecoder.prototype.decodeString_11 = TaggedDecoder.prototype.decodeString_11;
  JsonTreeDecoder.prototype.decodeStringElement_11 = TaggedDecoder.prototype.decodeStringElement_11;
  JsonTreeDecoder.prototype.decodeSerializableValue_23 = AbstractJsonTreeDecoder.prototype.decodeSerializableValue_23;
  JsonTreeDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  JsonTreeDecoder.prototype.decodeJsonElement_4 = AbstractJsonTreeDecoder.prototype.decodeJsonElement_4;
  JsonTreeDecoder.prototype.decodeNotNullMark_11 = AbstractJsonTreeDecoder.prototype.decodeNotNullMark_11;
  JsonTreeDecoder.prototype._get_json__4 = AbstractJsonTreeDecoder.prototype._get_json__4;
  JsonTreeDecoder.prototype._get_serializersModule__19 = AbstractJsonTreeDecoder.prototype._get_serializersModule__19;
  JsonTreeListDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  JsonTreeListDecoder.prototype.getTag_8 = NamedValueDecoder.prototype.getTag_8;
  JsonTreeListDecoder.prototype.nested_3 = NamedValueDecoder.prototype.nested_3;
  JsonTreeListDecoder.prototype.popTag_4 = TaggedDecoder.prototype.popTag_4;
  JsonTreeListDecoder.prototype.pushTag_0 = TaggedDecoder.prototype.pushTag_0;
  JsonTreeListDecoder.prototype._get_currentTagOrNull__4 = TaggedDecoder.prototype._get_currentTagOrNull__4;
  JsonTreeListDecoder.prototype.decodeSerializableValue_22 = TaggedDecoder.prototype.decodeSerializableValue_22;
  JsonTreeListDecoder.prototype.composeName_3 = AbstractJsonTreeDecoder.prototype.composeName_3;
  JsonTreeListDecoder.prototype.decodeTaggedBoolean_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_9;
  JsonTreeListDecoder.prototype.decodeTaggedByte_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedByte_9;
  JsonTreeListDecoder.prototype.decodeTaggedChar_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedChar_9;
  JsonTreeListDecoder.prototype.decodeTaggedDouble_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_9;
  JsonTreeListDecoder.prototype.decodeTaggedEnum_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedEnum_9;
  JsonTreeListDecoder.prototype.decodeTaggedFloat_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_9;
  JsonTreeListDecoder.prototype.decodeTaggedInt_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedInt_9;
  JsonTreeListDecoder.prototype.decodeTaggedLong_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedLong_9;
  JsonTreeListDecoder.prototype.decodeTaggedNotNullMark_5 = AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_5;
  JsonTreeListDecoder.prototype.decodeTaggedShort_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedShort_9;
  JsonTreeListDecoder.prototype.decodeTaggedString_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedString_9;
  JsonTreeListDecoder.prototype.decodeTaggedValue_0 = TaggedDecoder.prototype.decodeTaggedValue_0;
  JsonTreeListDecoder.prototype.getValue_2 = AbstractJsonTreeDecoder.prototype.getValue_2;
  JsonTreeListDecoder.prototype.decodeSerializableElement_11 = TaggedDecoder.prototype.decodeSerializableElement_11;
  JsonTreeListDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  JsonTreeListDecoder.prototype.decodeBoolean_11 = TaggedDecoder.prototype.decodeBoolean_11;
  JsonTreeListDecoder.prototype.decodeBooleanElement_11 = TaggedDecoder.prototype.decodeBooleanElement_11;
  JsonTreeListDecoder.prototype.decodeByte_11 = TaggedDecoder.prototype.decodeByte_11;
  JsonTreeListDecoder.prototype.decodeByteElement_11 = TaggedDecoder.prototype.decodeByteElement_11;
  JsonTreeListDecoder.prototype.decodeChar_11 = TaggedDecoder.prototype.decodeChar_11;
  JsonTreeListDecoder.prototype.decodeCharElement_11 = TaggedDecoder.prototype.decodeCharElement_11;
  JsonTreeListDecoder.prototype.decodeDouble_11 = TaggedDecoder.prototype.decodeDouble_11;
  JsonTreeListDecoder.prototype.decodeDoubleElement_11 = TaggedDecoder.prototype.decodeDoubleElement_11;
  JsonTreeListDecoder.prototype.decodeEnum_11 = TaggedDecoder.prototype.decodeEnum_11;
  JsonTreeListDecoder.prototype.decodeFloat_11 = TaggedDecoder.prototype.decodeFloat_11;
  JsonTreeListDecoder.prototype.decodeFloatElement_11 = TaggedDecoder.prototype.decodeFloatElement_11;
  JsonTreeListDecoder.prototype.decodeInt_11 = TaggedDecoder.prototype.decodeInt_11;
  JsonTreeListDecoder.prototype.decodeIntElement_11 = TaggedDecoder.prototype.decodeIntElement_11;
  JsonTreeListDecoder.prototype.decodeLong_11 = TaggedDecoder.prototype.decodeLong_11;
  JsonTreeListDecoder.prototype.decodeLongElement_11 = TaggedDecoder.prototype.decodeLongElement_11;
  JsonTreeListDecoder.prototype.decodeNull_11 = TaggedDecoder.prototype.decodeNull_11;
  JsonTreeListDecoder.prototype.decodeShort_11 = TaggedDecoder.prototype.decodeShort_11;
  JsonTreeListDecoder.prototype.decodeShortElement_11 = TaggedDecoder.prototype.decodeShortElement_11;
  JsonTreeListDecoder.prototype.decodeString_11 = TaggedDecoder.prototype.decodeString_11;
  JsonTreeListDecoder.prototype.decodeStringElement_11 = TaggedDecoder.prototype.decodeStringElement_11;
  JsonTreeListDecoder.prototype.decodeSerializableValue_23 = AbstractJsonTreeDecoder.prototype.decodeSerializableValue_23;
  JsonTreeListDecoder.prototype.beginStructure_11 = AbstractJsonTreeDecoder.prototype.beginStructure_11;
  JsonTreeListDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  JsonTreeListDecoder.prototype.decodeJsonElement_4 = AbstractJsonTreeDecoder.prototype.decodeJsonElement_4;
  JsonTreeListDecoder.prototype.decodeNotNullMark_11 = AbstractJsonTreeDecoder.prototype.decodeNotNullMark_11;
  JsonTreeListDecoder.prototype.endStructure_11 = AbstractJsonTreeDecoder.prototype.endStructure_11;
  JsonTreeListDecoder.prototype._get_json__4 = AbstractJsonTreeDecoder.prototype._get_json__4;
  JsonTreeListDecoder.prototype._get_serializersModule__19 = AbstractJsonTreeDecoder.prototype._get_serializersModule__19;
  JsonTreeMapDecoder.prototype._get_configuration__4 = AbstractJsonTreeDecoder.prototype._get_configuration__4;
  JsonTreeMapDecoder.prototype.decodeSequentially_11 = CompositeDecoder.prototype.decodeSequentially_11;
  JsonTreeMapDecoder.prototype.getTag_8 = NamedValueDecoder.prototype.getTag_8;
  JsonTreeMapDecoder.prototype.nested_3 = NamedValueDecoder.prototype.nested_3;
  JsonTreeMapDecoder.prototype.popTag_4 = TaggedDecoder.prototype.popTag_4;
  JsonTreeMapDecoder.prototype.pushTag_0 = TaggedDecoder.prototype.pushTag_0;
  JsonTreeMapDecoder.prototype._get_currentTagOrNull__4 = TaggedDecoder.prototype._get_currentTagOrNull__4;
  JsonTreeMapDecoder.prototype.decodeSerializableValue_22 = TaggedDecoder.prototype.decodeSerializableValue_22;
  JsonTreeMapDecoder.prototype.composeName_3 = AbstractJsonTreeDecoder.prototype.composeName_3;
  JsonTreeMapDecoder.prototype.decodeTaggedBoolean_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedBoolean_9;
  JsonTreeMapDecoder.prototype.decodeTaggedByte_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedByte_9;
  JsonTreeMapDecoder.prototype.decodeTaggedChar_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedChar_9;
  JsonTreeMapDecoder.prototype.decodeTaggedDouble_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedDouble_9;
  JsonTreeMapDecoder.prototype.decodeTaggedEnum_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedEnum_9;
  JsonTreeMapDecoder.prototype.decodeTaggedFloat_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedFloat_9;
  JsonTreeMapDecoder.prototype.decodeTaggedInt_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedInt_9;
  JsonTreeMapDecoder.prototype.decodeTaggedLong_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedLong_9;
  JsonTreeMapDecoder.prototype.decodeTaggedNotNullMark_5 = AbstractJsonTreeDecoder.prototype.decodeTaggedNotNullMark_5;
  JsonTreeMapDecoder.prototype.decodeTaggedShort_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedShort_9;
  JsonTreeMapDecoder.prototype.decodeTaggedString_9 = AbstractJsonTreeDecoder.prototype.decodeTaggedString_9;
  JsonTreeMapDecoder.prototype.decodeTaggedValue_0 = TaggedDecoder.prototype.decodeTaggedValue_0;
  JsonTreeMapDecoder.prototype.getValue_2 = AbstractJsonTreeDecoder.prototype.getValue_2;
  JsonTreeMapDecoder.prototype.decodeSerializableElement_11 = TaggedDecoder.prototype.decodeSerializableElement_11;
  JsonTreeMapDecoder.prototype.decodeSerializableElement$default_11 = CompositeDecoder.prototype.decodeSerializableElement$default_11;
  JsonTreeMapDecoder.prototype.decodeBoolean_11 = TaggedDecoder.prototype.decodeBoolean_11;
  JsonTreeMapDecoder.prototype.decodeBooleanElement_11 = TaggedDecoder.prototype.decodeBooleanElement_11;
  JsonTreeMapDecoder.prototype.decodeByte_11 = TaggedDecoder.prototype.decodeByte_11;
  JsonTreeMapDecoder.prototype.decodeByteElement_11 = TaggedDecoder.prototype.decodeByteElement_11;
  JsonTreeMapDecoder.prototype.decodeChar_11 = TaggedDecoder.prototype.decodeChar_11;
  JsonTreeMapDecoder.prototype.decodeCharElement_11 = TaggedDecoder.prototype.decodeCharElement_11;
  JsonTreeMapDecoder.prototype.decodeDouble_11 = TaggedDecoder.prototype.decodeDouble_11;
  JsonTreeMapDecoder.prototype.decodeDoubleElement_11 = TaggedDecoder.prototype.decodeDoubleElement_11;
  JsonTreeMapDecoder.prototype.decodeEnum_11 = TaggedDecoder.prototype.decodeEnum_11;
  JsonTreeMapDecoder.prototype.decodeFloat_11 = TaggedDecoder.prototype.decodeFloat_11;
  JsonTreeMapDecoder.prototype.decodeFloatElement_11 = TaggedDecoder.prototype.decodeFloatElement_11;
  JsonTreeMapDecoder.prototype.decodeInt_11 = TaggedDecoder.prototype.decodeInt_11;
  JsonTreeMapDecoder.prototype.decodeIntElement_11 = TaggedDecoder.prototype.decodeIntElement_11;
  JsonTreeMapDecoder.prototype.decodeLong_11 = TaggedDecoder.prototype.decodeLong_11;
  JsonTreeMapDecoder.prototype.decodeLongElement_11 = TaggedDecoder.prototype.decodeLongElement_11;
  JsonTreeMapDecoder.prototype.decodeNull_11 = TaggedDecoder.prototype.decodeNull_11;
  JsonTreeMapDecoder.prototype.decodeShort_11 = TaggedDecoder.prototype.decodeShort_11;
  JsonTreeMapDecoder.prototype.decodeShortElement_11 = TaggedDecoder.prototype.decodeShortElement_11;
  JsonTreeMapDecoder.prototype.decodeString_11 = TaggedDecoder.prototype.decodeString_11;
  JsonTreeMapDecoder.prototype.decodeStringElement_11 = TaggedDecoder.prototype.decodeStringElement_11;
  JsonTreeMapDecoder.prototype.decodeSerializableValue_23 = AbstractJsonTreeDecoder.prototype.decodeSerializableValue_23;
  JsonTreeMapDecoder.prototype.beginStructure_11 = JsonTreeDecoder.prototype.beginStructure_11;
  JsonTreeMapDecoder.prototype.decodeCollectionSize_11 = CompositeDecoder.prototype.decodeCollectionSize_11;
  JsonTreeMapDecoder.prototype.decodeJsonElement_4 = AbstractJsonTreeDecoder.prototype.decodeJsonElement_4;
  JsonTreeMapDecoder.prototype.decodeNotNullMark_11 = AbstractJsonTreeDecoder.prototype.decodeNotNullMark_11;
  JsonTreeMapDecoder.prototype._get_json__4 = AbstractJsonTreeDecoder.prototype._get_json__4;
  JsonTreeMapDecoder.prototype._get_serializersModule__19 = AbstractJsonTreeDecoder.prototype._get_serializersModule__19;
  WriteMode.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  WriteMode.prototype.equals = Enum.prototype.equals;
  WriteMode.prototype.hashCode = Enum.prototype.hashCode;
  WriteMode.prototype.toString = Enum.prototype.toString;
  $serializer.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_0.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_1.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_2.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_3.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_4.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_5.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_6.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_7.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_8.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_9.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_10.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_11.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_12.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_13.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_14.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_15.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_16.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_17.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_18.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_19.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_20.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  ObjectType.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  ObjectType.prototype.equals = Enum.prototype.equals;
  ObjectType.prototype.hashCode = Enum.prototype.hashCode;
  ObjectType.prototype.toString = Enum.prototype.toString;
  $serializer_21.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_22.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  $serializer_23.prototype.typeParametersSerializers_24 = GeneratedSerializer.prototype.typeParametersSerializers_24;
  JobSupport.prototype.invokeOnCompletion$default_3 = Job.prototype.invokeOnCompletion$default_3;
  JobSupport.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  JobSupport.prototype.get_42 = Element_0.prototype.get_42;
  JobSupport.prototype.fold_17 = Element_0.prototype.fold_17;
  JobSupport.prototype.minusKey_18 = Element_0.prototype.minusKey_18;
  AbstractCoroutine.prototype._get_key__20 = JobSupport.prototype._get_key__20;
  AbstractCoroutine.prototype._set_parentHandle__2 = JobSupport.prototype._set_parentHandle__2;
  AbstractCoroutine.prototype._get_parentHandle__2 = JobSupport.prototype._get_parentHandle__2;
  AbstractCoroutine.prototype.initParentJobInternal_2 = JobSupport.prototype.initParentJobInternal_2;
  AbstractCoroutine.prototype._get_state__3 = JobSupport.prototype._get_state__3;
  AbstractCoroutine.prototype._get_isCompleted__3 = JobSupport.prototype._get_isCompleted__3;
  AbstractCoroutine.prototype.start_7 = JobSupport.prototype.start_7;
  AbstractCoroutine.prototype.getCancellationException_3 = JobSupport.prototype.getCancellationException_3;
  AbstractCoroutine.prototype.toCancellationException_2 = JobSupport.prototype.toCancellationException_2;
  AbstractCoroutine.prototype.toCancellationException$default_2 = JobSupport.prototype.toCancellationException$default_2;
  AbstractCoroutine.prototype.invokeOnCompletion_3 = JobSupport.prototype.invokeOnCompletion_3;
  AbstractCoroutine.prototype.invokeOnCompletion$default_3 = Job.prototype.invokeOnCompletion$default_3;
  AbstractCoroutine.prototype.removeNode_2 = JobSupport.prototype.removeNode_2;
  AbstractCoroutine.prototype._get_onCancelComplete__2 = JobSupport.prototype._get_onCancelComplete__2;
  AbstractCoroutine.prototype.parentCancelled_4 = JobSupport.prototype.parentCancelled_4;
  AbstractCoroutine.prototype.childCancelled_5 = JobSupport.prototype.childCancelled_5;
  AbstractCoroutine.prototype.cancelImpl_2 = JobSupport.prototype.cancelImpl_2;
  AbstractCoroutine.prototype.getChildJobCancellationCause_3 = JobSupport.prototype.getChildJobCancellationCause_3;
  AbstractCoroutine.prototype.makeCompletingOnce_2 = JobSupport.prototype.makeCompletingOnce_2;
  AbstractCoroutine.prototype.attachChild_3 = JobSupport.prototype.attachChild_3;
  AbstractCoroutine.prototype.onCancelling_2 = JobSupport.prototype.onCancelling_2;
  AbstractCoroutine.prototype._get_isScopedCoroutine__2 = JobSupport.prototype._get_isScopedCoroutine__2;
  AbstractCoroutine.prototype._get_handlesException__2 = JobSupport.prototype._get_handlesException__2;
  AbstractCoroutine.prototype.handleJobException_2 = JobSupport.prototype.handleJobException_2;
  AbstractCoroutine.prototype.afterCompletion_2 = JobSupport.prototype.afterCompletion_2;
  AbstractCoroutine.prototype.toString = JobSupport.prototype.toString;
  AbstractCoroutine.prototype.toDebugString_2 = JobSupport.prototype.toDebugString_2;
  AbstractCoroutine.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  AbstractCoroutine.prototype.get_42 = Element_0.prototype.get_42;
  AbstractCoroutine.prototype.fold_17 = Element_0.prototype.fold_17;
  AbstractCoroutine.prototype.minusKey_18 = Element_0.prototype.minusKey_18;
  StandaloneCoroutine.prototype.onCompletionInternal_2 = AbstractCoroutine.prototype.onCompletionInternal_2;
  StandaloneCoroutine.prototype.attachChild_3 = JobSupport.prototype.attachChild_3;
  StandaloneCoroutine.prototype._get_context__9 = AbstractCoroutine.prototype._get_context__9;
  StandaloneCoroutine.prototype.toDebugString_2 = JobSupport.prototype.toDebugString_2;
  StandaloneCoroutine.prototype.cancelImpl_2 = JobSupport.prototype.cancelImpl_2;
  StandaloneCoroutine.prototype.handleOnCompletionException_2 = AbstractCoroutine.prototype.handleOnCompletionException_2;
  StandaloneCoroutine.prototype.initParentJob_1 = AbstractCoroutine.prototype.initParentJob_1;
  StandaloneCoroutine.prototype.initParentJobInternal_2 = JobSupport.prototype.initParentJobInternal_2;
  StandaloneCoroutine.prototype.makeCompletingOnce_2 = JobSupport.prototype.makeCompletingOnce_2;
  StandaloneCoroutine.prototype.onStartInternal_2 = AbstractCoroutine.prototype.onStartInternal_2;
  StandaloneCoroutine.prototype.removeNode_2 = JobSupport.prototype.removeNode_2;
  StandaloneCoroutine.prototype._get_state__3 = JobSupport.prototype._get_state__3;
  StandaloneCoroutine.prototype._set_parentHandle__2 = JobSupport.prototype._set_parentHandle__2;
  StandaloneCoroutine.prototype._get_parentHandle__2 = JobSupport.prototype._get_parentHandle__2;
  StandaloneCoroutine.prototype.nameString_3 = AbstractCoroutine.prototype.nameString_3;
  StandaloneCoroutine.prototype._get_handlesException__2 = JobSupport.prototype._get_handlesException__2;
  StandaloneCoroutine.prototype._get_onCancelComplete__2 = JobSupport.prototype._get_onCancelComplete__2;
  StandaloneCoroutine.prototype.toCancellationException_2 = JobSupport.prototype.toCancellationException_2;
  StandaloneCoroutine.prototype.toCancellationException$default_2 = JobSupport.prototype.toCancellationException$default_2;
  StandaloneCoroutine.prototype.afterCompletion_2 = JobSupport.prototype.afterCompletion_2;
  StandaloneCoroutine.prototype.afterResume_1 = AbstractCoroutine.prototype.afterResume_1;
  StandaloneCoroutine.prototype.cancellationExceptionMessage_2 = AbstractCoroutine.prototype.cancellationExceptionMessage_2;
  StandaloneCoroutine.prototype.onCancelled_1 = AbstractCoroutine.prototype.onCancelled_1;
  StandaloneCoroutine.prototype.onCancelling_2 = JobSupport.prototype.onCancelling_2;
  StandaloneCoroutine.prototype.onCompleted = AbstractCoroutine.prototype.onCompleted;
  StandaloneCoroutine.prototype.onStart_1 = AbstractCoroutine.prototype.onStart_1;
  StandaloneCoroutine.prototype._get_isScopedCoroutine__2 = JobSupport.prototype._get_isScopedCoroutine__2;
  StandaloneCoroutine.prototype.start_0 = AbstractCoroutine.prototype.start_0;
  StandaloneCoroutine.prototype.getCancellationException_3 = JobSupport.prototype.getCancellationException_3;
  StandaloneCoroutine.prototype.invokeOnCompletion_3 = JobSupport.prototype.invokeOnCompletion_3;
  StandaloneCoroutine.prototype.invokeOnCompletion$default_3 = Job.prototype.invokeOnCompletion$default_3;
  StandaloneCoroutine.prototype.parentCancelled_4 = JobSupport.prototype.parentCancelled_4;
  StandaloneCoroutine.prototype.resumeWith_11 = AbstractCoroutine.prototype.resumeWith_11;
  StandaloneCoroutine.prototype.start_7 = JobSupport.prototype.start_7;
  StandaloneCoroutine.prototype._get_isCompleted__3 = JobSupport.prototype._get_isCompleted__3;
  StandaloneCoroutine.prototype._get_key__20 = JobSupport.prototype._get_key__20;
  StandaloneCoroutine.prototype.get_42 = Element_0.prototype.get_42;
  StandaloneCoroutine.prototype.fold_17 = Element_0.prototype.fold_17;
  StandaloneCoroutine.prototype.childCancelled_5 = JobSupport.prototype.childCancelled_5;
  StandaloneCoroutine.prototype.getChildJobCancellationCause_3 = JobSupport.prototype.getChildJobCancellationCause_3;
  StandaloneCoroutine.prototype.minusKey_18 = Element_0.prototype.minusKey_18;
  StandaloneCoroutine.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  StandaloneCoroutine.prototype.toString = JobSupport.prototype.toString;
  StandaloneCoroutine.prototype._get_coroutineContext__3 = AbstractCoroutine.prototype._get_coroutineContext__3;
  StandaloneCoroutine.prototype._get_isActive__15 = AbstractCoroutine.prototype._get_isActive__15;
  LazyStandaloneCoroutine.prototype.onCompletionInternal_2 = AbstractCoroutine.prototype.onCompletionInternal_2;
  LazyStandaloneCoroutine.prototype.attachChild_3 = JobSupport.prototype.attachChild_3;
  LazyStandaloneCoroutine.prototype._get_context__9 = AbstractCoroutine.prototype._get_context__9;
  LazyStandaloneCoroutine.prototype.toDebugString_2 = JobSupport.prototype.toDebugString_2;
  LazyStandaloneCoroutine.prototype.cancelImpl_2 = JobSupport.prototype.cancelImpl_2;
  LazyStandaloneCoroutine.prototype.handleOnCompletionException_2 = AbstractCoroutine.prototype.handleOnCompletionException_2;
  LazyStandaloneCoroutine.prototype.initParentJob_1 = AbstractCoroutine.prototype.initParentJob_1;
  LazyStandaloneCoroutine.prototype.initParentJobInternal_2 = JobSupport.prototype.initParentJobInternal_2;
  LazyStandaloneCoroutine.prototype.makeCompletingOnce_2 = JobSupport.prototype.makeCompletingOnce_2;
  LazyStandaloneCoroutine.prototype.onStartInternal_2 = AbstractCoroutine.prototype.onStartInternal_2;
  LazyStandaloneCoroutine.prototype.removeNode_2 = JobSupport.prototype.removeNode_2;
  LazyStandaloneCoroutine.prototype._get_state__3 = JobSupport.prototype._get_state__3;
  LazyStandaloneCoroutine.prototype._set_parentHandle__2 = JobSupport.prototype._set_parentHandle__2;
  LazyStandaloneCoroutine.prototype._get_parentHandle__2 = JobSupport.prototype._get_parentHandle__2;
  LazyStandaloneCoroutine.prototype.nameString_3 = AbstractCoroutine.prototype.nameString_3;
  LazyStandaloneCoroutine.prototype._get_handlesException__2 = JobSupport.prototype._get_handlesException__2;
  LazyStandaloneCoroutine.prototype._get_onCancelComplete__2 = JobSupport.prototype._get_onCancelComplete__2;
  LazyStandaloneCoroutine.prototype.toCancellationException_2 = JobSupport.prototype.toCancellationException_2;
  LazyStandaloneCoroutine.prototype.toCancellationException$default_2 = JobSupport.prototype.toCancellationException$default_2;
  LazyStandaloneCoroutine.prototype.afterCompletion_2 = JobSupport.prototype.afterCompletion_2;
  LazyStandaloneCoroutine.prototype.afterResume_1 = AbstractCoroutine.prototype.afterResume_1;
  LazyStandaloneCoroutine.prototype.cancellationExceptionMessage_2 = AbstractCoroutine.prototype.cancellationExceptionMessage_2;
  LazyStandaloneCoroutine.prototype.handleJobException_2 = StandaloneCoroutine.prototype.handleJobException_2;
  LazyStandaloneCoroutine.prototype.onCancelled_1 = AbstractCoroutine.prototype.onCancelled_1;
  LazyStandaloneCoroutine.prototype.onCancelling_2 = JobSupport.prototype.onCancelling_2;
  LazyStandaloneCoroutine.prototype.onCompleted = AbstractCoroutine.prototype.onCompleted;
  LazyStandaloneCoroutine.prototype._get_isScopedCoroutine__2 = JobSupport.prototype._get_isScopedCoroutine__2;
  LazyStandaloneCoroutine.prototype.start_0 = AbstractCoroutine.prototype.start_0;
  LazyStandaloneCoroutine.prototype.getCancellationException_3 = JobSupport.prototype.getCancellationException_3;
  LazyStandaloneCoroutine.prototype.invokeOnCompletion_3 = JobSupport.prototype.invokeOnCompletion_3;
  LazyStandaloneCoroutine.prototype.invokeOnCompletion$default_3 = Job.prototype.invokeOnCompletion$default_3;
  LazyStandaloneCoroutine.prototype.parentCancelled_4 = JobSupport.prototype.parentCancelled_4;
  LazyStandaloneCoroutine.prototype.resumeWith_11 = AbstractCoroutine.prototype.resumeWith_11;
  LazyStandaloneCoroutine.prototype.start_7 = JobSupport.prototype.start_7;
  LazyStandaloneCoroutine.prototype._get_isCompleted__3 = JobSupport.prototype._get_isCompleted__3;
  LazyStandaloneCoroutine.prototype._get_key__20 = JobSupport.prototype._get_key__20;
  LazyStandaloneCoroutine.prototype.get_42 = Element_0.prototype.get_42;
  LazyStandaloneCoroutine.prototype.fold_17 = Element_0.prototype.fold_17;
  LazyStandaloneCoroutine.prototype.childCancelled_5 = JobSupport.prototype.childCancelled_5;
  LazyStandaloneCoroutine.prototype.getChildJobCancellationCause_3 = JobSupport.prototype.getChildJobCancellationCause_3;
  LazyStandaloneCoroutine.prototype.minusKey_18 = Element_0.prototype.minusKey_18;
  LazyStandaloneCoroutine.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  LazyStandaloneCoroutine.prototype.toString = JobSupport.prototype.toString;
  LazyStandaloneCoroutine.prototype._get_coroutineContext__3 = AbstractCoroutine.prototype._get_coroutineContext__3;
  LazyStandaloneCoroutine.prototype._get_isActive__15 = AbstractCoroutine.prototype._get_isActive__15;
  CancelHandlerBase.prototype.invoke = CancelHandlerBase.prototype.invoke;
  CancelHandler.prototype.invoke = CancelHandlerBase.prototype.invoke;
  BeforeResumeCancelHandler.prototype.invoke = CancelHandlerBase.prototype.invoke;
  SchedulerTask.prototype.run_3 = Runnable.prototype.run_3;
  DispatchedTask.prototype._get_delegate__1 = DispatchedTask.prototype._get_delegate__1;
  DispatchedTask.prototype.takeState_1 = DispatchedTask.prototype.takeState_1;
  CancellableContinuationImpl.prototype._get_resumeMode__0 = DispatchedTask.prototype._get_resumeMode__0;
  CancellableContinuationImpl.prototype.run_3 = DispatchedTask.prototype.run_3;
  CancellableContinuationImpl.prototype.handleFatalException_1 = DispatchedTask.prototype.handleFatalException_1;
  CancelledContinuation.prototype._get_cause__30 = CompletedExceptionally.prototype._get_cause__30;
  CancelledContinuation.prototype._get_handled__0 = CompletedExceptionally.prototype._get_handled__0;
  CancelledContinuation.prototype.makeHandled_0 = CompletedExceptionally.prototype.makeHandled_0;
  CancelledContinuation.prototype.toString = CompletedExceptionally.prototype.toString;
  CoroutineDispatcher.prototype.dispatch_8 = CoroutineDispatcher.prototype.dispatch_8;
  CoroutineDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  CoroutineDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  CoroutineDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  CoroutineDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  CoroutineDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  CoroutineStart.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  CoroutineStart.prototype.equals = Enum.prototype.equals;
  CoroutineStart.prototype.hashCode = Enum.prototype.hashCode;
  CoroutineStart.prototype.toString = Enum.prototype.toString;
  EventLoop.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  EventLoop.prototype.dispatch_8 = CoroutineDispatcher.prototype.dispatch_8;
  EventLoop.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  EventLoop.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  EventLoop.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  EventLoop.prototype.toString = CoroutineDispatcher.prototype.toString;
  EventLoop.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  EventLoop.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  EventLoop.prototype.fold_17 = Element_0.prototype.fold_17;
  EventLoop.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  LinkedListHead.prototype._get__next__2 = LinkedListNode.prototype._get__next__2;
  LinkedListHead.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  NodeList_0.prototype.remove_31 = LinkedListHead.prototype.remove_31;
  NodeList_0.prototype._get__next__2 = LinkedListNode.prototype._get__next__2;
  NodeList_0.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  CompletionHandlerBase.prototype.invoke = CompletionHandlerBase.prototype.invoke;
  CompletionHandlerBase.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  CompletionHandlerBase.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  JobNode.prototype.invoke = CompletionHandlerBase.prototype.invoke;
  JobNode.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  JobNode.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  JobNode.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  JobCancellingNode.prototype._get_isActive__15 = JobNode.prototype._get_isActive__15;
  JobCancellingNode.prototype._get_list__10 = JobNode.prototype._get_list__10;
  JobCancellingNode.prototype.dispose_10 = JobNode.prototype.dispose_10;
  JobCancellingNode.prototype.toString = JobNode.prototype.toString;
  JobCancellingNode.prototype.invoke = CompletionHandlerBase.prototype.invoke;
  JobCancellingNode.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  JobCancellingNode.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  JobCancellingNode.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  ChildHandleNode.prototype._get_job__1 = JobNode.prototype._get_job__1;
  ChildHandleNode.prototype._get_isActive__15 = JobNode.prototype._get_isActive__15;
  ChildHandleNode.prototype._get_list__10 = JobNode.prototype._get_list__10;
  ChildHandleNode.prototype.dispose_10 = JobNode.prototype.dispose_10;
  ChildHandleNode.prototype.toString = JobNode.prototype.toString;
  ChildHandleNode.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  ChildHandleNode.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  ChildHandleNode.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  InvokeOnCancelling.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  InvokeOnCancelling.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  InvokeOnCancelling.prototype.dispose_10 = JobNode.prototype.dispose_10;
  InvokeOnCancelling.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  InvokeOnCancelling.prototype.toString = JobNode.prototype.toString;
  InvokeOnCancelling.prototype._get_isActive__15 = JobNode.prototype._get_isActive__15;
  InvokeOnCancelling.prototype._get_list__10 = JobNode.prototype._get_list__10;
  InvokeOnCompletion.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  InvokeOnCompletion.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  InvokeOnCompletion.prototype.dispose_10 = JobNode.prototype.dispose_10;
  InvokeOnCompletion.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  InvokeOnCompletion.prototype.toString = JobNode.prototype.toString;
  InvokeOnCompletion.prototype._get_isActive__15 = JobNode.prototype._get_isActive__15;
  InvokeOnCompletion.prototype._get_list__10 = JobNode.prototype._get_list__10;
  ChildContinuation.prototype._get_job__1 = JobNode.prototype._get_job__1;
  ChildContinuation.prototype._get_isActive__15 = JobNode.prototype._get_isActive__15;
  ChildContinuation.prototype._get_list__10 = JobNode.prototype._get_list__10;
  ChildContinuation.prototype.dispose_10 = JobNode.prototype.dispose_10;
  ChildContinuation.prototype.toString = JobNode.prototype.toString;
  ChildContinuation.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  ChildContinuation.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  ChildContinuation.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  ChildCompletion.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  ChildCompletion.prototype.addOneIfEmpty_6 = LinkedListNode.prototype.addOneIfEmpty_6;
  ChildCompletion.prototype.dispose_10 = JobNode.prototype.dispose_10;
  ChildCompletion.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  ChildCompletion.prototype.toString = JobNode.prototype.toString;
  ChildCompletion.prototype._get_isActive__15 = JobNode.prototype._get_isActive__15;
  ChildCompletion.prototype._get_list__10 = JobNode.prototype._get_list__10;
  MainCoroutineDispatcher.prototype._get_immediate__0 = MainCoroutineDispatcher.prototype._get_immediate__0;
  MainCoroutineDispatcher.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  MainCoroutineDispatcher.prototype.dispatch_8 = CoroutineDispatcher.prototype.dispatch_8;
  MainCoroutineDispatcher.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  MainCoroutineDispatcher.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  MainCoroutineDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  MainCoroutineDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  MainCoroutineDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  MainCoroutineDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  MainCoroutineDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  Unconfined.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  Unconfined.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  Unconfined.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  Unconfined.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  Unconfined.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  Unconfined.prototype.fold_17 = Element_0.prototype.fold_17;
  Unconfined.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  OpDescriptor.prototype.perform_1 = OpDescriptor.prototype.perform_1;
  AtomicOp.prototype.prepare_1 = AtomicOp.prototype.prepare_1;
  AtomicOp.prototype.complete_2 = AtomicOp.prototype.complete_2;
  AtomicOp.prototype.toString = OpDescriptor.prototype.toString;
  DispatchedContinuation.prototype._set_resumeMode__0 = DispatchedTask.prototype._set_resumeMode__0;
  DispatchedContinuation.prototype.getSuccessfulResult_1 = DispatchedTask.prototype.getSuccessfulResult_1;
  DispatchedContinuation.prototype.getExceptionalResult_1 = DispatchedTask.prototype.getExceptionalResult_1;
  DispatchedContinuation.prototype.run_3 = DispatchedTask.prototype.run_3;
  DispatchedContinuation.prototype.handleFatalException_1 = DispatchedTask.prototype.handleFatalException_1;
  MutexImpl.prototype.unlock$default_0 = Mutex.prototype.unlock$default_0;
  LockedQueue.prototype._get__next__2 = LinkedListNode.prototype._get__next__2;
  LockedQueue.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  LockedQueue.prototype.remove_31 = LinkedListHead.prototype.remove_31;
  LockedQueue.prototype.removeFirstOrNull_4 = LinkedListNode.prototype.removeFirstOrNull_4;
  LockedQueue.prototype._get_isEmpty__4 = LinkedListHead.prototype._get_isEmpty__4;
  LockWaiter.prototype.tryResumeLockWaiter_0 = LockWaiter.prototype.tryResumeLockWaiter_0;
  LockWaiter.prototype.completeResumeLockWaiter_0 = LockWaiter.prototype.completeResumeLockWaiter_0;
  LockWaiter.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  LockWaiter.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  LockCont.prototype._get_owner__0 = LockWaiter.prototype._get_owner__0;
  LockCont.prototype.addLast_16 = LinkedListNode.prototype.addLast_16;
  LockCont.prototype.dispose_10 = LockWaiter.prototype.dispose_10;
  LockCont.prototype.remove_31 = LinkedListNode.prototype.remove_31;
  UnlockOp.prototype.perform_1 = AtomicOp.prototype.perform_1;
  UnlockOp.prototype.decide_0 = AtomicOp.prototype.decide_0;
  UnlockOp.prototype.toString = OpDescriptor.prototype.toString;
  JsMainDispatcher.prototype.toStringInternalImpl_0 = MainCoroutineDispatcher.prototype.toStringInternalImpl_0;
  JsMainDispatcher.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  JsMainDispatcher.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  JsMainDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  JsMainDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  JsMainDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  JsMainDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  JsMainDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  UnconfinedEventLoop.prototype.processUnconfinedEvent_0 = EventLoop.prototype.processUnconfinedEvent_0;
  UnconfinedEventLoop.prototype.dispatchUnconfined_0 = EventLoop.prototype.dispatchUnconfined_0;
  UnconfinedEventLoop.prototype._get_isUnconfinedLoopActive__0 = EventLoop.prototype._get_isUnconfinedLoopActive__0;
  UnconfinedEventLoop.prototype._get_isUnconfinedQueueEmpty__0 = EventLoop.prototype._get_isUnconfinedQueueEmpty__0;
  UnconfinedEventLoop.prototype.incrementUseCount_0 = EventLoop.prototype.incrementUseCount_0;
  UnconfinedEventLoop.prototype.decrementUseCount_0 = EventLoop.prototype.decrementUseCount_0;
  UnconfinedEventLoop.prototype.shutdown_0 = EventLoop.prototype.shutdown_0;
  UnconfinedEventLoop.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  UnconfinedEventLoop.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  UnconfinedEventLoop.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  UnconfinedEventLoop.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  UnconfinedEventLoop.prototype.toString = CoroutineDispatcher.prototype.toString;
  UnconfinedEventLoop.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  UnconfinedEventLoop.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  UnconfinedEventLoop.prototype.fold_17 = Element_0.prototype.fold_17;
  UnconfinedEventLoop.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  SetTimeoutBasedDispatcher.prototype.scheduleQueueProcessing_1 = SetTimeoutBasedDispatcher.prototype.scheduleQueueProcessing_1;
  SetTimeoutBasedDispatcher.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  SetTimeoutBasedDispatcher.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  SetTimeoutBasedDispatcher.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  SetTimeoutBasedDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  SetTimeoutBasedDispatcher.prototype.toString = CoroutineDispatcher.prototype.toString;
  SetTimeoutBasedDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  SetTimeoutBasedDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  SetTimeoutBasedDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  SetTimeoutBasedDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  NodeDispatcher.prototype._get_messageQueue__1 = SetTimeoutBasedDispatcher.prototype._get_messageQueue__1;
  NodeDispatcher.prototype.dispatch_8 = SetTimeoutBasedDispatcher.prototype.dispatch_8;
  NodeDispatcher.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  NodeDispatcher.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  NodeDispatcher.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  NodeDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  NodeDispatcher.prototype.toString = CoroutineDispatcher.prototype.toString;
  NodeDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  NodeDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  NodeDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  NodeDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  SetTimeoutDispatcher.prototype._get_messageQueue__1 = SetTimeoutBasedDispatcher.prototype._get_messageQueue__1;
  SetTimeoutDispatcher.prototype.dispatch_8 = SetTimeoutBasedDispatcher.prototype.dispatch_8;
  SetTimeoutDispatcher.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  SetTimeoutDispatcher.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  SetTimeoutDispatcher.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  SetTimeoutDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  SetTimeoutDispatcher.prototype.toString = CoroutineDispatcher.prototype.toString;
  SetTimeoutDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  SetTimeoutDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  SetTimeoutDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  SetTimeoutDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  MessageQueue.prototype.schedule_1 = MessageQueue.prototype.schedule_1;
  MessageQueue.prototype.reschedule_1 = MessageQueue.prototype.reschedule_1;
  MessageQueue.prototype._get_isEmpty__4 = ArrayQueue.prototype._get_isEmpty__4;
  MessageQueue.prototype.addLast_7 = ArrayQueue.prototype.addLast_7;
  MessageQueue.prototype.removeFirstOrNull_4 = ArrayQueue.prototype.removeFirstOrNull_4;
  WindowDispatcher.prototype.isDispatchNeeded_8 = CoroutineDispatcher.prototype.isDispatchNeeded_8;
  WindowDispatcher.prototype.interceptContinuation_9 = CoroutineDispatcher.prototype.interceptContinuation_9;
  WindowDispatcher.prototype.releaseInterceptedContinuation_9 = CoroutineDispatcher.prototype.releaseInterceptedContinuation_9;
  WindowDispatcher.prototype.plus_17 = CoroutineContext.prototype.plus_17;
  WindowDispatcher.prototype.toString = CoroutineDispatcher.prototype.toString;
  WindowDispatcher.prototype._get_key__20 = AbstractCoroutineContextElement.prototype._get_key__20;
  WindowDispatcher.prototype.get_42 = ContinuationInterceptor.prototype.get_42;
  WindowDispatcher.prototype.fold_17 = Element_0.prototype.fold_17;
  WindowDispatcher.prototype.minusKey_18 = ContinuationInterceptor.prototype.minusKey_18;
  WindowMessageQueue.prototype.removeFirstOrNull_4 = ArrayQueue.prototype.removeFirstOrNull_4;
  WindowMessageQueue.prototype.addLast_7 = ArrayQueue.prototype.addLast_7;
  WindowMessageQueue.prototype.enqueue_1 = MessageQueue.prototype.enqueue_1;
  WindowMessageQueue.prototype.process_1 = MessageQueue.prototype.process_1;
  WindowMessageQueue.prototype._get_isEmpty__4 = ArrayQueue.prototype._get_isEmpty__4;
  ScheduledMessageQueue.prototype.enqueue_1 = MessageQueue.prototype.enqueue_1;
  ScheduledMessageQueue.prototype.process_1 = MessageQueue.prototype.process_1;
  ScheduledMessageQueue.prototype._get_isEmpty__4 = ArrayQueue.prototype._get_isEmpty__4;
  ScheduledMessageQueue.prototype.addLast_7 = ArrayQueue.prototype.addLast_7;
  ScheduledMessageQueue.prototype.removeFirstOrNull_4 = ArrayQueue.prototype.removeFirstOrNull_4;
  GameScreenConfiguration.prototype.screen_1 = GameScreenConfiguration.prototype.screen_1;
  AnimatedComponent.prototype.onAdded_18 = Component.prototype.onAdded_18;
  AnimatedComponent.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  AnimatedComponent.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  AnimatedComponent.prototype.onDetach_18 = Component.prototype.onDetach_18;
  AnimatedComponent.prototype.onAttach_18 = Component.prototype.onAttach_18;
  CameraComponent.prototype.onAdded_18 = Component.prototype.onAdded_18;
  CameraComponent.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  CameraComponent.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  CameraComponent.prototype.onDetach_18 = Component.prototype.onDetach_18;
  CameraComponent.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Type.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  Type.prototype.equals = Enum.prototype.equals;
  Type.prototype.hashCode = Enum.prototype.hashCode;
  Type.prototype.toString = Enum.prototype.toString;
  LightComponent.prototype.onAdded_18 = Component.prototype.onAdded_18;
  LightComponent.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  LightComponent.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  LightComponent.prototype.onDetach_18 = Component.prototype.onDetach_18;
  LightComponent.prototype.onAttach_18 = Component.prototype.onAttach_18;
  ModelComponent.prototype.onAdded_18 = Component.prototype.onAdded_18;
  ModelComponent.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  ModelComponent.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  ModelComponent.prototype.onDetach_18 = Component.prototype.onDetach_18;
  ModelComponent.prototype.onAttach_18 = Component.prototype.onAttach_18;
  CoordinateConverter.prototype.convert_0 = CoordinateConverter.prototype.convert_0;
  TextComponent.prototype.onDetach_18 = Component.prototype.onDetach_18;
  TextComponent.prototype.onAttach_18 = Component.prototype.onAttach_18;
  HorizontalAlignment.prototype.getHorizontalOffset_0 = HorizontalAlignment.prototype.getHorizontalOffset_0;
  ParticleComponent.prototype.onAdded_18 = Component.prototype.onAdded_18;
  ParticleComponent.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  ParticleComponent.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  ParticleComponent.prototype.onDetach_18 = Component.prototype.onDetach_18;
  ParticleComponent.prototype.onAttach_18 = Component.prototype.onAttach_18;
  EntityFactoryDelegate.prototype.createFromNode$default_0 = EntityFactory.prototype.createFromNode$default_0;
  System.prototype.update_61 = System.prototype.update_61;
  EventQueue.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  EventQueue.prototype._get_input__25 = System.prototype._get_input__25;
  EventQueue.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  EventQueue.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  EventQueue.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  EventQueue.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  EventQueue.prototype.add_53 = System.prototype.add_53;
  EventQueue.prototype.remove_61 = System.prototype.remove_61;
  EventQueue.prototype.destroy_31 = System.prototype.destroy_31;
  EventQueue.prototype.onEvent_26 = System.prototype.onEvent_26;
  EventQueue.prototype.emit_56 = System.prototype.emit_56;
  EventQueue.prototype.emit$default_25 = System.prototype.emit$default_25;
  EventQueue.prototype.emit_16 = System.prototype.emit_16;
  EventQueue.prototype.emit_57 = System.prototype.emit_57;
  EventQueue.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  EventQueue.prototype.interested = System.prototype.interested;
  ObjectPool.prototype.newInstance_1 = ObjectPool.prototype.newInstance_1;
  ObjectPool.prototype.destroyInstance_3 = ObjectPool.prototype.destroyInstance_3;
  EventWithQueryObjectPool.prototype.obtain_0 = ObjectPool.prototype.obtain_0;
  EventWithQueryObjectPool.prototype.free_2 = ObjectPool.prototype.free_2;
  AABBCollisionResolver.prototype.collide_1 = CollisionResolver.prototype.collide_1;
  ArmatureUpdateSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ArmatureUpdateSystem.prototype._get_input__25 = System.prototype._get_input__25;
  ArmatureUpdateSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ArmatureUpdateSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ArmatureUpdateSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ArmatureUpdateSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ArmatureUpdateSystem.prototype.update_62 = System.prototype.update_62;
  ArmatureUpdateSystem.prototype.add_53 = System.prototype.add_53;
  ArmatureUpdateSystem.prototype.remove_61 = System.prototype.remove_61;
  ArmatureUpdateSystem.prototype.destroy_31 = System.prototype.destroy_31;
  ArmatureUpdateSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  ArmatureUpdateSystem.prototype.emit_56 = System.prototype.emit_56;
  ArmatureUpdateSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  ArmatureUpdateSystem.prototype.emit_57 = System.prototype.emit_57;
  ArmatureUpdateSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ArmatureUpdateSystem.prototype.interested = System.prototype.interested;
  CameraTrackSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  CameraTrackSystem.prototype._get_input__25 = System.prototype._get_input__25;
  CameraTrackSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  CameraTrackSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  CameraTrackSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  CameraTrackSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  CameraTrackSystem.prototype.update_62 = System.prototype.update_62;
  CameraTrackSystem.prototype.add_53 = System.prototype.add_53;
  CameraTrackSystem.prototype.remove_61 = System.prototype.remove_61;
  CameraTrackSystem.prototype.destroy_31 = System.prototype.destroy_31;
  CameraTrackSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  CameraTrackSystem.prototype.emit_56 = System.prototype.emit_56;
  CameraTrackSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  CameraTrackSystem.prototype.emit_57 = System.prototype.emit_57;
  CameraTrackSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  CameraTrackSystem.prototype.interested = System.prototype.interested;
  ParticlesEmitterSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ParticlesEmitterSystem.prototype._get_input__25 = System.prototype._get_input__25;
  ParticlesEmitterSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ParticlesEmitterSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ParticlesEmitterSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ParticlesEmitterSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ParticlesEmitterSystem.prototype.update_62 = System.prototype.update_62;
  ParticlesEmitterSystem.prototype.add_53 = System.prototype.add_53;
  ParticlesEmitterSystem.prototype.remove_61 = System.prototype.remove_61;
  ParticlesEmitterSystem.prototype.destroy_31 = System.prototype.destroy_31;
  ParticlesEmitterSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  ParticlesEmitterSystem.prototype.emit_56 = System.prototype.emit_56;
  ParticlesEmitterSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  ParticlesEmitterSystem.prototype.emit_57 = System.prototype.emit_57;
  ParticlesEmitterSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ParticlesEmitterSystem.prototype.interested = System.prototype.interested;
  ParticlesUpdateSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ParticlesUpdateSystem.prototype._get_input__25 = System.prototype._get_input__25;
  ParticlesUpdateSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ParticlesUpdateSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ParticlesUpdateSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ParticlesUpdateSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ParticlesUpdateSystem.prototype.update_62 = System.prototype.update_62;
  ParticlesUpdateSystem.prototype.add_53 = System.prototype.add_53;
  ParticlesUpdateSystem.prototype.remove_61 = System.prototype.remove_61;
  ParticlesUpdateSystem.prototype.destroy_31 = System.prototype.destroy_31;
  ParticlesUpdateSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  ParticlesUpdateSystem.prototype.emit_56 = System.prototype.emit_56;
  ParticlesUpdateSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  ParticlesUpdateSystem.prototype.emit_57 = System.prototype.emit_57;
  ParticlesUpdateSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ParticlesUpdateSystem.prototype.interested = System.prototype.interested;
  ScriptExecutorSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ScriptExecutorSystem.prototype._get_input__25 = System.prototype._get_input__25;
  ScriptExecutorSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ScriptExecutorSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ScriptExecutorSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ScriptExecutorSystem.prototype.add_53 = System.prototype.add_53;
  ScriptExecutorSystem.prototype.remove_61 = System.prototype.remove_61;
  ScriptExecutorSystem.prototype.destroy_31 = System.prototype.destroy_31;
  ScriptExecutorSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  ScriptExecutorSystem.prototype.emit_56 = System.prototype.emit_56;
  ScriptExecutorSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  ScriptExecutorSystem.prototype.emit_57 = System.prototype.emit_57;
  ScriptExecutorSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ScriptExecutorSystem.prototype.interested = System.prototype.interested;
  _no_name_provided__107.prototype._get_context__9 = CoroutineImpl_0.prototype._get_context__9;
  _no_name_provided__107.prototype.intercepted_1 = CoroutineImpl_0.prototype.intercepted_1;
  _no_name_provided__107.prototype.resumeWith_12 = CoroutineImpl_0.prototype.resumeWith_12;
  SpriteAnimatedSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  SpriteAnimatedSystem.prototype._get_input__25 = System.prototype._get_input__25;
  SpriteAnimatedSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  SpriteAnimatedSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  SpriteAnimatedSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  SpriteAnimatedSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  SpriteAnimatedSystem.prototype.update_62 = System.prototype.update_62;
  SpriteAnimatedSystem.prototype.add_53 = System.prototype.add_53;
  SpriteAnimatedSystem.prototype.remove_61 = System.prototype.remove_61;
  SpriteAnimatedSystem.prototype.destroy_31 = System.prototype.destroy_31;
  SpriteAnimatedSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  SpriteAnimatedSystem.prototype.emit_56 = System.prototype.emit_56;
  SpriteAnimatedSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  SpriteAnimatedSystem.prototype.emit_57 = System.prototype.emit_57;
  SpriteAnimatedSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  SpriteAnimatedSystem.prototype.interested = System.prototype.interested;
  TemporalSystem.prototype.timeElapsed_2 = TemporalSystem.prototype.timeElapsed_2;
  TemporalSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  TemporalSystem.prototype._get_input__25 = System.prototype._get_input__25;
  TemporalSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  TemporalSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  TemporalSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  TemporalSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  TemporalSystem.prototype.update_61 = System.prototype.update_61;
  TemporalSystem.prototype.add_53 = System.prototype.add_53;
  TemporalSystem.prototype.remove_61 = System.prototype.remove_61;
  TemporalSystem.prototype.destroy_31 = System.prototype.destroy_31;
  TemporalSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  TemporalSystem.prototype.emit_56 = System.prototype.emit_56;
  TemporalSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  TemporalSystem.prototype.emit_57 = System.prototype.emit_57;
  TemporalSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  TemporalSystem.prototype.interested = System.prototype.interested;
  TextEffectSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  TextEffectSystem.prototype._get_input__25 = System.prototype._get_input__25;
  TextEffectSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  TextEffectSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  TextEffectSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  TextEffectSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  TextEffectSystem.prototype.update_62 = System.prototype.update_62;
  TextEffectSystem.prototype.add_53 = System.prototype.add_53;
  TextEffectSystem.prototype.remove_61 = System.prototype.remove_61;
  TextEffectSystem.prototype.destroy_31 = System.prototype.destroy_31;
  TextEffectSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  TextEffectSystem.prototype.emit_56 = System.prototype.emit_56;
  TextEffectSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  TextEffectSystem.prototype.emit_57 = System.prototype.emit_57;
  TextEffectSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  TextEffectSystem.prototype.interested = System.prototype.interested;
  AssetsManagerSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  AssetsManagerSystem.prototype._get_input__25 = System.prototype._get_input__25;
  AssetsManagerSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  AssetsManagerSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  AssetsManagerSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  AssetsManagerSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  AssetsManagerSystem.prototype.add_53 = System.prototype.add_53;
  AssetsManagerSystem.prototype.remove_61 = System.prototype.remove_61;
  AssetsManagerSystem.prototype.destroy_31 = System.prototype.destroy_31;
  AssetsManagerSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  AssetsManagerSystem.prototype.emit_56 = System.prototype.emit_56;
  AssetsManagerSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  AssetsManagerSystem.prototype.emit_57 = System.prototype.emit_57;
  AssetsManagerSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  AssetsManagerSystem.prototype.interested = System.prototype.interested;
  DrawingType.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  DrawingType.prototype.equals = Enum.prototype.equals;
  DrawingType.prototype.hashCode = Enum.prototype.hashCode;
  DrawingType.prototype.toString = Enum.prototype.toString;
  StageWithSystem.prototype.compileShaders_6 = Stage.prototype.compileShaders_6;
  StageWithSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  StageWithSystem.prototype._get_input__25 = System.prototype._get_input__25;
  StageWithSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  StageWithSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  StageWithSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  StageWithSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  StageWithSystem.prototype.update_61 = System.prototype.update_61;
  StageWithSystem.prototype.update_62 = System.prototype.update_62;
  StageWithSystem.prototype.add_53 = System.prototype.add_53;
  StageWithSystem.prototype.remove_61 = System.prototype.remove_61;
  StageWithSystem.prototype.destroy_31 = System.prototype.destroy_31;
  StageWithSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  StageWithSystem.prototype.emit_56 = System.prototype.emit_56;
  StageWithSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  StageWithSystem.prototype.emit_57 = System.prototype.emit_57;
  StageWithSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  StageWithSystem.prototype.interested = System.prototype.interested;
  RenderStage.prototype.update_61 = RenderStage.prototype.update_61;
  RenderStage.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  RenderStage.prototype._get_input__25 = System.prototype._get_input__25;
  RenderStage.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  RenderStage.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  RenderStage.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  RenderStage.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  RenderStage.prototype.add_53 = System.prototype.add_53;
  RenderStage.prototype.remove_61 = System.prototype.remove_61;
  RenderStage.prototype.destroy_31 = System.prototype.destroy_31;
  RenderStage.prototype.onEvent_26 = System.prototype.onEvent_26;
  RenderStage.prototype.emit_56 = System.prototype.emit_56;
  RenderStage.prototype.emit$default_25 = System.prototype.emit$default_25;
  RenderStage.prototype.emit_57 = System.prototype.emit_57;
  RenderStage.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  RenderStage.prototype.interested = System.prototype.interested;
  ImGUIRenderStage.prototype._get_vertex__3 = RenderStage.prototype._get_vertex__3;
  ImGUIRenderStage.prototype._get_fragment__2 = RenderStage.prototype._get_fragment__2;
  ImGUIRenderStage.prototype._get_gl__4 = RenderStage.prototype._get_gl__4;
  ImGUIRenderStage.prototype._get_camera__5 = RenderStage.prototype._get_camera__5;
  ImGUIRenderStage.prototype._get_program__5 = RenderStage.prototype._get_program__5;
  ImGUIRenderStage.prototype._get__program__4 = RenderStage.prototype._get__program__4;
  ImGUIRenderStage.prototype.compileShaders_6 = RenderStage.prototype.compileShaders_6;
  ImGUIRenderStage.prototype.uniforms_4 = RenderStage.prototype.uniforms_4;
  ImGUIRenderStage.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ImGUIRenderStage.prototype._get_input__25 = System.prototype._get_input__25;
  ImGUIRenderStage.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ImGUIRenderStage.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ImGUIRenderStage.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ImGUIRenderStage.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ImGUIRenderStage.prototype.add_53 = System.prototype.add_53;
  ImGUIRenderStage.prototype.remove_61 = System.prototype.remove_61;
  ImGUIRenderStage.prototype.destroy_31 = System.prototype.destroy_31;
  ImGUIRenderStage.prototype.emit_56 = System.prototype.emit_56;
  ImGUIRenderStage.prototype.emit$default_25 = System.prototype.emit$default_25;
  ImGUIRenderStage.prototype.emit_57 = System.prototype.emit_57;
  ImGUIRenderStage.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ImGUIRenderStage.prototype.interested = System.prototype.interested;
  Key_4.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  Key_4.prototype.equals = Enum.prototype.equals;
  Key_4.prototype.hashCode = Enum.prototype.hashCode;
  Key_4.prototype.toString = Enum.prototype.toString;
  TouchSignal.prototype._get_ordinal__1 = Enum.prototype._get_ordinal__1;
  TouchSignal.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  TouchSignal.prototype.equals = Enum.prototype.equals;
  TouchSignal.prototype.hashCode = Enum.prototype.hashCode;
  TouchSignal.prototype.toString = Enum.prototype.toString;
  InternalTouchEventObjectPool.prototype.free_2 = ObjectPool.prototype.free_2;
  InternalTouchEventObjectPool.prototype.free_3 = ObjectPool.prototype.free_3;
  InternalTouchEventWay.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  InternalTouchEventWay.prototype.equals = Enum.prototype.equals;
  InternalTouchEventWay.prototype.hashCode = Enum.prototype.hashCode;
  InternalTouchEventWay.prototype.toString = Enum.prototype.toString;
  LogLevel.prototype._get_ordinal__1 = Enum.prototype._get_ordinal__1;
  LogLevel.prototype.compareTo_6 = Enum.prototype.compareTo_6;
  LogLevel.prototype.equals = Enum.prototype.equals;
  LogLevel.prototype.hashCode = Enum.prototype.hashCode;
  LogLevel.prototype.toString = Enum.prototype.toString;
  PowInterpolation.prototype.interpolate_6 = Interpolation.prototype.interpolate_6;
  ElasticInterpolation.prototype.interpolate_6 = Interpolation.prototype.interpolate_6;
  LinearInterpolation.prototype.interpolate_6 = Interpolation.prototype.interpolate_6;
  AnimatedModelRenderStage.prototype._get_vertex__3 = RenderStage.prototype._get_vertex__3;
  AnimatedModelRenderStage.prototype._get_fragment__2 = RenderStage.prototype._get_fragment__2;
  AnimatedModelRenderStage.prototype._get_gl__4 = RenderStage.prototype._get_gl__4;
  AnimatedModelRenderStage.prototype._get_camera__5 = RenderStage.prototype._get_camera__5;
  AnimatedModelRenderStage.prototype._get_light__2 = RenderStage.prototype._get_light__2;
  AnimatedModelRenderStage.prototype._get_program__5 = RenderStage.prototype._get_program__5;
  AnimatedModelRenderStage.prototype._get__program__4 = RenderStage.prototype._get__program__4;
  AnimatedModelRenderStage.prototype._get_combinedMatrix__2 = RenderStage.prototype._get_combinedMatrix__2;
  AnimatedModelRenderStage.prototype.compileShaders_6 = RenderStage.prototype.compileShaders_6;
  AnimatedModelRenderStage.prototype.uniforms_4 = RenderStage.prototype.uniforms_4;
  AnimatedModelRenderStage.prototype.update_62 = RenderStage.prototype.update_62;
  AnimatedModelRenderStage.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  AnimatedModelRenderStage.prototype._get_input__25 = System.prototype._get_input__25;
  AnimatedModelRenderStage.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  AnimatedModelRenderStage.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  AnimatedModelRenderStage.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  AnimatedModelRenderStage.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  AnimatedModelRenderStage.prototype.add_53 = System.prototype.add_53;
  AnimatedModelRenderStage.prototype.remove_61 = System.prototype.remove_61;
  AnimatedModelRenderStage.prototype.destroy_31 = System.prototype.destroy_31;
  AnimatedModelRenderStage.prototype.onEvent_26 = System.prototype.onEvent_26;
  AnimatedModelRenderStage.prototype.emit_56 = System.prototype.emit_56;
  AnimatedModelRenderStage.prototype.emit$default_25 = System.prototype.emit$default_25;
  AnimatedModelRenderStage.prototype.emit_57 = System.prototype.emit_57;
  AnimatedModelRenderStage.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  AnimatedModelRenderStage.prototype.interested = System.prototype.interested;
  BoundingBoxRenderStage.prototype._get_vertex__3 = RenderStage.prototype._get_vertex__3;
  BoundingBoxRenderStage.prototype._get_gl__4 = RenderStage.prototype._get_gl__4;
  BoundingBoxRenderStage.prototype._get_camera__5 = RenderStage.prototype._get_camera__5;
  BoundingBoxRenderStage.prototype._get_program__5 = RenderStage.prototype._get_program__5;
  BoundingBoxRenderStage.prototype._get__program__4 = RenderStage.prototype._get__program__4;
  BoundingBoxRenderStage.prototype._get_combinedMatrix__2 = RenderStage.prototype._get_combinedMatrix__2;
  BoundingBoxRenderStage.prototype.compileShaders_6 = RenderStage.prototype.compileShaders_6;
  BoundingBoxRenderStage.prototype.uniforms_4 = RenderStage.prototype.uniforms_4;
  BoundingBoxRenderStage.prototype.update_62 = RenderStage.prototype.update_62;
  BoundingBoxRenderStage.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  BoundingBoxRenderStage.prototype._get_input__25 = System.prototype._get_input__25;
  BoundingBoxRenderStage.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  BoundingBoxRenderStage.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  BoundingBoxRenderStage.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  BoundingBoxRenderStage.prototype.add_53 = System.prototype.add_53;
  BoundingBoxRenderStage.prototype.remove_61 = System.prototype.remove_61;
  BoundingBoxRenderStage.prototype.destroy_31 = System.prototype.destroy_31;
  BoundingBoxRenderStage.prototype.onEvent_26 = System.prototype.onEvent_26;
  BoundingBoxRenderStage.prototype.emit_56 = System.prototype.emit_56;
  BoundingBoxRenderStage.prototype.emit$default_25 = System.prototype.emit$default_25;
  BoundingBoxRenderStage.prototype.emit_57 = System.prototype.emit_57;
  BoundingBoxRenderStage.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  BoundingBoxRenderStage.prototype.interested = System.prototype.interested;
  ClearBufferRenderStage.prototype._get_gl__4 = RenderStage.prototype._get_gl__4;
  ClearBufferRenderStage.prototype._get_camera__5 = RenderStage.prototype._get_camera__5;
  ClearBufferRenderStage.prototype._get_program__5 = RenderStage.prototype._get_program__5;
  ClearBufferRenderStage.prototype._get__program__4 = RenderStage.prototype._get__program__4;
  ClearBufferRenderStage.prototype.uniforms_4 = RenderStage.prototype.uniforms_4;
  ClearBufferRenderStage.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ClearBufferRenderStage.prototype._get_input__25 = System.prototype._get_input__25;
  ClearBufferRenderStage.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ClearBufferRenderStage.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ClearBufferRenderStage.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ClearBufferRenderStage.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ClearBufferRenderStage.prototype.add_53 = System.prototype.add_53;
  ClearBufferRenderStage.prototype.remove_61 = System.prototype.remove_61;
  ClearBufferRenderStage.prototype.destroy_31 = System.prototype.destroy_31;
  ClearBufferRenderStage.prototype.onEvent_26 = System.prototype.onEvent_26;
  ClearBufferRenderStage.prototype.emit_56 = System.prototype.emit_56;
  ClearBufferRenderStage.prototype.emit$default_25 = System.prototype.emit$default_25;
  ClearBufferRenderStage.prototype.emit_57 = System.prototype.emit_57;
  ClearBufferRenderStage.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ClearBufferRenderStage.prototype.interested = System.prototype.interested;
  EmptyVertexShader.prototype._get_parameters__7 = VertexShader.prototype._get_parameters__7;
  EmptyVertexShader.prototype.toString = VertexShader.prototype.toString;
  EmptyFragmentShader.prototype._get_parameters__7 = FragmentShader.prototype._get_parameters__7;
  EmptyFragmentShader.prototype.toString = FragmentShader.prototype.toString;
  ModelComponentRenderStage.prototype._get_vertex__3 = RenderStage.prototype._get_vertex__3;
  ModelComponentRenderStage.prototype._get_fragment__2 = RenderStage.prototype._get_fragment__2;
  ModelComponentRenderStage.prototype._get_gl__4 = RenderStage.prototype._get_gl__4;
  ModelComponentRenderStage.prototype._get_camera__5 = RenderStage.prototype._get_camera__5;
  ModelComponentRenderStage.prototype._get_light__2 = RenderStage.prototype._get_light__2;
  ModelComponentRenderStage.prototype._get_program__5 = RenderStage.prototype._get_program__5;
  ModelComponentRenderStage.prototype._get__program__4 = RenderStage.prototype._get__program__4;
  ModelComponentRenderStage.prototype._get_combinedMatrix__2 = RenderStage.prototype._get_combinedMatrix__2;
  ModelComponentRenderStage.prototype.compileShaders_6 = RenderStage.prototype.compileShaders_6;
  ModelComponentRenderStage.prototype.uniforms_4 = RenderStage.prototype.uniforms_4;
  ModelComponentRenderStage.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ModelComponentRenderStage.prototype._get_input__25 = System.prototype._get_input__25;
  ModelComponentRenderStage.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ModelComponentRenderStage.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ModelComponentRenderStage.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ModelComponentRenderStage.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ModelComponentRenderStage.prototype.add_53 = System.prototype.add_53;
  ModelComponentRenderStage.prototype.remove_61 = System.prototype.remove_61;
  ModelComponentRenderStage.prototype.destroy_31 = System.prototype.destroy_31;
  ModelComponentRenderStage.prototype.onEvent_26 = System.prototype.onEvent_26;
  ModelComponentRenderStage.prototype.emit_56 = System.prototype.emit_56;
  ModelComponentRenderStage.prototype.emit$default_25 = System.prototype.emit$default_25;
  ModelComponentRenderStage.prototype.emit_57 = System.prototype.emit_57;
  ModelComponentRenderStage.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ModelComponentRenderStage.prototype.interested = System.prototype.interested;
  ShaderParameter.prototype.create_14 = ShaderParameter.prototype.create_14;
  UniformMat4.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  UniformArrayMat4.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  UniformVec3.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  UniformVec4.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  UniformFloat.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  AttributeVec2.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  AttributeVec3.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  AttributeVec4.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  UniformSample2D.prototype._get_name__24 = ShaderParameter.prototype._get_name__24;
  ColorFragmentShader.prototype._get_parameters__7 = FragmentShader.prototype._get_parameters__7;
  ColorFragmentShader.prototype.toString = FragmentShader.prototype.toString;
  UVFragmentShader.prototype.toString = FragmentShader.prototype.toString;
  AnimatedMeshVertexShader.prototype.toString = VertexShader.prototype.toString;
  BoundingBoxVertexShader.prototype.toString = VertexShader.prototype.toString;
  MeshVertexShader.prototype.toString = VertexShader.prototype.toString;
  WebGL.prototype.getProgramParameterB_1 = GL.prototype.getProgramParameterB_1;
  WebGL.prototype.getShaderParameterB_1 = GL.prototype.getShaderParameterB_1;
  WebGL.prototype.uniformMatrix4fv_5 = GL.prototype.uniformMatrix4fv_5;
  Chrono.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Chrono.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Chrono.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Chrono.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Chrono.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Score.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Score.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Score.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Score.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Score.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Player.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Player.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Player.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Player.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Player.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Enemy.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Enemy.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Enemy.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Enemy.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Enemy.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Dying.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Dying.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Dying.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Dying.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Dying.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Hit.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Hit.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Hit.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Hit.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Hit.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Spawn.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Spawn.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Spawn.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Spawn.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Spawn.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Start.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Start.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Start.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Start.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Start.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Left_0.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Left_0.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Left_0.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Left_0.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Left_0.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Right.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Right.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Right.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Right.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Right.prototype.onAttach_18 = Component.prototype.onAttach_18;
  Track.prototype.onAdded_18 = Component.prototype.onAdded_18;
  Track.prototype.onRemoved_18 = Component.prototype.onRemoved_18;
  Track.prototype.onComponentUpdated_18 = Component.prototype.onComponentUpdated_18;
  Track.prototype.onDetach_18 = Component.prototype.onDetach_18;
  Track.prototype.onAttach_18 = Component.prototype.onAttach_18;
  ScoreSystem.prototype._get_entities__3 = System.prototype._get_entities__3;
  ScoreSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ScoreSystem.prototype._get_input__25 = System.prototype._get_input__25;
  ScoreSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ScoreSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ScoreSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ScoreSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ScoreSystem.prototype.update_62 = System.prototype.update_62;
  ScoreSystem.prototype.add_53 = System.prototype.add_53;
  ScoreSystem.prototype.remove_61 = System.prototype.remove_61;
  ScoreSystem.prototype.destroy_31 = System.prototype.destroy_31;
  ScoreSystem.prototype.emit_56 = System.prototype.emit_56;
  ScoreSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  ScoreSystem.prototype.emit_57 = System.prototype.emit_57;
  ScoreSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ScoreSystem.prototype.interested = System.prototype.interested;
  TrackSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  TrackSystem.prototype._get_input__25 = System.prototype._get_input__25;
  TrackSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  TrackSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  TrackSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  TrackSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  TrackSystem.prototype.update_62 = System.prototype.update_62;
  TrackSystem.prototype.add_53 = System.prototype.add_53;
  TrackSystem.prototype.remove_61 = System.prototype.remove_61;
  TrackSystem.prototype.destroy_31 = System.prototype.destroy_31;
  TrackSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  TrackSystem.prototype.emit_56 = System.prototype.emit_56;
  TrackSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  TrackSystem.prototype.emit_57 = System.prototype.emit_57;
  TrackSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  TrackSystem.prototype.interested = System.prototype.interested;
  EnemySpawner.prototype.update_62 = TemporalSystem.prototype.update_62;
  EnemySpawner.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  EnemySpawner.prototype._get_input__25 = System.prototype._get_input__25;
  EnemySpawner.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  EnemySpawner.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  EnemySpawner.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  EnemySpawner.prototype.add_53 = System.prototype.add_53;
  EnemySpawner.prototype.remove_61 = System.prototype.remove_61;
  EnemySpawner.prototype.destroy_31 = System.prototype.destroy_31;
  EnemySpawner.prototype.onEvent_26 = System.prototype.onEvent_26;
  EnemySpawner.prototype.emit_56 = System.prototype.emit_56;
  EnemySpawner.prototype.emit$default_25 = System.prototype.emit$default_25;
  EnemySpawner.prototype.emit_57 = System.prototype.emit_57;
  EnemySpawner.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  EnemySpawner.prototype.interested = System.prototype.interested;
  EnemyMove.prototype._get_entities__3 = System.prototype._get_entities__3;
  EnemyMove.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  EnemyMove.prototype._get_input__25 = System.prototype._get_input__25;
  EnemyMove.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  EnemyMove.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  EnemyMove.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  EnemyMove.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  EnemyMove.prototype.update_62 = System.prototype.update_62;
  EnemyMove.prototype.add_53 = System.prototype.add_53;
  EnemyMove.prototype.remove_61 = System.prototype.remove_61;
  EnemyMove.prototype.destroy_31 = System.prototype.destroy_31;
  EnemyMove.prototype.emit_56 = System.prototype.emit_56;
  EnemyMove.prototype.emit$default_25 = System.prototype.emit$default_25;
  EnemyMove.prototype.emit_57 = System.prototype.emit_57;
  EnemyMove.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  EnemyMove.prototype.interested = System.prototype.interested;
  EnemyDying.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  EnemyDying.prototype._get_input__25 = System.prototype._get_input__25;
  EnemyDying.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  EnemyDying.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  EnemyDying.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  EnemyDying.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  EnemyDying.prototype.update_62 = System.prototype.update_62;
  EnemyDying.prototype.add_53 = System.prototype.add_53;
  EnemyDying.prototype.remove_61 = System.prototype.remove_61;
  EnemyDying.prototype.destroy_31 = System.prototype.destroy_31;
  EnemyDying.prototype.onEvent_26 = System.prototype.onEvent_26;
  EnemyDying.prototype.emit_56 = System.prototype.emit_56;
  EnemyDying.prototype.emit$default_25 = System.prototype.emit$default_25;
  EnemyDying.prototype.emit_57 = System.prototype.emit_57;
  EnemyDying.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  EnemyDying.prototype.interested = System.prototype.interested;
  PlayerSystem.prototype._get_entities__3 = System.prototype._get_entities__3;
  PlayerSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  PlayerSystem.prototype._get_input__25 = System.prototype._get_input__25;
  PlayerSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  PlayerSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  PlayerSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  PlayerSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  PlayerSystem.prototype.update_62 = System.prototype.update_62;
  PlayerSystem.prototype.add_53 = System.prototype.add_53;
  PlayerSystem.prototype.remove_61 = System.prototype.remove_61;
  PlayerSystem.prototype.destroy_31 = System.prototype.destroy_31;
  PlayerSystem.prototype.emit_56 = System.prototype.emit_56;
  PlayerSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  PlayerSystem.prototype.emit_57 = System.prototype.emit_57;
  PlayerSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  PlayerSystem.prototype.interested = System.prototype.interested;
  MyGame.prototype._get_clearColor__1 = Game.prototype._get_clearColor__1;
  MyGame.prototype.createDefaultSystems_1 = Game.prototype.createDefaultSystems_1;
  MyGame.prototype.createPostRenderSystem_1 = Game.prototype.createPostRenderSystem_1;
  MyGame.prototype.createFrameBuffers_1 = Game.prototype.createFrameBuffers_1;
  MyGame.prototype.createRenderStage_1 = Game.prototype.createRenderStage_1;
  MyGame.prototype.createDebugRenderStage_1 = Game.prototype.createDebugRenderStage_1;
  MyGame.prototype.render_5 = Game.prototype.render_5;
  MyGame.prototype.destroy_32 = Game.prototype.destroy_32;
  ChronoSystem.prototype.update_62 = TemporalSystem.prototype.update_62;
  ChronoSystem.prototype._get_entities__3 = System.prototype._get_entities__3;
  ChronoSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  ChronoSystem.prototype._get_input__25 = System.prototype._get_input__25;
  ChronoSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  ChronoSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  ChronoSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  ChronoSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  ChronoSystem.prototype.add_53 = System.prototype.add_53;
  ChronoSystem.prototype.remove_61 = System.prototype.remove_61;
  ChronoSystem.prototype.destroy_31 = System.prototype.destroy_31;
  ChronoSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  ChronoSystem.prototype.emit_56 = System.prototype.emit_56;
  ChronoSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  ChronoSystem.prototype.emit_54 = System.prototype.emit_54;
  ChronoSystem.prototype.emit_57 = System.prototype.emit_57;
  ChronoSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  ChronoSystem.prototype.interested = System.prototype.interested;
  StartGameSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  StartGameSystem.prototype._get_input__25 = System.prototype._get_input__25;
  StartGameSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  StartGameSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  StartGameSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  StartGameSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  StartGameSystem.prototype.add_53 = System.prototype.add_53;
  StartGameSystem.prototype.remove_61 = System.prototype.remove_61;
  StartGameSystem.prototype.destroy_31 = System.prototype.destroy_31;
  StartGameSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  StartGameSystem.prototype.emit_56 = System.prototype.emit_56;
  StartGameSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  StartGameSystem.prototype.emit_54 = System.prototype.emit_54;
  StartGameSystem.prototype.emit_57 = System.prototype.emit_57;
  StartGameSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  StartGameSystem.prototype.interested = System.prototype.interested;
  BlinkingSystem.prototype.update_62 = TemporalSystem.prototype.update_62;
  BlinkingSystem.prototype._get_entityFactory__25 = System.prototype._get_entityFactory__25;
  BlinkingSystem.prototype._get_input__25 = System.prototype._get_input__25;
  BlinkingSystem.prototype._get_gameContext__32 = System.prototype._get_gameContext__32;
  BlinkingSystem.prototype.onGameStarted_25 = System.prototype.onGameStarted_25;
  BlinkingSystem.prototype.onEntityAdded_25 = System.prototype.onEntityAdded_25;
  BlinkingSystem.prototype.onEntityRemoved_25 = System.prototype.onEntityRemoved_25;
  BlinkingSystem.prototype.add_53 = System.prototype.add_53;
  BlinkingSystem.prototype.remove_61 = System.prototype.remove_61;
  BlinkingSystem.prototype.destroy_31 = System.prototype.destroy_31;
  BlinkingSystem.prototype.onEvent_26 = System.prototype.onEvent_26;
  BlinkingSystem.prototype.emit_56 = System.prototype.emit_56;
  BlinkingSystem.prototype.emit$default_25 = System.prototype.emit$default_25;
  BlinkingSystem.prototype.emit_57 = System.prototype.emit_57;
  BlinkingSystem.prototype.consumeEvents_25 = System.prototype.consumeEvents_25;
  BlinkingSystem.prototype.interested = System.prototype.interested;
  Title.prototype._get_clearColor__1 = Game.prototype._get_clearColor__1;
  Title.prototype.createDefaultSystems_1 = Game.prototype.createDefaultSystems_1;
  Title.prototype.createPostRenderSystem_1 = Game.prototype.createPostRenderSystem_1;
  Title.prototype.createFrameBuffers_1 = Game.prototype.createFrameBuffers_1;
  Title.prototype.createRenderStage_1 = Game.prototype.createRenderStage_1;
  Title.prototype.createDebugRenderStage_1 = Game.prototype.createDebugRenderStage_1;
  Title.prototype.render_5 = Game.prototype.render_5;
  Title.prototype.destroy_32 = Game.prototype.destroy_32;
  _stableSortingIsSupported = null;
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufFloat32 = bufFloat32$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  propertyRefClassMetadataCache = propertyRefClassMetadataCache$init$();
  EMPTY_DESCRIPTOR_ARRAY = EMPTY_DESCRIPTOR_ARRAY$init$();
  EMPTY_SERIALIZER_ARRAY = EMPTY_SERIALIZER_ARRAY$init$();
  BUILTIN_SERIALIZERS = mapOf([to(PrimitiveClasses_getInstance()._get_stringClass_(), serializer_1(StringCompanionObject_getInstance())), to(getKClass_0(Char), serializer_2(Companion_getInstance_8())), to(PrimitiveClasses_getInstance()._get_charArrayClass_(), CharArraySerializer()), to(PrimitiveClasses_getInstance()._get_doubleClass_(), serializer_3(DoubleCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_doubleArrayClass_(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance()._get_floatClass_(), serializer_4(FloatCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_floatArrayClass_(), FloatArraySerializer()), to(getKClass_0(Long), serializer_5(Companion_getInstance_9())), to(PrimitiveClasses_getInstance()._get_longArrayClass_(), LongArraySerializer()), to(PrimitiveClasses_getInstance()._get_intClass_(), serializer_6(IntCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_intArrayClass_(), IntArraySerializer()), to(PrimitiveClasses_getInstance()._get_shortClass_(), serializer_7(ShortCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_shortArrayClass_(), ShortArraySerializer()), to(PrimitiveClasses_getInstance()._get_byteClass_(), serializer_8(ByteCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_byteArrayClass_(), ByteArraySerializer()), to(PrimitiveClasses_getInstance()._get_booleanClass_(), serializer_9(BooleanCompanionObject_getInstance())), to(PrimitiveClasses_getInstance()._get_booleanArrayClass_(), BooleanArraySerializer()), to(getKClass_0(Unit), serializer_10(Unit_getInstance()))]);
  NULL = new Object();
  EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap());
  C2TC = C2TC$init$();
  ESCAPE_CHARS = ESCAPE_CHARS$init$();
  RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
  COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
  COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
  TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
  SEALED_0 = new Symbol('SEALED');
  EMPTY_NEW = new Empty(false);
  EMPTY_ACTIVE = new Empty(true);
  NO_DECISION = new Symbol('NO_DECISION');
  UNDEFINED = new Symbol('UNDEFINED');
  REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  UNLOCK_FAIL = new Symbol('UNLOCK_FAIL');
  LOCKED = new Symbol('LOCKED');
  UNLOCKED = new Symbol('UNLOCKED');
  EMPTY_LOCKED = new Empty_0(LOCKED);
  EMPTY_UNLOCKED = new Empty_0(UNLOCKED);
  counter = 0;
  DEBUG = false;
  simpleFragmentShader = trimIndent('\n        #ifdef GL_ES\n        precision highp float;\n        #endif\n        \n        varying vec4 vColor;\n\n        void main() {\n              gl_FragColor = vColor;\n        }\n    ');
  simpleFragmentShader_0 = trimIndent('\n        #ifdef GL_ES\n        precision highp float;\n        #endif\n        \n        varying vec2 vUVPosition;\n        varying vec4 vLighting;\n\n        uniform sampler2D uUV;\n\n        void main() {\n              vec4 texel = texture2D(uUV, vUVPosition);\n              // If the light alpha is 0, the light will be vec3(1.0) so the texel will not be altered\n              // otherwise, the light will be vLighting.rgb\n              vec3 light = (vec3(1.0) * (vec3(1.0) - vec3(vLighting.a))) + vLighting.rgb * vLighting.a;\n              gl_FragColor = vec4(texel.rgb * light, texel.a);\n        }\n    ');
  simpleVertexShader = trimIndent('\n        #ifdef GL_ES\n        precision highp float;\n        #endif\n        \n        uniform mat4 uModelView;\n        uniform vec4 uColor;\n        \n        attribute vec3 aVertexPosition;\n        \n        varying vec4 vColor;\n        \n        void main() {\n            gl_Position = uModelView * vec4(aVertexPosition, 1.0);\n            vColor = uColor;\n        }\n    ');
  simpleVertexShader_0 = trimIndent('\n        #ifdef GL_ES\n        precision highp float;\n        #endif\n        \n        uniform mat4 uModelView;\n        // Light information\n        uniform vec3 uLightPosition;\n        uniform vec4 uLightColor;\n        \n        attribute vec3 aVertexPosition;\n        attribute vec3 aVertexNormal;\n        attribute vec2 aUVPosition;\n        \n        varying vec2 vUVPosition;\n        varying vec4 vLighting;\n        \n        void main() {\n            vec3 vPosToLight = normalize(aVertexPosition - uLightPosition);\n        \tfloat directional = max(0.0, dot(aVertexNormal, -vPosToLight));\n\n            gl_Position = uModelView * vec4(aVertexPosition, 1.0);\n            vUVPosition = aUVPosition;\n            \n            vLighting = uLightColor + uLightColor * directional;\n        }\n    ');
  simpleVertexShader_1 = trimIndent('\n        #ifdef GL_ES\n        precision highp float;\n        #endif\n        \n        attribute vec2 aVertexPosition;\n        varying vec2 inputUV;\n        \n        void main() {\n            \n            gl_Position = vec4(aVertexPosition, 0.0, 1.0);\n            inputUV = vec2((aVertexPosition.x + 1.0) * 0.5, (aVertexPosition.y + 1.0) * 0.5);\n        }\n    ');
  main();
  return _;
}));
